export const links = [
 {
  "Email": "randu.riiberg@eversheds.ee",
  "Name": "Randu Riiberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/00DFFdIlWfSBeXeF5wqh"
 },
 {
  "Email": "mulugetazemene@gmail.com",
  "Name": "Mulugeta Zemene Zerihun",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/02jqSRK6QvShDUOAqe7N"
 },
 {
  "Email": "lynette.chew@stamfordlaw.com.sg",
  "Name": "Bernard Lui",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/02qrlWC13dA7WEmMuL8c"
 },
 {
  "Email": "ncarr@mofo.com",
  "Name": "Noah Carr",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/03Jc7xq7zvZivBgJCpCq"
 },
 {
  "Email": "mbueso@latam-lex.com",
  "Name": "Manuela Bueso",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/04geZfZ5E1EOhyUSH64t"
 },
 {
  "Email": "john.williams@hsf.com",
  "Name": "John Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/05je6qCcELvH5o4Yrfdb"
 },
 {
  "Email": "zelalem@mehrteableul.com",
  "Name": "Zelalem Yibrah",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/06KG0Z5IIsH3JH4Q4yyM"
 },
 {
  "Email": "miraf_bedru@yahoo.com",
  "Name": "Mearaf Bedru",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/06eyZFnZaDP7JEksFFtT"
 },
 {
  "Email": "stanislav_puginsky@epam.ru",
  "Name": "Stanislav Puginsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/06fvTuZUOWIGmBX8DjE5"
 },
 {
  "Email": "Hakki.Gedik@gedikeraksoy.com",
  "Name": "Mr Hakk? Gedik",
  "Document Name": "IS-#1440317-v1-World_Bank_BI_2020_-_Turkey.DOC",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/07oWUbWWb3BE3smiFspY"
 },
 {
  "Email": "boy@ptsmi.co.id",
  "Name": "[do not publish] Mr. Boy Aditya Prakasa Ishar",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_PT SMI.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/07wP1biw2lwKleWyG13Z"
 },
 {
  "Email": "hansi@desaram.com",
  "Name": "Ms Hansi Abayaratne",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en_DL&F De Saram.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/088dj4dXp8H5ES7LZsmZ"
 },
 {
  "Email": "pfi@pfi.mw",
  "Name": "Elton Jangale",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/08O0mt5AA60AwOKTawuF"
 },
 {
  "Email": "jelani.waziri@mcit.gov.af",
  "Name": "Raihana Popalzi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/09dLDPW2vKaQay7sJZE6"
 },
 {
  "Email": "stskhakaia@glcc.ge",
  "Name": "Shalva Tskhakaia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/09m65f6dbzBWxXQ895m7"
 },
 {
  "Email": "yujin.tay@dlapiper.com",
  "Name": "Yu-Jin Tay",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0A9umU2AjdTWusamk8dI"
 },
 {
  "Email": "marge.manniko@lextal.ee",
  "Name": "Marge M�nniko",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0AfAKUm080OBoUArjEqb"
 },
 {
  "Email": "info@governancesystemsug.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0D3xHsJx4tUw4TN2XHqD"
 },
 {
  "Email": "jane.parker@minterellison.co.nz",
  "Name": "Jane Parker",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0D5Cjh3K9RXvYU8set9z"
 },
 {
  "Email": "francis.laws@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0DOztqa9uyxBWmZmje8T"
 },
 {
  "Email": "ajacy@alvarezcalderon.com",
  "Name": "title Alfonso Alvarez Calderon",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en (2).docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0E567lFNoKHBiL5UX9W9"
 },
 {
  "Email": "fradinta.laksmita@dentons.com",
  "Name": "Ms. Fradinta Nadya Laksmita",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Dentos.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0GHbRLiP7wbfSG7Ft8x1"
 },
 {
  "Email": "sppsak@nus.edu.sg",
  "Name": "Suzalna Kadlr",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0GKM99JpO6y855JGRBB5"
 },
 {
  "Email": "law@uofk.edu",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0GKup15XiXriv34mJWml"
 },
 {
  "Email": "piei@nortonrosefulbright.com",
  "Name": "Ms. Pimchanok Eianleng",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Go2ckBsaNDi9VDXqhrf"
 },
 {
  "Email": "nja@pagbam.com",
  "Name": "Nicole Jaureguiberry",
  "Document Name": "World Bank- Concession survey (3).docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Hc6k9Tpl1cV9VkrpwpA"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Mikhail Gerchuk",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Hhb6Rj1po1tZ1dQWICd"
 },
 {
  "Email": "arabian@bemco-ipp.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0HpVnLuvf9XHBeltFEBX"
 },
 {
  "Email": "raquel.sampaio@abreuadvogados.com",
  "Name": "Raquel Sampaio",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0IPTraUAF7MpkE4QBkG3"
 },
 {
  "Email": "jnovales@novales.com.gt",
  "Name": "Javier Novales Schlesinger",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0IikmH0R5ypBxJnVOj4j"
 },
 {
  "Email": "gastorn.kennedy@mkono.com",
  "Name": "Kennedy Gastorn",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0J4xubt7tGqrDzAn6uSb"
 },
 {
  "Email": "allar.joks@sorainen.com",
  "Name": "Allar J�ks",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0J8cmPLs1CYnP4ucuShh"
 },
 {
  "Email": "sshengelia@cu.edu.ge",
  "Name": "Sophio Shengelia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0JENwgsXdqXlUPo6O9TB"
 },
 {
  "Email": "info@confluentlaw.com",
  "Name": "Alan Wahid",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0JIrv0HSEfKQbYirE77A"
 },
 {
  "Email": "toomas.prangli@sorainen.com",
  "Name": "Toomas Prangli",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0KAFhhzWxRGe6M40Rjru"
 },
 {
  "Email": "ernest.wiltshire@bowmanslaw.com",
  "Name": "Wiltshire Ernest",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0KJVXZq5sETS7gqKJr4T"
 },
 {
  "Email": "camillo@giamundoneto.com.br",
  "Name": "Dr. Camillo Giamundo",
  "Document Name": "3 BI 2020 BRA_bi_concession_survey_en.doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0KP0cerjvFBsikepqebH"
 },
 {
  "Email": "maarten.wolfs@ae.pwc.com",
  "Name": "Maarten Wolfs",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0LIHn7qVuLnBsO1G8neN"
 },
 {
  "Email": "pippa.read@pinsentmasons.com",
  "Name": "Pippa Read",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0LhJ3Sl1TVBm1gzQVOp2"
 },
 {
  "Email": "mateus.chale@pwc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0M4G1AJm5eCvp9auRzWZ"
 },
 {
  "Email": "aguirola@lexincorp.com",
  "Name": "Antonio Guirola",
  "Document Name": "ELSALVADOR) LEXINCORP) BI 2020 SLV_bi_PPP_survey_en.docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0M9sBBwwkG5d34XeUFIM"
 },
 {
  "Email": "sorieyillah@gmail.com",
  "Name": "Ibrahim S. Yillah Esq.",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0MMJe9CJt6K9uG2UEqTa"
 },
 {
  "Email": "aleksei.forstiman@narlex.com",
  "Name": "Aleksei Forstiman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0MgWWdjitRXzLKW34blV"
 },
 {
  "Email": "rekhaswati@gmail.com",
  "Name": "Rekha A. Kumar",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0N2DZKvmY6nFYJUUU6lN"
 },
 {
  "Email": "naghababyan@prudencelegal.com",
  "Name": "Nerses Aghababyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Ngbsn6r6oWVXBwoHx2s"
 },
 {
  "Email": "iain.thain@dlapiper.com",
  "Name": "Iain Thain",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0NzZvKEBw9IgxtxKVVzv"
 },
 {
  "Email": "patrick.ibbotson@maddocks.com.au",
  "Name": "Patrick Ibbotson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0OEYcshZhk46FvcSIuu1"
 },
 {
  "Email": "rosshopkins@bigpond.com",
  "Name": "Ross Hopkinsa",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0P6zl9JOsT9lqeRDMpod"
 },
 {
  "Email": "daniel@flackswong.co.nz",
  "Name": "Daniel Wong",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0PEDQUWZd7due36a93c4"
 },
 {
  "Email": "makoto.terazaki@amt-law.com",
  "Name": "Mr. Makoto Terazaki",
  "Document Name": "BI 2020 JPN_bi_TPI_survey_en_AMT20190906.docx",
  "Country": "JPN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0PLthclyyeE5o4cRjWb9"
 },
 {
  "Email": "cyrus.mehta@cms-cmno.com",
  "Name": "Cyrus Mehta",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0PeEsVl5JbsFInZjaMCV"
 },
 {
  "Email": "rika.beppu@squirepb.com",
  "Name": "Rika Beppu",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Q6UdRjPwPN8WzxFMUqs"
 },
 {
  "Email": "cviana@whitecase.com",
  "Name": "Carlos Viana",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0QCNA0pwDPDQDn5Eb8iS"
 },
 {
  "Email": "Yasser.Alhussain@ashlawksa.com",
  "Name": "Yasser Al-Hussain",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0QLFCRYfPBuSG6CnGKSl"
 },
 {
  "Email": "kmiller@fitzwilliamstone.com",
  "Name": "Kurt Miller",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0RYyq0UqoF1MYOlpXFUE"
 },
 {
  "Email": "gurrutia@central-law.com",
  "Name": "Gilda Maria Urrutia Sosa",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Syxc8kzLaDdc0L4Dp1q"
 },
 {
  "Email": "cstp@ns.kgtu.runnet.ru",
  "Name": "??????? ???????? ?????",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0UC7tHod1ccyCF3NaU4J"
 },
 {
  "Email": "oleksandra.prysiazhniuk@cms-rrh.com",
  "Name": "Ms Oleksandra Prysiazhniuk",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_CMS Reich-Rohrwig Hainz.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Ui6SbtI7YA5Nal3Fnoc"
 },
 {
  "Email": "anthonyb@s-horowitz.com",
  "Name": "Anthony Bloch",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0VKuVIQfhEJa9x7RBSvF"
 },
 {
  "Email": "info@glf.sd",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0WJPclKCYyYoubPEZQyV"
 },
 {
  "Email": "Lfshriyadh@hejailanlaw.com",
  "Name": "Robert Thomas",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0WtKZk7LPWl2vSbZrqjC"
 },
 {
  "Email": "arjola.rushiti@pwc.com",
  "Name": "Ms Arjola Rushiti",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_en_PWC.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0Wv0eDEm0n9VfNt72yoY"
 },
 {
  "Email": "acevedo@berettagodoy.com",
  "Name": "Mr Fernando Acevedo",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en (1) (003) (FG).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0YGprsSNLQO8wu97G7rJ"
 },
 {
  "Email": "jkeenan@brifnsw.com.au",
  "Name": "John Keenan",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ZdkslJ7jxQRYDryXfJZ"
 },
 {
  "Email": "skinner-klee@arenales.com.gt",
  "Name": "Alfredo Skinner-Klee",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0aJkHkcDFOBu0Bb0w9sZ"
 },
 {
  "Email": "filipa.veigagomes@csassociados.pt",
  "Name": "Ms. Filipa Veiga Gomes",
  "Document Name": "WordBank_SurveyPPP.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0cYZY0a41B1Mf7VNj5wR"
 },
 {
  "Email": "mafalda.t.abreu@abreuadvogados.com",
  "Name": "Mrs. Mafalda Teixeira de Abreu",
  "Document Name": "Questionnaire PPP WB 2020 12.07.2019.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0cvj0IaGXxspHTCKdDFN"
 },
 {
  "Email": "agata.szeliga@skslegal.pl",
  "Name": "Ms. Agata Szeliga",
  "Document Name": "BI 2020 POL_bi_PPP_SKS.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ddgXVCxkHUKON6ucYJw"
 },
 {
  "Email": "eeshi.katugugu@pwc.com",
  "Name": "Mrs Eeshi Katugugu",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_TPI_survey_en.docx 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0doavm6i6AscrO4Mt81s"
 },
 {
  "Email": "aarriola@arenales.com.gt",
  "Name": "Alejandro Arriola D.",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0dtutIWeZBLlzAJr0rsN"
 },
 {
  "Email": "beatrix.spargo@allenovery.com",
  "Name": "Ms Beatrix Spargo",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Allen & Overy.doc",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ecpsYE3zlOBohqbUAjR"
 },
 {
  "Email": "nf17@soas.ac.uk",
  "Name": "Norman Flynn",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0egyJtDO3sTe7713Moau"
 },
 {
  "Email": "info@qc-law.com",
  "Name": "Paul Turner",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ezGN2acB8sT5BYdrOHj"
 },
 {
  "Email": "dmitry.kovalev@ru.pwc.com",
  "Name": "Dmitry Kovalev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0fMfdkJIRJy2O0dZXdL5"
 },
 {
  "Email": "daniadib@asarlegal.com",
  "Name": "Mrs Dania Dib",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_ASAR.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0gTJyGjLyI2vW7mgNbtl"
 },
 {
  "Email": "execdirector@amchamthailand.com",
  "Name": "Judy Benn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ghCZ0V7eLJgWyLzMrg2"
 },
 {
  "Email": "cam.cameron@gowlings.com",
  "Name": "Cam Cameron",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0gm2s7eyYICBkWNgFYPt"
 },
 {
  "Email": "pmattos@demarest.com.br",
  "Name": "Ms. Patricia Mattos",
  "Document Name": "wb bench questionnaire PPPs.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0h1yX5FHok3Ur2PNU2Ny"
 },
 {
  "Email": "atexo@bkzr.com.uy",
  "Name": "Mr. Agust�n Texo",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en (0291310xD5B0A).docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0h3yNICMH0PcYQFo7nNG"
 },
 {
  "Email": "adahsylviaolando@gmail.com",
  "Name": "Adah Olando",
  "Document Name": "BI 2020 KEN_bi_PPP_PO_survey_en-Robert Osudi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0hCjJNUi4UzpbtFDoybX"
 },
 {
  "Email": "sdean@akingump.com",
  "Name": "Susan W. Dean",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0hdd2esq6jvz3UwwNnee"
 },
 {
  "Email": "fepuleai@lesamoa.net",
  "Name": "Patrick Fepuleai",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0hvqKNeTyHeESplfk3hQ"
 },
 {
  "Email": "iccoffice@iccwbo.ru",
  "Name": "Vladimir Dmitriyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0iBQShpUA8tyR6ptrIkx"
 },
 {
  "Email": "a.smith@pppexpert.com",
  "Name": "Anthony Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0iOXamEqzr5wf8ImRUXY"
 },
 {
  "Email": "yosbe@ethionet.et",
  "Name": "Yoseph Gebregiziabher",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0jhwbwOJYjnZ8psj0wEL"
 },
 {
  "Email": "kevin.rihtar@karanovicpartners.com",
  "Name": "Mr. Kevin Rihtar",
  "Document Name": "PPP_Ermina.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0jqAFnV8qtsiWBiGUAnZ"
 },
 {
  "Email": "jitranut@huntonak.com",
  "Name": "Ms. Jitranut Narkmai",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0jwtUpI0xdUYs1EfDWv6"
 },
 {
  "Email": "jeff.law@investec.com.au",
  "Name": "Jeff Law",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0lLHuCu9xYiQFybw9Nga"
 },
 {
  "Email": "akirethi@hallmarkattorneys.com",
  "Name": "Annette W. Kirethi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0mGDRu2UGeyUfgRfAZuE"
 },
 {
  "Email": "thomas.wilson@squirepb.com",
  "Name": "Thomas Wilson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0mJEH7zIhg4Qus5ReyB2"
 },
 {
  "Email": "jona.alla@pwc.com",
  "Name": "Ms Jona Alla",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_en_PWC.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0mei5vgOEXOiuRb26yGc"
 },
 {
  "Email": "a.mayaram@pppexperts.com",
  "Name": "Arvind Mayaram",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0mtoqlBloB7ueLQ0vujq"
 },
 {
  "Email": "info@theawoonorlaw.com",
  "Name": "Ekow N. Awoonor",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0nAfZycnn9cip6J3qPel"
 },
 {
  "Email": "mauricio@portugalribeiro.com.br",
  "Name": "Maurício Portugal",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0nk6faj8ao9vMviNSlJY"
 },
 {
  "Email": "argita_malltezi@yahoo.com",
  "Name": "Prof. DR Argita Malltezi",
  "Document Name": "BI 2020  ALB_bi_PPP_survey_en _answered.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0o8twU1CUCs2IJqwVua4"
 },
 {
  "Email": "Durim.Sheremeti@rks-gov.net",
  "Name": "Mr. Durim Sheremeti",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_en_Chief.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ogvk1OuA1d9izGkOaIq"
 },
 {
  "Email": "jfitzgerald4@kpmg.com.au",
  "Name": "John Fitzgerald",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0ovmFhDn8GMvBZzIcPUL"
 },
 {
  "Email": "khalid.shami@sksadvocates.com",
  "Name": "Khalid Elsadig Shami",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0puRevUFgcOazzcszL5Y"
 },
 {
  "Email": "kmideksa@gmail.com",
  "Name": "Kelemework Mideksa Debela",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0rKEwYslnYQqpZSdznnr"
 },
 {
  "Email": "jdelacruz@lq.com.pe",
  "Name": "Mr. Jorge De la Cruz Ravines",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en 2.JorgedeLaCruz.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0s4UjlLycgT6jcVD9p4O"
 },
 {
  "Email": "macarena@chirgwin.cl",
  "Name": "Ms. Macarena Bedregal",
  "Document Name": "BI 2020 CHL_bi_PPP_survey_en_20190830_Chirgwin .docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0s4iERhy44KQAyVNWJ9L"
 },
 {
  "Email": "mttoledo@philexmining.com.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0stPzHQ4RiKWaPmBhnqK"
 },
 {
  "Email": "pssebaduka@mantracuganda.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0tJtNdeQYBNadcJhHt5o"
 },
 {
  "Email": "info@ppmattorneys.co.za",
  "Name": "Diana Schwarz",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0thAmSFgobSIiguTanNt"
 },
 {
  "Email": "benjamin.paine@painestevens.com",
  "Name": "Benjamin Paine",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0tsJ4oCXxMW3TGxs0OSY"
 },
 {
  "Email": "jalliy@velmalaw.com",
  "Name": "Joy Hadji Alliy",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0vHdY8xBIQM1jEa7Y4ID"
 },
 {
  "Email": "yusuke.abe@cliffordchance.com",
  "Name": "Yusuke Abe",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0vv663oprp6Oc8eRBvYF"
 },
 {
  "Email": "mpolonsky@whitecase.com",
  "Name": "Marc Polonsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0wcA2PkEwFmUtVvPQ6fO"
 },
 {
  "Email": "bina.baron@moital.gov.il",
  "Name": "Bina Bar-On",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0wu7B7WOEE1bPxjtlaDc"
 },
 {
  "Email": "info@paytailor.com",
  "Name": "Rode Luha��r",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0yFyMQwO1Wae2wJE99vk"
 },
 {
  "Email": "rtinham@wslaw.co.uk",
  "Name": "Richard Tinham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/0zW2AivXzCLosS45RDiB"
 },
 {
  "Email": "contactus@novuscf.com",
  "Name": "Yih Pong Chen",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/10lnNuWeugLG5IA3QSxx"
 },
 {
  "Email": "kfallas@theprojectcr.com",
  "Name": "Kristian Fallas",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1230y9moWN40fonA5gZK"
 },
 {
  "Email": "erin.tobin@ashurst.com",
  "Name": "Erin Tobin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/12Ma3vL2vw2DyRvQjZkq"
 },
 {
  "Email": "a.tithecott@tamimi.com",
  "Name": "Andrea Tithecott",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/12h6Qy59XPm4fwCzXA9I"
 },
 {
  "Email": "Soroka@aequo.ua",
  "Name": "Mr. Mykhaylo Soroka",
  "Document Name": "BI 2020 2 UKR_bi_PPP_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/12mNspQdTPHYg4lWev38"
 },
 {
  "Email": "ioana.roman@filippandcompany.com",
  "Name": "Mrs Ioana Roman",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Filip.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/12qwcecBgqFQssj9v4Sw"
 },
 {
  "Email": "rashane@dfdl.com",
  "Name": "Rashane Leerabandhu",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/13JRl0SkpNrpXPDs4RsQ"
 },
 {
  "Email": "office1@mostpp.ru",
  "Name": "Vladimir Platonov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/14EuAhW6dkKYbtjJhMri"
 },
 {
  "Email": "mmorgan@fitzwilliamstone.com",
  "Name": "Mark Morgan",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1558PDXuQ6rLmauj8p8R"
 },
 {
  "Email": "mcalderon@s-s.mx",
  "Name": "title Mariano Calderón Vega",
  "Document Name": "S-S-#76696-v1-2020_TPI_SURVEY_wb.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/15vTerQdM1UKSLp5DlQD"
 },
 {
  "Email": "aelizondo@camara-comercio.com",
  "Name": "Alonso Bolanos Elizondo",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/16Qj1W3rXyD9S92aYTgA"
 },
 {
  "Email": "irakli.gelovani@ge.pwc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/17SMZ3xG1c49p99JLv77"
 },
 {
  "Email": "russia@mottmac.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/17yByIcgYqrzvzcU8Dh7"
 },
 {
  "Email": "colin.wilson@dlapiper.com",
  "Name": "Colin Wilson",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/184JpeUoUq3Px51nm3MC"
 },
 {
  "Email": "mdorion@mccarthy.ca",
  "Name": "Marc Dorion",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/185Rzpeess7LRNHZRRRN"
 },
 {
  "Email": "karen@bbi.co.bw",
  "Name": "Karen Robertson",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/189nJp225HsMkVyGcZCR"
 },
 {
  "Email": "mbairstow1@uk.ey.com",
  "Name": "Malcolm Bairstow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/18gheq7vjp3tOtr6zNBJ"
 },
 {
  "Email": "shadi.haroon@bakerbotts.com",
  "Name": "Shadi Haroon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/19HqfXG20K59fnMJ3gCI"
 },
 {
  "Email": "alavrentev@vegaslex.ru",
  "Name": "Alexander Lavrentyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/19VEyhzn3yUjihhFTd0V"
 },
 {
  "Email": "fadhili.lwendo@zenithattorneys.com",
  "Name": "Fadhili Nathan Lwendo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1AHJ0n2w5vdnrFtb9uEi"
 },
 {
  "Email": "tim.murphy@mcmillan.ca",
  "Name": "Tim Murphy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Az3Hx3LyClRhDj1Kxhx"
 },
 {
  "Email": "alexander.newton@dlapiper.com",
  "Name": "Alexander Newton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1BLKurGmcyVBQ19UGUEP"
 },
 {
  "Email": "karolina.niewiadomska@twobirds.com",
  "Name": "Ms Karolina Niewiadomska",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_Bird&Bird.DOCX",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1BS2mZ4uVEO80dnZaxjv"
 },
 {
  "Email": "barbara.mayer-trautmann@cliffordchance.com",
  "Name": "BARBARA MAYER-TRAUTMANN",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1BvnRkV23DBg54UjmCgn"
 },
 {
  "Email": "hgadsby@jdsellier.com",
  "Name": "Hadyn-John A. Gadsby",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1BwieZJuJIZzv8sTPMYw"
 },
 {
  "Email": "marko.kairjak@tgsbaltic.com",
  "Name": "Marko Cairjak",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1C42ISRMsP5JzVl62bcE"
 },
 {
  "Email": "aj@amereller.com",
  "Name": "Mr. Ahmed Al Janabi",
  "Document Name": "BI 2020 IRQ_bi_PPP_survey_en_Amereller.docx",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1C5QdWAB324VpnkNfGBJ"
 },
 {
  "Email": "shiraz.yusuf@mw.ey.com",
  "Name": "Mr Shiraz Yusuf",
  "Document Name": "MALAWI) EY) BI 2020 MWI_bi_PPP_survey_en_mw.docx",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1D3k7xOo0oWtBxCQPTCK"
 },
 {
  "Email": "ppontaza@gpelegal.com",
  "Name": "Paulina Pontaza",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Dq7f5G1sMCOAU6T7Uiv"
 },
 {
  "Email": "Fernando.Sioson@Romulo.com",
  "Name": "Fernando Sioson",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1ECOF9hbTFVjG6DFOyEh"
 },
 {
  "Email": "info@bonfield.com",
  "Name": "Tim Meana",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1FP5OkD3Mn8nGLUm7Lzk"
 },
 {
  "Email": "davit.harutyunyan@am.pwc.com",
  "Name": "Davit Harutyunyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1FstRotbR9mXPtQXtsjV"
 },
 {
  "Email": "zeyad.alsalloum@lfst.com",
  "Name": "Zeyad Alsalloum",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1FukJeHCdx1OJcN0BG2C"
 },
 {
  "Email": "o_pouono@hotmail.com",
  "Name": "�Ofa Pouono",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1GRCs7yLqYN9gT7oDQI6"
 },
 {
  "Email": "shiricom@botsnet.bw",
  "Name": "Lovejoy Topera Shiripinda",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1GjpsO4DJX38usynHWHQ"
 },
 {
  "Email": "john.stephens@meredithconnell.co.nz",
  "Name": "John Stephens",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1H3FXZUNoPjdhYzAOyYn"
 },
 {
  "Email": "smomeni@winston.com",
  "Name": "Mr Shaheer Momeni",
  "Document Name": "BI 2020 ARE_bi_PPP_survey_en_W&S.DOCX",
  "Country": "ARE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1HGLMaGrvYCULCw8OTXH"
 },
 {
  "Email": "office@abylaw.com",
  "Name": "Yuri Pustovit",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1HhKeBXaEaTgLGZZZRlV"
 },
 {
  "Email": "michael.kaihatu@dentons.com",
  "Name": "Mr. Michael Kaihatu",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Dentos.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1IjHXrLLeV4tpbCtNDfq"
 },
 {
  "Email": "thidatun210@gmail.com",
  "Name": "Ms. Thida Tun Thida Tun",
  "Document Name": "PPP (BD).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1J5b7LWZRGjvDP1gEmi4"
 },
 {
  "Email": "p.shamte@crbafricalegal.com",
  "Name": "Pendo Marsha Shamte",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1JIq6p2pZGnr90tJ4QkF"
 },
 {
  "Email": "alida@benedetti.com.pa",
  "Name": "Alida Benedetti",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1JSFhvDyi4O9oU8mjfuG"
 },
 {
  "Email": "abull@ulhoacanto.com.br",
  "Name": "Mr. Alberto B�ll",
  "Document Name": "PPP Consolidado 10.07.2019.DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1K9UEepbuTmgRJsUQ6Q9"
 },
 {
  "Email": "bsteinhardt@stblaw.com",
  "Name": "Brian M. Steinhardt",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1KEIJIjr4gQbmINYiN0r"
 },
 {
  "Email": "tshekisoditirojani@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1KY5HudBiSuB7t9mh3K0"
 },
 {
  "Email": "enquiries@co2balance.com",
  "Name": "Mark Simpson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1KeqDo2YrWZyg4siT1Gs"
 },
 {
  "Email": "rosy.venlangenberg@fjgdesaram.com",
  "Name": "Rosy Vanlangenberg",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Me9Y4GuPKE7ZUYUvcEp"
 },
 {
  "Email": "favillez@abcc.co.mz",
  "Name": "Francisco Avillez",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1N7ozsfyxAcudCORydlA"
 },
 {
  "Email": "APANNIER@ARNECKESIBETH.COM",
  "Name": "Andreas Pannier",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1OayRQcg7Kqym9V5WqDE"
 },
 {
  "Email": "esa.halmari@hedman-attorneys.com",
  "Name": "Esa Halmari",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1OoneEKbyaeLRsMTI4AC"
 },
 {
  "Email": "maraki@mofo.com",
  "Name": "Motonori Araki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1POXRLpzV12DDrOglfdS"
 },
 {
  "Email": "hrvoje.bujanovic@pbz.hr",
  "Name": "Hrvoje Bujanovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Q3pn90LNrO2v6btyra2"
 },
 {
  "Email": "info@ironwoodlegal.com",
  "Name": "Rajesh Ponnan",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1QXaz304sYtdy98mBNwM"
 },
 {
  "Email": "info@dragadosgulf.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1R2ntjCI8aUXRTIRj4Fp"
 },
 {
  "Email": "sebastian@lincolnmyanmar.com",
  "Name": "Mr Sebastian Pawlita",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en_Sebastian Pawlita.docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1ReOYSmSqZoApCWtfpPB"
 },
 {
  "Email": "nino.dolidze@iliauni.edu.ge",
  "Name": "Nino Dolidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1SNNrytcKxnyNUToFHrQ"
 },
 {
  "Email": "f.descombes@ds-legal.com",
  "Name": "Frederic Descombes",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Shdmvm0QRJUnRa1gZDZ"
 },
 {
  "Email": "mugdad@unitedlawyersfirm.com",
  "Name": "Muqdad Sami Allwan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1SoZOzdqEMV3MQTK00I0"
 },
 {
  "Email": "s.wienhues@gvw.com",
  "Name": "Sigrid Wienhues",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1T6P7sYZYDBjGzTCaJCI"
 },
 {
  "Email": "kyrgyzstan@colibrilaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1TJyUQ89mtktLptlAFH8"
 },
 {
  "Email": "Fahad.Abuhimed@ashlawksa.com",
  "Name": "Fahad Abuhimed",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1TTRRWqyU9icplUUYDyd"
 },
 {
  "Email": "jasmina.dzaferovic@karanovic-nikolic.com",
  "Name": "Jasmina Dzaferovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1TvxcaWqUv64W6mqZpRT"
 },
 {
  "Email": "simeon.okoduwa@alliancelf.com",
  "Name": "Mr Simeon Okoduwa",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_PPP_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1V1W3GVkay8UxwZCBoIY"
 },
 {
  "Email": "fm@nationalchamber.lk",
  "Name": "Krishani Fonseka",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1VAYjV10rY8hDS6cNxX9"
 },
 {
  "Email": "logan.mair@ashurst.com",
  "Name": "Logan Mair",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1VXG3eEPGwDVNlnNj9pU"
 },
 {
  "Email": "Paull@ayr.co.il",
  "Name": "Mr. Paul Lenga",
  "Document Name": "ISRAEL) AYR) BI 2020 ISR_bi_PPP_survey_en.doc",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1Wx2rbMi9ltE6kdc7Jv6"
 },
 {
  "Email": "sol.lawconsult1983@gmail.com",
  "Name": "Solomon Teshome",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1XOU6WV7PytO0wzXhqqo"
 },
 {
  "Email": "akoshkarbayev@szp.kz",
  "Name": "Askhad Koshkarbayev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1ZVaau0WU0Fip2lo96gx"
 },
 {
  "Email": "geoffrey.heekin@aon.com",
  "Name": "Geoff Heekin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1ZubAvbvQYXhbHAM16nT"
 },
 {
  "Email": "info@aihlawfirm.com",
  "Name": "Jaba Shadrack",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1aaxE9D59anDTwOZiq8O"
 },
 {
  "Email": "sergei.ostrovsky@ashurst.com",
  "Name": "Sergei Ostrovsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1bovAaITKFCTyYbsuGz3"
 },
 {
  "Email": "juliet.reingold@simmons-simmons.com",
  "Name": "Juliet Reingold",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1bpLd45ld15OAPBO64Ry"
 },
 {
  "Email": "mrath@deloitte.com.au",
  "Name": "Michael Rath",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1bsrx0SK2G0tPy5VPQB7"
 },
 {
  "Email": "swati.johri@pegasus-legal.com",
  "Name": "Swati Johri",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1c7BcYRIgQMIqwG1TjZd"
 },
 {
  "Email": "Kaeda.Toh@ropesgray.com",
  "Name": "Kaede Toh",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1cPBkwrsjpAxLKDY4kVX"
 },
 {
  "Email": "kmctigue@omm.com",
  "Name": "Kelly Mctigue",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1cUwwuOYSCjQcl1aHbYL"
 },
 {
  "Email": "anicoleyson@central-law.com",
  "Name": "Allan Nicoleyson",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1dHVYxs2Tl5duuYOnqE2"
 },
 {
  "Email": "x.laurent@bangor.ac.uk",
  "Name": "Xavier Laurent",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1dR1aWEPrCwBwuLRops1"
 },
 {
  "Email": "ganderson@vtti.vt.edu",
  "Name": "Gabrial Anderson",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1dUG1hGXyhnFg2tEaEiG"
 },
 {
  "Email": "koridze@gmail.com",
  "Name": "Konstantine Koridze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1eCiu2SArZVq8IUVdZrR"
 },
 {
  "Email": "bindradolsingh@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1ePybfTlOtl5Igpy8bxJ"
 },
 {
  "Email": "oqouteshat@qatarlaw.com",
  "Name": "Mr. Omar Qouteshat",
  "Document Name": "BI 2020 QAT_bi_PPP_survey_en_Sultan.docx",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1eghv96Cu9FE0n9c4MqF"
 },
 {
  "Email": "christian.reininger@bmf.gv.at",
  "Name": "Mr. Christian Reininger",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_Ministry of Finance.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1el1hlIN73dvIoDGC6n7"
 },
 {
  "Email": "iain.black@dwf.law",
  "Name": "Iain Black",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1f3wIYrW8CaEeLv6pQfE"
 },
 {
  "Email": "rbauer@dwpv.com",
  "Name": "Robert T. Bauer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1i2CkEmk0RfbE9EaxVQO"
 },
 {
  "Email": "serv20all@mail.ru",
  "Name": "?????? ?????? ????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1jj4UyBqgoYEmwg67aSj"
 },
 {
  "Email": "yibeltala@tadessekiros.com",
  "Name": "Yibeltal Azene",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1lWWTjHIcegmsr1Y6dIT"
 },
 {
  "Email": "mlambe@mwe.com",
  "Name": "Martin Lambe",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1lleKSasczw1zNRTEVEi"
 },
 {
  "Email": "victoria.bortkevicha@cliffordchance.com",
  "Name": "Victoria Bortkevicha",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1mns04jpi8hpco25gmpS"
 },
 {
  "Email": "sbashir@kpmg.co.tz",
  "Name": "Salim Bashir",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1mqufYBLyd3IpbQEiMBJ"
 },
 {
  "Email": "tahsin_20042000@yahoo.com",
  "Name": "Tahseen Hassan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1nnzBsVMXVb1lt4rZhyB"
 },
 {
  "Email": "andrew.pettinger@addleshawgoddard.com",
  "Name": "Andrew Pettinger",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1oz9n4Xw4u6uqkvd39Eg"
 },
 {
  "Email": "khalifa.kiango@zenithattorneys.com",
  "Name": "Khalifa Kiango",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1pOv87qDirS47g1wMamV"
 },
 {
  "Email": "pierre-paul.henrie@nortonrosefulbright.com",
  "Name": "Pierre-Paul Henrie",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1pboCRyfvNPwpsC5pL5c"
 },
 {
  "Email": "sbashir@kpmg.co.tz",
  "Name": "Salim Bashir",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1qQCZzCoZ45Z2LG4nRLw"
 },
 {
  "Email": "cazlabssi@cazlabssi.com",
  "Name": "Liza H. Abiera",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1rHgBAb4mNoN3bi4m3QK"
 },
 {
  "Email": "adam.lovett@nortonrosefulbright.com",
  "Name": "Adam Lovett",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1rlPywYRMmrw3qwVEL4Y"
 },
 {
  "Email": "kentwong@vci-legal.com",
  "Name": "Partner Kent Wong",
  "Document Name": "VIETNAM) VCI LEGAL) BI 2020 VNM_bi_TPI_survey_en-[completed KW].docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1rm2cDAn4s7UGhc4l2YV"
 },
 {
  "Email": "jinglis@milbank.com",
  "Name": "John Inglis",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1sXBo1iDb9aVb6N542gZ"
 },
 {
  "Email": "echao@gibsondunn.com",
  "Name": "Elaine Chao",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1uD4zbGeZYPx3HTQ0yP2"
 },
 {
  "Email": "contactus@azylawfirm.com",
  "Name": "Ahmed Zaki Yamani",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1uPSXAalz5QkRmygigce"
 },
 {
  "Email": "amonzon@industriaguate.com",
  "Name": "Andrea Monzon",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1uQ4hz09c7fBrTSr68Ih"
 },
 {
  "Email": "dmcnair@gtlaw.com.au",
  "Name": "Damian Mcnair",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1vdz6Ly0UfkhBs8YZcgh"
 },
 {
  "Email": "kramachandra@duanemorrisselvam.com",
  "Name": "Mr. Krishna Ramachandra",
  "Document Name": "TPI_Myanmar (DMS 29072019).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1vxlQoXBUw52gvKJqaTS"
 },
 {
  "Email": "raul.santos@mattosfilho.com.br",
  "Name": "Mr. Raul Dias dos Santos Neto",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1wiSU3Tj8DhBH8X1tN4M"
 },
 {
  "Email": "chen.fah.yee@sg.pwc.com",
  "Name": "Yee Chen Fah",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1xW12L9Q58l53MripSuo"
 },
 {
  "Email": "stephen.howes@anu.edu.au",
  "Name": "Stephen Howes",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1xWWQBtfuX8hGZcb6Zww"
 },
 {
  "Email": "hiroaki.nakano@amt-law.com",
  "Name": "Mr. Hiroaki Nakano",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en_AMT20190906.doc",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1y1HpYjJdH3WeYpG0p8b"
 },
 {
  "Email": "marieke.datema@blplaw.com",
  "Name": "Marieke Datema",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1yBg0sv6ZIIAIEhoAFnq"
 },
 {
  "Email": "FHOQuaah@milbank.com",
  "Name": "Mrs Felicia lHanson Ofoi-Quaah",
  "Document Name": "BI 2020 GBR_bi_TPI_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1yCxEaSKaNu5XU0YugKR"
 },
 {
  "Email": "kate.rees@hoganlovells.com",
  "Name": "Kate Rees",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1yrgRY2mVv5Kx7Q3QP2t"
 },
 {
  "Email": "mwangieb@gmail.com",
  "Name": "M Wangieb",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/1zlt4jjdBdMYHWsAmbqH"
 },
 {
  "Email": "juridica@ucr.ac.cr",
  "Name": "Luis Carrillo Baudrit",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/201ml5XQ39ZBdyVergUJ"
 },
 {
  "Email": "paul.latto@cliffordchance.com",
  "Name": "Paul Latto",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/20qfrHBF5b5mzylRABLY"
 },
 {
  "Email": "hotak@hotakelgamal.com",
  "Name": "Abdul Basit Hotak",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/20zl1a1bmr7wlPBsThnw"
 },
 {
  "Email": "filijosi@gmail.com",
  "Name": "Filmon Yosief",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/22MUwkz77ThRsSFGzFvt"
 },
 {
  "Email": "dmanjate@fipag.co.mz",
  "Name": "David Manjate",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en_TTA.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/22Y4elOXNCkuDnTxA5Ii"
 },
 {
  "Email": "anna.howell@hsf.com",
  "Name": "Anna Howell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/23SwqtQsXaSOMyJYdv4w"
 },
 {
  "Email": "nsmith@deloitte.com.pg",
  "Name": "Noel Smith",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/23fCsI7roeFxJCu50uii"
 },
 {
  "Email": "paul.dunstan@plenarygroup.com",
  "Name": "Paul Dunstan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/24KgUtHSHnlbeB081bEE"
 },
 {
  "Email": "uemek@baskent.edu.tr",
  "Name": "Mr U?ur",
  "Document Name": "TURKEY) EMEK) WordlBank1 BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/27XLoG6GG7ECiWF3gyE8"
 },
 {
  "Email": "svega@camara-comercio.com",
  "Name": "Morera Vega Salome",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/29VkYdaYIn7y9kB1JEnc"
 },
 {
  "Email": "sirisha.sampat@kangacompany.com",
  "Name": "Ms. Sirisha Sampat",
  "Document Name": "BI 2020 IND_bi_PPP_survey_en-_09 08 2019 (002)_Sirisha Sampat.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/29dH0yQUh1auSQkw6nVX"
 },
 {
  "Email": "dlaktransport@gmail.com",
  "Name": "David Lakhan",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/29qPDcaEVC2mwWIFZziv"
 },
 {
  "Email": "principal@togamaelaw.com",
  "Name": "Whitlam Togamae",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2AXTlWGDCnAkoi2BM35S"
 },
 {
  "Email": "jflores@bufeterosa.com",
  "Name": "Julissa Flores Claudino",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2BKrYpdhlVTm59w5GHTl"
 },
 {
  "Email": "ligomarc@ligomarc.com",
  "Name": "Ruth Sebatindira",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2Ckg342bOHdNfdGx7aam"
 },
 {
  "Email": "Alexandru.sorici@ filipandcompany.com",
  "Name": "Mr. Alexandru Sorici",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en_Filip.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2Cp1I3C8534YTrlbekWh"
 },
 {
  "Email": "eric.lueber@deutschebahn.com",
  "Name": "Eric Luber",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2DtpujsGoRa4WH9YywD1"
 },
 {
  "Email": "k.barabash@ndex-solutions.kg",
  "Name": "Ksenyya Barabash",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2EjkRnXNKwcvelvO2jYk"
 },
 {
  "Email": "andgarces@ferrere.com",
  "Name": "Dr. Andrea Garc�s",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en (004).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2FqIbhUV2F6NXQnhD1PR"
 },
 {
  "Email": "KSmith@monckton.com",
  "Name": "Kassie Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2Gdzv8VtqRcFBGee8Kbf"
 },
 {
  "Email": "echu@dbrs.com",
  "Name": "Ernie Chu",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2HiBQcrtq3uUfZrhjf5K"
 },
 {
  "Email": "contact@triplealaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2IZ8aqL6zDxs6fLwBqoq"
 },
 {
  "Email": "anas.bhairi@blakes.com",
  "Name": "Anas Bhairi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2J5HFNE3BKJd5nxPGMel"
 },
 {
  "Email": "paul.armitage@gowlings.com",
  "Name": "Paul Armitage",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2JbjzIHJMDFLYPMY56Sa"
 },
 {
  "Email": "mariama.dumbuya@yahoo.com",
  "Name": "Mariama Dumbuya",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2MbT8krIy2ajzjUN9a9z"
 },
 {
  "Email": "masurashvili@mslaw.ge",
  "Name": "Ana Masurashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ND65PGzzfTMhGvcqqEL"
 },
 {
  "Email": "n&m@malawi.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2NV8WMq4HQZjlBQJnnJG"
 },
 {
  "Email": "malik.rahmani@ada.org.af",
  "Name": "Abdul Malik Rahmani",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2NiE4kn6xlgp8uyeeila"
 },
 {
  "Email": "tcj@zamnet.zm",
  "Name": "Judith Tembo",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2OXqTB8Q4rCpCM1nsBoi"
 },
 {
  "Email": "giorgio.telarico@bakermckenzie.com",
  "Name": "Mr Giorgio Telarico",
  "Document Name": "Italy PPP survey World Bank (005)_Baker Mckenzie.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2OuP7MOeZlFTRCpHyJfg"
 },
 {
  "Email": "sitnikov@vegaslex.ru",
  "Name": "Alexander Sitnikov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2Pe7XCtrwJ39tkFaIcHT"
 },
 {
  "Email": "teshomeg@tgmblawoffice.com",
  "Name": "Teshome Gabre-Mariam Bokan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2QGhC0s117PH6s6mer2z"
 },
 {
  "Email": "info@aljoufilaw.com",
  "Name": "Yousef Al-Joufi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2QvZWuMF8gORjt3hWlrf"
 },
 {
  "Email": "james.williams@languageline.co.uk",
  "Name": "James Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2RV5XiNYZhyJHzabMele"
 },
 {
  "Email": "thomas.kulzer@gleisslutz.com",
  "Name": "Thomas Kulzer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2RjzjaMGj5i5WlqhXQ3q"
 },
 {
  "Email": "gheadrick@dbrs.com",
  "Name": "Grant Hedrick",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2RrjKrglCnEpANeTEEjI"
 },
 {
  "Email": "bdesvignes@jdsellier.com",
  "Name": "Brian G. Des Vignes",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2SAEhXyZV3sMFehwaiWm"
 },
 {
  "Email": "kristine.gaigule-saveja@primus.legal",
  "Name": "Kristine Gaigule",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2SXgLH8EtOIhR7gOuEkz"
 },
 {
  "Email": "donna.robinson@bhciq.com",
  "Name": "Donna Robinson",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2TFHvpWlLh0cKGygWm4q"
 },
 {
  "Email": "AnaMarija.Grubisic@dtb.hr",
  "Name": "Ana Marija Grubisic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2TdmveCqpFGOdpOAcrlm"
 },
 {
  "Email": "emma.clarke@hoganlovells.com",
  "Name": "Emma Clarke",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2U1Bu6PQOXmQwTjSJjeU"
 },
 {
  "Email": "michael@andegeorgis.com",
  "Name": "Michael Andegeorgis",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2U6ql2T2iVVHmjSzLoWQ"
 },
 {
  "Email": "suriprac@gmail.com",
  "Name": "Gabriel Suri",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2UZbvzsDSP8Suw6TqNZM"
 },
 {
  "Email": "doyin.fadare@alliancelf.com",
  "Name": "Mr Doyin Fadare",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_PPP_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2Um4JT25Dd98BIcBYon8"
 },
 {
  "Email": "marko.tiiman@glimstedt.ee",
  "Name": "Marko Tiiman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2VAOWPwuza3U6t8FEuyL"
 },
 {
  "Email": "info@pppforum.si",
  "Name": "dr. Bo�tjan Ferk",
  "Document Name": "BI 2020 SVN_bi_PPP_survey_en_vpra�alnik-Bo�tjan Ferk.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2VEurMgHeWtilBggcgu4"
 },
 {
  "Email": "kantipatel@crc.co.zm",
  "Name": "Kanti Patel",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2W4Nec0mIp7DjUTq4by4"
 },
 {
  "Email": "pcaron@ait-aci.ca",
  "Name": "Patrick Caron",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2WSW5VtQQOW4ihNR0jvE"
 },
 {
  "Email": "siim.maripuu@triniti.ee",
  "Name": "Siim Maripuu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2XolUfBdR9HfeUGE0Fj4"
 },
 {
  "Email": "mnishigai@paulweiss.com",
  "Name": "Makoto Nishingai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2XyQ5k2XjU23VHyITElp"
 },
 {
  "Email": "ketselamulat2005@yahoo.com",
  "Name": "Ketsele Mulat",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2YUEuH5ORNkeg0LLhreR"
 },
 {
  "Email": "franceskinj@asiattorneys.com",
  "Name": "Mr. Albert Franceskinj",
  "Document Name": "BI 2020 VNM_bi_PPP_survey_en_ FidalAsiaattorneys_Albert Franceskinj04.09.2019.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2YZrbc7nHfHzvRB8U862"
 },
 {
  "Email": "nick.flanagan@meredithconnell.co.nz",
  "Name": "Nick Flanagan",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2agrP2xQzXpcVc7VnK4x"
 },
 {
  "Email": "tambet.toomela@eversheds.ee",
  "Name": "Tambet Toomela",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2bGpC5OMRds1akTm5gxm"
 },
 {
  "Email": "metw@nortonrosefulbright.com",
  "Name": "Mr. Methawat Wongsuwat",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2bSOHJNrkp2RZ95P30Ka"
 },
 {
  "Email": "lusakachamber@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2be4CEb9hFQMyy1KpOBf"
 },
 {
  "Email": "afakerdinova@deloitte.kg",
  "Name": "Albina Fakerdinova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2cEdiT673fsFkmHQIzCp"
 },
 {
  "Email": "samer.eido@allenovery.com",
  "Name": "Samer Eido",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2cWmbLpFR51PNA8TFMre"
 },
 {
  "Email": "reolon@jacoby.adv.br",
  "Name": "Mr. Jaques Reolon",
  "Document Name": "BRAZIL) JACOBY) BI 2020 BRA_bi_PPP_survey_en-JACOBY.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2cdk9yIt58Wn8skIWLFv"
 },
 {
  "Email": "paul.kunnap@sorainen.com",
  "Name": "Paul Kunnap",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2cqwDwPR5yXIrRHjbPJr"
 },
 {
  "Email": "AlKhobar@arabianbemco.com",
  "Name": "Henry Sarkissian",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2dVTIghuo5Op0uz3D1xn"
 },
 {
  "Email": "nikolaus.paul@wolftheiss.com",
  "Name": "Nikolaus Paul",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2dZ716pqCEGqMORjgtKB"
 },
 {
  "Email": "eramirez@blplegal.com",
  "Name": "Mr. Eduardo Ramírez",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2e54zlBo9uVtzkERzhQe"
 },
 {
  "Email": "liliana.andonova@graduateinstitute.ch",
  "Name": "Liliana Andonova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2eBO4KBZ0hLi0jvPE0eM"
 },
 {
  "Email": "psfinance@pmc.gov.sb",
  "Name": "Shadrach Fanega",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ehBIFviydi3z4zbZohz"
 },
 {
  "Email": "DBird@blg.com",
  "Name": "Donald G. Bird",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2grxjk9BE44JRJ4RDn2M"
 },
 {
  "Email": "legal@lex.kg",
  "Name": "Vitaliy Yen",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2h48JO6ZyiU3U8I6Trpt"
 },
 {
  "Email": "cobando@roqueyalvarez.co.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2hqcDU98W4tpuRbdCKgU"
 },
 {
  "Email": "tsvyetkov@gestors.com.ua",
  "Name": "Mr Andriy Tsvyetkov",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en2_Attorneys' Association Gestors.doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2isv2H4mPYvsRc5dFUMn"
 },
 {
  "Email": "raguevara@batalla.com",
  "Name": "Mr Ra�l/Marvin Guevara/Carvajal",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en Final.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jIUzX3Gd19Ywv4vyKZf"
 },
 {
  "Email": "james.clarke@bclplaw.com",
  "Name": "James Clarke",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jM4c7yiU2Tt8tvPimgS"
 },
 {
  "Email": "wolde.ab@pres.uoa.edu.er",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jO3iH2a8KEOrUeqYgNx"
 },
 {
  "Email": "adil.tirmizey@riaabg.com",
  "Name": "Mr Adil Tirmizey",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_RBG_Shaukat.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jRfkqwl04I0UshIx91k"
 },
 {
  "Email": "peter.hogstrom@cirio.se",
  "Name": "Mr Peter H�gstr�m",
  "Document Name": "SWEDEN) CIRIO LAW) BI 2020 SWE_bi_PPP_survey_FINAL.docx",
  "Country": "SWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jSLZlx6kdLk5P7m1Hhw"
 },
 {
  "Email": "dinka.kovacevic@kps-law.com",
  "Name": "Dinka Kovacevic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jhFvlceaBAurQLaRMHn"
 },
 {
  "Email": "chinwaandco@sdnp.org.mw",
  "Name": "Timothy Chinwa",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2jqNVnaIod04Tj0gb2Um"
 },
 {
  "Email": "hernan@chirgwin.cl",
  "Name": "Mr. Hernán Peñafiel",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en_20190830_Chirgwin.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2k7C5sUfvESCKglm6ZOu"
 },
 {
  "Email": "haneen@hejailanlaw.com",
  "Name": "Haneen Al Hejailan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2kROx44eMkMmG4abs4jH"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Mikhail Slobodin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2l17YkMf1DwNEKoaezmr"
 },
 {
  "Email": "shardhalim@azmilaw.com",
  "Name": "Miss Shardha Lim Yuet Ying",
  "Document Name": "2019-BI 2020 MYS_bi_PPP_survey_en[10535].docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2lpR4UK39rp6iHBHM7eW"
 },
 {
  "Email": "mostpp@mostpp.ru",
  "Name": "Mikhail Kuzovlev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ltLHVwPCi2iZpaLjxbU"
 },
 {
  "Email": "khalid.al-thebity@squirepb.com",
  "Name": "Khalid A Al-Thebity",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2oFMGKtXwQWDg1rFWlRe"
 },
 {
  "Email": "hirano@blakemore.gr.jp",
  "Name": "Takashi Hirani",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2phQcCVRRLLBVlK4oxbg"
 },
 {
  "Email": "georg.kahle@nortonrosefulbright.com",
  "Name": "Georg Kahle",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2q9TIC26b7TMys71DSk7"
 },
 {
  "Email": "mmatui@upng.ac.pg",
  "Name": "Mange Matui",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2qN1yLOi3w9tIu2048d2"
 },
 {
  "Email": "rkinghan@perlaw.ca",
  "Name": "Robert P. Kinghan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2qcXBQXnVXJN9mueWmRf"
 },
 {
  "Email": "psilveira@paltd.com.au",
  "Name": "Peter Silveira",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2qmuwEsN73QpmSoTMFId"
 },
 {
  "Email": "h.chamsaryan@avenueconsulting.am",
  "Name": "Hovhannes Chamsaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2r1wFW9iQIQGSGs4CppJ"
 },
 {
  "Email": "info@als.cr�",
  "Name": "Christian Krause",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2rJxHMIIA0seNsG5cJ7K"
 },
 {
  "Email": "federica.de.luca@pwc.com",
  "Name": "Ms. Federica De Luca",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2rPAym4LtkSq5no5poOn"
 },
 {
  "Email": "Bruce.Nicholson@KramerAusenco.com",
  "Name": "Bruce Nicholson",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2s9x4tBrmBLc9MSMQde1"
 },
 {
  "Email": "andreja.turcin@pbz.hr",
  "Name": "Andreja Turcin",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2sd6h3aGwnFOfAQ9Ipoy"
 },
 {
  "Email": "lauri.liivat@eversheds.ee",
  "Name": "Lauri Liivat",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2tFCJNF4CX2yeRYVc0Z8"
 },
 {
  "Email": "daniel.hulme@stblaw.com",
  "Name": "Daniel Hulme",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2tFtCFrcqgtnfhrmBe1e"
 },
 {
  "Email": "apierson@whitecase.com",
  "Name": "Adam Pierson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2thRvDPir3lTzoj4w3vd"
 },
 {
  "Email": "maruojoseph@gmail.com",
  "Name": "Joseph Macha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2uSmRKCqAQUNH5AUrozc"
 },
 {
  "Email": "rohullahamin@yahoo.com",
  "Name": "Rohullah Amin",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ueI2sgyU6i3U7aNGQ5V"
 },
 {
  "Email": "atunyan@mail.ru",
  "Name": "Araik Tunyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ui1Igc2Px0SsJBjYmjT"
 },
 {
  "Email": "wafa.shami@sksadvocates.com",
  "Name": "Wafa Shami",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2v7Cao83OmQuQsXWgxY4"
 },
 {
  "Email": "kebreab@castellucciemancuso.com",
  "Name": "Kebreab Habte Michael",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2va9eDzCn4lrfgBFes6D"
 },
 {
  "Email": "gunagm@ethionet.et",
  "Name": "Mulualem Berhane",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2vmAKs0wHYwvwZCsJtPl"
 },
 {
  "Email": "caroline.williams@norfolkchamber.co.uk",
  "Name": "Caroline Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2vv3KaI2qCgqBtseyG40"
 },
 {
  "Email": "supplierrelations.london@kbr.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2w1Ytzn8uOAcJayIN3AE"
 },
 {
  "Email": "tiwari_p@usp.ac.fj",
  "Name": "Pk Tiwari",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2wgHfMaceFNVOGZxv5ZR"
 },
 {
  "Email": "laura.chang@wongpartnership.com",
  "Name": "Laura Chang",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2wkyE16a0KkLvIc9Wamd"
 },
 {
  "Email": "antonio.rios@unachi.ac.pa",
  "Name": "Antonio R�os Ruiz",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2wzH3RUPaWd55sEBJbou"
 },
 {
  "Email": "mark.bassett@dentons.com",
  "Name": "Mark Bassett",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2x1EJwRNE96CzYdaPZAQ"
 },
 {
  "Email": "sflemming@goerg.de",
  "Name": "SANDRA FLEMMING",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2xp7KnKIPnUgnDv30Jvf"
 },
 {
  "Email": "leoarauz@carreirapitti.com",
  "Name": "Leonor Ara�z Silva",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/2ylD3OjXrDpTVBIh25qs"
 },
 {
  "Email": "jareina@ecija.com",
  "Name": "Mr. Jorge Reina Interiano",
  "Document Name": "UPDATED BI 2020 HND_bi_PPP_survey_en (07.10.19)Ecija.doc",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/30b8pJSxuWsz32A6sujB"
 },
 {
  "Email": "rrampersad@deloitte.com",
  "Name": "Rikhi Rampersad",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/31WiH12XkBIvOkeFuqGw"
 },
 {
  "Email": "info@davidmagang.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/325nkwxSYZKQQ1AHXuTN"
 },
 {
  "Email": "rmsmith@shajjanlaw.com",
  "Name": "Mike Smith",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/33iXrvPm2s4vAlGXBC7j"
 },
 {
  "Email": "sperez@guyer.com.uy",
  "Name": "Mr Sebastian Perez",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en final.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/34R54FbhWIu9w17hX3hx"
 },
 {
  "Email": "hamidhabibzada@gmail.com",
  "Name": "Abdul Hamid Habib",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/34UYv2Vxgrox9Upquf8K"
 },
 {
  "Email": "wolde.haimanot@gmail.com",
  "Name": "Getachew Mandefro Abate",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/35z6tPAJvOY77dw7RKbq"
 },
 {
  "Email": "jchida@omm.com",
  "Name": "Junaid Chida",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/369LAe1Fjri2J2vOMhQ4"
 },
 {
  "Email": "prasad_su@usp.ac.fj",
  "Name": "Narendra Prasad",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/37UjsDyoIve61YYGFtBf"
 },
 {
  "Email": "rmutasa@manokore.com",
  "Name": "Mr Ronald Mutasa",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en.doc-Ronald Mutasa (Zimbabwe) Responses-20-07-19-FINAL.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/37XOJj4ujqjOwPxFXnOl"
 },
 {
  "Email": ":o.anyanechi@seftonfross.com",
  "Name": "Mrs Olayemi Anyanechi",
  "Document Name": "NIGERIA) SEFTON FROSS) BI 2020 NGA_bi_PPP_survey_en .doc SF 21.8.2019.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3ALpUjEDcjfhHxup3T7W"
 },
 {
  "Email": "atiasm@hfn.co.il",
  "Name": "Mor Atias",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3AMPbYYscF3yuM7O9ZkW"
 },
 {
  "Email": "k.martirosyan@avenueconsulting.am",
  "Name": "Karen Martirosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3AQJk23PySdc2JQUBcHz"
 },
 {
  "Email": "owen.cooper@minterellison.com",
  "Name": "Owen Cooper",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Aa0pqKhYqR6Y0euwuPr"
 },
 {
  "Email": "elena@araujolaw.com",
  "Name": "Elena Araujo",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3AgO692zseZvqFO3pQtF"
 },
 {
  "Email": "mona@omeralilawfirm.com",
  "Name": "Mona Ahmed Ali",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3BUZ0OJtNb9dpsPAfYsV"
 },
 {
  "Email": "Shabaz.Khalid@alaflaw.com",
  "Name": "Shabaz Khalid",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Bt3BPqakplCsag6pl6d"
 },
 {
  "Email": "john.lonsberg@bakerbotts.com",
  "Name": "John Vincent Lonsberg",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3C0Bgu9tV9rl5AAryHWm"
 },
 {
  "Email": "yelzhan.birtanov@gmail.com",
  "Name": "Yelzhan Birtanov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3CDdA6TXjJVKUi6wYzte"
 },
 {
  "Email": "jeremy.connick@cliffordchance.com",
  "Name": "Jeremy Connick",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3CxQW8pACdiqsyIFlSp4"
 },
 {
  "Email": "alexela@alexela.ee",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3DHnM3sHRSZJ6aR9ZmSJ"
 },
 {
  "Email": "iva.basaric@babic-partners.hr",
  "Name": "Iva Basaric",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3FBUQ8r0xALS1KKiqH87"
 },
 {
  "Email": "stomovi@gmail.com",
  "Name": "Ms. Svetlana Tomovi?",
  "Document Name": "BI 2020 MNE_bi_PPP_survey_en_MOF.docx",
  "Country": "MNE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3FQtNkRlinIToEDAQ8ET"
 },
 {
  "Email": "aziza@aihlawfirm.com",
  "Name": "Mrs. Aziza Ismat",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_Kayan.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3FcwPLyJ5HCiXVLomRne"
 },
 {
  "Email": "ekihali@exorattorneys.com",
  "Name": "Ezekiel Kihali",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Fy4zn6PpVHhptVRRuAw"
 },
 {
  "Email": "christiane.freytag@gleisslutz.com",
  "Name": "Christiane Freytag",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Gx6yRO38hldhqAaBmwD"
 },
 {
  "Email": "shehara.varia@fjgdesaram.com",
  "Name": "Shehara Varia",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3HPEFCy5wFPYkaDDxXQr"
 },
 {
  "Email": "javier.aguilar@ariaslaw.com",
  "Name": "Mr. Javier Aguilar",
  "Document Name": "BI 2020 SLV_bi_PPP_survey_en.doc.docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3HdYcQrgSfpLz2IdTXxo"
 },
 {
  "Email": "Waleed@mansourlawfirm.com",
  "Name": "Waleed Mansour",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3HvYpAjAoOZXYFrbYY1F"
 },
 {
  "Email": "boltze@verkehr.tu-darmstadt.de",
  "Name": "Manfred BOLTZE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3I1AubZz3vsurZN52PnV"
 },
 {
  "Email": "Bahjay2004@yahoo.co.uk",
  "Name": "Alpha Muctarr Jalloh",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3I3fhCp0tccNqnwcrq6t"
 },
 {
  "Email": "Attorneys@wphklaw.com",
  "Name": "Mr. Wadih Philippe Khalaf",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Ia3IHCX1tjXuE411FiU"
 },
 {
  "Email": "neil.cuthbert@dentons.com",
  "Name": "Neil Cuthbert",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3J0Ek9FZAPkdjFjGMjvf"
 },
 {
  "Email": "narumi.ito@morganlewis.com",
  "Name": "Narumi Ito",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3JKumIhj0foub6xgTAqc"
 },
 {
  "Email": "wolfgang.sturm@linklaters.com",
  "Name": "Wolfgang Sturm",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3JP3O2nHU0RfyV4FLood"
 },
 {
  "Email": "ibsorie1@yahoo.com",
  "Name": "Ibrahim Sorie",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3JptWMT4mHEXVngCt1fT"
 },
 {
  "Email": "jelena.gazivoda@jpm.rs",
  "Name": "Dr Jelena Gazivoda",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_JPM Jankovic Popovic & Mitic.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3JrIoRJeeS4LYvyCqzez"
 },
 {
  "Email": "jonathan.casson@holmanwebb.com.au",
  "Name": "Jonathan Casson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3JsIVkpmbbrUbxJfik8k"
 },
 {
  "Email": "oko@bruunhjejle.dk",
  "Name": "Olaf Koktvedgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3LJHShZNtilVx7tr6bC3"
 },
 {
  "Email": "ahayrapetyan@fidelitylegal.am",
  "Name": "Arayik Hayrapetyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3MMLNvgQgKz24IwMX0xS"
 },
 {
  "Email": "varnavsky@imemo.ru",
  "Name": "Vladimir Varnavskiy",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3O60sd8v1Y05TLLkb8Eg"
 },
 {
  "Email": "jkotrba@deloitteCE.com",
  "Name": "Josef Kotrba",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3OZ71U8kmQr46ruSmwuZ"
 },
 {
  "Email": "jennifer@exeterchamber.co.uk",
  "Name": "Jennifer Byrne",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3PNg8PToQZeRDk5HrkEW"
 },
 {
  "Email": "ahatami@hatamilawfirm.com",
  "Name": "Ali Hatami",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3QdVzhs6iGanL5aIZtEV"
 },
 {
  "Email": "ringoeric@yahoo.com",
  "Name": "Eric Frank Ringo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3SDUuWJHvbhlXmsJkbjX"
 },
 {
  "Email": "Dler@dlerlawoffice.com",
  "Name": "Fouad S. Rasheed",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3SWL3Cluef4ocnvKrFBv"
 },
 {
  "Email": "csooko@deloitte.com",
  "Name": "Carl Sooko",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3T0iJjBLJXzKS3pqwy3c"
 },
 {
  "Email": "ariel.nachman@simmons-simmons.com",
  "Name": "Ariel Nachman",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3TvDbtekqpGXhZhVH2hr"
 },
 {
  "Email": "info@langcr.com",
  "Name": "Henry Lang",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3U1tredUp1Jlpo9NV95a"
 },
 {
  "Email": "evold@lawfrontadvocates.co.tz",
  "Name": "Evold Mushi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3UfefkmL9rR7ofPTpelM"
 },
 {
  "Email": "derek.loh@tsmplaw.com",
  "Name": "Derek Loh",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3V0HvcDe9AtXyMRHLLWc"
 },
 {
  "Email": "catherine.morton@sparke.com.au",
  "Name": "Catherine Morton",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3V5XB68FzqxNoDcUNKH6"
 },
 {
  "Email": "ed.fishman@klgates.com",
  "Name": "Edward Fishman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3WWi6xhs0rqfkl0BLbmv"
 },
 {
  "Email": "A.Haak@taylorwessing.com",
  "Name": "Andreas Max Haak",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Wg7KnKYxZmdtN5GJE0y"
 },
 {
  "Email": "vardanyan_so@mostpp.ru",
  "Name": "Suren Vardanyan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3WnCreC7OBGYaBJm6IUX"
 },
 {
  "Email": "msulemane@fra.legal",
  "Name": "Dr. Milton Sulemane",
  "Document Name": "MOZAMBIQUE) FRA LEGAL) BI 2020 MOZ_bi_PPP_survey_en.doc",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3Y4p5Zizna1JICdQCBKC"
 },
 {
  "Email": "vele@dm5.co.za",
  "Name": "Vele Mulangaphuma",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3YXfZdoTrxvNE7qQO4Jw"
 },
 {
  "Email": "adam.barlett@au.kwm.com",
  "Name": "Adam Barlett",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3ZpQUhDp5iHnQ3WrKC8q"
 },
 {
  "Email": "monthemarumo@botsnet.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3aOYrr8dmYMhyKKI5otJ"
 },
 {
  "Email": "info@egl.co.il",
  "Name": "Alina Kizin",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3alAe6cdkkmUKwec1jsP"
 },
 {
  "Email": "aiman.zhekeyeva@integrites.com",
  "Name": "Aiman Zhekeyeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3b4CTsuiewX4YTKCEJLY"
 },
 {
  "Email": "nabiladib@hotmail.com",
  "Name": "Nabil Adib",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3bY3QhYJOxld8FONEHUV"
 },
 {
  "Email": "info@mahassni.com.sa",
  "Name": "Hassan M.S. Mahassni",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3c3f23ysAQQe2XdERW66"
 },
 {
  "Email": "rrimats@golder.com",
  "Name": "Rosie Rimats",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3cRUiuIpPMTiax7RPmlJ"
 },
 {
  "Email": "aisha.sinda@mkono.com",
  "Name": "Aisha Sinda",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3cVW4XrQu9h52zlEGtKA"
 },
 {
  "Email": "gkaptanis@koutalidis.gr",
  "Name": "Mr. Ioannis Kaptanis",
  "Document Name": "GREECE) KOUTALIDIS) BI 2020 GRC_bi_PPP_survey_en_07082019.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3cuCSgFHzE5nig9eIeUK"
 },
 {
  "Email": "howard.kleiman@klgates.com",
  "Name": "Howard Kleiman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3dALGKZLQrZ5ZfO6wipq"
 },
 {
  "Email": "rashid.aliyev@remells.com",
  "Name": "Mr Rashid Aliyev",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en_Remells.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3fTwg8tFEP0rhvsg5ahq"
 },
 {
  "Email": "momo-o@mmn-law.gr.jp",
  "Name": "Shigeaki Momo-O",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3fW7kLguKFvJ7gH6LKJS"
 },
 {
  "Email": "ivana.cota@lbhlaw.com.br",
  "Name": "Ms. Ivana Cota",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en_vLBH.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3fZ0AVmBGJtnKp2jhVIZ"
 },
 {
  "Email": "yersinbek.mukhamedzhan@centil.law",
  "Name": "Mr. Yersinbek Mukhamejan",
  "Document Name": "BI 2020 KAZ_bi_TPI_survey_en (Centil Law - 30092019).docx",
  "Country": "KAZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3glX3f9XSkIQMfmDH3Jj"
 },
 {
  "Email": "jacky.scanlan-dyas@hoganlovells.com",
  "Name": "Jacky Scanlan",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3iFMUtkM1qyYEjQvc4za"
 },
 {
  "Email": "ndellolio@abbatescianni.eu",
  "Name": "Mr Nicola Alessandro Dell'Olio",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Nicola Alessandro Dell�Olio.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3iSUBLd4iDQW03m1PGPY"
 },
 {
  "Email": "ericherlafleche@stikeman.com",
  "Name": "Erik Richer La Fleche",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3jqRqanUFSCg6k7jsUJ2"
 },
 {
  "Email": "ian.tucker@burges-salmon.com",
  "Name": "Ian Tucker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3jxb4gGNqgs5CW6EHL6A"
 },
 {
  "Email": "info@constructoraguzman.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3k5BqxAfLkH8ic3X5jBN"
 },
 {
  "Email": "lejimenez@jcpdr.com",
  "Name": "Mr. Luis Eduardo Jim�nez",
  "Document Name": "BI 2020 DOM_bi_PPP-survey_en_LJJ (00402513xAEE47).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3mFBaTsWQuGBi5cUd1mm"
 },
 {
  "Email": "bernt.elsner@cms-rrh.com",
  "Name": "Dr. Bernt Elsner",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_CMS.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3n1gCHl3DISTdNwFTXok"
 },
 {
  "Email": "nja@pagbam.com",
  "Name": "Nicole Jaureguiberry",
  "Document Name": "World Bank- Traditional Public Investment in Infrastructure survey (2).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3nfWy1xtDPeU7wwsLPcw"
 },
 {
  "Email": "contactus@ypo.co.uk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3nlIe7SaZaOI9HdVyaWx"
 },
 {
  "Email": "raquiros@central-law.com",
  "Name": "Randall Quiros",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3nt5sAc3EUhBZvjAgpCL"
 },
 {
  "Email": "efrats@tadmor-levy.com",
  "Name": "Efrat Shapira Orren",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3oNPmcuXKNX0VmyAJvdM"
 },
 {
  "Email": "stephen.p.lechner@us.pwc.com",
  "Name": "Stephen Lechner",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3p75XVP7zXDeggDWkSoI"
 },
 {
  "Email": "hovhannisyanb@bso.am",
  "Name": "Izabela Hovhannisyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3pEO0J0d9O11NhHYSBij"
 },
 {
  "Email": "tamendes@hrlegalcircle.com",
  "Name": "Tiago Arouca Mendes",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3qGwRwMcZZ185rjh5rvf"
 },
 {
  "Email": "sjdirks@orrick.com",
  "Name": "Stanley Dirks",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3qcTC5Le4tlsdbza1kaU"
 },
 {
  "Email": "stephen.quinn@dlapiper.com",
  "Name": "Stephen Quinn",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3qlTfiZOdv0MJXl9sqYJ"
 },
 {
  "Email": "paul.k.brewer@uk.pwc.com",
  "Name": "Paul Brewer",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3rJiuJfcJvLkDdHjScNw"
 },
 {
  "Email": "mail@mbendernkhono.com",
  "Name": "Patrice Nkhono",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3rOGpCoqjUja2fCzkl3D"
 },
 {
  "Email": "Arthur.Gleijm@rebelgroup.com",
  "Name": "Arthur Gleijm",
  "Document Name": "LAO) PPP UNIT) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3rogeaiKx6BD6OwTuxr4"
 },
 {
  "Email": "gerry.bean@dlapiper.com",
  "Name": "Gerry Bean",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3rrYg1JHlWWUAczd4R7x"
 },
 {
  "Email": "simon.huxley@allenovery.com",
  "Name": "Mr Simon Huxley",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Allen & Overy.doc",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3sSLgqcwkPtbj6v0JzsN"
 },
 {
  "Email": "klebrun@shearman.com",
  "Name": "Keneth Lebrun",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3sTHeOC0baeBWE1S7ZBD"
 },
 {
  "Email": "info@hnmattorneys.co.za",
  "Name": "Basetsana Molebatsi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3sUxk2xutpE3cIt7X9hD"
 },
 {
  "Email": "kirchner@berettagodoy.com",
  "Name": "Mr Carlos Jorge Kirchner",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en (1) (003) (FG).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3sqWT7cMTqdvjPmoNVoH"
 },
 {
  "Email": "karveli@kelemenis.com",
  "Name": "Ms. Konstantina Karveli",
  "Document Name": "GREECE) KELEMENIS) BI 2020 GRC_bi_PPP_survey_en.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3t1dG5STxE3l6lDcxYu0"
 },
 {
  "Email": "aliaksandr.artsiukhevich@sorainen.com",
  "Name": "Mr Aliaksandr Artsiukhevich",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_Sorainen.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3uSa3BkqqbW4FFZhJAJy"
 },
 {
  "Email": "tabadia@fmm.com.pa",
  "Name": "Tatiana Abadia",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3ueCZ8dw2kiamUs9rsRc"
 },
 {
  "Email": "pdanquah@gimpa.edu.gh",
  "Name": "Paul Rex Danquah",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3waW8tg61X3oh9upHR7T"
 },
 {
  "Email": "didar.dhillon@pinsentmasons.com",
  "Name": "Didar Dhillon",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/3yeuLFtBL2ivbcKGIhNN"
 },
 {
  "Email": "nicole.green@minterellison.com",
  "Name": "Nicole Green",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/40qTW9fnZ75RlmWBerTg"
 },
 {
  "Email": "cbrown@porterhedges.com",
  "Name": "Corey Brown",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/40wlyl2Li8et47yFin15"
 },
 {
  "Email": "resconsulting@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/410dLRhirhi1CSu7RqNT"
 },
 {
  "Email": "Clyde.Rankin@BakerMcKenzie.com",
  "Name": "Clyde Rankin, Iii.",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/42XIguW5ooznafdaNmjA"
 },
 {
  "Email": "Hidemi.Chen@ropesgray.com",
  "Name": "Hidemi Chen",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/42x49vFEnYvgF9EyCLtS"
 },
 {
  "Email": "osama.s@mof.gov.jo",
  "Name": "Mr Osama Suliman",
  "Document Name": "PO BI 2020 JOR_bi_PPP_survey_en_MOF.doc",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/44faWVDX95s5r8K3SL8o"
 },
 {
  "Email": "fv@abel.dk",
  "Name": "Flemming Voldby",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/45dcjx86ARNgE2xU1wDH"
 },
 {
  "Email": "denis.tremblay@demex-canada.com",
  "Name": "Denis Tremblay",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/45eEGLn7v6LeVMEbdc9j"
 },
 {
  "Email": "andrew.wingfield@simmons-simmons.com",
  "Name": "Andrew Wingfield",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/47GGiFGN8BmTh8Fibx4v"
 },
 {
  "Email": "mrollins@austinchamber.com",
  "Name": "Michael Rollins",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/48HPczO5RJ4Rz3hqG0pG"
 },
 {
  "Email": "chiridacha@lsorizon.com",
  "Name": "Chiridacha Phungsunthorn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/498AcXMfiewqc0FeI1LJ"
 },
 {
  "Email": "jlastra@arodi.com",
  "Name": "Johanna Lastra",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4B5ct1KPFcj1A6wCXBwY"
 },
 {
  "Email": "pgaleano@palacioslleras.com",
  "Name": "Paola Galeano",
  "Document Name": "PPP Survey Colombia - �scar Guti�rrez V2.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4BBHPf94QwIk4tu5LFUw"
 },
 {
  "Email": "info@regencytrinidad.com",
  "Name": "Lara Quentrall-Thomas",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4BPXGNfP4cZCbvMgSpIQ"
 },
 {
  "Email": "lawsociety@lawsociety.com.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4BYv8WaJLaUCaFlDBeak"
 },
 {
  "Email": "paulo@constructoramoncada.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4BrD8LPBcKT0T2XCzFzw"
 },
 {
  "Email": "tmalatji@mkinc.africa",
  "Name": "Tebogo Malatji",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4CqE1wtlPUzap6iUClHc"
 },
 {
  "Email": "oleg.matiusha@kinstellar.com",
  "Name": "Mr. Oleg Matiusha",
  "Document Name": "BI 2020 2UKR_bi_PPP_survey_en_Kinstellar.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4DBHfhC3QRIu7LI6TAzT"
 },
 {
  "Email": "christopher.bates@ashurst.com",
  "Name": "Christopher Bates",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4DCHsiduUOKY5Juw4vdx"
 },
 {
  "Email": "info@erlf.com",
  "Name": "Eyad Reda",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4DjV4CdK3siK6k7F7Prh"
 },
 {
  "Email": "taras_rabko@epam.ru",
  "Name": "Taras Rabko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4E7D0QYr5C4v4kC6NJ5j"
 },
 {
  "Email": "ir@bog.ge",
  "Name": "Ana Kostava",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4Eyvh77a8PYZmYAuSpxB"
 },
 {
  "Email": "cfmargai@gmail.com",
  "Name": "Charles Margai",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4FKUbM2rPnyYKHWBqyRn"
 },
 {
  "Email": "chirag.mody@primus.legal",
  "Name": "Chirag Mody",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4GhDug8E69ouAOeYSgkg"
 },
 {
  "Email": "naphambolawco@malawi.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4GyCLroCYwi50dKq0TXX"
 },
 {
  "Email": "ivie@geplaw.com",
  "Name": "Mrs. Ivie Ehanmo",
  "Document Name": "NIGERIA) GEPLAW) World Bank TPI Survey .docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4HrjMTL77cwE2NBBzsQL"
 },
 {
  "Email": "tony.chappel@nortonrosefulbright.com",
  "Name": "Tony Chappel",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4JRuUT3UnzfCCeyYCHhL"
 },
 {
  "Email": "service@gjensidige.dk",
  "Name": "Allan Kragh Thaysen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4Ju670xCTBRL6TsZGueq"
 },
 {
  "Email": "jacklee@smu.edu.sg",
  "Name": "Jack Tsen-Ta Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4KfuOgNsvQffF8ba3q2u"
 },
 {
  "Email": "dave.poddar@cliffordchance.com",
  "Name": "Dave Poddar",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4KgpTTwSqOVSGySCNl1a"
 },
 {
  "Email": "amice@srilankalaw.com",
  "Name": "Amice Van Der Burg-Dissanayake",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4LU7qrsH2yucPLvzHSOp"
 },
 {
  "Email": "aacrouch@deloitte.kz",
  "Name": "Aaron Crouch",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4LmLz58PFYnfwGNRrdMA"
 },
 {
  "Email": "hansel_1_tillmann@yahoo.com",
  "Name": "Hansel Joseph Michael L. Tillmann",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4LqVkKStK8bueGp3htSq"
 },
 {
  "Email": "dramirez@fabara.ec",
  "Name": "Dr Diego Ram�rez Mesec",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en 005 (DRM).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4MJPdnVEkgbsFXh3oUcL"
 },
 {
  "Email": "joao.couinho@utap.pt",
  "Name": "Mr. Jo�o Coutinho",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en_UTAP_final.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4MUxAqD1CJ5bEYBJoTw6"
 },
 {
  "Email": "admin@bicc.org.uk",
  "Name": "Richard Dalton",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4OTAEN6stmwdpNEt8Biw"
 },
 {
  "Email": "solomon@nplaw.ge",
  "Name": "Mr Solomon Bagashvili",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en (filled).doc.docx",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4Ochdcm3OgFlc1juNxgH"
 },
 {
  "Email": "richard.armitage@simmons-simmons.com",
  "Name": "Richard Armitage",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4P3YsTfvIM42nD073qpM"
 },
 {
  "Email": "goncalo.sousa@uria.com",
  "Name": "Mr Gon�alo Andrade e Sousa",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4P4bKtOYYU4nookxQQbJ"
 },
 {
  "Email": "info@salazarmunoz.com",
  "Name": "Cynthia Salazar",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4PP8uCw3FSV7EsymIN73"
 },
 {
  "Email": "melikishvili@vbat.ge",
  "Name": "Giorgi Melikishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4PbVxeCOsJdHJjI7sylm"
 },
 {
  "Email": "gatobek@deloitte.com",
  "Name": "Gulanor Atobek",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4RT2O7CQGMjHelHhw7W0"
 },
 {
  "Email": "maria.athaydetavares@csassociados.pt",
  "Name": "Ms. Maria de Athayde Tavares",
  "Document Name": "WordBank_SurveyPPP.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4SGfVTHI6v0SDCmql0np"
 },
 {
  "Email": "csb24@cam.ac.uk",
  "Name": "Catherine Barnard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4TRHTdrl9zbGkXU6q1SQ"
 },
 {
  "Email": "anne.davies@law.ox.ac.uk",
  "Name": "Anne Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4UIAxtFeeZ9LBbadmfMo"
 },
 {
  "Email": "aatkins@velaw.com",
  "Name": "Alden Atkins",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4Uf9lU0HN4qXyah1BeNx"
 },
 {
  "Email": "hh@hejailanlaw.com",
  "Name": "Hussam Al Hejailan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4X5bpXl8I6x3mjdo0WU3"
 },
 {
  "Email": "Sergey.Krokhalev@bakermckenzie.com",
  "Name": "Sergey Krokhalev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4XGkQ2LZgcpqk3pOATDc"
 },
 {
  "Email": "prss@cowi.com",
  "Name": "Peter Sievers",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4YY3nCvikJr2ftiv9hki"
 },
 {
  "Email": "monyrith.eng@hml.com.kh",
  "Name": "Mr. Monyrith Eng",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en_HML1.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4YoRM7CWKDm24d9ipmKG"
 },
 {
  "Email": "Adrianonuvunga@gmail.com",
  "Name": "Adriano Nuvunga",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4ajvokJGgh9KlangO2Dm"
 },
 {
  "Email": "Hassan@somlegal.so�",
  "Name": "Hassan Farah Mohamed",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4bEFcy9s89fctBtcMMX8"
 },
 {
  "Email": "alma_porciuncula@dai.com",
  "Name": "Alma Porciuncula",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4cEzzaP7etSFlp2313kY"
 },
 {
  "Email": "n.pasaribu@amoktarina.co",
  "Name": "Mr Noverizki Tri Putra Pasaribu S.H. LL.M (Adv)",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Oktarina Counsellors.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4cJyoG4ix09jAnLhfYxy"
 },
 {
  "Email": "jurgita.nikita@sorainen.com",
  "Name": "Ms. Jurgita Nikita",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en[529] Sorainen 2019-07-20.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4f31BOb4JAi8rMTe1NvE"
 },
 {
  "Email": "lw.law@ipasifika.net",
  "Name": "Semi Wai",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4f3pTyzvtXcLHxchhnMX"
 },
 {
  "Email": "mam@isaacandpartners.com",
  "Name": "Mwenya Andrew Mukupa",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4fHrdQ1GbrLlLIE27UxE"
 },
 {
  "Email": "info@communicaid.com",
  "Name": "Katherine Palmer",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4faO1zD14lov2gB6gKLx"
 },
 {
  "Email": "info@kdaw.lk",
  "Name": "S. Sureshkumar",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4gPw91s4Y4EsohYTdlQf"
 },
 {
  "Email": "dfioretti@grimaldilex.com",
  "Name": "Ms Daniela Fioretti",
  "Document Name": "ITA_bi_PPP_survey_en_Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4gQvK7yKuGJ3UWT35F3k"
 },
 {
  "Email": "rahim.shimarov@dentons.com",
  "Name": "Rahim Shimarov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4gVlWQnXXD6m8iMSfSN6"
 },
 {
  "Email": "mark.richards@blplaw.com",
  "Name": "Mark Richards",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4ghpQPJyfmQKOvk7CYvw"
 },
 {
  "Email": "j.motion@unsw.edu.au",
  "Name": "Judy Motion",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4gwr4AU2305IUWfUqV6f"
 },
 {
  "Email": "info@asterionghana.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4hMz5vkXikYqMBli6dba"
 },
 {
  "Email": "anders.faeste@bcg.com",
  "Name": "Anders F�ste",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4hP0TK07rBgxlNBglc9I"
 },
 {
  "Email": "patrick.parkin@burges-salmon.com",
  "Name": "Patrick Parkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4hV5sGqs37KPhtmugzTZ"
 },
 {
  "Email": "yasuko.tsuchihashi@aplaw.jp",
  "Name": "Yasuko Tsuchihashi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4hiFA9FPs1EGadCdRA6m"
 },
 {
  "Email": "mauricio.villeda@gufalaw.com",
  "Name": "Mauricio Villeda Berm�dez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4i82d0Kv18g8Val9GSaV"
 },
 {
  "Email": "ishihara@bridge.t.u-tokyo.ac.jp",
  "Name": "Takeshi Ishihara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4i9phoXwF5WMM3tmDc0D"
 },
 {
  "Email": "ghana@baminternational.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4isTjTkJCyPi1F7Ma5dB"
 },
 {
  "Email": "chalaka@clsynergy.com",
  "Name": "Chalaka Siriwardena",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4iy1vnYkVGMO3RusWZp8"
 },
 {
  "Email": "natercia.sitoi@tta-advogados.com",
  "Name": "Ms Nat�rcia Sitoi",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en_TTA.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4jIyEDLn3yJRlLxJNNNG"
 },
 {
  "Email": "hcb@corderoabogados.com",
  "Name": "Hern�n Cordero Baltodano",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4jXdEJFJVoL8c5fiVLbj"
 },
 {
  "Email": "nessop@deloitte.co.za",
  "Name": "Nazeer Essop",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4lg6ilbHsffcqDVEitB5"
 },
 {
  "Email": "mark.walker@allenovery.com",
  "Name": "Mark Walker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4mNZ566Onqm2QKUXUJhP"
 },
 {
  "Email": "grigoryev@vegaslex.ru",
  "Name": "Maxim Grigoryev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4oXX7PB8If8ZZgOSn6ak"
 },
 {
  "Email": "anna.pogrebna@cms-rrh.com",
  "Name": "Ms Anna Pogrebna",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_CMS Reich-Rohrwig Hainz.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4onkOnUFCatdMf6k09ZR"
 },
 {
  "Email": "ldebernardis@mafirma.com.pe",
  "Name": "Mr. | Mrs. Luis Marcelo | Isabel De-Bernardis | Lira",
  "Document Name": "WB APP 2.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4p3PLsVEMpV1hwYPYGp2"
 },
 {
  "Email": "swati.rawat@azbpartners.com",
  "Name": "Ms Swati Rawat",
  "Document Name": "BI 2020 IND_bi_PPP_survey_en_ 02 08 2019.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4pEJdulUCQBHJqzDksiG"
 },
 {
  "Email": "giorgi.jolia@bgi.ge",
  "Name": "Mr. Giorgi Jolia",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en (3).docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4qL8qwTIDtR512dcZWMS"
 },
 {
  "Email": "neill.armstrong@collinsnewman.bw",
  "Name": "Neill Armstrong",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4qQS76Lr6gjYamXhE49f"
 },
 {
  "Email": "mateus.mosse@amac.org.mz",
  "Name": "Matteus Mosse",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4qiKC8BSsEXnclM4b3xS"
 },
 {
  "Email": "estudio@echevarriaabogados.com",
  "Name": "Jos� Luis Echevarr�a",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en (1).docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4qy1A4R9w61aXovSaiQD"
 },
 {
  "Email": "info@southpacificlayers.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4rsf47NJ2TSAHDCjk6mw"
 },
 {
  "Email": "s.clear@bangor.ac.uk",
  "Name": "Stephen Clear",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4s0I2xrMeflCJDq8wz33"
 },
 {
  "Email": "abhesh.kumar@sg.pwc.com",
  "Name": "Abhesh Kumar",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4swFd9y8Qu2ScAZ9mjdw"
 },
 {
  "Email": "info@eliteattorneys.co.tz",
  "Name": "Hussein Kitta Mlinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4u0o1baPQJYYKlG833j6"
 },
 {
  "Email": "raquel@chirgwin.cl",
  "Name": "Ms. Raquel Frattini",
  "Document Name": "BI 2020 CHL_bi_PPP_survey_en_20190830_Chirgwin .docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4uEjKyW4aBgfuJ4qj4sw"
 },
 {
  "Email": "info@interlexnet.com",
  "Name": "Wole Adesola",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4uTASQakphkYvjTDkD80"
 },
 {
  "Email": "andrew.jones@linklaters.com",
  "Name": "Andrew Jones",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4ulkvx9xeCBJ8dqP3J9I"
 },
 {
  "Email": "contact@canabid.com",
  "Name": "Lili Miller",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4vm2jFqlons3vqqmc1oI"
 },
 {
  "Email": "cgaray@dnp.gov.co",
  "Name": "Mr Carlos Garay",
  "Document Name": "BI 2020 COL_bi_PPP_survey_enCarlosGarayDNP6.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4wgPIWYeA1Kdqnoe0JUR"
 },
 {
  "Email": "steven.galbraith@slaughterandmay.com",
  "Name": "Steven Galbraith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4wkWpX3bLydoYBz2jMgk"
 },
 {
  "Email": "sato@coastal.t.u-tokyo.ac.jp",
  "Name": "Shinji Sato",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4wkzXHkS7x5qkmKYZDyr"
 },
 {
  "Email": "abs809@bangor.ac.uk",
  "Name": "Kay Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4wmts6jn5VykFiysP7pp"
 },
 {
  "Email": "info@hbkcontracting.com",
  "Name": "Niyaz Ahmed",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4yGGidlxEcrb8xLHLDV1"
 },
 {
  "Email": "ilaughland@millsoakley.com.au",
  "Name": "Ian Laughland",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4yWrS68zP3RkWjJq49r2"
 },
 {
  "Email": "groca@qil4.com",
  "Name": "Ana Gabriela Roca",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4yq306Cj5sRwmQmKFi9o"
 },
 {
  "Email": "n.gvinadze@gvinadzeandpartners.ge",
  "Name": "Nick Gvinadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4ytXqD7VUKHfXJenbj69"
 },
 {
  "Email": "naveed.Jeddy@kw.ey.com",
  "Name": "Naveed Ahmed Jeddy",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4z8ShbuRPrqN8o5xglE9"
 },
 {
  "Email": "jk@sltnet.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/4zz55tsvyd9eZoHsYSWR"
 },
 {
  "Email": "marija.gregoric@babic-partners.hr",
  "Name": "Marija Gregoric",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/50OlfUEK6NTGqOMQJlu3"
 },
 {
  "Email": "taras_rabko@epam.ru",
  "Name": "Taras Rabko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/50bQeFfiNMmPW8Md1pUC"
 },
 {
  "Email": "cpacheco@abpcr.com",
  "Name": "Carlos M Pacheco",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/51QyP5CBR3bdDPFlL4c9"
 },
 {
  "Email": "Vit.Vatanayothin@bakermckenzie.com",
  "Name": "Vit Vatanayothin",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/51SEV8n12OMDhDEqtZ0U"
 },
 {
  "Email": "karatai.dzhangeldiev@gmail.com",
  "Name": "Mr. DZHANGELDIEV Karatai",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_Karatai DZHANGELDIEV_PO.doc",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/529HVDFNxO26xyQYNsSC"
 },
 {
  "Email": "winnierolindrawan@ssek.com",
  "Name": "Mrs Winnie Yamashita Rolindrawan",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_SSEK.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/54EKyz0qHMiTonkJrIlT"
 },
 {
  "Email": "rabbe.sittnikow@hannessnellman.com",
  "Name": "Mr. Rabbe Sittnikow",
  "Document Name": "FINLAND) HANNES SNELLMAN ATTORNEYS) BI 2020 FIN_bi_PPP_survey_en_.doc",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/54O3wloxH0DHpPO3NYky"
 },
 {
  "Email": "acull@jonesday.com",
  "Name": "Alex Cull",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/54bJoM8XjbGcg1GwuV89"
 },
 {
  "Email": "degina@iep.ru",
  "Name": "Irina Dezhina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/54gKAwfNJTCWwdRwfEDW"
 },
 {
  "Email": "enquiries@officemax.co.nz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/557IZfKofZqIHXH7FePJ"
 },
 {
  "Email": "gsibay@mccarthy.ca",
  "Name": "Godyne Sibay",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/55tbgUpl8ovHAFO9FKVS"
 },
 {
  "Email": "george.borovas@shearman.com",
  "Name": "George Borovas",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/56Kuq5dFCJU6sHwsSMsc"
 },
 {
  "Email": "epinder@sanigest.com",
  "Name": "Etoile Pinder",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/56m9sWAjuBGeARRGhKaw"
 },
 {
  "Email": "gazmir.vehbi@atrako.gov.al",
  "Name": "Mr Gazmir Vehbi",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_enGazi.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/592o4IR1VuRpicj4pzav"
 },
 {
  "Email": "liliana.andonova@graduateinstitute.ch",
  "Name": "Liliana Andonova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/59SkrAxvR3XlZB0M8RHw"
 },
 {
  "Email": "david.evans@cliffordchance.com",
  "Name": "David Evans",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/59hD1NaHaldFQ9cr8LbR"
 },
 {
  "Email": "vardanyan_so@mostpp.ru",
  "Name": "Suren Vardanyan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5AWPMiCgi4JoNsQ5hFyJ"
 },
 {
  "Email": "ebloom@winston.com",
  "Name": "Eric W. Bloom",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5DYqRDUfvPrduUjqTt5P"
 },
 {
  "Email": "info@indoiranchamber.com",
  "Name": "Syed Afham Raza",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5F7T06YNj8MSGte8XayN"
 },
 {
  "Email": "david.j.harley@au.pwc.com",
  "Name": "David Harley",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5FXjzNzRiYjx3wpeYPsy"
 },
 {
  "Email": "heiko.hoefler@oppenhoff.eu",
  "Name": "Heiko H�fler",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5GeHeg3pY15jFgyorPK5"
 },
 {
  "Email": "mturcotte@stikeman.com",
  "Name": "Maxime Turcotte",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5HzbHFHTfYvyDhknsbmT"
 },
 {
  "Email": "info@care.org",
  "Name": "Chrys S. K. Pul",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5IIpoKDq8XkdQwVctBJ4"
 },
 {
  "Email": "stephen.matthews@bakerbotts.com",
  "Name": "Stephen Matthews",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5J9hAu4abLFozLQhJCRT"
 },
 {
  "Email": "khalid.salman@saudibauer.com",
  "Name": "Khalid Salman",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5JVS4QAqv9qDnftYCGTN"
 },
 {
  "Email": "raivo@lauspartners.ee",
  "Name": "Raivo Laus",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5K20Jsn2a9MFU6GVBXKk"
 },
 {
  "Email": "jzaputovich@grossbrown.com.py",
  "Name": "Mr. Juan Pablo Zaputovich",
  "Document Name": "19.06.27 - Survey - Private Public Partnership - World Bank Group [6].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5K7ZXUj5LEwQPKGQORWI"
 },
 {
  "Email": "andrew.fleming@nortonrosefulbright.com",
  "Name": "Andrew Fleming",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5KvRIytGw7yJO0A0pzi1"
 },
 {
  "Email": "leavailaw@samoa.ws",
  "Name": "Tima Leavai",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5LKcoRhGVS59dWK1lwXV"
 },
 {
  "Email": "vipuno@punopenalaw.com",
  "Name": "Vincent I. Puno",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5MGlYkMLfyHEjKfsVhvv"
 },
 {
  "Email": "chairman@jfcct.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5ND905uWkyvzDnqUa9z8"
 },
 {
  "Email": "libena.tetrevova@upce.cz",
  "Name": "Libena Tetrevova",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5Oriktih8tcIeNrhs55Z"
 },
 {
  "Email": "mailethiopia@deloitte.co.et",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5POBHTtrIgd9JZSjGErv"
 },
 {
  "Email": "omassmann@duanemorris.com",
  "Name": "Dr Oliver Massmann",
  "Document Name": "VIETNAM) DUANE MORRIS) BI 2020 VNM_bi_PPP_survey_en (updated).doc",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5PQRf3hPhh4xamT5h19Z"
 },
 {
  "Email": "estrella.elamparo@divinalaw.com",
  "Name": "Estrella C. Elamparo",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5PyIppMBSEptZQtFFOnk"
 },
 {
  "Email": "andrew.castle@allenovery.com",
  "Name": "Andrew Castle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5QmoKozy6hxyXVvDgD4Q"
 },
 {
  "Email": "airdberlis@airdberlis.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5Rr6n6zuST4PJ5LvlyeY"
 },
 {
  "Email": "deanlaw@cc.ac.mw",
  "Name": "N. Kanyongolo",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5SK85hIhi0YeNlpEJOz4"
 },
 {
  "Email": "dnk@mukumbyamusoke.com",
  "Name": "Ms Diana Ninsiima Kibuuka",
  "Document Name": "BI 2020 UGA_bi_PPP_survey_en_Diana Ninsiima Kibuuka_ Mukumbya Musoke Advocates.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5TqO2Zw5Lpfl4hzyxZ9v"
 },
 {
  "Email": "jgreen@milbank.com",
  "Name": "Jonathan Green",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5Tuet5t3D0UNBBVREdID"
 },
 {
  "Email": "andrey.mironov@cmslegal.com",
  "Name": "Mr. Andrey Mironov",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_concession_survey_en_CMS.docx",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5TxCuwKOzeNMoZpC5EAv"
 },
 {
  "Email": "KGeyi@idbz.co.zw",
  "Name": "Kenneth Geyi l",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en IDBZ.doc.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5U8XjHb1T7LuqsMw7Jnz"
 },
 {
  "Email": "office@ync.co.id",
  "Name": "Mrs. Ana Sofa Yuking",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_YNC Law.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5UAjtgvndue3hWVMdqev"
 },
 {
  "Email": "rahim.shimarov@dentons.com",
  "Name": "Rahim Shimarov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5UJRDKvZq2IWjslkRgbv"
 },
 {
  "Email": "sonoda@berettagodoy.com",
  "Name": "Mr. Juan Sonoda",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en (1) (003) (FG).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5UOPFIIUWzn9Gs91atxP"
 },
 {
  "Email": "iprd@ecsu.edu.et",
  "Name": "Gebre Tibetu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5VKOynXD4ZSGIDve32ry"
 },
 {
  "Email": "jonasbratt@eversheds-sutherland.se",
  "Name": "Mr Jonas Bratt",
  "Document Name": "SWEDEN) EVERSHEDS) WorldBankSurvey PPP - FINAL v.3.docx",
  "Country": "SWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5VbvN5noBKwoLnrB6qNL"
 },
 {
  "Email": "josef.severa@cz.ey.com",
  "Name": "Josef Severa",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5VpWD8Q7fVe7FdCwI7F1"
 },
 {
  "Email": "Law.School@upng.ac.pg",
  "Name": "Sam Kaipu",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5XRteoBHyHG7H3TTIu0l"
 },
 {
  "Email": "marit.konks@elering.ee",
  "Name": "Marit Saaretalu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5XyTQg1ZMf6PsJVjUEJP"
 },
 {
  "Email": "ben.koenigsberg@nortonrosefulbright.com",
  "Name": "Benjamin Koenigsberg",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5Y7mParFBEOFo8IWIsuy"
 },
 {
  "Email": "dronn@orrick.com",
  "Name": "David Ronn",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5YIpev88iL2iEas4XSSH"
 },
 {
  "Email": "info@abogadoscostarica.com",
  "Name": "Alvaro Moya Ramirez",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5bFl1xigeQSxtYWpfvcQ"
 },
 {
  "Email": "taniguchi@j.u-tokyo.ac.jp",
  "Name": "Masaki Taniguchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5c6Dd0cFEwCcyrv7VG69"
 },
 {
  "Email": "offices@airutlaw.com",
  "Name": "Charles Airut",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5d6gAqYVgIlbgk6LN8OD"
 },
 {
  "Email": "a.tamimi@tamimi.com",
  "Name": "Abdullah Al Tamimi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5dAlv7PxOakJUP0swQlo"
 },
 {
  "Email": "alena.rosakova@ujv.cz",
  "Name": "Alena Ros�kov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5e4ZFKYFtphngFCZbLUo"
 },
 {
  "Email": "cstp@ns.kgtu.runnet.ru",
  "Name": "??????? ???????? ?????",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5eFTl9fEcOcz3CwlGVbi"
 },
 {
  "Email": "alar.urm@lextal.ee",
  "Name": "Alar Urm",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5eu1WQz9Svs05ykzGWkx"
 },
 {
  "Email": "aleksi@lauspartners.ee",
  "Name": "Aleksi Araj�rvi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5fFo98REe9uqTKhGLS43"
 },
 {
  "Email": "stephen.ashworth@dentons.com",
  "Name": "Stephen Ashworth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5fshKXdQFK9TcygN62Zo"
 },
 {
  "Email": "giles.ashman@ashurst.com",
  "Name": "Giles Ashman",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5gFp8nR5uGGWVbsrNHFh"
 },
 {
  "Email": "C.Bovis@hull.ac.uk",
  "Name": "Christopher Bovis",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5gmWqQhHlVLOExRc1CPa"
 },
 {
  "Email": "john.inglis@shearman.com",
  "Name": "John Inglis",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5guWi6iesPDl1xoSk3lC"
 },
 {
  "Email": "jmaciel@afd.gov.py",
  "Name": "Mr Jos� Maciel",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en AFD JM.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5gvHqFWUlKVe23GQ1blK"
 },
 {
  "Email": "irena.vintergregoric@iop.hr",
  "Name": "Irena Vintergregoric",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5j40nHn5XDNKjZhdMtWj"
 },
 {
  "Email": "pedro@bndes.gov.br",
  "Name": "Pedro Ivo Peixoto",
  "Document Name": "Survey - Concession - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5jV2CrhTfhJcr6yKeaCe"
 },
 {
  "Email": "pmf@bdplaw.com",
  "Name": "Patricia Trish Fehr",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5jiSncu8jNwyJ3nbytOy"
 },
 {
  "Email": "apottas@deloitte.co.za",
  "Name": "Andre Pottas",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5kEtEGu34xQGmEdTZnbU"
 },
 {
  "Email": "rpaton1@kpmg.com",
  "Name": "Richard Paton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5kviUJDmf1fK1jxpG9Cc"
 },
 {
  "Email": "debi.hobson@calchamber.com",
  "Name": "Allan Zaremberg",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5mFqUkub4c1j8kIoGPL7"
 },
 {
  "Email": "udbud@sbf.dk",
  "Name": "Mikkel Taanum",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5mJyVW2I2oKQJVURswVZ"
 },
 {
  "Email": "predragm@hbkcontracting.com",
  "Name": "Predrag Mokric",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5mrkL9W8h5NuUgcaNkCY"
 },
 {
  "Email": "joseph.kim@hoganlovells.com",
  "Name": "Joseph Kim",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5mwYvivWyTBQA3GziXJL"
 },
 {
  "Email": "saenquiries@frost.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5nII5gJUuaX9MsVxQo7i"
 },
 {
  "Email": "leo.donnelly@chenpalmer.com",
  "Name": "Leo Donnelly",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5nTSgigegI6zmDBufKfu"
 },
 {
  "Email": "lawyers@penkov-markov.eu",
  "Name": "",
  "Document Name": "BI-2020-BGR_bi_PPP_survey_en_maria Pashalieva.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5oNJoFS4kixk3OpCGA1f"
 },
 {
  "Email": "jmendoza@iqsh.com.mx",
  "Name": "Jesus Mendoza Henriquez",
  "Document Name": "MEXICO) IBANEZ) World Bank BI 2020 MEX_bi_PPP_survey_en.docx A REV.docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5p2UdcH6dwVlTkVI3Qow"
 },
 {
  "Email": "ykifle@ethioconference.com",
  "Name": "Yohannes Kifle Daddi",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5pDLHbXrg0cti4d2S9QA"
 },
 {
  "Email": "info@tpsftz.org",
  "Name": "Angelina Ngalula",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5pKb2Hy87clJxfctY0Eo"
 },
 {
  "Email": "cordalis@greenfort.de",
  "Name": "Anh-Duc Cordalis",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5pi6vrOlCF9THDlil2CV"
 },
 {
  "Email": "rebecca.field@corrs.com.au",
  "Name": "Rebecca Field",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5q3smVUIsWpSBy5DfvJk"
 },
 {
  "Email": "jonathana@ebnlaw.co.il",
  "Name": "Jonathan Achiron",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5qbS4k0maURrUQLwq1QF"
 },
 {
  "Email": "mpdarden@gibsondunn.com",
  "Name": "Michael P. Darden",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5rSLoEVGrQrTSkATaOsf"
 },
 {
  "Email": "rachel.devine@minterellison.co.nz",
  "Name": "Rachel Devine",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5sRfT4HQDHQKvH92LKk8"
 },
 {
  "Email": "Dvortsov.AV@gazprom-neft.ru",
  "Name": "Alexey Vladimirovich Dvortsov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5t0DehlNjM6Sipuy99BM"
 },
 {
  "Email": "al-office@kpmg.com",
  "Name": "Mrs. Arjola Goxhaj",
  "Document Name": "BI 2020 ALB_bi_PPP_survey-Gergana Mantarkova.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5tVE9X2qtGf0k4BsLhOQ"
 },
 {
  "Email": "thelexmater@gmail.com",
  "Name": "Jaezi Orleans-Lindsay",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5uzWkj7Oqw0skPCM3BUP"
 },
 {
  "Email": "mwenda@anchicon.co.zm",
  "Name": "Mwenda Silumesii",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5v4itVBDXyNqg8zLmi2I"
 },
 {
  "Email": "matthew.grant@bakermckenzie.com",
  "Name": "Matthew Grant",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5vI7pcfPBgUjdFy0HAGc"
 },
 {
  "Email": "tadlaw@ethionet.et",
  "Name": "Dilnesahu Tadesse",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5vm4zBIZHqbdJUSNJftQ"
 },
 {
  "Email": "vaughan.mills@corrs.com.au�",
  "Name": "Vaughan Mills",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5vx1883s2776sztIR37L"
 },
 {
  "Email": "achintha.hewanayake@dfcc.lk",
  "Name": "Achintha Hewanayake",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5wKTTTGLCjGlqxQEuwPn"
 },
 {
  "Email": "aris.gulapa@gulapalaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5wNrkSoCvDBB2Y4faKgr"
 },
 {
  "Email": "sam@ksausalegal.com",
  "Name": "Samuel Eversman",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5wOwkuYrEiQPkX4JRTKw"
 },
 {
  "Email": "damian.joy@pi.bilfinger.ca",
  "Name": "Damian Joy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5wPaIMSd9at3KOuoZvpd"
 },
 {
  "Email": "jomachado@deloitte.co.mz",
  "Name": "Jo�o Machado",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5x9cclHwokfXxk5kQkqb"
 },
 {
  "Email": "cao_fuguo@aliyun.com",
  "Name": "title Cao Funguo",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en_CAO Fuguo.docx",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5xe8c7pbwsyKq30ONwnP"
 },
 {
  "Email": "jrsarmiento@punolaw.com",
  "Name": "Julito R. Sarmiento",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5xePtuxTi6pvzHZRDjSR"
 },
 {
  "Email": "klopatkina@morganlewis.com",
  "Name": "Kseniya Lopatkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5xpMvXQmuLA7muEXR5PW"
 },
 {
  "Email": "slent@akingump.com",
  "Name": "Susan Lent",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5y8aidVoja8NzVEbzvk2"
 },
 {
  "Email": "diana.radu@bpv-grigorescu.com",
  "Name": "Mrs. Diana Radu",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5ypQo5tUAqz1gsGqWt52"
 },
 {
  "Email": "anna.snejkova@dentons.com",
  "Name": "Ms. Anna Snejkova",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Dentons_Counsel.DOCX",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5z5QXVSgjnURMTWXnUaW"
 },
 {
  "Email": "info@alnogaithan.com",
  "Name": "Bander Alnogaithan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/5zVElyrJWRQRpHrHRmQG"
 },
 {
  "Email": "VDeRose@blg.com",
  "Name": "Vincent Derose",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/60GhU6Z1bUcDaUb0zQOK"
 },
 {
  "Email": "snadri@auaf.edu.af",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/60KFbQ4GEMXEfdKCjy7a"
 },
 {
  "Email": "yoditg@ethiopianlaw.com",
  "Name": "Mrs. Yodit Gurji Argaw",
  "Document Name": "ETHIOPIA) ETHIOPIANLAW) BI 2020 ETH_bi_PPP_survey_en.doc",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/60d4maMsWTjiU97flaD3"
 },
 {
  "Email": "chidi_izuwah@yahoo.co.uk",
  "Name": "title Chidi Izuwah",
  "Document Name": "NIGERIA) ICRC) WORLD BANK TPI QUESTIONNIAIRES.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/60yOq9kbYGQTP96OY0yE"
 },
 {
  "Email": "ushijima@blakemore.gr.jp",
  "Name": "Shoji Ushijima",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/61Y7MurTgj0hpm8lsiwn"
 },
 {
  "Email": "ABOLDT@ARNECKESIBETH.COM",
  "Name": "Antje Boldt",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/61iPIV3MgeRszUmahjVj"
 },
 {
  "Email": "denis.kachkin@kachkin.ru",
  "Name": "Denise Kachkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/62dZUveqFXyoGeZkBG52"
 },
 {
  "Email": "john.mccay@minterellison.co.nz",
  "Name": "John Mccay",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/62oCTxdfi2F8oQ6TCRxK"
 },
 {
  "Email": "miguel.riano@hsf.com",
  "Name": "Mr. MIguel Ria�o",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en july 2019.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/63fl138fmkVXLgRguwPd"
 },
 {
  "Email": "info@constructoraherrera.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/63pcrU8CBK21fpUqzbgI"
 },
 {
  "Email": "isap2011@simul.co.jp",
  "Name": "Xianbin Yao",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/63scg78LJG4R4QbutBXd"
 },
 {
  "Email": "kkonstantinov@chadbourne.com",
  "Name": "Konstantin Konstantinov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/63x37unsJy3PfcHOXitG"
 },
 {
  "Email": "vsevolod.volkov@everlegal.ua",
  "Name": "Mr Vsevolod Volkov",
  "Document Name": "VV_2020 UKR_bi_TPI_survey_en_Everlegal.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/65htCrrKeQ5jZq0Rdccx"
 },
 {
  "Email": "que.vu@rajahtannlct.com",
  "Name": "Ms Vu Thi Que",
  "Document Name": "VIETNAM) RTLCT) BI 2020 VNM_bi_PPP_survey_en.doc",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/65ovf9clY73yiCbMv9Pv"
 },
 {
  "Email": "savalos@grossbrown.com.py",
  "Name": "Mrs. Sol Avalos",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (GB 13.9.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/66BLv82GkGtLI4KkQYcZ"
 },
 {
  "Email": "Botswana@stefstocks.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/67It0bsUS6xO9jpwdIdz"
 },
 {
  "Email": "service@primeattorneysgh.com",
  "Name": "Maame Tutua Dadson",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/67kFtikhF0ACNIUbgxfQ"
 },
 {
  "Email": "gaukhar.abdigaliyeva@linkagemind.com",
  "Name": "Gaukhar Abdigaliyeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/68xTjLO4qCuY7bsMRDSh"
 },
 {
  "Email": "info@simad.edu.so",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/69DoojUQDO992cXFIfKo"
 },
 {
  "Email": "pkambewa@yahoo.com.au",
  "Name": "Patrick Kambewa",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/69XOqs97KRxNfuP9OFGu"
 },
 {
  "Email": "murga@servicios-legales.com�",
  "Name": "Maria De Los Angeles Barillas",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/69q8P9V5H9SPyQtTuuie"
 },
 {
  "Email": "cheah_li_fook@cp2m.gov.sg",
  "Name": "Li Fook Chean",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/69vnfTptpyEEkWw6TkiB"
 },
 {
  "Email": "abhaya.agarwal@in.ey.com",
  "Name": "Mr Abhaya Krishna Agarwal",
  "Document Name": "BI 2020 IND_bi_PPP_survey_en Abhaya Agarwal.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6AFSEN2vEAV1EUNb1ghH"
 },
 {
  "Email": "dlastman@goodmans.ca",
  "Name": "Dale Lastman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6BwoKvY1CHFCleqH7T5Q"
 },
 {
  "Email": "mari.foster@davispolk.com",
  "Name": "Mari Foster",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6CHGdHBXyOWxAuAWvtJb"
 },
 {
  "Email": "giovanni.ragnoni@dlapiper.com",
  "Name": "Giovanni Ragnoni",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6CXziAXrkvbubvAadnWa"
 },
 {
  "Email": "acarosemena@central-law.com",
  "Name": "ms Ana Cristina Arosemena",
  "Document Name": "BI 2020 PAN_bi_PPP_survey_en.docx",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6D6qptCBoui4SdGaf0qE"
 },
 {
  "Email": "SSvetankov@kpmg.ru",
  "Name": "?---? ?????? ?????????",
  "Document Name": "RUSSIA) KPMG) BI 2020 RUS_bi_concession_survey_ru.docx",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6DsMOUb32HcoVuaT6oKX"
 },
 {
  "Email": "reshedseid@yahoo.com",
  "Name": "Reshed Seid",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6E4moCeAqxZu069NsZJU"
 },
 {
  "Email": "jedge@ngamuru.com",
  "Name": "John Edge",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6E5pgI27dgQLMLqDnmrY"
 },
 {
  "Email": "tsungiriraim@gmail.com",
  "Name": "Mrs Tsungirirai Maune",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_Tsungirirrai Marufu-Maune (law firm).doc",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6E6Iil7wnwXfNYXdSWxW"
 },
 {
  "Email": "adriana.gaspar@nndkp.ro",
  "Name": "Ms. Adriana Gaspar",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Nestor.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6EMqJ0wgHVarGb0h3RnP"
 },
 {
  "Email": "ymoncho@botsnet.bw",
  "Name": "Moncho Yul Shara Malebogo",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6ETr4sIW4YuuU14grhT0"
 },
 {
  "Email": "megan.richards@minterellison.co.nz",
  "Name": "Megan Richards",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6El33rptARyzYbNd7vFZ"
 },
 {
  "Email": "inquiries@motleylegal.com",
  "Name": "Kimberley Cy Motley",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6FKpZ86X8ZxNinwsV6N7"
 },
 {
  "Email": "iva.vranova@spa5.cz",
  "Name": "Iva Vr�nov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6FMBiljOBAgyCVWMjEYG"
 },
 {
  "Email": "paul.buetow@kensingtonswan.com",
  "Name": "Paul Buetow",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6GGCmc4CRih7XYY18uIW"
 },
 {
  "Email": "nyeinkyaw@rajahtann.com",
  "Name": "title Nyein Kyaw",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en-1-Nyein Kyaw.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6HKp7gy9S3xREe06y9v2"
 },
 {
  "Email": "monica.alvarado@carrillolaw.com",
  "Name": "Monica Alvarado",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6HwggNTwFtHYcCpNEUdy"
 },
 {
  "Email": "info@zhaktoo.on.kg�",
  "Name": "Nuru Khankeldieva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6IWJqp6frLrUwE5zoWuE"
 },
 {
  "Email": "leticia@queirozmaluf.com.br?????",
  "Name": "Leticia Queiroz",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6IwOhM7ORfwEvgqt3nVb"
 },
 {
  "Email": "rena.katsuyama@shearman.com",
  "Name": "Rena Kastuyama",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6KER5e7ViSWuqOTMvnrr"
 },
 {
  "Email": "nf17@soas.ac.uk",
  "Name": "Norman Flynn",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6LMhYeOw6X771hXEzNlg"
 },
 {
  "Email": "bashar.g@hammourilaw.com",
  "Name": "Mr Bashar Gammaz",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Hammouri.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6LbezWSeZUks08xdDQDk"
 },
 {
  "Email": "counsel@cltpsj.com.ph�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6LbfwFlGPtQia50DpCkv"
 },
 {
  "Email": "sstarace@delfinowillkie.com",
  "Name": "Mr. Sergio Starace",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_713646v1_Delfino e Associati Willkie Farr & Gallagher LLP.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6LgjJxsIR8a6m3YOl5xb"
 },
 {
  "Email": "cumana@bu.com.co",
  "Name": "Mr Carlos Uma�a",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en FINAL BU.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6M7SRqf2hbZ45xiMUhPt"
 },
 {
  "Email": "wmakhuyana@idbz.co.zw",
  "Name": "Walter Makhuyana",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en.doc-Ronald Mutasa (Zimbabwe) Responses-20-07-19-FINAL.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6MRUKqt8ZwGiShXLSI1O"
 },
 {
  "Email": "chris@malcolmgordonlaw.com",
  "Name": "Dr Christopher Malcolm",
  "Document Name": "BI 2020 JAM_bi_PPP_survey_en_Christopher Malcolm.docx",
  "Country": "JAM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6NaNPDjqTnmMmqqSaKqA"
 },
 {
  "Email": "david.slade@allenovery.com",
  "Name": "David Slade",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6P66MTAXBPC3rNS5BaMJ"
 },
 {
  "Email": "c.pesha@crbafricalegal.com",
  "Name": "Rugambwa Cyril John Pesha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6PcYFyPypVn7mbQHP1SU"
 },
 {
  "Email": "nick.crang@duncancotterill.com",
  "Name": "Nick Crang",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6PeC6OcrB5ox7AR97Qoe"
 },
 {
  "Email": "tien.pham@indochinecounsel.com",
  "Name": "Mr. Minh Tien Pham",
  "Document Name": "VIETNAM) INDOCHINE COUSEL) BI 2020 VNM_bi_TPI_survey_EN-20190806.doc",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6Q7tmS8qfUz7ACd7Rclq"
 },
 {
  "Email": "Mark.Tibberts@bakermckenzie.com",
  "Name": "Mark Tibberts",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6QtSbaNAhVzguBNHpeN8"
 },
 {
  "Email": "eva.reudelhuber@gleisslutz.com",
  "Name": "Eva Reudelhuber",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6R81XxmGSpHHwfhZGZ7n"
 },
 {
  "Email": "ntlanganiso.fesi@akinc.co.za",
  "Name": "Ntlanganiso Fesi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6RamT7kDuLUJorDsExtQ"
 },
 {
  "Email": "dublin@arthurcox.com",
  "Name": "Aaron Boyle",
  "Document Name": "WBG - Benchmarking Infrastructure 2020 - Ireland PPP Survey (Arthur Cox 2019).DOCX",
  "Country": "IRL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6SX8xSpEAEJGnmb9Gyx5"
 },
 {
  "Email": "miftahulkhairi@ssek.com",
  "Name": "Mr. Miftahul Khairi",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_SSEK.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6VJKQss2pu0yFNP2m9rj"
 },
 {
  "Email": "phannan@bbcgrp.com",
  "Name": "Paul Hannan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6VRXtJYhlK6CT0clBiyh"
 },
 {
  "Email": "ian.bendell@dlapiper.com",
  "Name": "Ian Bendell",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6W9Se3xAOtF0m1O3yGin"
 },
 {
  "Email": "ahusein@kpmg.com",
  "Name": "Amin Husein",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6XEZLjTc0X9M97LX5BxK"
 },
 {
  "Email": "spbcci@spbcci.ru",
  "Name": "Vladimir Katenev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6XaDJoyUt66IWEgJ1lmB"
 },
 {
  "Email": "info@vme.com.pa",
  "Name": "Miguel E. Mihalitsianos",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6Xq7GpH6Bsc7jw1XcyDh"
 },
 {
  "Email": "lars.sondergaard@dk.ey.com",
  "Name": "Lars Rhod S�ndergaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6Y3dEk6A0BuhKwGIYLPY"
 },
 {
  "Email": "ferguson@weirfoulds.com",
  "Name": "Daniel .P Ferguson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6YAZM9bWqDrpGsMVQax8"
 },
 {
  "Email": "fikadu@ethiopianlaw.com",
  "Name": "Mr. Fikadu Asfaw Demissie",
  "Document Name": "ETHIOPIA) ETHIOPIANLAW) BI 2020 ETH_bi_PPP_survey_en.doc",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6YBtFciMYzE1srAiEF5Q"
 },
 {
  "Email": "gcowpersmith@goodsman.ca",
  "Name": "Geoff Cowper Smith",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6YV4VOCOvjXgFKJl7f5g"
 },
 {
  "Email": "mali@ardeanattorneys.co.tz",
  "Name": "Gratian Mali",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6YhtaluQDTxL87ITCYmM"
 },
 {
  "Email": "tbarlow@fasken.com",
  "Name": "W. Thomas Barlow",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6ZMjdwbaiiFrNORCNGwB"
 },
 {
  "Email": "aqazizada@shajjanlaw.com",
  "Name": "Abdul Razaq Qazizada",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6ZjbDuatNFAgEUQbC489"
 },
 {
  "Email": "francisco.rucavado@pragma.legal",
  "Name": "Francisco J. Rucavado-Luque",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6ahukeXIPOpXJdZWP8Eb"
 },
 {
  "Email": "gkhurodze@deloitte.ge",
  "Name": "Giorgi Khurodze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6cqj1bryL2sIVfnD12E3"
 },
 {
  "Email": "edward.balaba@ug.ey.com",
  "Name": "Edward Balaba",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6cv5J05nQqLm9qBuxhl5"
 },
 {
  "Email": "djlowdon@perlaw.ca",
  "Name": "David Lowdon",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6diRB5PByYR6TmNNhjB6"
 },
 {
  "Email": "bhakta@kangacompany.com",
  "Name": "Mr. M.L. Bhakta",
  "Document Name": "BI 2020 IND_bi_PPP_survey_en-_09 08 2019 (002)_Sirisha Sampat.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6eDS5EfR7bUmniN2ilRG"
 },
 {
  "Email": "consultants@beacontechs.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6g79jwGPQy3yfM5chL7M"
 },
 {
  "Email": "saudi-bauer@saudibauer.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6gRkxkyu1anYc3rqiUul"
 },
 {
  "Email": "andradi@sjmsassociates.com",
  "Name": "Dulsiri Andradi",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6iXSv5wtJAFELYpDJ7O7"
 },
 {
  "Email": "sgoicoechea@deloitte.co.mz",
  "Name": "Santiago Goicoechea",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6j0j9vF2Vntj8AXMPMHf"
 },
 {
  "Email": "bars@gornitzky.com",
  "Name": "Bar Sarafian",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6j9WZlhIm4fI2P6udkK2"
 },
 {
  "Email": "info@bmbureau.com",
  "Name": "Levan Kistauri",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6jAUni9R07ENtzhLAPxw"
 },
 {
  "Email": "salman.al-sudairi@lw.com",
  "Name": "Salman Al-Sudairi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6jHky9FIGRLuZKTC0gWX"
 },
 {
  "Email": "jane.eespold@sorainen.com",
  "Name": "Jane Eespold",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6jnbIry9d6tBXI7ejUah"
 },
 {
  "Email": "info@sunshineinvestmentgroup.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6jxmXcECLEc24HVwije4"
 },
 {
  "Email": "info@ppp.gov.ph",
  "Name": "",
  "Document Name": "BI 2020 PHL_bi_PPP_survey_en_v2_RO_PPP_Center.docx",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6kiZzagYTpEyzoTNZExH"
 },
 {
  "Email": "avril.cole@gowlings.com",
  "Name": "Avril Cole",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6krLevO3SeisveZ2rzmW"
 },
 {
  "Email": "temakpor@osler.com",
  "Name": "Tobor Emakpor",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6l4xTxOSqYxfjuwsPShR"
 },
 {
  "Email": "vanuatu@smec.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6mejoFFbAdJT8c7CKLDF"
 },
 {
  "Email": "julia.czarniak@skadden.com",
  "Name": "Julia Czarniak",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6ncHXY8ngAn1BQiEOMkw"
 },
 {
  "Email": "assaf@tadmor-levy.com",
  "Name": "Assaf Priel",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6pOLZQn7c9TQzbW6dzEF"
 },
 {
  "Email": "adam.stapledon@allenovery.com",
  "Name": "Mr Adam Stapledon",
  "Document Name": "AU TPI Survey_Allen and Overy.doc",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6qEr1CYpWAqRLzaFRR8s"
 },
 {
  "Email": "sales@toyotatz.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6qFBm8C8Lm3dqMxzOXsA"
 },
 {
  "Email": "kattorneys@africa-online.net",
  "Name": "Gautoni Kainja",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6rCcBT6vI2AGxnLGfsEa"
 },
 {
  "Email": "margo.lemetti@derling.ee",
  "Name": "Margo Lemeti",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6rKchgHwKlWcEb2BBrKw"
 },
 {
  "Email": "info@newtonlawllp.com",
  "Name": "Wissam Tamimi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6rf51CG69PGvmzLJCAPf"
 },
 {
  "Email": "mikhail.marinin@integrites.com",
  "Name": "Mikhail Marinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6st9c7bAcpBDeRSjQXQR"
 },
 {
  "Email": "ian.devaz@wongpartnership.com",
  "Name": "Ian De Vaz",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6tGEYdwqV8QLuFhZa5TD"
 },
 {
  "Email": "gmendoza@s-s.mx",
  "Name": "Mr. Gustavo Mendoza",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en 230719.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6tovWuv0MVg6kkqLpu4z"
 },
 {
  "Email": "nmkumbukwa@nexlawadvocates.com",
  "Name": "Nuhu S. Mkumbukwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6tpOMcpRKlAafNPrghhz"
 },
 {
  "Email": "Marin.Vukovic@dtb.hr",
  "Name": "Marin Vukovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6uCZujeLeuFBs8CSrmzA"
 },
 {
  "Email": "tim.sunar@blakes.com",
  "Name": "Tim Sunar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6uDRSYWjMqxsu9SFmt8O"
 },
 {
  "Email": "yuri.moreno@ariaslaw.com",
  "Name": "Yuri Moreno",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6uZeNGlEpca7LD82kUEM"
 },
 {
  "Email": "wilbert.kapinga@mkono.com",
  "Name": "Wilbert Kapinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6uZhlWKM26Gq2Eib9xYo"
 },
 {
  "Email": "S.FEKEDE@AFDB.ORG",
  "Name": "title Sahele Tamiru Fekede",
  "Document Name": "ETHIOPIA) AfDB) BI 2020 ETH_bi_TPI_survey_en.docx",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6vQZKNOiKzhC3UORkgjJ"
 },
 {
  "Email": "info-ksa@houraniassociates.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6vb8hHynNuXMeE0eUp7F"
 },
 {
  "Email": "sergei.ostrovsky@ashurst.com",
  "Name": "Sergei Ostrovsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6wbPwO9GGj0qrJ2tuWo0"
 },
 {
  "Email": "dmitry.kovalev@ru.pwc.com",
  "Name": "Dmitry Kovalev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6wcZKpbDu92YbgV1u8Mv"
 },
 {
  "Email": "jucros@gomezpinzon.com",
  "Name": "Mr. Juan-Antonio Ucros",
  "Document Name": "G.P. Infraestructura- Benchmarking infrastructure 2020 PPP.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6wdRhCdxg2SrriPiYzcA"
 },
 {
  "Email": "anthonybrewah2008@yahoo.com",
  "Name": "Anthony Y. Brewah",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6wpJna2VgWbHAs78EiQm"
 },
 {
  "Email": "hrojas@claro.cl",
  "Name": "Mr. Herman Rojas",
  "Document Name": "CHILE) CLARO N CIA) BI 2020 CHL_bi_TPI_survey_en (Autoguardado).docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6xH5KrdJaUKRiUQNZLIX"
 },
 {
  "Email": "tmaphane@sadc-dfrc.org",
  "Name": "Tsholofelo Maphane",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6xVc0jp0TgjOkCIGDV7f"
 },
 {
  "Email": "rajaram@straitslaw.com.sg",
  "Name": "Rajaram Muralli",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6z0B93s9zv3nsUr3sLIY"
 },
 {
  "Email": "esilverman@milbank.com",
  "Name": "Eric Silverman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6zLIofrAjrJRA0UC7bvO"
 },
 {
  "Email": "ivsuazo@bufeterosa.com",
  "Name": "Irma Violeta Suazo",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/6zuBI3U91SqyLzqflmBy"
 },
 {
  "Email": "komisi@clarkelawyers.net",
  "Name": "Leitaualesa Koria",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/70GBWVchJkGy7WQ1nqn1"
 },
 {
  "Email": "dhackett@atlanticlng.com",
  "Name": "Dawn Hackett",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/70W4D6xtUukQ9tE2N3vf"
 },
 {
  "Email": "Glen.Price@bbklaw.com",
  "Name": "Glen Price",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/70ndRtpfbu5TfGZ6PuYp"
 },
 {
  "Email": "dembanai@mega.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/71KfklCITyxe7IpBoC6D"
 },
 {
  "Email": "Galitd@ysl-law.com",
  "Name": "Galit Deli",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/732KX6g4WHPqSN91NJej"
 },
 {
  "Email": "mchernandez@kpmg.com",
  "Name": "Cynthia Hernandez",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/737R4fUAz8Kda6Z9Uxio"
 },
 {
  "Email": "nitzana@ebnlaw.co.il",
  "Name": "Nitzan Aberbach",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/73qHg39ebRnPds8aQkwJ"
 },
 {
  "Email": "abdulaziz.alabduljabbar@cliffordchance.com",
  "Name": "Abdulaziz Al-Abduljabbar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/74OwBcuxUipWP0lcGD44"
 },
 {
  "Email": "adz@diascarneiro.com.br",
  "Name": "Mr. Arthur Ayres Diniz de Oliveira",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en_DiasCarneiroAdvogados.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/74Y0DWfQXwWU6kBMoSNp"
 },
 {
  "Email": "qureshilawassociates@hotmail.com",
  "Name": "Mr Basharat Ali lMahmood",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_Qureshi.doc",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/76Mzcu7NSVDjyV1i6TtP"
 },
 {
  "Email": "cwohlferd@whitecase.com",
  "Name": "Clark Wohlferd",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/76iKLDblvCgd0mWwxWxx"
 },
 {
  "Email": "mirzoev@nmlaw.tj�",
  "Name": "Firdavs Mirzoev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/76sPyHaOydds4ZYPbQTq"
 },
 {
  "Email": "khaled.aljazwi@eldib.com",
  "Name": "Khaled Aljazwi",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/78gdxvXlpdzkRAbOHend"
 },
 {
  "Email": "elena_gavrilina@epam.ru",
  "Name": "Elena Gavrilina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/78hskVWQalG4tXeGoDZ6"
 },
 {
  "Email": "c.rwechungura@crbafricalegal.com",
  "Name": "Charles R. B. Rwechungura",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7AIm7r8ulqszWGmdbWux"
 },
 {
  "Email": "ssamadbegishvili@mkd.ge",
  "Name": "Mr. Sandro Samadbegishvili",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_MKD.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7BPCzrM1pT3h64VxGCGA"
 },
 {
  "Email": "mshibata@sidley.com",
  "Name": "Minako Shibata",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7BmeWKH5b7OHPL0B0dYA"
 },
 {
  "Email": "maria.jotautas@eversheds.ee",
  "Name": "Maria Jotautas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7Bt0AMMF7VKC1NuxrTBN"
 },
 {
  "Email": "Joseph.Byrne@bbklaw.com",
  "Name": "Joseph Byrne",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7CdwDLCrE5UeSmzvNOue"
 },
 {
  "Email": "caroline.nongwa@mw.ey.com",
  "Name": "Miss Caroline Nongwa",
  "Document Name": "MALAWI) ENY) BI 2020 MWI_bi_PPP_survey_en_ey.docx",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7CgiSWov0V3rTvns9bX7"
 },
 {
  "Email": "jferraz@ENSafrica.com�",
  "Name": "John Ferraz",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7DD6upeAdGfJYw8MTIZK"
 },
 {
  "Email": "aoj@prcp.com.pe",
  "Name": "Ms. Adriana lOspina-Jimenez",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_Payet - 4837-1645-6348 v. 3.doc",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7DQyyT0Re2cmVvDrRE7M"
 },
 {
  "Email": "dperera@kpmg.com",
  "Name": "Dulitha Perera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7DeHxcyF5AO2CnOO0v9x"
 },
 {
  "Email": "bwilson@zamtel.zm",
  "Name": "Kasongo Kamfwa",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7DqQmC3gcschrxXNeiks"
 },
 {
  "Email": "james.abbott@allenovery.com",
  "Name": "Mr James Abbott",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Allen & Overy.doc",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7DqxBd59Ff2eoBxbDXQ5"
 },
 {
  "Email": "gtabane@deloitte.co.za",
  "Name": "Gaba Tabane",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7EI7tjBfPTBUwyqhFUjP"
 },
 {
  "Email": "kibuta.ongwamuhana@akolaw.com",
  "Name": "Kibuta Ongwamuhana",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7EmHUAGeOAMSsvrLjTiH"
 },
 {
  "Email": "tsaturyans@bso.am",
  "Name": "Suzanna Tsaturyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7G9SPCC83uHMEaEnIRDB"
 },
 {
  "Email": "tlasuik@jrcc.ca",
  "Name": "Tim Lasuik",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7GBwSWS5b08lNsdQeUKU"
 },
 {
  "Email": "jones@sjp.co.za",
  "Name": "Philip Jones",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7GPzr2RXJ5vo0tYtpSnt"
 },
 {
  "Email": "embassies@taxplannercpa.com",
  "Name": "Kathya Parsons",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7HzUFf9Gt90xsiwsw1yC"
 },
 {
  "Email": "wongkaiyun@chiawongchambers.com",
  "Name": "Kai Yun Wong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7IeOozJCJ0Oa80mfgu6l"
 },
 {
  "Email": "linda.low@wongpartnership.com",
  "Name": "Linda Low",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7JYM0z1jCcTdIhl1jYPu"
 },
 {
  "Email": "konstantin.makarevich@hoganlovells.com",
  "Name": "Konstantin Makarevich",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7JyuaNGaBkNpN2Htmij3"
 },
 {
  "Email": "moon.wei@tpmahk.com",
  "Name": "Ms. Moon Wei",
  "Document Name": "BI 2020CHN_bi_PPP_survey_en 20190720 Moon Wei.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7KD3QRTpC8wee1R0hw8U"
 },
 {
  "Email": "sten.veidebaum@triniti.ee",
  "Name": "Sten Veidebaum",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7KXwewOQpkP9JsNQ6DKi"
 },
 {
  "Email": "mcoiscou@coiscoulaw.com",
  "Name": "Mr. Milvio Coiscou",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en (2).docx MARLEN.docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7KmPLPUIcZHuS411d3eP"
 },
 {
  "Email": "toomas.seppel@hedman.ee",
  "Name": "Toomas Seppel",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7MW4dY1KkYxlMl5gW1TU"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Mikhail Gerchuk",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7NyBiOYcVYS54HiQJPPj"
 },
 {
  "Email": "ymukhitdinov@curtis.com",
  "Name": "Yerzhan Mukhitdinov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7O9ocynDztmFx1NwoK6z"
 },
 {
  "Email": "kratos-2014@inbox.ru",
  "Name": "?????? ????? ?????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7OQHu9x9G3afjTrEBEx9"
 },
 {
  "Email": "carlos.padilla@ppulegal.com",
  "Name": "Mr Carlos Padilla",
  "Document Name": "PPU-_7979994_V_1_Benchmarking Infrastructure PPPs in Colombia 2020 - World Bank Group Survey.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7OQbCB2VVV3uNTxRPhoP"
 },
 {
  "Email": "iimaan@somlegal.so",
  "Name": "Iimaan Mohamed Omar",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7OUtFK02ev0qyZIPP5Fp"
 },
 {
  "Email": "lawyers@ponifasio.com",
  "Name": "Tuala Ponifasio",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7OmADybyLHNKFtbkL1Ey"
 },
 {
  "Email": "anil.khurana@ae.pwc.com",
  "Name": "Anil Khurana",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7P0GzLuqc6rHqJZVSR8o"
 },
 {
  "Email": "karcci@karcci.kz�",
  "Name": "Nesip Seitova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7Pk9DtEjS3V55V32Yw3e"
 },
 {
  "Email": "ketselamulat2005@yahoo.com",
  "Name": "Ketsele Mulat",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7PnJNcsS6BdjISU6E6Vf"
 },
 {
  "Email": "gatzori@cgsh.com",
  "Name": "Mr. Gianluca Atzori",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en (003).docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7RYR37rD80llDVdofQ5A"
 },
 {
  "Email": "jaanus.magi@magnussonlaw.com",
  "Name": "Jaanus Magi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7Rfb6yVUCLNhY0rGAg2v"
 },
 {
  "Email": "hayley.buckley@wynnwilliams.co.nz",
  "Name": "Hayley Buckley",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7TBpmzJqh3yaTwsoPzpJ"
 },
 {
  "Email": "oren@arnon.co.il",
  "Name": "Oren Roth",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7TTGaAdCVN3M0XxdEKw3"
 },
 {
  "Email": "tarik.zaimovic@efsa.unsa.ba",
  "Name": "Tarik Zaimovic",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_PO.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7U51WGM3txFVyXblHsl4"
 },
 {
  "Email": "TrinidadLawyers@gmail.com�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7UZXSGeM7abRRmppcw15"
 },
 {
  "Email": "wkhan@legaloracles.com",
  "Name": "M.Wisal Khan",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7UlqIZmBh8QssktJS9yb"
 },
 {
  "Email": "aleksandar@afsajic.com",
  "Name": "partner Aleksandar lSajic",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_Sajic.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7UpwfIZ8hLIlZX1lGX4r"
 },
 {
  "Email": "info@coverlinkinsurance.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7VBH07qZJuWwb2BDnDc5"
 },
 {
  "Email": "Kunze@bdkd-berlin.de",
  "Name": "Thomas Kunze",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7W6Ajlf5zVbBS9RZyQw5"
 },
 {
  "Email": "am@mercerandcompany.com",
  "Name": "Andrew Mercer",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7WbwON4lVNitHVn4oJJ2"
 },
 {
  "Email": "rrashidov@lex.tj",
  "Name": "Abdulbori Baibabayev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7WpOI8F7qcHpiTWgxMzO"
 },
 {
  "Email": "vcrespo@headrick.com.do",
  "Name": "Ms Vera Lucia Crespo",
  "Document Name": "Survey World Bank - Benchmarking Infrastructure - Final (00780110xA22EA).DOCX",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7WqC8LEtQ6qGX695fkU1"
 },
 {
  "Email": "cpedder@trowers.com",
  "Name": "Christopher Pedder",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7XH2b3vUlPcrLnlsxQQ9"
 },
 {
  "Email": "lma@horten.dk",
  "Name": "Line Markert",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7XYfkVtUJe2th3XI8uMU"
 },
 {
  "Email": "alexander.dolgov@hoganlovells.com",
  "Name": "Alexander Dolgov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7XnZ2ix3Lb8Pv7Q1QpGa"
 },
 {
  "Email": "secretaria.cr@astaldi.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ZE3bGHzDloFidbh87ow"
 },
 {
  "Email": "giemulla@giemulla.com",
  "Name": "Elmar Giemulla",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ZHCPQY4VnUIPv0RoMUe"
 },
 {
  "Email": "cluhanga@mccci.org",
  "Name": "Chimwemwe Luhanga",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ZlzgWrlWm5TQLbmY5ni"
 },
 {
  "Email": "ddiaz@palacioslleras.com",
  "Name": "Ms. Diana Díaz",
  "Document Name": "TPI Survey Colombia - Óscar Gutiérrez V3.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ZvfKxmeew6qSuUuPEhQ"
 },
 {
  "Email": "mkimhi@fbclawyers.com",
  "Name": "Miri Kimhi",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ajmp10vZd3f6siks1Pp"
 },
 {
  "Email": "neo@dm5.co.za",
  "Name": "Neo Moshimane",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7b8XWFavgGdL7gKRUQfu"
 },
 {
  "Email": "naida.custovic@lawoffice-custovic.com",
  "Name": "Naida Custovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7bGwGZJZaIuAn8m6OOn1"
 },
 {
  "Email": "info@steenjensen.com",
  "Name": "Mr. Steen Jensen",
  "Document Name": "DENMARK) STEENJENSEN) BI 2020 DNK_bi_PPP_survey_en.doc",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7bQbLI9ptaqsLgv1z7Cy"
 },
 {
  "Email": "mohamed.bangura@mbclegal.org",
  "Name": "Mohammed Bangura",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7cPkVUvka6guGW7cxOmc"
 },
 {
  "Email": "torihiki-help@ngk.co.jp",
  "Name": "Taku Oshima",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7eUoZGs9SbvHYQqWePp7"
 },
 {
  "Email": "jsc@danskerhverv.dk",
  "Name": "Jakob Scharff",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7efVQlZtZBdag9SZ9dPo"
 },
 {
  "Email": "Bfowler@blg.com",
  "Name": "Bruce E. Fowler",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7er3MYQpnO27mMTgYZTh"
 },
 {
  "Email": "marcus.harling@burges-salmon.com",
  "Name": "Marcus Harling",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7gpQQjGu8k0K61crvt4E"
 },
 {
  "Email": "info@avralaw.gr",
  "Name": "Mr. Athanassios Safaris",
  "Document Name": "GREECE) AVRAMOPOULOS) BI 2020 GRC_bi_PPP_survey_en_GREECE_AVRAMOPOULOS_AND_PARTNERS.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ha6HrnA8EryQBPD68h2"
 },
 {
  "Email": "paulc@ilct.co.th",
  "Name": "Paul . A Connelly",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7hrfyDaGXDZqIPFqshNP"
 },
 {
  "Email": "leng-fong.lai@cliffordchance.com",
  "Name": "Leng-Fong Lai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7iySsmuvUJC5xYDtO5ve"
 },
 {
  "Email": "kevin.ho@braddellbrothers.com",
  "Name": "Kevin Ho",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7jEvk6zWygjquO6M3eSf"
 },
 {
  "Email": "vsanvakil.15@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7jfHTNJHCVEn1YRV1ejY"
 },
 {
  "Email": "danalemou@gmail.com",
  "Name": "Daniel Alemu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7kBQOWzcz5dSazCM3gfr"
 },
 {
  "Email": "yana.koch@gleisslutz.com",
  "Name": "Yana Koch",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7kU8OSZ83Wlh9RDY2Pvf"
 },
 {
  "Email": "henrique.valente@mirandalawfirm.com",
  "Name": "Mr. Henrique Lopes Valente",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en(159971.1)(167135.1).docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7kp7wU6tzBd0dxDJsNxy"
 },
 {
  "Email": "jose_canessa@hacienda.gov.py",
  "Name": "Mr Jos� Canessa",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en_Adilio_Celle_PY_03_10_2019.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7n6f7OtAplELsUrQXrk3"
 },
 {
  "Email": "bbogopa@bomaattorneys.co.bw",
  "Name": "Basimane Bogopa",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7no9dLwA6Hgl20Y2bQzi"
 },
 {
  "Email": "admin@jkca.to",
  "Name": "Jennifer Tupou",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7o40OznCrITxOdxQxmMK"
 },
 {
  "Email": "office@mortimerblakelaw.com",
  "Name": "Pierre Seynaeve",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7qZZ2Z5NmTVHUoIzwXMW"
 },
 {
  "Email": "dhou@pso.gov.sb",
  "Name": "Douglas Hou",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7qtfhElL21CTsp2gg73l"
 },
 {
  "Email": "merle.kelder@glimstedt.ee",
  "Name": "Merle Kelder",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7r4tfu9bwEgWyS5fJTJl"
 },
 {
  "Email": "bizcentre@pomcci.com",
  "Name": "Peter Goodwin",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7r8PDtxP6hReT6OCeFC3"
 },
 {
  "Email": "wahed.fidaali@aon.ca",
  "Name": "Wahed Fidaali",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7rj6cKchYzxgLU5Welix"
 },
 {
  "Email": "lheim@deloitte.com.pg",
  "Name": "Lutz Heim",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7rk8rJ57Bqt50JIFyUQV"
 },
 {
  "Email": "Zhibek.Aidymbekova@nortonrosefulbright.com",
  "Name": "Zhibek Aidymbekova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7sHNTliqXgme2TjEb47Y"
 },
 {
  "Email": "info@ghanachamber.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7sIK6IC77HCPS1h426IX"
 },
 {
  "Email": "Edin.Rizvanovic@unmo.ba",
  "Name": "Edin Rizvanovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7uFiL651JuHYHbxaNbJV"
 },
 {
  "Email": "info@comesaria.org",
  "Name": "Heba Salama",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7uP7gtovzVDSm8oHao5a"
 },
 {
  "Email": "ksutton@transatlanticbusiness.org",
  "Name": "Kara Sutton",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7vKW6Db1yIP3aTXCnqoJ"
 },
 {
  "Email": "bettina.tugendreich@raue.com",
  "Name": "Bettina Tugendreich",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7wgjSQLaKgSxSVlp8HLA"
 },
 {
  "Email": "info@ardeanattorneys.co.tz",
  "Name": "Wambura Mkono",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7xsKh1pFpzPRXDqUn7fu"
 },
 {
  "Email": "info@focus.co.zm",
  "Name": "George Mubipe",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7yOYVJBoHaxQJQ6WGYuP"
 },
 {
  "Email": "rdumas@dumaslex.com",
  "Name": "Rodolfo Dumas Castillo",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7ycVMVgrRAocSQwIWe0O"
 },
 {
  "Email": "matrixlawfirmsrilanka@gmail.com�",
  "Name": "I.W. Gunawardana",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7yxvjENgRM09Fqnf9Q5R"
 },
 {
  "Email": "sherenah@schulich.yorku.ca",
  "Name": "Sherena Hussain",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7zNGDw8L8GWxaAWBGR77"
 },
 {
  "Email": "tyu@paulweiss.com",
  "Name": "Tong Yu",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/7zo7V0MCvZ16BF1nqioi"
 },
 {
  "Email": "graham.mcleod@blakes.com",
  "Name": "Graham Mcleod",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/81VeSV8ELIt14Iq20cPQ"
 },
 {
  "Email": "richard.anicich@sparke.com.au",
  "Name": "Richard Anicich",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/81xGRtH44FB7iVhbitnI"
 },
 {
  "Email": "stephanie.rickard@burges-salmon.com",
  "Name": "Stephanie Rickard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/82dD24MvRpMOAwt16X7S"
 },
 {
  "Email": "michael.harrod@maynewetherell.com",
  "Name": "Michael Harrod",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/82vgsP2ayxysIzuDjPBK"
 },
 {
  "Email": "Heru.Mardijarto@makarim.com",
  "Name": "Mr. Heru Mardijarto",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Makarim_v2.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/838YNcolpJ9tAUxS7qYj"
 },
 {
  "Email": "elmer.muna@derling.ee",
  "Name": "Elmer Muna",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/83sWO7KlX3uR9ySWVwAh"
 },
 {
  "Email": "hilda.kamugisha@pwc.com",
  "Name": "Ms Hilda Kamugisha",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_PPP_survey_en 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/84fbT3PryJ8oxhq0Sd3R"
 },
 {
  "Email": "emma.dempster@cdhlegal.com",
  "Name": "Emma Dempster",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/84nv7iCwTnfmC7a02AXb"
 },
 {
  "Email": "pduffy@stikeman.com",
  "Name": "Patrick G. Duffy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/85idDumw2n33QXaIW90t"
 },
 {
  "Email": "clive.edwards@edwardslaw.to",
  "Name": "William Clive Edwards",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/85wQsjEZ2u8Qg09LiF5C"
 },
 {
  "Email": "mail@dradamiprgroup.com",
  "Name": "Adam Ibrahim",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/865HIxWj5G6WUI75A49K"
 },
 {
  "Email": "giorau@meitar.com",
  "Name": "Giora Ungar",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/869yN5pvvXxPpW3PQeAO"
 },
 {
  "Email": "Isingoma.edgar@kpmg.com",
  "Name": "Edgar Isingoma",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8744uzDuyWWi8ZUGCH6D"
 },
 {
  "Email": "Adriana.Durinakova@mindop.sk",
  "Name": "Adriana Duinakova",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en K7499574.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/87niJ9FAyLjOc7YiDggy"
 },
 {
  "Email": "ti@transparency.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/88H0CYb69JXBr1OCiR9y"
 },
 {
  "Email": "y.llenas@estrellatupete.com",
  "Name": "Mrs. Yamel Llenas",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en.docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/894GPX1LXqhsxW0HLEmt"
 },
 {
  "Email": "gary.reader@kpmg.co.uk",
  "Name": "Gary Reader",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/89NPEptDMs3P2WJfezGb"
 },
 {
  "Email": "Ron_g@firon.co.il",
  "Name": "Ron Genat",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/89RYFu1okU075n1fHMeM"
 },
 {
  "Email": "ac@horten.dk",
  "Name": "Andreas Christensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/89XYfGe9ExI20Dj4wkBN"
 },
 {
  "Email": "michael.kaihatu@dentons.com",
  "Name": "Mr. Michael Kaihatu",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Dentons.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8AkgsvTnst0nYFIUsW6s"
 },
 {
  "Email": "lawyers@emilford.com.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8BVHpCVvqnr3EwNzg59A"
 },
 {
  "Email": "rarancio@grimaldilex.com",
  "Name": "Ms Rosaria Arancio",
  "Document Name": "ITA_bi_PPP_survey_en_Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8C2ZZhGvDgaVIYAiNOOz"
 },
 {
  "Email": "david.root@wits.ac.za",
  "Name": "David Root",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8CHaFRiMufJoq6Ue1FuI"
 },
 {
  "Email": "amarkova@gugushev.com",
  "Name": "Ms Antonia Markova",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_Gugushev&Partners_adjusted..docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8CKoCyTAr2YjHTvPiNEm"
 },
 {
  "Email": "a.karakhanyan@bdoarmenia.am",
  "Name": "Aram Karakhanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8CpJbrYhOXG8pWt6LFEh"
 },
 {
  "Email": "sminick@txbiz.org",
  "Name": "Stephen Minick",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8DiE7iEaA7jPvtHhFHcp"
 },
 {
  "Email": "martina.simunovic@iop.hr",
  "Name": "Martina Simunovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8EJr8pHsSahoHQEJBzTm"
 },
 {
  "Email": "info@sdconstructions.com�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Ec7gnWPCFKsKckaGuYv"
 },
 {
  "Email": "mail@delrosariolaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8FaGiblfa4lSjkTW3DEQ"
 },
 {
  "Email": "margus.arvisto@arvistopartners.ee",
  "Name": "Margus Arvisto",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8FfH75ESWCGWdqyZ23Az"
 },
 {
  "Email": "marsmith@deloitte.kz",
  "Name": "Mark Smith",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Fhz8UGL1cm2FKYQcVeN"
 },
 {
  "Email": "david.salt@clydeco.com",
  "Name": "David Salt",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8FlTQM73X1Iew6c445xA"
 },
 {
  "Email": "law@partner.kg",
  "Name": "Temirbek Kenenbaev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8HERyTwmMlKPzMfRZfiL"
 },
 {
  "Email": "dorothy.livingston@hsf.com",
  "Name": "Dorothy Livingston",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8HFfCEhgk4ZP5pWLy0ii"
 },
 {
  "Email": "villu.otsmann@triniti.ee",
  "Name": "Villu Otsmann",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8HgKAk21IFiT5MmjDbl0"
 },
 {
  "Email": "info@alnogaithan.com",
  "Name": "Bander Alnogaithan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8IguPZEAMSqkc2vNX9Ek"
 },
 {
  "Email": "srodrigue@torys.com",
  "Name": "Sylvie Rodrigue",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8IuIgbCo7Hf9x6nwT5Rt"
 },
 {
  "Email": "DWhelan@blg.com",
  "Name": "David C. Whelan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8JRJHuwBmPv3dVuMrYtD"
 },
 {
  "Email": "chumachenko@vegaslex.ru",
  "Name": "Igor Chumachenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8L5ELHoIBr8FbWWIRg16"
 },
 {
  "Email": "smj@pp-as.dk",
  "Name": "S�ren M�lgaard Juul",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Ln7r5Lh3uhbGxA8iYmD"
 },
 {
  "Email": "vahur.kivistik@hansalaw.ee",
  "Name": "Vahur Kivistik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8M0HKuyeynpNerHRjs2D"
 },
 {
  "Email": "Basira.zurmati@ada.org.af",
  "Name": "Basira Zurmati",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8MDUbZ9Vu18DJgeAm6Io"
 },
 {
  "Email": "ana.romer@carrillolaw.com",
  "Name": "Ana Luisa Romer",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8MeBg1Dq32Yog9RJNwMC"
 },
 {
  "Email": "kamanga.kapinga@mkono.com",
  "Name": "Kamanga Kapinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8MjshU9mVFRI4xDqK79R"
 },
 {
  "Email": "phaase@novales.com.gt",
  "Name": "Paola Haase",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8MoDFcdl6XzqFyEyxXg9"
 },
 {
  "Email": "scott.tindall@hoganlovells.com",
  "Name": "Scott Tindall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8OS541XYkM80LOfxMkVw"
 },
 {
  "Email": "jwebber@whitecase.com",
  "Name": "Jason Webber",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8OVZe0Lp6HirT8A6NuEi"
 },
 {
  "Email": "Jaanus.Stern@glikmanalvin.ee",
  "Name": "Jaanus Stern",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8OdxJkIF5R3rB9vftNnX"
 },
 {
  "Email": "ykiuchi@milbank.com",
  "Name": "Yoku Kiuchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Oo8v3i3GhraD2TSSmJu"
 },
 {
  "Email": "scott.neilson@allenovery.com",
  "Name": "Scott Neilson",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8PxpTAAMzyipoigy9ZbW"
 },
 {
  "Email": "bgarcia@perezllorca.com",
  "Name": "Ms. Beatriz Garcia",
  "Document Name": "Perez-LLorca - BI 2020 ESP_bi_PPP_survey (10.07.2019).docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Qlgbvf8DPY6RItpVd0d"
 },
 {
  "Email": "k&rattorneys@africa-online.net",
  "Name": "Gautoni Kainja",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8QzQF6Dt9L4kdO28AxLt"
 },
 {
  "Email": "stuart.arndt@echarris.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8So1Oakbe7IqwwP36rBn"
 },
 {
  "Email": "vallo.paal@aaviklaw.ee",
  "Name": "Vallo Paal",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8SqUN0NIi7DmghN0mGzW"
 },
 {
  "Email": "ozgur.ceylan@pae-law.com",
  "Name": "Mr. �zg�r Ceylan",
  "Document Name": "TURKEY) PELSITER) BI 2020 TUR_PPP_survey_en_PAE 22.07.2019.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Sx50CsMKBCmv2OBs7Lb"
 },
 {
  "Email": "khadija.sijaona@forbixattorneys.co.tz",
  "Name": "Khadija Ngasongwa Sijaona",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8T2zsS8YKDjG0kBT8d87"
 },
 {
  "Email": "alberto.simoes@mirandalawfirm.com",
  "Name": "Mr. Alberto Galhardo Sim�es",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en(159971.1)(167135.1).docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8TIdOaCKCOyWcx6kx7Uq"
 },
 {
  "Email": "gloriana.alvarado@pachecocoto.com",
  "Name": "Gloriana Alvarado",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8TjaJWIwNSG5wnCmkapN"
 },
 {
  "Email": "s.ndikimi@ealc.co.tz",
  "Name": "Miss STELLA NDIKIMI",
  "Document Name": "Tanzania - PPP EALC_.docx",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8WTYzJqgpQyaB2djLbS5"
 },
 {
  "Email": "bruce.white@linklaters.com",
  "Name": "Bruce White",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8Z4Pp3szpPSbSc7auzae"
 },
 {
  "Email": "g.spearing@nabarro.com",
  "Name": "Georgina Spearing",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8ZdUPKeoZ2OFFbsNAn6D"
 },
 {
  "Email": "zalfarisi@kslaw.com",
  "Name": "Zaid Hadir Al-Farisi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8ZjcA6KX1uuaAOCth2ny"
 },
 {
  "Email": "nikolai.majerovits@sirel.com",
  "Name": "Nikolai Majerovit",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8ZohoL44JXKS7tZp6kEA"
 },
 {
  "Email": "louise.camenzuli@corrs.com.au",
  "Name": "Louise Camenzuli",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8b4PtNuPv3sFL3Elkom5"
 },
 {
  "Email": "andrey.shastitko@verkhovodko.com",
  "Name": "Mr Andrey Shastitko",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_Verkhovodko and Partners.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8bE4fYKeQJR5leO3Obxg"
 },
 {
  "Email": "Jose.Moran@bakermckenzie.com",
  "Name": "Jose Moran",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8bWc0XFr9BzUgY4UPnZ6"
 },
 {
  "Email": "chewlett@nossaman.com",
  "Name": "Clothilde Hewlett",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8bniWK9RqkkmgsqQ6Are"
 },
 {
  "Email": "leander.opperman@adams.africa",
  "Name": "Leander Opperman",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8cPfx1trrSTvrNovby3c"
 },
 {
  "Email": "john.lal@fxbcfiji.com.fj",
  "Name": "John Lal",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8cdwfwI4esxXd72dyd6O"
 },
 {
  "Email": "tiyagon@scanlen.co.zw",
  "Name": "Ms Nellie Rafael Tiyago",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_Evans Talent Moyo.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8d5b8bIvfUoDZbQVqjca"
 },
 {
  "Email": "anat_p@ifct.th.com",
  "Name": "Khun Anat Prapasawad",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8d7agMCZSUuvzNJHZQvV"
 },
 {
  "Email": "kristian.bradshaw@allenovery.com",
  "Name": "Kristian Bradshaw",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8dEL8nAcDapWDHarPjZM"
 },
 {
  "Email": "info@ehandpartners.com",
  "Name": "Donya Moin",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8dvDW2Cteq2tHhK8txJV"
 },
 {
  "Email": "jmoeono.pma@gmail.com",
  "Name": "James Moeono",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8dxcWuAyuI8yujS8eL5S"
 },
 {
  "Email": "AlKhobar@arabianbemco.com",
  "Name": "Henry Sarkissian",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8e6B9ZlaTfNdbVTxlUUM"
 },
 {
  "Email": "yongjae.chang@leeko.com",
  "Name": "Mr. Yong Jae Chang",
  "Document Name": "BI 2020 KOR_bi_PPP_survey_en(LeeKo).doc",
  "Country": "KOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8eA7DNB42e4NSKpV65us"
 },
 {
  "Email": "mfi@kampala.mfios.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8eLmc1zWFFG0R2jzu0FV"
 },
 {
  "Email": "kanapinas@gmail.com",
  "Name": "Askar Kanapin",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8f2vn2SR94vTJVmO7eq5"
 },
 {
  "Email": "jhhines@morganlewis.com",
  "Name": "Jonathan Hines",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8fifgHj15KMcoL4hHgH2"
 },
 {
  "Email": "Silke.Goldberg@hsf.com",
  "Name": "Silke Goldberg",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8gG8Lp70v7rqoFs8afsq"
 },
 {
  "Email": "mccp@vda.pt",
  "Name": "Ms. Marina Costa Cabral",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_en.doc_(DM 7605157_1) (005).DOCX_(DM 7633273_1).docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8gKe2G8sGBuRMc29uUPe"
 },
 {
  "Email": "tsales@toyotaug.co.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8gwu2JWrG8PRO65yxGG6"
 },
 {
  "Email": "pascal.mousset02@rws.nl",
  "Name": "Mr Pascal Mousset",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en MBO opm PM.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8iJrHotBTf0kzORO70nC"
 },
 {
  "Email": "kyrgyzstan@colibrilaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8iOlbRgqNKT99UyQT5Ho"
 },
 {
  "Email": "rustagi@toyotatz.com",
  "Name": "Vinod Rustagi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8iq1oAzyYifG2ksaw9oe"
 },
 {
  "Email": "cmejia@cmconsultants.com.pa",
  "Name": "Claudia Mejia",
  "Document Name": "Benchmarking Infraestructure - 2020 (R. BORRELL - 5July2019).docx",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8jT6ErnDxqkAzj4L2Uwb"
 },
 {
  "Email": "mail@bgepal.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8kXUfpCgoFPQmXLWg9zR"
 },
 {
  "Email": "zsudairy@zaaslaw.com",
  "Name": "Ziad Al-Sudairy",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8mICqGtZIOlGet7yzXTS"
 },
 {
  "Email": "garciahamo@hotmail.com",
  "Name": "Ahmed Ali Hamo",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8nVt8yjpjHCQWw2W4IjS"
 },
 {
  "Email": "tanja.savicic@karanovic-nikolic.com",
  "Name": "Tanja Savicic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8oEjCWUu710Nn8Ga3DfM"
 },
 {
  "Email": "philo@phinc.co.za",
  "Name": "Philo Nel",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8oyS6oqPXQRAU7lmELu7"
 },
 {
  "Email": "tanju.ucar@alport.com.tr",
  "Name": "Tanju U�ar",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8p9gTHqGY602QEscMjJn"
 },
 {
  "Email": "giovanni.muhammad@dentons.com",
  "Name": "Mr. Giovanni Mofsol Muhammad",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Dentons.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8pmbijSM1i5kg5zryNXJ"
 },
 {
  "Email": "lori.bean@cliffordchance.com",
  "Name": "Lori Ann Bean",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8qPtJZg3nP8m5i7QW7ks"
 },
 {
  "Email": "msaenz@zaalaw.com",
  "Name": "Martha R. Saenz",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8qpcZ7Fm3DSFYfLGxCq7"
 },
 {
  "Email": "reuben.cronje@pinsentmasons.com",
  "Name": "Mr Reuben Cronjé",
  "Document Name": "BI 2020 ZAF_bi_TPI_survey_en_Pinsent Masons_Aug2019.docx",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8qrDczEqvWIU6wyVWX4Q"
 },
 {
  "Email": "mohamed.wahba@eldib.com",
  "Name": "Mohamed Wahba",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8r8SURxpV0Witb6cuELb"
 },
 {
  "Email": "colinfd@unimeld.edu.au",
  "Name": "Colin Duffield",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8rNQpMX3fwOzyHCS6s9d"
 },
 {
  "Email": "k.barabash@ndex-solutions.kg",
  "Name": "Ksenyya Barabash",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8rdP2AxIxtg9lTHFHu8a"
 },
 {
  "Email": "Cherinetgebrehiwot@gmail.com",
  "Name": "Cherinet Gebrihiwot",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8rqgBsdUIzszp0NFtyZA"
 },
 {
  "Email": "paul.epstein@shearman.com",
  "Name": "Paul Epstein",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8sNrPQRj2G8keFUW145E"
 },
 {
  "Email": "enquiries@smithbrothersltd.co.uk",
  "Name": "Clive Naylor",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8sYPNRfnmk1WiEcNRqWS"
 },
 {
  "Email": "billdegrandis@paulhastings.com",
  "Name": "William Degrandis",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8t4PhlwHEFHmAGgOU4oh"
 },
 {
  "Email": "somalilandbar_association@yahoo.co",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8tR91waA45H87QOsE8QL"
 },
 {
  "Email": "valter.vohma@hedman.ee",
  "Name": "Valter Vohma",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8tSHMBEjXfyBkQociXbN"
 },
 {
  "Email": "vanuatu@rmscivil.net.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8uxPXhIYTvMM0wnJIVbc"
 },
 {
  "Email": "douw@barnardinc.co.za",
  "Name": "Douw Breed",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8vGHyw9SlDnTII1MivC8"
 },
 {
  "Email": "christian.aispur@dlapiper.com",
  "Name": "Christian Aispur",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8wb8k6nDXBRa7CNp5wfc"
 },
 {
  "Email": "joana@uem.mz",
  "Name": "Joana Sono",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8xzmtKpsXoiWCsIYVjfh"
 },
 {
  "Email": "bongai.gandha@rsm.co.bw",
  "Name": "Bongai Gandha",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8yD1Aa816SQqRhjaq674"
 },
 {
  "Email": "mohammed@mansourlawfirm.com",
  "Name": "Mohammed Mansour",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8yDvZspSM9DMIuJ57acS"
 },
 {
  "Email": "patrick.mitchell@hsf.com",
  "Name": "Patrick Mitchell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8ykN5t0BCQdhYK3KKEEh"
 },
 {
  "Email": "carmela.semana@dlsu.edu.ph",
  "Name": "Carmela Semana",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8zS82rmVFXxMikVYJgnG"
 },
 {
  "Email": "ialbayaa@kpmg.com",
  "Name": "Islam Al Bayaa",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/8ztSMMS6rozgpUb8qqK5"
 },
 {
  "Email": "gregor.wolter@adams.africa",
  "Name": "Gr�gor Wolter",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/90IwG8Vofrn5Kgbr0J20"
 },
 {
  "Email": "yongjae.chang@leeko.com",
  "Name": "Mr. Yong Jae Chang",
  "Document Name": "BI 2020 KOR_bi_TPI_survey_en (LeeKo).docx",
  "Country": "KOR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/91W2fIKgx4slZVHjpsbB"
 },
 {
  "Email": "tony.klimas@ey.com",
  "Name": "Tony Klimas",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/91kizMCcviRtkptjZ4EF"
 },
 {
  "Email": "info@lpa.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/92532lCeZiVzJCmKWCpd"
 },
 {
  "Email": "robert.freedman@shearman.com",
  "Name": "Robert Freedman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/92nRpP4061VbuhStu9YJ"
 },
 {
  "Email": "mrochester@mccullough.com.au",
  "Name": "Michael Rochester",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/94NR2MVo6BuW76mhX3Tf"
 },
 {
  "Email": "riyadh@toban-lawfirm.com",
  "Name": "Sameh M. Toban",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/95i8haVk0gagEEoaIZrt"
 },
 {
  "Email": "jcespinosa@alves-legal.com",
  "Name": "Juan Carlos Espinosa Jimenez",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/95lmSQDixnGmT666boqR"
 },
 {
  "Email": "Ilo-Hanna.Keres@glikmanalvin.ee",
  "Name": "Ilo Hanna Keres",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/965GIgpJNoYArXY5tqD5"
 },
 {
  "Email": "akos.bajorfi@noerr.com",
  "Name": "Dr. �kos Bajorfi",
  "Document Name": "HUNGARY) NOERR) 20190731_BI 2020 HUN_bi_PPP_survey_en_Noerr.docx",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/96cjYC7LKlK98ijs7CDl"
 },
 {
  "Email": "richard.coar@linklaters.com",
  "Name": "Richard Coar",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/97WgF8deIIfx6sQODvVq"
 },
 {
  "Email": "kwadwontr@ntrakwahandco.com",
  "Name": "Kwadwo Ntrakwah",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/98likVkvPs0JUm1Y7CFX"
 },
 {
  "Email": "tesfai.goitom@csulb.edu",
  "Name": "Tesfai Goitom",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/98siiANyFKU0Sh6O0r2V"
 },
 {
  "Email": "bgrant@stikeman.com",
  "Name": "Bradley B. Grant",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/99lvOSyqBhpnKwm9mfrJ"
 },
 {
  "Email": "veritas@elcat.kg",
  "Name": "Nikolai Malyshev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9AC7TPETWZx8eHNWmJnA"
 },
 {
  "Email": "filip.ruben@t.mk",
  "Name": "Mr. Filip Ruben",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Mens_Filip.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9AslsLhHjWcdQPudeO9B"
 },
 {
  "Email": "bancha@siampremier.com",
  "Name": "Bancha Wudhiprecha",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9BUx5nnI3gzutHpdFNg7"
 },
 {
  "Email": "myagovkina@abylaw.com",
  "Name": "Mariana Yagovkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9BWznHLaluMn1U8Hm0to"
 },
 {
  "Email": "kyle.lakin@freshfields.com",
  "Name": "Kyle Lakin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9C3VU833eUKaMJqMu3yc"
 },
 {
  "Email": "info@ksjconstruction.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9CAqQnHlTcO8CVnsEeCM"
 },
 {
  "Email": "swalli@exorattorneys.com",
  "Name": "Shehzada Walli",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9EK5WpRp6U8aBLXWJWlt"
 },
 {
  "Email": "stephen.colliston@shepwedd.co.uk",
  "Name": "Stephen Colliston",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9F8EGpEvhexkSE0R5XIF"
 },
 {
  "Email": "tamandanyimba@yahoo.com",
  "Name": "Viva Nyimba",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Fm5KcGCKPNQZz5Ix9b5"
 },
 {
  "Email": "smonila@sanigest.com",
  "Name": "Silvia Molina",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Gq3D2G2DgeN9sThbNQz"
 },
 {
  "Email": "info@communicaid.com",
  "Name": "Katherine Palmer",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9H8dFkglATB8MrFqqxXF"
 },
 {
  "Email": "jan.fanta@cz.ey.com",
  "Name": "Jan Fanta",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9HiEQZc2GjzQ1DcIu7RZ"
 },
 {
  "Email": "ralleyne@kpmg.co.tt",
  "Name": "Robert Alleyne",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9HteLl7v1aa9tkDVmP7X"
 },
 {
  "Email": "elisabeth.preston@mcmillan.ca",
  "Name": "Elisabeth Preston",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9HvyEaiDpbUFb6CZi20w"
 },
 {
  "Email": "geoffrey.white@cliffordchance.com",
  "Name": "Geoffrey White",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9IYqv7alW1gur5i74SE8"
 },
 {
  "Email": "Marcin.Skowron@uzp.gov.pl",
  "Name": "Mr. Marcin Skowron",
  "Document Name": "BI 2020 POL_bi_PPP_PO_PPO.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Iqwpu3HdfC3YmyydOsj"
 },
 {
  "Email": "tpopovkina@granate.com",
  "Name": "Ms Tatyana Popovkina",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_GRATA.docx",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9J6ypnidB0Q47qnlrvGS"
 },
 {
  "Email": "Paul.Styman@anu.edu.au",
  "Name": "Paul Styman",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9JGsJuKRAftYZwHTW71G"
 },
 {
  "Email": "frederique.dupuis.toubol@twobirds.com",
  "Name": "Fr�d�rique Dupuis-Toubol",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Jx5gawj3HWPb09dAmIh"
 },
 {
  "Email": "anil.khurana@ae.pwc.com",
  "Name": "Anil Khurana",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9K1qkQFaBkpD9XxXdx2O"
 },
 {
  "Email": "anna.dreyzina@notemlaw.com",
  "Name": "Ms Anna Dreyzina",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en-completed_dreyzina.docx",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9KS6tiTQR5wvh4KY1d57"
 },
 {
  "Email": "brendan.hundt@shearman.com",
  "Name": "Brendan Hundt",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9KrWWbdflPLMHM3LvV4w"
 },
 {
  "Email": "jgjafar@tvcabo.co.mz",
  "Name": "Jafar Gulamo Jafar",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9LPkQtPowoaXOLtuKMEx"
 },
 {
  "Email": "kkonstantinov@chadbourne.com",
  "Name": "Konstantin Konstantinov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9LUEbG5NFbD7XE2hZJQr"
 },
 {
  "Email": "michaeldjohan@ssek.com",
  "Name": "Mr. Michael Amos Djohan",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_SSEK.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9M38in6ssDsKkqdkU5bT"
 },
 {
  "Email": "info@solielaw.gm",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9MF1hWhuKJDGnbnWgv7A"
 },
 {
  "Email": "rlewi@kslaw.com",
  "Name": "Rupert Lewi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9MZ3BwcWlrH6FMFKRbAJ"
 },
 {
  "Email": "marieke.datema@blplaw.com",
  "Name": "Marieke Datema",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9OSWl7Vs1SnhUZvGSyPh"
 },
 {
  "Email": "a.tithecott@tamimi.com",
  "Name": "Andrea Tithecott",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Pb4ZjDwqV9gpAnh2YOf"
 },
 {
  "Email": "jhugenberger@mwe.com",
  "Name": "Joel Hugenberger",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9QJlgKv41Ndv2gtUztiV"
 },
 {
  "Email": "thiago.sombra@mattosfilho.com.br",
  "Name": "Mr. Thiago Sombra",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9Qa0ZZOr60gkRfa9y9Oz"
 },
 {
  "Email": "info@prlaw.lk",
  "Name": "Paul Ratnayeke",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9QeWwdX3elmv0ZCLIDqE"
 },
 {
  "Email": "webber@ceal2005.com",
  "Name": "Dion Webber",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9QeZhAPhLGt9HmiFj3R3"
 },
 {
  "Email": "mail@advantek-ss.ru",
  "Name": "Yury Leonidovich Duzenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9RNFrX6FYFt3guqHXBzM"
 },
 {
  "Email": "edward.sampa@barclays.com",
  "Name": "Edward Sampa",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9SBzm6waClQcu5jeLFXw"
 },
 {
  "Email": "james.marshall@blplaw.com",
  "Name": "James Marshall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9SyVXGqVfSBIrU8RsXJv"
 },
 {
  "Email": "dick.leder@nortonrosefulbright.com",
  "Name": "Richard Leder",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9T79rxC02TE6qN9aGUid"
 },
 {
  "Email": "dcaldwell@mofo.com",
  "Name": "Dale Caldwell",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9TWmNlx2Vj1r7wdkWHHI"
 },
 {
  "Email": "ali@arcadia-engineering.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9UFUFi0FAfY8dP1wmwoV"
 },
 {
  "Email": "vianna.maino@gmail.com",
  "Name": "Dr. Vianna Maino",
  "Document Name": "Revision 2 REM BI 2020 ECU_bi_PPP_survey_en 3.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9UXIVsGWjqHyZSNYf9eK"
 },
 {
  "Email": "Scott.McCoy@allens.com.au",
  "Name": "Mr Scott McCoy",
  "Document Name": "Australia_Allens_TPI Survey(505580799.1).docx",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9UXLZ6iz8MivFGHUB0Oo"
 },
 {
  "Email": "mikk.lohmus@tgsbaltic.com",
  "Name": "Mikk L�hmus",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9UjfBIB4vudHwHm54vnO"
 },
 {
  "Email": "efeomo@geplaw.com",
  "Name": "Ms Efeomo Olotu",
  "Document Name": "NIGERIA) GEPLAW) World Bank TPI Survey .docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9VrdQ3h0XdaHh7AhLeJM"
 },
 {
  "Email": "info@logicon.am",
  "Name": "Vahe Petrosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9X2pfipF9BtW5HCLy3FE"
 },
 {
  "Email": "glopez@sucre.net",
  "Name": "Guillermo Lopez",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9XupaEDeywsdT7A8NInW"
 },
 {
  "Email": "info@exterior.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9ZCR3WKuA4uJyBzTyzMA"
 },
 {
  "Email": "m.ghazaryan@bdoarmenia.am",
  "Name": "Manvel Ghazaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9ZO8qBrBWUtuDgXvXyoe"
 },
 {
  "Email": "cereside@punolaw.com",
  "Name": "Christina E. Reside",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9ZTWuJ4cx9r4rBcPhXKW"
 },
 {
  "Email": "schowdhury@khossain.com",
  "Name": "Mr. Saiful Alam Chowdhury",
  "Document Name": "BANGLADESH) KAMAL) BI 2020 BGD_bi_PPP_survey_en_26 08 2019.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9aDBpJncdmmVNzbUW1Zq"
 },
 {
  "Email": "Ebrahim_Beigzadeh@sbu.ac.ir",
  "Name": "Ebrahim Beyk Zadeh",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9aeclgSVUsRz4rLN8sMM"
 },
 {
  "Email": "ahti.kuusevali@heta.ee",
  "Name": "Ahti Kuusev�li",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9bqEUKOakatUL6CXAaML"
 },
 {
  "Email": "omar@alrasheedlaw.com",
  "Name": "Omar Al-Rasheed",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9cML7oGYZ75yVixzED4N"
 },
 {
  "Email": "mpolonsky@whitecase.com",
  "Name": "Marc Polonsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9cSDH7R0JCGFb999feIG"
 },
 {
  "Email": "alferio.dgedge@fla.co.mz",
  "Name": "Alferio Dgedge",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9cYYWKJPTJThvXH3omdG"
 },
 {
  "Email": "tadessek@tadessekiros.com",
  "Name": "Tadesse Kiros",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9dAIBymSGFMWfP6TH9X1"
 },
 {
  "Email": "akirethi@hallmarkattorneys.com",
  "Name": "Annette W. Kirethi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9dkCCtVmbg7BiGlxJZ5E"
 },
 {
  "Email": "info@iraq-legal.com",
  "Name": "Wasan Almayah",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9eHwgmoi2Pcmx5nnSIY3"
 },
 {
  "Email": "emilio.viciana@hacienda.gob.es",
  "Name": "Mr Emilio Viciana",
  "Document Name": "19 07 08 Inf DGP BI 2020 ESP_bi_PPP_survey_env_SEITT.DOCX",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9fRTHkqu08b6qmSnOskK"
 },
 {
  "Email": "WScott@ScottAdvocates.com",
  "Name": "Ward E. Scott Ii",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9gcEfc2lBPXveYC7xiyk"
 },
 {
  "Email": "fec@ustm.ac.mz",
  "Name": "Raimundo Nassone",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9gd9MeWSMChL8KfCBB2p"
 },
 {
  "Email": "sduggins@eastlink.ca",
  "Name": "Steve Duggins",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9gyhfdI1OX8oQVoPe667"
 },
 {
  "Email": "mail@barlaw.co.il",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9iG7KHt4OWu528FEwVLm"
 },
 {
  "Email": "ijimenez@nossaman.com",
  "Name": "Isidro Jimenez",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9iN85xeHHMQugKBfonyk"
 },
 {
  "Email": "f.dini@anticorruzione.it",
  "Name": "title Dini Federico",
  "Document Name": "01_BI2020ITA_bi_TPI_survey_en (002)_Federico Dini.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9iNZFe6vverwPaH9Xcfp"
 },
 {
  "Email": "paul.lockyer@nortonrosefulbright.com",
  "Name": "Paul Lockyer",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9itPNW23hjFuCh0BBS3E"
 },
 {
  "Email": "info@aalaw.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9lIaLtdjdZRt7eW7mFc0"
 },
 {
  "Email": "sanabil@aloulalaw.com",
  "Name": "Ms. Sanabil Jafar",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_Oula.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9leaJbMW84pYZKKEKYLA"
 },
 {
  "Email": "andreas.dienemann@de.transport.bombardier.com",
  "Name": "Andreas Dienemann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9lz2Cjwbpdw8w3KiyoCX"
 },
 {
  "Email": "charlespatrizia@paulhastings.com",
  "Name": "Charles Patrizia",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9mJ18E7BGPByymDXeGz7"
 },
 {
  "Email": "elena.iacob@zrvp.ro",
  "Name": "Mrs Elena Iacob",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en_zrp_ ID300719.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9onhdHy5yrCDoRG7HPGL"
 },
 {
  "Email": "qatart@tag-legal.com",
  "Name": "Mr. Ali Sophie",
  "Document Name": "BI 2020 QAT_bi_PPP_survey_en_TAGLegal.doc",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9p4tMx3qFh18WirfnXS6"
 },
 {
  "Email": "matthew.bubb@ashurst.com",
  "Name": "Matthew Bubb",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9q2aSw50sDc6Kq4J5Kvk"
 },
 {
  "Email": "peter.pacheco@romulo.com",
  "Name": "Peter Pacheco",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9sHBOEpXGn61C6WdSRYD"
 },
 {
  "Email": "hailehadd@gmail.com",
  "Name": "Haile Kiros Haddis Assefa",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9sMJUiAU8iinqhu5SkGi"
 },
 {
  "Email": "savantha@desaram.com",
  "Name": "Mr. Savantha De Saram",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en_DL&F De Saram.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9smTEI206f7Jl3TIyGW5"
 },
 {
  "Email": "Guy.Callender@cbs.edu.au",
  "Name": "Guy Callender",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9u2tqO8IDW3Yr2Vz5OCR"
 },
 {
  "Email": "tim.philpotts@ca.ey.com",
  "Name": "Tim Philpotts",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9u8G6JEAZlWHQjPNUflx"
 },
 {
  "Email": "JohnK@sol-law.com.sb",
  "Name": "John Katahanas",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9u9JceXDUFwMfuQvwtFa"
 },
 {
  "Email": "Yoav.Zidon@ey.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9vZuivMssAt1u6dgqtkO"
 },
 {
  "Email": "djordje.dimitrijevic@karanovic-nikolic.com",
  "Name": "Dorde Dmitrijevic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9vtKkfOZd1CClyPNyZD2"
 },
 {
  "Email": "a.paul@ealc.co.tz",
  "Name": "title Angela Paul",
  "Document Name": "Tanzania_EALC_TPI.docx",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9wMWCbr65eTUQlsiNZzM"
 },
 {
  "Email": "marit.kukk@eversheds.ee",
  "Name": "Marit Kukk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9wkfL7EAZp11xrzCQ5N0"
 },
 {
  "Email": "d.akhmetov@integrites.com",
  "Name": "Duman Akhmetov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9xTc6KMhLYsibbYbAiGO"
 },
 {
  "Email": "hailehadd@gmail.com",
  "Name": "Haile Kiros Haddis Assefa",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9xh0EpEQjnR3Nsiz0JW9"
 },
 {
  "Email": "beverly.kennedy@corrs.com.au",
  "Name": "Beverly Kennedy",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9xnjKc4CJLQgknQ0e9CG"
 },
 {
  "Email": "info.slc@liebherr.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9xx9ggMmjG1IkZSiRoKB"
 },
 {
  "Email": "stephen.ashworth@dentons.com",
  "Name": "Stephen Ashworth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9y6MrHwU5WKpzJMcfa4y"
 },
 {
  "Email": "igelovani@deloitte.ge",
  "Name": "Irakli Gelovani",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9ygVm854n1NruUsgXaEJ"
 },
 {
  "Email": "carry.plaks@sorainen.com",
  "Name": "Carry Plaks",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9yw4pwn6QFiuCdLYzvZ9"
 },
 {
  "Email": "spitznagelp@bennettjones.com",
  "Name": "Perry Spitznagel",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9z7sSTllBYTba2kGvUpr"
 },
 {
  "Email": "ay.shaposhnikov@vaz.ru",
  "Name": "Igor Komarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/9zkTwwL7FZ0jhaHbGg5C"
 },
 {
  "Email": "afakerdinova@deloitte.kg",
  "Name": "Albina Fakerdinova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A06MWWDMxObqToCEqWkH"
 },
 {
  "Email": "fatima@aihlawfirm.com",
  "Name": "Ms Fatima Abass",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_Kayan.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A1GcPsynT0EvTwFBNDlG"
 },
 {
  "Email": "ajbgooding@hotmail.com",
  "Name": "Arnold J.B Bishop-Gooding",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A1T1XH25bJlrCLUWiJBv"
 },
 {
  "Email": "sayad@lawyer.am",
  "Name": "Sayad Badalyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A4YiOaBJ355TaSFzQQb3"
 },
 {
  "Email": "info@mbclegal.org",
  "Name": "Daniel Koroma Esq.",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A6OCxGWQdhTEDkxqE3LF"
 },
 {
  "Email": "info@tpp-sugd.tj",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A74ScA7BnmaCIT3zLK8d"
 },
 {
  "Email": "info@cci.kz",
  "Name": "Sabr Esimbekov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A7gsg3fBu1Ct5rdj2x3N"
 },
 {
  "Email": "airlie.fox@corrs.com.au",
  "Name": "Airlie Fox",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A7mwhGrciUovtahGyo9Z"
 },
 {
  "Email": "info@victoria-motors.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A7q4gwruyiCbeuCQfgAs"
 },
 {
  "Email": "ykojima@nossaman.com",
  "Name": "Yukiko Kojima",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A80JOtfAILIzA0wApdrC"
 },
 {
  "Email": "belal@ghazzawilawfirm.com",
  "Name": "Belal T Al Ghazzawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A8nnLh2wDVVmJxQjmLeL"
 },
 {
  "Email": "imran.jamil@saudibauer.com",
  "Name": "Imran Jamil",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A8szdg8NL4jiiUyNvkwp"
 },
 {
  "Email": "avargas@melarayasociados.com",
  "Name": "Alfredo Jos� Vargas Ch�vez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A91cI2hqqTblqpFwQkKD"
 },
 {
  "Email": "claire.barclay@pinsentmasons.com",
  "Name": "Ms Claire Barclay",
  "Document Name": "BI 2020 ZAF_bi_TPI_survey_en_Pinsent Masons_Aug2019.docx",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A9HVX01rPcWRKh3KgThi"
 },
 {
  "Email": "nkyshtobaev@gratanet.com",
  "Name": "Mr. Nurlan Kyshtobaev",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_GRATA.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/A9VU9u2wGVc0vIrEAZbu"
 },
 {
  "Email": "enkeleda.bega@kpp.gov.al",
  "Name": "Mrs Enkeleda Bega",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en_PPC.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AA3SXCAA4GqGQG2oyF2R"
 },
 {
  "Email": "spbcci@spbcci.ru",
  "Name": "Vladimir Katenev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AAY2cLoNMf6HSsGtqys0"
 },
 {
  "Email": "imran.jamil@saudibauer.com",
  "Name": "Imran Jamil",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AAcjWP3lnG1xYKEIKX97"
 },
 {
  "Email": "info.nsw@gadens.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ACAUjefGhr5W8I7KdSuR"
 },
 {
  "Email": "ren@dunster.co.za",
  "Name": "Ren Dunster",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AErXCNdAqmAgen6SNjOU"
 },
 {
  "Email": "gatzori@cgsh.com",
  "Name": "Mr. Gianluca Atzori",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en (002)[2].docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AGnwA3WpudyiV8Qigbcv"
 },
 {
  "Email": "bradford.oneill@gufalaw.com",
  "Name": "Bradford K. O'Neill",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AHnMiNmb9POc8qBC44gp"
 },
 {
  "Email": "Rshaban@blg.com",
  "Name": "Richard H. Shaban",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AI1IfjPhE6y49ih4CB9g"
 },
 {
  "Email": "ekoehler@huntonak.com",
  "Name": "Mr. Edward Koehler",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AI2XitljQb1dLVVh2bFw"
 },
 {
  "Email": "godoy@berettagodoy.com",
  "Name": "Mr Federico Godoy",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en (1) (003) (FG).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AIMgMv3apgDETjMBRH6s"
 },
 {
  "Email": "Dennis.Y.Kawaw@mw.ey.com",
  "Name": "Mr Dennis Kawawa",
  "Document Name": "MALAWI) ENY) BI 2020 MWI_bi_PPP_survey_en_ey.docx",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AIUhIUwqH6zwEsPS1IwE"
 },
 {
  "Email": "Yambani@knightnknight.com",
  "Name": "Yambai Mulemba",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AJB8ROIEdZvh2PMs595v"
 },
 {
  "Email": "maga@maga.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AJPrrMVBWs4sJ3XSPJ99"
 },
 {
  "Email": "pisarna@mrva.si",
  "Name": "Ms Manca Gorisek",
  "Document Name": "BI 2020 SVN_bi_PPP_survey_en_Blaz_Mrva.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AJQ71BRL1JsNKnqPUZRr"
 },
 {
  "Email": "jonathan.burns@dentons.com",
  "Name": "Jonathan Burns",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AJYEV1LwgGLh1CHFX5bZ"
 },
 {
  "Email": "andrew.petry@simmons-simmons.com",
  "Name": "Andrew Petry",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AL4DjoAPzC8VjoLvvVvE"
 },
 {
  "Email": "torsten.pokropp@dlapiper.com",
  "Name": "Dr Torsten Pokropp",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AMbdAgaK8QZPzkxKplzU"
 },
 {
  "Email": "info@ltcs-law.net",
  "Name": "Omer Ahmed El-Basheer Abu- Sham",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AMvyXr0n3A0BHxGc5Cx9"
 },
 {
  "Email": "cip@cipmoz.org",
  "Name": "Adriano Nuvunga",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ANIFQUvtJxL002G7iGMC"
 },
 {
  "Email": "roberto.cursano@bakermckenzie.com",
  "Name": "Dr. Roberto Cursano",
  "Document Name": "Italy TPI Survey for World Bank_Baker Mckenzie.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ANjycOcFbDjvmN6TuNkn"
 },
 {
  "Email": "richard.barham@dentons.com",
  "Name": "Richard Barham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ANwun9zzclt3mwdIg9bm"
 },
 {
  "Email": "miho.niunoya@aplaw.jp",
  "Name": "Miho Niunoya",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AP8kSxYImyS4vZu8LUQG"
 },
 {
  "Email": "robert.gross@blplaw.com",
  "Name": "Robert Gross",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/APWrKKOhTm1Q9U6KTf4g"
 },
 {
  "Email": "scandelaria@aps.ateneo.edu",
  "Name": "Sedfrey M. Candelaria",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ARlhELIIdmSd2HoPNbeH"
 },
 {
  "Email": "fsuazo@corplawhn.com",
  "Name": "Felix Alejandro Suazo S.",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ASZk1W43l6xx0OqfEDi5"
 },
 {
  "Email": "johannesburg@aurecongroup.com",
  "Name": "Irina Unkovski",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ATO4aFeG8He9zKTEPEKu"
 },
 {
  "Email": "stanislav_puginsky@epam.ru",
  "Name": "Stanislav Puginsky",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ATh5FIWW68y2wGVFu7dE"
 },
 {
  "Email": "elhussiens@yahoo.com",
  "Name": "El Hussein Ahmed Salah",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ATsEIMHYMj4uyhAZR4hS"
 },
 {
  "Email": "matt.mulligan@nortonrosefulbright.com",
  "Name": "Matt Mulligan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AV36k8LaqSuOKKvEBOmD"
 },
 {
  "Email": "rosudi@treasury.go.ke",
  "Name": "Mr. Robert Robert",
  "Document Name": "BI 2020 KEN_bi_PPP_PO_survey_en-Robert Osudi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AWKcXCWPjC8M3tFMSMBc"
 },
 {
  "Email": "holdencustomercare@gm.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AWxFMFgbTYRPknjAYSQi"
 },
 {
  "Email": "d.hanekom@spoor.com",
  "Name": "Dirk Hanekom",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AYGERvArTk0b6SEP7qLu"
 },
 {
  "Email": "jnavarro@portallaw.com",
  "Name": "title Jonathan Navarro",
  "Document Name": "BI 21020 SLV_bi_TPI_survey_en.docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AZhsBF9iUSZwqvSUu0wd"
 },
 {
  "Email": "info@haccw.org",
  "Name": "Arturo E. Enamorado",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Aas8PbDfYqv3z96XfIGd"
 },
 {
  "Email": "tthaveesangsakulthai@deloitte.com",
  "Name": "Thavee Thaveesangsakulthai",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AbLsH5dm2TjzDb3l7gVI"
 },
 {
  "Email": "diederik.dekoe@turntown.com",
  "Name": "Mr. Diederik de Koe",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en - INPUT DdK TT.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Abf9GMg2gswlUgFLuHX7"
 },
 {
  "Email": "tony.reale@bmo.com",
  "Name": "Tony Reale",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Abx52F3XziRwYhwkIKGB"
 },
 {
  "Email": "KCooligan@blg.com",
  "Name": "Katherine Cooligan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AdCWKZnJ19ydK8RD7CWU"
 },
 {
  "Email": "sintija.radionova@primus.legal",
  "Name": "Sintija Radionova",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AdoCpGHw6nS3mJejt4Eu"
 },
 {
  "Email": "info@sicangcolaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ae3ppeaDfXV5agrzahLe"
 },
 {
  "Email": "senaiwoldeab@gmail.com",
  "Name": "Mr. Senai Andemariam",
  "Document Name": "WB Survey (BGM).docx",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AeZFr3CfCLqjkC3f7R36"
 },
 {
  "Email": "aam@africalegalnetwork.com",
  "Name": "Mr. Amyn Mussa",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_Atiq S Anjarwalla.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AegnV2sPjKQ74A831xX7"
 },
 {
  "Email": "Helen_CHEN@cp2m.gov.sg",
  "Name": "Helen Chen",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Af3ax2g0IhTkwhFLXJdZ"
 },
 {
  "Email": "cndandiko@yahoo.co.uk",
  "Name": "Charles Ndandiko",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AfNS3mJd2lKKfdEEUwS9"
 },
 {
  "Email": "jacoattorney@gmail.com",
  "Name": "Jaco Du Plessis",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AfgakiQK2UueyDWiZKTO"
 },
 {
  "Email": "roah@mth.dk",
  "Name": "Robert Hodgkins",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AgD61nHf4DjYxa8vP59S"
 },
 {
  "Email": "mad@gorrissenfederspiel.com",
  "Name": "Martin Andr� Dittmer",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AgwwKaqqiPD4qfavIDYM"
 },
 {
  "Email": "afaq.mufti@ae.pwc.com",
  "Name": "Afaq Mufti",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AhpQu5u9YO4GR4iBG7GA"
 },
 {
  "Email": "lcg@lcg.tj",
  "Name": "Ravshan Niyazmukhamedov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AiKgNjwuCAq01Fr2jQm3"
 },
 {
  "Email": "kati.pino@magnussonlaw.com",
  "Name": "Kati Pino",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AjKT9gdZNqNYKTgoedXV"
 },
 {
  "Email": "heili.puumann@sorainen.com",
  "Name": "Heili Puumann",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AjcU8IZnI2nyC6u9UmnU"
 },
 {
  "Email": "jppessoa@toledomarchetti.com.br",
  "Name": "Dr. Jo�o Pessoa",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AjqHbovB8NMbhcOuKQAh"
 },
 {
  "Email": "ahmed.dawood@bhc-iq.com",
  "Name": "Ahmed Dawood",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Akh92o5WYMkz6PejFX0x"
 },
 {
  "Email": "sitnikov@vegaslex.ru",
  "Name": "Alexander Sitnikov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AlviziGylyL1gD4yobL7"
 },
 {
  "Email": "c.izuwah@icrc.gov.ng",
  "Name": "Engr. Chidi Izuwah",
  "Document Name": "NIGERIA) ICRC) BI 2020 NGA_bi_PPP_survey_en r1Answers.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Alz6MCTLMgR7piIpEzt0"
 },
 {
  "Email": "emahoney@afghanppp.org",
  "Name": "Elizabeth Mahoney",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AnHBexYSl7dXfKoBsp8x"
 },
 {
  "Email": "andre.maniam@wongpartnership.com",
  "Name": "Andrew Maniam",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AnSV20eWmIM1gUCBCeY9"
 },
 {
  "Email": "kisakiu.posman@posman.com",
  "Name": "Kisakiu Posman",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AoGj4FBLOkawAQh672OD"
 },
 {
  "Email": "bswick@mccarthy.ca",
  "Name": "Brenda C. Swick",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ApFv0aSjKwCi2ZgtMcXz"
 },
 {
  "Email": "benny@legallex.net",
  "Name": "Benny Lim Hc",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ApLCX0DzVxU6K7tFX0Kv"
 },
 {
  "Email": "herbert.giron@ariaslaw.com",
  "Name": "Mr. Herbert Gir�n",
  "Document Name": "20190729 - BI 2020 GTM_bi_PPP_survey_en - (Arias Guatemala).docx",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Aq4SOti1Y3vStg7oq18V"
 },
 {
  "Email": "giottavi@istat.it",
  "Name": "Dr. Giovanna Ottaviani",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en 18_07_2019_ISTAT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AqDT5grGaLGRpWluyQZu"
 },
 {
  "Email": "dga@galantemartins.com",
  "Name": "Dr Diego Galante",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ar4w2YCyBPR3Od6xhNOk"
 },
 {
  "Email": "Fisseha.tigist@yahoo.com",
  "Name": "Tigist Fisseha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ar76KAOhVLa4pu00zVag"
 },
 {
  "Email": "kai.schneider@cliffordchance.com",
  "Name": "Kai-Niklas Schneider",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ArjeoZNsnIkvsPxAtRcb"
 },
 {
  "Email": "giovanni.coletta@mef.gov.it",
  "Name": "Dr Giovanni Coletta",
  "Document Name": "World Bank Benchmarking Infrastructure 2020 in Italy_PPP - MEF.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AsnfLurOHnVb1o4TwaPN"
 },
 {
  "Email": "lbz@signumlaw.com",
  "Name": "Ms Liza Zhumakhmetova",
  "Document Name": "BI 2020 KAZ_bi_PPP_survey_en_SIGNUM Law Firm.docx",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/At2kdyckZFj2W100le0i"
 },
 {
  "Email": "louise.robling@bevanbrittan.com",
  "Name": "Louise Robling",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AtbjkktgsVmaNl31b3bc"
 },
 {
  "Email": "info-ksa@houraniassociates.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AtdgFlopHH7yNEXsesUN"
 },
 {
  "Email": "toteng.law@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AtxSyWgROoQ2fpUocA1f"
 },
 {
  "Email": "sascha.kuhn@simmons-simmons.com",
  "Name": "Sascha Kuhn",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AumALEEtEwQAbXFmcOXU"
 },
 {
  "Email": "dickey@brookfields.co.nz",
  "Name": "Melinda Dickey",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Aw0qZpPuQgS24Kk3GTEU"
 },
 {
  "Email": "ecousins@nossaman.com",
  "Name": "Elizabeth Cousins",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AwSUT1OpJk1h1Ryyo8oW"
 },
 {
  "Email": "federica.de.luca@pwc.com",
  "Name": "title Federica De Luca",
  "Document Name": "Italy TPI_Survey_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AxnVZENESGe9tI7c7zGn"
 },
 {
  "Email": "helenwestman@eversheds-sutherland.co.za",
  "Name": "Helen Westman",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ay6C4cL0yfPGfay4XxLi"
 },
 {
  "Email": "masselin@tremblaybois.qc.ca",
  "Name": "Myriam Asselin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/AzRToifiHfxhUZXpJhEa"
 },
 {
  "Email": "amina.abdala@tta-advogados.com",
  "Name": "Ms. Amina Abdala",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en_TTA.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B0T4XtNXeFvYKxagGHwK"
 },
 {
  "Email": "mnovak@csas.cz",
  "Name": "Novak Milos",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B0g2XkGtcH2aFnqe5uej"
 },
 {
  "Email": "marian.boyle@dentons.com",
  "Name": "Marian Boyle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B0gUVcF1l1nfShfPrcQE"
 },
 {
  "Email": "rizwan.desai@collinsnewman.bw",
  "Name": "Rizwan Desai",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B0oi5mYMoARW4zl6h8gd"
 },
 {
  "Email": "ana.kasirska@karanovicpartners.com",
  "Name": "Ms. Ana lKashirska",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Ljupka.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B0wbtSFPGCt2B4xuUDrl"
 },
 {
  "Email": "dli@whitecase.com",
  "Name": "Mr. David Li",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en (David Li 201909).doc",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B14N6CUEqq0NF3UCYFaq"
 },
 {
  "Email": "rquiros@central-law.com",
  "Name": "Rafael Quir�s Bustamante",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B1CXLVloIwQd138YORRw"
 },
 {
  "Email": "chatchavej@siampriemier.com",
  "Name": "Chatchavej Chitvarakorn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B1jBsgBwlELsR20tV7x8"
 },
 {
  "Email": "thomas.schwarz@bld.de",
  "Name": "THOMAS SCHWARZ",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B24PFxMUbpSGjKzgCxXb"
 },
 {
  "Email": "dpeel@whitecase.com",
  "Name": "Doug Peel",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B2JjhvbW7eSw0OONYOex"
 },
 {
  "Email": "mr.peritum@mail.ru",
  "Name": "Daler Kurbonov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B2Vw58uXcG4dd0jdgXGw"
 },
 {
  "Email": "yanjuna@catholic.ac.kr",
  "Name": "Prof Junsok Yang",
  "Document Name": "KOREA) PROF YANG) BI 2020 KOR_bi_TPI_survey_en-Yang.docx",
  "Country": "KOR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B3bjy7HbyB1FL5smkELB"
 },
 {
  "Email": "amartinez@hwle.com.au",
  "Name": "Ana-Mari Martinez",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B3zJIwApXtEOMiUCFYn5"
 },
 {
  "Email": "mbuke.james@forbixattorneys.co.tz",
  "Name": "Mbuke James",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B5UudGdDIqtOVqy5NdEi"
 },
 {
  "Email": "tomasz.pleskot@linklaters.com",
  "Name": "Mr Tomasz Pleskot",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_LL.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B5cGRdzzrHCoX9Daw51b"
 },
 {
  "Email": "marten.amjarv@eversheds-sutherland.ee",
  "Name": "Marten Amj�rv",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B6ANDO3SqnqkcuCAUk6v"
 },
 {
  "Email": "wchipeta@hallmarkattorneys.com",
  "Name": "Walter B. Chipeta",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B6uzmZyzodVGTGqz0Jm6"
 },
 {
  "Email": "tigran@guardianpark.com",
  "Name": "Tigran Nahapetyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B7OrhMfxmtLAME6C7k9i"
 },
 {
  "Email": "crd@sany.com.cn",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B7imMvzPzWgxhi87bDjD"
 },
 {
  "Email": "ygur@stanford.edu",
  "Name": "Yonatan Gur",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B7utk8heRpdgYxEVpwoq"
 },
 {
  "Email": "daniel.tyrer@linklaters.com",
  "Name": "Daniel Tyrer",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/B9b7JeMhLgHL5VZqqbZm"
 },
 {
  "Email": "armen.ter-tachatyan@ter-tachatyan.am",
  "Name": "Armen Ter-Tachatyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BB14flCadkiakCIEGkQN"
 },
 {
  "Email": "avalencia@mef.gob.pe",
  "Name": "Mr. Alvaro Valencia",
  "Document Name": "PO1.BI 2020 PER_bi_PPP_survey_en (19.07.19).docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BCE8EXMqNFUxflEV0uGP"
 },
 {
  "Email": "Chamber@chamber.org.il",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BE6OlXcWggnHUSzjhU5M"
 },
 {
  "Email": "info@icccostarica.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BF5BZDr0wAfFc3vHb37D"
 },
 {
  "Email": "ochkin@mostpp.ru",
  "Name": "Vladimir Ochkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BFRa5jLjVPpahfb5gjdG"
 },
 {
  "Email": "info@twiveylaw.com.pg",
  "Name": "Tiffany Twivey Nonggorrr",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BGEY8zEYQoalZCjtxrZ5"
 },
 {
  "Email": "anatkl@gkh-law.com",
  "Name": "Anat Klein",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BGaoqjmekbWDfHq2henV"
 },
 {
  "Email": "BSPTonga@bsp.com.pg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BGhDqAPpwHr9HTC6SPG8"
 },
 {
  "Email": "clare.burgess@cliffordchance.com",
  "Name": "Clare Burgess",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BHVAC0Rmc7UDVfJWnYOG"
 },
 {
  "Email": "mahinda@varners.lk",
  "Name": "Mr. Mahinda Haradasa",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en_Varners.doc",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BJLRX9IHa6KEfTDYChLt"
 },
 {
  "Email": "ngaloadvocates@habari.co.tz",
  "Name": "Colman Mark Ngalo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BK3befz70SExwMFxaf9y"
 },
 {
  "Email": "m10donna@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BKUPakmvFfegIy8DnvO4"
 },
 {
  "Email": "karla.ressler@od-bsds.hr",
  "Name": "Karla Ressler",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BLA0tXrIdjUs3TzwWBRJ"
 },
 {
  "Email": "jeff.byme@ottawa.ca",
  "Name": "Jeff Bryne",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BMEh9vg3rUap8bBOXkUv"
 },
 {
  "Email": "sharif.fayez@ada.org.af",
  "Name": "Mohammad Sharif Fayez",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BMYiqTmYPbFYD0GPk09u"
 },
 {
  "Email": "ddodig@gmail.com",
  "Name": "Domagoj Dodig",
  "Document Name": "BI 2020 HRV_bi_PPP_survey_en.docx",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BOOzdaJ7zu7PyvtuP0FS"
 },
 {
  "Email": "francisco.cobo@mx.ey.com",
  "Name": "Mr. Francisco Cobo",
  "Document Name": "Ernst_&Young_BI 2020 MEX_bi_PPP_survey_en.docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BOaGmHGpEJLXgLeB13vd"
 },
 {
  "Email": "samakicheche@yahoo.com",
  "Name": "Hamisi Sama",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BOvIO1XAYjyJEtux8alo"
 },
 {
  "Email": "arodzianko@amcham.ru",
  "Name": "Alexis Rodzianko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BPMPKfuOBk9NWIZTaqea"
 },
 {
  "Email": "ofarid.amidkhonov@pamirenergy.com",
  "Name": "Ofarid Amidkhonov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BPmRAnDUu3u6dYXeUoZg"
 },
 {
  "Email": "lucas.oliver-frost@talaw.jp",
  "Name": "Lucas Oliver-Frost",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BPoXG4ucPO3fVXqQts8t"
 },
 {
  "Email": "ul.kadurugamuwa@fjgdesaram.com",
  "Name": "U.L. Kadurugamuwa",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BPq1vyoaubikl5StDOde"
 },
 {
  "Email": "dc.affarilegali@agenziaentrate.it",
  "Name": "title Laura Salvati",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_PO_Revenue_Agency.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BRyl6UTX9VAHIZYHhc3e"
 },
 {
  "Email": "jpgonzalez@esguerra.com",
  "Name": "Mr. Juan Pablo Gonz�lez Mej�a",
  "Document Name": "PPP.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BSOkGd8U3VSwNobKQdka"
 },
 {
  "Email": "blaz.mrva@mrva.si",
  "Name": "Mr. Bla� Mrva",
  "Document Name": "BI 2020 SVN_bi_PPP_survey_en_Blaz_Mrva.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BSR0pa5V6GrP6KQ3XERU"
 },
 {
  "Email": "simon.barrett@pillsburylaw.com",
  "Name": "Simon Barrett",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BTkDVDy13aY1EbNSDkkr"
 },
 {
  "Email": "dlin@milbank.com",
  "Name": "Daniel Lin",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BTrMGNhZ5YpvOrUfYuFz"
 },
 {
  "Email": "mali@ardeanattorneys.co.tz",
  "Name": "Gratian Mali",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BV6oWFoy2bK9NN3DmuyG"
 },
 {
  "Email": "russell.kawahara@aplaw.jp",
  "Name": "Russell Kawahara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BVE0hwfPttS3nYkxBMeR"
 },
 {
  "Email": "leonardo@ahlikiconstruction.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BVzWqPgNXwgHdS7zGaMp"
 },
 {
  "Email": "mcupit@uk.ey.com",
  "Name": "Michael Cupit",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BWJ9DUZCZbPWTpSQ5CfI"
 },
 {
  "Email": "anna.moodie@meredithconnell.co.nz",
  "Name": "Anna Moodie",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BWKeQ1rQdgTqXG9ngUTM"
 },
 {
  "Email": "wjung@yulchon.com",
  "Name": "Won Jung",
  "Document Name": "KOREA) KDI) BI 2020 KOR_bi_TPI_survey_en (HYK) 0821.docx",
  "Country": "KOR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BXP1r8YjA6AT4ELK1tbw"
 },
 {
  "Email": "saudi-bauer@saudibauer.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BXhDtBLmJ4hcsIa8oI6b"
 },
 {
  "Email": "alexmbikayi@cabemery.org",
  "Name": "Alex Mbikayi Muana Kalala",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BZbrsKQSqaHbnApJ94oE"
 },
 {
  "Email": "roman@armirac.hr",
  "Name": "Roman Simunovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BZsoE69jqsLpeiTRlUFF"
 },
 {
  "Email": "Thiagaraj.Pillay@westerncape.gov.za",
  "Name": "Mr Thiagaraj (Joey) Pillay",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_Western Cape Department of Transport and Public Works.doc",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BaLrouhg00u3qobkwOBJ"
 },
 {
  "Email": "lmtremblay@millerthomson.com",
  "Name": "Louis-Michel Tremblay",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BcJ96Tmeb7psOK2N8MEM"
 },
 {
  "Email": "o.aljuboori@bv.tu-muenchen.de",
  "Name": "Omar Aljuboori",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bdf4t348O1HkzX8YWgHR"
 },
 {
  "Email": "raullopez@lopezcastroyasociados.com",
  "Name": "Raul L�pez Rivera",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BdfPRB1PhIQfbgT7dOkw"
 },
 {
  "Email": "lhuman@deloittece.com",
  "Name": "Mr Larry Human",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en (FINAL)_Larry Human.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BdpegCVIcd0rFknNasIp"
 },
 {
  "Email": "info@moreraraabogados.com",
  "Name": "Carmen Calvo Monney",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bet9uDZ3uZ7TnzaKsxb4"
 },
 {
  "Email": "chumbot@huntonak.com",
  "Name": "Mr. Chumbot Plangtrakul",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BezMnndeQpi4YCWnoEPl"
 },
 {
  "Email": "j.reardon@tamimi.com",
  "Name": "Jonathan Reardon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bf7D9kGYNwQWHBYIYqVd"
 },
 {
  "Email": "steve.gallaugher@minterellison.co.nz",
  "Name": "Steve Gallaugher",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BfGYB9M8mfujdO4UpYHw"
 },
 {
  "Email": "pmattos@demarest.com.br",
  "Name": "Ms. Patrícia Mattos",
  "Document Name": "DEMAREST_SP-#10961845-v1-2019_08_02_BI_2020_BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BfaQw1t4rrDxAE4A8zA5"
 },
 {
  "Email": "kproudian@whitecase.com",
  "Name": "Kaya Proudian",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BiEc7JqPokIOyvcEgjBS"
 },
 {
  "Email": "raith.pickup@mills-reeve.com",
  "Name": "Raith Pickup",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bj2KOqxuZQsppHEefyQN"
 },
 {
  "Email": "etshidiata@cabemery.org",
  "Name": "Edmond Cibamba Diata",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BjD2owXYJBm8GsbpWuru"
 },
 {
  "Email": "Ciara.Kennedy-Loest@hoganlovells.com",
  "Name": "Ciara Kennedy Loest",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BjDrgqWeInzLz7zbYrdd"
 },
 {
  "Email": "klloyd@debevoise.com",
  "Name": "Kevin Lloyd",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BjmtTPHJ6GWva0p4nDbs"
 },
 {
  "Email": "thpillay@deloitte.co.za",
  "Name": "Thiru Pillay",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BkA9nu3aeUNDqp0uVL6E"
 },
 {
  "Email": "hussam@ghazzawilawfirm.com",
  "Name": "Hussam T Al Ghazzawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BkEF9ujMootWu1WgPone"
 },
 {
  "Email": "phonganh.hoang@dfdl.com",
  "Name": "Mr. Phong Anh Hoang",
  "Document Name": "VIETNAM) DFDL) BI 2020 VNM_bi_PPP_survey_en (02August19).docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bln4lJmRwa8sWFm1vujx"
 },
 {
  "Email": "naomi.king@shearman.com",
  "Name": "Naomi King",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bm2k6MM1XGHlgV3QEENL"
 },
 {
  "Email": "annika@alternalaw.ee",
  "Name": "Annika Vait",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BmFo9RWke7FGlSGeQCer"
 },
 {
  "Email": "sgalal@laliveinqatar.com",
  "Name": "Saoudy Galal",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BmeO1BI6dSlTWWPED6pJ"
 },
 {
  "Email": "hannes.vallikivi@derling.ee",
  "Name": "Hannes Vallikivi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BnxpRNK0BJpzzVklDEsR"
 },
 {
  "Email": "asharipov@gratanet.com",
  "Name": "Mr Atabek Sharipov",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_GRATA.docx",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BqvLusWnpDvSxcZvu88W"
 },
 {
  "Email": "cristinatorres@ulatina.edu.pa",
  "Name": "Crisitna Torres Ubill�s",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BrKiDnFwOeBzumDIWNen"
 },
 {
  "Email": "d.niazov@ndex-solutions.kg",
  "Name": "Daniyar Niyazov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BsHCfmEL4s6yCmlAOVdC"
 },
 {
  "Email": "florian.agnel@hoganlovells.com",
  "Name": "Florian Agnel",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BsQGtMvFG0A8BdtEP0zL"
 },
 {
  "Email": "zana.pijetlovic@pbz.hr",
  "Name": "Zana Pijetlovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bsby4iidwQkWo1TTWumR"
 },
 {
  "Email": "dmn@sam.sdu.dk",
  "Name": "Dan Bonde Nielsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bsf2RbAGgkuIcvc5aHT3"
 },
 {
  "Email": "crodas@carrizales.pe",
  "Name": "Ms. Cindy Rodas Correa",
  "Document Name": "Rev- Doc 2-Cuestionario Banco Mundial - Versión Integrada.docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BuG28GyN5gSxMq3EH4Uy"
 },
 {
  "Email": "gustavo.magalhaes@fialhosalles.com.br",
  "Name": "Dr. Gustavo Magalh�es",
  "Document Name": "2 BI 2020 BRA_bi_PPP_survey_en 2.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BvdNrKFTU479f3ZshfCP"
 },
 {
  "Email": "shantanu.Dutta@telfer.uOttawa.ca",
  "Name": "Shantanu Dutta",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Bw5bsHSlvL2VZrnMLktP"
 },
 {
  "Email": "DENMON.SIGLER@BAKERMCKENZIE.COM",
  "Name": "Denmon Sigler",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BwV8SnCM88ZcNSUQA3QA"
 },
 {
  "Email": "fui.tsikata@reindorfchambers.com",
  "Name": "Fui Tsikata",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/BxN0a3qmiHvgi8HNlplU"
 },
 {
  "Email": "andronikosn@sullcrom.com",
  "Name": "Nikolaos Andronikos",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C0EeBVmHVVpBBzZ1o2nf"
 },
 {
  "Email": "sportmoresby@westpac.com.au",
  "Name": "Leanne Kema",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C1qD0wkYdCAdLnbYReAn"
 },
 {
  "Email": "sbarbaran@beccarvarela.com",
  "Name": "Mr. Santiago José Barbarán",
  "Document Name": "BI 2020 ARG_bi_TPI_ en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C1wM6jwL3Q5asMu8S5NQ"
 },
 {
  "Email": "nina.pobric@fipa.gov.ba",
  "Name": "Ms. Nina Pobric",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_PO.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C24mgnTQKI9HhMxSrPRX"
 },
 {
  "Email": "ambeim@unisa.ac.za",
  "Name": "Intaher Ambe",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C26OIGvQ1aPaN9gIfkah"
 },
 {
  "Email": "camillo@giamundoneto.com.br",
  "Name": "Dr. Camillo Giamundo",
  "Document Name": "3 BI 2020 BRA_bi_PPP_survey_en.doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C27qJLY5w8O1JlqZAmM8"
 },
 {
  "Email": "nyeinchanzaw@lincolnmyanmar.com",
  "Name": "Mr. Nyein lChan Zaw",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en_Sebastian Pawlita.docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C2uxcbNccYyjcfsPA9f1"
 },
 {
  "Email": "office@ync.co.id",
  "Name": "Mrs., Ana Sofa Yuking",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_YNC Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C36xRFb8pxAYi4cMOjh7"
 },
 {
  "Email": "vanessa.bayliss@gleisslutz.com",
  "Name": "Vanessa Bayliss",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C3AbldHYi8aheDtBm1Qt"
 },
 {
  "Email": "ismail.askerov@mgb-law.com",
  "Name": "Mr. Ismail Askerov",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en.docx",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C5Hl1BUnGs6ZRGeaj4Sf"
 },
 {
  "Email": "marina.guledani@cfslegal.com",
  "Name": "Marina Guledani",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C5SDrQu8lI7z2ajDnbV9"
 },
 {
  "Email": "cameron.smith@ashurst.com",
  "Name": "Cameron Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C6iwOEcmgcLaVoT3YpYb"
 },
 {
  "Email": "yazeed.altoaimi@lfst.com",
  "Name": "Yazeed Al-Toaimi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C92PDZ1Zq7287OcU38s0"
 },
 {
  "Email": "vhintsov@deloittece.com",
  "Name": "Veiko Hintsov",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/C9KGA6S6f98nNoS5YUeg"
 },
 {
  "Email": "mperez@cxrgp.com",
  "Name": "Mr Manuel P�rez Aguilar",
  "Document Name": "BI 2020 GHA_bi_PPP_survey_en COMPLETED.docx",
  "Country": "GHA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CAAHFqZCayaTWpuBwQky"
 },
 {
  "Email": "achivale@mlc.co.mz",
  "Name": "Alexandre Chivale",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CAHX8LeEmrGUSFBhCicQ"
 },
 {
  "Email": "amartin@txbiz.org",
  "Name": "Amanda Martin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CBenRi8wtMD739PxjPwk"
 },
 {
  "Email": "mabood@fmm.com.pa",
  "Name": "Melissa Abood",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CCAi2uxuLTRXMqiK7CTi"
 },
 {
  "Email": "regina.fock@dlapiper.com",
  "Name": "Regina Fock",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CCXqmVOZWylI5xH9FqOZ"
 },
 {
  "Email": "George.pataki@nortonrosefulbright.com",
  "Name": "George Pataki",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CCgMCRKFDDCtDvSfL76J"
 },
 {
  "Email": "aalfozan@kpmg.com",
  "Name": "Abdullah Al Fozan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CChHD3tvEANBmkQj6fjL"
 },
 {
  "Email": "efayorsey@deloitte.com.gh",
  "Name": "Mrs Ellen Fayorsey",
  "Document Name": "BI 2020 GHA_bi_PPP_survey_en_Ellen Fayorsey.docx",
  "Country": "GHA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CCpKZXpImWBSD5dASg68"
 },
 {
  "Email": "muleadada03@gmail.com",
  "Name": "Muleta Debel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CEhfY12FExxG23Gn8bHY"
 },
 {
  "Email": "a.hasolli@kalo-attorneys.com",
  "Name": "Lawyer Ahmet Hasolli",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_KALO.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CEonrczUM2iHr2sXkVav"
 },
 {
  "Email": "cfowles@torys.com",
  "Name": "Christopher J. Fowles",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CEou1Xjt0WfboQ9Xhc3P"
 },
 {
  "Email": "yunfei.guo@hsf.com",
  "Name": "Ms Yunfei Guo",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en - HSF 24 July 2019.docx",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CFYqulJDqOrun50svlBP"
 },
 {
  "Email": "dar@dsouza.co.tz",
  "Name": "Zainab Lumato",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CFyN8TpyVKaJ9uRZGtal"
 },
 {
  "Email": "pmm@aamm.pt",
  "Name": "Dr. Paulo Marques",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en - AAMM 24.07.2019.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CGI1s9IQktHTYn6La7FM"
 },
 {
  "Email": "edmouradian@prudencelegal.com",
  "Name": "Edward A. Mouradian",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CGhEdjddfFiJHpwEZ47R"
 },
 {
  "Email": "hscott@milbank.com",
  "Name": "Henry Scott",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CGhQu99uWuxpF5qxm5i2"
 },
 {
  "Email": "cheemeng.tan@wongpartnership.com",
  "Name": "Chee Meng Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CGofTCJEXTH9DM391vMV"
 },
 {
  "Email": "siret@alternalaw.ee�",
  "Name": "Siret Siilbek",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CHltkvRuIp9kpJxKZxXJ"
 },
 {
  "Email": "raber@hfn.co.il",
  "Name": "Nir Raber",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CHukVlXd5104LvKlMmta"
 },
 {
  "Email": "dan.bodle@dentons.com",
  "Name": "Dan Bodle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CHviJ1bL5H3mIIxNz0jy"
 },
 {
  "Email": "lakiniulaw@gmail.com",
  "Name": "Laki Maile Niu",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CHwFCdkPxZtYunEAq34z"
 },
 {
  "Email": "mgutierrez@jata.mx",
  "Name": "Ms. Mayte Gutierrez Loera",
  "Document Name": "20190712 BI 2020 MEX_bi_TPI_survey_en.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CIB3mOUKhMwuvLUxrMne"
 },
 {
  "Email": "k.bosselmann@auckland.ac.nz",
  "Name": "Klaus Bosselmann",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CIS0sJHXwVqfhr4s6O6N"
 },
 {
  "Email": "info@tnklaw.co.za",
  "Name": "Bradley Ravens",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CIfKzHscoOjGCpf32fpD"
 },
 {
  "Email": "roxana.stoica@ionescumiron.com",
  "Name": "Ms Roxana Stoica",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Roxana Stoica.doc.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CJ24IDWSyqdMw3KPcljl"
 },
 {
  "Email": "dhillon@dhillonpartners.com.sg",
  "Name": "Sunil Singh Panoo",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CJiH10GFk1iyDdR2JqiY"
 },
 {
  "Email": "mcarter@chamber.ca",
  "Name": "Mary Anne Carter",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CKaHXK5ZtgiYmd8enX94"
 },
 {
  "Email": "josh.kaufman@cooley.com",
  "Name": "Josh Kaufman",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CKybPhKa5RCsyXnvetqJ"
 },
 {
  "Email": "cblo@duanemorrisselvam.com",
  "Name": "Mr. CN Bei Lo",
  "Document Name": "TPI_Myanmar (DMS 29072019).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CMrKG0KqXv9ShAcEERE2"
 },
 {
  "Email": "fvelasco@vsvlegal.com",
  "Name": "Attorney Fernando Velasco",
  "Document Name": "BI 2020 SLV_bi_TPI_survey_en (1). (2).docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CNdMhpV2XSJsf2IDBTFm"
 },
 {
  "Email": "ajith@asianpromoters.com",
  "Name": "Ajith Wattuhewa",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CNx4ywmHiKpq0OV6XRRl"
 },
 {
  "Email": "lbz@signumlaw.com",
  "Name": "Ms Liza Zhumakhmetova",
  "Document Name": "KAZAKHSTAN) SIGNUM) BI 2020 KAZ_bi_TPI_survey_en SIGNUM.docx",
  "Country": "KAZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CPYSqTZIt4VyPgtDiPH5"
 },
 {
  "Email": "tomislav.sadric@kps-law.com",
  "Name": "Tomislav Sadric",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CQNABIlsPw1bzR1myRWd"
 },
 {
  "Email": "gloria.roman@tz.pwc.com",
  "Name": "Gloria Roman",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CSstpB10hq5qcPkBMn2d"
 },
 {
  "Email": "thefirm@ccvlaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CUFRwFhlsuI6W4K4ksEF"
 },
 {
  "Email": "drmolokorg@mweb.co.za",
  "Name": "Moloko Gantsho",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CUyUo8uhOHAuttzlXp3w"
 },
 {
  "Email": "Ilan@hmlaw.co.il",
  "Name": "Ilan Winder",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CVsTByP5bZXWT3UwBqn0"
 },
 {
  "Email": "eugenia.ciganda@andersentaxlegal.uy",
  "Name": "Dra. Eugenia Ciganda",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en FedericoFormentoATLU.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CW87LoqSqZelA5LPLYTP"
 },
 {
  "Email": "info@homa-lawoffice.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CWhWNo4KDYbvziQSYOJ3"
 },
 {
  "Email": "oa@integrites.com",
  "Name": "Oleksandr Aleksyeyenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CXF2fMoYr42TPt4JkvOI"
 },
 {
  "Email": "Kane.Satterthwaite@beca.com",
  "Name": "Kane Satterthwaite",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CXI9XXPsb4L7J5HLBTrR"
 },
 {
  "Email": "a.kersting@baumeister.org",
  "Name": "Andreas Kersting",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CYaBn0XGmPbfu7QaeZVi"
 },
 {
  "Email": "mjema@dsouza.co.tz",
  "Name": "Jeremiah Mjema",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CZddHa2NNAAatZ7TH1CK"
 },
 {
  "Email": "srs83@georgetown.edu",
  "Name": "Steven Smith",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CZfR35WJtk8hG3fHc1J1"
 },
 {
  "Email": "andres.aavik@aaviklaw.ee",
  "Name": "Andres Aavik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cb6PLm3nooJ7nRIaKlM0"
 },
 {
  "Email": "ltufarelli@ristuf.it",
  "Name": "Mr. Luca Tufarelli",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_RandT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CbYbCGkwygoJkPtrKozV"
 },
 {
  "Email": "Mashael.AlShebaiky@ashlawksa.com",
  "Name": "Mashael Alshebaiky",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CbjHEkV851kbiqEZnnpN"
 },
 {
  "Email": "rbarreda@basham.com.mx",
  "Name": "title Rodolfo Barreda",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en Jserra.doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CcPWCePG3GNOWwrDiQLp"
 },
 {
  "Email": "kai.villmann@narlex.com",
  "Name": "Kai Villman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ce9evocRHOdHCiJYNEyh"
 },
 {
  "Email": "benyam@mehrteableul.com",
  "Name": "Benyam Tafesse",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CeI6xjkIClpMk8wS6LVF"
 },
 {
  "Email": "juri.sirel@sirel.com",
  "Name": "J�ri Sirel",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CesiWaWlaVwgApowWFLL"
 },
 {
  "Email": "yadahw@yahoo.com",
  "Name": "Yada Hashim Williams",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cf5cpddXXT4j0Z2sV6FA"
 },
 {
  "Email": "terence.seah@virtus-law.com",
  "Name": "Terence Seah",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cg4KfeuZoCwda8Ggxsdq"
 },
 {
  "Email": "jennifer.robinson@pinsentmasons.com",
  "Name": "Jennifer Robinson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CgSDFHSCW462w8EPfurB"
 },
 {
  "Email": "zakhem@zakhem.com.gh",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CgYHswBY7jknBlrvgxun"
 },
 {
  "Email": "alex.cook@cliffordchance.com",
  "Name": "Alex Cook",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CiSIKJ3M5yKMgznORdPK"
 },
 {
  "Email": "mofinance.ird@gmail.com",
  "Name": "title first name last name",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en-1(Planning).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CipV51WaXpoOQG2neRmU"
 },
 {
  "Email": "valeri.bendianishvili@lst.ge",
  "Name": "Valeri Bendianishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CjYpTsuoJjQniYgz2DXq"
 },
 {
  "Email": "ahmed.butt@simmons-simmons.com",
  "Name": "Ahmed Butt",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CjlrxCx3svK87ej6hLBx"
 },
 {
  "Email": "safecon@ethionet.et",
  "Name": "Tihitina Shigizaw Gebre",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CkR5Uktx7urWtfYFQ9SO"
 },
 {
  "Email": "info@proess.ug",
  "Name": "Micheal Daka",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ClOqCrx4xyjZFY10t8hL"
 },
 {
  "Email": "gerd.laub@sorainen.com",
  "Name": "Gerd Laud",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cm0hxHfQdgBUurAydYIg"
 },
 {
  "Email": "guy.david@gowlings.com",
  "Name": "Guy David",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CmQB2qq00vYoSwFHSbUz"
 },
 {
  "Email": "kkennedy@altra.com.py",
  "Name": "Ms Karin Kennedy",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en(1).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CmWf6OjCZsgJAsCvE5HL"
 },
 {
  "Email": "carlos.ayon@pachecocoto.com",
  "Name": "Carlos L Ayon",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cniy1mqA6Ex4GDwX03uO"
 },
 {
  "Email": "alexandru.aman@nndkp.ro",
  "Name": "Mr. Alexandru Aman",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en (ID 347900)_Nestor.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CoAPBuYRZM8riwqlyny2"
 },
 {
  "Email": "sshg@syciplaw.com",
  "Name": "Ms. Arlene M. Maneja",
  "Document Name": "BI 2020 PHL_bi_PPP_survey_en SyCipLaw_rev 20190902.docx",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CoHO90Fz1NH28iTFl3RZ"
 },
 {
  "Email": "anovales@novales.com.gt",
  "Name": "Alfonso Novales Aguirre",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CpIVf8IyHl7VkUsUM7ZI"
 },
 {
  "Email": "fobando@blplegal.com",
  "Name": "Mr. Francisco Obando",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CpbahcDycGzocjiPdZI7"
 },
 {
  "Email": "naif@saajlaw.com",
  "Name": "Naif Alsabhan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cpj46ueJp1u3ZXhdny7l"
 },
 {
  "Email": "paul.latto@cliffordchance.com",
  "Name": "Paul Latto",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cpuv0KTzGrd75yumlLeT"
 },
 {
  "Email": "jonathan@tadmor.com",
  "Name": "Jonathan Finklestone",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CqOa7Np3wyT9vPa1wwNR"
 },
 {
  "Email": "armelnet@gmail.com",
  "Name": "Evgeny Gladunchik",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cr0xNPbZWaeaLkJhRWhO"
 },
 {
  "Email": "counselling@unisa.ac.za",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cr6JiOfXIUWJQu63UeRO"
 },
 {
  "Email": "zawnaing650211@gmail.com",
  "Name": "Mr. Zaw Naing] [Assit to DG: Ms. Kyi Kyi Win, Director, Financial Regulatory Department, Ministry of Planning and Finance, kyi237@gmail.com +9567410153",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en (FRD).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CsB7DtuEovY2Mse0A0VH"
 },
 {
  "Email": "danialgo19@yahoo.com",
  "Name": "Daniel Alemu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CsEu2ZcuPlbaxj9B5NND"
 },
 {
  "Email": "campbellk@sullcrom.com",
  "Name": "Kathryn A. Campbell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CswFkr3zaodSg1TBlYPC"
 },
 {
  "Email": "brian.hackett@tt.pwc.com",
  "Name": "Brian Hackett",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CtDoQCtjJPwT1Tip7sD6"
 },
 {
  "Email": "admin@gestionaj.com",
  "Name": "Joel Mailloux",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CtLWdSDku62U53InNUnr"
 },
 {
  "Email": "p.shamte@crbafricalegal.com",
  "Name": "Pendo Marsha Shamte",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CtMOzjSmv7x93JeEYSn6"
 },
 {
  "Email": "somkiat@tdri.or.th",
  "Name": "Somkiat Tangkitvanich",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CuRXLnTww1bnoyo1gIlN"
 },
 {
  "Email": "nick.wall@allenovery.com",
  "Name": "Nick Wall",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CuyhJ7hY8PQMCgFPhNXZ"
 },
 {
  "Email": "kdeleva@gugushev.com",
  "Name": "Ms Kostadinka Deleva",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_Gugushev&Partners_adjusted..docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CvDzRe9TjQeawEiDiiO5"
 },
 {
  "Email": "rajar.miller@sirel.com",
  "Name": "Rajar Miller",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CwDkMKa2NOE8NMIxGSkF"
 },
 {
  "Email": "huw.jenkins@cliffordchance.com",
  "Name": "Huw Jenkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cwp8vl2lN9dakgvQh2a5"
 },
 {
  "Email": "oashuov@deloitte.kz",
  "Name": "Olzhas Ashuov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CwqmZfgil5aCQ0TKaNwt"
 },
 {
  "Email": "info@Arabic-Group.Net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CxZDSzxQ7MmVNekw6KuF"
 },
 {
  "Email": "pt.rishworth@auckland.ac.nz",
  "Name": "Paul Rishworth",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Cz9OuOrd5f730x42bpL8"
 },
 {
  "Email": "ssingh@jcscaribbeanlaw.com",
  "Name": "Stephen A. Singh (Fciarb)",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/CzusKp8Li4eMtrGPlpKV"
 },
 {
  "Email": "william.conway@skadden.com",
  "Name": "William Conway",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D0UPvSqwxqzMC3RwziwI"
 },
 {
  "Email": "along@meitar.com",
  "Name": "Alon Gellert",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D1r8MI3HKdePAWVvWvtY"
 },
 {
  "Email": "Mashael.AlShebaiky@ashlawksa.com",
  "Name": "Mashael Alshebaiky",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D1umoAKWJgkWl5swpFgr"
 },
 {
  "Email": "admin@koerner.co.th",
  "Name": "Frank Koerner",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D2Vthkoqb4GCbIrS9zQ8"
 },
 {
  "Email": "amos.khumalo@akinc.co.za",
  "Name": "Amos Sandile Khumalo",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D2wjZiAFjJZzro1Q3IL3"
 },
 {
  "Email": "Edward.Quinn@BBKLaw.com",
  "Name": "Edward Quinn, Jr.",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D34dqDIFTiUKQ8wDdSfc"
 },
 {
  "Email": "lucymafi@hotmail.com",
  "Name": "Lucy Mafia",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D37y5yLwB4die53aV9f6"
 },
 {
  "Email": "dkuatbekov@deloitte.kz",
  "Name": "Daulet Kuatbekov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D3GDHW9Fyo9Rc9mXHl43"
 },
 {
  "Email": "mdepalacio@s-s.mx",
  "Name": "title Mar�a De Palacio Cuetos",
  "Document Name": "S-S-#76697-v1-PPP_SURVEY_2020_wb.doc",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D3d9tbCQbRW0JagJJrPa"
 },
 {
  "Email": "youngtaekim@uos.ac.kr",
  "Name": "Youngtae Kim",
  "Document Name": "-",
  "Country": "KOR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D4RHbbmGatR4berKf7Oz"
 },
 {
  "Email": "Arik.Leibovitz@moital.gov.il",
  "Name": "Arik Leibovitz",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D4jHX3KcmKaPD4g6qmbw"
 },
 {
  "Email": "Info@bufetecandanedo.com",
  "Name": "Litzka Rodriguez",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D5COaXNjlCzbaZ3OZAfs"
 },
 {
  "Email": "farida.elbakry@shalakany.com",
  "Name": "Ms. Farida El-Bakry",
  "Document Name": "BI 2020 EGY_bi_PPP_survey_en_Shalakany.doc",
  "Country": "EGY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D5uAebgsSg0BozhLYxH6"
 },
 {
  "Email": "david.haigh@wynnwilliams.co.nz",
  "Name": "David Haigh",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D5wnYSl1CrYQSnXP3qcf"
 },
 {
  "Email": "nyshalev@gmail.com",
  "Name": "Gabriela Shalev",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D7SWgOAW0rhA5dngDYtk"
 },
 {
  "Email": "aborisoff@milbank.com",
  "Name": "Alexander Borisoff",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D7clBrEDcNo87tlBWf6h"
 },
 {
  "Email": "ascavone@whitecase.com",
  "Name": "Art Scavone",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D7cucEe0PU84ozT0EXE4"
 },
 {
  "Email": "dhk@zamnet.zm",
  "Name": "Chewe Bwalya",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D7weRf7znOLorJbgR6Ty"
 },
 {
  "Email": "pkarekezi@gibbinternational.com",
  "Name": "Mr.",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en_completed by P Karekezi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/D8x5na4W6AC61kIgGu1q"
 },
 {
  "Email": "peter.braun@dentons.com",
  "Name": "Peter Braun",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DAQTqNARPcjgUWkW2Nt1"
 },
 {
  "Email": "kthomassin@mccarthy.ca",
  "Name": "Kim Thomassin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DAy104PYi7RoBgjKfmqZ"
 },
 {
  "Email": "Leon.Glikman@glikmanalvin.ee",
  "Name": "Leon Glikman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DC0e7uKxvsvdAPIhYXGq"
 },
 {
  "Email": "emontoya@lexincorp.com",
  "Name": "Edvin Oswaldo Montoya Berganza",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DC6sTSgwNDmyQOEPQ8o7"
 },
 {
  "Email": "erlich@hfn.co.il",
  "Name": "Tuvia Erlich",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DD88IuHOxdrvDFPieWNv"
 },
 {
  "Email": "giedre.dailidenaite@primus.legal",
  "Name": "Giedre Dailidenaite",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DDKhXBvSyDAijHQjUnq7"
 },
 {
  "Email": "eld@gebranmajdalany.com",
  "Name": "Gebran N. Majdalany",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DDXnsalW9FLokNSHvQcY"
 },
 {
  "Email": "Dsanders@blg.com",
  "Name": "Douglas Sanders",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DEk8qVJyGfqv08XPPIeS"
 },
 {
  "Email": "rosemary.jago@bevanbrittan.com",
  "Name": "Rosemary Jago",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DFoXutZN7haCyBA7urVX"
 },
 {
  "Email": "lerato@dm5.co.za",
  "Name": "Lerato Mathopo",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DFsJyyfqDUJYZSkJvTxD"
 },
 {
  "Email": "edwardhigenyi@yahoo.com",
  "Name": "Edward Higenyi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DHB1RfnB4N7YBs7RYgyn"
 },
 {
  "Email": "meinrad@dsouza.co.tz",
  "Name": "Meinrad D'Souza",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DHRp68cEGcCIqtae5RGd"
 },
 {
  "Email": "roshani.kobbekaduwa@fjgdesaram.com",
  "Name": "Roshani Kobbekaduwa",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DIAIajCWOEQio4NUXALm"
 },
 {
  "Email": "gerard@modernelectricaltt.com",
  "Name": "Geraad Moreau",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DIz9QnTuOGgwBg7SVyW8"
 },
 {
  "Email": "angelika.yakhneva@dlapiper.com",
  "Name": "Angelika Yakhneva",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DIz9rRNcpnXB43jlOXLT"
 },
 {
  "Email": "tim.weston@klgates.com",
  "Name": "Timothy Weston",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DJCxxN5FAmqS0ZNrHCEX"
 },
 {
  "Email": "solomongedamu2008@gmail.com",
  "Name": "Solomon Gedamu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DJTJKrqCu4m3jOin370T"
 },
 {
  "Email": "rashid2328@mail.ru",
  "Name": "Abdurashid Abdurozokov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DJgEXgVUrphKD86hPNNC"
 },
 {
  "Email": "ggalante@galantemartins.com",
  "Name": "Dra Giorgina Galante",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DKK3jk9b82RVAjhv9JRF"
 },
 {
  "Email": "ablanco@arturoblancolaw.com",
  "Name": "Arturo Blanco",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DKxLgMe7RBUAUxwZFHr9"
 },
 {
  "Email": "frank.thomas@klgates.com",
  "Name": "Frank Thomas",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DLA5UAnNBFU6dkasmdrP"
 },
 {
  "Email": "center4invest@tse.com.er",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DLHxBeNeHEXOePACB1mu"
 },
 {
  "Email": "ott@leno.ee",
  "Name": "Ott Lepmets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DMUo53naz3fXX70JTZeR"
 },
 {
  "Email": "tomasz.zalewski@twobirds.com",
  "Name": "Mr Tomasz Zalewski",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_Bird&Bird.DOCX",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DMs2R2ICOpps77nRZ2LW"
 },
 {
  "Email": "nicheconsulting2011@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DNlC2u1W4tBGmDH6I6TF"
 },
 {
  "Email": "info@ardeanattorneys.co.tz",
  "Name": "Wambura Mkono",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DO3bx9YZfl7bgndPLjah"
 },
 {
  "Email": "Kristian.Wolf@germany.org.au",
  "Name": "Kristian Wolf",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DPJXsvJGkFO0Zu6zdiOQ"
 },
 {
  "Email": "sharadsomani@kpmg.com.sg",
  "Name": "Mr Sharad Somani",
  "Document Name": "SINGAPORE) KPMG) BI 2020 SGP_bi_PPP_survey_en KPMG.docx",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DPRLLDtQ0SKYWFpytSbT"
 },
 {
  "Email": "deverajp@yahoo.com",
  "Name": "J. Prospero E. De Vera Iii",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DQ2t5RJQwDAEQX6yDSeA"
 },
 {
  "Email": "esinare@rexcl.com�",
  "Name": "Eve Hawa Sinare",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DQ4Ygn840hnukw0q2TgG"
 },
 {
  "Email": "info@dohanlawfirm.com",
  "Name": "Malik Dohan Al Hassan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DR0iac6jRa6QFJupVrEa"
 },
 {
  "Email": "elina.varendi@varul.com",
  "Name": "Elina Varendi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DRWlf49o4XGkt8S8qZ97"
 },
 {
  "Email": "mohammed.bilal@sa.ey.com",
  "Name": "Bilal Mohammed Akram",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DRbBnBxbbbGVXEAvAnWS"
 },
 {
  "Email": "info@globcorp.net",
  "Name": "Maricarmen Plata",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DSZu2G8c7i9x7QufCG8D"
 },
 {
  "Email": "schwarze@gps-logistics.com",
  "Name": "Manfred Schwarze",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DSs1o2L8cwLHDYezVGMJ"
 },
 {
  "Email": "oppen@greenfort.de",
  "Name": "Andreas von Oppen",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DUMH4lfVmQZQE4giI1gu"
 },
 {
  "Email": "reimo.hammerberg@sorainen.com",
  "Name": "Reimo Hammerberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DVoz3Wkv6BtFHSGyaFIT"
 },
 {
  "Email": "joseph.tato@dlapiper.com",
  "Name": "Joseph Tato",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DVv9h07yrXIa1IUmz5zM"
 },
 {
  "Email": "mina.sreckovic@karanovicpartners.com",
  "Name": "Ms. Mina Sreckovic",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_Karanovic & Partners.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DW9pPewpNjaId8FjRahZ"
 },
 {
  "Email": "sandra@leedsareachamber.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DWjwUXxAgJoILY0rjbde"
 },
 {
  "Email": "karo.lelai@nortonrosefulbright.com",
  "Name": "Karo Lelai",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DY8f0DSkyDC5T93GcELT"
 },
 {
  "Email": "ascott@milbank.com",
  "Name": "Anthony Scott",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DZSIk96d8zJ9QWaU2dFi"
 },
 {
  "Email": "chrisnaziris@mkklaw.net",
  "Name": "Mr Chris Naziris",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_MKK Law.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DZWWD7m79jA89Vs4NhP2"
 },
 {
  "Email": "lnasry@tiruchelvam.com",
  "Name": "Laila Nasry",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DbW86AiBTTpIuPSkh1vS"
 },
 {
  "Email": "lexonandlords@gmail.com",
  "Name": "Manuel Theu",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dbu11GBHzZMADYO2BOgh"
 },
 {
  "Email": "raymond.mbilinyi@gmail.com",
  "Name": "Raymond Mbilinyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dd0bt9O5ijICVkTiQJjs"
 },
 {
  "Email": "ykifle@ethioconference.com",
  "Name": "Yohannes Kifle Daddi",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DeaLOxAqHcuGiN7iyVzg"
 },
 {
  "Email": "emaratova@gratanet.com",
  "Name": "Ms Elvira Maratova",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_GRATA.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DfCP3uLEuXU1dA8CrQm7"
 },
 {
  "Email": "zuki@znlaw.co.za",
  "Name": "Zukiswa Ntlangula",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DfObCp7X0PFu6GZHcAkx"
 },
 {
  "Email": "fmvaihu@gmail.com",
  "Name": "Fataimoemanu Lafaele Vaihu",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DfgEgNDTaCRHF0uVIC1S"
 },
 {
  "Email": "pardini@padela.com",
  "Name": "Juan Francisco Pardini",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DiXBEjQhpPJbLMt9HirC"
 },
 {
  "Email": "wchang@omm.com",
  "Name": "Winston Chang",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DicLZBb9g2R9aK6zsjIi"
 },
 {
  "Email": "kl@kemp-lauritzen.dk",
  "Name": "Thomas Christensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DicTBZ7AVwlZhbVj9VlT"
 },
 {
  "Email": "bzimbler@morganlewis.com",
  "Name": "Brian Zimbler",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DjFwQRHqk2SuRtxMqihf"
 },
 {
  "Email": "maks_kobonbaev@yahoo.com",
  "Name": "Maksat Kobonbaev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DjcKnTKMaGMVBZPNHHr6"
 },
 {
  "Email": "cglaw@cagatlaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DkAFDabPH841BfU4woiK"
 },
 {
  "Email": "john.armour@law.ox.ac.uk",
  "Name": "John Armour",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DkFbCRO9VdTyceKhnwte"
 },
 {
  "Email": "neela@mnlaw.lk",
  "Name": "Kandiah Neelakandan",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dkqbt4BJJ43oWJb6uH5Z"
 },
 {
  "Email": "sharmakc@mopipi.ub.bw",
  "Name": "Keshav C. Sharma",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dkr257ViOJvQEqDCJWQo"
 },
 {
  "Email": "ekh@gorrissenfederspiel.com",
  "Name": "Erik Kj�r-Hansen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dky3rphA0ltCb1TeqRk9"
 },
 {
  "Email": "david.b@tilleke.com",
  "Name": "David Beckstead",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DlUVaFCxvGOQTGr3Pzby"
 },
 {
  "Email": "tonga@smec.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dmod6rb8upEZ6okGoB6T"
 },
 {
  "Email": "mark.williamson@dlapiper.com",
  "Name": "Mark Williamson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dn76ehuoFJXG1MDBpvhC"
 },
 {
  "Email": "rustagi@toyotatz.com",
  "Name": "Vinod Rustagi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DnUkw4Tc4Rln4JFy5NvU"
 },
 {
  "Email": "dave.wetherell@maynewetherell.com",
  "Name": "Dave Wetherell",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DoeSxflcVaMcJzwKmTgR"
 },
 {
  "Email": "mdicarlo@ristuf.it",
  "Name": "Mr Mario Di Carlo",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_RandT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DoelZS4dneSCXWCMZaVl"
 },
 {
  "Email": "ramon.morales@hn.pwc.com",
  "Name": "Ram�n Morales",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DoprC1QptvOw8sYhQvwv"
 },
 {
  "Email": "chamber@tpp.tj�",
  "Name": "Said Sharif",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dr7hmLjv4Nh4Aqjrg9j9"
 },
 {
  "Email": "kuthan@turhanlaw.com",
  "Name": "Kuthan Turhan",
  "Document Name": "TURKEY) YAZICI) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DrG5F3nNIDWvEEEMlD1M"
 },
 {
  "Email": "info@aja.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DshPRt66yFuICbzCN9Oq"
 },
 {
  "Email": "cwallace@txbiz.org",
  "Name": "Christopher Wallace",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DuPQwlfDZMM0DduWSMa7"
 },
 {
  "Email": "info@udbl.co.ug",
  "Name": "Patricia Adongo Ojangole Ojangole",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DuSlcH3qpXGGks9ETFKq"
 },
 {
  "Email": "ivana.cota@lbhlaw.com.br",
  "Name": "Ms. Ivana Cota",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en_vLBH.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dv7T498XZpdJVw5UZUqN"
 },
 {
  "Email": "n.daely@amoktarina.co",
  "Name": "Ms Nasfiahtul Istani Daely S.H",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Oktarina Counsellors.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DvXssXMLaC1UeafWeTmB"
 },
 {
  "Email": "Innerchambers001@yahoo.com",
  "Name": "Eke Ahmed Halloway",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DviuGGUwcsZMOBlXqtGQ"
 },
 {
  "Email": "andrew.monteith@minterellison.co.nz",
  "Name": "Andrew Monteith",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DvpxJgIL5stTIMLWs4w0"
 },
 {
  "Email": "ctlaw@sdnp.org.mw",
  "Name": "Mayer Chisana",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DvyGcgWVh7K0q1B3Pjlf"
 },
 {
  "Email": "martins.mezinskis@primus.legal",
  "Name": "Martins Mezinskis",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DwwhuAv3p4ZuUeMW36us"
 },
 {
  "Email": "sb@sb-lawyersweb.com",
  "Name": "Bader Behaishan Al- Busaies",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DxXm53sGN7PM3qHRbAFp"
 },
 {
  "Email": "sabina.orujova@dentons.com",
  "Name": "Ms. Sabina Orujova",
  "Document Name": "BI 2020 AZE_Dentons_bi_PPP_survey_en.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DyLZHBuUgxKAwxMofdBL"
 },
 {
  "Email": "leab.seng@dfdl.com",
  "Name": "Mr. Leab Seng",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en (27082019)_Leab Seng.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DyM0hHvOQArJPeJtSjk2"
 },
 {
  "Email": "cmc@cmcautomobiles.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DyPwCFzeFNkfI47tw3Jz"
 },
 {
  "Email": "jchanning@moralesybesa.cl",
  "Name": "Mr James Channing",
  "Document Name": "MYB-#387783-v1-World_Bank_TPI_Survey.DOCX",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DyemBAux96G3mb3WEMme"
 },
 {
  "Email": "david.hutton@bevanbrittan.com",
  "Name": "David Hutton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dyh0Z9Kb3RkhpA12M52H"
 },
 {
  "Email": "dandrade@iqsh.com.mx",
  "Name": "Dr, Diego Andrade-Max",
  "Document Name": "MEXICO) IBANEZ) World BI 2020 MEX_bi_TPI_survey_en (003).docx REV JMH DA 2.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Dz30GvK4uN9xrb9w9SX5"
 },
 {
  "Email": "m.kruc@schoenherr.eu",
  "Name": "Marko Kruc",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/DzORA4VascEsHNalAFjf"
 },
 {
  "Email": "bluna@ksa.mx",
  "Name": "Mr. Bernardo David Luna Gutierrez",
  "Document Name": "KSA BI_2020_MEX_bi_PPP_survey_en.DOC",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E1J2dXfp3MOurKIl7BPT"
 },
 {
  "Email": "ali.amadee@gowlings.com",
  "Name": "Ali Amadee",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E24gfdkzfNukSXuSO4Zt"
 },
 {
  "Email": "tembongulube@iconnect.zm",
  "Name": "Abel Tembo",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E2i80hN8KYm8ExPBhXzw"
 },
 {
  "Email": "mwk@mwklawyers.ws",
  "Name": "Tuatagaloa Wulf",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E2li3jaNYqhnG6xhaGt9"
 },
 {
  "Email": "macco@accu.or.ug",
  "Name": "Gloria Akisa Amaniyo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E2siXQbT4b6VBF8QldXd"
 },
 {
  "Email": "ymori@jonesday.com",
  "Name": "Yuichiro Mori",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E4YacvdzqaWSmkYLQOP8"
 },
 {
  "Email": "mark.butt@gsk.de",
  "Name": "Mark Butt",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E4fIxKSMHuFDWSAbxAfv"
 },
 {
  "Email": "jason.annibale@mcmillan.ca",
  "Name": "Jason J. Annibale",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E5NsTSFQ0gaAmSJgKS5R"
 },
 {
  "Email": "ebedard@fasken.com",
  "Name": "�ric B�dard",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E6NWWahdiOfRFGiPKOgE"
 },
 {
  "Email": "merlin.salvik@hedman.ee",
  "Name": "Merlin Salvik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E6OSyg4Ro7IbeW9RKiok"
 },
 {
  "Email": "dkdletsa@belonline.org",
  "Name": "Divine Kwaku Duwose Letsa",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E6PLQ3XMXeLuyzb1mzyU"
 },
 {
  "Email": "hco@andersen-partners.dk",
  "Name": "Hans-Christian Ohrt",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E6f9nHag2hKHiaGmIUxH"
 },
 {
  "Email": "ella.melany@dentons.com",
  "Name": "Mrs. Ella Melany",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Dentos.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E7VfUmifSptEOzsUUDOG"
 },
 {
  "Email": "hamish.mcardle@bakerbotts.com",
  "Name": "Hamish Mcardle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E7dYgljxGZsispWN00i2"
 },
 {
  "Email": "info@brc.capital",
  "Name": "Mark Weber",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E7yyXnZhiTzdJ49asyJ7"
 },
 {
  "Email": "gwatkins@porterhedges.com",
  "Name": "Gail Watkins",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/E8zfyxOttzickQZGchoS"
 },
 {
  "Email": "gmumladze@glcc.ge",
  "Name": "Grigol Mumladze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EAFa6nafKAoVY2ycLo2D"
 },
 {
  "Email": "matt.hughey@nortonrosefulbright.com",
  "Name": "Matthew Hughey",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EAJWeZsmkboboRS8FK9o"
 },
 {
  "Email": "aline@pladvogados.com.br",
  "Name": "Ms. Aline Lícia Klein",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en.doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EAvfrn1pWVcCUFLyO7m3"
 },
 {
  "Email": "phil.dreaver@plenarygroup.copm",
  "Name": "Phil Dreaver",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EBCFa4y43lDhmt8CSNVa"
 },
 {
  "Email": "nprior@deloitte.co.uk",
  "Name": "Nick Prior",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EBkAkhyL0SlL7meIlM5x"
 },
 {
  "Email": "dlevison@mofo.com",
  "Name": "Daniel P. Levison",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ECjQ0fbFMunc33eYor0h"
 },
 {
  "Email": "khenriquez@claro.cl",
  "Name": "Ms. Karina Henr�quez",
  "Document Name": "CHILE) CLARO N CIA) DOCS-#182036-v1-World_Bank_2020_PPP_Contracts_Questionnaire.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ED2Ke0SugMQIAdXZ8Tsl"
 },
 {
  "Email": "info@pasalic.ba",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EDrMUXFVP7tOG3W7biOq"
 },
 {
  "Email": "jaanus@pvesi.ee",
  "Name": "Jaanus Vent",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EEADHXfMFLhpxylHELCI"
 },
 {
  "Email": "iborman@winston.com",
  "Name": "Ian Borman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EEdhrEf0gjX57XA4TKcA"
 },
 {
  "Email": "saraf.intern@khossain.com",
  "Name": "Ms. Saraf Farhin Choudhury",
  "Document Name": "BANGLADESH) KAMAL) BI 2020 BGD_bi_PPP_survey_en_26 08 2019.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EG1D0pbM93fmIm0XcYQq"
 },
 {
  "Email": "g.khachatryan@avenueconsulting.am",
  "Name": "Georgi Khachatryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EHC2N4ujVpU19rxSnX9t"
 },
 {
  "Email": "a.abdurrahim@amoktarina.co",
  "Name": "Mr Aflah Abdurrahim S.H",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Oktarina Counsellors.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EHRYLt31kEpSPNAx9jnW"
 },
 {
  "Email": "hiroto.imai@hoganlovells.com",
  "Name": "Hiroto Imai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EHri7yA1nem2OhZQvvZG"
 },
 {
  "Email": "reem.alansari@qu.edu.qa",
  "Name": "Reem Al-Ansari",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EI0dKni8Bi2vBnsyhkir"
 },
 {
  "Email": "seng.chee.lee@sg.pwc.com",
  "Name": "Lee Seng Chee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EIdbsrs2zQI2Hccppa16"
 },
 {
  "Email": "daniel.roth@ca.ey.com",
  "Name": "Daniel Roth",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EJoDMGj9O42PMkMVta33"
 },
 {
  "Email": "phil.mcclure@infrastructure,gov.au",
  "Name": "Mr Phil McClure",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Australian Department of Infrastructure, Transport, Cities and Regional Development.docx",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EJscA7o8JtB4FOLybkN2"
 },
 {
  "Email": "zalqurashi@kau.edu.sa",
  "Name": "Zeyad Al Qurashi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EKDhea0HjKVm2Mt3i07O"
 },
 {
  "Email": "wangyushi@cpppc.org????",
  "Name": "Project Officer Yushi Wang",
  "Document Name": "BI 2020 CHN_bi_PPP_PO_survey_en_20190725-final.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ELJzUm6FPIrsj2Zb81uN"
 },
 {
  "Email": "julian.l.smith@ru.pwc.com",
  "Name": "Julian Smith",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ELLnpDNCZ54TuHwo0p5h"
 },
 {
  "Email": "rnsereko@governancesystemsug.org",
  "Name": "Rejab Nsereko",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EMGrt1znX44tWQrnGQrq"
 },
 {
  "Email": "twi@andersen-partners.dk",
  "Name": "Thilo Wind",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EMoNU7KodPA9OsJSw0Nz"
 },
 {
  "Email": "t.grigoryan@avenueconsulting.am",
  "Name": "Tigran Grigroyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ENW9MpGmAc3knAgfvQ7Y"
 },
 {
  "Email": "patrick@deale.co.za",
  "Name": "Patrick Deale",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ENuo2aHZYEvv11udEQAk"
 },
 {
  "Email": "melbourne@nevettford.com.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ENyOcqWIKl0T3f8e7ZHX"
 },
 {
  "Email": "kiranb@marquelawyers.com.au",
  "Name": "Kiran Bath",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EO3Yk4XzfnjFLl4UZWba"
 },
 {
  "Email": "stephen.murray@hsf.com",
  "Name": "Stephen Murray",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EP83ermnbf0FbaBdkGUU"
 },
 {
  "Email": "dimitri.papaefstratiou@dlapiper.com",
  "Name": "Dimitri Papaefstratiou",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ERU2a5Tn3dTnGtFc2sVf"
 },
 {
  "Email": "jayavadhb@ilct.co.th",
  "Name": "Jayavadh Bunnag",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ES8pp8y1mqTUCFdlSyjD"
 },
 {
  "Email": "ssantiago@nossaman.com",
  "Name": "Simon J. Santiago",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ESs6aKZSKZHSi4yscPMC"
 },
 {
  "Email": "t.rukhadze@gvinadzeandpartners.ge",
  "Name": "Tamara Rukhadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ETBZOeltguAjUH0P63qh"
 },
 {
  "Email": "fibemessie@ibtci.com",
  "Name": "Franklin Ibemessie",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EUfP9l1G6nuJp9l0zFLz"
 },
 {
  "Email": "cep@cepltd.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EUnQ9WNKBUJ7QJFxfkk8"
 },
 {
  "Email": "makcons@ud.co.tz",
  "Name": "M. Minja",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EV3178Y5r27NoYnnrbR9"
 },
 {
  "Email": "britta.oltjer@leadell.com",
  "Name": "Britta Oltjer",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EWbTBLjfd2CukrYzZvrr"
 },
 {
  "Email": "nperic@deloittece.com",
  "Name": "Nina Peric",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EWjx4Dumh6WhMwIwJJd3"
 },
 {
  "Email": "robert.dorion@gowlings.com",
  "Name": "Robert Dorion",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EX9ePKGZb0QhGIdFlTeo"
 },
 {
  "Email": "jabueva@yahoo.com",
  "Name": "Jose V. Abueva",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EXBvCD6D7WpJJnN41ipQ"
 },
 {
  "Email": "info@roselawcaribbean.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EXDVRnXwOITf6e0TBQta"
 },
 {
  "Email": "jgoodwin@calaw.co.nz",
  "Name": "Jeremy Goodwin",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EYWDe913i01XaW6L0xpQ"
 },
 {
  "Email": "sille.lehtsaar@magnussonlaw.com",
  "Name": "Sille Lehtsaar",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EZJTjToZK2ylj62ovQVB"
 },
 {
  "Email": "brian.mersereau@hillandknowlton.ca",
  "Name": "Brian Mersereau",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EaDzkpjQx7WD6s6oqiKl"
 },
 {
  "Email": "mail@adams.africa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EaJBJ0Lk8JdapYMaxdVb"
 },
 {
  "Email": "pmorris@pmg-tt.com",
  "Name": "Peter Morris",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EaixzFDSknwZfETIVsWE"
 },
 {
  "Email": "simon.courie@addleshawgoddard.com",
  "Name": "Simon Courie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ec1cWwnae6Pku3lokRGQ"
 },
 {
  "Email": "higo@blakemore.gr.jp",
  "Name": "Seishi Higo",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EefQf944WBrGwNx8bfl8"
 },
 {
  "Email": "zainab@sudathpereraassociates.com",
  "Name": "Zahrah Cader",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EfLnaypmyRqAgkIKxJI5"
 },
 {
  "Email": "stephanie.pearce@gowlings.com",
  "Name": "Stephanie Pearce",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Efk9MKfjzmzrHL8QegOj"
 },
 {
  "Email": "salger@salger.com",
  "Name": "Hanns-Christian Salger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Efk9cS9uPv3nrcDMh0Am"
 },
 {
  "Email": "javier.aguilar@ariaslaw.com",
  "Name": "Mr Javier Aguilar",
  "Document Name": "BI 2020 SLV_bi_TPI_survey_en.docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EfobCvTLd6HGYTCx3fDz"
 },
 {
  "Email": "janet.nsabata@ventus.co.zm",
  "Name": "Ms Janet Nsabata",
  "Document Name": "BI 2020 ZMB_bi_PPP_survey_en_VLP Ventus .docx",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EgblXn00v4slvusSmFkp"
 },
 {
  "Email": "ilustosa@ulhoacanto.com.br",
  "Name": "Ms. Isabel Lustosa",
  "Document Name": "PPP Consolidado 10.07.2019.DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EgxYiJFufMCfRbBp4nnm"
 },
 {
  "Email": "rodrigo.rocha@rodrigorochalaw.com",
  "Name": "Rodrigo Ferreira Rocha",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Eh53mO4ozzmX0js7Lch8"
 },
 {
  "Email": "kristjan@leno.ee",
  "Name": "Kristjan N�ges",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EhKSpy3oGpaGjwMMe2LP"
 },
 {
  "Email": "rene@lopezrodezno.com",
  "Name": "Ren� L�pez Rodezno",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ehu3zonB74aNbnWnfgb4"
 },
 {
  "Email": "info.krt@binsowaidan.ae",
  "Name": "Abdul Aziz Muhammed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ei3WUXFs6l3ND523IBr9"
 },
 {
  "Email": "keith.beattie@burges-salmon.com",
  "Name": "Keith Beattie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EiNY57dYJe5XZJFEucuk"
 },
 {
  "Email": "info@singoadvocates.co.tz",
  "Name": "Nesha Mringo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EiZ18wyj6O554zdTegDn"
 },
 {
  "Email": "nbuckworth@shearman.com",
  "Name": "Nicholas Buckworth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EkOxvhH4jdPXGvKZeRN4"
 },
 {
  "Email": "jedkee@gwu.edu",
  "Name": "James Edward Kee",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ekk5NG8yBOn8T6eQSkbQ"
 },
 {
  "Email": "mdavies@kslaw.com",
  "Name": "Mark Davies",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ElEKmUHRNULsT2hxROcW"
 },
 {
  "Email": "msaragoca@stoccheforbes.com.br",
  "Name": "Ms. Mariana Saragoça",
  "Document Name": "WB Concession.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EmGhIneYcWGuLo5eAEg4"
 },
 {
  "Email": "bozidar.milosevic@karanovicpartners.com",
  "Name": "Mr Bozidar Milosevic",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Ljupka.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EoaWqniAoEwAwKqOX8qS"
 },
 {
  "Email": "fso@civil.t.u-tokyo.ac.jp",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Eq51crEQDzwDwrOjwn4b"
 },
 {
  "Email": "caitora@mid.gov.sb",
  "Name": "Chrisanta Aitora",
  "Document Name": "BI 2020 SLB_bi_PPP_survey_en Dulcie Ausuta 15Jul19.docx",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Er82XGR1XgghuG5BAVaS"
 },
 {
  "Email": "bwinburne@orrick.com",
  "Name": "Blake Winburne",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ErBVFljLHl8naB9FZLOc"
 },
 {
  "Email": "a.tamimi@tamimi.com",
  "Name": "Abdullah Al Tamimi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EsMqaELVfxud6RGwx2ww"
 },
 {
  "Email": "sovetnik.minsk@gmail.com",
  "Name": "Mr. Ruslan Teodorovich",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_Teodorovich.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EucVzf7wXH8DKKH0YjRK"
 },
 {
  "Email": "maria.zagallo@utap.pt",
  "Name": "Ms. Maria Zagallo",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en_UTAP_final.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EutHyQQVmrwzYJYAZ3Nn"
 },
 {
  "Email": "info@joshobconstructiongh.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/EwX02Ky1tU7I9S2sPKMl"
 },
 {
  "Email": "john.inglis@shearman.com",
  "Name": "John Inglis",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ExEDAlkv0FSTvIADWfkj"
 },
 {
  "Email": "JMurphy@blg.com",
  "Name": "John Murphy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ExfTOvXxMadDCdtYn20h"
 },
 {
  "Email": "chris.andrew@allenovery.com",
  "Name": "Christopher Andrew",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ExhrSqxaJLXZhNtGE0qM"
 },
 {
  "Email": "temirlan.toguzbayev@centil.law",
  "Name": "Mr. Temirlan Toguzbayev",
  "Document Name": "BI 2020 KAZ_bi_PPP_survey_ENG (Centil Law - 300920019).docx",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ExsmBD9TllZK6xmybkEz"
 },
 {
  "Email": "qmbti@qmbti.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Eyh6BL4IlWYyFIjYE0UV"
 },
 {
  "Email": "bmhristovska@analyticamk.org",
  "Name": "Project manager Bojana Mijovic Hristovska",
  "Document Name": "BI_2020 MKD_bi_PPP_survey_en_Analytica.doc",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ezhks9GuIadln6936ia7"
 },
 {
  "Email": "eatkinson@torys.com",
  "Name": "Emily Atkinson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ezn0ksD6sh5peS37VA9N"
 },
 {
  "Email": "rkeenan@chadbourne.com",
  "Name": "Richard Keenan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F15EAbuHPueE6sIWmnIa"
 },
 {
  "Email": "rms@web.am",
  "Name": "Aragatsotn Marz",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1HkwYLiZkagRpn7LDz7"
 },
 {
  "Email": "mark.spivak@bakerbotts.com",
  "Name": "Mark Spivak",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1K4ec8wB4ywGhqVBWLl"
 },
 {
  "Email": "gabriel.alvarez@ariaslaw.com",
  "Name": "title Gabriel Alvarez",
  "Document Name": "071919 2020 NIC PPP Survey .docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1b14DHKriWaXCMOnggn"
 },
 {
  "Email": "maputo@jlaadvogados.com",
  "Name": "Edna Sacate",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1h3p9lYNgvNvZ9F1DCo"
 },
 {
  "Email": "t.maro@rexattorneys.co.tz�",
  "Name": "Tabitha Maro",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1rdRMtm56NRtGCDbBhm"
 },
 {
  "Email": "iain.duncan@simmons-simmons.com",
  "Name": "Iain Duncan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F1zCkuqfWIcJyS63NYWx"
 },
 {
  "Email": "nloizaga@ferrere.com",
  "Name": "Mr Nestor Loizaga",
  "Document Name": "World Bank - PPP Survey 2020 (Ferrere Comments July 15 2019) (ii)(925506.4).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F2QWlggqIBx1BWUXpup0"
 },
 {
  "Email": "yonatk@chamber.org.il",
  "Name": "Yonat Keren",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F2tCwxe1yZSogUGp7Cwt"
 },
 {
  "Email": "mark.hoskyns-abrahall@uk.pwc.com",
  "Name": "Mark Hoskyns-Abrahall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F3jnDnC9d7Ns7QFf1z47"
 },
 {
  "Email": "luiz.vieira@bicharalaw.com.br",
  "Name": "Dr. Luiz Henrique de Carvalho Vieria Gonçalves",
  "Document Name": "BICHARA - WBank - 2020 BRA - Concession Survey - V4 (final).docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F4IMOEyDLG7M0HIYy7RM"
 },
 {
  "Email": "pimlambert@gmail.com",
  "Name": "Patrick M. Lambert",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F4abzYXtuCTcnVlzNhCK"
 },
 {
  "Email": "edneuza.massingue@tta-advogados.com????",
  "Name": "Ms Edneuza Massingue",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en_TTA.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F4kPHqZ5rUpvmWqJsQmV"
 },
 {
  "Email": "email@ignis.co.za",
  "Name": "Trevor Williams",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F5Zax5UwNrvP2ZBke4ew"
 },
 {
  "Email": "katzked@biust.ac.bw",
  "Name": "Dawid Benjamin Katzke",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F6WZh1TkCzdO9ETGrG1l"
 },
 {
  "Email": "buengers@gps-logistics.com",
  "Name": "Aribert BUENGERS",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F7GrMIZU4JIEB4WrbGoo"
 },
 {
  "Email": "aa658@georgetown.edu",
  "Name": "Alexis Antoniades",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F7LMB1QijPWOfATtarHB"
 },
 {
  "Email": "colin.wilson@dlapiper.com",
  "Name": "Colin Wilson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F8t7zDpY9hJDS46RZcjR"
 },
 {
  "Email": "hambardzumyan@icloud.com",
  "Name": "Roman Hambardzumyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F90fvAt2xop4xtmHNDVl"
 },
 {
  "Email": "derrick.lusiba@pwc.com",
  "Name": "Mr Derrick Lusiba",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_PPP_survey_en 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F956p3y8muY46E7onAI3"
 },
 {
  "Email": "osmaelsr@hotmail.com",
  "Name": "Osama Elsir",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F9UDePYkGVPjUEFOOshT"
 },
 {
  "Email": "cs@ysu.am",
  "Name": "Vahram Dumanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/F9pQ9YAjuFcLnnCCjMDv"
 },
 {
  "Email": "mirghanishadia@yahoo.com",
  "Name": "Shadia Mirghani",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FAnwmpmlkpxhEo0SmkN3"
 },
 {
  "Email": "maks_kobonbaev@yahoo.com",
  "Name": "Maksat Kobonbaev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FBuu0tgRj9A7h40csg6t"
 },
 {
  "Email": "chona@areu.org.af",
  "Name": "Chona Echavez",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FBvccO11sSdR4VpT6MGi"
 },
 {
  "Email": "INFO@STANDARDINSGROUP.COM",
  "Name": "DR] AHMED SALAWUDEEN",
  "Document Name": "BI 2020 NGA_bi_PPP_survey_en Dr. Ahmed Salawudeen.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FCYxUq84kXOL20lifqBD"
 },
 {
  "Email": "arodzianko@amcham.ru",
  "Name": "Alexis Rodzianko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FD6RuTb4KpaMojA2mnpP"
 },
 {
  "Email": "raiko.paas@sirel.com",
  "Name": "Raiko Paas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FDBvFiboON65hU6l8FQt"
 },
 {
  "Email": "kati.miller@gencs.eu",
  "Name": "Kati Miller",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FDw7cunk4oS2JwStKVrZ"
 },
 {
  "Email": "hazim@almadanilaw.com",
  "Name": "Hazem Al Madani",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FE6Al465s4Dp0Pw1ArHG"
 },
 {
  "Email": "nkl@bruunhjejle.dk",
  "Name": "Nicolaj Kleist",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FEDC3beoHAyyvyzgerwW"
 },
 {
  "Email": "pmaugue@debevoise.com",
  "Name": "Pierre Maugue",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FEmzKKLFrP5Cww2OyTRw"
 },
 {
  "Email": "olavi-juri.luik@lextal.ee",
  "Name": "Olavi Juri",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FF0gM2paPjnObGHA3MCi"
 },
 {
  "Email": "mviera@opp.gub.uy",
  "Name": "Ms. Magdalena Viera",
  "Document Name": "BbI 2020 URY_bi_PPP_survey_en.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FFqvKG41i3OmbfPZD9sN"
 },
 {
  "Email": "cellina@udbs.udsm.ac.tz",
  "Name": "Marcellina Chijoriga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FGxWcadpbYFaImLM8r8P"
 },
 {
  "Email": "lilian.avila@garciabodan.com",
  "Name": "Lilian Graciela Avila Bier",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FIJHvs0EPzSaTNYeh2qn"
 },
 {
  "Email": "jmartin@claro.cl",
  "Name": "Mr. Jorge Mart�n",
  "Document Name": "CHL PPP Survey (2020)_.DOC",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FIZufGJMSZvhLR84KzN2"
 },
 {
  "Email": "sbarbosa@ulhoacanto.com.br",
  "Name": "Ms. Sofia Barbosa",
  "Document Name": "Concession Consolidado 10.07.2019 FINAL.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FKr41vNT6ZSOT2gqTuYS"
 },
 {
  "Email": "mark.walker@allenovery.com",
  "Name": "Mark Walker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FLL7HLHki2z3ISoQNAb9"
 },
 {
  "Email": "ross.howard@cliffordchance.com",
  "Name": "Ross Howard",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FLbmMqLkQvcV1TzXaA26"
 },
 {
  "Email": "arb@prcp.com.pe",
  "Name": "Mr. Alonso Rey",
  "Document Name": "BI_2020 PER_bi_PPP_survey_en_Payet - 4832-7662-0956 v. 5.doc",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FNur6FIFpFgfLQOIVl9t"
 },
 {
  "Email": "gavan.mackenzie@maddocks.com.au",
  "Name": "Gavan Mackenzie",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FOQAfG8GwxagUOngFw8n"
 },
 {
  "Email": "Navika_ast@list.ru",
  "Name": "????????? ?????? ?????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FOhuNzTVQoXKhRCBlYOL"
 },
 {
  "Email": "david_sjms@sltnet.lk",
  "Name": "Gerard David",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FPV0byfGFJ1taf08xucp"
 },
 {
  "Email": "helen.atkeson@hoganlovells.com",
  "Name": "Hellen Atkenson",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FPsxC0JZpr3F1y1dm5pB"
 },
 {
  "Email": "smilepac09@gmail.com",
  "Name": "Mr. Bereket Fesehatsion Tesfamarim",
  "Document Name": "ETHIOPIA) PLAN AND DEVELOPMENT COMMISSION) BI 2020 ETH_bi_TPI_survey_en-1.docx",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FQ9MJvwrl53NJL5JdsHw"
 },
 {
  "Email": "contactdubai@almcogroup.com",
  "Name": "Namir El Akabi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FRSILZRoenm6thU4Kyo4"
 },
 {
  "Email": "ceo@solomonchamber.com.sb",
  "Name": "Charles Persson",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FS0SnL7cfvmHL8K0c0WT"
 },
 {
  "Email": "farhang_taha@Yahoo.com",
  "Name": "Farhang Taha Rasool",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FSP3wM1r2pWKj4pU92sD"
 },
 {
  "Email": "kalecrestos@gmail.com",
  "Name": "Kalecrestos Getenet Tegegne",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FSzlwFbiqzGJd4amvoi8"
 },
 {
  "Email": "enquiries@co2balance.com",
  "Name": "Mark Simpson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FTZC8fJTPCRMoFS4JeEK"
 },
 {
  "Email": "rochagavia@claro.cl",
  "Name": "Mr. Rodrigo Ochagav�a",
  "Document Name": "CHL PPP Survey (2020)_.DOC",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FUZKNZTJafpsUsb9jxK3"
 },
 {
  "Email": "hirsch@mwp-berlin.de",
  "Name": "Veit Hirsch",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FVPs3pXAuWaWAxStuRKU"
 },
 {
  "Email": "mueller-wrede@mwp-berlin.de",
  "Name": "Malte M�ller-Wrede",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FVjKPlPIdbtJdPfpPzDG"
 },
 {
  "Email": "handerson@wslaw.co.uk",
  "Name": "Hazel Anderson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FVk7qwXe62sC8zlfu3X3"
 },
 {
  "Email": "elnur.aliyev@bhm.az",
  "Name": "Mr Elnur Aliyev",
  "Document Name": "BI 2020 AZE_bi_TPI_survey_en_BHM.doc",
  "Country": "AZE",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FW7zImFncFlSvYCDhKKC"
 },
 {
  "Email": "A.Ashraf@iccima.ir",
  "Name": "Alireza Ashraf",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FWUh7VwkotWuZWRErRWg"
 },
 {
  "Email": "larias@headrick.com.do",
  "Name": "Mr Luis Arias",
  "Document Name": "Survey World Bank - Benchmarking Infrastructure - Final (00780110xA22EA).DOCX",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FXWwON7GYQENgw8R99x2"
 },
 {
  "Email": "ayessimbekova@deloitte.kz",
  "Name": "Alua Yessimbekova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FXp1zuQoJqilRJxFx2Xy"
 },
 {
  "Email": "suetfern.lee@stamfordlaw.com.sg",
  "Name": "Suet-Fern Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FY2j9KWupuSzcRehSGEt"
 },
 {
  "Email": "ron.klein@hklaw.com",
  "Name": "Ronald J. Klein",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FYL0a0A28Dux2SYDCCWB"
 },
 {
  "Email": "jacqui.langley-white@addleshawgoddard.com",
  "Name": "Jacqui Langley-White",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FYMOj6aZ177RaT9ciCAd"
 },
 {
  "Email": "bethan.evans@bevanbrittan.com",
  "Name": "Bethan Evans",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FYrVTDGuhDMnjWJ5BlQB"
 },
 {
  "Email": "pavithra.navarathne@fjgdesaram.com",
  "Name": "Pavithra Navarathne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FZPhCT0Wrq15lMx4PHhH"
 },
 {
  "Email": "newcomer@gwu.edu",
  "Name": "Kathryn Newcomer",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FZUAx7f1smsKQvp5J1iH"
 },
 {
  "Email": "lawyers@pugnatorius.com",
  "Name": "Ulrich Eder",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FZwZ50SjdQbbSpSBorRt"
 },
 {
  "Email": "arevia@ppp.gov.ge",
  "Name": "Mr. Aleksandre Revia",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_PO_PPP Agency.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fb1w0b8jd65BsKFf5sW8"
 },
 {
  "Email": "nyao@tmi.gr.jp",
  "Name": "Noriko Yao",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fb2Q0DQ20t8Qt9PTFOx1"
 },
 {
  "Email": "ewohai@tsu.edu",
  "Name": "Andrew I. E. Ewoh",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FbX4VIGvl3pajt9AfpIp"
 },
 {
  "Email": "graeme.young@cms-cmck.com",
  "Name": "Graeme Young",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fbket1qqTDwplxh6SwwE"
 },
 {
  "Email": "susan.hankey@cms-cmck.com",
  "Name": "Susan Hankey",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FbwbE5m767THDOKte3aj"
 },
 {
  "Email": "llyimo@toyotatz.com",
  "Name": "Lightness Lyimo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FcQogqGwHISNQ1jKg6ob"
 },
 {
  "Email": "khalid.salman@saudibauer.com",
  "Name": "Khalid Salman",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Feii7FqUJKUnOnIp10XJ"
 },
 {
  "Email": "madis@lauspartners.ee",
  "Name": "Madis Kiisa",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FfYfOiA0RWxch9GousEh"
 },
 {
  "Email": "fmarais@glynmarais.co.za",
  "Name": "Francois Marais",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FgDeMTY3ylEFG4wtQ8gb"
 },
 {
  "Email": "teshomeg@tgmblawoffice.com",
  "Name": "Teshome Gabre-Mariam Bokan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fj4sQdOYHfsGPMH9uXFi"
 },
 {
  "Email": "toomas.kasesalu@primus.legal",
  "Name": "Toomas Kasesalu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fjh8SELxXApOGWnXVzUV"
 },
 {
  "Email": "gloria@melarayasociados.com",
  "Name": "Gloria Marina Sanchez Bonilla",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fjo6PBVBz2FlLerx0cQ4"
 },
 {
  "Email": "justin.tan@clydeco.com",
  "Name": "Justin Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FlWApk8R5PIPVvGtLrHV"
 },
 {
  "Email": "mail@lawpartnersvanuatu.com",
  "Name": "Vicki Joe",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Flhr4ImMaLhXQJrehqgg"
 },
 {
  "Email": "nawika@laopremier.com",
  "Name": "Ms. nawika charoenkitchatorn",
  "Document Name": "BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Flkp8cWfAyCb59SwdElr"
 },
 {
  "Email": "giovanni.muhammad@dentons.com",
  "Name": "Mr. Giovanni Mofsol Muhammad",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Dentos.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FmGub5aFbu4Balh0cRVg"
 },
 {
  "Email": "iub@university.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fn6Dhx55MbyUfy5Ey1hr"
 },
 {
  "Email": "abdulrahman.alayoni@lfst.com",
  "Name": "Abdulrahman Alayoni",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fn89qzpZrXvv3CZyRiPi"
 },
 {
  "Email": "igh@kpmg.co.za",
  "Name": "Tshidi Mokgabudi",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FnDg0N3AgR4M9EYMd4QZ"
 },
 {
  "Email": "g.nelson@tamimi.com",
  "Name": "Grahame Nelson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FnRlvSOSTT66cBir4iCk"
 },
 {
  "Email": "ahlersw@sullcrom.com",
  "Name": "Werner Ahlers",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fos4GPGGrGoD9zIQ1gpL"
 },
 {
  "Email": "marion.sahtel@varul.com",
  "Name": "Marion Sahtel",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fqi7PkXhB3OeYuEjIU0W"
 },
 {
  "Email": "emilie.halvorsen@dlapiper.com",
  "Name": "Emilie Agerbak Halvorsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FqvU4GXcBFqayAmRA6lb"
 },
 {
  "Email": "mbain@torys.com",
  "Name": "Mark W.S Bain",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fr8tBzG4ja1ve65TVT2G"
 },
 {
  "Email": "matteo.mariani@camic.cz",
  "Name": "Matthew Mariani",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FrJgCZy1Oq1s8rJbgFP6"
 },
 {
  "Email": "james.harris@hoganlovells.com",
  "Name": "James Harris",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fs4aCAChLfIvmKxDlhyr"
 },
 {
  "Email": "info@loria.info",
  "Name": "Federico R. Marten",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FskPMp4K7DqgTUeVdN7r"
 },
 {
  "Email": "jay.lemoine@nortonrosefulbright.com",
  "Name": "James Lemoine",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ft1Etm6aik5KXHGSY9zr"
 },
 {
  "Email": "ali.shahabi@atiehassociates.com",
  "Name": "Mr. Ali Shahabi",
  "Document Name": "IRAN) ATIEH ASSOCIATES) BI 2020 IRN_bi_PPP_survey_en.doc",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ftihvt1jQQmgU0lY9I38"
 },
 {
  "Email": "mohsin.iqbal@bakermckenzie.com",
  "Name": "Mohsin Iqbal",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FukohanAzdPDuQSecSlw"
 },
 {
  "Email": "tafyirga@yahoo.com",
  "Name": "Taffesse Yirga",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FvFg644CPDeXqe9bj70h"
 },
 {
  "Email": "sarun.kannitha@rajahtann.com",
  "Name": "Ms. Kannitha Sarun",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en - RTSH020919.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FwPH7FEwuwCMOTubNZyg"
 },
 {
  "Email": "moyoe@scanlen.co.zw",
  "Name": "Mr Evans Talent Moyo",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_Evans Talent Moyo.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FySnijIq4KRuT57jH6ZH"
 },
 {
  "Email": "shehara.gunasekara@fjgdesaram.com",
  "Name": "Shehara Gunasekara",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FyTVNxqU7Il0d5raxSuX"
 },
 {
  "Email": "imachitidze@ibsu.edu.ge",
  "Name": "Ivanna Machitidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fyl7n42vV0652ywn5biz"
 },
 {
  "Email": "dmitri.tsimpoaka@hedman.ee",
  "Name": "Dmitri Tsimpoaka",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fys8mbuKNyug5PNMB0iB"
 },
 {
  "Email": "clara@amchammyanmar.com",
  "Name": "Clara Tang",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Fz6DG4au9BvhGUTWLsYe"
 },
 {
  "Email": "pfo@plesner.com",
  "Name": "Mr. Peter Fogh",
  "Document Name": "DENMARK) PLESNER) World Bank 2020 PPP survey (2).docx",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/FzBpGPWl297N2NLBtkw1"
 },
 {
  "Email": "mgarza@jata.mx",
  "Name": "Mr. Mauricio Garza Bulnes",
  "Document Name": "20190712 BI 2020 MEX_bi_PPP_survey_en.docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G01FVvRJBPNWjA6lM2Wt"
 },
 {
  "Email": "chenge@immma.co.tz",
  "Name": "Madina Chenge",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G1Hkrj3PqJQgNm2b32cy"
 },
 {
  "Email": "George.Makharoblishvili@tsu.ge",
  "Name": "George Makharoblishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G2GJDUTmzmPdLi7ibCvI"
 },
 {
  "Email": "gavin.booth@kpmg.co.uk",
  "Name": "Gavin Booth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G358P3yExBQW4KJmi1D3"
 },
 {
  "Email": "ypustovit@abylaw.com",
  "Name": "Yuri Pustovit",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G4XvGqxvZ6CPwHhbuicg"
 },
 {
  "Email": "liads@adlaw.co.il",
  "Name": "Liad Sider",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G4qE2JpLzLwgKQ5La9Rl"
 },
 {
  "Email": "sales@toyotatz.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G4th0I95eDUkFroeieSA"
 },
 {
  "Email": "ian.gordon@cairnsslane.co.nz",
  "Name": "Ian Gordon",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G5FLXoDibxpAvMcuysCq"
 },
 {
  "Email": "lvelasquez@lq.com.pe",
  "Name": "Ms Leslie Vel�squez Gallo",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en 2.JorgedeLaCruz.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G5WW3u9zvbWKPOGOXaOm"
 },
 {
  "Email": "savrai@iran-attorney.com",
  "Name": "Parviz Savrai",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G7TmClODAqne9dgropYI"
 },
 {
  "Email": "info@greenstonegroup.co.nz",
  "Name": "Andrew Houghton",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G7liAtn7Sd3VU4sMDveA"
 },
 {
  "Email": "lawyers@solismedina.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G7n8gNBJbvNyEQGdxsxb"
 },
 {
  "Email": "rabee@ethionet.et",
  "Name": "Rahel Alemayehu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G7pAoeLTHjmA8PeJyvx9"
 },
 {
  "Email": "jurg.vandyk@cdhlegal.com",
  "Name": "Jurg Van Dyk",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/G9IpskD0GyjZNNWOiWOz"
 },
 {
  "Email": "kamanga.kapinga@mkono.com",
  "Name": "Kamanga Kapinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GA71KIQ6EdIwbqmO9WHK"
 },
 {
  "Email": "jan.endler@linklaters.com",
  "Name": "Jan Endler",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GBbqA4pStk76KzvsFQRx"
 },
 {
  "Email": "mgraffagna@mofo.com",
  "Name": "Michael C. Graffagna",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GDSRTxXLXJIwsttdJxJG"
 },
 {
  "Email": "hrandall@trowers.com",
  "Name": "Helen Randall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GDVUc9n8NqVmMaPmV8ko"
 },
 {
  "Email": "MASpenke@duanemorrisselvam.com",
  "Name": "Mr. MORITZ SPENKE",
  "Document Name": "PPP_Maynmar (DMS29072019).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GDWrmONTYZf9sbpLni6P"
 },
 {
  "Email": "jcurrie@mccarthy.ca",
  "Name": "John C. Currie",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GEFyyWE5aNTgKHLfQMLm"
 },
 {
  "Email": "wilson.mukebezi@beeakolaw.co.tz",
  "Name": "Wilson Mukebezi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GEUVZhzx348U56xX1nQh"
 },
 {
  "Email": "tato@ppi-ebrd-uncitral.com",
  "Name": "Tato Urjumelashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GEbDybSH8EJ4pG4Vqtyj"
 },
 {
  "Email": "carritola@fmm.com.pa",
  "Name": "Carla Arritola",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GEp0tRNj7VCwZTvqvLBG"
 },
 {
  "Email": "rburdick@akingump.com",
  "Name": "Rick Burdick",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GEwgJnrcoPdzf3IytXNj"
 },
 {
  "Email": "kateryna.soroka@dlapiper.com",
  "Name": "Ms Kateryna Soroka",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en DLA.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GFNyktSZ8nQyQhSMVcnb"
 },
 {
  "Email": "dinah@byenkyakihika.co.ug",
  "Name": "Ms Dinah Mukasa",
  "Document Name": "UGANDA) BYENKYA) BI 2020 UGA_bi_PPP_survey_en.docx BK comments and additions.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GFWvnq3s0GAhcePEsfSD"
 },
 {
  "Email": "agmakhalira@yahoo.co.uk",
  "Name": "Arthur Makhalira",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GGBg60IbQNmWYSzTVE9T"
 },
 {
  "Email": "anu.sander@varul.com",
  "Name": "Anu Sanders",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GGbsy00hA9eokhG9uuC3"
 },
 {
  "Email": "info@osmconsult.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GGyPuGSH4oipRgX7f4dT"
 },
 {
  "Email": "andreas.neun@gleisslutz.com",
  "Name": "Andreas Neun",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GH4Qh4GPHat6VvUxWE5p"
 },
 {
  "Email": "andrey.mironov@cmslegal.ru",
  "Name": "Mr Andrey Mironov",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_TPI_survey_en_CMS.DOCX",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GHB52wZDDubbHFmUJL2p"
 },
 {
  "Email": "fernando.loeser@lbhlaw.com.br",
  "Name": "Mr. Fernando Loeser",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en_vLBH.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GHBUAAtv7rwpSsg9cQj4"
 },
 {
  "Email": "info@chamberuganda.com",
  "Name": "Olive Z. Kigongo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GHtREs2fzUxRwOknpzEf"
 },
 {
  "Email": "Frank.Obermann@bblaw.com",
  "Name": "Frank Obermann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GISGDsJhQ2XvpLrgPL6z"
 },
 {
  "Email": "thomas.heijerman@cliffordchance.com",
  "Name": "Mr. Thomas Heijerman",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en 95064-3-7083 v0.4_Clifford Chance.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GJG0IR98LI01zGIFx4Ks"
 },
 {
  "Email": "michael.creedon@minterellison.com",
  "Name": "Michael Creedon",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GJiO5i3kHBvhBUo3Sz5S"
 },
 {
  "Email": "charbel.maakaron@squirepb.com",
  "Name": "Charbel M. Maakaron",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GJktrtSypxS96RR2Yer0"
 },
 {
  "Email": "jeb308@georgetown.edu",
  "Name": "John Buttarazzi",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GLGZR3GmZuluxh1ZZ7vT"
 },
 {
  "Email": "mdicks@deloitte.co.et",
  "Name": "Murray Dicks",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GO3BkGux1L9Mrd2imPra"
 },
 {
  "Email": "jgoldberg@porterhedges.com",
  "Name": "Joel Goldberg",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GObnOAlhlCUtIYfoWRFs"
 },
 {
  "Email": "V.Kilinkarov@maximalegal.ru",
  "Name": "Vladimir Kilinkarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GOySnU3adJaWI8PGgLql"
 },
 {
  "Email": "abdelmutalab@gmail.com",
  "Name": "Abelmutalab Adam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GPJQMCzcS24yU3IsAHpg"
 },
 {
  "Email": "shareef@gwlfs.com",
  "Name": "Abdullahi Shariff Omar",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GPm3b34YZp3vyXjDcdLI"
 },
 {
  "Email": "hvardanyan@kpmg.co.am",
  "Name": "Hovhannes Vardanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GQVI1bloms7H6gFCFcCX"
 },
 {
  "Email": "malammar@alammarlaw.com",
  "Name": "Mohammed Alammar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GQlvZMqzZFVfyPN4QsnO"
 },
 {
  "Email": "info@constructorakgk.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GR7FOJFUAWEU6UMQVIjm"
 },
 {
  "Email": "aa@pagbam.com",
  "Name": "Dr. Alan Arntsen",
  "Document Name": "World Bank- Concession survey (3).docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GSLOWnTHBvXG5CKAnJoD"
 },
 {
  "Email": "ebreyes@pecabar.ph",
  "Name": "Eleazar B. Reyes",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GSRdt9LFbuuFK8lCVFB5"
 },
 {
  "Email": "v.torossian@taalawfirm.com",
  "Name": "Mr. Vrej Torossian",
  "Document Name": "IRAN) TOROSSIAN) worldbank.docx",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GSbrDL6l74G3p5BVe1L8"
 },
 {
  "Email": "porteiro@abeledogottheil.com.ar",
  "Name": "Mr. Sergio Porteiro",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en.doc",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GT8QYLd09ZrOvwhixe7b"
 },
 {
  "Email": "mchaile@dbz.co.zm",
  "Name": "Mavis Chaile",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GTanYv6QjUyIz3KPBc1k"
 },
 {
  "Email": "manovelo@macesic.hr",
  "Name": "Ms Ivana Manovelo",
  "Document Name": "BI 2020 HRV_bi_PPP_survey_en_Macesicpartners_26 07 2019.docx",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GTmYEgJSjenIeBOaKOSA"
 },
 {
  "Email": "d.garrett@xtra.co.nz",
  "Name": "David Arthur Garret",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GU7xTxFFKxmvErC5AIuJ"
 },
 {
  "Email": "ekaterina.shapochka@ru.pwc.com",
  "Name": "Ekaterina Shapochka",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GU9MeFUDQHfPwNIxkyFM"
 },
 {
  "Email": "apanjshiri@a-acc.org",
  "Name": "Atiq Panjshiri",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GVOAJgJf8wXJbZf3orM5"
 },
 {
  "Email": "siosiua.utoikamanu@usp.ac.fj�",
  "Name": "Siosiua Utoikamanu",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GVPLckcqPlM5fQP0ylzR"
 },
 {
  "Email": "pwlee@smu.edu.sg",
  "Name": "Pey Woan Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GW0aqbPRLfygoPkXmIlf"
 },
 {
  "Email": "i.iyamu@abdulaitaiwo.com.ng",
  "Name": "Ms. Isoken Iyamu",
  "Document Name": "NIGERIA) TAIWO) BI 2020 NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GWhGPSK5OTbKaYfizlx2"
 },
 {
  "Email": "fadhili.lwendo@zenithattorneys.com",
  "Name": "Fadhili Nathan Lwendo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GYr4SRB63B0NZnPqkNqJ"
 },
 {
  "Email": "siiri.malmberg@hansalaw.ee",
  "Name": "Siiri Malmberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GZXSdtVX4lO3wRq2eZ22"
 },
 {
  "Email": "thaphanut@huntonak.com",
  "Name": "Mr. Thaphanut Vimolkej",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GZv8mHG4C3AYwniZgBSW"
 },
 {
  "Email": "anastasiia.zhebel@dlapiper.com",
  "Name": "Ms Anastasiia Zhebel",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_eng final_Soroka_Kateryna.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GZzPiKH5fqETLjPkWelT"
 },
 {
  "Email": "dvnikiforov@debevoise.com",
  "Name": "Dmitri Nikiforov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GaFHaiE7BIbLTFaiyvDv"
 },
 {
  "Email": "V.Bakshinskas@adm.gazprom.ru",
  "Name": "Vitautas Bashinskas",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GdHqLVCTEC7FwHfLc3m5"
 },
 {
  "Email": "diegoa@icazalaw.com",
  "Name": "Diego J. Alem�n",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GedRwmxVQbqwcEHrvyiP"
 },
 {
  "Email": "raisbeck@unimelb.edu.au",
  "Name": "Peter Raisbeck",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GfCIliNqNFAFcpmwDCSi"
 },
 {
  "Email": "ben.morton@dlapiper.com",
  "Name": "Ben Morton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GfVxQtePMfGh9w75CGT2"
 },
 {
  "Email": "JULIUS.CERVANTES@QUISUMBINGTORRES.COM",
  "Name": "Julius A. Cervantes",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Gfve30RbwxOnCL2xNGPa"
 },
 {
  "Email": "chall@wslaw.co.uk",
  "Name": "Colin Hall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GhEaaYu6NuMOOxWpmdyg"
 },
 {
  "Email": "magda@svanidzelawyers.com",
  "Name": "Magda Megrelidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GhKPnOMd59HHbJQ7i69L"
 },
 {
  "Email": "bill.holland@hobec.co.nz",
  "Name": "Bill Holland",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GhrMT2OIHhdE4cPiLJRS"
 },
 {
  "Email": "eweleong.lim@ah.co.nz",
  "Name": "Ewe Leong Lim",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GhytRyBECSFpAag1AM5j"
 },
 {
  "Email": "seh@bechbruun.com",
  "Name": "Simon Evers Kalsmose-Hjelmborg",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Gjg46LRYutccuyJPDIhv"
 },
 {
  "Email": "wilson.mukebezi@beeakolaw.co.tz",
  "Name": "Wilson Mukebezi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GjhMEttnQu9xA5BATpVr"
 },
 {
  "Email": "Joseph.Coomes@BBKLaw.com",
  "Name": "Joseph Coomes, Jr.",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GkCOooDJJ5ycQKEuPjUv"
 },
 {
  "Email": "tameratdelelegne@yahoo.com",
  "Name": "Tamerat Delelegne",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GknlhQSUUPhaVCkwfmRo"
 },
 {
  "Email": "raluca.marcu@bpv-grigorescu.com",
  "Name": "Mrs. Raluca Iulia Marcu",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GliEMFx3HROniIi6jH1x"
 },
 {
  "Email": "bhamae@law.co.za",
  "Name": "Azhar Bham Sc",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GljYcSm7G9GmNjcY2wqo"
 },
 {
  "Email": "slaven.dizdar@mariclaw.com",
  "Name": "Mr. Slaven Dizdar",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_Mariclaw.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Gm2TOhrAeEh6XT6mKhwX"
 },
 {
  "Email": "piibe.lehtsaar@sorainen.com",
  "Name": "Piibe Lehtsaar",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GmKOpTVubZGgA34nPw80"
 },
 {
  "Email": "sabina.saparova@centil.law",
  "Name": "?????? ????????",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_ru_Centil.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GneUfUbONoFDE6FlL4Hq"
 },
 {
  "Email": "philip.jeyaretnam@dentons.com",
  "Name": "Philip Jeyaretnam",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GngaTPHNQfzINi55P7II"
 },
 {
  "Email": "jjulien@mgdaly.com",
  "Name": "Jo-Anne Julien",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GpJ3SUVjS94ygwDLQcd5"
 },
 {
  "Email": "cbauer@pppcouncil.ca",
  "Name": "Christian Bauer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GpP16NIl9lgl4T3nDAnw"
 },
 {
  "Email": "aoruzbaev@gratanet.com",
  "Name": "Mr Aidar Oruzbaev",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_GRATA.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GppzlBgzQpCTGcYdXneh"
 },
 {
  "Email": "fmousavi@ut.ac.ir",
  "Name": "Mosavi S. Fazlollah",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GpyrWNNM6dHTTSQ7FBqs"
 },
 {
  "Email": "Keith-Hammond@DFOD.gov.uk",
  "Name": "Mr Keith Hammond",
  "Document Name": "BI 2020 SLE_bi_PPP_survey_en DFID SL.doc.docx",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GqYKDFsMvw98v69KQMzT"
 },
 {
  "Email": "stephen.jaggs@allenovery.com",
  "Name": "Stephen Jaggs",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GrItbn8uTiM92y8gIPbS"
 },
 {
  "Email": "noel@knightnknight.com",
  "Name": "Noel Chalamanda",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GrvoepS9ti7iHAiy9sGt"
 },
 {
  "Email": "reza.ahmadian@dlapiper.com",
  "Name": "Reza Ahmadian",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GsPABg5QMElwvuwV8Mqf"
 },
 {
  "Email": "mailethiopia@deloitte.co.et",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GtXynFkYj9YXVN0Bbdsw"
 },
 {
  "Email": "tblinfo@tudawe.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GuKNYOZNC7TLlk4u2H1w"
 },
 {
  "Email": "lawson@malawi.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GuYPHLCpCZQZUv7hh5YS"
 },
 {
  "Email": "sidhuco@yahoo.com",
  "Name": "Sidhu",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GumxTcynvq3ANb0Yia73"
 },
 {
  "Email": "roberto.morales@hn.pwc.com",
  "Name": "Roberto Morales",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GvZxm4Bjn8OSWIvETqUp"
 },
 {
  "Email": "lorraine.ball@allenovery.com",
  "Name": "Lorraine Bayliss",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GwmnPI41MjufFXbrcgK9"
 },
 {
  "Email": "info@rovanlaw.com",
  "Name": "Rovan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GwydZc8HTUUIyfGHXxQb"
 },
 {
  "Email": "gchaves@pdlawyers.net",
  "Name": "Gabriel Chaves Ledezma",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GxACJTUCq57bWZcgaHaK"
 },
 {
  "Email": "admin@tongachamber.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/GyNdxdBpPFAIeQ4j3c4j"
 },
 {
  "Email": "weiss@greenfort.de",
  "Name": "Gunther Weiss",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Gyitb6MljfhCSeSTt17Q"
 },
 {
  "Email": "lviner@torys.com",
  "Name": "Les M. Viner",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H0oactCR0u6AUKpRFw7U"
 },
 {
  "Email": "info@coastcolour.co.tz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H0xd8vbuq9wqsxZxx2ry"
 },
 {
  "Email": "dmitry.bokhan@verkhovodko.com",
  "Name": "Mr. Dmitry Bokhan",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_Verkhovodko and Partners.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H2rGAKt9b0Vp3K3XrXpL"
 },
 {
  "Email": "wolfram.krohn@dentons.com",
  "Name": "WOLFRAM KROHN",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H44f2jG2jpoRcsrhTUBM"
 },
 {
  "Email": "kazakhstan@colibrilaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H6FrTSpQZ7M9RDcdb2xA"
 },
 {
  "Email": "chong.boonleong@allenandgledhill.com",
  "Name": "Chong Boon Leong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H732lC8lWlCs7ORwZuYh"
 },
 {
  "Email": "info@nmmattorneys.info",
  "Name": "Godwin S Ngwilimi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H7thfR8KyDJ41deh2vK5"
 },
 {
  "Email": "reshedseid@yahoo.com",
  "Name": "Reshed Seid",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/H99yuTtbtAswbAmLZJqD"
 },
 {
  "Email": "rute.santos@cfa-lawfirm.com",
  "Name": "Dr Rute lSantos",
  "Document Name": "BI_2020_AGO_bi_PPP_survey_CFA.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HA6PCe4nddomWlOEh4rW"
 },
 {
  "Email": "Jr@university.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HAd0HYpes15vVQg9iCL3"
 },
 {
  "Email": "thiago.sombra@mattosfilho.com.br",
  "Name": "Mr. Thiago Sombra",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HAi7DGeqXYI4n0exLtaF"
 },
 {
  "Email": "bconway@uk.ey.com",
  "Name": "Bj�rn Conway",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HBjAEjLoTS9PMIR6Qvty"
 },
 {
  "Email": "rford@ncppp.org",
  "Name": "Randy Ford",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HDeErPYTERbCFMnaZDeJ"
 },
 {
  "Email": "ishara.madarasinghe@fjgdesaram.com",
  "Name": "Ishara Madarasinghe",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HEq3l1OInPeOVRVE0iFV"
 },
 {
  "Email": "jsuarez@gomezpinzon.com",
  "Name": "Mr Jose-Luis Suarez",
  "Document Name": "G.P. Infraestructura- Benchmarking infrastructure 2020 PPP.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HEywoQAC5IoTMnYie9b9"
 },
 {
  "Email": "info@comesaria.org",
  "Name": "Heba Salama",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HEzz4ZaJk8N4uy7iasDA"
 },
 {
  "Email": "gerhard@barnardinc.co.za",
  "Name": "Andries Gerhardus Truter",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HFCo1qQlSSqD0csm7S2k"
 },
 {
  "Email": "ANDREAS.SCHULZ@BAKERMCKENZIE.COM",
  "Name": "ANDREAS SCHULZ",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HFRJsozGWxM9i2kULIom"
 },
 {
  "Email": "abdulrahman.alayoni@lfst.com",
  "Name": "Abdulrahman Alayoni",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HFePjmZ7loidQCCg863J"
 },
 {
  "Email": "denise.hamer@dlapiper.com",
  "Name": "Denise R. Hamer",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HFyaTlNartHeuAh986SL"
 },
 {
  "Email": "hrcalo@punolaw.com",
  "Name": "Helena Rosales-Calo",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HGojigQ4KvxCWEMcQuLV"
 },
 {
  "Email": "irakli.gabisonia@mail.ru",
  "Name": "Irakli Gabisonia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HHiTjjhNxCrea64fUYdZ"
 },
 {
  "Email": "info@kone-areeco.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HJKmwbQi4LkboFffqld9"
 },
 {
  "Email": "rafia.rauf@riaabg.com",
  "Name": "Ms Rafia Khatri",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_RBG_Rehman.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HJV4yjS7ypfD9rwXMkWH"
 },
 {
  "Email": "domingodiaz@icazalaw.com",
  "Name": "Domingo A. Diaz De La Guardia",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HKrLRcXt8kNKk5MvnaE5"
 },
 {
  "Email": "sombhojen.limbu@ku.edu.np",
  "Name": "Sombhojen Limbu Sombhojen Limbu",
  "Document Name": "NEPAL) S.LIMBU) BI 2020 NPL_bi_PPP_survey_en.docx",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HLjsL6vsrjZJfKwknxua"
 },
 {
  "Email": "malin.dejounge@kkv.se",
  "Name": "Ms Malin de Jounge",
  "Document Name": "SWEDEN) COMPETITION AUTHORITY) BI 2020 SWE_bi_PPP_survey_en MDJ.docx",
  "Country": "SWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HLuVqSqtXoBpVozCkPoj"
 },
 {
  "Email": "sneceva@pepeljugoski.com.mk",
  "Name": "Ms Svetlana Necheva",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Pepeljugoski.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HMYPOAvAtv6SlEVlQOiw"
 },
 {
  "Email": "e.druzhinin@maximalegal.ru",
  "Name": "Evgeniy Druzhinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HMiKslUowm3w9E2fehpf"
 },
 {
  "Email": "sekaboyi@frosteeattorneys.co.tz",
  "Name": "Evarist Paul Sekaboyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HN2e75er1SsQB1y4fRZE"
 },
 {
  "Email": "geoffrey.white@cliffordchance.com",
  "Name": "Geoffrey White",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HO5YCZQCRjSmCsobpiqp"
 },
 {
  "Email": "jim-fingeroth@kekst.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HP2wUe6lcSzpg8wh0Aod"
 },
 {
  "Email": "tin.dolicki@odbd.hr",
  "Name": "Tin Dolicki",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HPe0LMOUsMKurFPU7m6H"
 },
 {
  "Email": "dalitso@knightnknight.com",
  "Name": "Dalitso Mtambo",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HPqAtsPjVaI6ncbLd6cA"
 },
 {
  "Email": "sjorge@cga.co.mz",
  "Name": "Mr. Sandro Jorge",
  "Document Name": "BI 2020 MOZ_bi_TPI_survey_en - CGA05092019.docx",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HPu4G5RiNiihnclxt1qe"
 },
 {
  "Email": "srandjelovic@kpmg.com",
  "Name": "Mr. Srdjan Randjelovic",
  "Document Name": "BI_2020 MKD_bi_PPP_survey_en_KPMG.DOC",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HQtaOMN0IopBFiExpUjy"
 },
 {
  "Email": "nanthini@touchwood.com",
  "Name": "Channa Abeygunawardene",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HReMVWYkx6A6ik9sVLKl"
 },
 {
  "Email": "Ficcbaghdad@hotmail.com",
  "Name": "Jaafar Al-Hamdani",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HRrhRGVJgOobqitOMdKe"
 },
 {
  "Email": "tsvyetkov@gestors.com.ua",
  "Name": "Mr Andriy Tsvyetkov",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_Attorneys' Association Gestors.doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HSPNsZsmrSO9RCuF3QjT"
 },
 {
  "Email": "gackerley@weirfoulds.com",
  "Name": "Glenn W. Ackerley",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HSQHBTHhFnpSNAhTcWNE"
 },
 {
  "Email": "abdulmajid.rizoev@gmail.com",
  "Name": "Abdulmachid Rizoev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HTaNWULuJaCdzRyucMpe"
 },
 {
  "Email": "kseidaliev@gratanet.com",
  "Name": "Mr. Kanat Seidaliev",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_GRATA Law Firm.docx",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HUfuhptOTjJkmTXig2xT"
 },
 {
  "Email": "admin@otf.org.au",
  "Name": "Steve Schmid",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HVJzEz7cFwH4LR3aS3Xp"
 },
 {
  "Email": "JKamau@httanzania.com",
  "Name": "James Kamau",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HVTQSihr6TtASCz0YZ4Y"
 },
 {
  "Email": "csb24@cam.ac.uk",
  "Name": "Catherine Barnard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HVvrl3SxcPen7LpZ9Kx4"
 },
 {
  "Email": "kateryna.soroka@dlapiper.com",
  "Name": "Ms Kateryna Soroka",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_eng final_Soroka_Kateryna.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HW62tZXa1QEVgDoZgkpz"
 },
 {
  "Email": "ilya.nikiforov@epam.ru",
  "Name": "Ilya Nikiforov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HWL8JJxzI0QtdA6USJMe"
 },
 {
  "Email": "eab@sudan-laws.com",
  "Name": "Eihab Babiker",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HWNj4dLrDi7DuHkUkQ57"
 },
 {
  "Email": "flago@camarco.org.ar",
  "Name": "Mr Fernando Lago",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HWRFodu8E7d3hSPBfP4Q"
 },
 {
  "Email": "domenic@rosenstocklegal.com",
  "Name": "Domenic Senger-Schenck",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HWbekbjVUD65dB2Znzod"
 },
 {
  "Email": "fernando.loeser@lbhlaw.com.br",
  "Name": "Mr. Fernando Loeser",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en_vLBH.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HX4AkfYUNZxK5Szgv4IM"
 },
 {
  "Email": "keith.g.robinson@tt.pwc.com",
  "Name": "Keith Robinson",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HXSnWFxOfQ6XN9rseTh1"
 },
 {
  "Email": "ochkin@mostpp.ru",
  "Name": "Vladimir Ochkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HXjyaRk90UE7JoL06HyR"
 },
 {
  "Email": "mmarshall@porterhedges.com",
  "Name": "Mac Marshall",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HYA6zVfshe84x8Patxsv"
 },
 {
  "Email": "julio.pohl@gufalaw.com",
  "Name": "Julio-Pohl Garcia-Prieto",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HYDjXiiZpxYtx3KxQ8UB"
 },
 {
  "Email": "kokpeng.tan@braddellbrothers.com",
  "Name": "Tan Kok Peng",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HYIuyugAwOCTDrVNbDFE"
 },
 {
  "Email": "encc@gemel.com.er",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HaYio0XVH0xOcrVjGpXS"
 },
 {
  "Email": "msosandi@cavendish.co.zm",
  "Name": "Moses Sosandi",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HbKDUOxBWyKlzK9BUQzq"
 },
 {
  "Email": "jto@lou.dk",
  "Name": "Jan Toft Olesen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HbVuf86gVX04EIqgfpL2"
 },
 {
  "Email": "kaspar.endrikson@sorainen.com",
  "Name": "Kasper Endrikson",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hbq8eLc1VEtjKjcwkhvm"
 },
 {
  "Email": "nihad.bajramovic@komorabih.ba",
  "Name": "Nihad Bajramovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HcYb1aBGl7eg8dAdW59h"
 },
 {
  "Email": "samuel.castro@mattosfilho.com.br",
  "Name": "Mr. Samuel Olavo Castro",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HdNfZIYp4tKyovQzsiRj"
 },
 {
  "Email": "adam.holloway@dlapiper.com",
  "Name": "Adam Holloway",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/He1CpBy8TQxlPYRl424F"
 },
 {
  "Email": "ravshan.adilov@centil.law",
  "Name": "Mr. Ravshan Adilov",
  "Document Name": "BI 2020 KAZ_bi_TPI_survey_en (Centil Law - 30092019).docx",
  "Country": "KAZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HeVSe9rdBoaal2MMUN6j"
 },
 {
  "Email": "schagoya@s-s.mx",
  "Name": "Dr. Sergio Chagoya D�az",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en (230719).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HeZValShNOlpccWw11I6"
 },
 {
  "Email": "goldenberge@bennettjones.com",
  "Name": "Edward S. Goldenberg",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hev4EHvLQv26RdtzAOls"
 },
 {
  "Email": "soren.klamer@dk.pwc.com",
  "Name": "S�ren Klamer",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HevfpvshwSXkxhe6RpNo"
 },
 {
  "Email": "bcm@info.bw",
  "Name": "Monty Mphathi",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HfWkDUu0ixQqAEADQNY0"
 },
 {
  "Email": "patrick.steinhausen@gleisslutz.com",
  "Name": "Patrick Steinhausen",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HfqNQSuMR9ygMq72flzi"
 },
 {
  "Email": "Kharutyunyan@edrc.am",
  "Name": "Karine Harutyunyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HgTefLtUPrOfqesJLGEu"
 },
 {
  "Email": "nick.stalbow@ashurst.com",
  "Name": "Nick Stalbow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hh7WF5QNPBnsEsBaBGVk"
 },
 {
  "Email": "david.blackburn@addisonslawyers.com.au",
  "Name": "David Blackburn",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HhB3IGO6szUGewlLqezI"
 },
 {
  "Email": "betinakalaja@gmail.com",
  "Name": "Betina Kalaja",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HhIvVVCAjYynC4N7mpDr"
 },
 {
  "Email": "manojbandara@sudathpereraassociates.com",
  "Name": "Manoj Bandara",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HhnDChAiFrB0bgzOQfhs"
 },
 {
  "Email": "jmhofilena@ateneo.edu",
  "Name": "Jose Maria G. Hofile�a",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hi6ZYucoIwhG2wa1bpWi"
 },
 {
  "Email": "info@boett.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HjCcAuFz8MmPxX9MJ2Jy"
 },
 {
  "Email": "krokowski@gps-logistics.com",
  "Name": "Wilfried KROKOWSKI",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HlKG22LGVjdHAUXBlZ3L"
 },
 {
  "Email": "info@bildtek.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HmPw8oJXY8PVHwJSkM98"
 },
 {
  "Email": "alcci@alcci.kz",
  "Name": "Muhtarhan Biyarov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HnoL1gLfyoc8Blvt84ZM"
 },
 {
  "Email": "info@alkheraiji.com",
  "Name": "Abdulaziz Al-Kheraiji",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HohgFFQrdCGqVaSdOGs6"
 },
 {
  "Email": "giorgio.telarico@bakermckenzie.com",
  "Name": "Mr Giorgio Telarico",
  "Document Name": "Italy TPI Survey for World Bank_Baker Mckenzie.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HowPhkIBspf6L5AZ6XHO"
 },
 {
  "Email": "mikk.lohmus@varul.com",
  "Name": "Mikk Lohmus",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hp5IGtSgdFdgX3SXyZWd"
 },
 {
  "Email": "stuart.mcintyre@bakerbotts.com",
  "Name": "Stuart Mcintyre",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HqVmBTpRJKjj3DE5lGPZ"
 },
 {
  "Email": "ismail.maraga@sa.pwc.com",
  "Name": "Ismail Maraqa",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HrE5qflAxm0CrI2s84wS"
 },
 {
  "Email": "serahks@gmail.com",
  "Name": "Serah Kias",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HrgXjoily7EyGVvkU5BV"
 },
 {
  "Email": "triin.valjaots@sorainen.com",
  "Name": "Triin Valjaots",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HrnggpGMotSKkYn7USPa"
 },
 {
  "Email": "tafyirga@yahoo.com",
  "Name": "Taffesse Yirga",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HsNqseD0EHZqgaovaGFa"
 },
 {
  "Email": "m3motino@yahoo.com",
  "Name": "Melvin Omar Motino",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HtpVEpeZFmpupoyXOmJ0"
 },
 {
  "Email": "chongboon@pkwalaw.com",
  "Name": "Chong Boon Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HuKsdipJbwEu63WdKq8P"
 },
 {
  "Email": "kramachandra@duanemorrisselvam.com",
  "Name": "Mr. KRISHNA RAMACHANDRA",
  "Document Name": "PPP_Maynmar (DMS29072019).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hv11vAbbkkjkc0lAdBh8"
 },
 {
  "Email": "makoto.terazaki@amt-law.com",
  "Name": "Mr. Makoto Terazaki",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en_AMT20190906.doc",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HvHjPixEKg8joX1AevdF"
 },
 {
  "Email": "z@lawyers.af",
  "Name": "Zmarak Zhouand",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Hw9qzxf82lSy56AkLB4q"
 },
 {
  "Email": "leroy.levy@squirepb.com",
  "Name": "Leroy Levy",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HxM6OMSoVxTQZHOZHJNT"
 },
 {
  "Email": "lmalicki@weirfoulds.com",
  "Name": "Linda Malicki",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HxhMUgUTfHdusgiHGhzQ"
 },
 {
  "Email": "anisa.kuqi@pwc.com",
  "Name": "Ms. Anisa Kuqi",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_en_PWC.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HynFwwclhseTcgBTIAE8"
 },
 {
  "Email": "marco.grossmann@ecos.ch",
  "Name": "Marco Grossmann",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HyvMTuG1fHedKvGIdRLy"
 },
 {
  "Email": "kalecrestos@gmail.com",
  "Name": "Kalecrestos Getenet Tegegne",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/HzvbF15JBnfHqAo5j4T5"
 },
 {
  "Email": "kfallas@camara-comercio.com",
  "Name": "Karol Estrada Fallas",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I02JFtmr59pGGYlrMQWE"
 },
 {
  "Email": "sille.allikmets@aaviklaw.ee",
  "Name": "Sille Allikmets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I0piqqkhPAQRYR9WLXtr"
 },
 {
  "Email": "eduardo.engel@yale.edu",
  "Name": "Eduardo Engel",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I2TVptt4YWS1xyP5M5Hi"
 },
 {
  "Email": "vako@osgf.ge",
  "Name": "Vakhtang (Vako) Natsvlishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I3Sh2BNh7vOZrcoEjthA"
 },
 {
  "Email": "veritas@clo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I491GE3EHmohxO2h1vmu"
 },
 {
  "Email": "mail@appro.org.af",
  "Name": "Saeed Parto",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I4OJ8uz91CoKGxx2PtuY"
 },
 {
  "Email": "admin@llaltd.com",
  "Name": "Margarita Leonard",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I66Gn4xN0y4tU7jJlVNg"
 },
 {
  "Email": "r.voss@lenz-johlen.de",
  "Name": "Rainer Vo�",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I7FKdOLDOfDlRUOAaJhw"
 },
 {
  "Email": "nhaffar@kpmg.com",
  "Name": "Nader Haffar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I7tvad43xCE3zh752lVn"
 },
 {
  "Email": "flago@camarco.org.ar",
  "Name": "Mr Fernando Lago",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I81K696FG9pRigE5zxXv"
 },
 {
  "Email": "imran.anwar@tanjibalam.com",
  "Name": "Mr. Imran Anwar",
  "Document Name": "BI 2020 BGD_bi_PPP_survey_en_Tanjib Alam and Associates.doc",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/I8Vix6VjqalkbWTb1Xg9"
 },
 {
  "Email": "marc.opitz@kapellmann.de",
  "Name": "Marc Opitz",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IA8mahDE9txPkFUBhCKT"
 },
 {
  "Email": "gabriele.radziute@ellex.lt",
  "Name": "Ms. Gabriel? Rad�i?t?",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en. FINAL.doc.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IAqb67U0AN12Tcya4NH7"
 },
 {
  "Email": "info@dc-ls.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IAtVUD6xdEDMs8E1hjSD"
 },
 {
  "Email": "kurmangazy.talzhanov@integrites.com",
  "Name": "Kurmangazy Talzhanov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IB1afudO1QsxP3LHMIla"
 },
 {
  "Email": "yazeed.altoaimi@lfst.com",
  "Name": "Yazeed Al-Toaimi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IBhsSBAmns2ezCIVAjid"
 },
 {
  "Email": "awt@legallex.net",
  "Name": "Wee Tiong Ang",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IBkcLW4JNEbYzFNRRoAi"
 },
 {
  "Email": "jennifer@exeterchamber.co.uk",
  "Name": "Jennifer Byrne",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IDudBMLnn5WxmRXYiaxD"
 },
 {
  "Email": "maarja-liisa.martis-lindeberg@lmp.ee",
  "Name": "Maarja Liisa",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IE2MCIH1pLsiwiOvkYFf"
 },
 {
  "Email": "jean@vdb-loi.com",
  "Name": "Ms. Jean Loi",
  "Document Name": "LAO) VDB-LOI) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IF5EznkE3YAdYOyJtgAP"
 },
 {
  "Email": "hcm@corderoabogados.com",
  "Name": "Hernan Cordero Maduro",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IF5bh4r01g2nhAUNo7VH"
 },
 {
  "Email": "cassam@cspabogados.com.ar",
  "Name": "Mr. Mario Eduardo Castro Sammartino",
  "Document Name": "BI 2020 ARG_bi_concession_survey_en.doc",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IFJyiy7az1MJEm0yEmHD"
 },
 {
  "Email": "klopatkina@morganlewis.com",
  "Name": "Kseniya Lopatkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IFKNUN12WrrGMhNqQ0G3"
 },
 {
  "Email": "kli@dbrs.com",
  "Name": "Kevin Li",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IFMOuRF9DmttOUfrEXcc"
 },
 {
  "Email": "Calvin.Walker@bakermckenzie.com",
  "Name": "Calvin Walker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IFRr8ts94JPKnDtXDNZM"
 },
 {
  "Email": "advokatsharipov@gmail.com",
  "Name": "Abduraxmon Sharipov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IGy8xMF5BUsljYODMprI"
 },
 {
  "Email": "jndazi@bhlawassociates.com",
  "Name": "Joseph Ndazi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IH03mfRyXWQFp7usrANN"
 },
 {
  "Email": "Macoduol.s@dalyinamdar.co.ke",
  "Name": "Mr. Samson Mac'Oduol",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en_DALY & INAMDAR.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IHfYMAeAKUpBL8LW2e69"
 },
 {
  "Email": "sngolding@kpmg.co.tt",
  "Name": "Stacy-Ann Golding",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IHl0iinzENo4UzbyfqVQ"
 },
 {
  "Email": "zoltan.mucsanyi@oppenheimlegal.com",
  "Name": "Dr. Zoltan Mucsanyi",
  "Document Name": "HUNGARY) OPPENHEIM) BI_2020_HUN_bi_PPP_survey_en_[2808620_v1.1].doc",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/II0mBlpKj5CHdg9dUA2E"
 },
 {
  "Email": "philip.abbott@fieldfisher.com",
  "Name": "Philip Abbott",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IIAqnA4nKShQGzdLIoZK"
 },
 {
  "Email": "oleg.khokhlov@gblplaw.com",
  "Name": "Oleg Khokhlov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IJKg7EW0hiwoSabydxkY"
 },
 {
  "Email": "hassan@watershedlegal.com",
  "Name": "Hassan Mohamed",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IKmafM6p9NJKVPwJdV6u"
 },
 {
  "Email": "Diana.Radu@bpv-grigorescu.com",
  "Name": "Attorney at Law Diana Radu",
  "Document Name": "ROM _bi_TPI_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ILc4vxLRB5GCgC6DoEdL"
 },
 {
  "Email": "dorothy.livingston@hsf.com",
  "Name": "Dorothy Livingston",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IMW4UCdjaNNWGWkSgI8n"
 },
 {
  "Email": "siemiatycki@geog.utoronto.ca",
  "Name": "Matti Siemiatycki",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IMk4XwKd2CvHf8Smwzeu"
 },
 {
  "Email": "maximilian.schiessl@hengeler.com",
  "Name": "MAXIMILIAN SCHIESSL",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IMv70AkEYB6hjFnZcJRJ"
 },
 {
  "Email": "andres.vinkel@narlex.com",
  "Name": "Andres Vinkell",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IN5SmAhj7YN4WUUUrWd9"
 },
 {
  "Email": "tferrer@dof.gov.ph",
  "Name": "Mr. Terence Ferrer",
  "Document Name": "BI 2020 PHL_bi_PPP_survey_en_Department of Finance.docx",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/INMdeXxcQrRQTz5VEgBI"
 },
 {
  "Email": "romel.s.castellanos@hn.pwc.com",
  "Name": "Romel Castellanos",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IP7RH2g68ps2isvFK4ER"
 },
 {
  "Email": "tam.billy@hotmail.com",
  "Name": "Mr. Billy Tam",
  "Document Name": "BI 2020_CHN_bi_PPP_survey_en 20190720 Billy Tam.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IPPO9u5Oz3qiXF2F1lru"
 },
 {
  "Email": "backmanp@bennettjones.com",
  "Name": "Phillip D. Backman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IQIMjHjhBdvaNCDVlolF"
 },
 {
  "Email": "info@cci.kg",
  "Name": "Marat Sharshekeev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IQK9GRFWYUK8yIwsgopq"
 },
 {
  "Email": "hudco@vanuatu.com.vu",
  "Name": "David Hudson",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IQTjeIbWLUPPGnGshDDV"
 },
 {
  "Email": "abaybabaev@lex.tj",
  "Name": "Ravshan Rashidov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IQaXhnEwiNvc77mOxLKY"
 },
 {
  "Email": "matilde.bonilla@usap.edu",
  "Name": "Matilde Bonilla",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IQphISZ3sRjt4ivhXse2"
 },
 {
  "Email": "Chris.Woodruff@mms.co.uk",
  "Name": "Chris Woodruff",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IRVHAWo5JdfaHQU8duFz"
 },
 {
  "Email": "cbeeny@kpmg.com.au",
  "Name": "Charlotte Beeny",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IRwqbJkeOwTjCUjMsuIL"
 },
 {
  "Email": "Jahangir@ut.ac.ir",
  "Name": "Jahangir Kiyamars",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ISAKF0wr6rVIcf81jR84"
 },
 {
  "Email": "andrew.wingfield@simmons-simmons.com",
  "Name": "Andrew Wingfield",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ISEKzntJFV3iLXtmtXbL"
 },
 {
  "Email": "wpigott@millerthomson.com",
  "Name": "William Bill Pigott",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IShUrRtIRG2zWUEXEVNt"
 },
 {
  "Email": "allanjluwagga@gmail.com",
  "Name": "Allan Luwagga",
  "Document Name": "UGANDA) ODERE) BI 2020 UGA_bi_PPP_Survey.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ISn8lRBCeORCCqrapZUR"
 },
 {
  "Email": "thasimoto@toledomarchetti.com.br",
  "Name": "title Thaisa lHasimoto",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ISyHk8fu9mCyGRzbTF3s"
 },
 {
  "Email": "tiina.pukk@lextal.ee",
  "Name": "Tiina Pukk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ITc8znGQOBBn6l6ZIkzq"
 },
 {
  "Email": "dporter@stikeman.com",
  "Name": "Dana Porter",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUcgHnCKcwbTmj9Zwciw"
 },
 {
  "Email": "alice.salumets@roedl.pro",
  "Name": "Alice Salumets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUgHGWKpraKkFTNdum41"
 },
 {
  "Email": "kpk@abmak.org",
  "Name": "Mr Kenneth Katusabe",
  "Document Name": "UGANDA) ABMAK) FINAL BI 2020 UGA_bi_TPI_survey_en.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUgQTXzHYJVgie4p6N7I"
 },
 {
  "Email": "hodham@gwlfs.com",
  "Name": "Hodhan Mohamud Ali",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUkwAlF3wqKecZ6bLi9r"
 },
 {
  "Email": "mbabajanyan@tk.partners",
  "Name": "Misak Babajanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUnyL1yXVH2ylJsev93G"
 },
 {
  "Email": "karenb@ameria.am",
  "Name": "Karen Babalyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IUyTqzmuTFYCpRSfaYyI"
 },
 {
  "Email": "mshamilova@lcg.tj",
  "Name": "Marina Shamilova",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IWJ05jPwj75fDOdJxrZS"
 },
 {
  "Email": "mperez@cxrgp.com",
  "Name": "Mr Manuel Pérez Aguilar",
  "Document Name": "BI 2020 GHA_bi_TPI_survey_en COMPLETED.docx",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IWJLCVaRO2D9JLWVvYSs"
 },
 {
  "Email": "attorneys@houylaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IWXRoOoSGMZmc5rEJQmQ"
 },
 {
  "Email": "Robert.Gray@cms-cmno.com",
  "Name": "Robert Gray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IWoNeGvQFQTbdnitMJLV"
 },
 {
  "Email": "emekataylor@yahoo.com",
  "Name": "Chukuemeka Cv Taylor",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IXiAphQVYHhO13bLiDzs"
 },
 {
  "Email": "kheriah.alsaeed@saudilegal.com",
  "Name": "Ms Kheriah Alsaeed",
  "Document Name": "BI 2020 SAU_bi_TPI_survey_en_Oct4_Kheriah_Abdulaziz_AlSaeed_Saudilegal.docx",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IXu96pMWis0CogLYcZ26"
 },
 {
  "Email": "djf@fitzwilliamstone.com",
  "Name": "Daniel Fitzwilliam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IYMjiQHlvuqH7HTjNmIF"
 },
 {
  "Email": "eaprescott@mgdaly.com",
  "Name": "Elton A. Prescott",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IaAeSEWbyFup3EQlmjd2"
 },
 {
  "Email": "nicholas.okafor@uubo.org",
  "Name": "Mr Nicholas Okafor",
  "Document Name": "NIGERIA) UUBO) BI 2020 NGA_bi_TPI_survey_en (UUBO Contribution) 15082019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IaWmr4n8PzTbEHUyPSUL"
 },
 {
  "Email": "feruz.fidaev@dlapiper.com",
  "Name": "Feruz Fidaev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IcC6fSCv6SuO2FEs8FIH"
 },
 {
  "Email": "mail@avaslaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IcOE8zWnqKrvPGbr6pvT"
 },
 {
  "Email": "ssjames@applebyglobal.com",
  "Name": "Stephen James",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IcVGYBYsZeEMMedDSG9g"
 },
 {
  "Email": "aberman@werksmans.com",
  "Name": "Astrid Berman",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IclVN1Wj6cvfj8DAhG0O"
 },
 {
  "Email": "paul.lalonde@dentons.com",
  "Name": "Paul M. Lalonde",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IeO59VmAdwuFEL6jNSm0"
 },
 {
  "Email": "pedro.castro@ldr.com.br",
  "Name": "Mr. Pedro Castro",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IenW2T4W3rF7bqjMWdb5"
 },
 {
  "Email": "tcdsco@ethionet.et",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IeqXgXPwfrzeKYIBHxip"
 },
 {
  "Email": "rrees@trowers.com",
  "Name": "Rebecca Rees",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IfqaUFN0PkEwakapGGSw"
 },
 {
  "Email": "gbengabiobaku@gbc-law.com",
  "Name": "Mr. Gbenga Biobaku",
  "Document Name": "NIGERIA) GBENGA) BI 2020 NGA_bi_PPP_survey- completed form August 2.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IgaIRGIYWJeb43Q7WSGh"
 },
 {
  "Email": "cfellowes@mayerbrown.com",
  "Name": "Chris Fellowes",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IhXwFDuTd28xQ7qwT4el"
 },
 {
  "Email": "tom.pemberton@chapmantripp.com",
  "Name": "Mr Tom Pemberton",
  "Document Name": "BI_2020_NZL_bi_PPP_survey_en_TOM PEMBERTON.docx",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ihgf3ZGXtOyxRqlTd05E"
 },
 {
  "Email": "atcole@slcgg.org",
  "Name": "Abdul Tejan-Cole",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IhvwbbSZjppZhjVxSiZp"
 },
 {
  "Email": "info@pachecocoto.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IksmedyR7PK4RWy2dzr6"
 },
 {
  "Email": "ceccws@sltnet.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IlH6cZZ7B4t9qJruLblk"
 },
 {
  "Email": "gkacharava@eugbc.net",
  "Name": "Giorgi Kacharava",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IlHUyXBDxN2gDYezEhjk"
 },
 {
  "Email": "lilian.arias@ariaslaw.com",
  "Name": "Ms. Lilian Arias",
  "Document Name": "BI 2020 SLV_bi_TPI_survey_en.docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IlHref1m12Em2xyYbVek"
 },
 {
  "Email": "psrivastava@duanemorrisselvam.com",
  "Name": "Mr. Priyank Srivastava",
  "Document Name": "TPI_Myanmar (DMS 29072019).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IloXq9wAztkvGwu0kYFB"
 },
 {
  "Email": "Gareth@prop-law.co.za",
  "Name": "Gareth Shepperson",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Im5RJQaWRgkzkeP3ANfA"
 },
 {
  "Email": "mdelfino@delfinowillkie.com",
  "Name": "Mr. Maurizio Delfino",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_713646v1_Delfino e Associati Willkie Farr & Gallagher LLP.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Im9J48zXPfpmvATT3eTj"
 },
 {
  "Email": "wbmlaw@malawi.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ImMPvJU8a1ITdbb4wge2"
 },
 {
  "Email": "psunsook@siampremier.com",
  "Name": "Phasunsook Ayanaputra",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ImMqtYjj3IUOqppQu1rQ"
 },
 {
  "Email": "petr.sabatka@dlapiper.com",
  "Name": "Petr �abatka",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ImqLN0h6afRW6EHaENCp"
 },
 {
  "Email": "wara1@msn.com",
  "Name": "Wara Serry-Kamal",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/InGNuSW3nFV84h2uvgUt"
 },
 {
  "Email": "victor.musabula@ventus.co.zm",
  "Name": "MR Victor Musabula",
  "Document Name": "BI 2020 ZMB_bi_PPP_survey_en_VLP Ventus .docx",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/InVJjnvpVrWOwqrhj2Ly"
 },
 {
  "Email": "yujin.tay@mayerbrown.com",
  "Name": "Matthew Shaw",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Iny5s47lG8nHegxEaswM"
 },
 {
  "Email": "info.construction@concor.co.za",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IoB48kb0nXodEHEd2Kn8"
 },
 {
  "Email": "tim.weston@klgates.com",
  "Name": "R. Timothy Weston",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IoLpBwQ419UotkXyS0Do"
 },
 {
  "Email": "olenakucherenko@gmail.com",
  "Name": "Ms Olena Kucherenko",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_Ministry of Regional Development, Construction and Communal Services of Ukraine.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IpKWRxKHJV3Iu8aDbWze"
 },
 {
  "Email": "erko-andreas.roosik@glimstedt.ee",
  "Name": "Erko Andreas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ipgk4gwhSywaZYK5mTa6"
 },
 {
  "Email": "lilian.mwamdanga@tic.co.tz",
  "Name": "Lilian Mwamdanga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IqXTIrzEiE6TUaSXQfbc"
 },
 {
  "Email": "nagashima@nandhlaw.com",
  "Name": "Takaaki Nagashima",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IrDOcn7v48FllEbFOkCh"
 },
 {
  "Email": "enquiries@exeterchamber.co.uk",
  "Name": "Sara Bond",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IryOJkchQj4hptjbc8N3"
 },
 {
  "Email": "yuri_savvin@epam.ru",
  "Name": "Yuri Savvin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Is0CLPt2c6FKgGNpbRX3"
 },
 {
  "Email": "rivelinconsultants@gmail.com",
  "Name": "Mr Mithra Rampersad",
  "Document Name": "BI 2020 TTO_bi_PPP_survey_en_RC.docx",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IscDsjNtnrQUsbDC3WhQ"
 },
 {
  "Email": "ugas2001@zamnet.zm",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Isfn32fMiKsUMQa4LMfy"
 },
 {
  "Email": "Melanie.Collier@postoffice.co.uk",
  "Name": "Melanie Collier",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ItG6rROinJrZNNOwUfWS"
 },
 {
  "Email": "ian.andrews@linklaters.com",
  "Name": "Ian Andrews",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ItUvkR5MkfzPRkT9JqeI"
 },
 {
  "Email": "simeon.okoduwa@alliancelf.com",
  "Name": "Mr Simeon Okoduwa",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_TPI_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Itf7VwXXHVWQaqwrKRjV"
 },
 {
  "Email": "ara@lawgroup.am",
  "Name": "Ara Zohrabyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ItfZdWIISBx5J2McLxNs"
 },
 {
  "Email": "msignor@stoccheforbes.com.br",
  "Name": "Ms. Miriam Signor",
  "Document Name": "WB Concession.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IuFlMt3MVJSvpkEMt5PJ"
 },
 {
  "Email": "info@cruzmarcelo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Iv26uN1GcnVSuwa3smJB"
 },
 {
  "Email": "ella.melany@dentons.com",
  "Name": "Mrs Ella Melany",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Dentons.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Iw3sWEgwrNQYv3GGaO9M"
 },
 {
  "Email": "office1@mostpp.ru",
  "Name": "Vladimir Platonov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IwXpsFU8U2FAk0YJnrSQ"
 },
 {
  "Email": "ljs@sicc.com.sg",
  "Name": "Ju Song Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/IyFowvEXsiD3R5F2113R"
 },
 {
  "Email": "vsevolod.volkov@everlegal.ua",
  "Name": "Mr Vsevolod Volkov",
  "Document Name": "VV_2020 UKR_bi_PPP_survey_en[2]_Everegal.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J068Fmgf7vndNGL1UT26"
 },
 {
  "Email": "jessica@kimathilegal.com",
  "Name": "Ms Jessica Twumasi",
  "Document Name": "BI 2020 GHA_bi_PPP_survey_en (KnPr).docx",
  "Country": "GHA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J1GRnKmmB7hxSh3OJxQN"
 },
 {
  "Email": "campbellconstruction@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J2EDXuMgBd0xkrLrfIS9"
 },
 {
  "Email": "ddiaz@palacioslleras.com",
  "Name": "Ms. Diana D�az",
  "Document Name": "PPP Survey Colombia - �scar Guti�rrez V2.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J3K3empCAT3ubUA72Wmm"
 },
 {
  "Email": "yosia.sekiremba@ug.ey.com",
  "Name": "Yosia Sekiremba",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J3MHl1hMDH5PUpSbeYwE"
 },
 {
  "Email": "john.maxwell@linklaters.com",
  "Name": "John Maxwell",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J3RXDOqROw13TsQpfrMi"
 },
 {
  "Email": "ian.tucker@burges-salmon.com",
  "Name": "Ian Tucker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J3WeVIDr41LNFb7FojhE"
 },
 {
  "Email": "hbrakel@chamber.ca",
  "Name": "Hendrik Brakel",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J3Yy27UZIUix9usjCE54"
 },
 {
  "Email": "V.Kilinkarov@maximalegal.ru",
  "Name": "Vladimir Kilinkarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J47ehADfhcsHMM5TyJEg"
 },
 {
  "Email": "jjanetos@casselsbrock.com",
  "Name": "Jim Janetos",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J5EGJlVc3NPiAwH6nikV"
 },
 {
  "Email": "urmas.kiik@hedman.ee",
  "Name": "Urmas Kiik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J6SLCs8KoqW2tbHVwrMJ"
 },
 {
  "Email": "enquiries@aon.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J6fuF3ju6Q5beYqOyrDV"
 },
 {
  "Email": "don.stokes@freshfields.com",
  "Name": "Mr Don Stokes",
  "Document Name": "BI 2020 VNM_bi_PPP_survey_en_Freshfields.doc.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J7FPN0i0O2lSQ6zuDEbV"
 },
 {
  "Email": "lh@nnlaw.dk",
  "Name": "Lotte Hummelsh�j",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J7NQeBOfQ2dLaG5GRZeT"
 },
 {
  "Email": "alturhani@yahoo.com",
  "Name": "Prof. Dr. Ali Turhani",
  "Document Name": "BI 2020  ALB_bi_PPP_survey_en.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J7NraXRlrTBOSi1rBXHx"
 },
 {
  "Email": "simon.horner@maynewetherell.com",
  "Name": "Simon Horner",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J7VvDNtgxYyLWdaZunA1"
 },
 {
  "Email": "acrean@millsoakley.com.au",
  "Name": "Andrew Crean",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J8P6Dg2pWBqwDmcPh3Dt"
 },
 {
  "Email": "p.msami@cbe.ac.tz",
  "Name": "Peter A. Msami",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J8Qki6jByrfYqD3mJwxK"
 },
 {
  "Email": "khosokawa@mofo.com",
  "Name": "Kenji Hosokawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J8sJU77pdmqXJrDDG9IO"
 },
 {
  "Email": "wbice@milbank.com",
  "Name": "William Bice",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J8v6XqRDYoVkyeArzmal"
 },
 {
  "Email": "tsaito@stblaw.com",
  "Name": "Takahiro Saito",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J9NWfp4rYBHGSWb1eSO2"
 },
 {
  "Email": "zara.jamal@abreuadvogados.com",
  "Name": "Zara Jamal",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/J9wFd8e1vD6LEkrpkMyH"
 },
 {
  "Email": "info@lisam.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JBBKTi5HWgn9KfscS9P9"
 },
 {
  "Email": "chris.beck@eastlink.ca",
  "Name": "Chris Beck",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JBPkuDw6vM2yg4yo0tJP"
 },
 {
  "Email": "zashcroft@winston.com",
  "Name": "Zoe Ashcroft",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JC6oVgEK3oyMz2UXOwEZ"
 },
 {
  "Email": "giwa-osagie@giwa-osagie.com",
  "Name": "Mr. Osayaba Giwa-Osagie",
  "Document Name": "NIGERIA) GIWA-OSAGIE) BI 2020 NGA_bi_PPP_survey_en ose.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JCMggUAPjduA4cCFXs7T"
 },
 {
  "Email": "dgogochuri@fmg.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JCO6WXnhZTS2InHR8puW"
 },
 {
  "Email": "bshamkeyev@caiconsulting.org",
  "Name": "Baktybek Shamkeyev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JCquX2fv61bDipro8iYg"
 },
 {
  "Email": "Sugan.Palanee@za.ey.com",
  "Name": "Sugan Palanee",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JDe0mqUrt64EtPxbWBgf"
 },
 {
  "Email": "aoj@prcp.com.pe",
  "Name": "Ms. Adriana Ospina-Jimenez",
  "Document Name": "BI_2020 PER_bi_PPP_survey_en_Payet - 4832-7662-0956 v. 5.doc",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JEzHscTnjHkgjehkOCyV"
 },
 {
  "Email": "luiz.vieira@bicharalaw.com.br",
  "Name": "Dr. Luiz Henrique de Carvalho Vieria Gon�alves",
  "Document Name": "BICHARA - WBank - 2020 BRA - PPP Survey - V4 (final).docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JF9i6gTWYjGFMRGr4j4s"
 },
 {
  "Email": "tgnu@tajnet.com",
  "Name": "Mahmaisuf Saidalievich Imomov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JGsnd3x9z38vTdKqOKIs"
 },
 {
  "Email": "michael.silverman@hugheshubbard.com",
  "Name": "Michael R. Silverman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JKVNjQonKC6ummcniQmv"
 },
 {
  "Email": "kratos-2014@inbox.ru",
  "Name": "?????? ????? ?????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JKaTCbHCT2lAESAePFky"
 },
 {
  "Email": "martin.j.callaghan@uk.pwc.com",
  "Name": "Martin Callaghan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JKnsHfiZTLxZfQTAITYM"
 },
 {
  "Email": "r.murray@ashfords.co.uk",
  "Name": "Ruth Murray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JKsLrUffDfTn5CxNhvfB"
 },
 {
  "Email": "dloewinger@whitecase.com",
  "Name": "Doron Loewinger",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JLXBj96C75viHYpcZP82"
 },
 {
  "Email": "michael.lalor@za.ey.com",
  "Name": "Michael Lalor",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JLk0UBgkoaTdSlYrRrY9"
 },
 {
  "Email": "vesna.ljubetic@hpb.hr",
  "Name": "Vesna Ijubetic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JMsP9dr9L7s1U1guLVwS"
 },
 {
  "Email": "cfellowes@mayerbrown.com",
  "Name": "Chris Fellowes",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JMu2SmbN6egM84CrT3s0"
 },
 {
  "Email": "john.gallagher@dlapiper.com",
  "Name": "John Gallanger",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JNnMASdVgePJRdI771f8"
 },
 {
  "Email": "boe@awoonorrenner.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JOACpBSs6tUntIDLjsWn"
 },
 {
  "Email": "getnet_yawkal@rocketmail.com",
  "Name": "Getnet Yawkal",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JOBfAIknIhG6gHg6rJFM"
 },
 {
  "Email": "zeljko.bekina@od-bsds.hr",
  "Name": "Zeljko Bekina",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JOa2rDwfjuJ4OIR5iD6G"
 },
 {
  "Email": "siri@laolaws.com",
  "Name": "Mrs Siri Boutdakham",
  "Document Name": "LAO) LAO LAW) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JOdPoKaJhtAUJhOTwsFP"
 },
 {
  "Email": "f.lucente@tamimi.com",
  "Name": "Frank Lucente",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JOn1KqQJ512SXohbtYJy"
 },
 {
  "Email": "tcioni@torys.com",
  "Name": "Anthony G. Cioni",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JP5cunxaZHWALdqAVIhc"
 },
 {
  "Email": "market_almaty@mail.ru",
  "Name": "Muhtarhan Biyarov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JPPJywtGw3LbU0VIk1NO"
 },
 {
  "Email": "ken.kurosu@squirepb.com",
  "Name": "Ken Kurosu",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JPWYdw6r4aNaVHwy5aje"
 },
 {
  "Email": "f.patnason@icrc.gov.ng",
  "Name": "Femi Patnason",
  "Document Name": "NIGERIA) ICRC) WORLD BANK PPP QUSTIONNAIRE.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JQBblPlWIIHNx6SKtSVU"
 },
 {
  "Email": "hp@nnlaw.dk",
  "Name": "Henrik Peytz",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JQaGU1iSuStjjZ6uLfEN"
 },
 {
  "Email": "jst@andersen-partners.dk",
  "Name": "Jon Stefansson",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JQaZXlOXNkKe3pDi6ubw"
 },
 {
  "Email": "linhgiangnguyen@mpi.gov.vn",
  "Name": "title Nguyen Thi Linh Giang",
  "Document Name": "BI 2020 VNM_bi_TPI_survey_en-_Public Procurement Agency, Ministry of Planning and Investment Mr. Nguyen Dang Truong.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JQpXH0Upn0kC18F9BtS8"
 },
 {
  "Email": "GracaPedretti@felsberg.com.br",
  "Name": "Ms. Maria da Graça Pedretti",
  "Document Name": "Survey - Concession - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JQxtdy3VBc6e6Uw9u7UO"
 },
 {
  "Email": "info@karabdic.ba",
  "Name": "Kerim Karabdic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JRKn9lxCKvg4UeyLepag"
 },
 {
  "Email": "mturrini@whitecase.com",
  "Name": "Michael Turrini",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JRZYHG3XLUYE2KoZjzmQ"
 },
 {
  "Email": "TheCanh.Bui@bakermckenzie.com",
  "Name": "Mr. The Canh Bui",
  "Document Name": "PPP_BakerMckenzie_Vietnam_en.DOCX",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JSoW7YFoKI6hOOoyxvcE"
 },
 {
  "Email": "mpimento@aa-panama.com",
  "Name": "Melba Emiliani De Pimento",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JTUcbMLHvAczlyfx0ZU1"
 },
 {
  "Email": "johanna.rahn@lindeberg.legal",
  "Name": "Johanna R�hn",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JW2pzB63sJOYsDcCHBvL"
 },
 {
  "Email": "ilvolovei@sanigest.com",
  "Name": "Ilie Volovei",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JXD3hcW78bvEfIsiPw4M"
 },
 {
  "Email": "medmike1@hotmail.com",
  "Name": "Martin Michael",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JXuXh5hXU9Up2HnQTNC4"
 },
 {
  "Email": "pgj@kjlaw.dk",
  "Name": "Peter Gj�rtler",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JYJSisfgHIVTnrfXNZbD"
 },
 {
  "Email": "pstewart@curtis.com",
  "Name": "Peter F. Stewart",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JaQGVjYhiAUhFF7po6C8"
 },
 {
  "Email": "ayomi.aluwihare@fjgdesaram.com",
  "Name": "Ayomi Aluwihare-Gunawardene",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jbg0VOfnALEwgYO96JFy"
 },
 {
  "Email": "phammes@shearman.com",
  "Name": "Patricia Hammes",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JcJOcu32GJsFT1PFqiCP"
 },
 {
  "Email": "oiwuoha@aelex.com",
  "Name": "Onyinyechi Iwuoha",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JeICZpfm5zuP7vaHmDyF"
 },
 {
  "Email": "matthew.rickards@ashurst.com",
  "Name": "Matthew Rickards",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jfk5NbqYl4agxgqZWolR"
 },
 {
  "Email": "louis-pierre.gregoire@gowlings.com",
  "Name": "Louis-Pierre Gregoire",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JgPuXe3tYfM5RZHHj3tZ"
 },
 {
  "Email": "emmanuelchorio@gmail.com",
  "Name": "MR EMMANUEL PHILIP CHORIO",
  "Document Name": "NIGERIA) ICRC) WORLD BANK PPP QUSTIONNAIRE.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JgWBpDNFsdQHvyXwFapF"
 },
 {
  "Email": "cassandra.ramkerrysingh@tt.pwc.com",
  "Name": "Cassandra Ramkerrysingh",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JgnALlQW5EHfslPp9BAy"
 },
 {
  "Email": "m-rasekh@sbu.ac.ir",
  "Name": "Mohammad Rasekh",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JhrxfJPo1BWyPMcK2tYv"
 },
 {
  "Email": "arvindmahajan@kpmg.com",
  "Name": "Arvind Mahajan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JhxTGyHhudrUNGlieX4t"
 },
 {
  "Email": "dvinog@essex.ac.uk",
  "Name": "Dmitri Vinogradov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JiDQj16YoZKwGcu3PM7j"
 },
 {
  "Email": "director@amcham.tj",
  "Name": "Ilkhom Makhkambaev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JiiTeSG19XxWQmYrJZ9T"
 },
 {
  "Email": "gebreg@tadessekiros.com",
  "Name": "Gebreamlak Gebrigiogis",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jijjkv2QiYcl1eOapwvR"
 },
 {
  "Email": "aplegal@mideastlaw.com",
  "Name": "Reema I. Ali",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JivXAjMwWdH5UgAA2cPj"
 },
 {
  "Email": "christian.schmidt@gsk.de",
  "Name": "Christian R. Schmidt",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jjj8GuTPGDGqRhGOSjEx"
 },
 {
  "Email": "akibaya@shonubimusoke.co.ug",
  "Name": "Andrew Kibaya",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JkQJghwgPcXlCkBkmsiq"
 },
 {
  "Email": "gurmeet.singh@usp.ac.fj",
  "Name": "Gurmeet Singh",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jkzr2lZ5Nx6qrFGXwq3J"
 },
 {
  "Email": "lbarone@azevedosette.com.br",
  "Name": "Mr Leonardo Antonacci Barone Santos",
  "Document Name": "Bruna - BI 2020 BRA_bi_PPP_survey_en Done.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jl3X5ke6163r0jagplvp"
 },
 {
  "Email": "therrera@gala.com.pa",
  "Name": "Tom�s Herrera D�az",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JlcONANFNlec5gxjzxTt"
 },
 {
  "Email": "saharaldory@yahoo.com",
  "Name": "Sahar Aldory",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JmNLIIRuPx1Fb0MwqKrd"
 },
 {
  "Email": "btalaw@qinet.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JmXeERQ2AjQixHFsRpCo"
 },
 {
  "Email": "ckaferapanjira@mccci.org",
  "Name": "Chancellor Kaferapanjira",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JmnY1wTgGEXMdnL73DX2"
 },
 {
  "Email": "wilfred_abraham@zulrafique.com.my",
  "Name": "Mr Wilfred Abraham",
  "Document Name": "MALAYSIA) ZULRAFIQUE) (Completed) - BI 2020 MYS_bi_PPP_survey_en.docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JmqBygDFVaciYEBnvs7E"
 },
 {
  "Email": "jaunius.gumbis@ellex.lt",
  "Name": "Dr. Jaunius Gumbis",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en. FINAL.doc.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JmyJyVpaN3oXLiKMuKdW"
 },
 {
  "Email": "info@mairandcompany.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jo8vyOWJBnyF5SzdjdIF"
 },
 {
  "Email": "e.kilinkarova@maximalegal.ru",
  "Name": "Elena Kilinkarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JoGYRKEKmZIDK58PqdBG"
 },
 {
  "Email": "sonyango@deloitte.co.ke",
  "Name": "Sammy Onyango",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jodwfpmg8bFbeQ0aZyrS"
 },
 {
  "Email": "matzke@gps-logistics.com",
  "Name": "Dieter MATZKE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JpWbIN22jpYj8UZh9zIT"
 },
 {
  "Email": "Irishsue22000@yahoo.co",
  "Name": "Susan Genervieve Sisay",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JskW4eC2YwXNb9tm1iF6"
 },
 {
  "Email": "dasteraki@kpmg.com.au",
  "Name": "David Asteraki",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jt4cPfQqQuAsYsFqhbfE"
 },
 {
  "Email": "therberghs@ncppp.org",
  "Name": "Todd Herberghs",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JtY6AJjd22Cge7NvBl37"
 },
 {
  "Email": "arianna@ereifejlaw.com",
  "Name": "Ms. Arianna Barilaro",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JudiPx28mFiy6aOQj1jc"
 },
 {
  "Email": "annette.mutschler-siebert@klgates.com",
  "Name": "Annette MUTSCHLER-SIEBERT",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JudlIT08zOuH1Ya84uOl"
 },
 {
  "Email": "ahmet.egrlic@komorabih.ba",
  "Name": "Ahmet Egrlic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jup6yLaRYdDKh51IngC5"
 },
 {
  "Email": "waswa@global.net.pg",
  "Name": "Nigel Merrick",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JuttKLzWlxE6k1QROwly"
 },
 {
  "Email": "info@adr.am�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JvCMAcdoguOkVTPf0kAr"
 },
 {
  "Email": "c.esengeldieva@lorenz-law.com",
  "Name": "Ms Chynara Esengeldieva",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_Lorenz.doc",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JvN8kP9lm6o3WcIU0pxo"
 },
 {
  "Email": "jkellerman@stikeman.com",
  "Name": "Jay C. Kellerman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JvbDuW5yryf8JUG0yg54"
 },
 {
  "Email": "sofia.suarez@berke.com.py",
  "Name": "tile Sofia Suarez",
  "Document Name": "Survey WBG (PPP) (21.7.19)[1].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JwlZCTV04GKyIXiYNzQb"
 },
 {
  "Email": "serhiy.piontkovsky@bakermckenzie.com",
  "Name": "Mr Serhiy Piontkovsky",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en (BMK Ukraine Input).docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JyVYkQ8Wbg6axGH8jScJ"
 },
 {
  "Email": "shamil.mueen@fjgdesaram.com",
  "Name": "Shamil Mueen",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jyts5iBjpmifqW96nnCl"
 },
 {
  "Email": "saudi@smas-ip.com",
  "Name": "Saud Al-Shawwaf",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jz3MZ3rBzeVY2lxpK036"
 },
 {
  "Email": "krohmann@deloitte.de",
  "Name": "Katrin Rohmann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Jzg7CVc8KWk6BNsM4V8w"
 },
 {
  "Email": "muleadada03@gmail.com",
  "Name": "Muleta Debel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JzgcvimvfmokicoqxwTY"
 },
 {
  "Email": "dps@udsm.ac.tz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JzlobL7CmFZwn4oVR43K"
 },
 {
  "Email": "accra@aelex.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JzoVHIsMqb6lNIQEx0lP"
 },
 {
  "Email": "mmarino@carrizales.pe",
  "Name": "Mr. Martin Mariño Marquina",
  "Document Name": "Rev- Doc 2-Cuestionario Banco Mundial - Versión Integrada.docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/JzuW3umiNrFzl86cxDY2"
 },
 {
  "Email": "seyoumy@tadessekiros.com",
  "Name": "Seyoum Yohannes",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K07ahJVhgaMgeG15dYYQ"
 },
 {
  "Email": "simon.aaron@sr-law.co.uk",
  "Name": "Simon Aaron",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K0PQKJYIe318Q8fQQufJ"
 },
 {
  "Email": "nurzhan.bostonova@centil.law",
  "Name": "Ms. Nurzhan Bostonova",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_CentilLaw.doc",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K13Qb2cef45R7jRsU6hm"
 },
 {
  "Email": "shardaheeralal@trinioil.com",
  "Name": "Shards Heeralal",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K33XKgUC7ciFa1WBMW9m"
 },
 {
  "Email": "loh@danskerhverv.dk",
  "Name": "Louise Hogh",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K3BExlYGMGq9TwilbKUf"
 },
 {
  "Email": "law@partner.kg",
  "Name": "Temirbek Kenenbaev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K3Wb6CuZqPcjGFDCwNfn"
 },
 {
  "Email": "william.greenlee@dfdl.com",
  "Name": "Mr. William Greenlee",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en final.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K4UYBudnM5IMxUD0v0Bg"
 },
 {
  "Email": "info@sggeorgia.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K4ewYFYPdwSRPPm9DPAt"
 },
 {
  "Email": "callcentre@standardbank.co.mw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K56di4LYPxvnqGQOO6dR"
 },
 {
  "Email": "info@lydianinternational.co.uk",
  "Name": "Lucy Fowler",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K5cnXKlnM8ehFN8BINDU"
 },
 {
  "Email": "wclarke@jdsellier.com",
  "Name": "William Clarke",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K6G249vOUxcr7wL8AUoe"
 },
 {
  "Email": "n.metje@bham.ac.uk",
  "Name": "Nicole Metje",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K7e7GvifiswDJc3Dkdto"
 },
 {
  "Email": "Sprint_mc@mail.ru",
  "Name": "???????? ????? ??????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K8Iq0I8jHthSbnX0NwZP"
 },
 {
  "Email": "sb@sb-lawyersweb.com",
  "Name": "Bader Behaishan Al- Busaies",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K8M43KhorpTxE9aMBXHM"
 },
 {
  "Email": "iraq@newtonlawllp.com",
  "Name": "Halim Gebeili",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/K9Xgj8uvzkqxMEokg1gs"
 },
 {
  "Email": "gthorpe@omm.com",
  "Name": "Gregory Thorpe",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KAWFMBag6LEIDOzAdqe6"
 },
 {
  "Email": "alcci@rambler.ru",
  "Name": "Shara Akilbaeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KBKMilzOGbgQ676ba0nl"
 },
 {
  "Email": "jmwaura@kpmg.co.ke",
  "Name": "Josphat Mwaura",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KBV1YncgLlhq2u4lcbJN"
 },
 {
  "Email": "info@altracapital.com",
  "Name": "John Davie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KC5Nqq6eq3dA5NEF6Cg4"
 },
 {
  "Email": "olkr@mth.dk",
  "Name": "Ole Kristensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KC5mUDG8ijm7e8igsMIu"
 },
 {
  "Email": "juanmanuel@diazduran.com",
  "Name": "Juan Manuel Diza-Duran",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KD650nCATQLF4GtoSPd1"
 },
 {
  "Email": "arash.izadi@izadilawoffice.com",
  "Name": "Dr. ARASH IZADI",
  "Document Name": "IRAN) PPP_survey_Arash_Izadi_Izadi_Law_Firm.docx",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KE4xrMITRIBFY9cXYpAU"
 },
 {
  "Email": "kkk@jnkirkland.com",
  "Name": "Kakembo K. Katende",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KEABJ6bJsRrtd5NBOYTb"
 },
 {
  "Email": "kei.sasaki@amt-law.com",
  "Name": "Mr. Kei Sasaki",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en_AMT20190906.doc",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KEL90yKXAaaLZmVGhWYh"
 },
 {
  "Email": "amirza@deloitte.com",
  "Name": "Ayad M. Mirza",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KG2eV0YWIb6sixoKUWJ7"
 },
 {
  "Email": "Ljupka.Noveska@karanovicpartners.com",
  "Name": "Ms. Ljupka Noveska Andonova",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Ljupka.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KHWbVEY5eAz7FtUK57XI"
 },
 {
  "Email": "info@oetp.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KHXse1jvw2qOULmIUlPJ"
 },
 {
  "Email": "athena.low@akingump.com",
  "Name": "Athena Low",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KIxsS787SuOblWT1ChWn"
 },
 {
  "Email": "chavalit@siamcitylaw.com",
  "Name": "Chavalit Uttasart",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KJ947fKbBFHWWCtFu7wY"
 },
 {
  "Email": "waalkens@quaychambers.co.nz",
  "Name": "Harry Waalkens",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KJCw00B0TxkJJaH1QpwS"
 },
 {
  "Email": "nikita.divissenko@varul.com",
  "Name": "Nikita Divissenkeo",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KKlfaPsSjpdfKKqbT7kf"
 },
 {
  "Email": "aalbabtain@wanpartners.com",
  "Name": "Abdulaziz M. Al-Babtain",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KL018XVNlQym2bxWm56u"
 },
 {
  "Email": "zusman@vegaslex.ru",
  "Name": "Evgenia Zusman",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KMpstdwxb9f1jLmx1vfA"
 },
 {
  "Email": "annalaliani@hotmail.com",
  "Name": "Ana Partskhalashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KN30rE1WFUUjCdkopAT1"
 },
 {
  "Email": "artashes@lawyer.am",
  "Name": "Artashes Kakoyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KO0HzkKqC26ig3GwgUhX"
 },
 {
  "Email": "don.leitch@dentons.com",
  "Name": "Don R. Leitch",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KOSzsOC7k4JWwe0d7afs"
 },
 {
  "Email": "chaipat@lsorizon.com",
  "Name": "Chaipat Kamchadduskorn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KOfxUOVIEifVTMz3USI9"
 },
 {
  "Email": "jchaves@camara-comercio.com",
  "Name": "Jason Chaves Viques",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KPZBZB37NqW4u7M3mmkj"
 },
 {
  "Email": "info@arp-co.co",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KPZjCNINiPrH7U1e71ko"
 },
 {
  "Email": "info@dragadosgulf.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KPaoW0HohoVZIWqcdY3T"
 },
 {
  "Email": "safwanii@gmail.com",
  "Name": "Karamallah Bushara",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KQ2Pna2OFU7tIp27Pn0B"
 },
 {
  "Email": "r.soriano@estrellatupete.com",
  "Name": "Ms. Rita Pilar Soriano",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en.docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KQiHNRf8u03Jnmb8DHIA"
 },
 {
  "Email": "David.Cox@hklaw.com",
  "Name": "David A. Cox",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KR4rgKNCdCsqC6e4MlWM"
 },
 {
  "Email": "rasmus.kuklane@keevallik.ee",
  "Name": "Rasmus Kuklane",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KRXqOTg2FTJZII1Z2avP"
 },
 {
  "Email": "jpalomo@central-law.com",
  "Name": "Juan Carlos Palomo",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KS57u7WyqQMftDkFgYB5"
 },
 {
  "Email": "mfischel@roblesoreamuno.com",
  "Name": "Manfred Fischel Robles",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KSPJYMr7g2vCiOAO7QC8"
 },
 {
  "Email": "info@acciona.ca",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KSafJiPVbZIw7n8pjYWW"
 },
 {
  "Email": "Alexander.Yerofeyev@ru.ey.com",
  "Name": "Alexander Yerofeyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KSdxXD0rWASk28jfvVHx"
 },
 {
  "Email": "monica.sun@hsf.com",
  "Name": "Ms Monica Sun",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en - HSF 24 July 2019.docx",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KUIEvhjkWwjUC68BICLS"
 },
 {
  "Email": "rkartheiser@paulhastings.com",
  "Name": "Bob Kartheiser",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KUnYqaWLmz989M7ck458"
 },
 {
  "Email": "dushan.soza@wnsgs.com",
  "Name": "Dushan Soza",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KV0Lx5VSLtjA0HbcA9Rx"
 },
 {
  "Email": "merav.griguer@twobirds.com",
  "Name": "Merav Griguer",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KWSP2DmS6OD0UUAAe1cj"
 },
 {
  "Email": "kate.orviss@pinsentmasons.com",
  "Name": "Kate Orviss",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KWYwDccSliOpDYVEBNRA"
 },
 {
  "Email": "thomas.kjaergaard@danskecapital.com",
  "Name": "Thomas Kjaergaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KWni5DkMJZ64XCHQuyKB"
 },
 {
  "Email": "btobedza@bomaatorneys.co.bw",
  "Name": "Binta Tobedza",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KXeULdHSoRZLh6FOWqqR"
 },
 {
  "Email": "admin@lawfieldsconsulting.com",
  "Name": "Charles Okyere",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KXrF1SAWClIKz1VsCrKf"
 },
 {
  "Email": "cbolduc@smart-biggar.ca",
  "Name": "Christian Bolduc",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KYzm0ZUggviWzdWgSSBl"
 },
 {
  "Email": "joe.bauerschmidt@dlapiper.com",
  "Name": "Joe Bauerschmidt",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KZ7VQN5ELj5baePJerKn"
 },
 {
  "Email": "nick.roberts@bakermckenzie.com",
  "Name": "Nick Roberts",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KZWhA5StzTDVUZshBeWg"
 },
 {
  "Email": "info@jurist.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KaLOce3qtkOewh2QOtbM"
 },
 {
  "Email": "Yifat.fux@evronlaw.com",
  "Name": "Yifat Fux",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KaVCcAInguGrRgKWyfQB"
 },
 {
  "Email": "kuldip.dhanoya@TLTsolicitors.com�",
  "Name": "Kuldip Dhanoya",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kayj3OZS4o7sC8p46vzu"
 },
 {
  "Email": "kadri.harginen@sorainen.com",
  "Name": "Kadri Harginen",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KbzZu3CnIdkgdlQv4Jrw"
 },
 {
  "Email": "iub@university.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KgEWtiU4TRzNLp0uAb2Z"
 },
 {
  "Email": "bgomez@s-s.mx",
  "Name": "Ms. Belén Gómez",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en 230719.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KiDRWqP6ruvuzgg57RTp"
 },
 {
  "Email": "hakwasc@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KiO1Bon4ewCn1lyOC4eV"
 },
 {
  "Email": "ian.barnard@fieldfisher.com",
  "Name": "Ian Barnard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KiRZiS9t7Rpbg0lnY4To"
 },
 {
  "Email": "tariq.taherbhai@aon.com",
  "Name": "Tariq Taherbhai",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kj6WWwRYvkbrJZBoxh3d"
 },
 {
  "Email": "cvumanzor@melarayasociados.com",
  "Name": "Carlos Virgilio Umanzor",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KjRN3YfiOnmoxafgo4x3"
 },
 {
  "Email": "eka.aleksidze@bgi.ge",
  "Name": "Ms. Ekaterina Aleksidze",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en (3).docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KjwiVbNdvPZEzr2zXLFd"
 },
 {
  "Email": "swhitehead@fasken.com",
  "Name": "Stephen P. Whitehead",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KkYezeikTSoaRQS2h9sj"
 },
 {
  "Email": "raul@arosemenamarin.com",
  "Name": "Raul Arosemena",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KkblT0YxvAdSHIjLorZJ"
 },
 {
  "Email": "raarias@gala.com.pa",
  "Name": "Ricardo Alberto Arias Arias",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KktkLT2aJLSEQg3VRg7z"
 },
 {
  "Email": "info@kbpackaging.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KlKcXRtA0X6u3DKAUClv"
 },
 {
  "Email": "amtafya@nexlawadvocates.com",
  "Name": "Ayoub Mtafya",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Klrls1BunSbNLHPzdde3"
 },
 {
  "Email": "corina.ionescu@ionescumiron.com",
  "Name": "Ms. Ionescu Corina",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Roxana Stoica.doc.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KmMLxKjOOzwcWv2mqBIe"
 },
 {
  "Email": "wrightlaw@sierratel.sl",
  "Name": "Roland S V Wright",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KmNoJWufOkTCoKv3FtWx"
 },
 {
  "Email": "nicheconsulting2011@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KmqQ7Xj7L6VqezSKcoRk"
 },
 {
  "Email": "wilailuk.okanurak@linklaters.com",
  "Name": "Wilailuk Okanurak",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kmux9iHmZBoaipAdgl4o"
 },
 {
  "Email": "jason.radford@ashurst.com",
  "Name": "Jason Radford",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Knj09fhOxEzgs0SEHclU"
 },
 {
  "Email": "smp@africalegalnetwork.com",
  "Name": "Ms. Sanelisiwe Mpofana",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_Atiq S Anjarwalla.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KpQeKdyvlBKLESNRz9oh"
 },
 {
  "Email": "jscharf@goerg.de",
  "Name": "JAN PETER SCHARF",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kpnns6BbQFt0lhfc9qsn"
 },
 {
  "Email": "Donald@raha.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KqOiy08J0kRliYRt2HcD"
 },
 {
  "Email": "paul.cooper@am.pwc.com",
  "Name": "Paul Cooper",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kryugz5bQSOksKD9kJyp"
 },
 {
  "Email": "steeldirect@bluescopesteel.com",
  "Name": "Debra Counsell",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KseltegMa6WqNhjoEPag"
 },
 {
  "Email": "anderson.mongolia@anallp.com",
  "Name": "MR DAVID BUXBAUM",
  "Document Name": "MONGOLIA) ANDERSON) BI 2020 MNG_bi_PPP_survey_en_Anderson_1stAugust2019.docx",
  "Country": "MNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ksot0n2gE2QmnkPtT6ly"
 },
 {
  "Email": "gutulaw@iwayafrica.co.zw",
  "Name": "Mr Obert Chaurura Gutu",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_Tsungirirrai Marufu-Maune (law firm).doc",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KsowWOJRap1SGbWeXPmg"
 },
 {
  "Email": "cyril.chew@bclplaw.com",
  "Name": "Cyril Chew",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KtWtwHTHV96utY5cmY92"
 },
 {
  "Email": "dcriddle@orrick.com",
  "Name": "Dean Criddle",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ku3JIZLsyjKW3jLhLfJY"
 },
 {
  "Email": "lm@abel.dk",
  "Name": "Lone M�ller",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ku9XL2xDyY6m6YFyX6gv"
 },
 {
  "Email": "cvaldes@talial.com",
  "Name": "Camilo A. Vald�s",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KuDepoVldQQgjHGJ3sO1"
 },
 {
  "Email": "s.kabaeva@lorenz-law.com",
  "Name": "Ms. Saara Kabaeva",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_Lorenz.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KuiNBEtJ4qEG7QEpR6sA"
 },
 {
  "Email": "Helen.Prandy@mills-reeve.com",
  "Name": "Helen Prandy",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kv3iavrnAivTsGcBvzlO"
 },
 {
  "Email": "mekchamber@ethionet.et",
  "Name": "Gebrehiwot Gebreegziabher",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KvZQD3WH2uzXdTGcdFKv"
 },
 {
  "Email": "markasmith@deloitte.com",
  "Name": "Mark Smith",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kvg7JtcyO4uIyJknel3X"
 },
 {
  "Email": "nhashimoto@kaynex-law.com",
  "Name": "Norifusa Hashimoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KxT3FGifW4qHSk4LsYSm"
 },
 {
  "Email": "jean-francois.marquaire@cmslegal.ru",
  "Name": "Mr. Jean-Francois Marquaire",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_PPP_survey_en_CMS.doc",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KxqkJPNSBRiwxTrS67qV"
 },
 {
  "Email": "jlisson@fasken.com",
  "Name": "James Lisson",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ky7ZgHfAcgJgaW6tRHV7"
 },
 {
  "Email": "eie@ethionet.et",
  "Name": "title first name last name",
  "Document Name": "ETHIOPIA) ETHIO INFRA) BJ1_BI 2020  ETH_bi_TPI_survey_en.doc",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Kymp1yX2ygmwsrgLdcpF"
 },
 {
  "Email": "asistentecca@camara-comercio.com",
  "Name": "Alexander Madrigal Brenes",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/KyvbBTzrJOvZDP8hXl7a"
 },
 {
  "Email": "sspencer@407etr.com",
  "Name": "Steve Spencer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L0g3IUFtYGZDo81w5T3p"
 },
 {
  "Email": "mshitaye@yahoo.com",
  "Name": "Michael Ayalew Tiruneh",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L1JtEnpQisl7cLo8BJUR"
 },
 {
  "Email": "MitieChief.Executive@mitie.com",
  "Name": "Ruby Mcgregor-Smith Cbe",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L1N96jokeNsJ4GoEG7ai"
 },
 {
  "Email": "gustav.runeland@freshfields.com",
  "Name": "Gustav Runeland",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L30hnyJJ20dFwkUxjN8R"
 },
 {
  "Email": "c.d.evans@bangor.ac.uk",
  "Name": "Ceri Evans",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L3DSVZGkQtIv8Kftb07U"
 },
 {
  "Email": "kstabuchi@toyo.jp",
  "Name": "Sam Tabuchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L3UI8CgVmeqCypVCcLjR"
 },
 {
  "Email": "gfabrizi@ristuf.it",
  "Name": "Miss Giulia Fabrizi",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_RandT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L4Dbrrg50aLyRcQuoa9C"
 },
 {
  "Email": "tcmr@tcmrlaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L4Ovq3zuC6ZW1UPpROe7"
 },
 {
  "Email": "ian.robertson@holdingredlich.com",
  "Name": "Ian Robertson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L4n8S0mA7uQ4MmW8BKkm"
 },
 {
  "Email": "orvc@out.ac.tz",
  "Name": "Paul Kihwelo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L4yH6D2n5kUDNYIMwuae"
 },
 {
  "Email": "LOURDES.DELEON@QUISUMBINGTORRES.COM",
  "Name": "Lourdes E. De Leon",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L5LwPbPuBH287NFNifhq"
 },
 {
  "Email": "enquiries@exeterchamber.co.uk",
  "Name": "Sara Bond",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L5qfgqVaKzb4P2kaifBo"
 },
 {
  "Email": "mregan@bond.edu.au",
  "Name": "Michael Regan",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L5weAJ1YtIsNif4ShPqD"
 },
 {
  "Email": "ramil.pardi@triniti.ee",
  "Name": "Ramil Pardi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L64lRoKYfcqURZnPdCh8"
 },
 {
  "Email": "a.okere@icrc.gov.ng",
  "Name": "Dr Amanze Okere",
  "Document Name": "NIGERIA) ICRC) BI 2020 NGA_bi_PPP_survey_en r1Answers.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L6Tx2GFQxmH517u6KV9v"
 },
 {
  "Email": "chartsiri.sop@bbl.co.th",
  "Name": "Chartsiri Sophonpanich",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L78oqoUW4YHIpV8Ka1N4"
 },
 {
  "Email": "martin.bytcanek@allenovery.com",
  "Name": "Mr. Martin Byt?anek",
  "Document Name": "BI 2020 CZE_bi_PPP_survey_en_allen overy.DOC",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L7AXNTcA43rnQOB2Erh3"
 },
 {
  "Email": "shevanthi.perera@fjgdesaram.com",
  "Name": "Shevanthi Seresinhe-Perera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L80rqJTlSovpxsFYnIKV"
 },
 {
  "Email": "david.cave@ashurst.com",
  "Name": "David Cave",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L81tkRQSzsIFGO1u9tJZ"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Taras Parkhomenko",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L8SEwvN9H0a8NTrZxgUI"
 },
 {
  "Email": "efloranoy@yahoo.com",
  "Name": "Ebinezer R. Florano",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L8SwsvyhtW7C9KA3dijv"
 },
 {
  "Email": "jzepeda@industriaguate.com",
  "Name": "Javier Zepeda",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/L9ORTQEKaX8hvMSCRqbC"
 },
 {
  "Email": "Marlene.Wimmer-Nistelberger@cms-rrh.com",
  "Name": "Mag., LL.M. Marlene Wimmer-Nistelberger",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_CMS.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LAuquW1MELngle1uL1UE"
 },
 {
  "Email": "ohashik@gtlaw.com",
  "Name": "Koichiro Ohashi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LBDm93G1egewVzHH1KTK"
 },
 {
  "Email": "kim.reddy@pinsentmasons.com",
  "Name": "Ms Kimera Reddyy",
  "Document Name": "BI 2020 ZAF_bi_TPI_survey_en_Pinsent Masons_Aug2019.docx",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LBIixKc7iEClRTeo1oz2"
 },
 {
  "Email": "Komziuk@aequo.ua",
  "Name": "Mr. Viktor Komziuk",
  "Document Name": "BI 2020 2 UKR_bi_PPP_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LCoyBaFyQnh7cBGdBEkI"
 },
 {
  "Email": "igraham@trowers.com",
  "Name": "Ian Graham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LD02n2OUUTTquzBg3oFk"
 },
 {
  "Email": "walnuwaiser@wanpartners.com",
  "Name": "Waleed Al-Nuwaiser",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LD7SQAP7Rj8hEi8htmRx"
 },
 {
  "Email": "amandarolt@felsberg.com.br",
  "Name": "Ms. Amanda Pauli De Rolt",
  "Document Name": "Survey - PPP - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LDS398W9CzoVLVjB2kA0"
 },
 {
  "Email": "gemadagonfa@gmail.com",
  "Name": "Gemeda Gonfa",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LDtWQMgep6Rt9DCFpXCO"
 },
 {
  "Email": "eculikova@csas.cz",
  "Name": "Eva ?ul�kov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LE6OT5rVZxVBOs8cUk4k"
 },
 {
  "Email": "aisha.sinda@mkono.com",
  "Name": "Aisha Sinda",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LEDc8r7b2djxBlCN08SE"
 },
 {
  "Email": "achinula@williamfaulkermw.com",
  "Name": "Alan Chinula",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LElQ5ry1nS1k6VVjuchJ"
 },
 {
  "Email": "info@alfksa.com",
  "Name": "Ali Bin Abdullah Bin Ali",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LFuXlpv3o12ikrfGWxgK"
 },
 {
  "Email": "eduard.stephenson@za.ey.com",
  "Name": "Eduard Stephenson",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LHVwtYpAfy3yGof6Lmf6"
 },
 {
  "Email": "agolub@gp.ua",
  "Name": "title Andrey Golub",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_GP.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LISnvbga5sFiSp7OETNq"
 },
 {
  "Email": "info@rovasacr.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LK4aG5xgJci1YyqExkyV"
 },
 {
  "Email": "kreardon@hwle.com.au",
  "Name": "Karyn Reardon",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LKEqt2hxD36MgL9O1uTp"
 },
 {
  "Email": "aram@lipameir.co.il",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LKZD0ClYYhdrJCtcDLN0"
 },
 {
  "Email": "nshakhabutdinov@legesadvokat.com",
  "Name": "Mr. Nizomiddin Shakhabutdinov",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Leges.docx",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LODyDVI61HiP3aZCxrzN"
 },
 {
  "Email": "sarah.sinclair@minterellison.co.nz",
  "Name": "Sarah Sinclair",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LOVZ7xjqKAzgHG01qAE4"
 },
 {
  "Email": "reginald@kimathilegal.com",
  "Name": "Mr Reginald Nii Odoi",
  "Document Name": "BI 2020 GHA_bi_TPI_survey_en KnPr 2.docx",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LOXF1JQE4iVoFBaVcTi1"
 },
 {
  "Email": "pdebuchy@grossbrown.com.py",
  "Name": "Mr. Pablo Debuchy",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (GB 13.9.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LPcxM8NvzMA7w60CpHrS"
 },
 {
  "Email": "que.vu@rajahtannlct.com",
  "Name": "title Que Vu",
  "Document Name": "VIETNAM) RTLCT) BI 2020 VNM_bi_TPI_survey_en.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LPmzo5izoQzJtPQZq46t"
 },
 {
  "Email": "phockless@debevoise.com",
  "Name": "Peter Hockless",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LQnNQ4AdIaK7KYPhyqlp"
 },
 {
  "Email": "MChiwalo@fdh.co.mw",
  "Name": "Mike Chiwalo",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LRFAXU1WW4fKCgR5t4p4"
 },
 {
  "Email": "Andy.Cartwright@chapmantripp.com",
  "Name": "Andy Cartwright",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LRi0jPzhD5oIcGXwZw2A"
 },
 {
  "Email": "i.amadi@seftonfross.com>",
  "Name": "Mr Ikenna Amadi",
  "Document Name": "NIGERIA) SEFTON FROSS) BI 2020 NGA_bi_TPI_survey_en 22..8.2019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LShKAfQPpiwjGY2OQCGm"
 },
 {
  "Email": "clare.corke@corrs.com.au",
  "Name": "Clare Corke",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LSkOIAQompcm9qMXQYuO"
 },
 {
  "Email": "occarag@cdmzlaw.com",
  "Name": "Othello C. Carag",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LSq8pOsA3Vy8PGIaxAH5"
 },
 {
  "Email": "sandra.fredman@law.ox.ac.uk",
  "Name": "Sandra Fredman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LTKcn3J8WHWNtbPnFRcy"
 },
 {
  "Email": "aare.lokk@elektrilevi.ee",
  "Name": "Aare Lokk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LTaSMsHeyscZb4VgUA6H"
 },
 {
  "Email": "amvelasco@dnp.gov.co",
  "Name": "Mrs Angelica Velasco",
  "Document Name": "PO.BI 2020 COL_bi_PPP_survey_en AVDNP1.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LTjCfauyoPxOSx2tZ4ys"
 },
 {
  "Email": "info@mikshin.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LTnTqVCnoQrJeHZiq8qM"
 },
 {
  "Email": "info@sbg.com.sa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LUitcYDwqThEE8uUQhAA"
 },
 {
  "Email": "rgomez@arodi.com",
  "Name": "Ruben Gomez",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LWbsqCP8l3IliPQGmRJF"
 },
 {
  "Email": "khinsandar.win@vdb-loi.com",
  "Name": "Mrs Khin Sandar Win",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en_07052019.docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LY4o65ZvpS7ybhrwY3vg"
 },
 {
  "Email": "tsano@jonesday.com",
  "Name": "Tadakatsu Sano",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LYUG5FBeirI18KB5By3A"
 },
 {
  "Email": "lesego.gabasiane@collinsnewman.bw",
  "Name": "Lesego Gabasiane",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LYZdAcltwanW8237w2xf"
 },
 {
  "Email": "info@iacci.info",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LaMCksE1hFjNXHemw6iC"
 },
 {
  "Email": "law@abdulaitaiwo.com",
  "Name": "Mr. Ladi Taiwo",
  "Document Name": "NIGERIA) TAIWO) BI 2020 NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lahlb061Rgh9Macm68EL"
 },
 {
  "Email": "Abbasamin2010@yahoo.com",
  "Name": "Abbas Amin",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LbV7l3sInxlQyTowkuLO"
 },
 {
  "Email": "anne.davies@law.ox.ac.uk",
  "Name": "Anne Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lc52PDkX6sMA3aEBH4tQ"
 },
 {
  "Email": "lmichalik@hkv.sk",
  "Name": "Mr. Luk� Mich�lik",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en_HKV.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LcKIlUNirz94LuB6mozb"
 },
 {
  "Email": "makcons@ud.co.tz",
  "Name": "M. Minja",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LcNJvbrbJb3vgdZmQNEm"
 },
 {
  "Email": "enquiries.fairgrounds@bancabc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LdaBm7g7qRUfjFdXsfd4"
 },
 {
  "Email": "randall@oss.com.gh",
  "Name": "Randall Obeng-Sakyi",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LdqEP0wLiOT5QEYNaLWl"
 },
 {
  "Email": "kirstin@drakelawsamoa.com",
  "Name": "Ruby Drake",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Le758vspzyHBC7fU0tJC"
 },
 {
  "Email": "danalemou@gmail.com",
  "Name": "Daniel Alemu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LeBvvNxSTU8zHPP3SdUR"
 },
 {
  "Email": "lawrence.rodkin@sr-law.co.uk",
  "Name": "Lawrence Rodkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lf0R3VK0hHs8QbCLKt0w"
 },
 {
  "Email": "Ain.Alvin@levinlaw.ee",
  "Name": "Ain Alvin",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lf1m7ck7CgXdnd9wAYWy"
 },
 {
  "Email": "mrghimire32@gmail.com",
  "Name": "Mr. Madhab Raj Ghimire",
  "Document Name": "NEPAL) PSM) 20190609 BI 2020 NPL_bi_PPP_survey_en.doc",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lf3rFaPauCFi4nG7LLFs"
 },
 {
  "Email": "unikbotswana@unikconst.com",
  "Name": "Wendy Zhu",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LfJuABkQF1ImYLB4NdTn"
 },
 {
  "Email": "todilov@whitecase.com",
  "Name": "Timur Odilov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LfLmqH0Pe55n22CC4dcI"
 },
 {
  "Email": "dean.thompson@hobec.co.nz",
  "Name": "Dean Thompson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lfb4oEJJ777ZMJyJ7IO3"
 },
 {
  "Email": "angel.bangachev@cms-cmno.com",
  "Name": "Mr Angel Bangachev",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_en_Angel Bangachev.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LgtdgHnzALaOB9b6WR0F"
 },
 {
  "Email": "mahasin.siddig@sksadvocates.com",
  "Name": "Mahasin Siddig Hassan Eltom",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lhkd0xbWKzS5ehuHBxPl"
 },
 {
  "Email": "info@fultonhogan.com",
  "Name": "Brad Robinson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Li5I1Yx3OBTYzEaqxNbE"
 },
 {
  "Email": "milena.sljivich@berke.com.py",
  "Name": "title Milena Sljivich",
  "Document Name": "Survey WBG (PPP) (21.7.19)[1].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LiJ3wpYvcgS3vg1IN8Ba"
 },
 {
  "Email": "euan.pinkerton@bakerbotts.com",
  "Name": "Euan Pinkerton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LjBpQbIjHLgjXQR55UR4"
 },
 {
  "Email": "richard.binns@burges-salmon.com",
  "Name": "Richard Binns",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lk6mFWcpkyU2CIotRFmN"
 },
 {
  "Email": "fbfigura@punopenalaw.com",
  "Name": "Frank B. Figura",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LkX2d8IJrb0SGztWyVVK"
 },
 {
  "Email": "info@monitor.com.vn",
  "Name": "Mr Hung Duy Tran",
  "Document Name": "VIETNAM) MONITOR) BI 2020 VNM_bi_PPP_survey_en- Hung Tran.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lko8h0lalWY4e0uoQN1M"
 },
 {
  "Email": "hannes@lauspartners.ee",
  "Name": "Hannes Olli",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lkzpgv70u7eux3Fe5cUJ"
 },
 {
  "Email": "info@aztanlawfirm.net",
  "Name": "Tayeb Hassabo",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LlhI6wdXu7FxAAEpjzYj"
 },
 {
  "Email": "kanematsu@mmn-law.gr.jp",
  "Name": "Yuriko Kanematsu",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LlryRCQczLZYzAoVPKG7"
 },
 {
  "Email": "janette.campbell@mc.co.nz",
  "Name": "Janette Campbell",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lm5V95EOWqsj80hsCLUE"
 },
 {
  "Email": "seppo.toivonen@vayla.fi",
  "Name": "Mr. Seppo Toivonen",
  "Document Name": "FINLAND) FINNISH TRANSPORT INFRASTUCTURE AUTHORITY) BI 2020 FIN_bi_PPP_survey_en Vayla.docx",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LmMkbPtLoYAaLBn9GtfF"
 },
 {
  "Email": "Simon.Takashvili@Jtconsulting-Geo.com",
  "Name": "Simon Takashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LmmxHQMLtGrd9UtMGm5h"
 },
 {
  "Email": "ekaterina.shapochka@ru.pwc.com",
  "Name": "Ekaterina Shapochka",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LnXBMDxN12VwVA1juL2h"
 },
 {
  "Email": "levani@g-p.ge",
  "Name": "Levan Pateishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LnoUSFJYU9S0FAqyJl7G"
 },
 {
  "Email": "AYerzhanov@bmflegal.com",
  "Name": "Arlan Yerzhanov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LoQjKDjCh1gM5AkbmMXQ"
 },
 {
  "Email": "cherie.faiella@ch.ey.com",
  "Name": "Cherie B Faiella",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LooC7LjUSIbsyzOKErQf"
 },
 {
  "Email": "scoonsttlaw@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LpZ8eL7hepPXYdyK7Tgo"
 },
 {
  "Email": "astein@stoccheforbes.com.br",
  "Name": "Ms. Ana Stein",
  "Document Name": "WB Concession.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LqaPbPwZbzq29x0YARxt"
 },
 {
  "Email": "Tahifisi.Vehikite@KramerAusenco.com",
  "Name": "Tahifisi Vehikite",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LrTkkmtkjvJfVuC5cLwZ"
 },
 {
  "Email": "mohdsharifsa@yahoo.com",
  "Name": "Mohamed Al-Sharif",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LsLpsXhMSdVVJoroVgdr"
 },
 {
  "Email": "Isabel.Gallego@uclm.es",
  "Name": "Dr. Isabel Gallego C�rcoles",
  "Document Name": "okBI 2020 ESP_bi_PPP_survey_en.doc.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lsn9W0zA7nLjkuWcQGWy"
 },
 {
  "Email": "kaisa-maria.vellomae@eversheds.ee",
  "Name": "Kaisa Maria",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LtFd8jqQNO5wOlwsAS5J"
 },
 {
  "Email": "sigfrido@grossbrown.com.py",
  "Name": "Mr. Sigfrido Gross Brown",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (GB 13.9.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LuIyxi7GkNyvROjN4Tdx"
 },
 {
  "Email": "Lawchak.Jalal@alaflaw.com",
  "Name": "Lawchak Jalal",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LviU0biQ4ZNXnrlIdx20"
 },
 {
  "Email": "Baghdad_chamber@yahoo.com",
  "Name": "Jaafar Alhamdany",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lvk0Qw9KT4Q34xSsCmEx"
 },
 {
  "Email": "dkunenova@bmflegal.com",
  "Name": "Dinara Kunenova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LwkhkSNK0O4cXe3O4X1s"
 },
 {
  "Email": "andrew.burton@dlapiper.com",
  "Name": "Andrew Burton",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lx8FQuSzdrvk2nyxAMEG"
 },
 {
  "Email": "dawn.gibson@iucn.org",
  "Name": "Dawn Gibson",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LxRemgSQAB6497Ey8WEy"
 },
 {
  "Email": "n.mouraviev@abertay.ac.uk",
  "Name": "Nikolai Mouraviev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Lz0wzvfV4q0TG3bYyBbD"
 },
 {
  "Email": "liam.cowell@dlapiper.com",
  "Name": "Liam Cowell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LzMX9OCo4mDP5dXSmQ5q"
 },
 {
  "Email": "Kieran.Whyte@bakermckenzie.com",
  "Name": "Mr Kieran Whyte",
  "Document Name": "JOHDMS-#486163-v1-BI_2020_ZAF_bi_TPI_survey_en_(005).docx",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/LzfXU4JSJyYeD7VeecCC"
 },
 {
  "Email": "amandarolt@felsberg.com.br",
  "Name": "Ms. Amanda Pauli De Rolt",
  "Document Name": "Survey - Concession - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M0BUa9EdtIdIU2UNvBdP"
 },
 {
  "Email": "pmaugue@debevoise.com",
  "Name": "Pierre Maugue",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M1wOzJN8JYIXx9ixUrfW"
 },
 {
  "Email": "celia.boyle@nortonrosefulbright.com",
  "Name": "Celia Boyle",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M1z8LEX3nOoBs1poDIZ7"
 },
 {
  "Email": "udayan.mukherjee@dentons.com",
  "Name": "Udayan Mukherjee",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M2xHnnslwI6zIfdBNtlg"
 },
 {
  "Email": "sharonbighornconstruction@gmail.com",
  "Name": "Sharon Mcnabb",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M3xyBL5Vi9I96ylVlzof"
 },
 {
  "Email": "carmon@erm-law.com",
  "Name": "Anna Carmon",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M40RvvgQRwCKSaaTp0WL"
 },
 {
  "Email": "kizzita.mensah@reindorfchambers.com",
  "Name": "Kizzita Mensah",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M4jpS0UstRKRV7BbPqqv"
 },
 {
  "Email": "gregory.hannays@tt.ey.com",
  "Name": "Gregory Hannays",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M5DxD5HzCH015gr6LTKG"
 },
 {
  "Email": "bank@aeb.am",
  "Name": "Edward Marutyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M5E7QK58pYA7kfUqjBoC"
 },
 {
  "Email": "david.bickerton@cliffordchance.com",
  "Name": "David Bickerton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M5XMXdkiaUatiWxyqFpW"
 },
 {
  "Email": "indira@law.cmb.ac.lk",
  "Name": "W.I. Nanayakkara",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M5kRbYLZHzmrsA2HFquc"
 },
 {
  "Email": "fbl@londonmet.ac.uk",
  "Name": "John Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M6oTfaVAhfGZBEYKxeHr"
 },
 {
  "Email": "roddytuazonjr@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M703QG1kvXARfFEZgp4F"
 },
 {
  "Email": "sdit@mnec.gr",
  "Name": "Mr. Nikolaos Mantzoufas",
  "Document Name": "GREECE) SPECIAL SECRETARIAT) 2020 PPP survey.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M7Q2GfXDnAS2Uy5AS4Kc"
 },
 {
  "Email": "office@demicco.ch",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M8LNsCk8dHqU1xUbgyLW"
 },
 {
  "Email": "sberaha@mofo.com",
  "Name": "Stuart S Berahi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M8QMiHnGGQBps29g75w3"
 },
 {
  "Email": "oyohannes@yahoo.com",
  "Name": "Oqubamichael Weldeyohannes",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M8RQW0rz2zbqFEscUHRY"
 },
 {
  "Email": "jean.bertrand@nortonrosefulbright.com",
  "Name": "Jean G. Bertrand",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/M94BgFPPhyGhwGOPqTyP"
 },
 {
  "Email": "zarinach@gmail.com",
  "Name": "Zarina Chekirbaeva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MA9lYGCb6dv9Bq5fQvHs"
 },
 {
  "Email": "secretariat@nus.edu.ws",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MAQqo19QYvTrRzik0Nb3"
 },
 {
  "Email": "pgaleano@palacioslleras.com",
  "Name": "Paola Galeano",
  "Document Name": "TPI Survey Colombia - Óscar Gutiérrez V3.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MAbFm5vBspEngIgzn9zm"
 },
 {
  "Email": "sullivand@sullcrom.com",
  "Name": "Dennis C. Sullivan",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MAlHGXl0xgCgdv7XDXwX"
 },
 {
  "Email": "aadebesin@olaniwunajayi.net",
  "Name": "Mr. Adetola Adebesin",
  "Document Name": "NIGERIA) OLANIWUN) World Bank Survey - Traditional Public Ifrastructure Finance (22.07.19).docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MCYjrSRgLmMGCxhPKG8f"
 },
 {
  "Email": "anuradhap@nithimurugesu.com",
  "Name": "Anuradha Pieris",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MCZrKcmNrjz2m9pNO01A"
 },
 {
  "Email": "mostafa.nagy@eldib.com",
  "Name": "Mostafa Nagy",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MCoBzUJdqlJ1tlZXW5yP"
 },
 {
  "Email": "john.houlden@burges-salmon.com",
  "Name": "John Houlden",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MDPJmgF8td7sNuUqklt2"
 },
 {
  "Email": "nigel.sievwright@shepwedd.co.uk",
  "Name": "Nigel Sievwright",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MFGQEi7eVLSv8qRz3VRh"
 },
 {
  "Email": "nmwesigwa@shonubimusoke.co.ug",
  "Name": "Noah E. Mwesigwa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MFGmSW6gRv3nwBsDsjP7"
 },
 {
  "Email": "munir.mashal@ada.org.af",
  "Name": "A. Munir Mashal",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MGG25HjDzhhhINQxQKyI"
 },
 {
  "Email": "hai.nguyen@ykvn-law.com",
  "Name": "Mr. Hai Nguyen Van Hai",
  "Document Name": "VIETNAM) YKVN) BI 2020 VNM_bi_PPP_survey_en_YKVN_20190816.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MGaxNhvcMvKm3aEkfvLY"
 },
 {
  "Email": "leon.larrain@bakermckenzie.com",
  "Name": "title León Larrain",
  "Document Name": "2. BI 2020 CHL_bi_TPI_survey_en (003).docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MGtS2WD2sy7sWbaOAPNy"
 },
 {
  "Email": "abdirashid.bra@gmail.com",
  "Name": "Mr. Abdirashid Salah",
  "Document Name": "BI 2020 SOM_bi_PPP_survey_en_Isir Consulting.doc",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MHw6xVwk2csBcWbFVxKB"
 },
 {
  "Email": "amer.alamr@dlapiper.com",
  "Name": "Amer Abdulaziz Al-Amr",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MIKnz4HRM6HVSSGBOOdL"
 },
 {
  "Email": "jadiala@upng.ac.pg",
  "Name": "John Dialala",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MIOFiXfuPjVKjfFHBH7T"
 },
 {
  "Email": "pbeatty@chamber.ca",
  "Name": "Perrin Beatty",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MIRPXrEDt57EF84Zx565"
 },
 {
  "Email": "Gavin.Noeth@adams.africa",
  "Name": "Gavin Noeth",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MJA7DcIEovYy8rMy0q0g"
 },
 {
  "Email": "gnaphambo@fdh.co.mw",
  "Name": "George Naphambo",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MLAF4wkNBFnhjc26MsNS"
 },
 {
  "Email": "tatiana.monastyrskaya@skadden.com",
  "Name": "Tatiana Monastyrskaya",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MLH5xnFL74yxY3dDilxY"
 },
 {
  "Email": "rupert.burrows@mayerbrown.com",
  "Name": "Rupert Burrows",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MM927vwX7kRKH2h3wBqz"
 },
 {
  "Email": "Alok.Chugh@kw.ey.com",
  "Name": "Mr. Alok Chugh",
  "Document Name": "BI 2020 KWT EY_bi_PPP_survey_en.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MMhdoGSkxZP3fCFT2Sdi"
 },
 {
  "Email": "mostpp@mostpp.ru",
  "Name": "Mikhail Kuzovlev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MNEswkluwvgwdZ32OP4S"
 },
 {
  "Email": "info@eugbc.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MNNULvZmhhn0HWi70HQ3"
 },
 {
  "Email": "bzimbler@morganlewis.com",
  "Name": "Brian Zimbler",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MOJgfvZ7HA2yzGz4lEdG"
 },
 {
  "Email": "jplabuschagne@deloitte.co.za",
  "Name": "Jp Labuschagne",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MP0tuCyFtp6xEz7jio3T"
 },
 {
  "Email": "yuya.aoki@dlapiper.com",
  "Name": "Yuya Aoki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MPPn8SnGDf4aP2buOfAw"
 },
 {
  "Email": "admin1@simpson.com.pg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MPXJYwdSOefLmSMWit8p"
 },
 {
  "Email": "reet.adamsoo@ut.ee",
  "Name": "Reet Adamsoo",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MPr9Mp6WzjRl7fXAtrNV"
 },
 {
  "Email": "ktwining@lockelord.com",
  "Name": "Kevin Twining",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MQ8V9RrNZCHXQtHVzrnX"
 },
 {
  "Email": "daniel.meikle@maynewetherell.com",
  "Name": "Daniel Meikle",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MQJD1Ko0IkvyAF8D6Jc0"
 },
 {
  "Email": "alvaro.costa@jacoby.adv.br",
  "Name": "Mr. �lvaro Costa",
  "Document Name": "BRAZIL) JACOBY) BI 2020 BRA_bi_PPP_survey_en-JACOBY.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MQy8MkxYyljp39ONWBtW"
 },
 {
  "Email": "info_general@tmi.gr.jp",
  "Name": "Naomichi Chiba",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MSCISoB0oILQAamTuipn"
 },
 {
  "Email": "daniel.chia@stamfordlaw.com.sg",
  "Name": "Daniel Chia",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MT1TL8X9hLpszZcgfbny"
 },
 {
  "Email": "adetolalawal@gbc-law.com",
  "Name": "Ms. Adetola Lawal",
  "Document Name": "NIGERIA) GBENGA) BI 2020 NGA_bi_PPP_survey- completed form August 2.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MTIbBGErsdoGm0UiqrZg"
 },
 {
  "Email": "president@kaliningrad-cci.ru",
  "Name": "Aleksey Zinoviev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MU5mTDLe2Wor397il5nd"
 },
 {
  "Email": "info.cr@bekaert.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MUD5VIr0KPzFcHAUvlIj"
 },
 {
  "Email": "ryangoldstein@quinnemanuel.com",
  "Name": "Ryan Goldstein",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MUazx0usYvjhu03zkCAu"
 },
 {
  "Email": "mork.murdock@squirepb.com",
  "Name": "Mork Murdock",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MUfOvicdEXLyPse2LKSc"
 },
 {
  "Email": "ChiLieu.Dang@bakermckenzie.com",
  "Name": "Mr. Chi Lieu Dang",
  "Document Name": "TPI_BakerMcKenzie_Vietnam.DOC",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MVAR7aBaPsWQxGoWRziw"
 },
 {
  "Email": "torsten.syrbe@cliffordchance.com",
  "Name": "Torsten Syrbe",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MVpFpOp6oRZPsnWwiVzn"
 },
 {
  "Email": "ac146@cam.ac.uk",
  "Name": "Amy Ludlow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MX1x1gzH58ypkKu7fQw4"
 },
 {
  "Email": "dbulat@millerthomson.com",
  "Name": "Drazen F. Bulat",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MXZI94CCoIRZFq7dTsI0"
 },
 {
  "Email": "vaclav.valvoda@allenovery.com",
  "Name": "V�clav Valvoda",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MXiqajzSXpf4Z1hVfzHp"
 },
 {
  "Email": "chris.wing@scotiabank.com",
  "Name": "Christopher Wing",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MXuNQ8DWYL0QBJArTb7t"
 },
 {
  "Email": "miraf_bedru@yahoo.com",
  "Name": "Mearaf Bedru",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mc2KyubE7j5f8QbUeyKO"
 },
 {
  "Email": "williamshopewell@yahoo.com",
  "Name": "Williams Idorenyin",
  "Document Name": "NIGERIA) ICRC) BI 2020  NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/McDW0No0m7ijXpAElZvf"
 },
 {
  "Email": "Karim.Nassar@bakermckenzie.com",
  "Name": "Karim B. Nassar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mcuz0iTfBJKEOTVOOL77"
 },
 {
  "Email": "davielameck@yahoo.com",
  "Name": "Dave Lameck",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MdWDYzgTL2gD7ahDSvY6"
 },
 {
  "Email": "hmargaryan@fidelitylegal.am",
  "Name": "Hayk Margaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Me2gdOmYf1Ec6YTwUNxu"
 },
 {
  "Email": "o.chentsova@aequitas.kz",
  "Name": "Olga Chentsova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MfDF5LpY8Tp90a2KXI8C"
 },
 {
  "Email": "sam@arzinger.by",
  "Name": "Mr. Sergey Mashonsky",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_A&P.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MfUZfxVTAxFGw6cYv1VV"
 },
 {
  "Email": "gadi@lipameir.co.il",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MfZHDjxNnNXUIXA2aDMZ"
 },
 {
  "Email": "ffadahunsi@geplaw.com",
  "Name": "Mr. Olufemi Fadahunsi",
  "Document Name": "NIGERIA) GEPLAW) World Bank TPI Survey .docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MgjjqkLfu30LyPz0mFHw"
 },
 {
  "Email": "floriano@manesco.com.br",
  "Name": "Mr FLoriano Azevedo Marques",
  "Document Name": "19092209 WB Concession and PPP - Floriano de Azevedo Marques Neto.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MhL8li8vBVx3k5zG2gGO"
 },
 {
  "Email": "ashonubi@shonubimusoke.co.ug",
  "Name": "Alan Shonubi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MhUAXMkn3BInrWCcH2Vj"
 },
 {
  "Email": "soheila@educatedlawyers.com",
  "Name": "Soheila Rahimi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MjCZj6XEaPRvdNt8fCyB"
 },
 {
  "Email": "waleed.alshubaili@sa.ey.com",
  "Name": "Waleed Alshubaili",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MjJVegw9pw4y1EOjzG7f"
 },
 {
  "Email": "ain.kalme@triniti.ee",
  "Name": "Ain Kalma",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MjPlFVk5CulqfbGt6eYM"
 },
 {
  "Email": "jennifer.maxwell@blakes.com",
  "Name": "Jennifer Maxwell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mkj1W8ATq2sfLuboQ9Yg"
 },
 {
  "Email": "mhiromi@paulweiss.com",
  "Name": "Makiko Hiromi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MkjhDngBzuEkAkSkZhDw"
 },
 {
  "Email": "contact@austbar.asn.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ml25gkhbymrUvOksGIX3"
 },
 {
  "Email": "mwiyaman1@ymail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MlbRlX7VuXQFUtwzBuLb"
 },
 {
  "Email": "carlos.padilla@ppulegal.com",
  "Name": "Mr Carlos Padilla",
  "Document Name": "PPU-_8122162_V_1_TPI in Colombia - World Bank Survey 2020.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mlw0gHYvEYUotOBNImv9"
 },
 {
  "Email": "gwinkler@fbclawyers.com",
  "Name": "Gilad Winkler",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mm5WrXTLvtOmffp8PGW4"
 },
 {
  "Email": "david.hartley@addleshawgoddard.com",
  "Name": "David Hartley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MmyZuQ1Ou3cMSjEzMiIx"
 },
 {
  "Email": "info@gba.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MnHU9BpQgRpNuCSC4G5k"
 },
 {
  "Email": "safwan@omerabdelati.com",
  "Name": "Safwan Omerabdelati",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MnP5pOIMhCOWAHQNqtGO"
 },
 {
  "Email": "javier.guillen@hsf.com",
  "Name": "Dr Javier Guillen",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en july 2019.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MnlqL6owCkCX3nLnngQ5"
 },
 {
  "Email": "info@zhaktoo.on.kg�",
  "Name": "Nuru Khankeldieva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MnnzRX8TtZ462qAqLZcd"
 },
 {
  "Email": "aguibert@deloitte.com",
  "Name": "Mr. Armando Guibert",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en_Deloitte.doc",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MqN7nbS5KEYDwOmuKHOd"
 },
 {
  "Email": "mikeda@shearman.com",
  "Name": "Masahisa Ikeda",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MqyESWgxna8s7aLx0RWn"
 },
 {
  "Email": "info@transatlanticbusiness.org",
  "Name": "Tim Bennett",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mrf7FCiesuwDudKCGdgZ"
 },
 {
  "Email": "info@garberandco.com",
  "Name": "Derek Beoku-Betts",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MsBfrMKOQUylgh6lGYbY"
 },
 {
  "Email": "stanislav.cherkezov@wolftheiss.com",
  "Name": "Stanislav Cherkezov",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MsUtuUfhi9npA3uqzetK"
 },
 {
  "Email": "peter.kinkartz@scortia.com",
  "Name": "Peter Kinkartz",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MslUjwbwSpeyUNjfOZWV"
 },
 {
  "Email": "matwanje@stuttafordsmalawi.com",
  "Name": "Obet Matwanje",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MspZApIZjflGaX0j2Ks5"
 },
 {
  "Email": "sulaiman@tejansie.com",
  "Name": "Sulaiman Banja Tejan-Sie",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MstrCTH6aV9m9MOnxxdH"
 },
 {
  "Email": "p.msami@cbe.ac.tz",
  "Name": "Peter A. Msami",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MtiG67YCctAC7FoKwL8I"
 },
 {
  "Email": "smit@sjp.co.za",
  "Name": "Pierre Smit",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mu3glbgQP46gr9iXWJrG"
 },
 {
  "Email": "eric.rwelamira@zenithattorneys.com",
  "Name": "Eric Rwelamira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MvnkkkUZChfunlX9Cymj"
 },
 {
  "Email": "info@fccisl.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/MwwxKJHSTsbaEd71mKpV"
 },
 {
  "Email": "contact@rushydro.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mx0tcwTI3oiPOGXG5UiN"
 },
 {
  "Email": "hussein@gwlfs.com",
  "Name": "Abdirashid Hussein Mohammed",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Mz2QIg0TEuXYclTLo1ie"
 },
 {
  "Email": "igor.hanas@squirepb.com",
  "Name": "Mr. Igor Hanas",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_Squire.DOCX",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N00hT0WhRxgetxzleJN9"
 },
 {
  "Email": "jakkrit@tdri.or.th",
  "Name": "Jakkrit Kuanpoth",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N07vEjOTxMsk9TDTa5De"
 },
 {
  "Email": "sargis@lawyer.am",
  "Name": "Sargis Torosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N0B3mrvnaOQzgo3TGPRB"
 },
 {
  "Email": "anastasiia.zhebel@dlapiper.com",
  "Name": "Ms Anastasiia Zhebel",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en DLA.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N0Uk9iW3BBqiNLMfFqnA"
 },
 {
  "Email": "shenyi.thio@tsmp.com.sg",
  "Name": "Thio Shen Yi,Sc",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N0UzH1JOvyLAh85lOSAH"
 },
 {
  "Email": "tameratdelelegne@yahoo.com",
  "Name": "Tamerat Delelegne",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N0d5IhGoSHwnjtdVyXSV"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Mikhail Gerchuk",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N0pdWqFXJVolQSbgkFOJ"
 },
 {
  "Email": "jek@bechbruun.com",
  "Name": "Jesper Kaltoft",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N1ie6tKXRgNASVjurCyi"
 },
 {
  "Email": "himali.mudadeniya@fjgdesaram.com",
  "Name": "Himali Mudadeniya",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N1teJWHbfafKd2Dwb9hN"
 },
 {
  "Email": "info@tpsftz.org",
  "Name": "Angelina Ngalula",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N3lbVsKfBHmr5zDzAcn6"
 },
 {
  "Email": "lianseng.yap@stamfordlaw.com.sg",
  "Name": "Lian Seng Yap",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N4caMqJ1yXH7gXpNxDWy"
 },
 {
  "Email": "rcherney@dwpv.com",
  "Name": "Richard Cherney",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N5C6kkSpqoKGWwo7bgvV"
 },
 {
  "Email": "cmedina@central-law.com",
  "Name": "Ms Claribel Medina",
  "Document Name": "BI 2020 HND_bi_TPI_survey_en.Central.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N5FQjzmivy2s7qs4LWOz"
 },
 {
  "Email": "info@mohammedmuigai.com",
  "Name": "Miss. Wanjiru Ngige",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en-Wanjiru Ngige.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N5YIFhbGTWIQRF8sKgBh"
 },
 {
  "Email": "pjs@pjslaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N68ApYv8SrtIN51QPTp5"
 },
 {
  "Email": "A.Kornilova@aequitas.kz",
  "Name": "Anna Kornilova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N68j6SOqiDI108k5w1iv"
 },
 {
  "Email": "isaac@isaacseloko.co.bw",
  "Name": "Isaac Seloko",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N6wxW5QdGUKvzNGq9PCt"
 },
 {
  "Email": "info@daremblum.com",
  "Name": "Yuri Herrera",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N73LHCZEmI6jV506lNl1"
 },
 {
  "Email": "asonga5@hotmail.com",
  "Name": "Andrew Songa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N75fzEFzzgVTx5rZG2gL"
 },
 {
  "Email": "Peter.D.Raymond@us.pwc.com",
  "Name": "Peter Raymond",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N7X0rGMRqZ2mLWwkKLSh"
 },
 {
  "Email": "enquiries@sharpehoward.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N7vBEi3njD4bvZs0ESUk"
 },
 {
  "Email": "dostos@s-s.mx",
  "Name": "Mr. Diego Ostos",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en (230719).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N7xwiodZ1lSQzg2pcSp8"
 },
 {
  "Email": "sami.mir@allenovery.com",
  "Name": "Sami Mir",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/N9YFuJEwPUIsb4n5DLvd"
 },
 {
  "Email": "info@kdltt.com",
  "Name": "Marcus Knaggs",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NA1CfCujJCxkTb4JmQmT"
 },
 {
  "Email": "info@arcblue.co.nz",
  "Name": "Fiona Nissen",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NANNGtFYqZBme4qxdfg8"
 },
 {
  "Email": "rborrell@alcogal.com",
  "Name": "Mr. Ra�l Borrell Azc�rraga",
  "Document Name": "Benchmarking Infraestructure - 2020 (R. BORRELL - 5July2019).docx",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NAeAH2bKHkJOJiCSyn3Z"
 },
 {
  "Email": "martin.tamme@varul.com",
  "Name": "Martin Tamme",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NAm6mA1XzaKSbrwVIjBD"
 },
 {
  "Email": "maja@stanivukovic.rs",
  "Name": "Professor Maja Stanivukovi?",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_University of Novi Sad Law School.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NBBjt223PvZOxIhWFuXj"
 },
 {
  "Email": "psmines@pmc.gov.sb",
  "Name": "Don Tolio",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NBbInt1kYisst7Rkknn9"
 },
 {
  "Email": "patrick@oss.com.gh",
  "Name": "Patrick Amatey Sogbodjor",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NByWDiuyvGIcen47MxOu"
 },
 {
  "Email": "webmaster@njala.edu.sl",
  "Name": "Bob K. Conteh",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NC3FhRNu9M3AEJ9ksizq"
 },
 {
  "Email": "uys@signumlaw.com",
  "Name": "Mr Ulan Stybayev",
  "Document Name": "KAZAKHSTAN) SIGNUM) BI 2020 KAZ_bi_TPI_survey_en SIGNUM.docx",
  "Country": "KAZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NC3dbRFWEX72tK75r51r"
 },
 {
  "Email": "iberg@goodsman.ca",
  "Name": "Ira Berg",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NCYtc3OzbWJkAeA8apNN"
 },
 {
  "Email": "saleh.abdelati@zubilaw.com",
  "Name": "Mr. Saleh Abdel Ati",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Sharif.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ND32wypx5O3ZU6PusbJG"
 },
 {
  "Email": "maarja.pild@triniti.ee",
  "Name": "Maarja Pild",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NDVLAbQMlCQ1Utun2E2N"
 },
 {
  "Email": "a.marshall@britishchambers.org.uk",
  "Name": "Adam Marshall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NDabgBtg2MigOPwm9o7e"
 },
 {
  "Email": "phongsak.a@bwm-group.com",
  "Name": "Phongsak Assakul",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NDm4lY3TrZ4Z1gdANP7G"
 },
 {
  "Email": "rasikder@khossain.com",
  "Name": "Mr. Ramzan Ali Sikder",
  "Document Name": "BANGLADESH) KAMAL) BI 2020 BGD_bi_PPP_survey_en_26 08 2019.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NE3fbk7CNvnTzp7Bissd"
 },
 {
  "Email": "kfujihira@mofo.com",
  "Name": "Katsuhiko Fugihira",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NEU3D8kQthzWrK9fwwif"
 },
 {
  "Email": "info@etabrizi.com",
  "Name": "Hussein Taleghani",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NF1BKE7oD6LSGsKFDHQp"
 },
 {
  "Email": "marcioalabarce@hotmail.com",
  "Name": "Mr. Marcio Roberto Alabarce",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en[2169].docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NFOi0zU5C1HaepDx9lau"
 },
 {
  "Email": "sj.macoun@hopgoodganim.com.au",
  "Name": "Sarah Macoun",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NFZfByWlIwqUVgrEuIJb"
 },
 {
  "Email": "juliet.reingold@simmons-simmons.com",
  "Name": "Juliet Reingold",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NGeGh1KITJ728RqQwSJA"
 },
 {
  "Email": "robert.thoms@hejailanlaw.com",
  "Name": "Robert Thoms",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NGzeY0aYNS2EEwt6N6ob"
 },
 {
  "Email": "fthorn@deloitte.com.au",
  "Name": "Fran Thorn",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NHM7ud6XYLeDaSfElz1O"
 },
 {
  "Email": "yogan.reddy@za.pwc.com",
  "Name": "Yogan Reddy",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NIJZ00XvbIpSB1TzJR90"
 },
 {
  "Email": "tommyp@fcc.co.nz",
  "Name": "Tommy Parker",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NKDUc2Hh1pakZXGViQHr"
 },
 {
  "Email": "viktor@lauspartners.ee",
  "Name": "Victor Sagarva",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NKlWKNXpzKsnvnD55UiL"
 },
 {
  "Email": "sstavros@kpmg.com.au",
  "Name": "Stanislav Stavros",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NKmqMNlYSAtBjQ1HTwVD"
 },
 {
  "Email": "jim.buchanan@blplaw.com",
  "Name": "Jim Buchanan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NL5aiAdIBhUMduICttdt"
 },
 {
  "Email": "Neil.Donoghue@bakermckenzie.com",
  "Name": "Neil Donoghue",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NLdH6dLJzHthIgsnYPAn"
 },
 {
  "Email": "ccarvajal@lloredacamacho.com",
  "Name": "Mr. Carlos Carvajal",
  "Document Name": "1340022.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NMniYoUBNY0DdPB3cgkS"
 },
 {
  "Email": "aisulu.chubarova@arte-ip.kg",
  "Name": "Aisulu Chubarova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NN4wwEMbhawb5rKyFm68"
 },
 {
  "Email": "wilbert.kapinga@mkono.com",
  "Name": "Wilbert Kapinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NNLrwdXP6F3qDnHdiK3G"
 },
 {
  "Email": "Aragltd@arminco.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NNjLlYOkrB5dk2jXArbx"
 },
 {
  "Email": "bedalken@malawi.net",
  "Name": "Masauko Msungama",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NNpSE45x4nCTXQa07BrI"
 },
 {
  "Email": "lbatiashvili@ppp.gov.ge",
  "Name": "Mr. Levan Batiashvili",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_PO_PPP Agency.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NO5mxCxuDfLnmtmYgmdd"
 },
 {
  "Email": "mandria.sua@nus.edu.ws",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NOAfdgocHvpxDca9YhqY"
 },
 {
  "Email": "kusunoki@k-i.jp",
  "Name": "Mr. Keitaro Kusunoki",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en KI&S 20190709.docx",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NOEovo3t9lc1XRe7RGZn"
 },
 {
  "Email": "danao@arnon.co.il",
  "Name": "Dana Ofer-Nutkevitch",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NOhNuQr8PdohzVCmvKv7"
 },
 {
  "Email": "teddi.rull@sirel.com",
  "Name": "Teddi Rull",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NPQAWkw5weetpwA4naMW"
 },
 {
  "Email": "atyebkhan@sudathpereraassociates.com",
  "Name": "Ali Tyebkhan",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NPvNGqvz6VNQxolwnybL"
 },
 {
  "Email": "chiaboonteck@chiawongchambers.com",
  "Name": "Chia Boon Teck",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NQPQe4sjOJD4Jql8AK1T"
 },
 {
  "Email": "info.slc@liebherr.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NRSxjJViOlsQaIeOyIc0"
 },
 {
  "Email": "adolfo.pulgar@icloud.com",
  "Name": "Mr. Adolfo Pulgar Soarez",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_AdolfoPulgar.docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NSUcidzCxIgeedtTz2Sf"
 },
 {
  "Email": "tdambe@minchinkelly.bw",
  "Name": "Terence Dambe",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NSVv4mzTPcRAUPqjO1cK"
 },
 {
  "Email": "rvydra@whitecase.com",
  "Name": "Robert Vydra",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NSabDKijUcr4uj2AIaXt"
 },
 {
  "Email": "info@vdma.co.za",
  "Name": "Pieter Van Der Merwe",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NT2Zh3NuM6u8QisAjKwc"
 },
 {
  "Email": "amanzanares@consortiumlegal.com",
  "Name": "Oscar Armando Manzanares Diaz",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NTmJtW9tE8xtrhIc5jO8"
 },
 {
  "Email": "moeti@kanyane.co.za",
  "Name": "Moeti Kanyane",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NUVEsa8S6cFOs1j9x18r"
 },
 {
  "Email": "yara.aleman@ariaslaw.com",
  "Name": "title Yara Valesia Alem�n Sequeira",
  "Document Name": "BI 2020 NIC_bi_PPP_survey_en (REV).docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NVsxmD7rZPTHMVwUkk7o"
 },
 {
  "Email": "asar@asarlegal.com",
  "Name": "Mrs Akusa Batwala",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_ASAR_Batwala.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NWC4ZoIwbf60iYsSNcKh"
 },
 {
  "Email": "kcasey@mofo.com",
  "Name": "Kevin Micheal",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NWPFJuM8paV90pXkf0Rw"
 },
 {
  "Email": "svetlana.shtopol@integrites.com",
  "Name": "Svetlana Shtopol",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NXb3pHm3qcjRcG2ppn4U"
 },
 {
  "Email": "dsookram@kpmg.co.tt",
  "Name": "Dushyant Sookram",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NXzy2ZgqIbeaG4U3y7PC"
 },
 {
  "Email": "v.b.kondr@imemo.ru",
  "Name": "Vladimir Kondratiev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NYMxT8zANZri3EFv9o1f"
 },
 {
  "Email": "tim.sunar@blakes.com",
  "Name": "Tim Sunar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NYgAAareaaPIKzQ38FSA"
 },
 {
  "Email": "antonio.mazzucco@mazzuccoemello.com",
  "Name": "Mr. Antonio Mazzucco",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en 07 11 2019 - M&M.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NYoXdjJalmDn3a39Bhhb"
 },
 {
  "Email": "sonkita@cardinalchambers.org",
  "Name": "Sonkita Conteh",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NZ309Zr83bQE7yoDwmVV"
 },
 {
  "Email": "ekoehler@huntonak.com",
  "Name": "Mr. Edward Koehler",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nbq9Y1qTbVbPF1fgHXmx"
 },
 {
  "Email": "phe@bechbruun.com",
  "Name": "Per Hemmer",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NdeO7UHEA2sIR68JUX1a"
 },
 {
  "Email": "kiluange.tiny@cfa-lawfirm.com",
  "Name": "Dr Kiluange Tiny",
  "Document Name": "BI_2020_AGO_bi_PPP_survey_CFA.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ne0hx49Hh35HJmUaMFla"
 },
 {
  "Email": "ldavies@velaw.com",
  "Name": "Lauren Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nf6rKRtQyr0t6gHzLhGU"
 },
 {
  "Email": "andrew.pritchard@nortonrosefulbright.com",
  "Name": "Andrew Pritchard",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NgFDexeGb2TxLrPoa0eK"
 },
 {
  "Email": "allen.mazengarb@abmm.co.nz",
  "Name": "Allen Mazengarb",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NgK0vsP4fcETwkaOpgsz"
 },
 {
  "Email": "dlittle@fasken.com",
  "Name": "David W. Little",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NggFuxKM4Ae7zsOQg0VU"
 },
 {
  "Email": "rglyn@glynmarais.co.za",
  "Name": "Richard Glyn",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ngqj3u2hw6B1y9Tuiw9u"
 },
 {
  "Email": "proyectos@fedecamarahn.org",
  "Name": "Ocdulio Fernando Hern�ndez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nh9XTeRWIYHtGoC8arW6"
 },
 {
  "Email": "getachewart@yahoo.com",
  "Name": "Getachew Sisay Kebede",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NhHnztlAvkqS63UBkJge"
 },
 {
  "Email": "richard.goodfellow@addleshawgoddard.com",
  "Name": "Richard Goodfellow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NiLrJSOyNn36r4Bsyz6x"
 },
 {
  "Email": "sozolaw@ncs.com",
  "Name": "Gertrude Araba Torkornoo",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nk0i1YH4PGCq5UjpjqfN"
 },
 {
  "Email": "anavasardian@gmail.com",
  "Name": "Arman Navasardian",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NmLkbPQvsuDtnOda37Iu"
 },
 {
  "Email": "stickler@redeker.de",
  "Name": "Dr Thomas Stickler",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NmO7L4SwyljMjX4fwrMy"
 },
 {
  "Email": "botswana@smec.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NnKlSlsb2tkSzXNWmLxU"
 },
 {
  "Email": "laura.perez@ariaslaw.com",
  "Name": "Laura Perez",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en CCG FINAL.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nnhub4yOXAD6QU7ggBui"
 },
 {
  "Email": "jherrera@consortiumlegal.com",
  "Name": "Juan De Dios Herrera Orizola",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nno9C5Gh0sQyG738EXN0"
 },
 {
  "Email": "allison.page@dlapiper.com",
  "Name": "Allison Page",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NoiEIMOd3PoneMyhyyE7"
 },
 {
  "Email": "doe.tsikata@reindorfchambers.com",
  "Name": "Doe Tsikata",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Np9V9oxPGJhCOD1MN72U"
 },
 {
  "Email": "Silje.Sander@ee.ey.com",
  "Name": "Silge Sander",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NqDAcjrNv6KB8Z5N6nos"
 },
 {
  "Email": "bruno.bojic@komorabih.ba",
  "Name": "Bruno Bojic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nqp8ip0WM9PCWRWMJxBu"
 },
 {
  "Email": "uchechi.ibeku@advocaat-law.com",
  "Name": "Ms. Uchechi Ibeku",
  "Document Name": "NIGERIA) ADVOCAAT) BI 2020 NGA_bi_PPP_survey_en (004).docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ns8PXBud6WaMsp0qWq5W"
 },
 {
  "Email": "david.mcgowan@cms-cmck.com",
  "Name": "David Mcgowan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NuSMfo77ljpkDtUkaoAn"
 },
 {
  "Email": "aalfozan@kpmg.com",
  "Name": "Abdullah Al Fozan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NuxlHTuPwU1TJKSoy3TA"
 },
 {
  "Email": "tatsuhiko.kamiyama@cliffordchance.com",
  "Name": "Tatsuhiko Kamiyama",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Nv6R86JrovQ7qzjRV6or"
 },
 {
  "Email": "miguel.melgar@garciabodan.com",
  "Name": "Miguel Melgar Guevara",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NwRghUxlRsOZuEny0yyJ"
 },
 {
  "Email": "ibuffone@modernizacion.gob.ar",
  "Name": "Ivan Buffone",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en 9.10.19.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NwycBTNHg1OwzB7d7CjK"
 },
 {
  "Email": "grigoryev@vegaslex.ru",
  "Name": "Maxim Grigoryev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NyDgts4nK8Beu5Ctq7QE"
 },
 {
  "Email": "mja_lukwaro@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NyPOcu1YGmsiclFB9yzu"
 },
 {
  "Email": "carlos.camacho@ariaslaw.com",
  "Name": "Mr CarlosF Camacho",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en-CCG  Final.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/NyPx6ZTcwk3aC4VyKjEj"
 },
 {
  "Email": "andrew.harmos@hhl.co.nz",
  "Name": "Andrew Harmos",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O00EL0VYMulJ3MRBESvR"
 },
 {
  "Email": "cg.fuentes@deloitte.com",
  "Name": "Ms Cosette Fuentes",
  "Document Name": "BI 2020 SLV_bi_PPP_survey_en (deloitte CF).docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O0aaBMJh5DGZkabTPKAY"
 },
 {
  "Email": "rkonale@mid.gov.sb",
  "Name": "Rodney Konare",
  "Document Name": "BI 2020 SLB_bi_PPP_survey_en Dulcie Ausuta 15Jul19.docx",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O0eabhyDXnuXWfXBlmzo"
 },
 {
  "Email": "jjmarigomen@punolaw.com",
  "Name": "Joseph J. Marigomen",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O0uzuHHJYDrZ0cMoZPHw"
 },
 {
  "Email": "m.bayatkomitki@gmail.com",
  "Name": "Mahnaz Bayat Komitaki",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O1CX9Xj6rfWZSiQbz0SB"
 },
 {
  "Email": "nigel.boardman@slaughterandmay.com",
  "Name": "Nigel Boardman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O1LR3zSHZNWcbRcmfPrm"
 },
 {
  "Email": "elshafieyh@bennettjones.com",
  "Name": "Hasan El-Shafiey",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O1e3IeK0R0CPSGqZDPzX"
 },
 {
  "Email": "de@amchamhonduras.org",
  "Name": "Lizanka Guevara",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O1gTq0BnURSyUs2hdywZ"
 },
 {
  "Email": "ejoujou@kpmg.com",
  "Name": "Edgard Joujou",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O23hqq4D04q0U18CsMzy"
 },
 {
  "Email": "Chiquie.posman@posman.com",
  "Name": "Chiquie Posman",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O2BZeaZG0vCosInTts9k"
 },
 {
  "Email": "sharewerk@gmail.com",
  "Name": "Sharew Erkehun",
  "Document Name": "ETHIOPIA) PLAN AND DEVELOPMENT COMMISSION) BI 2020 ETH_bi_TPI_survey_en-1.docx",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O2FrJnUIipBNtzXW450w"
 },
 {
  "Email": "n.shahryar@ada.org.af",
  "Name": "Nangialay Shahryar",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O2g5nMEEsGdVhUJJ6oeU"
 },
 {
  "Email": "mads.dambaek@accura.dk",
  "Name": "Mads Kjellerup Damb�k",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O4ghgmZSaMgyHvKUkBJ7"
 },
 {
  "Email": "alvaro.almengor@hatstone.com",
  "Name": "Alvaro Almengor",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O4oQBbwo0BQxvoRp2ucr"
 },
 {
  "Email": "tomoko.nakajima@freshfields.com",
  "Name": "Tomoko Nakajima",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O5krQL7DRGBIdTBrnD4E"
 },
 {
  "Email": "sawogbade@aelex.com",
  "Name": "Soji Awogbade",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O7RGxHyI3uRwChhPcsPn"
 },
 {
  "Email": "ddepablos@dnp.gov.co",
  "Name": "Diego De Pablos Diego De Pablos",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en (002) answers Diego De PablosDNP2.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O7UuuVLF0r1X2qAq3wRW"
 },
 {
  "Email": "cresmetbrokers2007@yahoo.co.uk",
  "Name": "Gladys E.O Strasser-King",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O9Jx6PzuOI5I6b8QL0c1"
 },
 {
  "Email": "fiallos@lopezrodezno.com",
  "Name": "Fernando Fiallos Guti�rrez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/O9mlqJFuTXry6dZkHcvs"
 },
 {
  "Email": "karin.molder@magnussonlaw.com",
  "Name": "Karin M�lder",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OBYPRpSGTmqByxjv3K2l"
 },
 {
  "Email": "ldavies@velaw.com",
  "Name": "Lauren Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OBj6cTGMEgOrLV6GTJxF"
 },
 {
  "Email": "mitani@mmn-law.gr.jp",
  "Name": "Kakuji Mitani",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OCnDTb6zdjd0CiZRif6K"
 },
 {
  "Email": "piia.simmermann@glimstedt.ee",
  "Name": "Piia Simmermann",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OCoh92lwXrz7rRTzgoZg"
 },
 {
  "Email": "lhorn@goerg.de",
  "Name": "LUTZ HORN",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ODhBWUtvJ86gjoZcCmU4"
 },
 {
  "Email": "editayo@yahooo.com",
  "Name": "Editayo Pabs-Garnon",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OEG5Ffu50Z6YXPaej5Cf"
 },
 {
  "Email": "fitsuma@tadessekiros.com",
  "Name": "Fitsum Andargatchew",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OEctwg6xX0WOzr0s5vah"
 },
 {
  "Email": "awmodimo@modimos.co.bw",
  "Name": "Abel W. Modimo",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OF6YBVQbV7iaAP25a4UU"
 },
 {
  "Email": "chris.chesterman@burges-salmon.com",
  "Name": "Chris Chesterman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OG22EHOO263HEZ6fSPwD"
 },
 {
  "Email": "meekness@jordaanatt.co.za",
  "Name": "Katie Jordaan",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OGKEFZVGcwtwKLBUfTuW"
 },
 {
  "Email": "ahmad@albureau.com",
  "Name": "Ahmad Khalaf Masa'Deh",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OGMUTNniGPf1vuvbo8MH"
 },
 {
  "Email": "pawel.piotrowski@klgates.com",
  "Name": "Mr Pawel Piotrowski",
  "Document Name": "BI 2020 QAT_bi_PPP_survey_en_K&L.DOCX",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OHSSQFWa8W3BGccxvHg0"
 },
 {
  "Email": "david@tnklaw.co.za",
  "Name": "David Van Niekerk",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OIxOx7Wnx9C2KEo27PmU"
 },
 {
  "Email": "aisulu.chubarova@arte-ip.kg",
  "Name": "Aisulu Chubarova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OJQo464BDYCBIMkrT6GB"
 },
 {
  "Email": "fm.acosta@thefirmva.com",
  "Name": "Franchette M. Acosta",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OJRC5sO2Q7NQCcgBn1DQ"
 },
 {
  "Email": "Alexey.Frolov@bakermckenzie.com",
  "Name": "Alexey Frolov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OJVFsaaB1aVvrODUjTlH"
 },
 {
  "Email": "info@mekkiosman.com",
  "Name": "Mekki Osman",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OJZZ0SES1rFZl9lSQ5dM"
 },
 {
  "Email": "info@khassanov.kz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OKgMmEL956LmL8urMRqo"
 },
 {
  "Email": "charles.lloyd@uk.pwc.com",
  "Name": "Charles Lloyd",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OKmvl11sbsoN9biUv6Ur"
 },
 {
  "Email": "brendan.hundt@shearman.com",
  "Name": "Brendan Hundt",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OLaA2yYBmnsKwjbF7X2l"
 },
 {
  "Email": "Ngumo.j@dalyinamdar.co.ke",
  "Name": "Ms. Jacinta Ngumo",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en_DALY & INAMDAR.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ONSPrMrPRT698LnKKrMw"
 },
 {
  "Email": "acoxshall@kpmg.com",
  "Name": "Andrew Coxshall",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ONftHQ68RPKGOXPINXzZ"
 },
 {
  "Email": "jonathan.burns@dentons.com",
  "Name": "Jonathan Burns",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ONsNH6K1VE16P0fd4xkQ"
 },
 {
  "Email": "mmarchetti@toledomarchetti.com.br",
  "Name": "Mr. Marcelo Marchetti",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OOaAKLeTJX1H7YQu0Gxr"
 },
 {
  "Email": "ann.hawkins@skadden.com",
  "Name": "Ann Hawkins",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OP4WXqXQK2eABs65feyY"
 },
 {
  "Email": "jferraz@ensafrica.com",
  "Name": "John Ferraz",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OQGHjKeWWTzbtyDvFEI2"
 },
 {
  "Email": "kedli.anvelt@varul.com",
  "Name": "Kedli Anvelt",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OS8ghGmclM0SMVpl6woN"
 },
 {
  "Email": "refilwe.mokanse@treasury.gov.za",
  "Name": "Mr. Refilwe Mokanse",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_National Treasury.docx",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OSBRVrPixvjdntfyBx4S"
 },
 {
  "Email": "richard.gordon@cliffordchance.com",
  "Name": "Richard Gordon",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OSDxQ8CA2VUC91aYLTDz"
 },
 {
  "Email": "Amitg@ysl-law.com",
  "Name": "Amit Gur",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OSJy95gYwzMYh0qkpNIx"
 },
 {
  "Email": "chris.booth@kensingtonswan.com",
  "Name": "Chris Booth",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OU8aJAGybd6dlEd8wVV1"
 },
 {
  "Email": "sustaindeveth@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OUOkdDeWXeP0hBPzAmVN"
 },
 {
  "Email": "gsexton@abl.com.au",
  "Name": "Genevieve Sexton",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OVFiqrEelDh467QlGyux"
 },
 {
  "Email": "geoffrey.byamugisha@ug.ey.com",
  "Name": "Geofrey Byamugisha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OXDO9rqmuv7w6eIBgcjZ"
 },
 {
  "Email": "sstarace@delfinowillkie.com",
  "Name": "Mr. Sergio????? lStarace",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en 2_713406v1_Delfino e Associati Willkie Farr & Gallagher LLP.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OY1NVor1Pkd31kY1ixFz"
 },
 {
  "Email": "marvin.cespedes@pachecocoto.com",
  "Name": "Marvin Cespedes",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OYENZ6fgEYZenLRCROuI"
 },
 {
  "Email": "jessica@kimathilegal.com",
  "Name": "Ms Jessica Twumasi",
  "Document Name": "BI 2020 GHA_bi_TPI_survey_en KnPr 2.docx",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OYcj5FgET2h2j7vYqyl8"
 },
 {
  "Email": "stephanj@africon.co.za",
  "Name": "Stephan Jooste",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ObFBoDhhcspFshvFoqjY"
 },
 {
  "Email": "a.eyo@bangor.ac.uk",
  "Name": "Ama Eyo",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ObHk3xSxfNyu5pSmMn1P"
 },
 {
  "Email": "sdubovik@deloitte.ru",
  "Name": "Sergey Dubovik",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ObtvWS8k457cq7P785TE"
 },
 {
  "Email": "yvette.anthony@braddellbrothers.com",
  "Name": "Yvette Anthony",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OckiDXqzJeQVvPUmQMoT"
 },
 {
  "Email": "guru.gurumoorthi@rsm.co.bw",
  "Name": "Guru Gurumoorthi",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OdQTXESHAwqkaK8d6svb"
 },
 {
  "Email": "leahy@llls.com.pg",
  "Name": "John Leahy",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OdueBYpPjY0JKN3bHxlj"
 },
 {
  "Email": "torsten.syrbe@cliffordchance.com",
  "Name": "Torsten Syrbe",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OeZEJR7nmiHtORG11ecg"
 },
 {
  "Email": "panova@panova.com.mk",
  "Name": "Ms. Biljana PANOVA",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OfA9wiYPk8xY5G3jGZT0"
 },
 {
  "Email": "anirban.ghosh-dastidar@sc.com",
  "Name": "Anirvan Ghosh Dastidar",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OfVMFZCE3orntj5bTifz"
 },
 {
  "Email": "ishengoma@immma.co.tz",
  "Name": "Protase Ishengoma",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OfeDBcTBAQy8xwHQnWHV"
 },
 {
  "Email": "info@snclavalin.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ofm9kIDEBE2LBfcbPJUX"
 },
 {
  "Email": "cbuderi@curtis.com",
  "Name": "Charles Buderi",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OfmqLQ9ldeIepQ7S0I4N"
 },
 {
  "Email": "christopher.kodama@davispolk.com",
  "Name": "Christopher Kodama",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OfrS0upWvsdhyeUCM7Vj"
 },
 {
  "Email": "pearllim@witherskhattarwong.com",
  "Name": "Pearl Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oh5ctgG6Ttv10ZtwTzow"
 },
 {
  "Email": "info@hormuud.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OhDMvfNQfENywCaNGm8M"
 },
 {
  "Email": "livinginstandards@gmail.com",
  "Name": "Mr Amir Albashir",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_PPP Unit.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OhsdbJQ8RWEEUVIvDz3C"
 },
 {
  "Email": "junaid-chida@omm.com",
  "Name": "Junaid Chida",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OhtdhwXnrM8RV8iblcHF"
 },
 {
  "Email": "chanlf@straitslaw.com.sg",
  "Name": "Lai Foong Chan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OhxfnEaaKRCXJugPAO8C"
 },
 {
  "Email": "aorbelyan@deloitte.am",
  "Name": "Artur Orbelyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oi3lkaKtUexMS8cPgSWv"
 },
 {
  "Email": "ckariuki@tripleoklaw.com",
  "Name": "Catherine Kariuki",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en-Wanjiru Ngige.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oiux2HO49sfHmU2OCUID"
 },
 {
  "Email": "ahazlitt@omm.com",
  "Name": "Arthur Hazlitt",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OjPwrAULYn40qfhKZNZk"
 },
 {
  "Email": "info@gdcentr.ru",
  "Name": "Felix Issakovich Batkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OjrmYoX4sBxHVYyZuTL9"
 },
 {
  "Email": "abull@ulhoacanto.com.br",
  "Name": "Mr. Alberto Büll",
  "Document Name": "Concession Consolidado 10.07.2019 FINAL.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ojx6iIZiNDWS8Nh6GnpI"
 },
 {
  "Email": "info@bdo.tj",
  "Name": "Daler Sirojiddinov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OlBWEehhw6nsfjXIIQb6"
 },
 {
  "Email": "richard.budge@dentons.com",
  "Name": "Richard Budge",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OlNOPyuhC339ZHlAq1ch"
 },
 {
  "Email": "info@jaalo.com�",
  "Name": "Ayyoub Mansouri Razi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OmlVoam0yjxRZ9eXWNDY"
 },
 {
  "Email": "kkikuchi@tmi.gr.jp",
  "Name": "Kiyomi Kikuchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OnRnEy2zrTHWq0dg95Tp"
 },
 {
  "Email": "ignacio.flores@ariaslaw.com",
  "Name": "Mr. Ignacio Flores",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en CCG FINAL.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Onx9Pm5suotXRvsUFqAv"
 },
 {
  "Email": "V.Bakshinskas@adm.gazprom.ru",
  "Name": "Vitautas Bashinskas",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OoUjnFd8omUpzB8kmJ7J"
 },
 {
  "Email": "rtaylor@bbcgrp.com",
  "Name": "Richard C. Taylor",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ooa2dnVxlhwZ44FzigKR"
 },
 {
  "Email": "james.quinney@hsf.com",
  "Name": "James Quinney",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OosdaYIXTTO37QSuB85K"
 },
 {
  "Email": "omelara@malarayasociados.com",
  "Name": "Oscar Armando Manzanares Diaz",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OplfDtEc2Gu7Z4lNhL6v"
 },
 {
  "Email": "dhorner@HuntonAK.com",
  "Name": "David B. Horner",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oq5vuSOvXNzxRFYgkt6a"
 },
 {
  "Email": "gtoebben@lachamber.com",
  "Name": "Gary Toebben",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OqJAiAPsiXLDVxOUTNkC"
 },
 {
  "Email": "fbl@londonmet.ac.uk",
  "Name": "John Davies",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Or7jEeykxJbJ9Hss10sJ"
 },
 {
  "Email": "joji.ozawa@shearman.com",
  "Name": "Joji Ozawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OsSlQdKXk4KWJoesp8WW"
 },
 {
  "Email": "mallozzi@fbattorneys.com",
  "Name": "Alex Mallozzi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Otw5wKfnEUMsoeIwcXB0"
 },
 {
  "Email": "yemerun@yencomad.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oty7H20WqT3sRnMB9FCC"
 },
 {
  "Email": "nottbusch@bmt.eu",
  "Name": "Claudia Nottbusch",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OwClqrs5cYWHVGPPWN6J"
 },
 {
  "Email": "ChiLieu.Dang@bakermckenzie.com",
  "Name": "Mr. Chi Lieu Dang",
  "Document Name": "PPP_BakerMckenzie_Vietnam_en.DOCX",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OwX44GzNte88UdEbL6sH"
 },
 {
  "Email": "sagarwal@winston.com",
  "Name": "Shreyansi Agarwal",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OwqVtxdMfs3xKDQP5KF9"
 },
 {
  "Email": "cdewitt@txbiz.org",
  "Name": "Cathy Dewitt",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ows1SYlUcky0uARJvw3L"
 },
 {
  "Email": "jvastrup@kpmg.com.sg",
  "Name": "Mr Jacob Vastrup",
  "Document Name": "SINGAPORE) KPMG) BI 2020 SGP_bi_PPP_survey_en KPMG.docx",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OxXOxF8MtVtLEF0a8Wzs"
 },
 {
  "Email": "rsebastiano@osler.com",
  "Name": "Rocco Sebastiano",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Oxj2Ao1MeLP5TOdNM2QN"
 },
 {
  "Email": "sevak@lawyer.am",
  "Name": "Sevak Aleksanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OxjtWq8agpSBA8NZwfhk"
 },
 {
  "Email": "peter.doyle@au.kwm.com",
  "Name": "Peter Doyle",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OyP6S0Fl7u1JYVPQ4cAD"
 },
 {
  "Email": "a.abdurrahim@amoktarina.co",
  "Name": "Mr Aflah Abdurrahim S.H",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_an_Oktarina.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OyekDwonQmP15uVw7WBO"
 },
 {
  "Email": "jbeck@aecon.com",
  "Name": "John M. Beck",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/OzemKKZ2qpC3YDSlV5GW"
 },
 {
  "Email": "hrodriguez@nassarabogados.com",
  "Name": "Henry Rodriguez",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P26UU5VZ6TlcJohsQAJz"
 },
 {
  "Email": "getnet_yawkal@rocketmail.com",
  "Name": "Getnet Yawkal",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P45xzhGnibOiX9LpbXCk"
 },
 {
  "Email": "notificaciones@batalla.com",
  "Name": "Mr. / Ms. / Ms./ Mr Marco / Raquel / Pamela/Raúl Ureña / Salazar / Castro/Guevara",
  "Document Name": "20190717 CRI_bi_concession_survey_en Final.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P4QqIScIi9iXGe8XCg2X"
 },
 {
  "Email": "richard.bonnar@dlapiper.com",
  "Name": "Richard Bonnar",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P4tI6Y7MX70d5rmGjVUN"
 },
 {
  "Email": "pkambewa@cc.ac.mw",
  "Name": "Patrick Kambewa",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P5OXlWY3gFPsfYCypjnt"
 },
 {
  "Email": "j.tenizbaeva@lorenz-law.com",
  "Name": "Mrs Jibek Tenizbaeva",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_Lorenz.doc",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P62MwYQJJv0Gxv0knWMx"
 },
 {
  "Email": "gavin.margetson@hsf.com",
  "Name": "Gavin Margetson",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P6ArxVgJzGA6a19gV7XL"
 },
 {
  "Email": "executivedirector@panamcham.com",
  "Name": "Marcelo Gorrini",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P6Gqg1HiytA6sOEwS5Ol"
 },
 {
  "Email": "gjorgji.georgievski@odilaw.com",
  "Name": "Mr. Gjorgji Georgievski",
  "Document Name": "BI_2020 MKD_bi_PPP_survey_en_ODI.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P6PwKGfSzBy1bPfOZBSH"
 },
 {
  "Email": "geoffrey.byamugisha@ug.ey.com",
  "Name": "Geofrey Byamugisha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P6YRTMLgVFtkijcXyE3R"
 },
 {
  "Email": "ecobankenquiries@ecobank.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P7GTrm6tIQWdsJZIGFOH"
 },
 {
  "Email": "ajit.kapadia@mkono.com",
  "Name": "Ajit Manikant Kapadia",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P7qh2K99KUT0p9reFUZg"
 },
 {
  "Email": "enaikoba@governancesystemsug.org",
  "Name": "Eunice Naikoba",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/P8BhFrpd234CclQwPSes"
 },
 {
  "Email": "sbarbaran@beccarvarela.com",
  "Name": "Mr. Santiago Barbar�n",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PA1JfzRXRw5XuYwAW6lv"
 },
 {
  "Email": "hosam.ghaith@allenovery.com",
  "Name": "Hosam Ghaith",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PABjLo61Xx3dEaZBmFPo"
 },
 {
  "Email": "ahidalgo@lloredacamacho.com",
  "Name": "Mr Andres Hidalgo",
  "Document Name": "1340022.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PAFgQORiOF2oPL3C0X32"
 },
 {
  "Email": "mpabanga@mopipi.ub.bw",
  "Name": "Dorothy Mpabanga",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PBDuyAC5qdnPUuo9tk4p"
 },
 {
  "Email": "ekaterina.nekrasova@ru.pwc.com",
  "Name": "Ekaterina Nekrasova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PCiVfzQgFoY08IxhifyK"
 },
 {
  "Email": "mst@horten.dk",
  "Name": "Martin St�hr",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PEZzwB6dcrkk9pz1ZtkO"
 },
 {
  "Email": "mail@sudan-laws.com",
  "Name": "Eshraga Fadla",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PFPOiyN6abvDs9DG4CVv"
 },
 {
  "Email": "graeme.quigley@webbhenderson.com",
  "Name": "Graeme Quigley",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PFyucHgsJOwbLTtvWwya"
 },
 {
  "Email": "f.azizov@aaa.tj",
  "Name": "Farhad Azizov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PGFydWdhxVqMJHR1DUZt"
 },
 {
  "Email": "tbilisi@gratanet.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PGHNAhWrPXPdJEWLiuyR"
 },
 {
  "Email": "juan.fischer@andersentaxlegal.uy",
  "Name": "Dr. Juan Fischer",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en FedericoFormentoATLU.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PGIH8nGhU4qU3dcaydjd"
 },
 {
  "Email": "ewadlington@dcchamber.org",
  "Name": "Erika Wadlington",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PGWQgDyFqjcXdRElgVBB"
 },
 {
  "Email": "juanfernando.gaviria@ppulegal.com",
  "Name": "Mr Juan Fernando Gaviria",
  "Document Name": "PPU-_7979994_V_1_Benchmarking Infrastructure PPPs in Colombia 2020 - World Bank Group Survey.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PHBwkSiwJjdkYPRXnGrs"
 },
 {
  "Email": "aequitas@aequitas.kz",
  "Name": "Raushan Zhazykbaeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PHKPYUwbswnrOQs8C3Pf"
 },
 {
  "Email": "oda.wedemeyer@gsk.de",
  "Name": "Oda Wedemeyer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PHXKkfriQEmzOzFxECjM"
 },
 {
  "Email": "pepsit@cmclaw.co.bw",
  "Name": "Patient S. Thuto",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PInApurKMpZYa4DSRaXL"
 },
 {
  "Email": "charles.ochsner@pplex.jp",
  "Name": "Charles Ochsner",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PIwSp3i8OZVF2kaaSzkj"
 },
 {
  "Email": "andreas.ziegler@allenovery.com",
  "Name": "Andreas Ziegler",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PJVKpT3YaUQHDvJkbL8M"
 },
 {
  "Email": "amtafya@nexlawadvocates.com",
  "Name": "Ayoub Mtafya",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PJhyp1RI9nKnZRpkJQzQ"
 },
 {
  "Email": "zeyad.alsalloum@lfst.com",
  "Name": "Zeyad Alsalloum",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PKFiWFlupIOXi2kk2cWg"
 },
 {
  "Email": "tbk@winlaw.dk",
  "Name": "Trine B�gelund-Kj�r",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PKVjs3ady67bZZSSLCF5"
 },
 {
  "Email": "edgard@sucre.net",
  "Name": "Edgar Salomon Munoz M.",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PKroU8hrVF5vcRLhCw9q"
 },
 {
  "Email": "ratana@ctlo.com",
  "Name": "Ratana Poonsombudlert",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PLpxSKKOV3iZ5NvMLPBy"
 },
 {
  "Email": "prashanth.sabeshan@azbpartners.com",
  "Name": "Mr. Prashanth Sabeshan",
  "Document Name": "BI 2020 IND_bi_PPP_survey_en_ 02 08 2019.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PMYM4KfG9MOpGZs8FP4A"
 },
 {
  "Email": "ahannouche@hannouchelaw.com",
  "Name": "Alain Hannouche",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PMYezMe1bDSgPP7zN9tY"
 },
 {
  "Email": "info@lawyerofcostarica.com",
  "Name": "Giovanna Barrantes Esquivel",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PNl9zhR9Z62i8kmrOU0V"
 },
 {
  "Email": "cal@aguilarcastillolove.com",
  "Name": "title Carolina Aguirre Larios",
  "Document Name": "BI 2020 HND_bi_TPI_survey_en_AguilarCastilloCove.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PO2pS68DMBGFAMSR5qXY"
 },
 {
  "Email": "tara.chandler-scott@maddocks.com.au",
  "Name": "Tara Chandler-Scott",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/POoLcPt2E2DW07FhoQCt"
 },
 {
  "Email": "jus@snu.edu.so",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PPVkzdlVHT9fBbj1Gb5E"
 },
 {
  "Email": "fargo.group@fargomw.com",
  "Name": "Mukesh Juyal",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PQKvERVnra7iSy5KFnih"
 },
 {
  "Email": "oscarvasquez@accionciudadana.org.gt",
  "Name": "Oscar Vasquez Bocanegra",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PSKmSS6rn2C8vQCHPn85"
 },
 {
  "Email": "rtsu-1996@mail.ru",
  "Name": "Farid Mahmadaminova Aminova",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PSYuIWXApbcbXUxQzvmy"
 },
 {
  "Email": "kyamazaki@mofo.com",
  "Name": "Keiko Yamaziki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PStEpAQ1rbNhtBzj75X0"
 },
 {
  "Email": "uche.obi@alliancelf.com",
  "Name": "Mr Uche Obi",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_TPI_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PSxMyNLLbL8aiqgYb8VL"
 },
 {
  "Email": "contacto@viteriviteri.com�",
  "Name": "Maria Del Pilar Ogarrio Block",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PT81UbyoA8PmLSo2nPPu"
 },
 {
  "Email": "andrew.corletto@minterellison.com",
  "Name": "Andrew Corletto",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PTC6AXSElVXuHJXnhr4p"
 },
 {
  "Email": "arvindmahajan@kpmg.com",
  "Name": "Arvind Mahajan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PVhIqIiRUhsJe4Nmq5PQ"
 },
 {
  "Email": "tony.andriotis@hugheshubbard.com",
  "Name": "Tony Andriotis",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PWRUlLuvH8b7J5BKRRI8"
 },
 {
  "Email": "ahlersw@sullcrom.com",
  "Name": "Werner Ahlers",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PWYaDGZv90ENaGAIkIwL"
 },
 {
  "Email": "info@bdkd-berlin.de",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PWeUwqY4XUwRPBC22MHd"
 },
 {
  "Email": "AHarrison@blg.com",
  "Name": "Andrew Harrison",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PXiMY0GiI88DrQl0Hous"
 },
 {
  "Email": "pscommerce@pmc.gov.sb",
  "Name": "Jefferey Wikham",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PYApx4Eqp8oPvzBWfapD"
 },
 {
  "Email": "marketa.palenikova@econ.muni.cz",
  "Name": "Mark�ta P�len�kov�",
  "Document Name": "World_bank_PPP_Palenikova.docx",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PZTljDyH7QtAgERoPmNG"
 },
 {
  "Email": "ltufarelli@ristuf.it",
  "Name": "Mr. Luca Tufarelli",
  "Document Name": "BI 2020 ITA_bi_TPI_RandT.doc",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PavutEHNS2q9CK6x4aWM"
 },
 {
  "Email": "rdeyholos@torys.com",
  "Name": "Ron Deyholos",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PbcSMtClvtzw1QZYK1wj"
 },
 {
  "Email": "nick.collins@bakerbotts.com",
  "Name": "Nick Collins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pd2GecrojpoQiP6EI4kR"
 },
 {
  "Email": "priit.lember@derling.ee",
  "Name": "Priit Lember",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pd5q0CYGESkjcpndmbu5"
 },
 {
  "Email": "adina.chilim-dumitriu@nndkp.ro",
  "Name": "Ms. Adina Chilim-Dumitriu",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Nestor.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pe3Es1Tst4ZdICFJPutm"
 },
 {
  "Email": "jonathan.bevan@allenovery.com",
  "Name": "Jonathan Bevan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PeHwbbPhQNXYucv0pg41"
 },
 {
  "Email": "sales@parkaregroup.co.uk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pezq0EZ77fNrVux0wwzb"
 },
 {
  "Email": "ybumtsend@gratanet.com",
  "Name": "Ms Yanjmaa Bumtsend",
  "Document Name": "MONGOLIA) GRATA) BI 2020 MNG_bi_PPP_survey_en.docx",
  "Country": "MNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PfJ3CDmDSeyqQJZigfLm"
 },
 {
  "Email": "siyuanchen@smu.edu.sg",
  "Name": "Siyuan Chen",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PfbLH7OKjWnDHjqrOqY5"
 },
 {
  "Email": "maria@spb.amcham.ru",
  "Name": "Marian Chernobrovkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PfiY0RxVoxWYlKpCavpd"
 },
 {
  "Email": "benjamin.potter@davispolk.com",
  "Name": "Potter Benjamin",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pg3cwBad9oj2cbn7ybfW"
 },
 {
  "Email": "info@escom.mw",
  "Name": "David Kambauwa",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PgnsNlYYMRqvgoenbOdl"
 },
 {
  "Email": "craig@lawdogs.co.nz",
  "Name": "Craig Stevens",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PgpRWT6ztEkguE00rAMQ"
 },
 {
  "Email": "P.Soltani@iccima.ir",
  "Name": "Pedram Soultani",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pgwpup7ECJfYUEQpGJ3H"
 },
 {
  "Email": "Ethan.Walsh@BBKLaw.com",
  "Name": "Ethan Walsh",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pirea2yZoFnoF86SusRF"
 },
 {
  "Email": "abozaidlaw@yahoo.com",
  "Name": "Abdalla A. Abuzeid",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PjijjpaDheV106PVJKdd"
 },
 {
  "Email": "marija.serafimovska@odilaw.com",
  "Name": "Ms. Marija Serafimovska",
  "Document Name": "BI_2020 MKD_bi_PPP_survey_en_ODI.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PlXTAbzvxJojzc7msrg9"
 },
 {
  "Email": "cfmargai@yahoo.com",
  "Name": "Charles Margai",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pn30G6oLgtNC6G6Beu0F"
 },
 {
  "Email": "kamkasi@globemw.net",
  "Name": "Emily Makuta",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PnLJ4p8qrJRdtehUiXJ2"
 },
 {
  "Email": "NChernyavsky@sk.ua",
  "Name": "title Nazar Chernyavsky",
  "Document Name": "BI d2020 UKR_bi_TPI_survey_en.doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PndgyJm4p1AIEfprk82b"
 },
 {
  "Email": "gavin.booth@kpmg.co.uk",
  "Name": "Gavin Booth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PnrIpWpJGttg7K7zi6Tp"
 },
 {
  "Email": "adri@goldlaw.co.za",
  "Name": "Adrian� S Ludorf",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PnzcHGLaRgKT0QmqkJra"
 },
 {
  "Email": "sandra.ojaperv@sirel.com",
  "Name": "Sandra Ojaperv",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PoCfhMwkfHzKSDi8UZQY"
 },
 {
  "Email": "p.netzler_lagaaia@nus.edu.ws",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pp2XiQOduNOu8jk39cAC"
 },
 {
  "Email": "rajen@ranchhoojee.com",
  "Name": "Mr. Rajen Ranchhoojee",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_Orrick.docx",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PpetMV3m5oCMSbEY3Iwj"
 },
 {
  "Email": "toshiro.mochizuki@shearman.com",
  "Name": "Toshiro Mochizuki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PqKIUoTjsAJjqOtMhk61"
 },
 {
  "Email": "vahagn@lawyer.am",
  "Name": "Vahagn Dallakyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PqMDtLjBzydtGYRDDe0N"
 },
 {
  "Email": "n.peric@mprr.hr",
  "Name": "Ms. Natalija Peri",
  "Document Name": "CRO_20190627_survey_world_bank_PPP_procurement.docx",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pr6V8tRldqmhq8Yhptpb"
 },
 {
  "Email": "amelkumyan@prudencelegal.com",
  "Name": "Armen Melkumyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PrMG35XD5OUph78m4C7Z"
 },
 {
  "Email": "Richard.Wankmuller@ghd.com",
  "Name": "Richard Wankmuller",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PsH1o1jvr2tBf7rSl4pA"
 },
 {
  "Email": "avalderas@iridium-acs.com",
  "Name": "Adolfo Valderas",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PthZaZQBG0XuX5Cl44OH"
 },
 {
  "Email": "golinkconsulting@gmail.com",
  "Name": "Mr. Zhifeng Gao",
  "Document Name": "BI�2020CHN_bi_PPP_survey_en_GAO Zhifeng.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Puco7NsTCY7nRbJkUVx6"
 },
 {
  "Email": "geoff.hosking@ah.co.nz",
  "Name": "Geoff Hosking",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PvbD0qvxFWmictXqVM92"
 },
 {
  "Email": "klloyd@debevoise.com",
  "Name": "Kevin Lloyd",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pw9oGclgbpj0FZ36DCBH"
 },
 {
  "Email": "bruno.mweemba@iapri.org.zm",
  "Name": "Bruno Mweemba",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PwaQpZna0NJGcOirTyaV"
 },
 {
  "Email": "toomas.keevallik@keevallik.ee",
  "Name": "Toomas Keevallik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pwui9e4J9B4D4P6I66IV"
 },
 {
  "Email": "rterzian@bwslaw.com",
  "Name": "Richard Terzian",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PxW7Bzf03uJcuCGr7P50"
 },
 {
  "Email": "ross.pickmere@minterellison.co.nz",
  "Name": "Ross Pickmere",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PxeAzOqMmFqLGq70QcXn"
 },
 {
  "Email": "nerima@nnadvocates.com",
  "Name": "Nelson Nerima",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/PxsffDWPs1clMVah4cVl"
 },
 {
  "Email": "jlazarus@sfchamber.com",
  "Name": "Jim Lazarus",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Pzhplru4AL7HI8zoLXrO"
 },
 {
  "Email": "astpalata@mail.ru",
  "Name": "Tatiana Kononova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q0rqUSDrcSV8nznEj57d"
 },
 {
  "Email": "anjolus@ssconsultores.co.mz",
  "Name": "Angelo Inocentes Das Neves Salgado",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q1TGJs6OR2jLesFqsG3l"
 },
 {
  "Email": "Elizabeth.Hull@bbklaw.com",
  "Name": "Elizabeth Hull",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q1YUbxQgVGJFIiOOt3dG"
 },
 {
  "Email": "info@tinklerattorneys.co.za",
  "Name": "Gavin Ryan Tinkler",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q2M1nB0J6MxCU2bTWt06"
 },
 {
  "Email": "Dirgantara.Nugroho@makarim.com",
  "Name": "Mr Dirgantara Adi Nugroho",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Makarim v2.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q2cReetSSv4IhTTiAhSj"
 },
 {
  "Email": "info@lawfrontadvocates.co.tz",
  "Name": "Cornelius Mtaki",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q34zR5FINmkWaVJLobDt"
 },
 {
  "Email": "markdavis@kpmg.com.au",
  "Name": "Mark Davis",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q3E4pkQhv1bcd0ItOKmy"
 },
 {
  "Email": "ggelic@mccullough.com.au",
  "Name": "Goran Gelic",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q3RgYQJKXYLTsKZusnX3"
 },
 {
  "Email": "info@redcoalmana.com",
  "Name": "Monjid Abdelmajeed",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q3nrMDGbfVBfyFzoebRb"
 },
 {
  "Email": "orlaith.sheehy@mccannfitzgerald.com",
  "Name": "Ms Orlaith Sheehy",
  "Document Name": "IRL_World Bank - Benchmarking Infrastructure 2020 - Eamonn O Hanrahan response.docx",
  "Country": "IRL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q5OMAwY1CqBve7JYD7Fy"
 },
 {
  "Email": "lfontana@cov.com",
  "Name": "Lido Fontatna",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q65uRiq06ZaQqnFH4Rk5"
 },
 {
  "Email": "jadilio_celle@hacienda.gov.py",
  "Name": "Mr Adilio Celle",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en_Adilio_Celle_PY_03_10_2019.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q6WXxhYcf3QUznUWKh56"
 },
 {
  "Email": "f.rahman@as-associates.net",
  "Name": "Mr. Ferdausur Rahman",
  "Document Name": "BANGLADESH) AS ASSOCIATES) Benchmarking Infratructure PPP in Bd_Benchmarking Infrastructure 2020.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q78YGr8F3yuYX6g0T6nE"
 },
 {
  "Email": "Olexiy.Soshenko@redcliffe-partners.com",
  "Name": "Mr Olexiy Soshenko",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_RP comments_Rv.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q7X2wkvflRSJpVu5zGJ4"
 },
 {
  "Email": "malammar@alammarlaw.com",
  "Name": "Mohammed Alammar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q7ZBVvLGLZcEKij2vcGG"
 },
 {
  "Email": "mvmesquita@demarest.com.br",
  "Name": "Ms. Maria Virginia Mesquita",
  "Document Name": "DEMAREST_SP-#10961845-v1-2019_08_02_BI_2020_BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q7p4tUgOAU34DRtrA2EN"
 },
 {
  "Email": "megan.pearce@mc.co.nz",
  "Name": "Megan Pearce",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q7zCv3XBXwlNGXxxJu1u"
 },
 {
  "Email": "Michael.Schnitker@gtlaw.com",
  "Name": "Michael Schnitker",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Q8Wyxf25ttk9GdZ3VR78"
 },
 {
  "Email": "zhanna.babych@dlapiper.com",
  "Name": "Ms Zhanna Babych",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en DLA.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QB3DUBk949s9pNJ3uM4s"
 },
 {
  "Email": "s.karimi@kpu.edu.af",
  "Name": "Sebghatullah Karimi",
  "Document Name": "Sebghatullah AFG_bi_PPP_survey_en.docx",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QBoP11BF5cS0ATxrmbBB"
 },
 {
  "Email": "h.gill@nabarro.com",
  "Name": "Helen Gill",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QBq85XrNg9IR90Z1Eibq"
 },
 {
  "Email": "info@analyticamk.org",
  "Name": "Mrs Tamara Mijovi Spasova",
  "Document Name": "BI_2020 MKD_bi_PPP_survey_en_Analytica.doc",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QCJ4X4THdVmqyiR6pQ62"
 },
 {
  "Email": "arb@prcp.com.pe",
  "Name": "Mr. Alonso Rey",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_Payet - 4837-1645-6348 v. 3.doc",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QDaI6CDvmJ42nru01X16"
 },
 {
  "Email": "jacintho@sundfeld.adv.br",
  "Name": "Jacintho Arruda Câmara",
  "Document Name": "19092209 WB Concession and PPP - Floriano de Azevedo Marques Neto.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QEdYJk6q2Rj1ag5DXccy"
 },
 {
  "Email": "kelvin.wong@allenandgledhill.com",
  "Name": "Kelvin Wong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QEhB0zz3zybV4UqfonWw"
 },
 {
  "Email": "Info@simezasangwa.com",
  "Name": "Robert Simeza",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QGSyf4LmeksbfjTlCAkS"
 },
 {
  "Email": "wangch@ruc.edu.cn",
  "Name": "sir conghu lwang",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en_Conghu Wang.docx",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QGc61SU70tUc0tOqu0NQ"
 },
 {
  "Email": "zahid.safi@riaabg.com",
  "Name": "Mr. Zahid Safi",
  "Document Name": "RIAA BI 2020 AFG_bi_TPI_survey_en.docx",
  "Country": "AFG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QGhZFlnqOq5zmBfO5T2O"
 },
 {
  "Email": "juraj.fabijanic@dtb.hr",
  "Name": "Juraj Fabijanic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QHAhBLzNDVZKs0lJummz"
 },
 {
  "Email": "josina.correia@jcadvogados.co.mz",
  "Name": "Josina Correia",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QHpaBNom1J2LEiiNvEsc"
 },
 {
  "Email": "dar@dsouza.co.tz",
  "Name": "Zainab Lumato",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QIjPChrLfuAA2VXm9l1B"
 },
 {
  "Email": "nikolina.bacurin@cei.hr",
  "Name": "Nikolina Ba?urin",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QJCL6zKlzr6PsdxYT14t"
 },
 {
  "Email": "akos.szekely@ina.hr",
  "Name": "Akos Szekely",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QLOmWwytn7q8RsufFzSd"
 },
 {
  "Email": "london@grprainer.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QLTbNprPoO7qJZanyTQY"
 },
 {
  "Email": "eva-liisa.partel@varul.com",
  "Name": "Eva Liisa Partel",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QMDYs5x4rHOyH9PAXyzT"
 },
 {
  "Email": "sornpheth.douangdy@vdb-loi.com",
  "Name": "Mr Sornpheth Douangdy",
  "Document Name": "LAO) VDB-LOI) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QMhIPWoDyufl9E5bvx5N"
 },
 {
  "Email": "fevmendo@yahoo.com",
  "Name": "Maria Fe V. Mendoza",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QMpi9NasxVQrjXOWUzyL"
 },
 {
  "Email": "jcastellanos@latamlex.com",
  "Name": "Janet Castellanos Cruz",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QMrhNAKrWHerCI8HuyAu"
 },
 {
  "Email": "Kaishan.He@dfdl.com",
  "Name": "Ms Kaishan He",
  "Document Name": "LAO) DFDL) World Bank_Lao PDR PPP Survey_201819.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QOGg0kEJfAQa2sj8Z87m"
 },
 {
  "Email": "matthew.stott@ashurst.com",
  "Name": "Matthew Stott",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QP2gWzytIyqmKaN4yp2H"
 },
 {
  "Email": "fletcher@telsat.vu",
  "Name": "Tony Care",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QPGd9NxcFfkotpJP4G7N"
 },
 {
  "Email": "lawrence.carter@dlapiper.com",
  "Name": "Lawrence Carter",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QPOaKRCpKUVMhtMQifh7"
 },
 {
  "Email": "melipelie@yahoo.com",
  "Name": "M.A Davies",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QPfVpiZcNEQlh7QCgMLB"
 },
 {
  "Email": "mono@paulweiss.com",
  "Name": "Mie Ono",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QPqO7dL5wDSzPoHqaKnq"
 },
 {
  "Email": "jp.tenefrancia@cruzmarcelo.com",
  "Name": "Joe Nathan P. Tenefrancia",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QPsyuZKhOBH3OMA5ystv"
 },
 {
  "Email": "samakicheche@yahoo.com",
  "Name": "Hamisi Sama",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QRD5SgDxYeAEOcGPmzRx"
 },
 {
  "Email": "temur.phkhakadze@ge.ey.com",
  "Name": "Mr. Temur Phkhakadze",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en_EY.doc",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QRQt3qjrtNccpjCmQFIy"
 },
 {
  "Email": "ssingh@ensafrica.com",
  "Name": "Sasha Singh",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QRvQyP7p9NK9WXcR7WbF"
 },
 {
  "Email": "javierdaza@afra.com",
  "Name": "Mr. Javier J. Daza Rossi",
  "Document Name": "BI 2020 PAN_bi_PPP_survey_en1.docx",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QScqHYyWXh0r4I88JJUs"
 },
 {
  "Email": "f.huq@as-associates.net",
  "Name": "Ms. Faria Huq",
  "Document Name": "BANGLADESH) AS ASSOCIATES) Benchmarking Infratructure PPP in Bd_Benchmarking Infrastructure 2020.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QSkibValFB5S1LjaRoEB"
 },
 {
  "Email": "info@cipsa.com.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QTEJuIMtAYBGoVKBkS6X"
 },
 {
  "Email": "tekazelalem1@gmail.com",
  "Name": "Zelalem Teka Sima",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QW5Dc42uZGEMlueZjihM"
 },
 {
  "Email": "info@crbafricalegal.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QW6X67juWTpFh9aVECuq"
 },
 {
  "Email": "kusunoki@k-i.jp",
  "Name": "title Keitaro Kusunoki",
  "Document Name": "BI 2020 JPN_bi_TPI_survey_en KI&S 20190818.docx",
  "Country": "JPN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QWzbyiyBfpXUhhrgicIL"
 },
 {
  "Email": "ferdinand.jullaga@mkklaw.ne",
  "Name": "Mr Ferdinand Jullaga",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_MKK Law.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QXaEATh7adrDJYgmuQmm"
 },
 {
  "Email": "hans-joachim.priess@blomstein.com",
  "Name": "HANS-JOACHIM PRIESS",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QYtPAJSuCzDOXdJntrZ8"
 },
 {
  "Email": "ishengoma@immma.co.tz",
  "Name": "Protase Ishengoma",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QYwmHyt1g4DT9HKDk3kZ"
 },
 {
  "Email": "Florence.vanRavels@nautadutilh.com",
  "Name": "Mrs. Florence van Ravels",
  "Document Name": "PPP Survey_Netherlands_World Bank Group.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QZC8GmUOuboQpzb1dSWh"
 },
 {
  "Email": "suvad.bakic@lawoffice-bakic.ba",
  "Name": "Suvad Bakic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QaWUf7L7nY0xhmSIZjWh"
 },
 {
  "Email": "lasha.gogiberidze@bgi.ge",
  "Name": "Mr. Lasha Gogiberidze",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en (3).docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QaXlmTd9XmSqmdZo91al"
 },
 {
  "Email": "companysecretary@tullowoil.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QbYam5PBpxKf3Z4Fa5Yb"
 },
 {
  "Email": "teona.zakarashvili@transparency.ge",
  "Name": "Teona Zakarashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QbaLsQZrXvEF4F5NgHVk"
 },
 {
  "Email": "ka.palmer@auckland.ac.nz",
  "Name": "Ken Aitken Palmer",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QcoFInfQ9npcnefg3q2e"
 },
 {
  "Email": "alandodson@law.co.za",
  "Name": "Alan Dodson Sc",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QdPoSH2PIKExF1cn3lhk"
 },
 {
  "Email": "office@shabat-law.co.il",
  "Name": "Oren Shabat",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QdTq4iOa2P8rqQn9l70w"
 },
 {
  "Email": "mauricio@portugalribeiro.com.br",
  "Name": "Mauricio Portugal",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QeIIZBqxgARjZjpttW1v"
 },
 {
  "Email": "jfbustamante@bustamante.com.ec",
  "Name": "Mr. Juan Felipe Bustamante",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en.1.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QeIo5GgBYPUylsNeQwMD"
 },
 {
  "Email": "marcioalabarce@hotmail.com",
  "Name": "Mr. Marcio Roberto Alabarce",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (1)[2170].docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QgbxVlxo95EgV3qMoMOt"
 },
 {
  "Email": "candy.saga@mcmillan.ca",
  "Name": "Candy Saga",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QhsFHfVcG0Nrb5E8f5XJ"
 },
 {
  "Email": "d.varga@schoenherr.eu",
  "Name": "Mr. D�niel Varga",
  "Document Name": "HUNGARY) SCHOENHERR) BI 2020 HUN_bi_PPP_survey_en_SAchoenherr.docx",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QinweNWqHtrUDI6VH8il"
 },
 {
  "Email": "waleed.alshubaili@sa.ey.com",
  "Name": "Waleed Alshubaili",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QkUDpn6AV7yBFEzpl33Y"
 },
 {
  "Email": "kenneth.mack@dechert.com",
  "Name": "Kenneth Mack",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QlMbSo9a0Ke9LcKdCW0k"
 },
 {
  "Email": "p.telles@bangor.ac.uk",
  "Name": "Pedro Telles",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QlhI3yXUVB7jJkftTUHO"
 },
 {
  "Email": "asite.Talwatte@lk.ey.com",
  "Name": "Asite D.B.Talwatte",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QnawfHYs0oSvW1R5YGBh"
 },
 {
  "Email": "lit@tpprf.ru",
  "Name": "Sergey Katyrin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QqhRTe8KuXGku1FUjbpU"
 },
 {
  "Email": "bianca.soares@castrobarros.com.br",
  "Name": "Ms. Bianca Correia",
  "Document Name": "World Bank - Benchmarking Infrastructure -Concession2.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Qr8wT2CdWHDdVMUbXZt7"
 },
 {
  "Email": "bnyabira@ikm.co.ke",
  "Name": "Ms. Beatrice Nyabira",
  "Document Name": "KEN_bi_PPP_survey_en_Christine Murangi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QrNiVYlG1irrVkihrE02"
 },
 {
  "Email": "chagwamnjira@malawi.net",
  "Name": "Dick Chagwamnjira",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QrxJ2i7UWaja2lHgpAPU"
 },
 {
  "Email": "abn@bechbruun.com",
  "Name": "Anders Birkelund Nielsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QsD1V0MSMWf6ZHYU2qAw"
 },
 {
  "Email": "pbeaudoin@lavery.ca",
  "Name": "Pierre Beaudoin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QsWiSwMtFCsTgTzh723j"
 },
 {
  "Email": "audax.kameja@mkono.com",
  "Name": "(Rtd) Audax Kameja",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Qsj7PRy4a1JrB5U3Wrk0"
 },
 {
  "Email": "kardo.rander@hedman.ee",
  "Name": "Kardo Rander",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QtecVUCXGfpQyNUxybP9"
 },
 {
  "Email": "Calvin.Walker@bakermckenzie.com",
  "Name": "Calvin Walker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QuiADlB4ZPc9eYz6P7d3"
 },
 {
  "Email": "ursula.kosk@primus.legal",
  "Name": "Ursula Kosk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QunLh0RiYXYqSOiQJCaj"
 },
 {
  "Email": "safa@safalaw.com.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QvEZXrHeV6iEPcwDKxlF"
 },
 {
  "Email": "karen@durbanlawoffices.co.za",
  "Name": "Karen Anne Olivier",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QwIuGX3wAL2rStCvv1PA"
 },
 {
  "Email": "assel.m@colibrilaw.com",
  "Name": "Assel Meiramgaliyeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QwZsJ8YiO7BLuMH613ea"
 },
 {
  "Email": "ngaloadvocates@habari.co.tz",
  "Name": "Colman Mark Ngalo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QwgP0gepMXqIb4KHGkWy"
 },
 {
  "Email": "thomas.wilson@squirepb.com",
  "Name": "Thomas Wilson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Qx0tesOcbG1p8GI6xP8l"
 },
 {
  "Email": "lguinard@vvgm.com",
  "Name": "Luis E. Guinard Rennert",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QxN1kiMt0eNKJG9QtLsx"
 },
 {
  "Email": "chss@udom.ac.tz",
  "Name": "Baraka Gesona",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QxqWOF8VZaNE969bBO7T"
 },
 {
  "Email": "joneidi@ut.ac.ir",
  "Name": "Laya Jonaidi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QxzCXW6jOhaIznFXQbaK"
 },
 {
  "Email": "rizmaylova@whitecase.com",
  "Name": "Rimma Izmaylova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QyDJcfCa8rMy34GhiGcR"
 },
 {
  "Email": "coop@youssrysaleh.com",
  "Name": "MR Youssry Saleh",
  "Document Name": "BI 2020 EGY_bi_PPP_survey_en_Youssry.docx",
  "Country": "EGY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Qz3KcAAmExYOFfP9lcCa"
 },
 {
  "Email": "george.sayen@bakermckenzie.com",
  "Name": "George Sayen",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/QzC67VPEjTALPteh2hZK"
 },
 {
  "Email": "dschiappacasse@claro.cl",
  "Name": "Mr. Dino Schiappacasse",
  "Document Name": "CHILE) CLARO N CIA) BI 2020 CHL_bi_TPI_survey_en (Autoguardado).docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R0VTx99eky7JVstUAVWv"
 },
 {
  "Email": "nemanja.vasic@komorabih.ba",
  "Name": "Nemanja Vasic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R0XJxB28PEc90kKNUcAh"
 },
 {
  "Email": "sekaboyi@frosteeattorneys.co.tz",
  "Name": "Evarist Paul Sekaboyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R27OtjevufG9TYxWpxne"
 },
 {
  "Email": "peter.magambo@kaggapartners.com",
  "Name": "Peter Magambo",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R2qSu5YHfbu8MKqd3edI"
 },
 {
  "Email": "palonzo@scgg.gob,hn",
  "Name": "title Patricia Alonzo",
  "Document Name": "PO.BI 2020 HND_bi_TPI_survey_enONCAE27.7.2019.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R3HszmAFqNJzxrYUCyus"
 },
 {
  "Email": "gailoub.hashmi@gmail.com�",
  "Name": "Eli Gailoub",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R3NLrkYPwqSeekEvdVcn"
 },
 {
  "Email": "ana.argueta@gufalaw.com",
  "Name": "Ana Luz Argueta De Guilbert",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R3R1hc5B8TPscX3T3GHA"
 },
 {
  "Email": "giorgi.chanturia@bgi.ge",
  "Name": "Mr. Giorgi Chanturia",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en (3).docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R3f6B3gewVwHxE9N5Blx"
 },
 {
  "Email": "aline@pladvogados.com.br",
  "Name": "Ms. Aline L�cia Klein",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en.doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R3jr9rGGwncizC8MCJul"
 },
 {
  "Email": "gab.onojason@alliancelf.com",
  "Name": "Mr Gabriel Onojason",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_PPP_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R4xMaTaYUPm5hCcaypyp"
 },
 {
  "Email": "peter.swiecicki@squirepb.com",
  "Name": "Mr. Peter Swiecicki",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_Squire.DOCX",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R6nJPkuFAgSegLuaBcBg"
 },
 {
  "Email": "elwaleed.hussein@cbos.gov.sd",
  "Name": "Hussein Elwaleed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R7POwNrvR4S05VN2kgVf"
 },
 {
  "Email": "siaska.lorenzo@ariaslaw.com",
  "Name": "Siaska Sss Lorenzo",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R8GuFZ11Wo0JyG4fhA3C"
 },
 {
  "Email": "weverson@chamber.ca",
  "Name": "Warren Everson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R95NzJ68oZSiecLYOTgW"
 },
 {
  "Email": "dkemoklidze@mcageorgia.ge",
  "Name": "Dimitri Kemoklidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R9PKFTD3vQLJdsDjSFbQ"
 },
 {
  "Email": "frank.meininger@menoldbezler.de",
  "Name": "Frank Meininger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/R9gD1FkLEQUO4y4HyFeD"
 },
 {
  "Email": "katherine.calder@blplaw.com",
  "Name": "Katherine Calder",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RA30WW4bTDvyf350UeDh"
 },
 {
  "Email": "ssmyth@mccarthy.ca",
  "Name": "Sean S. Smyth",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RANElFashaWW4mQ4xTBY"
 },
 {
  "Email": "office@arte-ip.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RCHFUY7iqpKVBK21Tu6c"
 },
 {
  "Email": "greg.begaud@cbp.com.au",
  "Name": "Gregory Begaud",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RDC6lg3dDeITCboqkYia"
 },
 {
  "Email": "myoung@casselsbrock.com",
  "Name": "Mark I. Young",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RE14a8Y8ngldQSE8O7aW"
 },
 {
  "Email": "martin.talli@aaviklaw.ee",
  "Name": "Martin Talli",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RE4Puae0r7fsce7yKzro"
 },
 {
  "Email": "gerly.kask@hansalaw.ee",
  "Name": "Gerly Kask",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RED7CBEW4N0Xdj00Dd3Y"
 },
 {
  "Email": "jglopez@lopezrodezno.com",
  "Name": "Jorge L�pez Loewenberg",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RElL2c95eRwZLFozkmUp"
 },
 {
  "Email": "adolfo.pulgar@icloud..com",
  "Name": "Mr. Adolfo Pulgar Soarez",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en_AdolfoPulgar.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RFEuQZX65CbUHdOHP0Qu"
 },
 {
  "Email": "wael.alissa@dentons.com",
  "Name": "Wael Alissa",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RFhdcm3JyWiiVCL2Y4ns"
 },
 {
  "Email": "Phil.Montgomery@ghd.com",
  "Name": "Phil Montgomery",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RFu5v5bd23GtH7oV0Oyx"
 },
 {
  "Email": "oleksandr.kurdydyk@dlapiper.com",
  "Name": "Mr Oleksandr Kurdydyk",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en DLA.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RGP2jnVN59pwyIWPHnQ5"
 },
 {
  "Email": "manuel.gonzalez@mvgslaw.com",
  "Name": "Manuel Z Gonzalez",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RHVLIAtnSQqclRm01fc3"
 },
 {
  "Email": "bcastellanos@umg.edu.gt",
  "Name": "Benito Mariano Maza Castellanos",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RHlI2dkLQFH9sRunTqqZ"
 },
 {
  "Email": "jkyeyune@udbl.co.ug",
  "Name": "Peter Barugahara",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RIhDl1WERFE1n2U6ixeV"
 },
 {
  "Email": "salimabdullah42@yahoo.com",
  "Name": "Salim Abdullah",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RIkp6dZ3ufgddhhdOaCU"
 },
 {
  "Email": "alzayat@alzayatfirm.com",
  "Name": "Dr. Mahmoud Alzayat",
  "Document Name": "BI 2020 EGY_bi_PPP_survey_en_Alzayat.docx",
  "Country": "EGY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RItPNqnP3moHQCAAHxFr"
 },
 {
  "Email": "vjekoslav.ivancic@ostermann.hr",
  "Name": "Vjekoslav Ivancic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RKsglkFnbudDOtp6BDsu"
 },
 {
  "Email": "AWimmers@kmpg.co.nz",
  "Name": "Adrian Wimmers",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RL8uhSw1Bdddl8N8Wu4L"
 },
 {
  "Email": "nimrod.mkono@mkono.com",
  "Name": "Nimrod Mkono",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RLNo7MXYQtCaaKpsYWKG"
 },
 {
  "Email": "jack.chor@christopherleeong.com",
  "Name": "Mr. Jack Chor",
  "Document Name": "MALAYSIA) CHRISTOPHER N LEE) BI 2020 MYS_bi_PPP_survey_en.doc",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RLdfPD5gDomDYiu4sY70"
 },
 {
  "Email": "rodrigobertoccelli@felsberg.com.br",
  "Name": "Mr. Rodrigo de Pinho Bertoccelli",
  "Document Name": "Survey - Concession - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RLi7HYoUa83GUriDvDrE"
 },
 {
  "Email": "ddoxaki@chadbourne.com",
  "Name": "Despina Doxaki",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RMkf80DDVhL92aqfkOxL"
 },
 {
  "Email": "fsolis@fragomen.com",
  "Name": "Federico Solis",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RMmLCiS8yUbaAKtMvjUg"
 },
 {
  "Email": "bconway@uk.ey.com",
  "Name": "Bj�rn Conway",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RMwKXQtWJT3NxrJpxeDW"
 },
 {
  "Email": "genuineparts@eaglemotors.co.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RNe7BFP0dna7XN3CDF4D"
 },
 {
  "Email": "info@tdmconsulting.co.nz",
  "Name": "Kevin Marsh",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RNsRzjJmDgbYaQ8SndcB"
 },
 {
  "Email": "nerses@vardanyanlaw.com",
  "Name": "Nerses Isajanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RNu2JZ9ZVbLuJpazJ6bF"
 },
 {
  "Email": "plima@demarest.com.br",
  "Name": "Ms. Paloma Lima",
  "Document Name": "wb bench questionnaire PPPs.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RO4sw5K3VUa0l7a4YT5Y"
 },
 {
  "Email": "an@abmak.org",
  "Name": "Ms Aisha Naiga",
  "Document Name": "UGANDA) ABMAK) FINAL BI 2020 UGA_bi_TPI_survey_en.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ROGfcnz9CPV20GCF9dZa"
 },
 {
  "Email": "hhedayati@ku.edu.af",
  "Name": "Mohammad Hadi Hedayati",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ROX3wAC9FZKszrE5quPv"
 },
 {
  "Email": "michael.ledgett@dentons.com",
  "Name": "Micheal F. Ledgett",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ROq62zlWYJvGbBFTWe1Y"
 },
 {
  "Email": "andrew.jones@linklaters.com",
  "Name": "Andrew Jones",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RPiwJ9Hi7nP4kVgqGqwK"
 },
 {
  "Email": "archobanyan@me.com",
  "Name": "Artak Chobanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RRl2kBxmx4F2he5WTozB"
 },
 {
  "Email": "g.hawkins@ashfords.co.uk",
  "Name": "Giles Hawkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RTXYaUZAX3QtWB87fNAh"
 },
 {
  "Email": "aaghajanyan@deloitte.am",
  "Name": "Aren Aghajanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RUNauBoa6DtLkYxpdENi"
 },
 {
  "Email": "info@astanapartners.com",
  "Name": "Alex Verba",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RUfwxrEQMjiNZuekZlsT"
 },
 {
  "Email": "JFattorini@bmflegal.com",
  "Name": "Julia Fattorini",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RUqIZgYtW0NPDRHp4BM0"
 },
 {
  "Email": "tiro@sikhakhane.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RV3HXENAsdVa34q4tgWD"
 },
 {
  "Email": "info@mdic.com",
  "Name": "Hussein Rifai",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RVRawtA0AjxDa7PdPeF8"
 },
 {
  "Email": "aalbabtain@wanpartners.com",
  "Name": "Abdulaziz M. Al-Babtain",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RVgKGqBAfpE2ylSDfciE"
 },
 {
  "Email": "mugoya@mlhud.co.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RVt2zDoofKTUbdJkBaoC"
 },
 {
  "Email": "ccm@vda.pt",
  "Name": "Mrs. Catarina Coimbra",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en (002)_(DM 7606538_1) (002) (003).DOCX_(DM 7641292_1).DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RWiVaO0AXJHlNvHdo6XX"
 },
 {
  "Email": "adam.stapledon@allenovery.com",
  "Name": "Mr Adam Stapledon",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Allen & Overy.doc",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RY74yAZxZR7zZZrnuJXR"
 },
 {
  "Email": "mark.elsey@ashurst.com",
  "Name": "Mark Elsey",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RYRcylkZGNY5D7sgXQOQ"
 },
 {
  "Email": "haggar@arnon.co.il",
  "Name": "Haggar Moav",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RZST29OuTXlpEbk4Y78q"
 },
 {
  "Email": "leon.alexander@clydeco.com",
  "Name": "Leon Alexander",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RZWiUhyR0HslCe9yBYaP"
 },
 {
  "Email": "evelyn@dnkabugoadvocates.com",
  "Name": "Evelyn Zawedde Arocha",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RaJ7filTeVY0ceRJs5vB"
 },
 {
  "Email": "bertha.arguello@ariaslaw.com",
  "Name": "Ms. Bertha Arg�ello",
  "Document Name": "071919 2020 NIC PPP Survey .docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RbmUMYByIVwafN6MYXXk"
 },
 {
  "Email": "a.wong@nabarro.com",
  "Name": "Adrian Wong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RbpuAskjy7kPW44THuK5"
 },
 {
  "Email": "olga.revzina@hsf.com",
  "Name": "Olga Revzina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RcBKm6ME9Y4fUSQoiszc"
 },
 {
  "Email": "ysasson@meitar.com",
  "Name": "Yuval Z. Sasson",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RcLNXFOZxH7uZc2McbTk"
 },
 {
  "Email": "hadasch@buse.de",
  "Name": "Martina Hadasch",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RcOBoHAugit9cD4wyLsr"
 },
 {
  "Email": "pppcenterlaos@gmail.com",
  "Name": "Mr Sayphet Thun In Art",
  "Document Name": "LAO) PPP UNIT) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rctmg99wo0lHVDy6qrPY"
 },
 {
  "Email": "a.maharaj@polanc.com",
  "Name": "Amalia Maharaj",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RdTgd2M0ZxvmhUTUTQio"
 },
 {
  "Email": "pekka.puolakka@sorainen.com",
  "Name": "Pekka Puolakka",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RdXbBCST302X91hnjbA4"
 },
 {
  "Email": "carman.mcnary@dentons.com",
  "Name": "Carman R. Mcnary",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Re0U0E0Z25N3XPbLhXa2"
 },
 {
  "Email": "stayler@opp.gub.uy",
  "Name": "Ms. Silvana Tayler",
  "Document Name": "BbI 2020 URY_bi_PPP_survey_en.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ReAAvhK8UIk4VLLvwAT9"
 },
 {
  "Email": "nadeen.abushaqra@zubilaw.com",
  "Name": "Miss Nadeen Abu Shaqra",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Sharif.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ReC5Z9DTtM90WB7KWhLD"
 },
 {
  "Email": "David.vanEe@nautadutilh.com",
  "Name": "Mr. David van Ee",
  "Document Name": "PPP Survey_Netherlands_World Bank Group.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RgaNMea2TcUcXwaNMj2L"
 },
 {
  "Email": "ranui@greenwoodroche.com",
  "Name": "Ranui Calman",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RgrnTbuOvxSJUCX67LkQ"
 },
 {
  "Email": "heinz@lawyers.co.ck�",
  "Name": "Heinz Matyasik",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rhhm3zd5PoLWykBKXnpo"
 },
 {
  "Email": "nick.crennan@cbp.com.au",
  "Name": "Nick Crennan",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RiTiq3P4q5vzWdMxqoxI"
 },
 {
  "Email": "federico.formento@andersentaxlegal.uy",
  "Name": "Dr Federico Formento",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en FedericoFormentoATLU.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RjMjHzzG5w1LxmcO4Oap"
 },
 {
  "Email": "glahs@redeker.de",
  "Name": "Dr Heike Glahs",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rk7d2OC9GPTcRZTOyGra"
 },
 {
  "Email": "toomas@tehver.ee",
  "Name": "Toomas Laanema",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RkuK7x0gOWwIbmn0wvqN"
 },
 {
  "Email": "ccardozo@afd.gov.py",
  "Name": "Mr Cesar Cardozo",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en AFD.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RkvIFXxezdwuJ3UbRoUY"
 },
 {
  "Email": "rafael.veras@lllaw.com.br",
  "Name": "Mr. Rafael V�ras",
  "Document Name": "BRAZIL) VERAS DE FREITAS) BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rlp6MTGoBPC5rxNnnajE"
 },
 {
  "Email": "rap@machadoassociados.com.br",
  "Name": "Ms. Renata Almeida Pisaneschi",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en[2169].docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RmDiXFxAZYohb8adatVc"
 },
 {
  "Email": "erki.kergandberg@derling.ee",
  "Name": "Erki Kergandberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RmezEhGHeBCfX9BmgSST"
 },
 {
  "Email": "pnalvarte@rossellolaw.com",
  "Name": "Pierre Nalvarte",
  "Document Name": "MSM BI 2020 PER_bi_PPP_survey_en.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rmk6QLaSP6B4LIfVysh9"
 },
 {
  "Email": "s.ndikimi@ealc.co.tz",
  "Name": "Ms Stella Ndikimi",
  "Document Name": "Tanzania_EALC_TPI.docx",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rneu2ldXorUG8nrdk2em"
 },
 {
  "Email": "info@crlfsd.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ro29KL8foxz7j3y3IVQD"
 },
 {
  "Email": "hondaug@honda.co.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ro4xrlSS4BlbPh6Sv2sP"
 },
 {
  "Email": "qatar@tag-legal.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rq0QdUOMbnJsxuHOYVva"
 },
 {
  "Email": "dirk.uwer@hengeler.com",
  "Name": "Dirk Uwer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RqTywmM9CWE4Wy74a86i"
 },
 {
  "Email": "jnelson@trinioil.com",
  "Name": "Joannah Nelson",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RrMkkk1RktJFWC8QukPT"
 },
 {
  "Email": "legal@hoshanlaw.com",
  "Name": "Mohamed H. Al Hoshan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RtNUSQTUi96HtenoXhvT"
 },
 {
  "Email": "wilsonmorgan@malawi.net",
  "Name": "Arthur Alick Msowoya",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RtPOin5H5CbpIgX8s4vD"
 },
 {
  "Email": "senaykuflu23@gmail.com",
  "Name": "Mr. Senay Ghebremeskel",
  "Document Name": "WB Survey (BGM).docx",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RvcOeDqegO2PQ2MYbD4Y"
 },
 {
  "Email": "spou@ciccp.es",
  "Name": "Salvador Pou",
  "Document Name": "KSA BI_2020_MEX_bi_PPP_survey_en.DOC",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RvrCKvb9KP5egHDXwiW6"
 },
 {
  "Email": "maarja.varav@ebs.ee",
  "Name": "Maarja V�rav",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RwDdgU4ldsgQdkxrNtsM"
 },
 {
  "Email": "jsmith@lawsonlundell.com",
  "Name": "John Smith",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RwEk2qMtcc70R8beZ6kQ"
 },
 {
  "Email": "paul.kraske@skadden.com",
  "Name": "Paul Kraske",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RwJMM9DXS58ggyMM2avT"
 },
 {
  "Email": "ignazio.castellucci@unitn.it",
  "Name": "Ignazio Castellucci",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RxELDhNLBmfrlJ5YiYaF"
 },
 {
  "Email": "mtelemtayev@whitecase.com",
  "Name": "Maxim Telemtayev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/RxjUEJIDw1CyJUw04LbY"
 },
 {
  "Email": "jirapon.s@gmail.com",
  "Name": "Jirapon Sunkpho",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ry60fuDvdaB6YXrjdHd4"
 },
 {
  "Email": "stephen.massa@dentons.com",
  "Name": "Stephen Massa",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Rz9sEnRzJ8uid5lh2FVE"
 },
 {
  "Email": "SASCHA.MICHAELS@BBH-ONLINE.DE",
  "Name": "SASCHA MICHAELS",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S0fxcMJNtKJAQNQpo061"
 },
 {
  "Email": "v.bosisio@slf-qa.com",
  "Name": "Vincenzo Bosisio",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S18NJAqOMy5IMSQdbXno"
 },
 {
  "Email": "tds@globcorp.net",
  "Name": "Thays Herrera De Salas",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S35WI02TmClS4g25q0PW"
 },
 {
  "Email": "feedback@firstcapitalbank.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S3H5FSKt1LGcgpeioi7e"
 },
 {
  "Email": "advocates@kaggwalaw.com",
  "Name": "David S. Kaggwa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S3OLMeBGw9GsosX8p01S"
 },
 {
  "Email": "counseling@ulloayasociados.com",
  "Name": "Marielena Ulloa De Pineda",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S4M6sJdZkWaW1RoAZNFi"
 },
 {
  "Email": "jfk@kateeraandkagumire.com",
  "Name": "John Fisher Kanyemibwa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S5QtdEdBoLRKijlBH1f3"
 },
 {
  "Email": "ikihika@shonubimusoke.co.ug",
  "Name": "Innocent Kihika",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S5er1hOWm3E8yB5FFe3P"
 },
 {
  "Email": "afields@mofo.com",
  "Name": "Aramide Fields",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S5uxG52p5KZQw8fIScxW"
 },
 {
  "Email": "iborman@winston.com",
  "Name": "Ian Borman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S62WCVCF73O5NAF2Xhfw"
 },
 {
  "Email": "alfredo.fernandez.rancano@garrigues.com",
  "Name": "Mr Alfredo Fern�ndez Ranca�o",
  "Document Name": "BI20202020ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S6SHRn0myWarSPOrZs5Q"
 },
 {
  "Email": "office@minicozzilawyers.com",
  "Name": "Nic Minicozzi",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S7OxFXW03ZRkClQMV8Wk"
 },
 {
  "Email": "contactus@ferialaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S81uaZzbTPDIlB50HnTG"
 },
 {
  "Email": "jitranut@huntonak.com",
  "Name": "Ms. Jitranut Narkmai",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S8m78zG8Tq5Kzx5bbpiB"
 },
 {
  "Email": "rlawrence@orrick.com",
  "Name": "Robert Lawrence",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/S8sAsRJgLXfom0mJbtx2"
 },
 {
  "Email": "brozek@mf.cz",
  "Name": "Frantisek Brozek",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SAFcLfB4M5ZqnslZGPSl"
 },
 {
  "Email": "orantes@cuestasppq.com",
  "Name": "Victor Hugo Orantes Diaz",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SAeiyvG7BJdYgGG8OGfg"
 },
 {
  "Email": "sharon.renouf@bevanbrittan.com",
  "Name": "Sharon Renouf",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SAmRVrwvcrdmbl2VXi7L"
 },
 {
  "Email": "md@davidwalterghana.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SBC7zDdgmO21APC7BaAL"
 },
 {
  "Email": "borodkin@vkp.ua",
  "Name": "Mr. Alexander Borodkin",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_Vasil Kisil & Partners.doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SBmaIuHyqqf4qegFJQRH"
 },
 {
  "Email": "zusman@vegaslex.ru",
  "Name": "Evgenia Zusman",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SCicB3k1ZzTj0lu4aF2O"
 },
 {
  "Email": "lsafarova@bmlawaz.com",
  "Name": "Mrs Leyla Safarova",
  "Document Name": "Safarova BI 2020 AZE_bi_TPI_survey_en.docx",
  "Country": "AZE",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SDVIWlQ9Jw4TfXA1LaH0"
 },
 {
  "Email": "federica.giardina@esade.edu",
  "Name": "Mrs. Federica Giardina",
  "Document Name": "NEW_BI 2020 ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SDlEiEhlwZYu0ifRUWTD"
 },
 {
  "Email": "ppp@gov.pl",
  "Name": "Ms. Ma?gorzata Go?y?ska-Minkiewicz",
  "Document Name": "PO BI 2020 POL_bi_PPP_survey_en_MIED.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SFmn4DOc2bITVM0Wgpak"
 },
 {
  "Email": "kristin.forsyth@tt.ey.com",
  "Name": "Kristin Forsyth",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SFpBuRnxqWpxzlcd6FwF"
 },
 {
  "Email": "sarguello@consortiumlegal.com",
  "Name": "Msc. Silvio Arguello",
  "Document Name": "Encuesta Banco mundial 17.07.2019.docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SFsd7OPzxO6T20GNt4nf"
 },
 {
  "Email": "oa@integrites.com",
  "Name": "Oleksandr Aleksyeyenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SGHW0gBZo79xoWm2ATCQ"
 },
 {
  "Email": "info@globeleq.com",
  "Name": "Alex Douglas",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SGLMG3k92KMkYT4MxEFO"
 },
 {
  "Email": "chadwichft@botsnet.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SHj1vpBeTexD9k4qtlb3"
 },
 {
  "Email": "office@bel.co.ug",
  "Name": "James Mc Gowan",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SI7APqtMugAWCvxirFe4"
 },
 {
  "Email": "fazal.shinwari@ada.org.af",
  "Name": "Fazal Khaliq Shinwari",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SIBKtqcSR15Gudq8J2F5"
 },
 {
  "Email": "Joseph.Sheffu@tz.ey.com",
  "Name": "Joseph G Sheffu",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SJCQonNWoe094t0a98KO"
 },
 {
  "Email": "ZAHI.YOUNES@BAKERMCKENZIE.COM",
  "Name": "Zahi Y. Younes",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SJDQ04LPMZh0Uy15D3eO"
 },
 {
  "Email": "susanbarry@orrick.com",
  "Name": "Susan Barry",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SKFHjzsONFubRiWApOT0"
 },
 {
  "Email": "nschreiber@fandz.com",
  "Name": "Noam Schreiber",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SKQiZ6T25R9G2ufLxIaM"
 },
 {
  "Email": "teomacabiog@yahoo.com",
  "Name": "Teofino C. Macabiog",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SKeSgJ4B5zLs65VHIkkn"
 },
 {
  "Email": "oliveronylander@yahoo.com",
  "Name": "Oliver O. Nylander",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SLWHMEa82cP0AImtcYxB"
 },
 {
  "Email": "SUSANNE.MERTENS@BAKERMCKENZIE.COM",
  "Name": "SUSANNE MERTENS",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SM6jAM8Gcoj03w0Wjeum"
 },
 {
  "Email": "ivieibharebhor@gbc-law.com",
  "Name": "Miss Ivie lIbharebhor",
  "Document Name": "NIGERIA) GBENGA) BI 2020 NGA_bi_PPP_survey- completed form August 2.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SM941AC3c6QNgir137sl"
 },
 {
  "Email": "stefan.geiger@gsk.de",
  "Name": "Stefan Geiger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SMAvZ7GDJO0rC3YNttFA"
 },
 {
  "Email": "CarlosIvan@sucre.net",
  "Name": "Carlos Sucre Levy",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SNSZqT65E1HByElkSXtC"
 },
 {
  "Email": "mitchell.mostyn@dlapiper.com",
  "Name": "Mitchell Mostyn",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SNaKLfW0kVe7NwJpFG7F"
 },
 {
  "Email": "hussam@ghazzawilawfirm.com",
  "Name": "Hussam T Al Ghazzawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SORO2WTT3cd0YlUookwI"
 },
 {
  "Email": "ibrahim@saajlaw.com",
  "Name": "Ibrahim Alajaji",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SPuRTOjXHcEdBh1dkzcO"
 },
 {
  "Email": "thierau@redeker.de",
  "Name": "Prof Thomas Thierau",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SRDXFJkO1lyxuNpjIKdA"
 },
 {
  "Email": "info@fbattorneys.com",
  "Name": "Fayaz A. Bhojani",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SRmmIFQo9sG9Kbi4cou3"
 },
 {
  "Email": "abaev@chadbourne.com",
  "Name": "Andrei Baev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ST2E2B9ctlCf1MdMaCOi"
 },
 {
  "Email": "vasilenko@pppcenter.ru",
  "Name": "Dmitriy Vasilenko",
  "Document Name": "RUSSIA) NATIONAL PPP CENTER) 02.08. BI 2020 RUS_bi_concession_survey_ru_PPP.docx",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/STFMxwHnJHsNEqpWtKQD"
 },
 {
  "Email": "odiscoshalf@yahoo.com",
  "Name": "Ms Judith Odimbaiwe",
  "Document Name": "NIGERIA) ICRC) BI 2020  NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/STO64oXrGX25riOVrgt1"
 },
 {
  "Email": "info@impklawyers.com",
  "Name": "Elena Pitsillidou",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/STuIQkCvmlI2m6vxZqLQ"
 },
 {
  "Email": "marcelo.alvarado@fca.com.py",
  "Name": "Mr Marcelo Alvarado",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (08.28.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SU2G8CTEsgMyc5TdBZCE"
 },
 {
  "Email": "arothman@nblaw.com",
  "Name": "Azriel Rothman",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SUT4S6v6VRUQnYfUjm15"
 },
 {
  "Email": "joao.lourocosta@uria.com",
  "Name": "Mr Jo�o Louro e Costa",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SUsy3qWz5w88rdgshWlf"
 },
 {
  "Email": "jorge.angulo@fca.com.py",
  "Name": "mr jorge angulo",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (08.28.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SUyM5ytzfYkZ4gw4w9Vz"
 },
 {
  "Email": "tdokei@tokyo.whitecase.com",
  "Name": "Toshio Dokei",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SVGJM6XB5OTu2Atvznpt"
 },
 {
  "Email": "mirko.bogdanovic@odbd.hr",
  "Name": "Mirko Bogdanovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SW03CPm4zbi58Z1Y3Jnt"
 },
 {
  "Email": "tdolatotse@olatotseattorneys.co.bw",
  "Name": "David Olatotse",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SWrpoqcBw8EXtHaClPRp"
 },
 {
  "Email": "tekazelalem1@gmail.com",
  "Name": "Zelalem Teka Sima",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SY5pIOdxx2z9guLKtSIA"
 },
 {
  "Email": "zainab@qc-law.com",
  "Name": "Zainab Al Qurnawi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SZnLXwedWOha9n7mY4Vb"
 },
 {
  "Email": "matthew.osborne@whitecase.com",
  "Name": "Matthew Osborne",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SZvE7Sv0IP6PbIO9ir0E"
 },
 {
  "Email": "Teet.Lehiste@heta.ee",
  "Name": "Teet Lehiste",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sa10eRZWyeexmpwRIqsJ"
 },
 {
  "Email": "mike.mclaren@nortonrosefulbright.com",
  "Name": "Mike Mclaren",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sa7AA4snB4IkvaUjMxnx"
 },
 {
  "Email": "info@kairumccourt.com",
  "Name": "Patricia Lelei",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en-Wanjiru Ngige.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SaHwvlkVfMddX5HhQUJY"
 },
 {
  "Email": "mannc@sullcrom.com",
  "Name": "Christopher Mann",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SaKQXIhvSzw6dKRCw65h"
 },
 {
  "Email": "alexishjr@icazalaw.com",
  "Name": "Alexis V. Herrera Jr.",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SaXjzCGArffaU6n5ILSp"
 },
 {
  "Email": "ceo@cordiabancorp.com",
  "Name": "Jack Zoeller",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sdx2ip4mR17vs59LOXpr"
 },
 {
  "Email": "nmkumbukwa@nexlawadvocates.com",
  "Name": "Nuhu S. Mkumbukwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SeXhTN19f7FYQVXdJprt"
 },
 {
  "Email": "khalid.massoudi@gmail.com",
  "Name": "Mohammad Khalid Massoudi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SfsxLQ1xZRIrxNIy9JXW"
 },
 {
  "Email": "robert.borduas@nortonrosefulbright.com",
  "Name": "Robert G. Borduas",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SgscuOIITRfBULs716p1"
 },
 {
  "Email": "sachaleli@mslaw.ge",
  "Name": "Sophio Sachaleli",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SiLPzOsCS8IdDwTudjaq"
 },
 {
  "Email": "paul.jun@shearman.com",
  "Name": "Paul Jun",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SidKSs4ohw1wWenQWD06"
 },
 {
  "Email": "IJHouston@blg.com",
  "Name": "Ian Houston",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sl45dQoMtepE5WnXnB1h"
 },
 {
  "Email": "policy@metrochamber.org",
  "Name": "Chris Worden",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SlryFnlqDRMRDBu4Qasu"
 },
 {
  "Email": "maletandumbaro@yahoo.co.uk",
  "Name": "Ramadhani Ally Maleta",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sm4nGLUwKNJfJEvRQo3I"
 },
 {
  "Email": "jean-francois.marquaire@cmslegal.ru",
  "Name": "Mr. Jean-Francois Marquaire",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_concession_survey_en_CMS.docx",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SmOsrB3IJjazgRNbNvjI"
 },
 {
  "Email": "president@kaliningrad-cci.ru",
  "Name": "Aleksey Zinoviev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SoIRfr8xFQQbfI3luIak"
 },
 {
  "Email": "fin_kred@krsu.edu.kg",
  "Name": "Damira Bektenova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SoggID88TiR5ncgckKG7"
 },
 {
  "Email": "danielgemechulawoffice@gmail.com",
  "Name": "Daniel Gemechu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SpJgxfd6NbfW2xnKruHN"
 },
 {
  "Email": "gpolson@polsonlaw.co.za",
  "Name": "John Roderick Graeme Polson",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SpuM2oIECvYnXEGZIKHG"
 },
 {
  "Email": "mdicks@deloitte.co.et",
  "Name": "Murray Dicks",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SqrFrS911xFoQx3ScnaF"
 },
 {
  "Email": "jesse.phillips@kpmg.nz.com",
  "Name": "Jesse Phillips",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SqxrOQyaEtBVWRlsL98w"
 },
 {
  "Email": "bobbydemissie@mckinsey.com",
  "Name": "Bobby Demissie",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SrT0ahoXgs91d0GNey60"
 },
 {
  "Email": "pdavis@mofo.com",
  "Name": "Paul Davis",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/StAq2HKG5BsO7t1nGmAp"
 },
 {
  "Email": "bianca.soares@castrobarros.com.br",
  "Name": "Ms. Bianca Correia",
  "Document Name": "World Bank - Benchmarking Infrastructure - PPP.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Stf9bzawvlM5dbhCtY2P"
 },
 {
  "Email": "michael.park@addleshawgoddard.com",
  "Name": "Michael Park",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/StwXb4JfrKoRMVqhnip2"
 },
 {
  "Email": "nina.vjestica@karanovic-nikolic.com",
  "Name": "Nina Vjestica",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SuJ4T19XJIza1uUfe8do"
 },
 {
  "Email": "iraq@elareflaw.com",
  "Name": "Abdulwahid Alaf",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SvB0T6YzqN4MDtCjsL6n"
 },
 {
  "Email": "akbarsakhi2527@yahoo.com",
  "Name": "Mohammad Akbar Sakhi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SwmV6qYITKv2ShVC0peX"
 },
 {
  "Email": "paulo.dantas@castrobarros.com.br",
  "Name": "Mr. Paulo Dantas",
  "Document Name": "World Bank - Benchmarking Infrastructure -Concession2.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SwxOLK9sR1psg7olge9x"
 },
 {
  "Email": "Olesia.Abramova@ee.ey.com",
  "Name": "Olesia Abramova",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SxSbKmBL2sg61VSdYkQI"
 },
 {
  "Email": "ecsu.planning@gmail.com",
  "Name": "Nesru Awel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sxx7kqVvRjTUjZ8C7rpb"
 },
 {
  "Email": "jvaca@s-s.mx",
  "Name": "Jair Vaca Avendaño",
  "Document Name": "S-S-#76696-v1-2020_TPI_SURVEY_wb.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Sy5B3GmEv7vG88wbMyqs"
 },
 {
  "Email": "a.okere@icrc.gov.ng",
  "Name": "title Amanze Okere",
  "Document Name": "NIGERIA) ICRC) WORLD BANK TPI QUESTIONNIAIRES.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SyyS5cFw8NLpmQ4FJbQJ"
 },
 {
  "Email": "sahmed@winston.com",
  "Name": "Mr Shibeer Ahmed",
  "Document Name": "BI 2020 ARE_bi_PPP_survey_en_W&S.DOCX",
  "Country": "ARE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/SzirguKdU30XiPEKkJ5w"
 },
 {
  "Email": "andrey_porfiriev@epam.ru",
  "Name": "Andrey Porfiriev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T2YJFebFWWSOehT7h4OJ"
 },
 {
  "Email": "gerald.arends@pegasus-legal.com",
  "Name": "Gerald Arends",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T2YMlTVyArFwa8sR42C9"
 },
 {
  "Email": "Amkrtchyan@edrc.am",
  "Name": "Ani Mkrtchyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T3nS9js32NUEnF5hl1O0"
 },
 {
  "Email": "riyadh@sa.ey.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T4MR6WJSxAQYzMuhM7Tm"
 },
 {
  "Email": "cflores@aczalaw.com",
  "Name": "Ms Cecille Flores",
  "Document Name": "BI 2020 HND_bi_TPI_survey_en.ACZALAW.doc.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T6NvrScYYdxHgliWLG0n"
 },
 {
  "Email": "M.Tranquilli@palazzochigi.it",
  "Name": "title Marco Tranquilli",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_review_PMO.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T7jCotPai1yszz1OLsOi"
 },
 {
  "Email": "raymond.mbilinyi@gmail.com",
  "Name": "Raymond Mbilinyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T7wKgS11zuZGKltwAhOK"
 },
 {
  "Email": "cosmaliganya@gmail.com",
  "Name": "Emmanuel Malignaya",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T87761G4W0O8UypwFmhI"
 },
 {
  "Email": "nare@ameria.am",
  "Name": "Nare Manukyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T8V3wIBABSPmaul1ucgM"
 },
 {
  "Email": "Dmitry.Marchan@bakermckenzie.com",
  "Name": "Dmitry Marchan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/T8fJejfLpxhPHKda4mNy"
 },
 {
  "Email": "frederick.chen@hoganlovells.com",
  "Name": "Fredrick Chen",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TAEc5vq8TJaggq7dnWn7"
 },
 {
  "Email": "james.pay@cliffordchance.com",
  "Name": "James Pay",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TAJ1vEHnSiObYmwzGHJD"
 },
 {
  "Email": "nicole.cargill@blakes.com",
  "Name": "Nicole Cargill",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TAwSIXnjcsDNbj8aJSmh"
 },
 {
  "Email": "adam.hodon@kinstellar.com",
  "Name": "Mr. Adam Hodon",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en K7499574.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TB3bxTBr1Tibj7APQjXf"
 },
 {
  "Email": "thse@nortonrosefulbright.com",
  "Name": "Mr. Thanthiti Saneewong Na Ayudthaya",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TB6t4zoAwd6SD5iUy276"
 },
 {
  "Email": "dlieberman@stblaw.com",
  "Name": "David Lieberman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TB74je8GGYhZJe7sZUMZ"
 },
 {
  "Email": "nick.jones@simmons-simmons.com",
  "Name": "Nick Jones",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TBaFSPewDspvYLUkLWef"
 },
 {
  "Email": "evold@lawfrontadvocates.co.tz",
  "Name": "Evold Mushi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TBdmuoGRJBCbIKCaSmzK"
 },
 {
  "Email": "sandra.nissan@nortonrosefulbright.com",
  "Name": "Sandra Nissan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TBpIMv2MF841ptNlKc9m"
 },
 {
  "Email": "maspenke@duanemorrisselvam.com",
  "Name": "Mr. Moritz Spenke",
  "Document Name": "TPI_Myanmar (DMS 29072019).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TC4VzDHaeY1OiaLF4eFL"
 },
 {
  "Email": "aahmetaj@halimi.com.al",
  "Name": "Mr. Arlind Ahmetaj",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en.doc",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TDzgmuzxrbZkrEAamMkT"
 },
 {
  "Email": "tomfakahua@gmail.com",
  "Name": "Sione Tomasi Naite Fakahua",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TEJLziSvnVoA4gpMPxx8"
 },
 {
  "Email": "nhenchie@velaw.com",
  "Name": "Nick Henchie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TFVBJ5lA11o7rv5z3mEF"
 },
 {
  "Email": "hwaibin.lee@wongpartnership.com",
  "Name": "Hwai Bin Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TFzHmPeI7ab04JRDhpva"
 },
 {
  "Email": "patrick.parkin@burges-salmon.com",
  "Name": "Patrick Parkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TG56UARt7L7ETcWHcxcP"
 },
 {
  "Email": "ddeaton@nixonpeabody.com",
  "Name": "Daniel Deaton",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TGSjBVfZnzzCfnfjs7VA"
 },
 {
  "Email": "angela.mndolwa@nortonrosefulbright.com",
  "Name": "Angela Mndolwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TGdE1uegeRyHqFSVUMqB"
 },
 {
  "Email": "alida.tuyebekova@linkagemind.com",
  "Name": "Alida Tuyebekova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TGeh9dNogISGUSVokPtx"
 },
 {
  "Email": "lilidomingo@yahoo.com",
  "Name": "Ma. Oliva Z. Domingo",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TGv1lGBx68qPM5o47Y4v"
 },
 {
  "Email": "vakimkanova@curtis.com",
  "Name": "Veronica Akimkanova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TH1KyC4s4bwfpDdcCIxY"
 },
 {
  "Email": "bgalaw@bgalaw.co.il",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/THYv2v6PtXMrVca9PPpX"
 },
 {
  "Email": "mhakimi@law.stanford.edu",
  "Name": "Mehdi Hakimi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/THZze98k0FqSELCm2bJX"
 },
 {
  "Email": "nick.kovacevich@wynnwilliams.co.nz",
  "Name": "Nick Kovacevich",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/THmGotdtDP8UjbfLnhUx"
 },
 {
  "Email": "berhaneconsult@gmail.com",
  "Name": "Mr. Berhane Gila-Michael",
  "Document Name": "WB Survey (BGM).docx",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TIJnl0pXEtKlJIQpltDf"
 },
 {
  "Email": "kolitha.dissanayake@fjgdesaram.com",
  "Name": "Kolitha Dissanayake",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TILm6E0dfosDRE9I3Wyn"
 },
 {
  "Email": "anas.bhairi@blakes.com",
  "Name": "Anas Bhairi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TIPkNjZ6neBrWX5ewNll"
 },
 {
  "Email": "mark.dewar@fticonsulting.com",
  "Name": "Mark Dewar",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TJgbWHG7Ui9QHZkJiWBu"
 },
 {
  "Email": "Chitsanzo@knightnknight.com",
  "Name": "Chitsanzo Zingano",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TKABwGJKo4G2zy0UKALs"
 },
 {
  "Email": "peter.dieners@cliffordchance.com",
  "Name": "Peter Dieners",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TKTi7gsNIvqiwtstsqg3"
 },
 {
  "Email": "jie.li@hsf.com",
  "Name": "Ms Jie Li",
  "Document Name": "BI 2020 CHN_bi_PPP_survey_en - HSF 18 July 2019.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TKnSqYvhZmJLtnpX5LE7"
 },
 {
  "Email": "mvmesquita@demarest.com.br",
  "Name": "Ms Maria Virginia Mesquita",
  "Document Name": "wb bench questionnaire PPPs.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TLT2aQewYmkFZGBbtmGy"
 },
 {
  "Email": "mark@armstrongs.bw",
  "Name": "Mark Mckee",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TLtUhcpzjSUKWsAl0QY5"
 },
 {
  "Email": "fayoziddin.kamalov@dentons.com",
  "Name": "Mr Fayoziddin Kamalov",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Dentons_Partner.docx",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNKeArjzZE56QIehmyTo"
 },
 {
  "Email": "million.habte@mh-tdlo.com",
  "Name": "Million Habte",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNbNHaRVL5QqAceZy7PV"
 },
 {
  "Email": "lindsay.krauss@dlapiper.com",
  "Name": "Lindsay Krauss",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNbQD6fs687cnHdJEz1o"
 },
 {
  "Email": "zia.rahimi@ada.org.af",
  "Name": "Ziaurahman Rahimi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNmCJhmQ0CEW8ytEOS6i"
 },
 {
  "Email": "o.emanuele@nmlex.it",
  "Name": "Mr Otello Emanuele",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Daniela Jouvenal Long.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNwXjn9YTanrEYu2DLHC"
 },
 {
  "Email": "p.manon@sdhhlaw.com",
  "Name": "Ms. Paola Manon",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en (002).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TNyK9RC84QSe4sKrrQbx"
 },
 {
  "Email": "simon.colvin@pinsentmasons.com",
  "Name": "Simon Colvin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TOfkGBVrGqYDnziGVoNo"
 },
 {
  "Email": "aguibert@deloitte.com",
  "Name": "Mr Armando Guibert",
  "Document Name": "03. BI 2020 ARG_bi_concession_survey_en.doc",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TOunhTWN52b206MqwbRz"
 },
 {
  "Email": "mdenyes@fasken.com",
  "Name": "Martin K. Denyes",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TP27C0j1d97NVcNT6k3D"
 },
 {
  "Email": "rabee@ethionet.et",
  "Name": "Rahel Alemayehu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TPQ88QbBpZ4JUeoArSzE"
 },
 {
  "Email": "oseikteirobert@yahoo.com",
  "Name": "Robert Osei-Kyei",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TPmZsQmetz8vqUwbiMpt"
 },
 {
  "Email": "Makolego@Malawi.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TQ3m4YodyNmiR2fQvU3v"
 },
 {
  "Email": "joseph.tato@dlapiper.com",
  "Name": "Joseph Tato",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TQSkJYz0Snq4t2PcZkzL"
 },
 {
  "Email": "bojana.paneva@adtrpenoski.com.mk",
  "Name": "Bojana Paneva",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Trpenoski.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TQhONDin9TaZyoJzwl3g"
 },
 {
  "Email": "mwilliams@albureau.com",
  "Name": "Matthew Williams",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TR6z8lwyHrS3sVjqPI27"
 },
 {
  "Email": "scairways@westpac.com.au",
  "Name": "Garry William",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TSCpZCJUVEU5w0mYzmNR"
 },
 {
  "Email": "mds@abreuccadvogados.com",
  "Name": "Dra Margarida Duarte Santos",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_Abcc_19.7.19.docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TSp0QXbQxdRf5HUlyN42"
 },
 {
  "Email": "vmc@legalmca.com",
  "Name": "Mr. V�tor Marques da Cruz",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en Angola_ MC&A.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TT0zsvZN0DRiOAvjc50t"
 },
 {
  "Email": "pedro.castro@ldr.com.br",
  "Name": "Mr. Pedro Castro",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (002).DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TTgKjfcn74iV9qiTQpQR"
 },
 {
  "Email": "gustavo.gamboa@ariaslaw.com",
  "Name": "Mr. Gustavo Gamboa",
  "Document Name": "20190729 - BI 2020 GTM_bi_PPP_survey_en - (Arias Guatemala).docx",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TTphCzbzjclAy9fTimnX"
 },
 {
  "Email": "victor@sicc.com.sg",
  "Name": "Victor Mills",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TTxpIRwSmI0g8bLeMVqx"
 },
 {
  "Email": "tbarnett@cov.com",
  "Name": "Thomas O. Barnett",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TVIfzTmOwsJ5vQgxr4FE"
 },
 {
  "Email": "roberto.camacho@ppulegal.com",
  "Name": "Mr Roberto Camacho",
  "Document Name": "PPU-_8122162_V_1_TPI in Colombia - World Bank Survey 2020.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TWe7i2SwwX4Om0cTWX6E"
 },
 {
  "Email": "lnash@obriens.com",
  "Name": "Lloyd Nash",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TWhvQT7LQpRHXSPx1tRy"
 },
 {
  "Email": "salegal@me.com",
  "Name": "Abigail Ronald-Louw",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TYaB4lviZbGlBe3HH0c3"
 },
 {
  "Email": "Nicholas.Carney@hsf.com",
  "Name": "Mr Nicholas Carney",
  "Document Name": "BI 2020 AUS_bi_PPP_survey_Herbert Smith Freehills.docx",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TYyvLdnltm1FquVBXhQL"
 },
 {
  "Email": "c.linder@athos-solar.de",
  "Name": "Christian Linder",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TZUDrySQKe6CKtzApOV0"
 },
 {
  "Email": "nzervos@velmalaw.com",
  "Name": "Nicholas Zervos",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TbOGgyypIYypy5ZsEVxk"
 },
 {
  "Email": "adavies@milbank.com",
  "Name": "Aled Davies",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TbdNkCKgEn3bhdofo3XU"
 },
 {
  "Email": "malcolm.hurley@ah.co.nz",
  "Name": "Malcolm Hurley",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TcFFEzsD34EijnhiOZ6n"
 },
 {
  "Email": "parks.tafa@collinsnewman.bw",
  "Name": "Parks Tafa",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TccyKX3i3NgkLh5Gvzwu"
 },
 {
  "Email": "info@omerabdelati.com",
  "Name": "Omer Abdelati",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TdAUhCTuPftOAyvudlvK"
 },
 {
  "Email": "martin.brown@shlegal.com",
  "Name": "Martin Brown",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TdL8pCbu2Uc19C6DkNUk"
 },
 {
  "Email": "giwa-osagie@giwa-osagie.com",
  "Name": "title Osayaba Giwa-Osagie",
  "Document Name": "NIGERIA) GIWA-OSAGIE) Traditional Public Investment in Infrastructure in Nigeria.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TdNql2GtuLZ37bqUenNq"
 },
 {
  "Email": "james.pay@cliffordchance.com",
  "Name": "James Pay",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Te3lHfQoi7SyIlxNWVnV"
 },
 {
  "Email": "nabilshariq@shajjanlaw.com",
  "Name": "Ahmad Nabil Shariq",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Te8Qv8v8DT6xSf1vZN0h"
 },
 {
  "Email": "darko.jovanovic@karanovicpartners.com",
  "Name": "Mr. Darko Jovanovic",
  "Document Name": "BI 2020 MNE_bi_PPP_survey_en_KaranovicRev_10Jul19.docx",
  "Country": "MNE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Teal3jcl2sU7cMXI49kD"
 },
 {
  "Email": "s.dumanaeva@lorenz-law.com",
  "Name": "Ms Samara Dumanaeva",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_Lorenz.doc",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Tei5KRwvSTlb2UCDUq69"
 },
 {
  "Email": "ttlawassociation@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TfO1CkJ3EzvgFT3mWjL0"
 },
 {
  "Email": "ohad@porat-lawfirm.com",
  "Name": "Ohad Tzori",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TftMJ2219uJEsChwFQ7J"
 },
 {
  "Email": "georgievski@ddklaw.com.mk",
  "Name": "Mr. Riste Georgievski",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_DDK.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Tg6CkaSw7gyyUjioIFGr"
 },
 {
  "Email": "michael.syc-mily@mfsr.sk",
  "Name": "Mr Michael S�?-Mil�",
  "Document Name": "Svetova_banka_dotaznik_Ministry of Finance.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TgGCWmRTsxIIuFPryu7a"
 },
 {
  "Email": "cci@volgogradcci.ru",
  "Name": "Vladimir Vasilenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TgYLgdvnvSpnqUY9bIcN"
 },
 {
  "Email": "kalev@lauspartners.ee",
  "Name": "Kalev Avik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TgvfLcSPKIFCh3LUz9Wk"
 },
 {
  "Email": "petervanniekerk@eversheds-sutherland.co.za",
  "Name": "Peter Van Niekerk",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TirPjxc1gvKjyWSBQFoR"
 },
 {
  "Email": "tgerwel@glynmarais.co.za",
  "Name": "Tamara Gerwel",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TjBRj2l1q8WH7W3fV6ae"
 },
 {
  "Email": "advokat@ckr.mk",
  "Name": "Ms. Danche Cakarovska",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Cakarovska.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TjEjMYq1Soil62xIQNLi"
 },
 {
  "Email": "vonlan@vonlan.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Tl0sny8CO1QXtR8xIY8i"
 },
 {
  "Email": "sbillard@airdberlis.com",
  "Name": "Sam Billard",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Tlghgafu8ZzKJsyTIlz0"
 },
 {
  "Email": "umejia@consortiumlegal.com",
  "Name": "Ulises Mejia",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnEiJIJr9YzP7QPpXpUX"
 },
 {
  "Email": "mark.phillips@webberwentzel.com",
  "Name": "Mark Phillips",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnH9eWuGyFHEHH9kLzFi"
 },
 {
  "Email": "tamar.shotadze@tsu.ge",
  "Name": "Tamar Shotadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnVcXAilvrGWNtISHe6R"
 },
 {
  "Email": "carri.ginter@sorainen.com",
  "Name": "Carri Ginter",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnllHu2TaEDNAySkNAIe"
 },
 {
  "Email": "j.reardon@tamimi.com",
  "Name": "Jonathan Reardon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnomURIHiUU1JWyZubpV"
 },
 {
  "Email": "nissanka@aureos.com.lk",
  "Name": "Nissanka Bandara Weerasekera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TnorjT0Cv9CzIrQxQOAt"
 },
 {
  "Email": "jmf@aamm.t",
  "Name": "Dr. Jos� Miguel Figueiredo",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en - AAMM 24.07.2019.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Tnr3p2K8kjsehnkjoqKM"
 },
 {
  "Email": "mrlopes@hrlegalcircle.com",
  "Name": "Ms. Mara Rupia Lopes",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/To8YuIJQ5PdruAmtw5Kf"
 },
 {
  "Email": "kaleetaconstruction@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TpMaVWIcZsnjJgf9KOp5"
 },
 {
  "Email": "a.marshall@britishchambers.org.uk",
  "Name": "Adam Marshall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TqaZtdpR8OF4j99yriHP"
 },
 {
  "Email": "jdr@flycia.cl",
  "Name": "Mr Juan Rabat",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en (3).docxJDR.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TrthKJP3NabSqSphSDMm"
 },
 {
  "Email": "info@shafelaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ts4HR4t2sEJZqATbjA45"
 },
 {
  "Email": "N.Sholanov@aequitas.kz",
  "Name": "Nurlan Sholanov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TsAfZAC9ncroR1Z5FxTj"
 },
 {
  "Email": "ethiopia@sabaip.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TtXpe6bzcUTFA6BZC9tI"
 },
 {
  "Email": "Saidydossantos01@gmail.com",
  "Name": "Saidy Fernando",
  "Document Name": "BI_2020_AGO_bi_PPP_survey_CFA.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TtyNeQk6sxbNsu3CXDvn"
 },
 {
  "Email": "dgrant@shearman.com",
  "Name": "Denise Grant",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TutzRcONoOuiUFNbkbMN"
 },
 {
  "Email": "vianney@cairnsslane.co.nz",
  "Name": "Vianney Newman-Watt",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TvuRy98Qrtm3HQZgnXy9"
 },
 {
  "Email": "MKTYEO@ntu.edu.sg",
  "Name": "Khim Teck Yeo",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TvxerDK9iG18tsQzbGbr"
 },
 {
  "Email": "ortiz.avidan@usac.edu.gt",
  "Name": "Avidan Ortiz",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TxvYuRel1rzFdq3OLpJB"
 },
 {
  "Email": "pchester@abl.com.au",
  "Name": "Philip Chester",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/TzKcDejjmtP7QyMaNv1f"
 },
 {
  "Email": "lesina.tonga@gmail.com",
  "Name": "Lesina Tonga",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U122W9T9MqS0idz9c985"
 },
 {
  "Email": "myathita.oo@dfdl.com",
  "Name": "Ms. Mya Thita Oo",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en final.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U1xA4Uu33ckXXyaPdOZY"
 },
 {
  "Email": "dilshad.k@centil.law",
  "Name": "?-? ??????? ???????????",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_ru_Centil.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U33QmKKG1ZQik86S7yHX"
 },
 {
  "Email": "E.Rata@schoenherr.eu",
  "Name": "Ms Rata Evelina",
  "Document Name": "BI 2020 MDA_bi_PPP_Schoenherr.docx",
  "Country": "MDA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U5N4SO2Nrz7PAIBJoPWZ"
 },
 {
  "Email": "didar.dhillon@pinsentmasons.com",
  "Name": "Didar Dhillon",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U5V8sqfsFFHijuyIckNX"
 },
 {
  "Email": "aa@pagbam.com",
  "Name": "Mr Alan Arntsen",
  "Document Name": "World Bank- PPP survey (1).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U5jwW6zGXVh4plJKAe1O"
 },
 {
  "Email": "spetaia@gmail.com",
  "Name": "Papalili Samuel Petaia",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U6JpUaUSFPkqDglYMeFf"
 },
 {
  "Email": "marielena@avilaco.com",
  "Name": "Marielena Gonz�lez Pe�a",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U6OaKI8os61QevSKIE4Q"
 },
 {
  "Email": "mail@ynw.com.pg",
  "Name": "Gregory Sheppard",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U7Xx4U1BYn0iH20SndOX"
 },
 {
  "Email": "ekua@upng.ac.pg",
  "Name": "Evelyn Kua",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U7wQew0v6v0WbhW2EjyZ"
 },
 {
  "Email": "mcautillo@strategycorp.com",
  "Name": "Micheal Cautillo",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/U8g1hjX91fDh6SWDimQf"
 },
 {
  "Email": "fobando@blplegal.com",
  "Name": "Mr. Francisco Obando",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UB1nFzj3Zy31gqNOYVX9"
 },
 {
  "Email": "dguijarro@mlabogados.com.ec",
  "Name": "Mr Daniel Guijarro",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en_RML.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UC68UMUZOr9KkCINvo9M"
 },
 {
  "Email": "amsamoa@pacificlawyers.law",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UCEY5Nsr2yxZskzetMDU"
 },
 {
  "Email": "pradana@ptsmi.co.id",
  "Name": "Mr. Pradana Murti",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_PT SMI.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UCFiwFQLUk3dpUYzp7Xc"
 },
 {
  "Email": "info@demedeiroslawfirm.com",
  "Name": "Frank Yao Baku Badohu",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UCVTZ13Xe4xN6sldeibm"
 },
 {
  "Email": "jose.azevedo@mz.pwc.com",
  "Name": "Jose Azevedo",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UCbLuT2auRRFHobnH2RU"
 },
 {
  "Email": "gaborone@arup.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UCkWhrp7DiyAqJLcUC8O"
 },
 {
  "Email": "Seth.Merewitz@BBKLaw.com",
  "Name": "Seth Merewitz",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UDLB9UfhjAi438FMlMHj"
 },
 {
  "Email": "merie-anne.beavis@gowlings.com",
  "Name": "Merie-Anne Beavis",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UDx9OEjocbmZv7J9risH"
 },
 {
  "Email": "deleceaantonio@gmail.com",
  "Name": "Antonio De Lecea",
  "Document Name": "NEW_BI 2020 ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UEMHqSixitRTIWJMN3CO"
 },
 {
  "Email": "charles.odere@gmail.com",
  "Name": "mr charles Odere",
  "Document Name": "UGANDA) ODERE) BI 2020 UGA_bi_PPP_Survey.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UEeICXN8JbtgHXNR7Et7"
 },
 {
  "Email": "assistant@gvinadzeandpartners.ge",
  "Name": "Tedo Ninidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UFTLwMiR4s6zzB0qFeMR"
 },
 {
  "Email": "enquiries@theprif.org",
  "Name": "Vinoka Hewag�",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UGWS0rBskwIBDp15Wvw4"
 },
 {
  "Email": "kibirangoleo@yahoo.co.uk",
  "Name": "Kibirango Leo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UHHYA7Ile8moulAiaWTK"
 },
 {
  "Email": "lortiz@blplegal.com",
  "Name": "Mr. Luis Ortiz",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UI5YqDZbf7BeSpxaYEiG"
 },
 {
  "Email": "info@iwatagodo.com",
  "Name": "Hiroki Fujiwara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UILi5v4Cjf0YSbcDAa1E"
 },
 {
  "Email": "getu@mehrteableul.com",
  "Name": "Getu Shiferaw Shiferwe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UJhYmGM7COEs48OtyvFQ"
 },
 {
  "Email": "david.d@tilleke.com",
  "Name": "David Duncan",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UK19n1QqDfF1NIKkimpS"
 },
 {
  "Email": "Alexey.Frolov@bakermckenzie.com",
  "Name": "Alexey Frolov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UKRTE4e9yUQb1fyOZ7d5"
 },
 {
  "Email": "fionn.bowd@au.pwc.com",
  "Name": "Fionn Bowd",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UL4WLdVMul0syLBEkuRE"
 },
 {
  "Email": "info@tgmblawoffice.com",
  "Name": "Teshome Gabre-Mariam Bokan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ULQxGS7qimDWLajgeBG1"
 },
 {
  "Email": "staylor@nossaman.com",
  "Name": "Stanley Taylor",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ULuOc4JuiKMlpPYqj7az"
 },
 {
  "Email": "info@ippp.org",
  "Name": "Roger Legare",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UNEvtrcj90kAFFK4lA7n"
 },
 {
  "Email": "lbarone@azevedosette.com.br",
  "Name": "Mr Leonardo Antonacci Barone Santos",
  "Document Name": "Bruna - BI 2020 BRA_bi_concession_survey_en Done.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UNVSgGVAzwpTpeF5vcnC"
 },
 {
  "Email": "m.msisha@nandmlawoffice.com",
  "Name": "Modecai Msisha",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UOG3UClZtAOPHa1pvJKE"
 },
 {
  "Email": "bmclellan@weirfoulds.com",
  "Name": "Bradley N. Mclellan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UPFMvxFTtkE4DaUtPLPw"
 },
 {
  "Email": "jpenrile@pecabar.ph",
  "Name": "Juan Ponce Enrile",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UPMnGl1AJVSmd9ifOTjl"
 },
 {
  "Email": "uwk@danskeadvokater.dk",
  "Name": "Ulrikke W. Krogbeck",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UQ64XAeqJLzMuEWeGc1p"
 },
 {
  "Email": "nateladogjonadze@ibsu.edu.ge",
  "Name": "Natela Doghonadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UQpw2vNulj3bhxRSNSWS"
 },
 {
  "Email": "udo.olgemoeller@allenovery.com",
  "Name": "Udo Herbert Olgem�ller",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UROFLiDahVYrXJL6CrGo"
 },
 {
  "Email": "saumendu.sinha@pwc.com",
  "Name": "Saumendu Sinha",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/USAAxtm851E1v6Pwbh44"
 },
 {
  "Email": "iana.tui@rtprallenovery.com",
  "Name": "MRS Ianita Tui",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_Ianita Tui.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/USZCkvpbmMzDopwVVVOb"
 },
 {
  "Email": "s.daly@polanc.com",
  "Name": "Stephanie Daly",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/USowqgNyrnUyfU3OuNGv"
 },
 {
  "Email": "umid.a@colibrilaw.com",
  "Name": "Umid Aripdjanov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UTaor99wR82H9qspEETF"
 },
 {
  "Email": "BASEL.BARAKAT@BAKERMCKENZIE.COM",
  "Name": "Basel Barakat",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UTvyD5xOR6xOjqxeBf6p"
 },
 {
  "Email": "cbuderi@curtis.com",
  "Name": "Charles Buderi",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UU4InCrsvLU28DZNS0tM"
 },
 {
  "Email": "mbuke.james@forbixattorneys.co.tz",
  "Name": "Mbuke James",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UUK3FHGcVc5hC1Ts0ydD"
 },
 {
  "Email": "ermo.kosk@primus.legal",
  "Name": "Ermo Kosk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UUzPhO0OsymWhd7j3U0t"
 },
 {
  "Email": "orlando.quilambo@uem.ac.mz",
  "Name": "Orlando Antonio Quilambo",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UYNOHPFU8nzXQsbuMUCY"
 },
 {
  "Email": "andrew.pettinger@addleshawgoddard.com",
  "Name": "Andrew Pettinger",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UZLcaiBsN3WpiT8bBk4Z"
 },
 {
  "Email": "adam.haque@dlapiper.com",
  "Name": "Adam Haque",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UZUUns9CJ7uIs1uYuxfd"
 },
 {
  "Email": "ZAHI.YOUNES@BAKERMCKENZIE.COM",
  "Name": "Zahi Y. Younes",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UZUmdSFSfW0Sz8cEBjr8"
 },
 {
  "Email": "jonathan.scragg@duncancotterill.com",
  "Name": "Jonathan Scragg",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UZcGn28mvWLk7CF8IWd3"
 },
 {
  "Email": "steven.galbraith@slaughterandmay.com",
  "Name": "Steven Galbraith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UZiO5Ct8QOcephwp7MXp"
 },
 {
  "Email": "law@aau.sd",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UabzgqeHT0ZAY6ksx1Q1"
 },
 {
  "Email": "nuinfo@northrise.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ub5ExOxFNAKd1PCvxLUm"
 },
 {
  "Email": "heisnerm@sullcrom.com",
  "Name": "Michelle Heisner",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UbLwgHjEAhuMiBdlDrDF"
 },
 {
  "Email": "juha-pekka.mutanen@dittmar.fi",
  "Name": "Mr. Juha-Pekka Mutanen",
  "Document Name": "FINLAND) DITTMAR) 1079988-V2-BI 2020 FIN_bi_PPP_survey_en.DOC",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UbMmHn6pDr09ji0VsgF2"
 },
 {
  "Email": "afaq.mufti@ae.pwc.com",
  "Name": "Afaq Mufti",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UbNJWWxLfMMbgMNOO8ZA"
 },
 {
  "Email": "samia.elhashmi10@gmail.com�",
  "Name": "Samia Hashmi",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UcZKfiNmUFRdJEnU60iV"
 },
 {
  "Email": "amarks@milbank.com",
  "Name": "Allan Marks",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ue46cdoKJxJclDGrHlHp"
 },
 {
  "Email": "jbond@uschamber.com",
  "Name": "Jodi Hanson Bond",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UeIzxOq9u4kflqW97NtU"
 },
 {
  "Email": "Kalunga@africaonline.co.tz",
  "Name": "Leopold Thomas Kalunga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UegAXIkg1VlnJmeZVr2X"
 },
 {
  "Email": "ksack@407etr.com",
  "Name": "Kevin Sack",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UhPjKbAHHogZc6sPRo0N"
 },
 {
  "Email": "office@asr-af.com",
  "Name": "Daud Saba",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ui0HSImUrhIKb9oDPc18"
 },
 {
  "Email": "jamalh@adssomali.com",
  "Name": "Abdullahi Salad Dahir",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uj1E3NwpKoMa7aYMMxVv"
 },
 {
  "Email": "nhenchie@velaw.com",
  "Name": "Nick Henchie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uk8YhbwyYPCJBRh5oRze"
 },
 {
  "Email": "mrivett@aecon.com",
  "Name": "Mark Rivett",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UkmzX9pQsLWfNTpI5oBr"
 },
 {
  "Email": "msingleton@dcchamber.org",
  "Name": "Margaret Singleton",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ul7RQ6I1PhPeNYyMNfV6"
 },
 {
  "Email": "info@sorylawgh.com",
  "Name": "Thaddeus Sory",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UlFWTy6MJ33Nr4YjPjiv"
 },
 {
  "Email": "archil_abashidze@illiauni.edu.ge",
  "Name": "Archil Abashidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UltaxV3OXo7N0YBiYK3I"
 },
 {
  "Email": "maythawee.sarathai@mayerbrownjsm.com",
  "Name": "Maythawee Sarathai",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UlwAiCnCgqYan4YTq1zc"
 },
 {
  "Email": "soroka@aequo.ua",
  "Name": "Mr. Mykhaylo Soroka",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UlxLrfy2c2gDgImzYXoL"
 },
 {
  "Email": "marina.freitas@pnm.adv.br",
  "Name": "Ms. Marina Cardoso de Freitas",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial concessão final.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UlzSbGkHEXlJOyBJ8Pd0"
 },
 {
  "Email": "inquiries@cna.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Unj9xV3Ryx7MjBNVkGFR"
 },
 {
  "Email": "Dmitry.Krupyshev@lecap.ru",
  "Name": "Dmitry Krupyshev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UnpBWq4YmZ266sey55Hl"
 },
 {
  "Email": "mahmadi@auaf.edu.af",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uo4u1kDUJLEvMqxc826Q"
 },
 {
  "Email": "jfleming@milbank.com",
  "Name": "Justine Fleming",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UoUjxyRgzuWkAJoosIM4"
 },
 {
  "Email": "rws@diascarneiro.com.br",
  "Name": "Mr. Ricardo Sanches",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en_DiasCarneiroAdvogados.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UobgTzTe4CBKbTDw4WST"
 },
 {
  "Email": "vcorpa@perezllorca.com",
  "Name": "Sr. V�ctor Corpa",
  "Document Name": "Perez-LLorca - BI 2020 ESP_bi_PPP_survey (10.07.2019).docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UrEo0rMlWxyz592FQKi2"
 },
 {
  "Email": "arabian@bemco-ipp.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UsgDUVDAQVPT7010LppD"
 },
 {
  "Email": "d.jouvenal@nmlex.it",
  "Name": "Ms. Daniela Jouvenal",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_Daniela Jouvenal Long.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ut8EwefUeTIWMh602To7"
 },
 {
  "Email": "veiko.lember@ttu.ee",
  "Name": "Veiko Lember",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ut8TqwK3zvjIt10DO8NM"
 },
 {
  "Email": "Irina.Anindita@makarim.com",
  "Name": "Ms Irina Anindita",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Makarim v2.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UtYvybM0TFiBcmq3QdaA"
 },
 {
  "Email": "avagyanh@bso.am",
  "Name": "Hakob Avagyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UtrIgVUifnGMBs4uHayV"
 },
 {
  "Email": "nick.tidnam@hoganlovells.com",
  "Name": "Nick Tidnam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UuGHulfAIkMFkP4G0yA8"
 },
 {
  "Email": "wchipeta@hallmarkattorneys.com",
  "Name": "Walter B. Chipeta",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UuKXFOCuo4a2uQOdKgsF"
 },
 {
  "Email": "denis.piskunov@magnussonlaw.com",
  "Name": "Denis Piskunov",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uv0jXTGTaChvfWIzUSgs"
 },
 {
  "Email": "Ron.Plascow@mills-reeve.com",
  "Name": "Ron Plascow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uv4tUpwXY0KvdTVkCXLW"
 },
 {
  "Email": "hfessahaie@yahoo.com",
  "Name": "Fessahaie Habte",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UvQ8RhTemX11gKnQQeNe"
 },
 {
  "Email": "cnewman@casselsbrock.com",
  "Name": "Charles Newman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UvTOCF3pYk0YTJ5nlzIO"
 },
 {
  "Email": "sjimenez@ibarrapg.com",
  "Name": "Ms. Sandra Jimenez Huerta",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en.doc (004).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UvvUluXmJXh75zFcNxUE"
 },
 {
  "Email": "raul.santos@mattosfilho.com.br",
  "Name": "Mr. Raul Dias dos Santos Neto",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UwImPqyqWanz2gNvJvJQ"
 },
 {
  "Email": "hblumberg@tmlw.co.il",
  "Name": "Hillah Blumberg",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uwx4DYeS3sfxwtslZPf9"
 },
 {
  "Email": "paola.sapienza@berke.com.py",
  "Name": "title Paola Sapienza",
  "Document Name": "Survey WBG (PPP) (21.7.19)[1].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ux5Z8kpLklV6JMBK0N91"
 },
 {
  "Email": "serra@basham.com.mx",
  "Name": "title Juan C. Serra",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en Jserra.doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UyD5rT4znSGxYfGu82Qk"
 },
 {
  "Email": "tarass.boichuk@gmail.com2",
  "Name": "Taras Boychuk",
  "Document Name": "BI 2020 2UKR_bi_PPP_survey_en_Kinstellar.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uye3XS9CFI9PyV0BIVbf"
 },
 {
  "Email": "info@kkattorneys.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Uyjg4evgMqf7ffGJpnVo"
 },
 {
  "Email": "chamber@sudanchamber.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UykvATcM0XrcMme5d0J3"
 },
 {
  "Email": "abraham.akkawi@ae.ey.com",
  "Name": "Abraham Akkawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/UzLgnCuyA0ZtamA9aUxx"
 },
 {
  "Email": "llyimo@toyotatz.com",
  "Name": "Lightness Lyimo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V2TWgJl1KshTrw5YVB8z"
 },
 {
  "Email": "e.druzhinin@maximalegal.ru",
  "Name": "Evgeniy Druzhinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V2dUEADjIuL3CcoOYm8E"
 },
 {
  "Email": "joanne.crew@nortonrosefulbright.com",
  "Name": "Jo Crew",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V3hDjFfDHqqGwnJTzI2P"
 },
 {
  "Email": "chambers@monckton.com",
  "Name": "Rebecca Haynes",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V4QiziG7G28A0TJIUhwm"
 },
 {
  "Email": "pkarugaba@ensafrica.com",
  "Name": "Mr. Phillip Karugaba",
  "Document Name": "UGANDA) ENSafrica) BI 2020 UGA_bi_PPP_survey_en (002) - pk.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V4XftruQ2TWh19RdYYBP"
 },
 {
  "Email": "bdonovan@chadbourne.com",
  "Name": "Ben Donovan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V4fPjwoVlEZ8YGD0iYuO"
 },
 {
  "Email": "ac146@cam.ac.uk",
  "Name": "Amy Ludlow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V6IxEBmadKaKdSMiQIiZ"
 },
 {
  "Email": "M.Norri@Tamimi.com",
  "Name": "Mr. Mohammed Norri",
  "Document Name": "BI 2020 IRQ_bi_PPP_survey_en_Norri.docx",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V6ejVqCtUdBl4QKiSPVh"
 },
 {
  "Email": "bbender@wslaw.co.uk",
  "Name": "Bettina Bender",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V6mJBBlJUWr09oiatZu2"
 },
 {
  "Email": "friedland@gornitzky.com",
  "Name": "Chaim Friedland",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V7gfClTMKMRKN3M8Byqy"
 },
 {
  "Email": "info@uniconethiopia.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V8XrSqh6foAl4Nvnp62N"
 },
 {
  "Email": "shaig_adigozalov@cbar.az",
  "Name": "Mr Shaig Adigozalov",
  "Document Name": "BI 2020 AZE_bi_TPI_survey_en.docx",
  "Country": "AZE",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V9Xh1626kzR6eZ8j5sww"
 },
 {
  "Email": "GChitera@fdh.co.mw",
  "Name": "George Chitera",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V9cFeuTgHTdCPg5zihFy"
 },
 {
  "Email": "jfehrenb@winston.com",
  "Name": "John Fehrenbach",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/V9w92cgMBFkQ4AAlXO4x"
 },
 {
  "Email": "pmbogo@walkerkontos.com",
  "Name": "Mr Peter Mbogo",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en _ Kenya (Walker Kontos Advocates comments).docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VAHASJtoEQlWNQthuiJV"
 },
 {
  "Email": "spunha@mlc.co.mz",
  "Name": "Silvia Prista Cunha",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VAV3j2W0V8tqoWhuSY8t"
 },
 {
  "Email": "david.gould@ah.co.nz",
  "Name": "David Gould",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VAf3ICfY6eDgbvIGjqf6"
 },
 {
  "Email": "finca_manuel@yahoo.com�",
  "Name": "Manuel Antonio Hern�ndez Aguilar",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VAwid7gkbzvkpXdBlrmN"
 },
 {
  "Email": "gtan@shearman.com",
  "Name": "Gregory Tan",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VD217cul6r48nQwQ2o7Q"
 },
 {
  "Email": "info-ppp@hochtief.de",
  "Name": "Peter Coenen",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VDReaaq8aSSh40bmzcRo"
 },
 {
  "Email": "radcliffe.jones@bmtlaw.com",
  "Name": "Radcliffe Jones",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VE8Erx41s5qZGeFx91nc"
 },
 {
  "Email": "mark.davies@mc.co.nz",
  "Name": "Mark Davies",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VEG8tXrkLRHTqtiEPadr"
 },
 {
  "Email": "zia.paton@tt.pwc.com",
  "Name": "Zia",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VET4OLarbimYJXx3Uulg"
 },
 {
  "Email": "razan.ghamdii@gmail.com",
  "Name": "Ms. Razan Alghamdi",
  "Document Name": "TAGLegal_PPP_survey_en.docx",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VFF8lBGEX8USfsPOY0k4"
 },
 {
  "Email": "finance@mpwr.gov.so",
  "Name": "Mr. Mohamed Hussein",
  "Document Name": "BI 2020 SOM_bi_PPP_survey_en_Ministry of Public Works, Recontstruction & Housing.docx",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VFn58sH10vfhuMoPmqey"
 },
 {
  "Email": "nazrisho@nmlaw.tj",
  "Name": "Rustam Nazrisho",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VGw60eFo8mchlsCUp9ds"
 },
 {
  "Email": "ekaterina.logvinovich@sbh-partners.com",
  "Name": "Ms Katsiaryna Lahvinovich",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_SBH.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VGzbaosIO3KmSofLIrsR"
 },
 {
  "Email": "scustodio@fasken.com",
  "Name": "Sergio C. Custodio",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VHAhzjsdZLcrye9wZI4M"
 },
 {
  "Email": "lysenko@aequo.ua",
  "Name": "Mr. Denis Lysenko",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VHXCquhZQGsNNEC9qEzm"
 },
 {
  "Email": "pwcjapan.legal@jp.pwc.com",
  "Name": "Nao Tsuchiya",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VII9fcZWX2fd1XRN19yi"
 },
 {
  "Email": "katri.tomson@triniti.ee",
  "Name": "Katri Tomson",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VKRnCV9ZHgSeyEc5bDpe"
 },
 {
  "Email": "ross.mckinnon@ashurst.com",
  "Name": "Ross Mckinnon",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VKf3LqIwjXyOKOoKawaV"
 },
 {
  "Email": "jaap.koster@cliffordchance.com",
  "Name": "Mr. Jaap Koster",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en 95064-3-7083 v0.4_Clifford Chance.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VKsrvRBa9nPSaD3XHtIo"
 },
 {
  "Email": "jie.li@hsf.com",
  "Name": "Ms Jie Li",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en - HSF 24 July 2019.docx",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VKtLej4mA9fVjEoynizF"
 },
 {
  "Email": "juanfernando.gaviria@ppulegal.com",
  "Name": "Mr Juan Fernando Gaviria",
  "Document Name": "PPU-_8122162_V_1_TPI in Colombia - World Bank Survey 2020.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VMVg5o1SHvHUEbff8EMg"
 },
 {
  "Email": "geoff.busch@al.nz",
  "Name": "Geoff Busch",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VNLeuYpH2LWqF9gJML1J"
 },
 {
  "Email": "analopez1@kmg.es",
  "Name": "Ms. Ana L�pez Carrascal",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en-v2.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VOu7KSOgYisa0nj7wMGx"
 },
 {
  "Email": "vschaefer@dallaschamber.org",
  "Name": "Virginia Martinez Schaefer",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VP7ze2RQbQO2WNodiWrN"
 },
 {
  "Email": "lee.keane@clydeco.com",
  "Name": "Lee Keane",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VPKEXf0Ek9lgjzbkMpHk"
 },
 {
  "Email": "info@fmh.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VPb6zgZ4RKF5Atbtagaw"
 },
 {
  "Email": "galmanza@aa-panama.com",
  "Name": "Gabriel Almanza Ja�n",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VPwvXlzPkYMPozCuKQGM"
 },
 {
  "Email": "jelena.jovetic@mif.gov.me",
  "Name": "Ms Jelena Joveti?",
  "Document Name": "BI 2020 MNE_bi_PPP_survey_en_MOF.docx",
  "Country": "MNE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VQVSZpk1TGhrmYOSTib6"
 },
 {
  "Email": "masato.m.kayahara@jp.pwc.com",
  "Name": "Masato Kayahara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VQjvRQ6htDVL4Xasn7Qa"
 },
 {
  "Email": "mxu@whitecase.com",
  "Name": "Ms. Mengbi Xu",
  "Document Name": "BI 2020 CHN_bi_PPP_survey_en (David Li 201909).docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VRJNtRIZ2GiZeOZRqHJd"
 },
 {
  "Email": "kupreishvilit@gmail.com",
  "Name": "Teona Kupreishvili",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en (filled).doc.docx",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VRdfzalNUjqCFLlNRQCP"
 },
 {
  "Email": "info@dowa.co.jp",
  "Name": "Kenichi Sasaki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VSq3Oe3Q0tIOiBg8NeTf"
 },
 {
  "Email": "Biddy.faber@hsf.com",
  "Name": "Biddy Faber",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VTlwkERy7lRKZ0ihnytO"
 },
 {
  "Email": "taddesse@mehrteableul.com",
  "Name": "Taddesse Lencho",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VUFXlXMfQBavcmQaScoI"
 },
 {
  "Email": "dr.omer.dekel@gmail.com",
  "Name": "Omer Dekel",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VVVQKx1c9MgVdoGTJC18"
 },
 {
  "Email": "bekelej@yahoo.com",
  "Name": "Mr Bekele Jebessa",
  "Document Name": "ETHIOPIA) ETHIO INFRA) BJ2_BI 2020  ETH_bi_PPP_survey_en.doc",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VW27XF81WIvtB7Azo6R5"
 },
 {
  "Email": "office@mortimerblakelaw.com",
  "Name": "Pierre Seynaeve",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VW2pr50aS6xMDvYN3Ex2"
 },
 {
  "Email": "catherine.bingham@dentons.com",
  "Name": "Catherine Bingham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VWM4i2YyH4WrCmB44g7q"
 },
 {
  "Email": "jwhitehead@stikeman.com",
  "Name": "Justine M. Whitehead",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VWjE1fXJHeRUdrgwrIIS"
 },
 {
  "Email": "ainouras@siar-consult.com",
  "Name": "Ainoura Sagynbaeva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VXR6fEEpVlOfJebig8oL"
 },
 {
  "Email": "Yerzhan.Kumarov@nortonrosefulbright.com",
  "Name": "Yerzhan Kumarov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VYAm4BlvdBhpOKY7e2G2"
 },
 {
  "Email": "jackie@jnkirkland.com",
  "Name": "Jackie Naluyima Katende",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VZQQjEpfMEwV2SGbI7w5"
 },
 {
  "Email": "walnuwaiser@wanpartners.com",
  "Name": "Waleed Al-Nuwaiser",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VZdulsOS1YXXxJIsu6rD"
 },
 {
  "Email": "phil.bentley@mitie.com",
  "Name": "Phil Bentley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VZxmAJMtvERnhO8HcOVZ"
 },
 {
  "Email": "andrew.lin@dbrs.com",
  "Name": "Andrew Lin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VbYJCtQjQZwUFnSH7HPa"
 },
 {
  "Email": "alanna.lawson@gowlings.com",
  "Name": "Alanna Lawson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VccMTqcTKn5D1N2r7vjT"
 },
 {
  "Email": "david.lee@allenovery.com",
  "Name": "David Lee",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VdT0nvKxCr8OAXWCG2AB"
 },
 {
  "Email": "pdrocha@hrlegalcircle.com",
  "Name": "Paula Duarte Rocha",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VeKvkVhdjrGMFFkgFqv7"
 },
 {
  "Email": "petr.knap@cz.ey.com",
  "Name": "Petr Knap",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vf2q5x0Iq0SHe6PVC7AS"
 },
 {
  "Email": "david.hartley@addleshawgoddard.com",
  "Name": "David Hartley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VgV7B3jMwxiPUAH3ly2k"
 },
 {
  "Email": "maniple@umu.ac.ug",
  "Name": "Everd Maniple",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vgq3gS73VPQuu3OC6Hn7"
 },
 {
  "Email": "nick.collins@bakerbotts.com",
  "Name": "Nick Collins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vhrc3ZarY4AMf1Pdx1YR"
 },
 {
  "Email": "sieme@baumeister.org",
  "Name": "Stefan Sieme",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vi88Vw3IXVGhkR5aqoBZ"
 },
 {
  "Email": "jvides@borgwardtlaw.com",
  "Name": "title Julio Vides",
  "Document Name": "Traditional Public Investment in Infrastructure in El Salvador.docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VivEeMbUvF0ft3wmiHvx"
 },
 {
  "Email": "info@kamlaw.com",
  "Name": "Keiko Ohara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VjMvEQ4CYIZzXy8YVhza"
 },
 {
  "Email": "ignacio.paz@hsf.com",
  "Name": "Mr. Ignacio Paz",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en july 2019.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VjQhqdA108uRcJ7jz8Bb"
 },
 {
  "Email": "jorge.diterlizzi@ppulegal.com",
  "Name": "Mr Jorge Di Terlizzi",
  "Document Name": "PPU-_7979994_V_1_Benchmarking Infrastructure PPPs in Colombia 2020 - World Bank Group Survey.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VkgHTja3R9qnO55fTwz6"
 },
 {
  "Email": "MS@MSLF.COM.SA",
  "Name": "Mohammed Naser Alshareef",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VkonP1hrBBswxAp3UXRL"
 },
 {
  "Email": "ron.lunau@gowlings.com",
  "Name": "Ronald D. Lunau",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VlIOCvGXoOMvk7WhA6LL"
 },
 {
  "Email": "julie.marshall@mills-reeve.com",
  "Name": "Julie Marshall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VloF7DLEUTP5GZCSeJ9s"
 },
 {
  "Email": "meagan@capitalregionchamber.com",
  "Name": "Mark Eagan",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vmg2pfuflWB7PErSeFjX"
 },
 {
  "Email": "bruce.white@linklaters.com",
  "Name": "Bruce White",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VnHNGRsQpF9nf8UGM0mi"
 },
 {
  "Email": "eganyan@vegaslex.ru",
  "Name": "Albert Eganyan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VnL1j0d1MSeFCEjb8xc9"
 },
 {
  "Email": "rainer.ratnik@lextal.ee",
  "Name": "Rainer Ratnik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VnnVvIuNxrIpQmsAujfo"
 },
 {
  "Email": "bmasia@mkinc.africa",
  "Name": "Bonang Lorato Masia",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VqEhsTmI8ueoL8ZZKZsk"
 },
 {
  "Email": "wolde.haimanot@gmail.com",
  "Name": "Getachew Mandefro Abate",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VqXpIKt3iwwMxhJz6hDx"
 },
 {
  "Email": "bgomez@s-s.mx",
  "Name": "Ms. Bel�n G�mez",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en (230719).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VqbytKNNGOshbTcOyt3P"
 },
 {
  "Email": "info@aglegal.com",
  "Name": "Ronald Hidalgo Cuadra",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VrwjvmzDneAUxLkUwQyd"
 },
 {
  "Email": "joanna_ledgerwood@dai.com",
  "Name": "Joanna Ledgerwood",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VsiLYfCN4cRfceFMU5WW"
 },
 {
  "Email": "lilian.arias@ariaslaw.com",
  "Name": "Ms. Lilian Arias",
  "Document Name": "BI 2020 SLV_bi_PPP_survey_en.doc.docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vti2NgAEwhardxYkp9iG"
 },
 {
  "Email": "Norberto.Montero@ar.pwc.com",
  "Name": "Mr. Norberto Montero",
  "Document Name": "2019.07 - PwC BI 2020 ARG_bi_PPP_survey_en (Completed Def ).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VtlHwkDIl6SBt3EvSW9S"
 },
 {
  "Email": "dapd@daplaw.com�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VvaS6QZbwgozpCOyPrxb"
 },
 {
  "Email": "com@yerevandjur.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VwPUGq9BT2Mch0QFwpvF"
 },
 {
  "Email": "edward.baring@hsf.com",
  "Name": "Edward Baring",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VwS3mINijMfMFaCw8Kxs"
 },
 {
  "Email": "clerk@williamforster.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vwlh26O5ckKl5wg7dqxM"
 },
 {
  "Email": "acarrau@bkzr.com.uy",
  "Name": "Mr. Alvaro Carrau",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en (0291310xD5B0A).docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vwo6kmgIQvqngAK7A9v5"
 },
 {
  "Email": "erki.vabamets@triniti.ee",
  "Name": "Erki Vabamets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vx11x5W2fj6MYjuf31JL"
 },
 {
  "Email": "roberto@gala.com.pa",
  "Name": "Roberto Antonio De Araujo L�pez",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VxSlttPt5yFc1EgiF9em"
 },
 {
  "Email": "ali.g@mof.gov.jo",
  "Name": "Mr Ali Al-Gghwairi",
  "Document Name": "PO BI 2020 JOR_bi_PPP_survey_en_MOF.doc",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vxsnwz3RkFiQniMLGsO9"
 },
 {
  "Email": "stevarad@gmail.com",
  "Name": "mr Stevan Radunovi?",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_Serbian Association of public Procurement Professionals.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vy8MLMHzWq5CF29vsx4U"
 },
 {
  "Email": "sandra.vark@primus.legal",
  "Name": "Sandra Vark",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VyGyfV0pXfl1t3RY6MUl"
 },
 {
  "Email": "auckland@adcorp.co.nz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VzPFGRkdPBQCHC2ONYHr"
 },
 {
  "Email": "info@gdcentr.ru",
  "Name": "Felix Issakovich Batkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Vznc4RI0jvH1I6jkcoCY"
 },
 {
  "Email": "gemadagonfa@gmail.com",
  "Name": "Gemeda Gonfa",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/VzuYOygKPL4K5ycX0qcJ"
 },
 {
  "Email": "howard.corney@macfarlanes.com",
  "Name": "Howard Corney",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W0FqQgFQeAK7Sas5hndB"
 },
 {
  "Email": "tmuktarov@gratanet.com",
  "Name": "Mr. Tamirlan Muktarov",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_GRATA Law Firm.docx",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W0VwWTgiGY8ivLJxwLzh"
 },
 {
  "Email": "info@eaattorneystz.com",
  "Name": "Themistocles L. Rwegasira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W0tXNTY99310CibghxM1"
 },
 {
  "Email": "info@erlf.com",
  "Name": "Eyad Reda",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W1lu6YiFpoQHNhjZTvEW"
 },
 {
  "Email": "daryll.ng@virtus-law.com",
  "Name": "Daryll Ng",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W1qRQKxJ9gU4GBGgrznj"
 },
 {
  "Email": "fhaddad@laliveinqatar.com",
  "Name": "Fouad El Haddad",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W2XfQLLrN5TRSKwZ0FeF"
 },
 {
  "Email": "mail@kairi.com",
  "Name": "Ralph Henry",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W2x3gJa0bAmY7EA555ac"
 },
 {
  "Email": "aschmid@nossaman.com",
  "Name": "Ann-Therese Schmid",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W5EI9orjP3b1uLptLCOS"
 },
 {
  "Email": "steven.williams@cms-cmno.com",
  "Name": "Steven Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W6TJ1pyRSC6eZbSK5DBt"
 },
 {
  "Email": "itarutia@nasfund.com.pg",
  "Name": "Ian Tarutia",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W7tqtt3CV39cIrke3xoV"
 },
 {
  "Email": "lashapiro@mwe.com",
  "Name": "Lynn Anne Shapiro",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W8HHhJ6k2eXtQgoHZoXC"
 },
 {
  "Email": "azmi@azmilaw.com",
  "Name": "Dato' Azmi Mohd Ali",
  "Document Name": "2019-BI 2020 MYS_bi_PPP_survey_en[10535].docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/W8YguWagj4IWSpLrsket"
 },
 {
  "Email": "patrick.boyle@ashurst.com",
  "Name": "Patrick Boyle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WAbq637ZC3GMGoga9KcA"
 },
 {
  "Email": "info@oratschilde.com",
  "Name": "Atipo Ambrose Peter Jnr.",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WBUyq6mIOEUNB9yCPq3V"
 },
 {
  "Email": "chandoo@fbattorneys.co.tz",
  "Name": "Mustafa Chandoo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WC3Sg1mX9nGYXfjJdehC"
 },
 {
  "Email": "info@kpc.kg",
  "Name": "Robert Brown",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WCfnagOCaLo3pqwfXAxR"
 },
 {
  "Email": "abaev@chadbourne.com",
  "Name": "Andrei Baev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WCxKxgwhtZUSQbLbL87P"
 },
 {
  "Email": "gthorpe@omm.com",
  "Name": "Gregory Thorpe",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WD2J1Mw88wsWHL1jdd0e"
 },
 {
  "Email": "emre.tekin@sbb.gov.tr",
  "Name": "Mr Zeki Emre Tekin",
  "Document Name": "TURKEY) PRESIDENCY OF STRATEGY AND BUDGET) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WDZFh2F9j3xQFDAfqMBU"
 },
 {
  "Email": "info@firstcapitalbank.co.mw",
  "Name": "Agness Jazza",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WEcmcOPKiSCDKtbXx2ib"
 },
 {
  "Email": "sbuss@whitecase.com",
  "Name": "Sebastian Buss",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WGIFOEwEWz4bbo4wzD6i"
 },
 {
  "Email": "knakanishi@tmi.gr.jp",
  "Name": "Kentaro Nakanishi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WH1uFQCBc3TPTTOBoEYf"
 },
 {
  "Email": "ignacio.flores@ariaslaw.com",
  "Name": "Mr. Ignacio Flores",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en-CCG  Final.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WHHyvhEqbnrJDkG2rWvf"
 },
 {
  "Email": "M.Baumhauer@taylorwessing.com",
  "Name": "Michael Baumhauer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WIDzHuRR0ixCsp1209W9"
 },
 {
  "Email": "ofer@gkh-law.com",
  "Name": "Ofer Hanoh",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WIPdM5CbTEpJ7urvUkS1"
 },
 {
  "Email": "michael.o'connor@addleshawgoddard.com",
  "Name": "Michael O'Connor",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WIeUr9AALqxD64zmXp0H"
 },
 {
  "Email": "sergiy.datsiv@cms-rrh.com",
  "Name": "Mr Sergiy Datsiv",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_CMS Reich-Rohrwig Hainz.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WJPY610fA9qvGdZJWc8J"
 },
 {
  "Email": "knakhon@wu.ac.th",
  "Name": "Nakhon Kokkaew",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WK0uyrzIMUYaA8wkWt6V"
 },
 {
  "Email": "kml@africalegalnetwork.com",
  "Name": "Mr. Karim Lalji",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_Atiq S Anjarwalla.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WKVIrV6A2bHEYuGD9Z2c"
 },
 {
  "Email": "mmaravi@rubio.pe",
  "Name": "title Milagros Maraví",
  "Document Name": "TPI Survey - Benchmarking Infraetsructure Global (1144010xA8986).docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WKtXNqr7eHbyQAPcDqPi"
 },
 {
  "Email": "salma.khashab@eldib.com",
  "Name": "Salma Khashab",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WKuue6reYGHdYOzneXzZ"
 },
 {
  "Email": "info@ircls.com",
  "Name": "Ali Kahrobaie",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WLIUIFEegPbOBCEKDkXA"
 },
 {
  "Email": "Gordsmith@BTY.com",
  "Name": "Gord Smith",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WLewm0LJAUujn68LG8ar"
 },
 {
  "Email": "guido.ajello@pwc.com",
  "Name": "title Guido Ajello",
  "Document Name": "Italy TPI_Survey_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WLfaB5wolU7FhDhVn0p0"
 },
 {
  "Email": "Yasser.Alhussain@ashlawksa.com",
  "Name": "Yasser Al-Hussain",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WMjzJ0Q0ujUUCbdFhHQv"
 },
 {
  "Email": "darryl.brown@gowlings.com",
  "Name": "Darryl J. Brown",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WNdBV4rdqDu4Kisic3YU"
 },
 {
  "Email": "GAMMACONSULT@MAIL.RU",
  "Name": "????????? ????? ?????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WO8QZV7L9dy0XKrWMCL6"
 },
 {
  "Email": "Qatar@seeroeng.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WOCu5DUflvT4p5TFriaN"
 },
 {
  "Email": "marine.shahparonyan@am.gt.com",
  "Name": "Marine Shahparonyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WQyeBEk1ql3ua5jf485N"
 },
 {
  "Email": "iraqibar@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WSVY6rt9jcvNfixfQpuT"
 },
 {
  "Email": "graeme.roberts@beca.com",
  "Name": "Graeme Roberts",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WT93BePX5sIBdNI6Vpju"
 },
 {
  "Email": "drubingh@aconex.com",
  "Name": "Douglas Rubingh",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WURaGFd8j2cqS2mQuTsq"
 },
 {
  "Email": "behr@bmt.eu",
  "Name": "Andreas Behr",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WUUTnwKSdUznG00VU0qa"
 },
 {
  "Email": "pkarpunin@cls.ru",
  "Name": "?-? ????? ????????",
  "Document Name": "BI 2020 RUS_bi_concession_survey_ru_CLS.doc",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WWyiYiAWo1Grx9njOZd0"
 },
 {
  "Email": "nbj@pp-as.dk",
  "Name": "Niels Blirup Jensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WXXfwWaj5DJ170kSjYcx"
 },
 {
  "Email": "juanjosejimenez@bufelco.com.gt",
  "Name": "Juan Jose Jimenez Soto",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WYNszF70gmPc07H9dwRa"
 },
 {
  "Email": "maylen@blg.com",
  "Name": "Mandy Aylen",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WZ2raJjlv3VIDn5ScLB7"
 },
 {
  "Email": "sakhi.ludin@ada.org.af",
  "Name": "Gh. Sakhi Ludin",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WZOcwpRRLILkQ1R4jKCg"
 },
 {
  "Email": "kjablonski@moralesybesa.cl",
  "Name": "Mrs. Katannya Jablonski",
  "Document Name": "MYB-#387783-v1-World_Bank_TPI_Survey.DOCX",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WaRKg48JRetl6z53l7UN"
 },
 {
  "Email": "ophelia.abdullayeva@dentons.com",
  "Name": "Ms. Ophelia Abdullayeva",
  "Document Name": "BI 2020 AZE_Dentons_bi_PPP_survey_en.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WaXjsPYdMySGSKXyG2oZ"
 },
 {
  "Email": "roman.stepanenko@asterslaw.com",
  "Name": "Mr. Roman Stepanenko",
  "Document Name": "BI_2020_UKR_bi_PPP_survey_en_Asters.DOCX",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WbjR1YvxsoP5SZ1ROvuR"
 },
 {
  "Email": "vmarkov@bmflegal.com�",
  "Name": "Vsevolod Markov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WdaCCFuamGNvURmP0Bff"
 },
 {
  "Email": "info@legaloracles.com",
  "Name": "Qasim Wadud",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WdibsiVN0mNdJ2hrz3qa"
 },
 {
  "Email": "elsheikh564@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wdk5HJGlQpFFIuuNjnWq"
 },
 {
  "Email": "marwan.elaraby@shearman.com",
  "Name": "Marwan Elaraby",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WeapisVZJuZDMrhiz3NN"
 },
 {
  "Email": "lowell.battles@stblaw.com",
  "Name": "Lowell Battles",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wf0HU9KzkeUr83tbARUk"
 },
 {
  "Email": "Jr@university.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WfD2Kz23iIOrpu0Kd0sR"
 },
 {
  "Email": "yunfei.guo@hsf.com",
  "Name": "Ms Yunfei Guo",
  "Document Name": "BI 2020 CHN_bi_PPP_survey_en - HSF 18 July 2019.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WfpA9FNVn25hVNb72J7t"
 },
 {
  "Email": "hh@hejailanlaw.com",
  "Name": "Hussam Al Hejailan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wg2tc6egKCgndOCpuMau"
 },
 {
  "Email": "abla@dowuonalaw.com",
  "Name": "Abla Masoperh",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wg489iYTQXzqBf3EhQXS"
 },
 {
  "Email": "law-firm@bahagram.com",
  "Name": "Mr Vasilis Keramaris",
  "Document Name": "GREECE) BAHAS) BI 2020 GRC_bi_PPP_survey_en 2.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wgv1ppEVj4Lf3xbyItpk"
 },
 {
  "Email": "Bben.Morris@ropesgray.com",
  "Name": "Ben Morris",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wi2xqexHib1ToBsW1vIw"
 },
 {
  "Email": "bishkekchamber@netmail.kg",
  "Name": "Asiya Barieva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WiIm2OEx94IYbAfF9Gst"
 },
 {
  "Email": "ahmedglf@yahoo.co.uk",
  "Name": "Ahmed Ahmed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WiPzKVyXDfTWwJqvecAs"
 },
 {
  "Email": "Fahad.Abuhimed@ashlawksa.com",
  "Name": "Fahad Abuhimed",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WikfFfPUbW9Vemc7krHJ"
 },
 {
  "Email": "jose.campos-nave@roedl.com",
  "Name": "Jose A. Campos Nave",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wja5LC40fGeQ1bL06NiJ"
 },
 {
  "Email": "abuov2005@yahoo.com",
  "Name": "Kenzhekhan Abuov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WkPxKbMhMH4FBTd6qTBO"
 },
 {
  "Email": "fas@alves-legal.com",
  "Name": "Francisco J. Alvarez De Soto",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wke94jX2UtwYV4Ab9Gjr"
 },
 {
  "Email": "lorenz.claussen@gsk.de",
  "Name": "Lorenz Claussen",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WlZD6M8eccEpES4TDZLI"
 },
 {
  "Email": "rsmith@uschamber.com",
  "Name": "Reuben Smith-Vaughan",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WlxjkXnG6qO8ZegnEMwV"
 },
 {
  "Email": "latu@latulaw.com",
  "Name": "Matafeo Latu",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WlzDGnUUPWRoKj4afssZ"
 },
 {
  "Email": "svyas@luthra.com",
  "Name": "Mr. Sameen Vyas",
  "Document Name": "PPP in India- World bank survey - BI 2020 IND_bi_PPP_survey_en (002)(5031384.1)(.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WmNXiF35V7DegzH3aMhp"
 },
 {
  "Email": "dpicotte@fasken.com",
  "Name": "Daniel Picotte",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wmee6xYOmIEENhgrRVFc"
 },
 {
  "Email": "spaul@jdsellier.com",
  "Name": "Steven M. Paul",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wmn9SNIs0UMOhr2TRUGT"
 },
 {
  "Email": "mariav@almanzalegal.com",
  "Name": "Maria Virginia Almanza Ja�n",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WmtbjV5JKUrzq6TUtDi9"
 },
 {
  "Email": "info@alfksa.com",
  "Name": "Ali Bin Abdullah Bin Ali",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WmyhUBlgl2G7vmd9DYdx"
 },
 {
  "Email": "chris.cameron@global.net.pg",
  "Name": "Chris Cameron",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wo5t39u0ZW8Y6AdzVUwZ"
 },
 {
  "Email": "support@satu.kz",
  "Name": "Vadim Shishkov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WpvxHKp7bUzzwpeDIiqG"
 },
 {
  "Email": "rzacarias@zaalaw.com",
  "Name": "Roberto Zacarias",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WqBZvMKCqd3CXlMI8mRt"
 },
 {
  "Email": "tkarapetyan@tkequitypartners.com",
  "Name": "Tigran Kareptyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WqGOZQ11CO9SXo5JQMGd"
 },
 {
  "Email": "jstupenengo@beccarvarela.com",
  "Name": "Mr. Juan Antonio Stupenengo",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WqVOYUGx8AFHZ9BYbkqA"
 },
 {
  "Email": "ykantas@koutalidis.gr",
  "Name": "Mr. Yannis Kantas",
  "Document Name": "GREECE) KOUTALIDIS) BI 2020 GRC_bi_PPP_survey_en_07082019.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WqhudjWbuevDo68ZfUfe"
 },
 {
  "Email": "emma.clarke@hoganlovells.com",
  "Name": "Emma Clarke",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WrTNlR8qZNWp6rGuKeJo"
 },
 {
  "Email": "jrobalino@ferrere.com",
  "Name": "Dr. Javier Robalino",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en (004).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WrZuz22QuPBUjMCY7529"
 },
 {
  "Email": "raiko.lipstok@eversheds.ee",
  "Name": "Raiko Lipstock",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WraWA1vEKJCHI3B7hKN1"
 },
 {
  "Email": "e.papponetti@studiogfferrari.it",
  "Name": "Lawyer Ernesto Papponetti",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_ DEF.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WrdzdM6j4anrEIRtMk0M"
 },
 {
  "Email": "euan.pinkerton@bakerbotts.com",
  "Name": "Euan Pinkerton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WrzKZ35XFrQLT7JrM0ID"
 },
 {
  "Email": "office@mcnairchambers.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WtqiJ4L4038WJVP2hhrK"
 },
 {
  "Email": "maiava@consultuspasefika.com",
  "Name": "Maiava Peteru",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WuCwnTLEYqzi6uv1Algy"
 },
 {
  "Email": "c.esengeldieva@lorenz-law.com",
  "Name": "Ms. Chynara Esengeldieva",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_Lorenz.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WuYkPjkd97pRajXKgSiS"
 },
 {
  "Email": "rotjohnson@yahoo.com",
  "Name": "Ransford Johnson",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WudwLa5Zj7j3kbTVgR9X"
 },
 {
  "Email": "juraj.nemec@umb.sk",
  "Name": "Prof. Dr. Juraj Nemec",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en_JN.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WvbNT6D0lZJwxmioE5v0"
 },
 {
  "Email": "Maxim.Kalinin@bakermckenzie.com",
  "Name": "Maxim Kalinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WwxUJz2iXpZAvdQ3xdic"
 },
 {
  "Email": "ben@lawyers.co.ck",
  "Name": "Ben Marchall",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wz2PXSAB6aj2F3agEv2h"
 },
 {
  "Email": "sharnila@sjmsassociates.com",
  "Name": "Sharnila Henry",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/WzMTyWLMS6G4CGtKG3F0"
 },
 {
  "Email": "william.kasozi@bowmanslaw.com",
  "Name": "William Kasozi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Wze4zlDftBWnAjFiPquM"
 },
 {
  "Email": "baghdad.iraq@iq.ey.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X00OMoMvOMKfjcqxDH1C"
 },
 {
  "Email": "mark.saunders@blplaw.com",
  "Name": "Mark Saunders",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X0lvDuheu7fjQUFs3LKd"
 },
 {
  "Email": "zfurnas@umich.edu",
  "Name": "Alexander Furnas",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X0vdqWuKeMCcnL2aSwuR"
 },
 {
  "Email": "shell@ftfarfan.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X2FVnkLxZ6RG5gWo5eT6"
 },
 {
  "Email": "jbb@kjlaw.dk",
  "Name": "Jens Bastrup-Birk",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X2SI9Oog3wzN5ZImbsvJ"
 },
 {
  "Email": "pwcmsia.info@my.pwc.com",
  "Name": "Sandile Lukhele",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X2wi1J7JXfCtuNrwIDR7"
 },
 {
  "Email": "d.jouvenal@nmlex.it",
  "Name": "Ms Daniela Jouvenal",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Daniela Jouvenal Long.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X2yLKkBQdvcdkXC66Sef"
 },
 {
  "Email": "steve.patrick@dentons.com",
  "Name": "Steve Patrick",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X34a8qLK5cZV9U3d6NXn"
 },
 {
  "Email": "dmitry.denisov@ut.ee",
  "Name": "Dmitry Denisov",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X4mbbBcGxaGyj3z9Orm2"
 },
 {
  "Email": "phockless@debevoise.com",
  "Name": "Peter Hockless",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X50i66D4cnYiESrS4gOw"
 },
 {
  "Email": "lmancera@gcsc.com.mx",
  "Name": "title Luis Mancera de Arrigunaga",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en (002).doc (002).docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X6QsgsItUZKnbxmaSGz7"
 },
 {
  "Email": "amin.samandar@gmail.com",
  "Name": "Mohammad Amin Samandar",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X7JPheY277PctVdTgFyK"
 },
 {
  "Email": "John@Simezasangwa.co.zm",
  "Name": "John Sangwa",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X7jODKhT0zoMa8yo2zeQ"
 },
 {
  "Email": "vmarulanda@dnp.gov.co",
  "Name": "Viviana Marulanda Alayon",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en[1]DNP5.doc",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X7oo43IUvc4IYpSsYwgp"
 },
 {
  "Email": "airawati@abnrlaw.com",
  "Name": "Ms. Anastasia Irawati",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_ABNR Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X8hyW0u8DYVIPFz6vmB7"
 },
 {
  "Email": "plarrahondo@gomezpinzon.com",
  "Name": "Mrs Paola Larrahondo",
  "Document Name": "G.P. Infraestructura- Benchmarking infrastructure 2020 PPP.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/X8zMmoDnRLciWZfBEbt3"
 },
 {
  "Email": "tajikistan@smec.com",
  "Name": "George Lasek",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XAmA9oYYC51E1360768V"
 },
 {
  "Email": "kgalemang@info.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XC4kPHfxoBza67KtupeK"
 },
 {
  "Email": "richard.beckles@tlclaw.org",
  "Name": "Richard Beckles",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XDMQmQMjJ8IOANSapqu6"
 },
 {
  "Email": "irina.zapatrina@gmail.com",
  "Name": "Dr. Prof. Iryna Zapatrina",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_IZ.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XDY1R0RLLBc413fzjQcU"
 },
 {
  "Email": "erb@aguilarcastillolove.com",
  "Name": "title Enrique Rodriguez Burchard",
  "Document Name": "BI 2020 HND_bi_TPI_survey_en_AguilarCastilloCove.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XDraG7ZPEFiu5FWMcPzk"
 },
 {
  "Email": "mega@maga.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XE5kq5F4rBfVXGuJtyCo"
 },
 {
  "Email": "t_firon@firon.co.il",
  "Name": "Tamar Firon�Smorodinsky",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XERLME95SjBIkdm3VMoe"
 },
 {
  "Email": "eugene.gregor@davispolk.com",
  "Name": "Eugene Gregor",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XEhMQWINJv9iOGdPQSf9"
 },
 {
  "Email": "duy.cao@rajahtannlct.com",
  "Name": "title Duy Cao",
  "Document Name": "VIETNAM) RTLCT) BI 2020 VNM_bi_TPI_survey_en.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XHniDfdRpSfTt71mM4Hk"
 },
 {
  "Email": "gplater@stike.com",
  "Name": "Greg Plater",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XIPbEMi3Ysu1qF5OOEm0"
 },
 {
  "Email": "rmorrone@foglers.com",
  "Name": "Rudy Marrone",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XIszTd139q1EecYImiAe"
 },
 {
  "Email": "info@forbixattorneys.co.tz",
  "Name": "Nasra Hassan",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XK81MUSq0A7X35raimVh"
 },
 {
  "Email": "vanlaw@ridgewayblake.com.vu",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XKsAYNC4L9hJZetemzX7"
 },
 {
  "Email": "eckova@mf.cz",
  "Name": "Daniela Eckov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XMNVphBcV2VU9D9vx5vN"
 },
 {
  "Email": "isattout@asarlegal.com",
  "Name": "Mr. Ibrahim Sattout",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_ASAR.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XMq1V82MQBR2MTpYHLqZ"
 },
 {
  "Email": "emily.heard@bevanbrittan.com",
  "Name": "Emily Heard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XN4JnvR32KeqB0Vs7stL"
 },
 {
  "Email": "yvonne@chilumeco.com",
  "Name": "Yvonne Chilume",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XNbOocFxHmKukKdSjKGn"
 },
 {
  "Email": "irener@mtnloaded.co.za",
  "Name": "Irene Rome",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XOQ8Z9JYZWBC3ZFVT57C"
 },
 {
  "Email": "fearey_s@auca.kg",
  "Name": "Seth Fearey",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XOngGRPsDpzDNX0ohQbs"
 },
 {
  "Email": "emmanuelroberts@robertspartners.org",
  "Name": "Emmanuel E Roberts",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XPk6ANZy7f7gHJcyKEOE"
 },
 {
  "Email": "khovhannisyan@counterpart.am",
  "Name": "Karen Hovhannisyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XPtITt7rjTKynxjdZ6iN"
 },
 {
  "Email": "sgoonewardene@kpmg.com",
  "Name": "Shiluka Goonewardene",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XQJRr4uXyueLxNzAqH3A"
 },
 {
  "Email": "Aleksander.Glikman@levinlaw.ee",
  "Name": "Aleksander Glikman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XQxfLGk0wipRby3EGwUX"
 },
 {
  "Email": "julian@greenwoodroche.com",
  "Name": "Julian Smith",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XQy4PwgTovab0ExRmmnK"
 },
 {
  "Email": "info@mergence.co.za",
  "Name": "Masimo Magerman",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XRIBF8IcFD4YzGtMNpVD"
 },
 {
  "Email": "dclark@applebyglobal.com",
  "Name": "David Clark",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XRYOBX8g1TmP2XX15m6k"
 },
 {
  "Email": "jan.sanders@ashurst.com",
  "Name": "Jane Sanders",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XTcX03phwrZJTSjbtyGj"
 },
 {
  "Email": "leticia@queirozmaluf.com.br",
  "Name": "Leticia Queiroz",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XTj5M1eLqBZSoI28FxEF"
 },
 {
  "Email": "cmoraitis@werksmans.com",
  "Name": "Chris Moraitis",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XUXry3utIBDDNspUQ3Zg"
 },
 {
  "Email": "pjohnson@dwpv.com",
  "Name": "Phillipe Johnson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XVkkZcD5aLJmmnhEeqsc"
 },
 {
  "Email": "epstein@erm-law.com",
  "Name": "Amnon Epstein",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XVwxlnuzPt2XDAZFAlej"
 },
 {
  "Email": "apbutler@netspace.net.au",
  "Name": "Anthony Butler",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XWQxAvep8NzEUi8v07R1"
 },
 {
  "Email": "jgatotubo@punolaw.com",
  "Name": "John Maynard G. Atotubo",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XXT6MdDDKiV0wHb9E0lU"
 },
 {
  "Email": "vsattler@estudiorodrigo.com",
  "Name": "Ms Veronica Sattler",
  "Document Name": "[381874v1] - respuesta banco mundial.DOCX",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XXYBaUmW4Isorxp7i8FP"
 },
 {
  "Email": "gfabrizi@ristuf.it",
  "Name": "Miss Giulia Fabrizi",
  "Document Name": "BI 2020 ITA_bi_TPI_RandT.doc",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XY7ThNTsG0nSpoyhzaAI"
 },
 {
  "Email": "oscar.torres@garciabodan.com",
  "Name": "Oscar Jose Torres Ca�as",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XZN3P0RHRY1lJ1NNfdhT"
 },
 {
  "Email": "S.Sequeira@lse.ac.uk",
  "Name": "Sandra Sequeira",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XaCjpMBEpahx5hTI7R16"
 },
 {
  "Email": "richard@ceal2005.com",
  "Name": "Richard Greenidge",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XbEAtUvvUzrhCPvPU0Go"
 },
 {
  "Email": "nberker@yaziciao.com",
  "Name": "Ms. Nihal Berker Atl?",
  "Document Name": "TURKEY) YAZICI) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XbrZ2gbUv79RmlwBSFAV"
 },
 {
  "Email": "sobrien@obriens.com",
  "Name": "Steven O'Brien",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xc0wyQwv6dh0EoWQSZdv"
 },
 {
  "Email": "hodmanagementsci@mubs.ac.ug",
  "Name": "Joseph M. Ntayi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XcimTPm0snBsyVEGzJhy"
 },
 {
  "Email": "michael.park@addleshawgoddard.com",
  "Name": "Michael Park",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xd8LGgCOQgfOfy7Ggvlj"
 },
 {
  "Email": "moemedi@armstrongs.bw",
  "Name": "Moemedi Jr. Tafa",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XejokSfIl2D3spkmfOJY"
 },
 {
  "Email": "i.amadi@seftonfross.com>",
  "Name": "Mr Ikenna Amadi",
  "Document Name": "NIGERIA) SEFTON FROSS) BI 2020 NGA_bi_PPP_survey_en .doc SF 21.8.2019.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XfLG4AhN2dkn7ZmIRQwc"
 },
 {
  "Email": "deborah.greenwood@blplaw.com",
  "Name": "Deborah Greenwood",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XfWGekBPVK2X0NewCYyU"
 },
 {
  "Email": "fearey_s@auca.kg",
  "Name": "Seth Fearey",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XfadETulgdFhlSmVa77s"
 },
 {
  "Email": "pierre.lemieux@fd.ulaval.ca",
  "Name": "Pierre Lemieux",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xg9SRLQRGyxFYg8tFuE9"
 },
 {
  "Email": "cs@nohr-con.com",
  "Name": "Christine Skovgaard Madsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xgke5Xvp8HNw5UgFVGvq"
 },
 {
  "Email": "esinare@rexcl.com�",
  "Name": "Eve Hawa Sinare",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XjjLTbEOgvCm8aYdiKR3"
 },
 {
  "Email": "mahmoud.abdel-baky@dentons.com",
  "Name": "Mahmoud Abdel-Baky",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XjmsYfDBKSysuv2rypf0"
 },
 {
  "Email": "jorgeluis.arenales@ariaslaw.com",
  "Name": "Mr. Jorge Arenales",
  "Document Name": "20190729 - BI 2020 GTM_bi_PPP_survey_en - (Arias Guatemala).docx",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XmxZjpKuIc8HqRNrJ7qt"
 },
 {
  "Email": "tdrew@txbiz.org",
  "Name": "Theresa Drew",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xn1jiw4ilIpBtnabaaH4"
 },
 {
  "Email": "jramiza@bwslaw.com",
  "Name": "Gerald Ramiza",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XoNnzxPFX6F1wYvZO8iN"
 },
 {
  "Email": "jim.wheeler@ca.ey.com",
  "Name": "Jim Wheeler",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XoaQAnre3sYF0LF8009Z"
 },
 {
  "Email": "matthew.ockleston@kensingtonswan.com",
  "Name": "Matthew Ockleston",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xodcr4Mf4iHHkjpec23F"
 },
 {
  "Email": "esther.tan@zulrafique.com.my",
  "Name": "Ms Esther Tan",
  "Document Name": "MALAYSIA) ZULRAFIQUE) (Completed) - BI 2020 MYS_bi_PPP_survey_en.docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XojuRhg8glRosSYNGGUZ"
 },
 {
  "Email": "christopher.chuah@wongpartnership.com",
  "Name": "Christopher Chuah",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XracOji37xH5IceDex1q"
 },
 {
  "Email": "pathemens@dwpv.com",
  "Name": "Pierre-Andr� Themens",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XrizIZGAAEJwZovRJpA2"
 },
 {
  "Email": "cdaza@perezllorca.com",
  "Name": "Sr. Carlos Daza",
  "Document Name": "Perez-LLorca - BI 2020 ESP_bi_PPP_survey (10.07.2019).docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XtudKCFmO1eOmuV9MrOY"
 },
 {
  "Email": "bhammond@txbiz.org",
  "Name": "Bill Hammond",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xu8R5gLIgHCeTjcF3ZT9"
 },
 {
  "Email": "legal@dslm-law.com",
  "Name": "Sermid D. Al-Sarraf",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xu9pkPdpFwaWrXw00FEh"
 },
 {
  "Email": "kalle.pedak@hedman.ee",
  "Name": "Kalle Pedak",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XuoImdHocaRQgsUUAzlf"
 },
 {
  "Email": "ranbir.hunjan@cliffordchance.com",
  "Name": "Ranbir Hunjan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XureQS2taRsLOj7o45Qs"
 },
 {
  "Email": "info@frankfurt-ic.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XwFH8mHROLiVfZFpBxFm"
 },
 {
  "Email": "ioana.roman@ filipandcompany.com",
  "Name": "Mrs Ioana Roman",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en_Filip.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XwKPDeng8JHjSgjfZs8E"
 },
 {
  "Email": "david.benson@klgates.com",
  "Name": "David Benson",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XwQhRy4Onuhmol3tjtHq"
 },
 {
  "Email": "George.svanadze@ge.ey.com",
  "Name": "Dr. George Svanadze",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en_EY.doc",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XxRqFqouFZnhnWoTajOJ"
 },
 {
  "Email": "mgrigalashvili@blc.ge",
  "Name": "Ms Mariam Grigalashvili",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_BLC.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xy3YzVGarcwp0m2ZYh4J"
 },
 {
  "Email": "shakilakhan@kcl.co.bw",
  "Name": "Shakila Khan",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XyJDhpZwfLNENSgGZh05"
 },
 {
  "Email": "fin_kred@krsu.edu.kg",
  "Name": "Damira Bektenova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XyRM8tsTpzn8lAH68JVc"
 },
 {
  "Email": "info@dnkadvocates.com",
  "Name": "Dorothy Nandugga Kabugo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Xym5eVAtEfQ366c9kZcI"
 },
 {
  "Email": "jhawkins@trowers.com",
  "Name": "James Hawkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XzdStplnbeSK6v9hJSOd"
 },
 {
  "Email": "yuito_yamada@mckinsey.com",
  "Name": "Yuito Yamada",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XzdrrkD4TdGe5f777dzS"
 },
 {
  "Email": "pkiley@stewartmckelvey.com",
  "Name": "Paul Kiley",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/XzhEVZ0CQkDVhgWOhO51"
 },
 {
  "Email": "cmichaud@bsp.com.pg",
  "Name": "Christophe Michaud",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y0OBGM4VnQROTQuuFE25"
 },
 {
  "Email": "michael.edwards@sr-law.co.uk",
  "Name": "Michael Edwards",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y0tJ9OEEvUEFYsINzqKB"
 },
 {
  "Email": "tajikistan@centil.law",
  "Name": "???????? ?????? ???????",
  "Document Name": "BI 2020 TJK_bi_PPP_survey_ru_centil.doc",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y0tyayFqTIUsWR7IRBUI"
 },
 {
  "Email": "adeegsan1@gmail.com/ www.adegsan.com",
  "Name": "Mr. Mohamed Ali",
  "Document Name": "BI 2020 SOM_bi_PPP_survey_en_Ministry of Public Works, Recontstruction & Housing.docx",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y25uuVRz4n8g2sJpfZjH"
 },
 {
  "Email": "amezher@hannouchelaw.com",
  "Name": "Amanda Mezher",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y2r1aXLczCAVGDFN3xNU"
 },
 {
  "Email": "BASEL.BARAKAT@BAKERMCKENZIE.COM",
  "Name": "Basel Barakat",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y33fPbyIxeHms1wtowgi"
 },
 {
  "Email": "djiwunde@yahoo.com",
  "Name": "Priscilla Devaan Jiwunde",
  "Document Name": "NIGERIA) ICRC) BI 2020  NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y3mtPbrYlc0l4czUKbvK"
 },
 {
  "Email": "info@olatotseattorneys.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y40yD5WnvnEsHnvXUxEg"
 },
 {
  "Email": "pgu@fondenab.dk",
  "Name": "Patrik Gustavsson",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y47o4BxJgigewo6qcEqX"
 },
 {
  "Email": "Dmitry.Marchan@bakermckenzie.com",
  "Name": "Dmitry Marchan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y59Txw7DtueEqsTa2rtV"
 },
 {
  "Email": "info@citytyres.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y5GON3o7keUEPEsnpeV6"
 },
 {
  "Email": "nmotsonelidze@ppp.gov.ge",
  "Name": "Ms. Natalia Motsonelidze",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_PO_PPP Agency.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y60GKZqi3H4vySRlZK2U"
 },
 {
  "Email": "acevedo@berettagodoy.com",
  "Name": "Mr. Fernando Acevedo",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_BN2 (FG).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y6WIwFEqIRSrHAjq24g2"
 },
 {
  "Email": "sharon@sicc.com.sg",
  "Name": "Sharon Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y6bpR4xprqVBIIQJIQU4"
 },
 {
  "Email": "info@ethiolegal.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y7mjti2FXFbiEEt8kGAk"
 },
 {
  "Email": "saodat.shakirova@arte-ip.kg",
  "Name": "Saodat Shakirova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y7mp1vAfarYFndC2IZOX"
 },
 {
  "Email": "mcc@avm.biz",
  "Name": "Mario Cassoma Cangombe",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y86p65W0ImD3XB4dCpSL"
 },
 {
  "Email": "kalasaco@globemw.net",
  "Name": "Kiphet Kalasa",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y8eeA3gz6XIbj0NWFuvQ"
 },
 {
  "Email": "tamratassefa@ethiolegal.com",
  "Name": "Tamrat Assefa�Liban",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y8f7h7DeUCxvxlJI5OjL"
 },
 {
  "Email": "carrie.follas@jws.com.au",
  "Name": "Carrie Follas",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y8m5MOLtUZqNsy2lR9qg"
 },
 {
  "Email": "khmakala@zamnet.zm",
  "Name": "Kenny Makala",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y90awcQwI9f1klcQbxVR"
 },
 {
  "Email": "warsha.kale@blplaw.com",
  "Name": "Warsha Kal�",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Y9m0U7gQeYQdyJd3JqiT"
 },
 {
  "Email": "geral@correiadvogados.com",
  "Name": "Gilberto Correia",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YA8qVgsbbBQd2qqHd0PG"
 },
 {
  "Email": "l.pelinku@yahoo.ca",
  "Name": "Ms Lealba Pelinku",
  "Document Name": "BI 2020  ALB_bi_PPP_survey_en _answered.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YBN1j01wrlcIv8qfJgKh"
 },
 {
  "Email": "info@azzawilaw.com",
  "Name": "Hussein Ahmed Al Azzawi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YBWp4DtwylmW9DeCdks3"
 },
 {
  "Email": "michal.jasek@cliffordchance.com",
  "Name": "Michal Jasek",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YBZebKFKjkTKZQ6LpPRy"
 },
 {
  "Email": "alfonso.carrillo@carrillolaw.com",
  "Name": "Alfonso Carrillo",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YBy4mgMqCSUYCSfKGMjP"
 },
 {
  "Email": "Melanie.Collier@postoffice.co.uk",
  "Name": "Melanie Collier",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YChMuxRxysNz0L2juLtU"
 },
 {
  "Email": "redondouna@yahoo.com",
  "Name": "Oscar Ovidio Redondo Flores",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YDffBZCdzzWK1btTks8X"
 },
 {
  "Email": "ott.saame@concordia.ee",
  "Name": "Ott Saame",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YEAYGP7r1xEjfR1muo7u"
 },
 {
  "Email": "dave.seibert@dfdl.com",
  "Name": "Mr. Dave Seibert",
  "Document Name": "VIETNAM) DFDL) BI 2020 VNM_bi_PPP_survey_en (02August19).docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YEoETPXXG7MkK7pDm43P"
 },
 {
  "Email": "sustaindeveth@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YF3lI1NSEhpVT7sRfYvp"
 },
 {
  "Email": "mateus.adami@pnm.adv.br",
  "Name": "Mr. Mateus Adami",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial concessão final.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YFfvlXa8yyQ4fwoTMzya"
 },
 {
  "Email": "michael.chee@bclplaw.com",
  "Name": "Michael Chee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YFqWuupiAB9RWXgNYhMp"
 },
 {
  "Email": "shanthisegha@law.cmb.ac.lk",
  "Name": "S. Segarajasingham",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YGxyyua1CH2ggpXv6BWu"
 },
 {
  "Email": "cnansubuga@kaa.co.ug",
  "Name": "Miss Catherine Nansubuga",
  "Document Name": "UGANDA) KAMPALA ASSOCIATED ADVOCATES) BI 2020 UGA_bi_PPP_survey_en.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YHMEgeXSboEzIXvOxdHy"
 },
 {
  "Email": "andrii.moskalyk@bakermckenzie.com",
  "Name": "Mr Andrii Moskalyk",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en (BMK Ukraine Input).docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YHy3Q9hhHEExmIp4EA7l"
 },
 {
  "Email": "mogadishu@somalieconomicforum.org",
  "Name": "Hassan Dudde",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YI3IByUB9KFOcO8Rfm57"
 },
 {
  "Email": "imbi.jurgen@glimstedt.ee",
  "Name": "Imbi Jurgen",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YIbu6pivBjgoVC5KnJI5"
 },
 {
  "Email": "maruojoseph@gmail.com",
  "Name": "Joseph Macha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YJONpUE555Q4MPsKXAfe"
 },
 {
  "Email": "akasymov@caiconsulting.org",
  "Name": "Azamat Kasymov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YJWSeJHWs0rIC2XaFvV7"
 },
 {
  "Email": "kochashvili@yahoo.com",
  "Name": "Ketevan Kochashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YKJwpx9Xnc9J8P85REkx"
 },
 {
  "Email": "saak@nortonrosefulbright.com",
  "Name": "Mr. Somboon Kitiyansub",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YKRyWq0ZXpLpWsuMMTge"
 },
 {
  "Email": "adeline_tan@cp2m.gov.sg",
  "Name": "Adeline Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YL0qnuANPeT7BfqBsww4"
 },
 {
  "Email": "mai.ha@rajahtannlct.com",
  "Name": "title Mai Ha",
  "Document Name": "VIETNAM) RTLCT) BI 2020 VNM_bi_TPI_survey_en.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YMJiY5rI9rSUnl242vjF"
 },
 {
  "Email": "jdahik@ferrere.com",
  "Name": "Jack Dahik",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en (004).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YMYoqEeOs1MnT3LzhNUk"
 },
 {
  "Email": "naramerlotto@spparcerias.com.br",
  "Name": "Nara Merlotto",
  "Document Name": "DEMAREST_SP-#10961845-v1-2019_08_02_BI_2020_BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YN0opGABPX48IfTQbR4p"
 },
 {
  "Email": "nmerabishvili@amklex.com",
  "Name": "Ms. Natalia Merabishvili",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en.doc",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YNIWJn2KToqjjnZBJiD8"
 },
 {
  "Email": "ainouras@siar-consult.com",
  "Name": "Ainoura Sagynbaeva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YNQJwBRNBKXng5lCSc4P"
 },
 {
  "Email": "sarajevo@cms-rrh.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YNaAyxq9G8OQLSRygZRu"
 },
 {
  "Email": "gea.gustavson@glimstedt.ee",
  "Name": "Gea Gustavson",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YNmw89kebsb0a5OMO03z"
 },
 {
  "Email": "nicolae.ursu@bpv-grigorescu.com",
  "Name": "Mr. Nicolae Ursu",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YOaTO4phw0xNt3A1MnHW"
 },
 {
  "Email": "marius@vdslegal.co.za",
  "Name": "Marius De Jager",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YPi9Tqjpb5mCI3pW1H48"
 },
 {
  "Email": "r.bassi@tamimi.com",
  "Name": "Rakesh Bassi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YQvhFrPlnnTlGqqgqiJI"
 },
 {
  "Email": "sue@blakemore.gr.jp",
  "Name": "Keicheru Sue",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YREApF7wCjNbw2eNXmMN"
 },
 {
  "Email": "ruth.snell@addleshawgoddard.com",
  "Name": "Ruth Snell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YROm9HFz6GynhSlgU8jy"
 },
 {
  "Email": "jacqueline.harkin@klgates.com",
  "Name": "Jacqueline T. Harkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YRkyNFvu9dVUfC0FsWZI"
 },
 {
  "Email": "d.stopher@nabarro.com",
  "Name": "David Stopher",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YUXqDTw6RzlMCP9ogzP5"
 },
 {
  "Email": "c.pesha@crbafricalegal.com",
  "Name": "Rugambwa Cyril John Pesha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YV0IDTcmtigdYBxESqqh"
 },
 {
  "Email": "wael.alissa@dentons.com",
  "Name": "Wael Alissa",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YVibJ2ljcRVPry5udNFu"
 },
 {
  "Email": "info@forbixattorneys.co.tz",
  "Name": "Nasra Hassan",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YVimEE0TT9gTDIUd3pEE"
 },
 {
  "Email": "ilc@integratedlegalconsultants.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YVqqipHXCDt3HUHHVIJD"
 },
 {
  "Email": "ks@arzinger.by",
  "Name": "Mr Klim Stashevsky",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_A&P.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YYLMK5uj0cWLhVSYe23l"
 },
 {
  "Email": "ysenbore@olaniwunajayi.net",
  "Name": "Mrs. Yewande Senbore",
  "Document Name": "NIGERIA) OLANIWUN) World Bank Survey - Traditional Public Ifrastructure Finance (22.07.19).docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YZR0oGcM0icYLnHm1Ly8"
 },
 {
  "Email": "b.ayik@cakmak.av.tr",
  "Name": "Ms. Ba?ak????? Ay?k",
  "Document Name": "TURKEY) CAKMAK) EA- World Bank 2020 PPP Survey (E).DOCX",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YZR1VRACMColqkWzJLa0"
 },
 {
  "Email": "r.steiling@gvw.com",
  "Name": "Ronald Steiling",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YZjV28Cnqhc2TK3V79I5"
 },
 {
  "Email": "somaliprocurement@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YZpK3ukV2W346m2qjexv"
 },
 {
  "Email": "mkattapuram@aecon.com",
  "Name": "Mathew Kattapuram",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YaaGNKjjcrbiEj6lDdml"
 },
 {
  "Email": "MGakunga@comesa.int�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YbXOG629HLXHV6RDoqPK"
 },
 {
  "Email": "gareth.price@allenovery.com",
  "Name": "Gareth Price",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YbeuZQhy1nC4vRmZozGo"
 },
 {
  "Email": "hello@99.co.nz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YcFVFfmZAcSSZziYEvNn"
 },
 {
  "Email": "nrgregson@arbiter.com.sg",
  "Name": "Neale R Gregson",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YcM0NecrwdU5idXMLR9Y"
 },
 {
  "Email": "bnurov@gratanet.com",
  "Name": "Mr. Bahodur Nurov",
  "Document Name": "BI 2020 TJK_bi_PPP_survey_en_GRATA Law Firm.docx",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YdZTo7OsrL1tPfFAKdje"
 },
 {
  "Email": "ipaskal@whitecase.com",
  "Name": "Ivan Paskal",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YdbcRoghABsiTlvVYC74"
 },
 {
  "Email": "nithi@nithimurugesu.com",
  "Name": "Nithi Murugesu",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YdsQpFBWYaijI67uHnu8"
 },
 {
  "Email": "piquero@esguerra.com",
  "Name": "Mr Felipe Piquero Villegas",
  "Document Name": "TPI.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yf8ZCecdKE7doiIW5T8A"
 },
 {
  "Email": "darrin.grimsey@au.ey.com",
  "Name": "Darrin Grimsey",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YfDvAT2kmad06mTduiQz"
 },
 {
  "Email": "ogutierrez@palacioslleras.com",
  "Name": "Mr. �scar Fabi�n Guti�rrez",
  "Document Name": "PPP Survey Colombia - �scar Guti�rrez V2.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YfbRFCt1CU0aXVgp7jxo"
 },
 {
  "Email": "ggaikis@smart-biggar.ca",
  "Name": "Gaikis Gunnars",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YgEuIK0JuIkoidWR806e"
 },
 {
  "Email": "info@eaattorneystz.com",
  "Name": "Themistocles L. Rwegasira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YhMaKaVk0SACgHbuDk30"
 },
 {
  "Email": "euan.wilson@mms.co.uk",
  "Name": "Euan Wilson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YiRtQ87CfsMdWiubFmaC"
 },
 {
  "Email": "psj@bechbruun.com",
  "Name": "Peter Stig Jakobsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yjpt26FeMcO31k9LgzVE"
 },
 {
  "Email": "C.Bovis@hull.ac.uk",
  "Name": "Christopher Bovis",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yju9Q4uy9djII2p3zaFg"
 },
 {
  "Email": "scomer@mofo.com",
  "Name": "Steven Comer",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YjypX7X3BVzZDeExSscz"
 },
 {
  "Email": "zdravko.marinkovic@komorabih.ba",
  "Name": "Zdravko Marinkovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YkAzpOM2QC37RhDNJOFR"
 },
 {
  "Email": "o.anyanechi@seftonfross.com",
  "Name": "Mrs Olayemi Anyanechi",
  "Document Name": "NIGERIA) SEFTON FROSS) BI 2020 NGA_bi_TPI_survey_en 22..8.2019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YkfaZmmAgJvrV73ukWVC"
 },
 {
  "Email": "info@barterlaw.co.nz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YkjtfKlSUqLcoqUk1vQn"
 },
 {
  "Email": "A.ziv@shibolet.com",
  "Name": "Alon Ziv",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YlvEWtcTiv6aGcKUvvma"
 },
 {
  "Email": "M-Ghanbari@sbu.ac.ir",
  "Name": "Mohammad Jafar Hanbari Jahromi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ym78f580uNInfXMdf96Q"
 },
 {
  "Email": "kaidar.sultson@magnussonlaw.com",
  "Name": "Kaidar Sultson",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ymh4ZuNo3qUT26cb1drM"
 },
 {
  "Email": "nihad.sijercic@karanovic-nikolic.com",
  "Name": "Nihad Sijercic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YmyttrUHxgZNqzxswwGc"
 },
 {
  "Email": "bobby.stewart@freshfields.com",
  "Name": "Bobby Stewart",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yn9Wrm0gGLm5CiVlaLW9"
 },
 {
  "Email": "Alexander.Gomonov@bakermckenzie.com",
  "Name": "Alexander Gomonov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YnwIDfIDZsV7K6dW4qyw"
 },
 {
  "Email": "rafoat.98@mail.ru",
  "Name": "Rafoat Kurbonova",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YoXzzG3zlGse8G49VuTN"
 },
 {
  "Email": "<irina.zapatrina@gmail.com",
  "Name": "Irina Zapatrina",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_Ministry of Regional Development, Construction and Communal Services of Ukraine.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yoo0csjqhISllEP0exgd"
 },
 {
  "Email": "abrenner@stblaw.com",
  "Name": "Alan Brenner",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yp2Z9FlsvUFf6c91cuJh"
 },
 {
  "Email": "nweoo@tilleke.com",
  "Name": "Mr. Nwe Oo",
  "Document Name": "MM_Benchmark Infrastructure Survey_TPI.doc",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YpXq1GOk6QsGSeHSNvD8"
 },
 {
  "Email": "lawcla@justice.com",
  "Name": "Melron Nicol-Wilson",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YqQtVffi6MyNk0R672t0"
 },
 {
  "Email": "jros@ferrere.com",
  "Name": "title Juan Manuel Ros",
  "Document Name": "World Bank - PPP Survey 2020 (Ferrere Comments July 15 2019) (ii)(925506.4).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YrOfroJmTlSItrJ60r66"
 },
 {
  "Email": "cecoma@uem.ac.mz",
  "Name": "Joana Sono",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YrmKX9LUkd6qmRwOkRZU"
 },
 {
  "Email": "law.firm@malsawwaf.com�",
  "Name": "David Wells",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YtsaOBZH5lWfrSj4nhrt"
 },
 {
  "Email": "kelvin.chia@kcpartnership.com",
  "Name": "Kelvin Chia",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YuMtKoKvjquiYiPnfpAK"
 },
 {
  "Email": "dvnikiforov@debevoise.com",
  "Name": "Dmitri Nikiforov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YvhbZuFhutm2Ga0Xe773"
 },
 {
  "Email": "stephen.beach@pg.pwc.com",
  "Name": "Stephen Beach",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YvnkHGqjqQRZZUk7r5PP"
 },
 {
  "Email": "globalaw@gmail.com",
  "Name": "Makario Tagini",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YvsBNH9vel9brLDauObt"
 },
 {
  "Email": "wwesteringh@fasken.com",
  "Name": "William Westeringh",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YvsSu718Usi3rdKtd4TH"
 },
 {
  "Email": "veritas@elcat.kg",
  "Name": "Nikolai Malyshev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YvxqCMcopZT6eThNrAFj"
 },
 {
  "Email": "nross@mostertlaw.com",
  "Name": "Nicky Ross",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YxIpcHKcmCy7NMCoJUVm"
 },
 {
  "Email": "pt@prestigenetwork.com",
  "Name": "Peter Townsley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YxxzFs7HFPvWqUrGzOhM"
 },
 {
  "Email": "ek@lou.dk",
  "Name": "Ernst Kj�rgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yy5d5W84Nt9NSxIScqIn"
 },
 {
  "Email": "john.boehm@nortonrosefulbright.com",
  "Name": "John C. Boehm, Jr.",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YybHGqr9IUzEFkrdJaG8"
 },
 {
  "Email": "piei@nortonrosefulbright.com",
  "Name": "Ms. Pimchanok Eianleng",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Yyr4Bmp3vvYvRrXXT3uq"
 },
 {
  "Email": "dilith@capitallaw.lk",
  "Name": "Dilith Jayaweera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YzENlxKRfFhPnBcbDCBe"
 },
 {
  "Email": "Kirchner@berettagodoy.com",
  "Name": "Mr. Carlos Kirchner",
  "Document Name": "BI 2020 ARG_bi_concession_survey FF(FG).docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YzMMj0UtOkfECuobGWql"
 },
 {
  "Email": "kate.rees@hoganlovells.com",
  "Name": "Kate Rees",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/YzZJeme9rR3CmtoQa2jp"
 },
 {
  "Email": "info@almisnad-rifaat.com",
  "Name": "Danny Rifaat",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z154jYIrN5cOnChd6UaG"
 },
 {
  "Email": "thuan.pham@vdb-loi.com",
  "Name": "Mr. Thuan Pham",
  "Document Name": "VIETNAM) VDB-LOI) BI 2020 VNM_bi_PPP_survey_en (002).docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z16Ez2LOqaBBKrJ7JaWE"
 },
 {
  "Email": "Maan.Al-Maree@undp.org",
  "Name": "Maan Al Maree",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z1YhBdtqru7c0fj49avU"
 },
 {
  "Email": "lars.westermark@vayla.fi",
  "Name": "Mr. Lars Westermark",
  "Document Name": "FINLAND) FINNISH TRANSPORT INFRASTUCTURE AUTHORITY) BI 2020 FIN_bi_PPP_survey_en Vayla.docx",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z1lMLYaeHTUsbmlVL2lq"
 },
 {
  "Email": "hberger@whitecase.com",
  "Name": "Henning Berger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z2EEHm6niVWHWWhTyWGb"
 },
 {
  "Email": "info@pacificprivatebank.com",
  "Name": "Eimantas Kazlauskas",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z2Y1aliqnzlIZg6Z6lTV"
 },
 {
  "Email": "Cherinetgebrehiwot@gmail.com",
  "Name": "Cherinet Gebrihiwot",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z2jq96hHI9MoSIl0Rgj5"
 },
 {
  "Email": "eric.rwelamira@zenithattorneys.com",
  "Name": "Eric Rwelamira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z47hXDr54jOPGwxVHD8g"
 },
 {
  "Email": "rmarti@una.cr",
  "Name": "Ruth Martinez Cascante",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z51I9k2YluHlbBS3YTgE"
 },
 {
  "Email": "bmanewe@bomaattorneys.co.bw",
  "Name": "Busang Manewe",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z5ZLWx2hdr2vxvaUyq1Z"
 },
 {
  "Email": "lala.hasanova@mgb-law.com",
  "Name": "Mrs. Lala Hasanova",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en.docx",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z64Ocs9i9n9LErDvCuiT"
 },
 {
  "Email": "lhoughton@deloitte.com.au",
  "Name": "Luke Houghton",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z6SZ7h4LrzLu1dkeLfQc"
 },
 {
  "Email": "carl.tremblay@nortonrosefulbright.com",
  "Name": "Carl Tremblay",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z6aC0HU6zOvO6QNAasek"
 },
 {
  "Email": "Ruth.Smith@mills-reeve.com",
  "Name": "Ruth Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z6anLYg4ME8ldWr4895E"
 },
 {
  "Email": "bbayram@morogluarseven.com",
  "Name": "Mrs. B�?ra Bayram",
  "Document Name": "182807 - 1 - BI 2020 TUR_bi_PPP_survey_en (ID 182807).doc",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z6e28uutiobkvQjekyTU"
 },
 {
  "Email": "info@tederlaw.ee",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z8IdWMMxUBzWq7vyEbqO"
 },
 {
  "Email": "jaan.lindmae@aaviklaw.ee",
  "Name": "Jaan Lindmae",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Z9ZBDIYXZAGDgrWBlkw7"
 },
 {
  "Email": "kostka@hertie-school.org",
  "Name": "Genia Kostka",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZAJcuVgJk9GQ6akNBQg2"
 },
 {
  "Email": "khalifa.kiango@zenithattorneys.com",
  "Name": "Khalifa Kiango",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZAM38REXiNWr4iU7Pn2g"
 },
 {
  "Email": "ysc@azizovpartners.uz",
  "Name": "Mrs Yana Niyazmetova",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Azizov.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZAqlMH9OrbxW771aPEeE"
 },
 {
  "Email": "kok.cheewai@allenandgledhill.com",
  "Name": "Kok Chee Wai",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZBMfxKrXwY8fNjpIRYJg"
 },
 {
  "Email": "ramahq@ramaconstructionplc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZD0KG57ui6iVu5Tjof7e"
 },
 {
  "Email": "pbi@horten.dk",
  "Name": "Peter Bisgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZDCZg6qrRIgXwTK5Mwib"
 },
 {
  "Email": "f.dawson@auckland.ac.nz",
  "Name": "Francis Dawson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZDJ8v7nfygW73gld8Jz8"
 },
 {
  "Email": "info@putrajaya-sd.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZFFGWHxfo5jPwOlb7Fuc"
 },
 {
  "Email": "info@zaconassociates.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZFNUYdkceXsoDOCKfkXe"
 },
 {
  "Email": "kmideksa@gmail.com",
  "Name": "Kelemework Mideksa Debela",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZFiaLun9BQ4AQn2XTgBm"
 },
 {
  "Email": "chamber@amcham.co.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZFqtpeozHK8GFGcGic6z"
 },
 {
  "Email": "liisa@alternalaw.ee�",
  "Name": "Liisa Orav",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZIDUJ2x8q9G20ukg1MUS"
 },
 {
  "Email": "inquiry@by.ey.com",
  "Name": "Mr. Vasili Babariko",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_EY.DOCX",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZJpkrq9oaEliLzguMIV7"
 },
 {
  "Email": "lroberts@corbanrevell.co.nz",
  "Name": "Lisa Roberts",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZJtkUylcJjIPxZ3krcjd"
 },
 {
  "Email": "curdakassis@shearman.com",
  "Name": "Cynthia Urda Kassis",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZKBHcp5FBZbpn8aOe1LZ"
 },
 {
  "Email": "patrick.mitchell@hsf.com",
  "Name": "Patrick Mitchell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZKwrrVdTDqp5SU32PTVI"
 },
 {
  "Email": "tferreira@cga.co.mz",
  "Name": "Mr. Telmo Ferreira",
  "Document Name": "BI 2020 MOZ_bi_TPI_survey_en - CGA05092019.docx",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZLXehWnt1gSOG9NSZ1q0"
 },
 {
  "Email": "habab.amin@sksadvocates.com",
  "Name": "Hebab Amin",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZLaqQkHODvn504VH5dRx"
 },
 {
  "Email": "dinukshi.thalgahagoda@fjgdesaram.com",
  "Name": "Dinukshi Thalgahagoda",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZLutzQsUpeumNxmI7z3J"
 },
 {
  "Email": "euan.murray@shepwedd.co.uk",
  "Name": "Euan Murray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZMca5WGE5afMAiOeCvK6"
 },
 {
  "Email": "phughes@carillion.ca",
  "Name": "Paul Hughes",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZNEwnjJ14JD10sJUgIUv"
 },
 {
  "Email": "Abolfazl@educatedlawyers.com",
  "Name": "Abolfazl Hosseinzadeh",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZNSLR71sKvDL3Q7UyL7l"
 },
 {
  "Email": "rmuttettuwegama@tiruchelvam.com",
  "Name": "Ramani Uttettuwegama",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZNhnJxSFDo4XYJN9t6Tq"
 },
 {
  "Email": "hiroo.atsumi@aplaw.jp",
  "Name": "Hiroo Atsumi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZNwn6uXrxrtonhYFbn03"
 },
 {
  "Email": "andres.siigur@derling.ee",
  "Name": "Andres Siigur",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZNzVcjoPHtKdTeOvoB0Y"
 },
 {
  "Email": "kalev.kasemets@labochema.ee",
  "Name": "Kalev Kasemets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZP46DBQiKX75z0ozbXB4"
 },
 {
  "Email": "duramotors@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZPGDgLVWelBJMnJfsWj6"
 },
 {
  "Email": "vanessa.oqueli@garciabodan.com",
  "Name": "Jazna Vanessa Oqueli De Riera",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZPXsDoYrsWK51SJrIGW5"
 },
 {
  "Email": "ian.barnard@fieldfisher.com",
  "Name": "Ian Barnard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZQQExc7hEFLQIpb0WpqJ"
 },
 {
  "Email": "wade.george@tt.ey.com",
  "Name": "Wade George",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZRBToyEbhnqxCPDbsc4A"
 },
 {
  "Email": "info@sfplaw.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZRq4Q664sZ5tE6krF1mI"
 },
 {
  "Email": "ansusky@yahoo.com",
  "Name": "Centus Lasana Ansu Macauley",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZU56m8cCZ70pNAt8yQ6D"
 },
 {
  "Email": "sharieaandlaw@iua.edu.sd",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZU5sQ7ayhE4cTtuOnRzl"
 },
 {
  "Email": "bernardo.ayala@uria.com",
  "Name": "Mr Bernardo Ayala",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZUQRvVdVI7XhMEQgTE96"
 },
 {
  "Email": "ahamad@albureau.com",
  "Name": "Alaa Hamad",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZUaQxvKrdbFs1KuhwtZ1"
 },
 {
  "Email": "H.Shafei@iccima.ir",
  "Name": "Gholamhossein Shafei",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZVu8bLdh7V7EQjlauFRW"
 },
 {
  "Email": "archer@ghana.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZWK30YpB4BZqZoR4W77e"
 },
 {
  "Email": "steven.williams@cms-cmno.com",
  "Name": "Steven Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZX6jLvM6EwXs7pGtIgii"
 },
 {
  "Email": "zbazianec@deloittece.com",
  "Name": "Zlatko Bazianec Bazianec",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZYOlAoPCNwdsTXGN2VO1"
 },
 {
  "Email": "jeankoh@ylp.com.sg",
  "Name": "Jean Koh",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZZ36QsgXVuTbFmvCmJSb"
 },
 {
  "Email": "teresa_ee@cp2m.gov.sg",
  "Name": "Teresa Ee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZZQjopmIskhjpo7cLLo5"
 },
 {
  "Email": "paula.akiwumi@gh.pwc.com",
  "Name": "Paula Akiwumi",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZZhN2kog0qz2OomgOKhM"
 },
 {
  "Email": "pgomezdelatorre@bustamante.com.ec",
  "Name": "Mr. Pedro G�mez de la Torre",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en.1.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZZpweCykdyJHqXLK69bY"
 },
 {
  "Email": "sarpong@4u.com.gh",
  "Name": "George Agyemang Sarpong",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZbM7uCpVVVrNpLIHNxld"
 },
 {
  "Email": "nikola.salatic@tasiclaw.com",
  "Name": "Mr Nikola Salatic",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_Tasic & Partners.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZbOMCR9Ym0zGY54G3rSK"
 },
 {
  "Email": "zelalem@mehrteableul.com",
  "Name": "Zelalem Yibrah",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZbiSwASWEs47StTtM1jT"
 },
 {
  "Email": "piia.kulm@lextal.ee",
  "Name": "Piia Kulma",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZblaFpmLBPDbEuzmBcDU"
 },
 {
  "Email": "richard.barham@dentons.com",
  "Name": "Richard Barham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zcd7GSC13AzspBYMoVzv"
 },
 {
  "Email": "dsneider@stblaw.com",
  "Name": "David A. Sneider",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZcnAMXjIO4THk4f8hRTj"
 },
 {
  "Email": "taavi.pihlakas@heta.ee",
  "Name": "Taavi Pihlakas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZeDj48aWxV9Ahy2Q3s1e"
 },
 {
  "Email": "info@iipppconsult.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZeSSAxeY7jODFcEGTA1c"
 },
 {
  "Email": "ljimenez@jcpdr.com",
  "Name": "Mr. Luis J. Jim�nez",
  "Document Name": "BI 2020 DOM_bi_PPP-survey_en_LJJ (00402513xAEE47).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZfLuSE2xeNiQQ9plGrIT"
 },
 {
  "Email": "cheah.sweegim@kcpartnership.com",
  "Name": "Cheah Swee Gim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZgHXDQiMzwKMHPK8LHlR"
 },
 {
  "Email": "abnolawi@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zggqfkv5zDUQNS0bKcB4"
 },
 {
  "Email": "ndtruong@mpi.gov.vn",
  "Name": "title Nguyen Dang Truong",
  "Document Name": "BI 2020 VNM_bi_TPI_survey_en-_Public Procurement Agency, Ministry of Planning and Investment Mr. Nguyen Dang Truong.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZhLi90kO9dIl8b0fiI7a"
 },
 {
  "Email": "atolchinsky@cdcfoundation.org",
  "Name": "Amy Tolchinsky",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZhgxR4gzyJrp2snS6uaM"
 },
 {
  "Email": "martinkizito@yahoo.co.uk",
  "Name": "Martin Kizito",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZhiiwXHABy3JwymiQAyE"
 },
 {
  "Email": "njohnson@millsoakley.com.au",
  "Name": "Nicola Johnson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZhmLygTQ1OBKS8oL6OhE"
 },
 {
  "Email": "Amitr@ysl-law.com",
  "Name": "Amit Ron",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZieQkP1VjERDk5NBOYuZ"
 },
 {
  "Email": "jileon@flycia.cl",
  "Name": "Mr Juan León",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en (3).docxJDR.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zik1AjZbkPiDNpluAMzp"
 },
 {
  "Email": "greg.lewis@nortonrosefulbright.com",
  "Name": "Greg Lewis",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZimFMOtSzHadNm4SYPMy"
 },
 {
  "Email": "office@app.gov.md",
  "Name": "Mrs Maria Sendila",
  "Document Name": "BI 2020 MDA_bi_PPP_survey_en_PPP Unit.docx",
  "Country": "MDA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Ziv3G8Jg4eyTHtdeKEuS"
 },
 {
  "Email": "vgarrido@rvhb.com",
  "Name": "Mr. Victor Garrido",
  "Document Name": "BI 2020 DOM__bi_PPP_survey_en.doc (00137128xA81FF).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zj26yHb5AaWUScSV7F3b"
 },
 {
  "Email": "alexander.newton@dlapiper.com",
  "Name": "Alexander Newton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zj3hTRMH5YVIA2YjkGjp"
 },
 {
  "Email": "jstupenengo@beccarvarela.com",
  "Name": "Mr. Juan Antonio Stupenengo",
  "Document Name": "BI 2020 ARG_bi_concession_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZjUZJBZttvswcrYKVLQI"
 },
 {
  "Email": "info@dccintl.com",
  "Name": "Richard Dick",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zjji3KjDhBiDBL0mUhjc"
 },
 {
  "Email": "dbartfeld@milbank.com",
  "Name": "Daniel Bartfeld",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZlkTqq7C9PO2z23djHwn"
 },
 {
  "Email": "andries@barnardinc.co.za",
  "Name": "Andries Stander",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZmXLGeAWmCnYRJgY8KFY"
 },
 {
  "Email": "stuart.stock@blplaw.com",
  "Name": "Stuart Stock",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZmlXVULeccqYp6z61M1T"
 },
 {
  "Email": "michael.o'connor@addleshawgoddard.com",
  "Name": "Michael O'Connor",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZmxRD5HvuTyBYr2LTUM9"
 },
 {
  "Email": "fd@abel.dk",
  "Name": "Flemming Dahl",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZmxmTFowdT2BnjiJsO7V"
 },
 {
  "Email": "hpf@hpf-advogados.com",
  "Name": "Helder Paulo Frechaut",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZnN7HWEjIo8eLG7vV1av"
 },
 {
  "Email": "kb@financewithvision.com",
  "Name": "Kabwe Pande",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZnT5BXswFA00PFsFHo4Y"
 },
 {
  "Email": "eric.colvin@usp.ac.fj",
  "Name": "Erin Colvin",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZoQN1ZZ2wbH2tGKwck4D"
 },
 {
  "Email": "JSLim@tpclaw.com.sg",
  "Name": "Jo See Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZohjVqxehhT9HyEwveep"
 },
 {
  "Email": "paulo.dantas@castrobarros.com.br",
  "Name": "Mr. Paulo Dantas",
  "Document Name": "World Bank - Benchmarking Infrastructure - PPP.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZojpTelmuDasay7iUbnW"
 },
 {
  "Email": "phuong.ngo@gowlings.com",
  "Name": "Phuong T.V. Ngo",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZqDunVBSrKs2OIv3s8YX"
 },
 {
  "Email": "falfaro@arifa.com",
  "Name": "Federico Alfaro",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZqPtV3VSWGJAgMpyhrg4"
 },
 {
  "Email": "thilanw@mo.treasury.gov.lk",
  "Name": "Mr. Thilan Wijesinghe",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en NAPPP.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZqlooYmYlesFFtj1FHEH"
 },
 {
  "Email": "mjgcain@smcm.edu",
  "Name": "Michael Cain",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZrCi7bxQaZyrFqnAexdr"
 },
 {
  "Email": "david.cave@ashurst.com",
  "Name": "David Cave",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZrQMwrJWKaqa43Vehwns"
 },
 {
  "Email": "mariam@adansonia.co.mz",
  "Name": "Mariam Umarji",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zu6J2HYVZOpT2RBb5alm"
 },
 {
  "Email": "artjom.luik@eversheds.ee",
  "Name": "Artjom Luik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZuTPQ7OOS47fIbg35Hsa"
 },
 {
  "Email": "gwalisto@gmail.com",
  "Name": "Michael Gwala",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zv2qWNIz0U36gPL6s3jb"
 },
 {
  "Email": "markfindlay@smu.edu.sg",
  "Name": "Mark Findlay",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZvkyvUZLSPNQc03tBspo"
 },
 {
  "Email": "sawawdeh@deloitte.com",
  "Name": "Mr Salam Awawdeh",
  "Document Name": "BI 2020 SAU_bi_TPI_survey_en_Deloitte.doc",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZvwYzc6Jp39BZXPbIuxj"
 },
 {
  "Email": "svetlana.sorkina@hoganlovells.com",
  "Name": "Svetlana Sorkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZwdkZB7KlsQYySUKvEHg"
 },
 {
  "Email": "rbeissel@cowellclarke.com.au",
  "Name": "Richard Beissel",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zy1gYuqXAO1t8oUK3MeB"
 },
 {
  "Email": "contact@cmathew.com",
  "Name": "Dimantha Mathew",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/Zz6t3rappfFcg7iRbSpn"
 },
 {
  "Email": "jwashington@ncppp.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZzHP3QpNkrjF10Ir3TR2"
 },
 {
  "Email": "emina.zahirovic@wolftheiss.com",
  "Name": "Emina Zahirovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ZzkZAH2KplLokFOvTsx5"
 },
 {
  "Email": "amoukhitdinov@curtis.com",
  "Name": "Askar Moukhitdinov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a0QXdlngB84kZlp1EtcQ"
 },
 {
  "Email": "v.sischin@moldcell.md",
  "Name": "Mr Vadim Sischin",
  "Document Name": "BI 2020 MDA_bi_PPP_survey_ru.doc",
  "Country": "MDA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a1oEoz9rz6yVzdRp2oRB"
 },
 {
  "Email": "janno.meriloo@rt.ee",
  "Name": "Janno Meriloo",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a2GQ0bRIr6qTypfrjl83"
 },
 {
  "Email": "adib@adiblawfirm.com",
  "Name": "Emad Mansouri Zad",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a3Ezoq0r3HuW92SqKxcK"
 },
 {
  "Email": "janderson@goodmans.ca",
  "Name": "Jean Anderson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a3WZURUyedHITD6Xzg4s"
 },
 {
  "Email": "mcalderon@s-s.mx",
  "Name": "Mariano Calder�n Vega",
  "Document Name": "S-S-#76697-v1-PPP_SURVEY_2020_wb.doc",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a42aO865t8BWFn9eqweU"
 },
 {
  "Email": "Vimal.Nair@minterellison.co.nz",
  "Name": "Vimal Nair",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a4gzllEw5HFLgtOIpmV6"
 },
 {
  "Email": "andrew.digges@ashurst.com",
  "Name": "Andrew Digges",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a5AxZEeJeeUDLGmFVQrZ"
 },
 {
  "Email": "mark.rathbone@sg.pwc.com",
  "Name": "Mark Rathbone",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a5JbCkINnVE1iBBP0Fov"
 },
 {
  "Email": "marko.kairjak@varul.com",
  "Name": "Marko Kairjak",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a5p0GVRHemwgizWUz65q"
 },
 {
  "Email": "armen.baghdasaryan@armadel.am",
  "Name": "Armen Baghdasaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/a9TyH4gMyzcCGCPrnF9X"
 },
 {
  "Email": "info@am.am",
  "Name": "Ani Atoyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aBLbDhnlaDV2uTDg2mBt"
 },
 {
  "Email": "davorin.marinkovic@karanovic-nikolic.com",
  "Name": "Davorin Marinkovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aBfkOQVfPR4G3cak7oFG"
 },
 {
  "Email": "gdd@bdplaw.com",
  "Name": "Dino Deluca",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aC72JY2IF5GHZd0ACHXe"
 },
 {
  "Email": "flainez@lainezlaw.com",
  "Name": "J. Faustino La�nez Mej�as",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aC9EeC6JxlA5oZfs3rCb"
 },
 {
  "Email": "Kokorev@gazprom-neft.ru",
  "Name": "Alexey Sergeevich Kokorev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aCCobefRNwLLVHkyy7ko"
 },
 {
  "Email": "erichards@omm.com",
  "Name": "Eric Richards",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aDzIDIjpqLILHuYa1PVG"
 },
 {
  "Email": "maria.castelos@csassociados.pt",
  "Name": "Ms. Maria Castelos",
  "Document Name": "WordBank_SurveyPPP.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aEEwcBk4fbhjsVTN0F2y"
 },
 {
  "Email": "info@usircc.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aEGEXK3Y11nu0rkpkvQz"
 },
 {
  "Email": "jh@pp-as.dk",
  "Name": "Jesper Hvam",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aFCaX4SMliZpvNQFDrgY"
 },
 {
  "Email": "pegatzky@greenfort.de",
  "Name": "Claus Pegatzky",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aFSKUANmtkgqTlMbX3Kk"
 },
 {
  "Email": "office@LP.ua",
  "Name": "Dmytro Savchuk",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en (ID 16253).doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aFyHhSa9ytGh2uZWpmNQ"
 },
 {
  "Email": "jdelgado@deloitte.co.mz",
  "Name": "Jacinto Delgado",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aH18euXC8Vk092PgD2ij"
 },
 {
  "Email": "matta@rs.kagu.tus.ac.jp",
  "Name": "Matsuda Takanori",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aHeH4S7q8nruQUB3knfB"
 },
 {
  "Email": "info@lawyers-uganda.com",
  "Name": "Angualia Daniel",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aHlZGU88SEML8Rmq5x7j"
 },
 {
  "Email": "paul.k.brewer@uk.pwc.com",
  "Name": "Paul Brewer",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aIZIkrzwpfFr7G2kPJAo"
 },
 {
  "Email": "hsargsyan@prudencelegal.com",
  "Name": "Hayk Sargsyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aJm7YQU3Xanmvr9Dsrkm"
 },
 {
  "Email": "gwebster@kpmg.ca",
  "Name": "Gary Webster",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aJpFGgGEQqTxw6IAtSs3"
 },
 {
  "Email": "jemalawyers@jemalawyers.com.pg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aL0C9mKGv7dQoisnkYMj"
 },
 {
  "Email": "dean_law@neelain.edu.sd",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aLQe6j8PVOPbaQI9rAsj"
 },
 {
  "Email": "steve.wardlaw@bakerbotts.com",
  "Name": "Steven Wardlaw",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aMIEhxy7kIN9xB9lmErY"
 },
 {
  "Email": "sylvester.taku@za.ey.com",
  "Name": "Sylvester Taku",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aNZ4wOPPGb5T3nXGl203"
 },
 {
  "Email": "taimi@zincpot.ee",
  "Name": "Taimi Toman",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPS014YQr4zFrLMkn9Xs"
 },
 {
  "Email": "iria.calvino@hsf.com",
  "Name": "Mrs. Iria Calvi�o",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en july 2019.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPYNjILuh37UevbatBzC"
 },
 {
  "Email": "jasmin.saric@wolftheiss.com",
  "Name": "Jasmin Saric",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPauQLuefjj9kkoAs8oO"
 },
 {
  "Email": "elgawharym@bennettjones.com",
  "Name": "Muhammad El Gawhary",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPtDxKiVWs1JI6BCY3WI"
 },
 {
  "Email": "carlos.hernandez@pragma.legal",
  "Name": "Carlos Hernandez-Aguiar",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPuKU198AW3mZ7c8KWiq"
 },
 {
  "Email": "info@chaverrisoto.com",
  "Name": "Doris Rodriguez Chaves",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPwTJpfNbTQ5nN5kszyN"
 },
 {
  "Email": "jdewar@milbank.com",
  "Name": "Mr John Deware",
  "Document Name": "BI 2020 GBR_bi_TPI_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aPxjTZlpcj7i16lGFet4"
 },
 {
  "Email": "tatsuo.tezuka@aplaw.jp",
  "Name": "Tatsuo Tezuka",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aQEkVJaJJ0akBgNq6Pur"
 },
 {
  "Email": "myazici@yaziciao.com",
  "Name": "Mr Murat Yaz?c?",
  "Document Name": "TURKEY) YAZICI) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aRVMdHwr2jHDmCIb3qcp"
 },
 {
  "Email": "zmomin@alghanim.com",
  "Name": "Zafar Momin",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aSMZ7oDyuR53O1WPrEXS"
 },
 {
  "Email": "mbairstow1@uk.ey.com",
  "Name": "Malcolm Bairstow",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aSd43KAiTjQp4KZlJkgz"
 },
 {
  "Email": "sheelgill1@kpmg.co.ke",
  "Name": "Sheel Gill",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aTCHrJGzfKX1otzk31oa"
 },
 {
  "Email": "dausuta@mid.gov.sb",
  "Name": "Ms Dulcie Ausuta",
  "Document Name": "BI 2020 SLB_bi_PPP_survey_en Dulcie Ausuta 15Jul19.docx",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aTCp4AZJOLbNAAcSiaMX"
 },
 {
  "Email": "upekha.senaratne@fjgdesaram.com",
  "Name": "Upekha Senaratne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aTnAQU3hUG7jBNI1sTh7"
 },
 {
  "Email": "rap@machadoassociados.com.br",
  "Name": "Ms Renata Almeida Pisaneschi",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (1)[2170].docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aUOKT40TIJD9ewbSVHO2"
 },
 {
  "Email": "amelkonyan@counterpart.am",
  "Name": "Anna Melkonyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aUaMjxwl2RmnbTGnzND7"
 },
 {
  "Email": "info@lorma.com.pg",
  "Name": "Danny Korakali",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aUcIcjHiJ0Zpkpphpmx0"
 },
 {
  "Email": "carlos@sundfeld.adv.br",
  "Name": "Carlos Ari Sundfeld",
  "Document Name": "19092209 WB Concession and PPP - Floriano de Azevedo Marques Neto.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aVj6ltxb1fZZGEfl5pTs"
 },
 {
  "Email": "montaseral@mansourlawfirm.com",
  "Name": "Montaseral Sokkary",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aWbjMU9G5uVu5cj5l77x"
 },
 {
  "Email": "tata@ptsmi.co.id",
  "Name": "Mr Tata Sumirat",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_PTSMI.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aXziFRXGYwmkgnBcoh24"
 },
 {
  "Email": "gksharmagk@yahoo.co.in",
  "Name": "Greesh Sharma",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aYVRX5NKoZaaLZHfMbG3"
 },
 {
  "Email": "francisco@matapitti.com",
  "Name": "Francisco Javier Mata Donado",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aZKPE0DzS2g00NJ5CF6t"
 },
 {
  "Email": "kimathi@kimathilegal.com",
  "Name": "Mr. Kimathi Kuenyehia",
  "Document Name": "BI 2020 GHA_bi_PPP_survey_en (KnPr).docx",
  "Country": "GHA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aZOp6LG7UzTU7LjL0bdA"
 },
 {
  "Email": "magdalena.zablocka@twobirds.com",
  "Name": "Ms Magdalena Zab?ocka",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_Bird&Bird.DOCX",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aaG6h372QitLCCr9EKah"
 },
 {
  "Email": "iain.duncan@simmons-simmons.com",
  "Name": "Iain Duncan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aajiaUf2e0CNO6WCKpU1"
 },
 {
  "Email": "matt.rennie@ey.com",
  "Name": "Matt Rennie",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aam57KpQxtnq6cqNCjiI"
 },
 {
  "Email": "law.firm@malsawwaf.com�",
  "Name": "David Wells",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/abSWmHbQ4fP5KdN4Ulcg"
 },
 {
  "Email": "main@picazolaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/abxTXEtMvutpdM0gLwAB"
 },
 {
  "Email": "audax.kameja@mkono.com",
  "Name": "(Rtd) Audax Kameja",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aeOy0WjSmnqFMbgt7RH2"
 },
 {
  "Email": "sthouvenot@ensafrica.com",
  "Name": "S�bastien Thouvenot",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/agIu17xd0gaW8UbAdvub"
 },
 {
  "Email": "info@bklaw.ge",
  "Name": "Mikheil Kristesashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ah8PAjTypOL5oWgIeMUe"
 },
 {
  "Email": "dumann@bmt.eu",
  "Name": "Axel Dumann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ahRQ2KUHynhfGzQ6vSzC"
 },
 {
  "Email": "klaird@deloitte.com.pg",
  "Name": "Kirsty Laird",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ahaLPveHB8pYk03c5xD4"
 },
 {
  "Email": "carlos.camacho@ariaslaw.com",
  "Name": "Mr. Carlos F. Camacho",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en CCG FINAL.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aj8MyzxVmgD1DEkDrSm6"
 },
 {
  "Email": "feruz.fidaev@dlapiper.com",
  "Name": "Feruz Fidaev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ajW2huBb7JDhE6PV9Fgr"
 },
 {
  "Email": "gsoutham@dwpv.com",
  "Name": "Gregory G. Southam",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/akz2C9ug3kj3Qvoib89v"
 },
 {
  "Email": "mohammed@aljadaan.com",
  "Name": "Mohammed Al-Jadaan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/alOaDprwcrHudP9OSMuc"
 },
 {
  "Email": "logan.mair@ashurst.com",
  "Name": "Logan Mair",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/amrEVkj5SFSeW5qJ6rZL"
 },
 {
  "Email": "kelshall.jb@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/an37UiYjlpTZbycdj8Mr"
 },
 {
  "Email": "dbahige@kaa.co.ug",
  "Name": "Mr. David Bahige",
  "Document Name": "UGANDA) KAMPALA ASSOCIATED ADVOCATES) BI 2020 UGA_bi_PPP_survey_en.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/anT07N2KTg27onv27otf"
 },
 {
  "Email": "vfranyutti@nhg.com.mx",
  "Name": "Ms. Vanessa Franyutti",
  "Document Name": "NHG-#68420-v2-World_Bank_Tradition_Public_Infrastructure_Investment.DOC",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/anni8iFTJrlhrSt9gtm4"
 },
 {
  "Email": "roberto.camacho@ppulegal.com",
  "Name": "Mr Roberto Camacho",
  "Document Name": "PPU-_7979994_V_1_Benchmarking Infrastructure PPPs in Colombia 2020 - World Bank Group Survey.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/apGg6TOZquVUHF8mDGQt"
 },
 {
  "Email": "msignor@stoccheforbes.com.br",
  "Name": "Ms. Miriam Signor",
  "Document Name": "WB PPP.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/apoiZ3nZXMLWikU82yLl"
 },
 {
  "Email": "sertac.kocahal@pae-law.com",
  "Name": "Mr. Mehmet Ali Serta� Kocahal",
  "Document Name": "TURKEY) PELSITER) BI 2020 TUR_PPP_survey_en_PAE 22.07.2019.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aqxodoZ1YT6vDgxr0o1C"
 },
 {
  "Email": "tilani.ford@fjgdesaram.com",
  "Name": "Tilani Ford",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ar4m2aItIrK2FpBywd0v"
 },
 {
  "Email": "ani@kp.am",
  "Name": "Ms Ani NARGIZYAN",
  "Document Name": "BI 2020 ARM_bi_PPP_survey_en_K&P.docx",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/arrZ41jwCcHAz9kHB15W"
 },
 {
  "Email": "thomas.donovan@iqilaw.com",
  "Name": "Thomas W. Donavan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/arrgwtKk7lgZmGpFCRso"
 },
 {
  "Email": "olivera.stojanovic@ups.gov.me",
  "Name": "Ms Olivera Stojanovi?",
  "Document Name": "PPP Montenegro Directorate for the Maritime Economy- Ministry of Transport and Maritime Affairs.docx",
  "Country": "MNE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/arwEff4bspXphfRkTe5y"
 },
 {
  "Email": "danat@gkh-law.com",
  "Name": "Dana Tal",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aso9OMJb267ELLiDo09y"
 },
 {
  "Email": "boazf@arnon.co.il",
  "Name": "Boaz Fiel",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/asuKdr9wt5qkCwXtxuLw"
 },
 {
  "Email": "mshitaye@yahoo.com",
  "Name": "Michael Ayalew Tiruneh",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/atFRfHFLK2IbFBwtvJli"
 },
 {
  "Email": "mail@advantek-ss.ru",
  "Name": "Yury Leonidovich Duzenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/atOsoZ0qkUcT3tC84bSO"
 },
 {
  "Email": "pharrison@whitecase.com",
  "Name": "Paul Harrison",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/atVWw7PUcjDxhKIomcuG"
 },
 {
  "Email": "m.jogi@ts.ee",
  "Name": "Margo J�gi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/atwWAxKBAv5D6mNiQdPN"
 },
 {
  "Email": "mmunalula@hotmail.com",
  "Name": "Margaret M. Manalula",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aufMdxo0AviPOR8TKqGL"
 },
 {
  "Email": "theo.guerre@gmail.com",
  "Name": "Theo Guerre-Canon",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/aul8lroNDxh2IPcJHyKS"
 },
 {
  "Email": "enquiries@hallowell-law.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/avU05OdM0SZjoanqliJh"
 },
 {
  "Email": "jndazi@bhlawassociates.com",
  "Name": "Joseph Ndazi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/awdge0scCMPVcywELnY7"
 },
 {
  "Email": "gilaniadil@gmail.com",
  "Name": "Mr Syed Adil Gilani",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_Syed Adil Gilani.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/axB6xxlpbol4nl2fZDHM"
 },
 {
  "Email": "chisom.sam-obasi@alliancelf.com",
  "Name": "Ms Chisom Sam - Obasi",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_TPI_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/azC9yhyPfDJCbgFIy6fl"
 },
 {
  "Email": "hideyuki.kobayashi@blakemore.gr.jp",
  "Name": "Hideyuki Kobayashi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/azQMY8xb1Zo7Creq0w9i"
 },
 {
  "Email": "pvalcarcel@uvigo.es",
  "Name": "Dr. Patricia Valc�rcel",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b1hwN2QYavPvbdki2wxD"
 },
 {
  "Email": "jstupenengo@beccarvarela.com",
  "Name": "Mr. Juan Antonio Stupenengo",
  "Document Name": "BI 2020 ARG_bi_TPI_ en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b1phJAO9ePP4Zo9a1eai"
 },
 {
  "Email": "sirle.karu@lextal.ee",
  "Name": "Sirle Karu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b1v8W08zGcd2nlcjUrJ8"
 },
 {
  "Email": "zekiafwork4@gmail.com",
  "Name": "Zekarias Afwork",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b26hbasVfAtMEkvU6vHz"
 },
 {
  "Email": "mburansky@deloittece.com",
  "Name": "Martin Buransky",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b2ENptEss8vlZysdiMA0"
 },
 {
  "Email": "saud.ammari@blakes.com",
  "Name": "Saud Al-Ammari",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b3ZGH5fPzsP4a1XW0qY6"
 },
 {
  "Email": "info@anham.com",
  "Name": "Kabir Arghandiwal",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b3iSH67uuJ7oRfyPIPID"
 },
 {
  "Email": "barry@arnon.co.il",
  "Name": "Barry Levenfeld",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b3jXEs5EvQ2i7uxXwq4t"
 },
 {
  "Email": "meploriega@punolaw.com",
  "Name": "Ma. Elizabeth E. Peralta-Loriega",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b47KUWC6roECceaCiADm"
 },
 {
  "Email": "ozm@firon.co.il",
  "Name": "Oz Mordechay",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b6jFk60cFnuqs5wHIUXq"
 },
 {
  "Email": "sujeewa.medalige@lk.pwc.com",
  "Name": "Sujeewa Medalige",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b7GrCoOI1mWULck1YNAC"
 },
 {
  "Email": "annemarie.mille@wko.at",
  "Name": "Dr. Annemarie Mille",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_Economic_Chamber.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b7bcuNDCHcKovYro7v1X"
 },
 {
  "Email": "stephen.matthews@bakerbotts.com",
  "Name": "Stephen Matthews",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b7gzUFGaCpqT7KpuUbDq"
 },
 {
  "Email": "fcairella@beccarvarela.com",
  "Name": "Ms. Florencia Cairella",
  "Document Name": "BI 2020 ARG_bi_concession_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b85hzWA5zjRVBllbcLHh"
 },
 {
  "Email": "anastasiya.malakhova@sbh-partners.com",
  "Name": "Ms Anaslasiya Malakhova",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_SBH.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b8AwfqC8liKNGw3zFFIC"
 },
 {
  "Email": "salvatore.mancuso@uct.ac.za",
  "Name": "Salvatore Mancuso",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/b98GSnwwURoMKc2chjay"
 },
 {
  "Email": "Nick.Saxton@minterellison.co.nz",
  "Name": "Nick Saxton",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bAL3q0aWAqlHuHmj49Sd"
 },
 {
  "Email": "reitor@ucm.ac.mz",
  "Name": "Alberto Ferreira",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bASRyr5xvEMuthqBZIPU"
 },
 {
  "Email": "francisco.morera@moreraabogados.com",
  "Name": "Francisco Morera Alfaro",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bAZQzMMBx7IVKjqFZcjt"
 },
 {
  "Email": "info@thenbf.co.za",
  "Name": "Laetitia Habchi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bCCWPoPRrszMHmwW7WG4"
 },
 {
  "Email": "khenriquez@claro.cl",
  "Name": "Mrs Karina Henríquez",
  "Document Name": "CHILE) CLARO N CIA) BI 2020 CHL_bi_TPI_survey_en (Autoguardado).docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bCTRckiptUcsVaUKJr2F"
 },
 {
  "Email": "saifullah.saifi@ada.org.af",
  "Name": "Saifullah Saifi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bCsByt3XJUTQ1hFoH89Z"
 },
 {
  "Email": "anaetony05@yahoo.co.nz",
  "Name": "Anae Tony Pereira",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bDFYsIfnnl6lm4hZcZsF"
 },
 {
  "Email": "ian.jacobsberg@hoganlovells.com",
  "Name": "Ian Jacobsberg",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bDmL97SF3RCgzv5tebr9"
 },
 {
  "Email": "solomon@nplaw.ge",
  "Name": "Mr Solomon Bagashvili",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_Nino.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bE3aiLOd4SoXyiqTRyrx"
 },
 {
  "Email": "mark.hoskyns-abrahall@uk.pwc.com",
  "Name": "Mark Hoskyns-Abrahall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bH4sfu3NNbpQnov4euAU"
 },
 {
  "Email": "fuente@abeledogottheil.com.ar",
  "Name": "Mrs. Verónica Fuente Kleiner",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en.doc",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bIvMYG9a85NrrHh8PfzQ"
 },
 {
  "Email": "awf_advocates@yahoo.co.uk",
  "Name": "Mohamed Elzain Mohamed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bJ6Q25KN4pv3PDXKlWqV"
 },
 {
  "Email": "danialgo19@yahoo.com",
  "Name": "Daniel Alemu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bJjgYD5GUftoyeGQWVh9"
 },
 {
  "Email": "nick.prowse@nortonrosefulbright.com",
  "Name": "Nick Prowse",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bK1vMABNnZyFulhiJcWm"
 },
 {
  "Email": "dandrade@iqsh.com.mx",
  "Name": "Dr Diego Andrade-Max",
  "Document Name": "MEXICO) IBANEZ) World Bank BI 2020 MEX_bi_PPP_survey_en.docx A REV.docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bK4mcaXylghFUjHPncjL"
 },
 {
  "Email": "a.elbekei@sharqlawfirm.com",
  "Name": "Abdelraouf Elbekei",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bL9fFToT6QgQZK7lACUr"
 },
 {
  "Email": "ppp@pcna.gkp.pk",
  "Name": "Mr. Sohail Ayaz",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_P&DD_Government of KP province.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bLjExReTQ2NocHOIwx5K"
 },
 {
  "Email": "ictar@zamnet.zm",
  "Name": "Pinalo Chifwanakeni",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bMeOe7SB1VWCxg6Emty4"
 },
 {
  "Email": "marianne.smith@blakes.com",
  "Name": "Ms. Marianne Smith",
  "Document Name": "BI 2020 CAN_Blake, Cassels & Graydon LLP.doc",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bMgbslgaQZeK2CxQyLFN"
 },
 {
  "Email": "ecobankenquiries@ecobank.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bNKQbLZXKZ4QUEuTvzb0"
 },
 {
  "Email": "dmatamoros@latamlex.com",
  "Name": "Denis Matamoros Batson",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bNudhV3naafm1Ca8KGPN"
 },
 {
  "Email": "onno.bakker@dlapiper.com",
  "Name": "Onno Bakker",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bO2JeUikmAdlQv7EHslB"
 },
 {
  "Email": "jarinaitwe@governancesystemsug.org",
  "Name": "John Bosco Arinaitwe",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bO7z9A1mg6SuchS2FpWE"
 },
 {
  "Email": "apierson@whitecase.com",
  "Name": "Adam Pierson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bOYLipEd64i1yZgKdsoa"
 },
 {
  "Email": "jalvarez@blplegal.com",
  "Name": "Mr Jose Alvarez",
  "Document Name": "BI 2020 HND_bi_PPP_survey_enBLP.doc",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bR4KCsnaOphqM6S9Slnx"
 },
 {
  "Email": "marwa.taha@sksadvocates.com",
  "Name": "Marwa Taha",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bR8J8nYgPoFrtuvX915r"
 },
 {
  "Email": "ceoacci@acci.org.af",
  "Name": "Kabir Haqjo",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bTSrrdRXULtI2t2BnVuc"
 },
 {
  "Email": "martin.polonyi@mfsr.sk",
  "Name": "Mr. Martin Polonyi",
  "Document Name": "Svetova_banka_dotaznik_Ministry of Finance.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bU8IPNIMBxdNnVpCUXye"
 },
 {
  "Email": "raquel@chirgwin.cl",
  "Name": "Ms. Raquel Frattini",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en_20190830_Chirgwin.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bUM0KbbCEoiovlm4YWXW"
 },
 {
  "Email": "d.samkharashvili@vmk.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bV1VJAcdyfeLobnCOxPs"
 },
 {
  "Email": "adjareli@hotmail.com",
  "Name": "Osman Chalishkhan - Mjavanadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bXNxxJWAAHVC49qwHz3l"
 },
 {
  "Email": "robin.baillie@squirepb.com",
  "Name": "Robin Baillie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYCwr5JQFMEihlS5m8ZU"
 },
 {
  "Email": "info@blayandassociates.com",
  "Name": "Freddie Blay",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYLPk6gt9CIM37Bi6q1g"
 },
 {
  "Email": "j.schulz@bmt.eu",
  "Name": "J�rg Schulz",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYQwGHUn5QK8mE1oBjpP"
 },
 {
  "Email": "Yerzhan.Kumarov@nortonrosefulbright.com",
  "Name": "Yerzhan Kumarov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYZFD3VsNCef2iH1GBie"
 },
 {
  "Email": "sarunas.neniskis@ellex.lt",
  "Name": "Mr. �ar?nas Neni�kis",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en. FINAL.doc.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYamGEA7dIvn6SZNptGL"
 },
 {
  "Email": "paul.sandosham@cliffordchance.com",
  "Name": "Paul Sandosham",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bYtymDI8R3F2bFGwMMrV"
 },
 {
  "Email": "Oleg.Matiusha@kinstellar.com",
  "Name": "Oleg Matiusha",
  "Document Name": "Kinstellar_Traditional Public Investment in Infrastructure in Ukraine_22.07.2019.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bZ8Ow17xGC25BOVWezy8"
 },
 {
  "Email": "cvouga@vouga.com.py",
  "Name": "Mr. Carlos Vouga",
  "Document Name": "BI 20220 PRY_bi_PPP_survey_en.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/baKWowlP7CmLduQPxW5c"
 },
 {
  "Email": "s.soravia@gvw.com",
  "Name": "Saskia Soravia",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/baUXCzJEkReo6Idkg8EA"
 },
 {
  "Email": "frank.kramer@kramerausenco.com",
  "Name": "Frank Kramer",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/baxIP6REvkYpL1pJdvEs"
 },
 {
  "Email": "hiroki.mori@aplaw.jp",
  "Name": "Hiroki Mori",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bb5vcvVtJ2SnMeCc8uFi"
 },
 {
  "Email": "ruediger.huelst@klgates.com",
  "Name": "R�diger von H�lst",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bcBUCeRAlmQ9cYfG9QrI"
 },
 {
  "Email": "lcastro@dnp.gov.co",
  "Name": "Mr Luis Fernando Castro",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en.doc",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bcS2ywrhK3dKqO5ykxJZ"
 },
 {
  "Email": "ulrich.reese@cliffordchance.com",
  "Name": "ULRICH REESE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bezkDNbZncm21D4DjuKK"
 },
 {
  "Email": "Bavesh.Pillay@pinsentmasons.com",
  "Name": "MR Bavesh Pillay",
  "Document Name": "BI 2020 ZAF_bi_TPI_survey_en_Pinsent Masons_Aug2019.docx",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bf3hUG0yE6NQf24NhPe4"
 },
 {
  "Email": "t.maro@rexattorneys.co.tz�",
  "Name": "Tabitha Maro",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bfL8dGXQVIeBZpgUT7Ri"
 },
 {
  "Email": "monsicha.pongrujikorn@allenovery.com",
  "Name": "Monsicha Pongrujikorn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bfTdEUfrsqI5HMlOZZSE"
 },
 {
  "Email": "lizst.real@hatstone.com",
  "Name": "Lizst Real",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bfYoN4EGugxebWBpRtg8"
 },
 {
  "Email": "t.toriashvili@energotrans.com.ge",
  "Name": "Tea Toriashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bgFIv4Q3RUum4V0p9M7c"
 },
 {
  "Email": "davies.tan@vdb-loi.com",
  "Name": "Mr Xue Jun Tan",
  "Document Name": "LAO) VDB-LOI) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bj2AvJ5ALsochOV6fnnw"
 },
 {
  "Email": "valeriya.ok@centil.law",
  "Name": "??????? ??",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_ru_Centil.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bjLeLJXq83T8oFIH4PbO"
 },
 {
  "Email": "udayan.mukherjee@dentons.com",
  "Name": "Udayan Mukherjee",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bk4OdN2jy1ROGxi3T8Tf"
 },
 {
  "Email": "rob.palmer@ashurst.com",
  "Name": "Rob Palmer",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bkgKSUbXZOUk4QtNhYhR"
 },
 {
  "Email": "ron@wwplaw.co.za",
  "Name": "Ron Ward",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bkt3bfaIy7oRJcIE7NDV"
 },
 {
  "Email": "orvc@out.ac.tz",
  "Name": "Paul Kihwelo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bmYwpg5SMYCqtCcLHIH1"
 },
 {
  "Email": "nomita.nair@blplaw.com",
  "Name": "Nomita Nair",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bmy8IaxraXk283ClATbY"
 },
 {
  "Email": "contactus.bw@sc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/boUbtyaNKFIsw5FCJRmp"
 },
 {
  "Email": "int.rel@ysu.am",
  "Name": "Gegham Petrosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bp4WcxGNMrfJDHkVETU8"
 },
 {
  "Email": "david.hattery@klgates.com",
  "Name": "David Hattery",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bpK20IqR3iNUVEytpEE0"
 },
 {
  "Email": "hrvoje.spajic@od-bsds.hr",
  "Name": "Hrvoje Spajic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bqncqsplHlvJKHhKQypc"
 },
 {
  "Email": "cpe.pdm@wits.ac.za",
  "Name": "Thabo Owen Mokwena",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/brjBSLO2veVfodOX1R5g"
 },
 {
  "Email": "ma-bahmaei@sbu.ac.ir",
  "Name": "Mohammad Bahmaei",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bsWVeAKWJKFh1TvkYWtR"
 },
 {
  "Email": "info@infrastructureontario.ca",
  "Name": "Nicholas Hann",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bsmQ8DeOpB33RZEO7pld"
 },
 {
  "Email": "hlotfi@hlotfi.com",
  "Name": "Hossein Lotfi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/btEh2Wa5vziwfyIe5vQ8"
 },
 {
  "Email": "office@tasiclaw.com",
  "Name": "Ms Marija Tasic",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_Tasic & Partners.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/btM9LItUYbrXxcLkc96a"
 },
 {
  "Email": "anjali.fernando@fjgdesaram.com",
  "Name": "Anjali Fernando",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/btYZL3cM3J1Y8c7iCZPQ"
 },
 {
  "Email": "ndellolio@abbatescianni.eu",
  "Name": "Mr Nicola Alessandro Dell'Olio",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_Nicola Alessandro Dell’Olio.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/btkMDDJvzlDJQCA30WZX"
 },
 {
  "Email": "dmathews@orrick.com",
  "Name": "Daniel Mathews",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bu2AYsF9fiqYOdt8C7Uk"
 },
 {
  "Email": "eastafricatenders@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/buduNead62O4mlXUYTVY"
 },
 {
  "Email": "oleh.andreikiv@kinstellar.com",
  "Name": "title Oleh Andreikiv",
  "Document Name": "Kinstellar_Traditional Public Investment in Infrastructure in Ukraine_22.07.2019.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bv4inZ92HlWlmsEtiX5y"
 },
 {
  "Email": "simomov@caiconsulting.org",
  "Name": "Sulton Imomov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bv6Zp0zs886hU89k5Zjp"
 },
 {
  "Email": "alistair.mcgillivray@cliffordchance.com",
  "Name": "Alistair Mcgillivray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bv9bDVDEWsJ1991mHWml"
 },
 {
  "Email": "lbarquero@lexincorp.com",
  "Name": "Ms. Linda Barquero",
  "Document Name": "BI 2020 NIC_bi_PPP_survey_en.docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bvKEbjZyyvzVoDYry3PR"
 },
 {
  "Email": "jake.falk@nortonrosefulbright.com",
  "Name": "Jacob Falk",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bvQ82Orx2a2agbVLM3fA"
 },
 {
  "Email": "vance.scott@ey.com",
  "Name": "Vance Scott",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bx7QQYBYq7iVTfWusLig"
 },
 {
  "Email": "richard.wagner@nortonrosefulbright.com",
  "Name": "Richard Wagner",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bxA8Aft495zpX19gpiM4"
 },
 {
  "Email": "ergo.blumfeldt@triniti.ee",
  "Name": "Ergo Blumfeldt",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bz6HAOcD2txNz0Gf6FFq"
 },
 {
  "Email": "sbuss@whitecase.com",
  "Name": "Sebastian Buss",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bzcA0pTf8AAYpK0DhQcO"
 },
 {
  "Email": "nir@porat-lawfirm.com",
  "Name": "Nir Porat",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/bzo4VeHTCFs4bFyUoxsg"
 },
 {
  "Email": "ulandacaldwell@yahoo.com",
  "Name": "Ulanda Caldwell",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c090MmFuthFh8CGNyHV4"
 },
 {
  "Email": "akiko.yamakawa@freshfields.com",
  "Name": "Akiko Yamakawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c0yw3aChIE9JJq8kH3B9"
 },
 {
  "Email": "jookhin.ng@stamfordlaw.com.sg",
  "Name": "Joo Khin Ng",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c1Y9zYhy8qnrEjUnZLa9"
 },
 {
  "Email": "sankha.karunaratne@fjgdesaram.com",
  "Name": "Sankha Karunaratne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c22uS9WGQmJ29KwyfwDn"
 },
 {
  "Email": "abox@kpmg.com.au",
  "Name": "Adrian Box",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c3pH34Z5Yka1NlawCXB4"
 },
 {
  "Email": "noora_sarhan@hotmail.com",
  "Name": "Noora Sarhan",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c40dNwddHr4N9lfnT9fH"
 },
 {
  "Email": "posesibloomfield@solutionconsultinghouse.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c5nLZCgiv1YFv9Sr3NDQ"
 },
 {
  "Email": "nagayama@bridge.t.u-tokyo.ac.jp",
  "Name": "Nagayama",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c7w2VKS8Z93qO1Owp0Rp"
 },
 {
  "Email": "david.lee@allenovery.com",
  "Name": "David Lee",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c84pl49jBM5EqForfGpB"
 },
 {
  "Email": "Joe.Cosma@za.ey.com",
  "Name": "Joe Cosma",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c8YlHAlrMpQICNlRHPRg"
 },
 {
  "Email": "matthias.voss@allenovery.com",
  "Name": "Matthias Voss",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c90DOX2DZKSFllBEVnlA"
 },
 {
  "Email": "andreas.peters@gsk.de",
  "Name": "Andreas C. Peters",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c9tbo1EgRPS6sONxYt0o"
 },
 {
  "Email": "j.taylor@ashfords.co.uk",
  "Name": "Jessica Taylor",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/c9v7M8sIrF2p4V0EXW6v"
 },
 {
  "Email": "angela.mndolwa@nortonrosefulbright.com",
  "Name": "Angela Mndolwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cA2fY09tfJTU7PGTZtlK"
 },
 {
  "Email": "artan@bozolaw.al",
  "Name": "Av. LL. M (PhD c) Artan Bozo",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en[1].docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cATmDjdOjPilC8a4oTZt"
 },
 {
  "Email": "sultanova77@mail.ru",
  "Name": "??????? ?????????",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cBYWj9xSmXlJ5TvoKQt4"
 },
 {
  "Email": "ablakov@bondstonelaw.com",
  "Name": "Sanat Ablakov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cCfJgf3ph6at10gxkMvh"
 },
 {
  "Email": "dkiefer@kslaw.com",
  "Name": "David Kiefer",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cCruNqhSsksmlHvCrP5P"
 },
 {
  "Email": "ashish.mathews@skrine.com",
  "Name": "Mr Ashish Mathews",
  "Document Name": "MALAYSIA) SKRINE) BI 2020 MYS_bi_PPP_survey_en (Skrine 19 July 2019).docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cDcqek0SxkFyaEtjsoUj"
 },
 {
  "Email": "ronald.fernandez@ppulegal.com",
  "Name": "Mr Ronald Fern�ndez-D�vila",
  "Document Name": "PPU-_211307_V_1_(Rev. PPU al 16.07.19)  WB 2020 - PPP Survey.DOCX",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cDlzlgryrvrNdTzBJVd6"
 },
 {
  "Email": "koinumam@gtlaw.com",
  "Name": "Makoto Koinuma",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cF2xF5hX8M56QYVNnQ9H"
 },
 {
  "Email": "simonas@simonas.net",
  "Name": "Simon Senaratna",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cFK6LPtXRKuvUqwMG5xA"
 },
 {
  "Email": "damat@arifa.com",
  "Name": "Diana M. Amat",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cG9wAoznKTQMytNUW407"
 },
 {
  "Email": "carles@alcabco.com",
  "Name": "Alexis Carlos Barraza",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cGKBWlUvtgQVzI1IqBlT"
 },
 {
  "Email": "jferentinos@mhealthtzppp.net",
  "Name": "Janita Ferentinos",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cGyD8fWYSa03EeUg1Ovb"
 },
 {
  "Email": "equeimado@ga-p.com",
  "Name": "Mr. Eduardo Queimado",
  "Document Name": "PORTUGAL) GAP) BI 2020 PRT_bi_PPP_survey_en.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cH54uzIruGsVeAF1yJ9Q"
 },
 {
  "Email": "nick.ogden@pinsentmasons.com",
  "Name": "Nick Ogden",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cIq8aanqDAlaBsRtxuEZ"
 },
 {
  "Email": "aivar.pilv@leadell.com",
  "Name": "Aivar Pilv",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cIroMcowB2M3iJPvaail"
 },
 {
  "Email": "ogutierrez@palacioslleras.com",
  "Name": "Mr. Óscar Gutiérrez",
  "Document Name": "TPI Survey Colombia - Óscar Gutiérrez V3.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cJZa8QV5IqiDQmqo8utp"
 },
 {
  "Email": "third@mega.bw",
  "Name": "K. Palalani",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cJznuyiCpJTjj1JBVdTB"
 },
 {
  "Email": "vcuyco@sunyaf.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cLsjYvSinVZ1VyAiTNgE"
 },
 {
  "Email": "cathy.quinn@minterellison.co.nz",
  "Name": "Cathy Quinn",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cMKbaHJk0nxslizrIHmQ"
 },
 {
  "Email": "tpm@avm.biz",
  "Name": "Tiago Pereira Monteiro",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cMiLAR7YwQx8v3qDoxt0"
 },
 {
  "Email": "drucil.taylor@bmtlaw.com",
  "Name": "Drucil Taylor",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cN5ENpn5I9tpohZSuYow"
 },
 {
  "Email": "sarona@ponifasio.com",
  "Name": "Sarona Ponifasio",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cNdK2Kex2Q7TwEBj8A6N"
 },
 {
  "Email": "yosbe@ethionet.et",
  "Name": "Yoseph Gebregiziabher",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cNeKPkNsaNxHROYcYp0W"
 },
 {
  "Email": "utku.unver@gedikeraksoy.com",
  "Name": "Mr Utku �nver",
  "Document Name": "IS-#1440317-v1-World_Bank_BI_2020_-_Turkey.DOC",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cOS1k7s05aH6gWJeZwL0"
 },
 {
  "Email": "peter.mastromarini@cibc.ca",
  "Name": "Peter Mastromarini",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cOfqfoBpK2H3nCbpaN0M"
 },
 {
  "Email": "andrew.chapman@maddocks.com.au",
  "Name": "Andrew Chapman",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cOza5ZUSKFTOruOVrwc8"
 },
 {
  "Email": "mahmoud.abdel-baky@dentons.com",
  "Name": "Mahmoud Abdel-Baky",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cPTVAffiYEFCJAv5kHEJ"
 },
 {
  "Email": "info@winmo.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cPvHd1yAhUnFbYl4HUug"
 },
 {
  "Email": "omerali@omeralilawfirm.com",
  "Name": "Omer Ali Ali",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cQHRf7rBd3CUvhXxhayz"
 },
 {
  "Email": "wmccormack@shearman.com",
  "Name": "Bill Mccormack",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cQzxraHL9fFGDPruwyIQ"
 },
 {
  "Email": "jorge.ucuchoadvogado@tmd.co.mz",
  "Name": "Jorge Ucucho",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cR8El9Ph6QG7GO7zB54I"
 },
 {
  "Email": "info@gse.com.ge",
  "Name": "Zurab Ezugbaia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cRdPbR4oy8NMvxBOJSG5"
 },
 {
  "Email": "santiago.maqueda@bakermckenzie.com",
  "Name": "Mr. Santiago Maqueda Fourcade",
  "Document Name": "BI_2020_ARG_bi_PPP_survey_en_BakerMcKenzie.doc",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cRlwTqUGz4WlqiZWsPJY"
 },
 {
  "Email": "mahekeac@yahoo.com",
  "Name": "Chimwemwe Kalua",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cRryAN8YakSfBDGAWbBt"
 },
 {
  "Email": "a.petres@schoenherr.eu",
  "Name": "Arijana Petres",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cRyqgQglXpVarMQl8eyW"
 },
 {
  "Email": "pradana@ptsmi.co.id",
  "Name": "Mr Pradana Murti",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_PTSMI.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cSh74EUuVkttDSlAnhw8"
 },
 {
  "Email": "Charles.Borden@hklaw.com",
  "Name": "Charles Borden",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cTMS0GGd4TvSMcL41sTp"
 },
 {
  "Email": "saudi@smas-ip.com",
  "Name": "Saud Al-Shawwaf",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cUFPkZkddC7aOkCvZDuI"
 },
 {
  "Email": "samra.hadzovic@lawoffice-hadzovic.com",
  "Name": "Samra Hadzovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cUQrWumjcbDewZp93ZqV"
 },
 {
  "Email": "?xiefei@cpppc.org????",
  "Name": "MR.????? ?Fei???? Xie",
  "Document Name": "BI 2020 CHN_bi_PPP_PO_survey_en_20190725-final.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cV9NosTNcA0EhTF81wpQ"
 },
 {
  "Email": "tdeboer@airdberlis.com",
  "Name": "Trevor Deboer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cVtKsZidJm3uPPjdFuTx"
 },
 {
  "Email": "lfanga@aelex.com",
  "Name": "Lawrence Fubara Anga",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cXDsxJ74pq3jmxU4Ogzt"
 },
 {
  "Email": "info@eliteattorneys.co.tz",
  "Name": "Hussein Kitta Mlinga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cXH02oUZL8EEpU5te7Ss"
 },
 {
  "Email": "shabat.oren@gmail.com",
  "Name": "Oren Shabat",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cY3jViFjj78nfKhqc8nR"
 },
 {
  "Email": "info@alhazmilawfirm.com.sa",
  "Name": "Hasan Al Hazmi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cZFkHpkTbZEpVmJ8a7t7"
 },
 {
  "Email": "laura.kiwelu@nortonrosefulbright.com",
  "Name": "Laura Kiwelu",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cZaedBHvlgy10iRtvtkD"
 },
 {
  "Email": "eramirez@blplegal.com",
  "Name": "Mr. Eduardo Ram�rez",
  "Document Name": "BI 2020 CRI_bi_PPP_survey_en.docx",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cZlwMFiHZYoHy1c70YNd"
 },
 {
  "Email": "amydorosan@yahoo.com",
  "Name": "Amelia A. Dorosan",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/caGMxjgokmuCioCiSJ0f"
 },
 {
  "Email": "aaj@azizovpartners.uz",
  "Name": "Mr. Abdulaziz Jurajonov",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Azizov.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cdc1I4aPVORHa96aRM5X"
 },
 {
  "Email": "besty@hbs.edu",
  "Name": "Benjamin Esty",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cdt0YGxyrPFKY0G7PWTr"
 },
 {
  "Email": "katri.paas@varul.com",
  "Name": "Katri Paas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ceAN211oTNf7YXOWuWMU"
 },
 {
  "Email": "heidi.muukkonen@dittmar.fi",
  "Name": "Ms. Heidi Muukkonen",
  "Document Name": "FINLAND) DITTMAR) 1079988-V2-BI 2020 FIN_bi_PPP_survey_en.DOC",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cf0q2LNQakmfydpCc1Jo"
 },
 {
  "Email": "Fleur.Clegg@AllenOvery.com",
  "Name": "Fleur Clegg",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cfOBYhwNFW8vR29Co5yo"
 },
 {
  "Email": "eric.roose@witherskhattarwong.com",
  "Name": "Eric Roose",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cfYsbp858GEeDTsESBWS"
 },
 {
  "Email": "mike.kaplan@dentons.com",
  "Name": "Mike N. Kaplan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cgAIYTqd9Qxo7lPuzijz"
 },
 {
  "Email": "tao@ut.ee",
  "Name": "Indrek Ots",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/chQWZUfS4phIRWVZhbAP"
 },
 {
  "Email": "marilin.laud@primus.legal",
  "Name": "Marlin Laud",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/chl04INpFkbOAgZ0oYCV"
 },
 {
  "Email": "benjiemarzan@yahoo.com",
  "Name": "Bienvenido C. Marzan",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/chygiVbcL8eaunOJmFOn"
 },
 {
  "Email": "iprd@ecsu.edu.et",
  "Name": "Gebre Tibetu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cjCSf1HDuRrMLGzo9Yrp"
 },
 {
  "Email": "duncan.halliwell@kensingtonswan.com",
  "Name": "Duncan Halliwell",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cjOqQhajuyzIkNcFGHDf"
 },
 {
  "Email": "nalesoni@tupoulaw.co.nz",
  "Name": "Nalesoni Tu'Inauvai Tupou",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ckFYYZSzltqlGChG7vMt"
 },
 {
  "Email": "jalvarez@blplegal.com",
  "Name": "Jos� Miguel Alvarez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cluWJNPrUl76oSo1xlA5"
 },
 {
  "Email": "adrian.magnus@blplaw.com",
  "Name": "Adrian Magnus",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cmKwpcjP9JFttQHrz20k"
 },
 {
  "Email": "tpm@avm.biz",
  "Name": "Dr- Tiago Pereira Monteiro",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en (002)_AVM_13092019_vf.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cmQ6grAErB9JEc56JHEy"
 },
 {
  "Email": "info@kazproduct.kz",
  "Name": "Zangar Tleubayev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cmz33hgB7tJkPMdHdCqS"
 },
 {
  "Email": "malter@casselsbrock.com",
  "Name": "Mathew R. Alter",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cn4XzQxlLWjOAVPekZAS"
 },
 {
  "Email": "takao_higuchi@noandt.com",
  "Name": "Mr. Takao Higuchi",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en_190717_Higuchi.docx",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cn6dwx7RCNz1bAC1Jy9w"
 },
 {
  "Email": "Chavapol.Akkaravoranun@bakermckenzie.com",
  "Name": "Chavapol Akkaravoranun",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/co9H23BaGzKiycSES9XH"
 },
 {
  "Email": "sanja.veljanovska@t.mk",
  "Name": "Ms. Sanja Veljanovska",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Mens_Sanja.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/coFeCYx6DeA9kWF3kbVr"
 },
 {
  "Email": "Greg.Koger@hklaw.com",
  "Name": "Gregory H. Koger",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/conzfuRROx3jn7zRJ3Pm"
 },
 {
  "Email": "focus.lutinwa@tz.pwc.com",
  "Name": "Focus Lutinwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cozsjvkLctF2HZruZGxV"
 },
 {
  "Email": "yotta.b@hammourilaw.com",
  "Name": "Ms and Mr and Mr Yotta Pantoula-Bulmer",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Hammouri.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cpF2pI1O8d4IQYV7tSoC"
 },
 {
  "Email": "mehrteab@mehrteableul.com",
  "Name": "Mehrteab Leul",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cpKiHpieV7snSDRfBVkf"
 },
 {
  "Email": "darshi@sudathpereraassociates.com",
  "Name": "Dharshika Herat Gunaratne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cpNGZRPQdeMH3Xs2FPDH"
 },
 {
  "Email": "federico.gurdian@garciabodan.com",
  "Name": "Mr. Federico Gurdian",
  "Document Name": "BI 2020 NIC_bi_PPP_survey_en.doc.docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cprsgE0sxA9n2Ll3eh5l"
 },
 {
  "Email": "Bishr.Baker@jo.ey.com",
  "Name": "Bishir Baker",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cqdP2mbyMNJlzb8cN6UO"
 },
 {
  "Email": "paubry@perlaw.ca",
  "Name": "Philip Aubry",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cquMLPXRSQvkmCuOw8RG"
 },
 {
  "Email": "sami.al-louzi@lw.com",
  "Name": "Sami Al-Louzi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cr32zchg3YH1VJ7GNzM9"
 },
 {
  "Email": "nmukhitdinov@curtis.com",
  "Name": "Nurlan Mukhitdinov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/crAxBQkimPn5iYitUQsk"
 },
 {
  "Email": "jemina.jarvilehto@dittmar.fi",
  "Name": "Ms. Jemina lJ�rvilehto",
  "Document Name": "FINLAND) DITTMAR) 1079988-V2-BI 2020 FIN_bi_PPP_survey_en.DOC",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/crvR01DEroPzb4YzojN2"
 },
 {
  "Email": "macarena@chirgwin.cl",
  "Name": "Ms. Macarena Bedregal",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en_20190830_Chirgwin.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/csQCSik5LtA9s1D4c1FH"
 },
 {
  "Email": "s.deeb@tamimi.com",
  "Name": "Salah Deeb",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ctf2TElxW71tdCW9lVsp"
 },
 {
  "Email": "elizabeth.mayer@dlapiper.com",
  "Name": "Elizabeth Mayer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cuZlLJLTPKarjvojT9vE"
 },
 {
  "Email": "yuri_savvin@epam.ru",
  "Name": "Yuri Savvin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/curOBpgBn2QEeJ6jWGwa"
 },
 {
  "Email": "radler@azevedosette.com.br",
  "Name": "Rafael Adler",
  "Document Name": "B2I 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cvCpemZ2ufxLteT0V2sJ"
 },
 {
  "Email": "info@mik-law.org",
  "Name": "Mohamed Ibrahim Khalil",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cxDmcZdiN7mD7mUb7nqb"
 },
 {
  "Email": "edoardo.betto@dlapiper.com",
  "Name": "Edoardo Betto",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cxTd0DKCVEB6cA10NrRq"
 },
 {
  "Email": "acapP3@aecom.com",
  "Name": "Katayoun Sadeghi",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cxYuIRRyrmrpcBRLU0TU"
 },
 {
  "Email": "stuart.mcintyre@bakerbotts.com",
  "Name": "Stuart Mcintyre",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cyIkIJ3usFEQtwgKBurX"
 },
 {
  "Email": "benru.genent@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/cyX3Q6MJowVt4YrgytGU"
 },
 {
  "Email": "wheelerco@lawyer.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/czRAYDj1PUcdyUYUJkoW"
 },
 {
  "Email": "tongalawsociety@gmail.com",
  "Name": "Laki Maile Niu",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/czc6vtNN1FnUUYNPF5cd"
 },
 {
  "Email": "abamasak@kau.edu.sa",
  "Name": "Abdullah Mohammed Bamasak",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/czhJwtRVulhmj4rcwajT"
 },
 {
  "Email": "kevin.arkwright@nortonrosefulbright.com",
  "Name": "Kevin Arkwright",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/czvxamXBbQ1eORkA0KDv"
 },
 {
  "Email": "maryam@sjmsassociates.com",
  "Name": "Maryam Marikkar",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d1DnCOBbJXPZYrdxkXJq"
 },
 {
  "Email": "paul.kibuuka@isidoralaw.co.tz",
  "Name": "Paul Kibuuka",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d1nmUr5j71fNyqYV9Rgx"
 },
 {
  "Email": "AkhtarRaja@quistlaw.com",
  "Name": "Akhtar Raja",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d2eCsbIjVrppNAGgbRt1"
 },
 {
  "Email": "fd@ustm.ac.mz",
  "Name": "Rufino Adriano",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d3DSfO1r8K10Kqn2pRjo"
 },
 {
  "Email": "jcv@vda.pt",
  "Name": "Mr. Jo�o Cortez Vaz",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_en.doc_(DM 7605157_1) (005).DOCX_(DM 7633273_1).docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d3srkm3x3389W6joFwzl"
 },
 {
  "Email": "taivo.ruus@triniti.ee",
  "Name": "Taivo Ruus",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d4UzwnXlatIBDWMDxoJa"
 },
 {
  "Email": "feras@alshawaflaw.com",
  "Name": "Feras Al Shawaf",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d835MiEbgzvW0ELKX64U"
 },
 {
  "Email": "bluhm@mwp-berlin.de",
  "Name": "Carsten Bluhm",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d93ClKlfGqr1tLA9cr44"
 },
 {
  "Email": "colin.wilson@dlapiper.com",
  "Name": "Colin Wilson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d9KpCcKSJrR4RUcrxoBK"
 },
 {
  "Email": "glenn.lovell@me.kwm.com",
  "Name": "Glenn Lovell",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/d9bSvfohPybiJYEsGAYe"
 },
 {
  "Email": "Margarita.Oliva@bakermckenzie.com",
  "Name": "Margarita Oliva",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dA0zF3Ot1a0RfdikUNIj"
 },
 {
  "Email": "karen.fulton@hsf.com",
  "Name": "Karen Fulton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dC4nhYNUMdm6AD6WrJEG"
 },
 {
  "Email": "janis.buendia@arodi.com",
  "Name": "Janis Buendia",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dC7hx9H0wldDwMpfygMZ"
 },
 {
  "Email": "ddonald@osler.com",
  "Name": "Danna Donald",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dCCTNG1PicipKZkP4LU7"
 },
 {
  "Email": "inquire@wilsonwilliams.com",
  "Name": "Charles Williams",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dCytLkqnINoNz25HSqdP"
 },
 {
  "Email": "ocsolon@up.edu.ph",
  "Name": "Orville Jose C. Solon",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dDtSP9LIe97Sh5LmygRP"
 },
 {
  "Email": "m_ito@jurists.co.jp",
  "Name": "Ms. Maya Ito",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en_Maya Ito.doc",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dERwCYTeqvY5c87Qj2Yu"
 },
 {
  "Email": "kg.law@kglawfirm.gr",
  "Name": "Ms Elisabeth Eleftheriades",
  "Document Name": "GREECE) KYRIAKIDES) BI 2020 GRC_bi_PPP_survey_en_KG input.DOCX",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dEa8SYHGvGsGcsVapZ0t"
 },
 {
  "Email": "cmurangi@ikm.co.ke",
  "Name": "Ms. Christine Murangi",
  "Document Name": "KEN_bi_PPP_survey_en_Christine Murangi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dFpOQNPm9gulGzCCDRxm"
 },
 {
  "Email": "lmayorga@mef.gob.pe",
  "Name": "Lenin Mayorga",
  "Document Name": "PO1.BI 2020 PER_bi_PPP_survey_en (19.07.19).docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dFsb7As0A4KxjKJ06bgq"
 },
 {
  "Email": "t.tupefou@nus.edu.ws",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dGQ6ZJjjer4Eb3AV5Fev"
 },
 {
  "Email": "chandoo@fbattorneys.co.tz",
  "Name": "Mustafa Chandoo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dGj20W9WfbzKW3rBkesU"
 },
 {
  "Email": "mohdsharifsa@yahoo.com",
  "Name": "Mohamed Al-Sharif",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dHqtISnn1wCpwO0kpcUz"
 },
 {
  "Email": "riabenko@vkp.ua",
  "Name": "Mr Roman Riabenko",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_Vasil Kisil & Partners.doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dIA8RSSUbfNlDv6X6L7z"
 },
 {
  "Email": "zekiafwork4@gmail.com",
  "Name": "Zekarias Afwork",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dIEYUNtBsCJSVKM2JnHu"
 },
 {
  "Email": "alexander.dolgov@hoganlovells.com",
  "Name": "Alexander Dolgov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dJ0WDNs8ZXwticePSzqW"
 },
 {
  "Email": "info@cll.ge",
  "Name": "Aleksandre Tsuladze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dJJpKq4STRqsvkTUESgG"
 },
 {
  "Email": "katri.paalberg@pvesi.ee",
  "Name": "Katri Paalberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dJRuiKYiVd6sPlOUBR7g"
 },
 {
  "Email": "hrandall@trowers.com",
  "Name": "Helen Randall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dKxRcaeLNwj8PawEhUwM"
 },
 {
  "Email": "agamallo@talial.com",
  "Name": "Anabel Gamallo Q.",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dL8pv9nifJeR4gGbOUy9"
 },
 {
  "Email": "info@globalspc.am",
  "Name": "Samvel Zakaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dLOFaskQerhtADgwguSO"
 },
 {
  "Email": "khalil@khazindarlaw.com",
  "Name": "Khalil Khazindar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dLZ7hv0a9FSolK8woAwn"
 },
 {
  "Email": "shiva@pioneerlaw.com",
  "Name": "Mr. Shiva Prasad Rijal",
  "Document Name": "BI 2020 NPL_bi_PPP_survey_en (2).docx",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dMTViejGv4F2nz4FpxSJ"
 },
 {
  "Email": "simon.caridia@hsf.com",
  "Name": "Simon Caridia",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dMhEFmoRDIiUXJPQmWwo"
 },
 {
  "Email": "JGodber@blg.com",
  "Name": "John Godber",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dMlAeQik1x0v4KAdzlWt"
 },
 {
  "Email": "Zong-Pei.Zhao@chenpalmer.com",
  "Name": "Zong-Pei Zhao",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dMy86liu7MfpZiwgVCvv"
 },
 {
  "Email": "ewafwana@cabemery.org",
  "Name": "Emery Mukendi Wafwana",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dONyTDxrxxfpGGm43dvG"
 },
 {
  "Email": "z.tsotsiashvili@energotrans.com.ge",
  "Name": "Zaza Tsotsiashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dOkrUfz5B8xDGGKdmfXZ"
 },
 {
  "Email": "d.samson@unimelb.edu.au",
  "Name": "Daniel Samson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dPWo46CMJWxudyrmXtXs"
 },
 {
  "Email": "michael.hodge@meredithconnell.co.nz",
  "Name": "Michael Hodge",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dQJGKsKAWvfEoJmr9xVX"
 },
 {
  "Email": "nkumamoto@stblaw.com",
  "Name": "Noritaka Kumamoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dQQQ5AbEZvYtxeZYK5xD"
 },
 {
  "Email": "info@nmmattorneys.info",
  "Name": "Godwin S Ngwilimi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dQkQifS8YWaFpIAeMvEu"
 },
 {
  "Email": "n.metje@bham.ac.uk",
  "Name": "Nicole Metje",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dQpFpgzA5lm06raDDWF0"
 },
 {
  "Email": "mbconsult@global.net.pg",
  "Name": "Alan Mclay",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dS6hEWLq9UQ28g05YVk5"
 },
 {
  "Email": "lit@tpprf.ru",
  "Name": "Sergey Katyrin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dSBghujb2USbIcpOwkrE"
 },
 {
  "Email": "shaig_adigozalov@cbar.az",
  "Name": "Mr Shaig Adigozalov",
  "Document Name": "BI 2020 AZE_PPP_survey_en_Final (1).docx",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dSjSxo0DJfv7bWNUck2g"
 },
 {
  "Email": "jennifer.gibson@burges-salmon.com",
  "Name": "Jennifer Gibson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dTkrScnmFmDNysIEtPMt"
 },
 {
  "Email": "anuamah2@yahoo.com",
  "Name": "Agel Nuamah",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dUr3zzXiynA3alULlqG2"
 },
 {
  "Email": "jplabuschagne@deloitte.co.ke",
  "Name": "Jean-Pierre Labuschagne",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dV223AwFCXTjMnTqXKU5"
 },
 {
  "Email": "jaanus@tehver.ee",
  "Name": "Jaanus Tehver",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dV7Nrwc3nqGxkt2keRtW"
 },
 {
  "Email": "darcy.ammerman@mcmillan.ca",
  "Name": "Darcy Ammerman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dVVZWtBBaXx4LkZmjofX"
 },
 {
  "Email": "laura.kiwelu@nortonrosefulbright.com",
  "Name": "Laura Kiwelu",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dW6bxnRXTPl1DbbIwtrg"
 },
 {
  "Email": "jonathan.seeto@pg.pwc.com",
  "Name": "Jonathan Seeto",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dWZVyZ8oDmqUFOPWt9Ql"
 },
 {
  "Email": "belal@ghazzawilawfirm.com",
  "Name": "Belal T Al Ghazzawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dWds4AGYgNdB7gvZZSqy"
 },
 {
  "Email": "lni@plesner.com",
  "Name": "Ms Lise Aaby Nielsen",
  "Document Name": "DENMARK) PLESNER) World Bank 2020 PPP survey (2).docx",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dXdkz5XxbAyMYq5XPbSu"
 },
 {
  "Email": "edoardo.betto@dlapiper.com",
  "Name": "Edoardo Betto",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dYCuQ51geUOX8unEafor"
 },
 {
  "Email": "gandhi@telfer.uOttawa.ca",
  "Name": "Devinder Gandhi",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dYYxMxD35QtQqsoSD60A"
 },
 {
  "Email": "agathalee@witherskhattarwong.com",
  "Name": "Agatha Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dZ4Q4E1bigVpSgimNCk3"
 },
 {
  "Email": "chike.obianwu@templars-law,com",
  "Name": "Mr. Chike Obianwu",
  "Document Name": "NIGERIA) TEMPLARS) BI 2020 NGA_bi_PPP_survey_(Templars).docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dZZ9qA4vPXN3Xh8KUepo"
 },
 {
  "Email": "mkern@cgsh.com",
  "Name": "Michael Kern",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dZhATdDtdV65k5xQ18I7"
 },
 {
  "Email": "amalia.hernandez.sendin@garrigues.com",
  "Name": "Mrs Amalia Hern�ndez Send�n",
  "Document Name": "BI20202020ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/da59jdVUGu1aZObydnYf"
 },
 {
  "Email": "brian.budden@plenarygroup.com",
  "Name": "Brian Budden",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/da8jl2V4uqgRdLDifG0m"
 },
 {
  "Email": "kbadalyan@prudencelegal.com",
  "Name": "Karapet Badalyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/damnNq2gqpnT6vRwaNWe"
 },
 {
  "Email": "anisa.law@telkomsa.net",
  "Name": "Anisa Soobrathi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dbCiBD38pqIB4eF1zFMZ"
 },
 {
  "Email": "avm@avm.biz",
  "Name": "Dr. Ant�nio Vicente Marques",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en (002)_AVM_13092019_vf.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dc8WL0p0jDQjjWzsrxHP"
 },
 {
  "Email": "jwakhweya@usaid.gov",
  "Name": "Jacqueline Wakhweya",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dcI1uZuvQ8RwLSBjpYxO"
 },
 {
  "Email": "d.niazov@ndex-solutions.kg",
  "Name": "Daniyar Niyazov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dcXQ0BRiwQzia3h7HaGE"
 },
 {
  "Email": "jlvagcaoili@avaslaw.com",
  "Name": "Jose Luis V. Agcaoili",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dciKSqqXf5DFNnSYmRbm"
 },
 {
  "Email": "david@tadmor-levy.com",
  "Name": "David Tadmor",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ddjqHwo9JueWuEVkxaMZ"
 },
 {
  "Email": "analuiza.jacoby@jacoby.adv.br",
  "Name": "Ms. Ana Luiza Jacoby Fernandes",
  "Document Name": "BRAZIL) JACOBY) BI 2020 BRA_bi_PPP_survey_en-JACOBY.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/deFQzGrByy05qBlDS8bZ"
 },
 {
  "Email": "sbarbaran@beccarvarela. com",
  "Name": "Mr. Santiago Barbarán",
  "Document Name": "BI 2020 ARG_bi_concession_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/deyTGs6Upomx8APercvu"
 },
 {
  "Email": "elena.giuffre@ashurst.com",
  "Name": "Ms Elena Giuffr�",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Ashurst.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dfkDuVaMTQyjP7ztde6W"
 },
 {
  "Email": "nova.fairbank@norfolkchamber.co.uk",
  "Name": "Nova Fairbank",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dhQ8B3rY00ZZmNa8n3E9"
 },
 {
  "Email": "advice@srilankalaw.com",
  "Name": "John Wilson",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/di8TVEFKY4k9X4Rvlw57"
 },
 {
  "Email": "armcci@arminco.com",
  "Name": "Andranik Alexanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/diI3tpuGFD2TMOBCPsGo"
 },
 {
  "Email": "catherine.mangahas@delrosariolaw.com",
  "Name": "Catherine E. Mangahas",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dk0Gna2OCqbI2kEUkUyI"
 },
 {
  "Email": "enquiries@cbi.org.uk",
  "Name": "George Mcfarlane",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dk8QskiEoYMeQ7Q74fc6"
 },
 {
  "Email": "hrojas@claro.cl",
  "Name": "Mr. Herman Rojas",
  "Document Name": "CHILE) CLARO N CIA) DOCS-#182036-v1-World_Bank_2020_PPP_Contracts_Questionnaire.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dlmWCAoMUVqcIsdlIPdX"
 },
 {
  "Email": "kpk@abmak.org",
  "Name": "Mr. Kenneth Katusabe",
  "Document Name": "UGANDA) ABMAK) BI 2020 UGA_bi_PPP_survey_en-2.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dloOu7jFx89JETrORvdK"
 },
 {
  "Email": "krispinana.shirima@kibuukalaw.com�",
  "Name": "Krispinana Shirima",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dmLBEoxDbzKeAfvU0O5c"
 },
 {
  "Email": "bandarap@upng.ac.pg",
  "Name": "Panditha Bandara",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dmo7YtOhfjDp7GCoPSFm"
 },
 {
  "Email": "munir.hassan@cms-cmck.com",
  "Name": "Munir Hassan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dmodv5Lf8WatZ7VkSgBi"
 },
 {
  "Email": "ccarvajal@lloredacamacho.com",
  "Name": "Mr Carlos Carvajal",
  "Document Name": "1340025.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dnTevpN5RZrolZWKRhLb"
 },
 {
  "Email": "gregg.cosimi@klgates.com",
  "Name": "Gregg Cosimi",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/do082B80xJzh4xrCw4E8"
 },
 {
  "Email": "ghiwetattorney@gmail.com",
  "Name": "Gebrehiwet Fessehaye",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/doAPvH3bp8jj9jFdAssH"
 },
 {
  "Email": "ashabahebwaian@gmail.com",
  "Name": "Ian Ashabahebwa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/doOFsziaP9BNt3FaY7Q7"
 },
 {
  "Email": "m.tindamanyire@ealc.co.tz",
  "Name": "Mr. Mark Tindamanyire",
  "Document Name": "Tanzania - PPP EALC_.docx",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dozvCkey12Iao7tpcEXQ"
 },
 {
  "Email": "jbodemer@polsonlaw.co.za",
  "Name": "Jeanette Bodemer",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dp8ktE0i00dSBUDW8ZtE"
 },
 {
  "Email": "j.ip@auckland.ac.nz",
  "Name": "John Ip",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dpDiH7ZvH4lwE77KNvM2"
 },
 {
  "Email": "president@fccisl.lk",
  "Name": "Ruwan Edirisinghe",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dpbEt0lzUesff2JhrjDj"
 },
 {
  "Email": "passanan.s@tilleke.com",
  "Name": "Passanan Suwannoi",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dr8caonemVm4IWAhXeEj"
 },
 {
  "Email": "info@oetp.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dsOKTsur6Zdv4Kt8E55I"
 },
 {
  "Email": "hnourzad@ut.ac.ir",
  "Name": "Hossein Nourzad",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dsV8aPMBFrqRT5qYZt6d"
 },
 {
  "Email": "marsmith@deloitte.kz",
  "Name": "Mark Smith",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dsV96Jp4wj69M7KGqYaG"
 },
 {
  "Email": "georgy.kalashnikov@hoganlovells.com",
  "Name": "Georgy Kalashnikov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dsWl71fay7B1AaLCwUAZ"
 },
 {
  "Email": "pfletcher@milbank.com",
  "Name": "Phillip Fletcher",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dstOd1epS11yJQWcpcWr"
 },
 {
  "Email": "ilustosa@ulhoacanto.com.br",
  "Name": "Ms. Isabel Lustosa",
  "Document Name": "Concession Consolidado 10.07.2019 FINAL.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/du1fJUXH2wQEbwpbV96l"
 },
 {
  "Email": "steven.edwards@slaughterandmay.com",
  "Name": "Steven Edwards",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/du2XEf2STAtjb6ogK9gx"
 },
 {
  "Email": "dli@whitecase.com",
  "Name": "Mr. David Li",
  "Document Name": "BI 2020 CHN_bi_PPP_survey_en (David Li 201909).docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/duBHyCTVuNo8MoetVG9j"
 },
 {
  "Email": "tesfubery@yahoo.com",
  "Name": "Tesfaye Berhe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/duZJMjh0yDWMy9L4KAJF"
 },
 {
  "Email": "roxana.stoica@ionescumiron.com",
  "Name": "Ms. Roxana Stoica",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_Roxana Stoica.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dv2R9d07VrchvWBM8ZJT"
 },
 {
  "Email": "ppp@jefatura.gob.ar",
  "Name": "Mr Ignacio Machado",
  "Document Name": "Argentina PPP Benchmarking Infrastructure BM 200819 v2.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dv8xingRfu1c1EkuyvJl"
 },
 {
  "Email": "o.coku@optima-al.com",
  "Name": "Mr. Olsi �oku",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en_Optima.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dvuoVUXJERjoZvv7bD77"
 },
 {
  "Email": "vlad.anghel@nndkp.ro",
  "Name": "Mr. Vlad Anghel",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en (ID 347900)_Nestor.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dweHF9vgn8kwbemZGZZk"
 },
 {
  "Email": "co.edna@gmail.com",
  "Name": "Edna Estifania A. Co",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dx9gziSDFNeEscZyzsFl"
 },
 {
  "Email": "shajjan@shajjanlaw.com",
  "Name": "Sayed Mohammed Saqeen Shajjan",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/dz3WOecaDw4rQ22gJVYs"
 },
 {
  "Email": "izak@barnardinc.co.za",
  "Name": "Izak Viljoen",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e3x1dkCdy4gnTFLLTJGu"
 },
 {
  "Email": "anna.adams@mc.co.nz",
  "Name": "Anna Adams",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e43cjkrGBSw9Maru88kX"
 },
 {
  "Email": "mao.villeda@gufalaw.com",
  "Name": "Mauricio Villeda Jr.",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e4ZByIYxQcOJZqUBOMA5"
 },
 {
  "Email": "JDR@FLYCIA.CL",
  "Name": "MR 1. HERNAN FLEISCHMANN.2. JUAN IGNACIO LEON.3.PAULO ROMAN.4. JUAN DIEGO RABAT",
  "Document Name": "BI 2020 CHL_bi_PPP_survey_JDRen.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e5iGamC67ZlNF8qqHbmH"
 },
 {
  "Email": "rugile@transparency.lt",
  "Name": "Rugile Trumpyte",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e5xTINSYcWggR84kduUb"
 },
 {
  "Email": "jpolson@polsonlaw.co.za",
  "Name": "Jean Graeme Polson",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e77fYTwCAW7LuhFRSmAf"
 },
 {
  "Email": "HansGeorg.Neumeier@bblaw.com",
  "Name": "Hans Georg Neumeier",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e7RNnWvN1Dv77kbOOC7x"
 },
 {
  "Email": "claire.barclay@pinsentmasons.com",
  "Name": "Ms Claire Barclay",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_Pinsent Masons Africa.docx",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e7itLM1b75C0P2KpVClw"
 },
 {
  "Email": "jolson-welsh@mayerbrown.com",
  "Name": "Jonathan Olson-Welsh",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e8OwWyrfshH2kRP7MTiO"
 },
 {
  "Email": "karl.haavasalu@varul.com",
  "Name": "Karl Haavasalu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e8oj4UeJrxmKz3mLaIo8"
 },
 {
  "Email": "omelara@melarayasociados.com",
  "Name": "Oscar Armando Melara Facuss�",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/e9mEZ933Gry8NvFPsmgf"
 },
 {
  "Email": "shinya.fujiwara@davispolk.com",
  "Name": "Shinya Fujiwara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eAhUwjztR7RocYQEvax3"
 },
 {
  "Email": "hvanderlaat@roblesoreamuno.com",
  "Name": "Hans Van Der Laat",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eCQvjJG0nQhAvP4qdCzh"
 },
 {
  "Email": "rachel.chiah@skrine.com",
  "Name": "Ms Rachel Chiah",
  "Document Name": "MALAYSIA) SKRINE) BI 2020 MYS_bi_PPP_survey_en (Skrine 19 July 2019).docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eCU0tu0cIr6slE0asbab"
 },
 {
  "Email": "goga@armirac.hr",
  "Name": "Gordana Simunovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eCajiypGvlojFGMouhwR"
 },
 {
  "Email": "lalakkas@velaw.com",
  "Name": "Looaye M. Al-Akkas",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eCbHuXeytqh0hZRiZmkm"
 },
 {
  "Email": "shemoses@yahoo.co.uk",
  "Name": "Shears-Moses",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eClU9tV4vqTdpikX8euU"
 },
 {
  "Email": "lrosab@bufeterosa.com",
  "Name": "Leonidas Rosa Bautista",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eD3P5LNWzP582UV49zsV"
 },
 {
  "Email": "lawyers@chamberscolombo.com",
  "Name": "Kusal Subasinghe",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eEY412Yyrx6CdX7hnVy7"
 },
 {
  "Email": "tomislav.orehovec@iop.hr",
  "Name": "Tomislav Orehovec",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eEoTVaZbN9b3IJdyefnq"
 },
 {
  "Email": "hasmik.avetisyan@mek.am",
  "Name": "Hasmik Avetisyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eHaAqbMcQrTjQRewfgVM"
 },
 {
  "Email": "pgachet@ferrere.com",
  "Name": "Dr. Paola Gachet",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en (004).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eHzkIplGXrkdxQOkt7r1"
 },
 {
  "Email": "info@jec.qa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eHzvMm429nhvrehah9nT"
 },
 {
  "Email": "info@clsynergy.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eI6uQJtQTVA1Pi65hEpF"
 },
 {
  "Email": "cristi.porojanu@rtprallenpvery.com",
  "Name": "Mr Cristi Porojanu",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_Ianita Tui.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eIlRbDltZjOjUC5GugnQ"
 },
 {
  "Email": "mcrigger@vtti.vt.edu",
  "Name": "Michelle Crigger",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eJU0CtsFZZz6ldJacjOe"
 },
 {
  "Email": "brad@ca.ey.com",
  "Name": "Brad Watson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eK9XZiuXi1EoVIyYX52W"
 },
 {
  "Email": "MS@MSLF.COM.SA",
  "Name": "Mohammed Naser Alshareef",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eKkMIZTwctlRc3eibM0r"
 },
 {
  "Email": "franciscobustamante@bustamante.com.ec",
  "Name": "Mr. Francisco Bustamante",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en.1.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eMWp1v4IvIWAQ8JFZjXE"
 },
 {
  "Email": "reuben.cronje@pinsentmasons.com",
  "Name": "Mr Reuben Cronj�",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_Pinsent Masons Africa.docx",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eMbEoBLr6YPmiiw30zHq"
 },
 {
  "Email": "ogiwaray@gtlaw.com",
  "Name": "Yuji Ogiwara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eMsSh5eGbfOXUINzwYZS"
 },
 {
  "Email": "vera.lukic@tasic.com",
  "Name": "Ms Vera Lukic",
  "Document Name": "BI 2020 SRB_bi_PPP_survey_en_Tasic & Partners.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eNuNaczd8Yb3E7BbLljR"
 },
 {
  "Email": "charana.kanankegamage@fjgdesaram.com",
  "Name": "Charana Kanankegamage",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eNznU53xSGIz5UT00Qhy"
 },
 {
  "Email": "draytis@omm.com",
  "Name": "Denise Raytis",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eOUHanqfeifPQQ4ATRyj"
 },
 {
  "Email": "Grant.Hodges@nz.ey.com",
  "Name": "Mr Grant Hodges",
  "Document Name": "EY BI 2020 NZL_bi_PPP_survey_en.asd.docx",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eOjmUVHh7Sq8WrG6SVbj"
 },
 {
  "Email": "hmiyakawa@jonesday.com",
  "Name": "Hiromitsu Miyakaya",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eOnXdJ6OfHo6qEXD3unn"
 },
 {
  "Email": "ana.jarosova@rprg.cz",
  "Name": "Jana Jaro�ov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eRVhfoZOigCVoWWEA0uY"
 },
 {
  "Email": "info@pravnifakultet.rs",
  "Name": "Dr. Zlatko Stefanovi?",
  "Document Name": "BI 2020  SRB_bi_PPP_survey_en_University of Belgrad.docx",
  "Country": "SRB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eRjV0xPksnBCWI5iOIky"
 },
 {
  "Email": "robert.weekes@squirepb.com",
  "Name": "Robert Weekes",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eSj8ZDbRpivFsx8R1XxJ"
 },
 {
  "Email": "info@dowuonalaw.com",
  "Name": "Nanaama Botchway-Dowuona",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eT8DzvwFHuQzil40RGQY"
 },
 {
  "Email": "phillip.lee@dlapiper.com",
  "Name": "Philip Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eUcAKOPV6fjvYSoEG2T0"
 },
 {
  "Email": "christian.mueller@wilmerhale.com",
  "Name": "Christian M�ller",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eUyVJxnWqp8PaMYHSzSw"
 },
 {
  "Email": "edwin@vdb-loi.com",
  "Name": "Mr. Edwin Vanderbruggen",
  "Document Name": "VIETNAM) VDB-LOI) BI 2020 VNM_bi_PPP_survey_en (002).docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eV1ORygCKVqHLSW2rw6f"
 },
 {
  "Email": "marie-france.beland@gowlings.com",
  "Name": "Marie-France Beland",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eWH2NlNhcFMCWur64Qwi"
 },
 {
  "Email": "ave-liis.saluveer@glimstedt.ee",
  "Name": "Ave Liis",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eWiepQG6V7GwIVEqpaTT"
 },
 {
  "Email": "ehsan@educatedlawyers.com",
  "Name": "Ehsan Hosseinzadeh",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eWk4nn7qUsG7xrgemMkI"
 },
 {
  "Email": "kalle.liiv@tlu.ee",
  "Name": "Kalle Liiv",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eYCka4naZlz5jruKi9U7"
 },
 {
  "Email": "Tatiana.Muratova@nortonrosefulbright.com",
  "Name": "Tatiana Muratova",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eYNDgJTxH2lh8os4EJOi"
 },
 {
  "Email": "info@plemconstruction.com",
  "Name": "Flemings Kapunda",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eYnbLzHxrrwtCL78f9nH"
 },
 {
  "Email": "mary.martinez@usap.edu",
  "Name": "Mary Ela Mart�nez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eaHLc7hblJFoh91op6hD"
 },
 {
  "Email": "lgoodwin@nixonpeabody.com",
  "Name": "Lee M. Goodwin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eacO97xCQS0DLzXjgKWQ"
 },
 {
  "Email": "adam.haque@dlapiper.com",
  "Name": "Adam Haque",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eb7vyQEWwli7IkCSIBac"
 },
 {
  "Email": "gareth.price@allenovery.com",
  "Name": "Gareth Price",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ebKUU3vJpzPy0VdFlfOE"
 },
 {
  "Email": "thasimoto@toledomarchetti.com.br",
  "Name": "title Taisa Hasimoto",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ebLMpWO0ttjnKqZX3xAJ"
 },
 {
  "Email": "info@astlex.com",
  "Name": "Seylbek Kaliyev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ebnuuXC8Ki8RB3whuDtC"
 },
 {
  "Email": "haklegal@qatar.net.qa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ecQhKEKMGhDQSTwHyvXN"
 },
 {
  "Email": "darren.craig@cms-cmck.com",
  "Name": "Darren Craig",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ecjkby0420yTYkoNXBbs"
 },
 {
  "Email": "hiroaki.nakano@amt-law.com",
  "Name": "Mr. Hiroaki Nakano",
  "Document Name": "BI 2020 JPN_bi_TPI_survey_en_AMT20190906.docx",
  "Country": "JPN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ecu7eyttnCxGRehgjJS0"
 },
 {
  "Email": "c.rodriguez@sdhhlaw.com",
  "Name": "Mr. Cesar Rodr�guez",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en (002).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/edURDa7mt5FrNPXEUcks"
 },
 {
  "Email": "Maria.Orlyk@cms-rrh.com",
  "Name": "Ms Maria Orlyk",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en_CMS Reich-Rohrwig Hainz.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ede5dqrZTfBMYfJS6ydr"
 },
 {
  "Email": "cumana@bu.com.co",
  "Name": "Mr. Carlos Umaña",
  "Document Name": "BI 2020 COL_bi_TPI_survey_en FINAL BU.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/edx5CbzCfWHT0FcTIw9n"
 },
 {
  "Email": "info@alg.legal",
  "Name": "Juan Carlos Pizarro Corrales",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eeBJsZovLH9EEmyWfabt"
 },
 {
  "Email": "rdanielsen@deloitte.dk",
  "Name": "Rikke Beckmann Danielsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eeirxnWfmsNQdYZ4k9Cq"
 },
 {
  "Email": "info.jacobsdcsa@jacobs.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/efEueYEPUp4N3ocNmmWY"
 },
 {
  "Email": "nurzhan.bostonova@centil.law",
  "Name": "Ms. Nurzhan Bostonova",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_CentilLaw.doc",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/efMjrd2eyGhRN9ym3BlR"
 },
 {
  "Email": "salamzuhair@eversheds-sutherland.com",
  "Name": "Salam Zuhair",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/efPmM72JERvJUD1Sex9H"
 },
 {
  "Email": "pascalis@mahowainc.co.za",
  "Name": "Pascalis Ndivhuho Moila",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ehtusJxEQpR42tekv1Z6"
 },
 {
  "Email": "hewco_mills@yahoo.com",
  "Name": "George Addison Heward-Mills",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eiEtfmVWa7ouBWKfN8jW"
 },
 {
  "Email": "mia.mijatovic@ostermann.hr",
  "Name": "Mia Mijatovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eitLx455v7cgiVVs0iI2"
 },
 {
  "Email": "heidi.luna@garciabodan.com",
  "Name": "Heidi Dayana Luna De Paguaga",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ek5YIGIdYwiZJQQrANAb"
 },
 {
  "Email": "chapagainaresh@gmail.com",
  "Name": "Mr Naresh Kumar Chapagain",
  "Document Name": "BI 2020 NPL_bi_PPP_survey_en.doc",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ekKne7ESsXEvnD0ygUiv"
 },
 {
  "Email": "nmehta@stblaw.com",
  "Name": "Nirav Metha",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/elDbJpTwC7qJbEtOLy70"
 },
 {
  "Email": "mnabil@deltagroup.com.eg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/elu9bqQv79YWR0KJjTL7"
 },
 {
  "Email": "jcmata@matapitti.com��",
  "Name": "Juan Carlos Mata",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/en7lZWdeS2vGpmIhaOuf"
 },
 {
  "Email": "mccombe@brookfields.co.nz",
  "Name": "Ian Mccombe",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/enFYcayqXb3btfCpc0dL"
 },
 {
  "Email": "johnsul2@ozemail.com.au",
  "Name": "John Sullivan Qc",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/enIuFXt4DzWhtXUsHNex"
 },
 {
  "Email": "info@snkentp.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/enZHNDFIgzGsgjeuHt39"
 },
 {
  "Email": "s.panjikidze@gvinadzeandpartners.ge",
  "Name": "Sophie Panjikidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eokE67T1r1j4bmEeKTLE"
 },
 {
  "Email": "ilan.dunsky@dentons.com",
  "Name": "Ilan Dunsky",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/epANfOMmecPoQb7rw2g5"
 },
 {
  "Email": "ian.clarke@dentons.com",
  "Name": "Ian Clarke",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/epvh4usvi02Qr88iNqWu"
 },
 {
  "Email": "kpicota@globcorp.net",
  "Name": "Karina Picota",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eqNogijzj7bvwNJmvjM0"
 },
 {
  "Email": "service@lawhousevanuatu.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eqdrVrYlpiWY7ZpxjWbh"
 },
 {
  "Email": "fepaz@deloitte.com",
  "Name": "Mr Federico Paz",
  "Document Name": "BI 2020 SLV_bi_PPP_survey_en (deloitte CF).docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/etAHrrfW9LN1vHRNpecj"
 },
 {
  "Email": "david.clinch@hsf.com",
  "Name": "David Clinch",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/etdGeDA9HQJ8HfLO2C2x"
 },
 {
  "Email": "Fernando.Gomes@cesconbarrieu.com.br",
  "Name": "Fernando Gomes",
  "Document Name": "BRAZIL) CESCON BARRIEU) BI 2020 BRA_bi_concession_survey_en pos FMG (inputs RAL 1.1. e 5.1).docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/etpR3nA6jmosyBCrwYDB"
 },
 {
  "Email": "luluakij@upng.ac.pg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eu0Yv3LlKpDK6qv0Rplf"
 },
 {
  "Email": "elena.giuffre@ashurst.com",
  "Name": "Mrs Elena Giuffrè",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_Ashurst.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/euvAgwWp6eAYBir2Sgdl"
 },
 {
  "Email": "simon.rickit@meredithconnell.co.nz",
  "Name": "Simon Rickit",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ev6hLtaxjC6ucHHqPzBg"
 },
 {
  "Email": "andrew.tobin@bevanbrittan.com",
  "Name": "Andrew Tobin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/exBRmsu8HdJoUU1BJ0JW"
 },
 {
  "Email": "mikk.pold@triniti.ee",
  "Name": "Mikk P�ld",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eyhBaDYXqJWAMz8fwJsL"
 },
 {
  "Email": "info@altracapital.com",
  "Name": "John Davie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/eyp9NoQ6IHrW9jaWyEiU"
 },
 {
  "Email": "comunicacionespanama@aes.com",
  "Name": "Miguel Bolinaga",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ezT9dSiL9axV2WJGHKGd"
 },
 {
  "Email": "dspielberg@orrick.com",
  "Name": "David Spielberg",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ezZUKSBJRxcU8DW1jkwL"
 },
 {
  "Email": "Sumedha.Wijayasinghe@qpmc.qa",
  "Name": "Sumedha Wijayasinghe",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f0bnQoRaci2jlvdcOchf"
 },
 {
  "Email": "info@kayan.sd",
  "Name": "Eng Mohamed ZeinElabden",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_AIH.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f2sLip7vGPTIHB71d22l"
 },
 {
  "Email": "henric.immink@kellerhals-carrard.ch",
  "Name": "Henrick Immik",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f3KBVHV7OZsCynVSdnH1"
 },
 {
  "Email": "dgabunia@gap.ge",
  "Name": "Dimitri Gabunia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f3TTpbiVwWKWuXHMED6x"
 },
 {
  "Email": "Acevedo@berettagodoy.com",
  "Name": "Mr. Fernando Acevedo",
  "Document Name": "BI 2020 ARG_bi_concession_survey FF(FG).docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f5jf60DE5yddrLgHRRc3"
 },
 {
  "Email": "lecheverria@fragomen.com",
  "Name": "Leonor Echeverria",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f5ldTBcqy2PUoqokK1f4"
 },
 {
  "Email": "bilal.shaukat@riaabg.com",
  "Name": "Mr. Bilal Shaukat",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_RBG_Shaukat.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f5wWlcpDJOLuTTQsQAI5"
 },
 {
  "Email": "vlavianosg@bennettjones.com",
  "Name": "George M. Vlavianos",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f7q4CmAiNTnS3nxKCRAs"
 },
 {
  "Email": "ialbayaa@kpmg.com",
  "Name": "Islam Al Bayaa",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f7uPUDgUUSpTZrdiSyXl"
 },
 {
  "Email": "KSibanda@idbz.co.zw",
  "Name": "Dr. Sibanda Khutula",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en IDBZ.doc.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f8IZ4MsQxiPNaWihliK4"
 },
 {
  "Email": "dsasias@guyer.com.uy",
  "Name": "Mr Diego Sas�as",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en final.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f8e6I9MAhE8UG0z8ImEy"
 },
 {
  "Email": "mehrteab@mehrteableul.com",
  "Name": "Mehrteab Leul",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f8rEoScIEm9yLKlBOTaS"
 },
 {
  "Email": "justin.yip@stamfordlaw.com.sg",
  "Name": "Justin Yip",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/f9sImdB8s5YVvBBBCNar"
 },
 {
  "Email": "Krmanj.Omer@alaflaw.com",
  "Name": "Krmanj Omer",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fCfScoBy4omBjxsFzHhT"
 },
 {
  "Email": "albert.boateng@pfan.net",
  "Name": "Albert Boateng",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fDR9eYlnOhVeMWxn0ogF"
 },
 {
  "Email": "Dirgantara.Nugroho@makarim.com",
  "Name": "Mr Dirgantara Adi Nugroho",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Makarim_v2.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fDfIuZfXbEp75f86cwvK"
 },
 {
  "Email": "remlaw@africaonline.com.gh",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fEZ9ozFqafcov4rKbobS"
 },
 {
  "Email": "Adrian.Balanuta@bpv-grigorescu.com",
  "Name": "Attorney at Law Adrian Balanuta",
  "Document Name": "ROM _bi_TPI_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fFR8BnrdDsCRT918jT7r"
 },
 {
  "Email": "jee-seon.lee@jws.com.au",
  "Name": "Jee-Seon Lee",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fFZSgIG2JfWpxBccxjdW"
 },
 {
  "Email": "sppasher@nus.edu.sg",
  "Name": "Mukul Asher",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fG486FLj00tlgDGGHXX5"
 },
 {
  "Email": "dgovender@cov.com",
  "Name": "Deon Govender",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fGwIEHMveCPtq59QZ14d"
 },
 {
  "Email": "omrania@omrania.com.sa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fGyiQ7Pqpscc3RkoIHO8"
 },
 {
  "Email": "lana.deljkic@karanovic-nikolic.com",
  "Name": "Lana Deljkic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fHHceyplgNEAYE0CYc96"
 },
 {
  "Email": "manage@krsu.edu.kg",
  "Name": "Ludmila Hasanova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fHIpHYusgGOsCX7uWf0k"
 },
 {
  "Email": "andrey_porfiriev@epam.ru",
  "Name": "Andrey Porfiriev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fHcYxW9u0HuNdGdxbCW0"
 },
 {
  "Email": "kathleen.griffiths@rmit.edu.au",
  "Name": "Kathy Griffiths",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fHeadqpFzgiPQzOyIRqB"
 },
 {
  "Email": "Jaco.Belder@nautadutilh.com",
  "Name": "Mr. Jaco Belder",
  "Document Name": "PPP Survey_Netherlands_World Bank Group.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fHpzmWndDU0zqt7zThtg"
 },
 {
  "Email": "infrastructurecom@snclavalin.com",
  "Name": "Hartland Peterson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fI546WPajfIDygcYuInl"
 },
 {
  "Email": "info@aljoufilaw.com",
  "Name": "Yousef Al-Joufi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fIxKfzzOP4IAq9FKAice"
 },
 {
  "Email": "crodas@carrizales.pe",
  "Name": "Cindy Rodas Correa",
  "Document Name": "2019-Rev-DOC1-BI 2020 PER_bi_PPP_survey_BID.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fJ7bYpnKETFMxOIff9d4"
 },
 {
  "Email": "yuri.ganga@cfa-lawfirm.com",
  "Name": "Dr Yuri lGanga",
  "Document Name": "BI_2020_AGO_bi_PPP_survey_CFA.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fKMcKVI5zIiZmQf068oy"
 },
 {
  "Email": "yutaka.sakai@aplaw.jp",
  "Name": "Yutaka Sakai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fLh7wAeweGjuxs5hX6NI"
 },
 {
  "Email": "t.shaw@nabarro.com",
  "Name": "Tim Shaw",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fLw7qtuHKbAdWvCsOCe6"
 },
 {
  "Email": "N.Agmon@shibolet.com",
  "Name": "Nati Agmon",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fMAAPkDSOFtIw72cW3se"
 },
 {
  "Email": "fahenriques@hrlegalcircle.com",
  "Name": "Ms. Fabrícia de Almeida Henriques",
  "Document Name": "BI 2020 MOZ_bi_TPI_survey_en.docx",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fME3lMUvKHflpVCIDCnX"
 },
 {
  "Email": "juliet.reingold@simmons-simmons.com",
  "Name": "Juliet Reingold",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fN4vIPYwnYljslemFNxG"
 },
 {
  "Email": "bpaisley@reedsmith.com",
  "Name": "Belinda Paisley",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fN9sYaSC2omDOAPTrUes"
 },
 {
  "Email": "kirill.nikitin@ru.pwc.ru",
  "Name": "Kirill Nikitin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fNuUTA7BViVV7zPYHIWT"
 },
 {
  "Email": "kelly.wheeler@cdcltd.ca",
  "Name": "Kelly Wheeler",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fOHM5YrY93R8KiPValJm"
 },
 {
  "Email": "tippitt@upng.ac.pg",
  "Name": "Tapora Isorua",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fOPfvi8l5MKDXNefU21l"
 },
 {
  "Email": "c.rwechungura@crbafricalegal.com",
  "Name": "Charles R. B. Rwechungura",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fQQXpT3tBYPX7txg16oC"
 },
 {
  "Email": "ifargan@erm-law.com",
  "Name": "Eran Ifargan",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fQTTjkAEXfdUTBj9yzSi"
 },
 {
  "Email": "riabenko@vkp.ua",
  "Name": "Mr Roman Riabenko",
  "Document Name": "BI 2020 UKR_bi_TPI_survey2_en_Vasil Kisil & Partners.doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fR8lqwpvhPbHA1IbVPpD"
 },
 {
  "Email": "gwillcocks@mccarthy.ca",
  "Name": "Gordon F. Willcocks",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fREetS0pEEYir2kcmqj8"
 },
 {
  "Email": "an@abmak.org",
  "Name": "Mr. Aisha Naiga",
  "Document Name": "UGANDA) ABMAK) BI 2020 UGA_bi_PPP_survey_en-2.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fRL4cBvmZo9moPwnZA6H"
 },
 {
  "Email": "walid.halabi@saudibauer.com",
  "Name": "Walid Halabi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fRo1BpwYxhOcuZuGifb3"
 },
 {
  "Email": "charles.marais@hoganlovells.com",
  "Name": "Charles Marais",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fStskoovwzNP6j0MTwyo"
 },
 {
  "Email": "astein@stoccheforbes.com.br",
  "Name": "Ms. Ana Stein",
  "Document Name": "WB PPP.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fTD85ZKXVnlwIiNvHgFT"
 },
 {
  "Email": "info@oppenheimer-partners.com",
  "Name": "Scott Brodsky",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fTNUvZBhS1vCafGxjRWP"
 },
 {
  "Email": "absa0c@bangor.ac.uk",
  "Name": "Gwilym Owen",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fTkE2GxsavJ0v5YbJlai"
 },
 {
  "Email": "yemerun@yencomad.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fUCZYYyh1sQsFIjR8fhk"
 },
 {
  "Email": "crecio@carrizales.pe?????",
  "Name": "Mr.. Carlos Carrizales Recio",
  "Document Name": "2019-Rev-DOC1-BI 2020 PER_bi_PPP_survey_BID.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fUxgKERtb2t0gwJ9vhPj"
 },
 {
  "Email": "lynn.solomons@interfront.co.za",
  "Name": "Lynn Solomons",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fUy5b5TK24kmDzH46eNV"
 },
 {
  "Email": "hazim@almadanilaw.com",
  "Name": "Hazem Al Madani",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fXXG9tUoqndWhkAvmvI2"
 },
 {
  "Email": "communications@sportt-tt.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fXrSkng6LWYTVJtMWJsQ"
 },
 {
  "Email": "cbe@horten.dk",
  "Name": "Claus Bennetsen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fXw59HGyawuPMEhpkLbH"
 },
 {
  "Email": "ertunc@istanbul.edu.tr",
  "Name": "Mr. Ertun� Sirin",
  "Document Name": "182807 - 1 - BI 2020 TUR_bi_PPP_survey_en (ID 182807).doc",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fYYtgfcQ9hYPsxSeR6TI"
 },
 {
  "Email": "igonzalez@saraviamunoz.com",
  "Name": "Iieana Gonzalez Bolanos",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fYixigycaWaEM2Vcwr2E"
 },
 {
  "Email": "dpeel@whitecase.com",
  "Name": "Doug Peel",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fYmLbwKn5psMU5jPOwaq"
 },
 {
  "Email": "john.boehm@nortonrosefulbright.com",
  "Name": "John C. Boehm, Jr.",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fZQ9KXcAJlgNgnNysmVk"
 },
 {
  "Email": "tmckibbon@aecon.com",
  "Name": "Terrance L. Mckibbon",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fZmTPZfjJ2T5wnbPwnWi"
 },
 {
  "Email": "andre@lexincorp.com",
  "Name": "Arnoldo Andre Tinoco",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fZu42GSETO6vFmO3T5oE"
 },
 {
  "Email": "a9213042122@gmail.com",
  "Name": "Natalia Andrianova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/faOR62467korx78RLTVb"
 },
 {
  "Email": "dato@ppi-ebrd-uncitral.com",
  "Name": "David Marghania",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/faoA3x3yUHJElgwLcrCk"
 },
 {
  "Email": "lakshana@sudathpereraassociates.com",
  "Name": "Lakshana Perera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fbMKVIS3pRL5X6n1Bwkh"
 },
 {
  "Email": "sagarwal@winston.com",
  "Name": "Shreyansi Agarwal",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fbckRxN1Vaj7zxmyN39x"
 },
 {
  "Email": "sawawdeh@deloitte.com",
  "Name": "Mr. Salam Awawdeh",
  "Document Name": "BI 2020 SAU_bi_PPP_survey_en_GLCSP.doc",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fd8HAIsUHLnpB4h5PcpB"
 },
 {
  "Email": "office@abylaw.com",
  "Name": "Yuri Pustovit",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fdfXsdQP31oVgvrMrZrG"
 },
 {
  "Email": "msm@webberslaw.com",
  "Name": "Morne Maree",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fdgxNk3jNNqUuHxbJ9dr"
 },
 {
  "Email": "raaed_ahmed@yahoo.com",
  "Name": "Raaed Ahmed Hassen Al-Nuaimay",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fdw2eGXk0U7sLiWOy3l0"
 },
 {
  "Email": "info@ghanaukconstruct.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/febFpQzmvWSRsxaFeNe4"
 },
 {
  "Email": "ghassan@rassimlawfirm.net",
  "Name": "G. Hassan",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ff2d4r3E4kw3c1LeMDCY"
 },
 {
  "Email": "t.kakoyan@lawyer.am",
  "Name": "Taron Kakoyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ffXb84ZRulu3JwprLsYm"
 },
 {
  "Email": "sgarciarojas@cnbv.gob.mx",
  "Name": "title García Rojas Castillo Sandro",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en - SGRC.doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ffwqr8JHrGOVJPupZJnt"
 },
 {
  "Email": "hykim2011@kdi.re.kr",
  "Name": "Specialist Hyeyoung KIM",
  "Document Name": "KOREA) KDI) BI 2020 KOR_bi_TPI_survey_en (HYK) 0821.docx",
  "Country": "KOR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fhYbn2zawqZ0ks84J6gQ"
 },
 {
  "Email": "poghosyang@bso.am",
  "Name": "Gevorg Poghosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fhZoHpYGCMHZHT8jHVnn"
 },
 {
  "Email": "BMcIsaac@blg.com",
  "Name": "Barbara Mcisaac",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fhhEms45n0igeuPGl4dy"
 },
 {
  "Email": "daniil@lauspartners.ee",
  "Name": "Daniil Savitski",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fhv8cMoCqdg8ByV7vhKp"
 },
 {
  "Email": "anthony.raven@pillsburylaw.com",
  "Name": "Anthony Raven",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fhvM3PvuXIYvSis3fecj"
 },
 {
  "Email": "mark.crosbie@minterellison.co.nz",
  "Name": "Mark Crosbie",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fiHS7YjybffCHVHTvaJA"
 },
 {
  "Email": "legal@hoshanlaw.com",
  "Name": "Mohamed H. Al Hoshan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fildRp7tRCGRM4sRglJq"
 },
 {
  "Email": "laura.perez@ariaslaw.com",
  "Name": "Ms. Laura lPerez",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en-CCG  Final.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/flJBWJK7xpKSTbhaFzwd"
 },
 {
  "Email": "vhilldrup@HuntonAK.com",
  "Name": "Vincent Hilldrup",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/flfdwDIYBV1NsyewG3su"
 },
 {
  "Email": "fabricio.longhin@cliffordchance.com",
  "Name": "Fabricio Longhin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fmCBUTUh144o2r5WSsvo"
 },
 {
  "Email": "jlpacheco@abpcr.com",
  "Name": "Jose Luis Pacheco",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fmKGtyw4K0niPw9UKa9Q"
 },
 {
  "Email": "joao.tilly@utap.pt",
  "Name": "Mr. Jo�o Tilly",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en_UTAP_final.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fmlLxEHDaAK7FRS6qvym"
 },
 {
  "Email": "cyrus.mehta@cms-cmno.com",
  "Name": "Cyrus Mehta",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fnYbteNIx9EgONSNgz09"
 },
 {
  "Email": "kal@prcp.com.pe",
  "Name": "Ms. Karen Angeles",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_Payet - 4837-1645-6348 v. 3.doc",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fnq5yYq081x9iiImY8Q0"
 },
 {
  "Email": "dpetroskey@dallaschamber.org",
  "Name": "Dale Petroskey",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/foCdHM4ff3B2YDIL0O6q"
 },
 {
  "Email": "info@globalpsa.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fq2OiaNlIni7nd83g3VS"
 },
 {
  "Email": "noel@kateeraandkagumire.com",
  "Name": "Noel Muhangi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fqHmhpbVw1c5bsyMDGeS"
 },
 {
  "Email": "muchiri.g@dalyinamdar.co.ke",
  "Name": "Mr. George Muchiri",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_en_DALY & INAMDAR.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fqt4k1woCS65L3oue6qa"
 },
 {
  "Email": "richard@thinkhub.co.nz",
  "Name": "Richard Smith",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/frqGnHBZKhCV58neEDVx"
 },
 {
  "Email": "don.stokes@freshfields.com",
  "Name": "Don Stokes",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fruFUrWRc9fScSrZPPDA"
 },
 {
  "Email": "christoforster@hotmail.com",
  "Name": "Christo Forster",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ftnLgZs35vfUevXXRzMy"
 },
 {
  "Email": "rhona.harper@shepwedd.co.uk",
  "Name": "Rhona Harper",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fvOc9dmxdTJJNtqC7fzw"
 },
 {
  "Email": "Hossam.mashhour@qpmc.qa",
  "Name": "Hossam Mashhour",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fw5ANpizeAX5mouwMrH4"
 },
 {
  "Email": "dvinog@essex.ac.uk",
  "Name": "Dmitri Vinogradov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fwl3XgSVDaHYtthOPSPI"
 },
 {
  "Email": "cmedina@central-law.com",
  "Name": "Ms Claribel Medina",
  "Document Name": "BI 2020 HND_bi_PPP_survey_en.Central.docx",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fxtUsPBRjtEDfjk4wSJT"
 },
 {
  "Email": "har@kammeradvokaten.dk",
  "Name": "Kristian Hartlev",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fy2rjr6gQeg3xPAqgpL5"
 },
 {
  "Email": "kane.patena@meredithconnell.co.nz",
  "Name": "Kane Patena",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fycQyWnWbNQX16UiUsey"
 },
 {
  "Email": "gmaharaj@ckrlaw.com",
  "Name": "Geeta Maharaj",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fzFQnpO7vjkEDYcbHpHV"
 },
 {
  "Email": "liisa.linna@hedman.ee",
  "Name": "Liisa Linna",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fzZDIW2t0NcgaSxFhVWb"
 },
 {
  "Email": "rui.santos@cralaw.com",
  "Name": "Rui Botica Santos",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_en_CRA Timor contribution.docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/fzsGo4TNbNhOebLYJQmb"
 },
 {
  "Email": "h.wilberg@auckland.ac.nz",
  "Name": "Hanna Wilberg",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g0DSwfQcK0xB93ZFl2Ua"
 },
 {
  "Email": "mshivek@fbclawyers.com",
  "Name": "Merav Shivek",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g14Sbwf6JBgiVfOyIupw"
 },
 {
  "Email": "s.james@ashfords.co.uk",
  "Name": "Stewart James",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g1TBaakBfdaaAnjqdRjo"
 },
 {
  "Email": "unity@kantorimmerman.co.zw",
  "Name": "Mr Unity Sakhe",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_KI.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g1bexVcQEiy8UrJ6qG6A"
 },
 {
  "Email": "mc@minc.co.za",
  "Name": "Mailula Chrispoland Mahowa",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g2j91OAok7v4bD10Yicr"
 },
 {
  "Email": "rodneyk@sol-law.com.sb",
  "Name": "Rodney Kingmele",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g2wGrMKVcoxmlJ41hQae"
 },
 {
  "Email": "didas4j@gmail.com",
  "Name": "Mr. Didas Kayiranga Mirrimo",
  "Document Name": "UGANDA) MINISTRY OF FINANCE) BI 2020 UGA_bi_PPP_survey_en - Didas Ug.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g3QXe51qxJIH1vr9I7M4"
 },
 {
  "Email": "Paul.Keres@glikmanalvin.ee",
  "Name": "Paul Keres",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g3zB9NbMtY69Ajau4aR6"
 },
 {
  "Email": "thse@nortonrosefulbright.com",
  "Name": "Mr. Thanthiti Saneewong Na Ayudthaya",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g4EaTTIs654vt99ZYh3c"
 },
 {
  "Email": "pghurtado@url.edu.gt",
  "Name": "Pablo Garcia Gerardo Hurtado",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g57C68WsTdOz1WVLzMfL"
 },
 {
  "Email": "e.arslanpay@cakmak.av.tr",
  "Name": "Ms Ezgi Arslanpay",
  "Document Name": "TURKEY) CAKMAK) EA- World Bank 2020 PPP Survey (E).DOCX",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g5ngK5RpQIpasHGIhVZV"
 },
 {
  "Email": "alicia.templeton@aon.ca",
  "Name": "Alicia Templeton",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g5q4dOZ2U7tKy0QuwDjo"
 },
 {
  "Email": "sabine.wieduwilt@dentons.com",
  "Name": "Sabine Wieduwilt",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g5rB15HGKB3TmWQsipE1"
 },
 {
  "Email": "info@kaynex-law.com",
  "Name": "Kota Kikuchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g7EZYZRRnGn7tdAlltRu"
 },
 {
  "Email": "kierap@marquelawyers.com.au",
  "Name": "Kiera Peacock",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g7PeK38CfhICOyjI2RjR"
 },
 {
  "Email": "dirk@rosenstocklegal.com",
  "Name": "Dirk Hanekom",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g91bbHfj0etmIIqtSjem"
 },
 {
  "Email": "shannon.itoyama@stblaw.com",
  "Name": "Shanon Itoyama",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/g9GBGvciTJu44ZY2ai6a"
 },
 {
  "Email": "msanchezm@rossellolaw.com",
  "Name": "Mr. . Miguel Sanchez Moreno Cisneros",
  "Document Name": "MSM BI 2020 PER_bi_PPP_survey_en.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gAUJbtEqMluHUWjQFlVP"
 },
 {
  "Email": "amoses@wow.net",
  "Name": "John Moses",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gB4C6LdH76w3iwNpw0Ov"
 },
 {
  "Email": "marcus.obrien@clydeco.com",
  "Name": "Marcus O'Brien",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gBETSz310PAAr3F87kZh"
 },
 {
  "Email": "anower.sadat@biffl.org.bd",
  "Name": "Mr. Sheikh Anower Sadat",
  "Document Name": "BANGLADESH) INFRASTRUCTURE FINANCE FUND) Filled-up BI 2020 BGD_bi_PPP_survey_en_Anower_BIFFL.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gBfFvcQaXwZCKwoubY4I"
 },
 {
  "Email": "attorneysafwanshorra@hotmail.com",
  "Name": "Safwani Mohammed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gCDSVsHrK6Iatnq9greu"
 },
 {
  "Email": "metw@nortonrosefulbright.com",
  "Name": "title first name last name",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gCpvyqVgEegLTRq9fSgN"
 },
 {
  "Email": "andrew.chitembo@zambia.co.zm",
  "Name": "Andrew Chitembo",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gDA9jiCr67FylOrLBIZ1"
 },
 {
  "Email": "charles.whiddington@fieldfisher.com",
  "Name": "Charles Whiddington",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gDJNNgQhE8Vuw8Rn2K5e"
 },
 {
  "Email": "sigurdjensen@deloitte.dk",
  "Name": "Sigurd Jensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gDJw4lAkIYfNnPZyb0N3"
 },
 {
  "Email": "rethompson@mercerthompson.com",
  "Name": "Chip Thompson",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gDNWAMcfeMecvJMKVNcS"
 },
 {
  "Email": "tamar.tatanashvili@transparency.ge",
  "Name": "Tamar Tatanashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gDSyTm3tzknmge7N9vS8"
 },
 {
  "Email": "kalle-kaspar.sepper@sirel.com",
  "Name": "Kalle Kasper",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gES10KKOX6x6uyMa117d"
 },
 {
  "Email": "ayotunde@sierratel.sl",
  "Name": "J.B Jenkins-Johnson",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gEVd7QeabnGaSztKqmyJ"
 },
 {
  "Email": "pgonzalez@esguerra.com",
  "Name": "Mr Juan Pablo González Mejía",
  "Document Name": "TPI.docx",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gFONJE9uqXPEPlrnipE9"
 },
 {
  "Email": "getu@mehrteableul.com",
  "Name": "Getu Shiferaw Shiferwe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gFgytlA7d6qNrToE12iy"
 },
 {
  "Email": "chris.bryant@blplaw.com",
  "Name": "Chris Bryant",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gG8qfBXdx0aObcPfTl3f"
 },
 {
  "Email": "christian.rosa@mazzuccoemello.com",
  "Name": "Mr. Christian Fernandes Gomes da Rosa",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en 07 11 2019 - M&M.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gGajbBrLLBTYOJh49IjH"
 },
 {
  "Email": "admin@iccthailand.or.th",
  "Name": "Kamesit Pathomsak",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gHPT7asqYLAwxiNWlBEK"
 },
 {
  "Email": "Bazukao@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gHxFt9LmXCrcdJKeGwM1"
 },
 {
  "Email": "h.alnaddaf@tamimi.com",
  "Name": "Hani Al Naddaf",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gI3zBw0mrrWhUgFTqfOI"
 },
 {
  "Email": "chss@udom.ac.tz",
  "Name": "Baraka Gesona",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gIzvJfFCM6Cq6tstYtI9"
 },
 {
  "Email": "Kim.Stouffer@bakermckenzie.com",
  "Name": "Kim Stouffer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gJgfpQKtIEjdEVtC3oaw"
 },
 {
  "Email": "jfr@legalmca.com",
  "Name": "Ms. Joana Ferreira Ribeiro",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en Angola_ MC&A.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gJpnezJwuJk7p1sivLdF"
 },
 {
  "Email": "smcreynolds@dwpv.com",
  "Name": "D. Shawn Mcreynolds",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gKqq2qidWh1Ppdg3Py7V"
 },
 {
  "Email": "gitahi.gachahi@ke.ey.com",
  "Name": "Gitahi Gachahi",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gKtVNDjoTwAolPC3FXUj"
 },
 {
  "Email": "hugo.coetzee@cms-cmck.com",
  "Name": "Hugo Coetzee",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gM4yVatgj6iitFCEoAxi"
 },
 {
  "Email": "infopanama@deloitte.com",
  "Name": "Rub�n Irigoyen",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gMSC0cZCHkvDeiDT3x5l"
 },
 {
  "Email": "carlos.ubico@ariaslaw.com",
  "Name": "Mr Carlos Ubico",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en-(final).docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gMahd9VbExWahZcF7HmD"
 },
 {
  "Email": "boadu@africaonline.com.gh",
  "Name": "Kofi Peasah-Boadu",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gOUdUXEOzbWK8PpOpnwz"
 },
 {
  "Email": "nicole.xanthopol@kensingtonswan.com",
  "Name": "Nicole Xanthopol",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gOgKGBPLjVoDJwN5rYNj"
 },
 {
  "Email": "jason.wozniak@aurecongroup.com",
  "Name": "Jason Wozniak",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gPVYWWIg8Q1jB255bNIT"
 },
 {
  "Email": "simon.black@allenovery.com",
  "Name": "Simon Black",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gQaD9JB7XAnT6KSCH9Oo"
 },
 {
  "Email": "office@arte-ip.kg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gQzJmLCfEuHlS8ZXz248"
 },
 {
  "Email": "temalaw@malawi.net",
  "Name": "Samuel Tembenu",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gSJfy0Wd6GAhuZCLtofh"
 },
 {
  "Email": "godfrey@lawfrontadvocates.co.tz",
  "Name": "Godfrey Paul",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gT61mnXC4CVdFHHMt6ER"
 },
 {
  "Email": "info@kpmg.com.gh",
  "Name": "Nii Amanor Dodoo",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gTVlIbn2FIE5HZT8iIUl"
 },
 {
  "Email": "dbfps.vergabestelle@deutschebahn.com",
  "Name": "Herrn Gerhard Dech",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gTtEOmMAag4E6DY242pS"
 },
 {
  "Email": "aroy@stikeman.com",
  "Name": "Andr� J. Roy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gUDHeWxcBlBPu0cHD7zg"
 },
 {
  "Email": "gamri@mccci.org",
  "Name": "Grace Amri",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gUjnfDmdyPG2xsfTtxPF"
 },
 {
  "Email": "Rshouldice@blg.com",
  "Name": "Robert R. Shouldice",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gUoZcvMLKKTSRd1aL8uv"
 },
 {
  "Email": "a.krishingee@polanc.com",
  "Name": "Ariana Krishingee",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gUt9LR9nWWqTPJUyFYI1"
 },
 {
  "Email": "yulia.klyukach@aaviklaw.ee",
  "Name": "Yulia Klyukach",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gVU5HopNfkya3pBolCyt"
 },
 {
  "Email": "pravina1@telekomsa.net",
  "Name": "Pravina Govender",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gW8u4WZGCc7ccSjk5UdR"
 },
 {
  "Email": "info@ihi.co.jp",
  "Name": "Tamotsu Saito",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gWUQasileNbOCL1DEQNN"
 },
 {
  "Email": "tom.pemberton@chapmantripp.com",
  "Name": "Mr Thomas Pemberton",
  "Document Name": "BI_2020_TON_bi_PPP_survey_en_TOM PEMBERTON.doc",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gX9beGpFaBrRd3yQrTbA"
 },
 {
  "Email": "james.abbott@allenovery.com",
  "Name": "Mr James Abbott",
  "Document Name": "AU TPI Survey_Allen and Overy.doc",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gXjyu7zlseKG2MZ2UU39"
 },
 {
  "Email": "jferentinos@mhealthtzppp.net",
  "Name": "Janita Ferentinos",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gYCaY4LNZBH7STksB1W1"
 },
 {
  "Email": "info@snclavalin.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gb8kiQg2VPFqAD7CEllh"
 },
 {
  "Email": "kfelz@HuntonAK.com",
  "Name": "Kevin Felz",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gblthIhs7m4hexgUGhaO"
 },
 {
  "Email": "kyungrak@elclawoffice.mn",
  "Name": "title Kyungrak Ko",
  "Document Name": "MONGOLIA) ECL LAW) BI 2020 MNG_bi_PPP_survey_en_ELC.docx",
  "Country": "MNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gbxMNaoZqTi0WsG7g4G7"
 },
 {
  "Email": "martin.kudnig@ashurst.com",
  "Name": "Martin Kudnig",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gd8qP4fL96WeTaa7xQEv"
 },
 {
  "Email": "akhachaturyan@tkequitypartners.com",
  "Name": "Alekxsander Khachaturyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/geEQE1p1Xt8GNMrL8NiM"
 },
 {
  "Email": "khalid.al-thebity@squirepb.com",
  "Name": "Khalid A Al-Thebity",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/geGHMRCue6CWpPUb4tev"
 },
 {
  "Email": "benjamin.hirasawa@clydeco.com",
  "Name": "Benjamin Hirasawa",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gei91eGbqimZEdPXTWdX"
 },
 {
  "Email": "dolly@aloulalaw.com",
  "Name": "Mrs. Dolly Sleem",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_Oula.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gfrjqBuC9fbJottCK1Ny"
 },
 {
  "Email": "kerim.pelister@pae-law.com",
  "Name": "Mr. Kerim Pelister",
  "Document Name": "TURKEY) PELSITER) BI 2020 TUR_PPP_survey_en_PAE 22.07.2019.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ggA4NUoMhbdAts6bHvvN"
 },
 {
  "Email": "info@cfpslawschool.com",
  "Name": "Saliya Pieris",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ggqvtHLfeRqxgCncNGPX"
 },
 {
  "Email": "charles.brasted@hoganlovells.com",
  "Name": "Chareles Brasted",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/giCKq7vIML2PQfySl0J9"
 },
 {
  "Email": "azimfarighi@yahoo.com",
  "Name": "Mohammad Azim Farighi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/giKo7BcKHMQryMNiKn0f"
 },
 {
  "Email": "apendleton@milbank.com",
  "Name": "Andrew Pendleton",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gic20aVqriQfOutxBrtS"
 },
 {
  "Email": "yatesd@gtlaw.com",
  "Name": "David Yates",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gj9lFpEoxzycLYerATSX"
 },
 {
  "Email": "lbs4@gsb.columbia.edu�",
  "Name": "Lynne Sagalyn",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gjBxNN8BAWRN9fqv9T2U"
 },
 {
  "Email": "ammar.naji@Confluentlaw.com",
  "Name": "Mr. Ammar Naji",
  "Document Name": "BI 2020 IRQ_bi_PPP_survey_en_Confluent.docx",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gjFp5QyJd95TsewqUMzO"
 },
 {
  "Email": "nazarian@berettagodoy.com",
  "Name": "Mr. Behrad Nazarian",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_BN2 (FG).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gjoihGu4kpxhLrTSkcvW"
 },
 {
  "Email": "hwang@adb.org",
  "Name": "Hong Wang",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gk19xkra0kHrGqcn5puF"
 },
 {
  "Email": "nigel.drew@dlapiper.com",
  "Name": "Nigel Drew",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gkgDAi5lWHWbye0wcTgL"
 },
 {
  "Email": "ekihali@exorattorneys.com",
  "Name": "Ezekiel Kihali",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gl9hiBiPVOYNXp4Pgwzf"
 },
 {
  "Email": "andrew.christopher@webbhenderson.com",
  "Name": "Andrew Christopher",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/glJ50kqpyouETpz8OlXf"
 },
 {
  "Email": "kmmn@cats-net.com",
  "Name": "Josaphat Kanywanyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/glOA1zkyU1Dn4y4Fip1N"
 },
 {
  "Email": "JacobusDuPlessis@dfdl.com",
  "Name": "Mr. Jacobus Du Plessis",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en final.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/glsLm7qhDBotItZ62xM2"
 },
 {
  "Email": "bcarvajal@kpmg.es",
  "Name": "Mr. Borja Carvajal Borrero",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en-v2.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gm7vXdPMuP5vtVyFETDq"
 },
 {
  "Email": "christy@accessengsl.com",
  "Name": "Mr Christopher Joshua",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gmBRMPD7bKEOhc0XYfsj"
 },
 {
  "Email": "jsantamaria@acsinfra.com",
  "Name": "Juan Santamaria",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gmg8cBhTbOpUrRH7PN7H"
 },
 {
  "Email": "adrian.walker@hoganlovells.com",
  "Name": "Adrian Walker",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gndtPpvelIjgr4YuuEq4"
 },
 {
  "Email": "mario.rietti@cofinsa.hn",
  "Name": "Mario Rietti",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/goVQ4zYQZJB1V7TtnvI7"
 },
 {
  "Email": "vassili.salei@borovtsovsalei.com",
  "Name": "Mr. Vassili Salei",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_B&S.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gpI626TZq2zNusXDglEr"
 },
 {
  "Email": "george.sayen@bakermckenzie.com",
  "Name": "George Sayen",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gpJiqv6mhFb8FnKwjsPQ"
 },
 {
  "Email": "getachewart@yahoo.com",
  "Name": "Getachew Sisay Kebede",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gpb50brA5dxj8Ukwv7Wd"
 },
 {
  "Email": "shigeki.okatani@mhm-global.com",
  "Name": "Mr. Shigeki Okatani",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en (MHM).docx",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gplw4GBAYENuGwAx52H1"
 },
 {
  "Email": "aam@africalegalnetwork.com",
  "Name": "Amyn Mussa",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gpvqS37uENM5TGCrgH6E"
 },
 {
  "Email": "navruz.odinaev@gmail.com",
  "Name": "Navruz Odinayev",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gqWlyaUnNhK3452vxrlw"
 },
 {
  "Email": "smabiti@nexlawadvocates.com",
  "Name": "Stanley Mabiti",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gqgmCV7jYuP26FoIZDIr"
 },
 {
  "Email": "enquiries@clc-asia.com",
  "Name": "Christopher Larkin",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/grR9h3ieVy7U88UeIOYh"
 },
 {
  "Email": "eve.orgse@heta.ee",
  "Name": "Eve Orgse",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/grZbbGT6RswiP290KrVQ"
 },
 {
  "Email": "alan@schwalgerdesigns.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/grcypNk7sPVZnsdujeGG"
 },
 {
  "Email": "gsantoni@rvhb.com",
  "Name": "Mr. Georges Santoni",
  "Document Name": "BI 2020 DOM__bi_PPP_survey_en.doc (00137128xA81FF).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gs8vyyfL8jlrmeuYrNwv"
 },
 {
  "Email": "sandor.elias@triniti.ee",
  "Name": "Sandor Elias",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gsa5IZIfhR4K95gbMwxP"
 },
 {
  "Email": "info@moyolegalpractice.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gu5ZHe6ERAfUzUWe618g"
 },
 {
  "Email": "stanislav.babic@babic-partners.hr",
  "Name": "Stanislav Babic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/guyEoMhdx3Qus4B8N4RL"
 },
 {
  "Email": "tatiana@manesco.com.br",
  "Name": "Ms Tatiana Matiello CYMBALISTA",
  "Document Name": "19092209 WB Concession and PPP - Floriano de Azevedo Marques Neto.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gv98d3l0Rcqx7p4EnljJ"
 },
 {
  "Email": "r.jaffer@tamimi.com",
  "Name": "Rafiq Jaffer",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gw4MRYF9hUgq5beSCcnY"
 },
 {
  "Email": "david@attwater.ca",
  "Name": "David M. Attwater",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gwiuWMWZgwJOmSQ1FSWP"
 },
 {
  "Email": "info@uniconethiopia.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gxRrO1qZ5MNbjUN2psUg"
 },
 {
  "Email": "psjustice@pmc.gov.sb",
  "Name": "James Remobatu",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gxfNW5eIa6OTg5slhWGM"
 },
 {
  "Email": "v.b.kondr@imemo.ru",
  "Name": "Vladimir Kondratiev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gz0I9mZEtyhNA0D1F4wv"
 },
 {
  "Email": "info@alkheraiji.com",
  "Name": "Abdulaziz Al-Kheraiji",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/gzzJQiq82sFUC29f49B5"
 },
 {
  "Email": "andrew.castle@allenovery.com",
  "Name": "Andrew Castle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h0C4WxOGe1mOuXdYrjCA"
 },
 {
  "Email": "info@unitedlawyersfirm.com",
  "Name": "Hadeel A. Anwar Al-Ani",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h0FrX7U1Z0ph9iAzRNqc"
 },
 {
  "Email": "sguindi@osler.com",
  "Name": "Shahir Guindi",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h0eKhw8qkv36XV2hlBZt"
 },
 {
  "Email": "ivan.mandic@komorabih.ba",
  "Name": "Ivana Mandic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h1NV0cKMKtrQYZWtzUIA"
 },
 {
  "Email": "efidan@fidan-fidan.com",
  "Name": "Erdogan Fidan",
  "Document Name": "TURKEY) YAZICI) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h4uE0Z8njo8D08487zWw"
 },
 {
  "Email": "sarah@fs-lawyers.com",
  "Name": "Sarah Churstain",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h5RKf4ehVKX8g9CrmdCj"
 },
 {
  "Email": "commdir@aps.ateneo.edu",
  "Name": "Antonio G.M. La Vi�a",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h6EjNpJrT69z8ZDqtLm0"
 },
 {
  "Email": "khathlan@ksu.edu.sa",
  "Name": "Khalid Al-Khathlan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h6i6smWpzrUeVgQDCNl4"
 },
 {
  "Email": "mmacces-nimi@ait-aci.ca",
  "Name": "Murielle Macces-Nimi",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h6x9uBfg1ZPZhhGOlVTa"
 },
 {
  "Email": "maguilar@central-law.com",
  "Name": "Ms Marcela Aguilar",
  "Document Name": "BI 2020 HND_bi_PPP_survey_en.Central.docx",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h7HbJstUzFQjv7qWjMHM"
 },
 {
  "Email": "tchen@kpmg.com.au",
  "Name": "Alison Kitchen",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h7KL8WP7sIkE1eGapfYh"
 },
 {
  "Email": "pengcheng.tay@wongpartnership.com",
  "Name": "Peng Cheng Tay",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h86lLN2nhriGNGtsZ8yB"
 },
 {
  "Email": "nadeem.arshad@bevanbrittan.com",
  "Name": "Nadeem Arshad",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h89sCLhJxqubUn0qSpAr"
 },
 {
  "Email": "info.jacobsdcsa@jacobs.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h8tFHAKhvJ6s70kEcp0I"
 },
 {
  "Email": "nseferi@gjika-associates.com",
  "Name": "Ms. Nensi Seferi",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en - FINAL.doc",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h9GBDw4MgcyAOKLyoRL5"
 },
 {
  "Email": "veronika.sabolova@upce.cz",
  "Name": "Veronika Sabolova",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h9IJJb4B0UR3XX9OJXGn"
 },
 {
  "Email": "rose@law.cmb.ac.lk",
  "Name": "Nilmini Rose Wijeyesekera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/h9O9ycGyT1WxTbQgl4OH"
 },
 {
  "Email": "office@LP.ua",
  "Name": "Mr Dmytro Savchuk",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en (ID 16188).doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hAx5bMuzFIIiEAbIVnRu"
 },
 {
  "Email": "victoria.bortkevicha@cliffordchance.com",
  "Name": "Victoria Bortkevicha",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hB6NN8pUXmsJiZm9sb4S"
 },
 {
  "Email": "macus.schimidt@pnm.adv.br",
  "Name": "Mr. Marcus Vinicius Schimidt",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial PPP vfinal.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hBbPb0sUeVManbWvqYhb"
 },
 {
  "Email": "migueledu.ortiz@gmail.com",
  "Name": "Miguel Ortiz",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_AdolfoPulgar.docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hC0rqtVVTcYRBdkoq9KQ"
 },
 {
  "Email": "mtrabacchin@grimaldilex.com",
  "Name": "Mr. Matteo Trabacchin",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Matteo Trabacchin.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hDZ68AoMMy09sVZSawKP"
 },
 {
  "Email": "Stephen.Sim@makarim.com?",
  "Name": "Mr Stephen Sim",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Makarim v2.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hE5dJvGfL2tRnKsphv4O"
 },
 {
  "Email": "omrania@omrania.com.sa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hEOKgOU2pTy2BN3QdX5a"
 },
 {
  "Email": "Hatamkhalid@gmail.com",
  "Name": "Ahmad Khalid Hatam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hEbPGqxFlH4l1WU7BUtR"
 },
 {
  "Email": "linke@gps-logistics.com",
  "Name": "Wolfgang LINKE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hHfyAuZIFjfddl6Ye5sX"
 },
 {
  "Email": "davids@arnon.co.il",
  "Name": "David H. Schapiro",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hHqq48nzy0agsT5vIJoz"
 },
 {
  "Email": "ajit.kapadia@mkono.com",
  "Name": "Ajit Manikant Kapadia",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hIrfxzqi3XlqKTZJ21NP"
 },
 {
  "Email": "alberto.espejel.espinoza@gmail.com",
  "Name": "Dr Alberto Espejel Espinoza",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en (1).docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hJ1d2tjQeW1CiMjcmmva"
 },
 {
  "Email": "pfoxlee@kpmg.com.au",
  "Name": "Paul Foxlee",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hJ5K6aXzw54oAoCDLPTk"
 },
 {
  "Email": "GStobo@blg.com",
  "Name": "Gerry Stobo",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hJAG6gbA0HD0x6gzYIJC"
 },
 {
  "Email": "james.quinney@hsf.com",
  "Name": "James Quinney",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hJEMjooxtr4pMyLIC6i9"
 },
 {
  "Email": "RMalunga@idbz.co.zw",
  "Name": "Engineer Malunga R. K",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en IDBZ.doc.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hJkulGxRib0hekLDN70D"
 },
 {
  "Email": "ali.khalil@sksadvocates.com",
  "Name": "Ali Abdelrahman Khalil",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hK3GLQyXzHdJOpDJnuID"
 },
 {
  "Email": "andrew.molver@adams.africa",
  "Name": "Andrew Molver",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hL6d5lUqRWihsIKji5cj"
 },
 {
  "Email": "allan.mana@corrs.com.au",
  "Name": "Allan Mana",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hN419BYK6lFXfdPlCyXr"
 },
 {
  "Email": "myagovkina@abylaw.com",
  "Name": "Mariana Yagovkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hN9l4pXfyRB5IorRWrEe"
 },
 {
  "Email": "tcallahan@mcguirewoods.com",
  "Name": "Timothy Callahan",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hNXPKw3nO2ECa1hD6qBs"
 },
 {
  "Email": "shawn@goldsmine.co.za",
  "Name": "Shawn Rademeyer",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hPxhVDbLI37xYGJhNnt1"
 },
 {
  "Email": "mdepalacio@s-s,x",
  "Name": "title María De Palacio Cuetos",
  "Document Name": "S-S-#76696-v1-2020_TPI_SURVEY_wb.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hRqHK3lA82EpSZpzlAxy"
 },
 {
  "Email": "jbarksdale@dallaschamber.org",
  "Name": "Jay Barksdale",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hSIY04JsyrmMPBijuwmA"
 },
 {
  "Email": "torben.hartz@dk.ey.com",
  "Name": "Mr Torben Hartz",
  "Document Name": "BI 2020 DNK_bi_PPP_survey_en-alle SPM EY.docx",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hSikHWuxSsfK39bUJUjK"
 },
 {
  "Email": "office@pashabank.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hTD4deGi1nb0n9vfRLN3"
 },
 {
  "Email": "cradford@whitecase.com",
  "Name": "Carina Radford",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hTrNT56RUBGwF4i9XF5c"
 },
 {
  "Email": "Karim.Nassar@bakermckenzie.com",
  "Name": "Karim B. Nassar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hTu7nQUmG7dc1u8TrwiT"
 },
 {
  "Email": "tasipatea@xtra.co.nz",
  "Name": "Tuisa Tasi Patea",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hU13kCFSnwRad8Y55CUT"
 },
 {
  "Email": "Lizelle.Botha@aurecongroup.com",
  "Name": "Lizelle Botha",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hUirDiAPq9sCb4BBjHWp"
 },
 {
  "Email": "tienwah.ling@dentons.com",
  "Name": "Tien Wah Ling",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hUr8pCTwT6QQ3JRukluR"
 },
 {
  "Email": "jchaitrading@tstt.net.tt",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hVI9aPPlPrhJc2AXOs9W"
 },
 {
  "Email": "rang@ateneo.edu",
  "Name": "Rodolfo P. Ang",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hVuwfFXgnxgeUVAMUrqa"
 },
 {
  "Email": "jeba@mth.dk",
  "Name": "Jens Bastrup",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hW19hFZ0iWvEKAEmyrtD"
 },
 {
  "Email": "mxu@whitecase.com",
  "Name": "Ms. Mengbi Xu",
  "Document Name": "BI 2020 CHN_bi_TPI_survey_en (David Li 201909).doc",
  "Country": "CHN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hWodpa9jVvhBgq1qROEb"
 },
 {
  "Email": "datel@datel.ee",
  "Name": "Urmas K�lli",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hXbu6izySOxp27kei6cA"
 },
 {
  "Email": "ey@clarkelawyers.net",
  "Name": "Fiona Ey",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hY7djyxHl6R7SNXXFuKR"
 },
 {
  "Email": "matt.girard@plenarygroup.com",
  "Name": "Matt Girard",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/haeNJGkPNlLhDGUsou8A"
 },
 {
  "Email": "rick.borden@nortonrosefulbright.com",
  "Name": "Richard P. Borden",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hbqrPlVZOX3DJg8BKcCi"
 },
 {
  "Email": "kei.sasaki@amt-law.com",
  "Name": "Mr. Kei Sasaki",
  "Document Name": "BI 2020 JPN_bi_TPI_survey_en_AMT20190906.docx",
  "Country": "JPN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hciRetcEpx8VYpQgywPc"
 },
 {
  "Email": "emma.higham@clydeco.com",
  "Name": "Emma Higham",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hdeeMuyfjF7gMhUjGrcO"
 },
 {
  "Email": "murray.mcewen@abmm.co.nz",
  "Name": "Murray Mcewen",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hduLj9n3q5ZsK3B86kuf"
 },
 {
  "Email": "chauchuang@pkwalaw.com",
  "Name": "Chau Chuang Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/heZYTdcTgqCruT2U4y7P"
 },
 {
  "Email": "cflores@aczalaw.com",
  "Name": "Ms Cecille Flores",
  "Document Name": "BI 2020 HND_bi_PPP_survey_enACZALAW.docx",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hemWnnrXBbyGmFmy0aNy"
 },
 {
  "Email": "enquiries@cbi.org.uk",
  "Name": "George Mcfarlane",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hgOXRcVylHgRxve1QiiX"
 },
 {
  "Email": "jalliy@velmalaw.com",
  "Name": "Joy Hadji Alliy",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hgw4D78YOn3aufWd2NFp"
 },
 {
  "Email": "jigb@grossbrown.com.py",
  "Name": "Mr. Jorge Ignacio Gross Brown",
  "Document Name": "19.06.27 - Survey - Private Public Partnership - World Bank Group [6].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hh903e5GXJjHQ3Zo1WhC"
 },
 {
  "Email": "yassir@aihlawfirm.com",
  "Name": "Mr. Yassir Ali",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_Kayan.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hhV9ki8xoQ3CaQM1dfSv"
 },
 {
  "Email": "luis.ocando@pa.ey.com",
  "Name": "Luis Eduardo Ocando",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hhyNgbIEPHyxxSYWJyDu"
 },
 {
  "Email": "salmahdi@wanpartners.com",
  "Name": "Saad Al-Mahdi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hiHbpttbMBjelgmXMEuf"
 },
 {
  "Email": "wayne.bradshaw@fticonsulting.com",
  "Name": "Wayne Bradshaw",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hj5eHWDKfzaTBW46v7e4"
 },
 {
  "Email": "rvydra@whitecase.com",
  "Name": "Robert Vydra",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hjUbTno8GenA44F8XuyC"
 },
 {
  "Email": "mashora@mashora.com.kw",
  "Name": "Abdulrahman Alhumaidan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hjv3x666nNTCbS36BC6N"
 },
 {
  "Email": "artjom.buligin@hsf.com",
  "Name": "Artjom Buligin",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hkIXDBPQpm4Lf0hEGJuO"
 },
 {
  "Email": "ynachovski@penev.eu",
  "Name": "Mr. Yanko Nachovski",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_en_PENEV_LLP_Aug_2019.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hkNh5LRnI7uUnsOusQht"
 },
 {
  "Email": "tam.dinh@ykvn-law.com",
  "Name": "Ms. Tam Dinh Trinh Thanh",
  "Document Name": "VIETNAM) YKVN) BI 2020 VNM_bi_PPP_survey_en_YKVN_20190816.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hlXw9JCHovIZWE4gs5Du"
 },
 {
  "Email": "ushar@srilankalaw.com",
  "Name": "Usha Saraniya",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hlYaeawfEOBwR00flbja"
 },
 {
  "Email": "yboudreault@tremblaybois.qc.ca",
  "Name": "Yves Boudreault",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hldMnBi9NGCI8Y9kDj8p"
 },
 {
  "Email": "dimitrieska@ddklaw.com.mk",
  "Name": "Mrs. Ema Dimitrieska",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_DDK.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hmFp58YslZ60C0QRGtfg"
 },
 {
  "Email": "ronald.fernandez@ppulegal.com",
  "Name": "Mr Ronald Fernández-Dávila",
  "Document Name": "PPU-_211570_V_1_(Rev. PPU al 17.07.19)  WB 2020 - TPI Survey.DOCX",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hmnOQKM6isgUHbOILq12"
 },
 {
  "Email": "dms@appl.lk",
  "Name": "D.M Seneviratne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hmtyvEtxAQtjmKtRS9aW"
 },
 {
  "Email": "g.estrella@estrellatupete.com",
  "Name": "Mr. Guillermo Estrella",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_en.docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hpqUhO0NdAHFPUu8DOK0"
 },
 {
  "Email": "mario.sorm@fin.ee",
  "Name": "Mr Mario S�rm",
  "Document Name": "ESTONIA) MINSITRY OF FINANCE) 20190709_BI 2020 EST_bi_PPP_survey_en_12.07.2019.docx",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hq5LAe1ZYH9bPeEahE28"
 },
 {
  "Email": "paul.oldfield@hhl.co.nz",
  "Name": "Paul Oldfield",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hrBL3kPehmFhjJxgdY86"
 },
 {
  "Email": "alejandro.penados@legalsa.com",
  "Name": "Alejandro Penados",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hrOclrh3CqrfN6T2RqEw"
 },
 {
  "Email": "elena.iacob@zrvp.ro",
  "Name": "Mrs Elena Iacob",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en zrp 20 07 19.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hrcHMrZf383YHhpErrtG"
 },
 {
  "Email": "info@abdavid.com",
  "Name": "David Ofosu-Dorte",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hsQwpm68jUFOoIwIuerp"
 },
 {
  "Email": "gbryan@omm.com",
  "Name": "Greyson Bryan",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hsTUbb4KdxB0F1cxOiBc"
 },
 {
  "Email": "vesna.trnokop@hr.pwc.com",
  "Name": "Vesna Trnokop -Tanta",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ht5CRhvt6mBRI6cN5jvo"
 },
 {
  "Email": "gregor.page@shearman.com",
  "Name": "Gregor Page",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/htEHBh7z7vpinvUTASZv"
 },
 {
  "Email": "nana.chighladze@tsu.ge",
  "Name": "Nana Chighladze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/htdCyNctuqkq2xdGIdgR"
 },
 {
  "Email": "claude.morency@dentons.com",
  "Name": "Claude Morency",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/huojNWszksonFoVf0n2y"
 },
 {
  "Email": "kentwong@vci-legal.com",
  "Name": "Mr. Kent Wong",
  "Document Name": "VIETNAM) VCI LEGAL) BI 2020 VNM_bi_PPP_survey_en-[completed KW].docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hvIEgyqQ9cEo0pi5c6lo"
 },
 {
  "Email": "sppywh@nus.edu.sg",
  "Name": "Wai-Hang Yee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hvdolwvuAmSXiO1Eho7O"
 },
 {
  "Email": "sami.al-louzi@lw.com",
  "Name": "Sami Al-Louzi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hw0WCCLn1QaPmDq1UOEu"
 },
 {
  "Email": "seloff@mkinc.africa",
  "Name": "Sunelle Eloff",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hwPf9OLVpieMcyVHtUtw"
 },
 {
  "Email": "tevangelista@omers.com",
  "Name": "Mr. Tenio Evangelista",
  "Document Name": "BI 2020 CAN_bi_PPP_OMERS.docx",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hwi6H4VrBK8naV3LlVlE"
 },
 {
  "Email": "prl@diascarneiro.com.br",
  "Name": "Mr. Paulo Leme",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en_DiasCarneiroAdvogados.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hwnJUlti24sMUpo5KVXv"
 },
 {
  "Email": "fpiquero@esguerra.com",
  "Name": "Mr. Felipe Piquero Villegas",
  "Document Name": "PPP.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hxAvgzRQnwqUTLl90bK5"
 },
 {
  "Email": "sgarzon@lloredacamacho.com",
  "Name": "Mr. Santiago Garzon",
  "Document Name": "1340022.DOCX",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hxulI4ttk2XHxUHpFN0S"
 },
 {
  "Email": "spptank@nus.edu.sg",
  "Name": "Kenneth Paul Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hysmo9ILvKk7IuKwlrxJ"
 },
 {
  "Email": "sabit.abdullayev@remells.com",
  "Name": "title Sabit Abdullayev",
  "Document Name": "BI 2020 AZE_bi_TPI_survey_en_Remells.doc",
  "Country": "AZE",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hzB5dogVOon5x8nlDq8T"
 },
 {
  "Email": "shafaq.rehman@riaabg.com",
  "Name": "Ms. Shafaq Rehman",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_RBG_Rehman.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hzIIbJwd2XetjUqNdQ0O"
 },
 {
  "Email": "anishitani@paulweiss.com",
  "Name": "Ari Nishitane",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hzIiWbb6nNwZzUaoBpVb"
 },
 {
  "Email": "cindy@goldlaw.co.za",
  "Name": "Cindy Jonker",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hzJJlMzNE5ud0nhr5SWK"
 },
 {
  "Email": "jfaber@fogler.com",
  "Name": "Joel Farber",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/hziFN0byGJ8MngJclm5j"
 },
 {
  "Email": "Tsuyoshi.Imai@ropesgray.com",
  "Name": "Tsuyoshi Imai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i0CCVlw2k7vdxuOtbBxq"
 },
 {
  "Email": "info@newplan.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i0QEVCzCRSrbZNCLaC9K"
 },
 {
  "Email": "mark.godfrey@meredithconnell.co.nz",
  "Name": "Mark Godfrey",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i0l97RaMCySJFWjL5YBw"
 },
 {
  "Email": "billfarmer@ugandacarbon.org",
  "Name": "Bill Farmer",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i1Tx4CQrgtNNInfnODnZ"
 },
 {
  "Email": "sam_vongsy@mef.gov.kh",
  "Name": "Mr Vongsy Sam",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en_MeF.doc.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i2cYxSOfz3FjXfqOMsh2"
 },
 {
  "Email": "jlaker@mukumbyamusoke.com",
  "Name": "Ms. Juliana Laker",
  "Document Name": "BI 2020 UGA_bi_PPP_survey_en_Diana Ninsiima Kibuuka_ Mukumbya Musoke Advocates.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i3TjkkhFmVZ4vffjvDo3"
 },
 {
  "Email": "turani_andkhui@gmail.com",
  "Name": "Abdul Rahman Turani",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i45tA1AaTyD7PIXZ31v2"
 },
 {
  "Email": "davit.galdava@ge.ey.com",
  "Name": "Mr. Davit Galdava",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en_EY.doc",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i4mmpP5OlE1e5ZP6IaVf"
 },
 {
  "Email": "martin.lundbye@inlumi.com",
  "Name": "Martin Lundbye",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i5odnSNmxEVsAmnBPuJt"
 },
 {
  "Email": "marek.staron@whitecase.com",
  "Name": "Marek Staro?",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en_PRK Partners_190913.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i6VTl6RZdwZFDrzHOz2i"
 },
 {
  "Email": "aotpptk@mail.ru",
  "Name": "Mustafa Kaliev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i6WVs1umUw3ro7SQeehO"
 },
 {
  "Email": "aslan.bulatov@gmail.com",
  "Name": "Aslan Bulatov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i6loyASSpVdDeOdKeuuL"
 },
 {
  "Email": "elopez@vouga.com.py",
  "Name": "Mr. Eusebio L�pez",
  "Document Name": "BI 20220 PRY_bi_PPP_survey_en.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i75w78bgald0RulSbk0g"
 },
 {
  "Email": "tommy.gunarsa@mkklaw.net",
  "Name": "Mr Tommy Handono",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_MKK Law.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i7I3TS5bA2Wyk1B8IoOF"
 },
 {
  "Email": "saravanan.neelakandan@mnlaw.lk",
  "Name": "Saravanan Neelakandan",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i7pRpW3IenWoyeLUeAg7"
 },
 {
  "Email": "bob@sfchamber.com",
  "Name": "Bob Linscheid",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i99W9up04TVV0SzIuZnc"
 },
 {
  "Email": "tquiros@central-law.com",
  "Name": "Tomas Quiros",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i9j8Mvz4HTX5tOdEnOpP"
 },
 {
  "Email": "pinnel@abeledogottheil.com.ar",
  "Name": "Mr. Pablo Alejandro Pinnel",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en.doc",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i9lCfj1g3MhGOu47Iyvh"
 },
 {
  "Email": "manfredomarroquin@accionciudadana.org.gt",
  "Name": "Manfredo Marroquin",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i9t4MpvrQ1KEniaOdsTN"
 },
 {
  "Email": "lp@kordzadzelawoffice.ge",
  "Name": "Zviad Kordzadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/i9uX8SCdq6OgMBUOf2JY"
 },
 {
  "Email": "miriam.galandova@prkpartners.com",
  "Name": "Dr. Miriam Galandov�",
  "Document Name": "BI 2020 SVK_bi_PPP_survey_en_PRK Partners_190913.docx",
  "Country": "SVK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iA6k7Nq5qVudGctZ5bae"
 },
 {
  "Email": "tarmo.kalvet@taltech.ee",
  "Name": "Tarmo Kalvet",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iA9Md3koQ5JkW8XPKb9e"
 },
 {
  "Email": "ebm@africalegalnetwork.com",
  "Name": "Mr. Edwin Baru",
  "Document Name": "BI 2020 KEN_bi_PPP_survey_Atiq S Anjarwalla.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iB4WkZpjXyW1WhCnKfwl"
 },
 {
  "Email": "lettservices@yahoo.com",
  "Name": "Sahlemariam Tecle Kidane",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iBXyY7peIvCJRHKHTknm"
 },
 {
  "Email": "priethmuller@jonesday.com",
  "Name": "Paul Riethmuller",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iBbGiqQNeIQclRsUJhu2"
 },
 {
  "Email": "marinabwile@ethiolegal.com",
  "Name": "Marina Bwile",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iBdrppv1U61guhnYxJ19"
 },
 {
  "Email": "tcrider@stblaw.com",
  "Name": "S. Todd Crider",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iCWsYXhX6DUwLZRGTwcy"
 },
 {
  "Email": "e.kilinkarova@maximalegal.ru",
  "Name": "Elena Kilinkarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iClgggI5mOjHj5H2E2ji"
 },
 {
  "Email": "tanya.theobald@squirepb.com",
  "Name": "Tanya L Theobald",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iCx9cBet8pe1oqJoavo0"
 },
 {
  "Email": "matthew.job@hsf.com",
  "Name": "Matthew Job",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iDcdFJMpNtwpmoQVvbrK"
 },
 {
  "Email": "godfrey@lawfrontadvocates.co.tz",
  "Name": "Godfrey Paul",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iF15XM1jrU7vWWX3W5Cy"
 },
 {
  "Email": "stevan.dimitrijevic@karanovic-nikolic.com",
  "Name": "Stevan Dmitrijevic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iFxnEWvBaUMpGv1jgHC3"
 },
 {
  "Email": "cmc@cmcautomobiles.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iHDVOB4eTA9kRymRisQq"
 },
 {
  "Email": "anna.orlovich@verkhovodko.com",
  "Name": "Mrs Anna Olovich",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_V&P.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iHFYYDvLsVVA2RxQOKop"
 },
 {
  "Email": "marcus.collins@dfdl.com",
  "Name": "Marcus Collins",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iHkNiJEnUNt71pvxkrre"
 },
 {
  "Email": "mohammed.al-ghamdi@nortonrosefulbright.com",
  "Name": "Mohammed Al-Ghamdi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iJNrmLNzgpztt07csQUc"
 },
 {
  "Email": "nordecon@nordecon.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iJnZM1BPOz8AAY2E8vnd"
 },
 {
  "Email": "info@thornburghlawyers.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iK3gb6SWw7WhwNmi8k2h"
 },
 {
  "Email": "jdzida@kmpg.com",
  "Name": "Josko Dzida",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iLnibsDIkitchjpoZWqX"
 },
 {
  "Email": "r.bassi@tamimi.com",
  "Name": "Rakesh Bassi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iMvq9wfTjfPZ3HVmAsVq"
 },
 {
  "Email": "kab_hamid@yahoo.com",
  "Name": "Kabashi",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iNsnaEbZv4x8Ou1Yfc1T"
 },
 {
  "Email": "rutch21@yahoo.com",
  "Name": "Rutchelle B. Enriquez",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iOWKkjbaFD2TJcNhhZNE"
 },
 {
  "Email": "brian.dillon@dilloneustace.ie",
  "Name": "Brian Dillon",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iP3GCtIM3PzLMWjq3TcG"
 },
 {
  "Email": "praveeni.algama@fjgdesaram.com",
  "Name": "Praveeni Algama",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iPUipttHWYnz5qPhw3WM"
 },
 {
  "Email": "hans.heller@raue.com",
  "Name": "Hans Heller",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iPbf7aOjmzRZkPTzyRcV"
 },
 {
  "Email": "info@fengatecapital.com",
  "Name": "Peter Hughes",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iQdv2kdAxlER5ZlbPFNO"
 },
 {
  "Email": "mic@avm.biz",
  "Name": "Dra. Maria In�s Costa",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en (002)_AVM_13092019_vf.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iQlvDHLwpowUSDkG7URU"
 },
 {
  "Email": "john.haythorne@dentons.com",
  "Name": "John. S Haythorne",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iR2rXlwEN99WpiwFPHuw"
 },
 {
  "Email": "mekdemb@yahoo.com",
  "Name": "Mekdem Belayneh Woldeselassie",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iS4BqzCY4pDjb9UP8Nhw"
 },
 {
  "Email": "adbouin@kpmg.ca",
  "Name": "Alain Drouin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iSdxkUpgXjVyuvnOjn9F"
 },
 {
  "Email": "VYaremko@sk.ua",
  "Name": "title Volodymyr Yaremko",
  "Document Name": "BI d2020 UKR_bi_TPI_survey_en.doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iTdwncZzB6lTap9T9HGm"
 },
 {
  "Email": "marienoelle@vanuatu.com.vu",
  "Name": "Marie Noelle Patterson",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iU2ts3TE4Zuw33QrY2F7"
 },
 {
  "Email": "mearley@qatarlaw.com",
  "Name": "Mr Michael Earley",
  "Document Name": "BI 2020 QAT_bi_PPP_survey_en_Sultan.docx",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iURxdbxWvrt8GQIa5OFQ"
 },
 {
  "Email": "agustina.di-santo@bakermckenzie.com",
  "Name": "Ms. Mar�a Agustina Di Santo",
  "Document Name": "BI_2020_ARG_bi_PPP_survey_en_BakerMcKenzie.doc",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iUd9BqYGTOs8M77H0FMu"
 },
 {
  "Email": "thaphanut@huntonak.com",
  "Name": "Mr. Thaphanut Vimolkej",
  "Document Name": "BI 2020 THA_bi_PPP_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iWuuH1dQHhus25TOAcX5"
 },
 {
  "Email": "jlay@alcabco.com",
  "Name": "Jonathan R. Lay Velarde",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iXIDWOJ95sr0kL0d8SX1"
 },
 {
  "Email": "matorres@ferrere.com",
  "Name": "Dr. Mario Torres",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en (004).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iXVHDZ9IbWKIlqRiCQ6q"
 },
 {
  "Email": "gcastillo@saraviamunoz.com",
  "Name": "Ana Gisela Castillo",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iXVWiCX8yfPHFl1N2yTa"
 },
 {
  "Email": "h.tantawy@slf-qa.com",
  "Name": "Hussam Tantawy",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iXl7bW3yx2PRIyn03iC0"
 },
 {
  "Email": "info@dreves-law.jp",
  "Name": "Thomas J. Dreves",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iYOYK0QKAXCLxf958O53"
 },
 {
  "Email": "ravshan.adilov@centil.law",
  "Name": "Mr. Ravshan Adilov",
  "Document Name": "BI 2020 KAZ_bi_PPP_survey_ENG (Centil Law - 300920019).docx",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iZ5ouTbpieruz3UccGSn"
 },
 {
  "Email": "masayuki.matsuura@aplaw.jp",
  "Name": "Masayuki Matsuura",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iZeQj0kuPMSpEE8OFQk1"
 },
 {
  "Email": "ramon.clarete@up.edu.ph",
  "Name": "Ramon L. Clarete",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iaBCpRwRWSNi4Bp4dHrU"
 },
 {
  "Email": "skabochi@ikm.co.ke",
  "Name": "Ms. Sarah Kabochi",
  "Document Name": "KEN_bi_PPP_survey_en_Christine Murangi.docx",
  "Country": "KEN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iaDaVc2vJoOkCE4YXxby"
 },
 {
  "Email": "Brian.Waffi@dci.gov.pg",
  "Name": "Brian Waffi",
  "Document Name": "BI 2020 PNG_bi_PPP_survey_en_Kuria Lawyers.docx",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iajWsTZFsOCGTqExJmpI"
 },
 {
  "Email": "charles.morrison@dlapiper.com",
  "Name": "Charles Morrisin",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ibgR7kLAIcWBfRg1ZIvl"
 },
 {
  "Email": "dwhite@osler.com",
  "Name": "Donna White",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/icUWdptkra5HQeZSJ4AY"
 },
 {
  "Email": "jacintab@marquelawyers.com.au",
  "Name": "Jacinta Bishop",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/idGRtSEaxMkdeFqnT54i"
 },
 {
  "Email": "info@crbafricalegal.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/idGpGFiOjMnsc6Xk5FEx"
 },
 {
  "Email": "nils.miller@investec.com.au",
  "Name": "Nils Miller",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/idNgFsP2IrXgeusRg5IN"
 },
 {
  "Email": "sudan@smas-ip.com",
  "Name": "Isma Hassan",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/idp6wcgtaG75HIjo8v57"
 },
 {
  "Email": "brad.hayden@nortonrosefulbright.com",
  "Name": "Bradley Hayden",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ie6WwVzFjmLQkYBc0Kix"
 },
 {
  "Email": "charles.minega@uem.mz",
  "Name": "Charles Edward Minega",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ifQ241aQSm6WLNRwhq7I"
 },
 {
  "Email": "rozani@sudathpereraassociates.com",
  "Name": "Rozani Rodrigo",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ifxU09G7K9myDaIm4mcs"
 },
 {
  "Email": "sophie.nyombi@bowmanslaw.com",
  "Name": "Sophie Nyombi",
  "Document Name": "UGANDA) ABMAK) FINAL BI 2020 UGA_bi_TPI_survey_en.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ig8Rm77wpWoWRWeR4yAQ"
 },
 {
  "Email": "elena_gavrilina@epam.ru",
  "Name": "Elena Gavrilina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/igPA77KnvN0nF7CmDQxn"
 },
 {
  "Email": "Kyasin@kpmg.com",
  "Name": "Khalid Yasin",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/igtUh1yoWB6G9V3bHzBb"
 },
 {
  "Email": "Masoud.mohammadpour@de.ey.com",
  "Name": "Masoud Mohammadpour",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ijEJnhRe6v0yhfdGyPpd"
 },
 {
  "Email": "rjones@nixonpeabody.com",
  "Name": "Richard Jones",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ijLHBlW1SSiC6kUggAi9"
 },
 {
  "Email": "ilyas.ustunyer@ibsu.edu.ge",
  "Name": "Ilyas Ustunyer",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ik9Z6ehGYCbgGP7eZ1rP"
 },
 {
  "Email": "jessada@ctlo.com",
  "Name": "Jessada Sawatdipong",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ika2rTfpA7X7DBPIxhvC"
 },
 {
  "Email": "mharutyunyan@counterpart.am",
  "Name": "Maria Harutyunyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/imNGMUstZJ4RzzToNmh6"
 },
 {
  "Email": "wesley@knighnknight.com",
  "Name": "Wesley Namasala",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/inAgjbvAT9TzIPWZ5HCL"
 },
 {
  "Email": "sedef.yavuznoyan@sbb.gov.tr",
  "Name": "Mrs. Sedef Yavuz Noyan",
  "Document Name": "TURKEY) PRESIDENCY OF STRATEGY AND BUDGET) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iorrFpS2RwHYjWrPkEhs"
 },
 {
  "Email": "david.isaac@pinsentmasons.com",
  "Name": "David Isaac",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iowTREl7cQo1cj5WqRmE"
 },
 {
  "Email": "mestrade@hughes.com.uy",
  "Name": "Ms Mariana Estrad�",
  "Document Name": "PPP ENCUESTA WORLD BANK (241053xBF7D6).docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ip6HEKYIhISiKqmGzyGf"
 },
 {
  "Email": "chumachenko@vegaslex.ru",
  "Name": "Igor Chumachenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ir1JjUCP8gWMQQk9gFjl"
 },
 {
  "Email": "tarik.zaimovic@efsa.unsa.be",
  "Name": "Tarik Zaimovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/is03HQYKAjNQlZr7quds"
 },
 {
  "Email": "shafiq.tanha@ada.org.af",
  "Name": "Sahfiqullah Tanha",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/is6YViDMGn8JViT7YE9I"
 },
 {
  "Email": "amer.alamr@dlapiper.com",
  "Name": "Amer Abdulaziz Al-Amr",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/isOk722eNqE3w1V6w7hb"
 },
 {
  "Email": "matthias.lang@twobirds.com",
  "Name": "Matthias Lang",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/isVdxSqxvy9vBIGPTQ1Q"
 },
 {
  "Email": "zhanna.babych@dlapiper.com",
  "Name": "Ms Zhanna Babych",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_eng final_Soroka_Kateryna.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iscDecN7S55LPv9DIZaY"
 },
 {
  "Email": "serv20all@mail.ru",
  "Name": "?????? ?????? ????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ismaLfxP6LLiA9qjC25D"
 },
 {
  "Email": "su@bridge.t.u-tokyo.ac.jp",
  "Name": "Di Su",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/itBvYqeaAWxuySKgyjfm"
 },
 {
  "Email": "jacqui.wilkinson@nortonrosefulbright.com",
  "Name": "Jacqui Wilkinson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ite8bJyd31WqtZfydYdA"
 },
 {
  "Email": "alice.favotto@esterni.istat.it",
  "Name": "Dr. Alice Favotto",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en 18_07_2019_ISTAT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iuPdvbZXPikqM1aSqR2E"
 },
 {
  "Email": "richard.lewis@nortonrosefulbright.com",
  "Name": "Richard B. Lewis",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iuTvHHDE1oNYobad4fVm"
 },
 {
  "Email": "crystal_nam@mof.gov.sg",
  "Name": "Crystal Nam",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iunCd7IHaMeqE1ddJ0f2"
 },
 {
  "Email": "zhora.khachatryan@yerevandjur.am",
  "Name": "Zhora Khachatryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ivIo2LzlNtP4U4kVteIp"
 },
 {
  "Email": "howardhunter@smu.edu.sg",
  "Name": "Howard Hunter",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ivmxPMeeSx8Zl434xSjX"
 },
 {
  "Email": "nwimmer@whitecase.com",
  "Name": "Norbert Wimmer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iwGNMQ0Jfi9wKzPkj6az"
 },
 {
  "Email": "ryuichi.nozaki@aplaw.jp",
  "Name": "Ryuichi Nozaki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iww5vbhoOlyzLbYWCzxx"
 },
 {
  "Email": "kittipongyu@gmail.com",
  "Name": "(Tom) Yu Kittipong",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ix7ZLXAGF5Rd1vWxl2dV"
 },
 {
  "Email": "mercadeo@amchamguate.com",
  "Name": "Mariana De Sandoval",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ixdplrcKsXTdHZnIhmBw"
 },
 {
  "Email": "JOERG.RISSE@BAKERMCKENZIE.COM",
  "Name": "JOERG RISSE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ixs7bY7eZ7euEr3xohtg"
 },
 {
  "Email": "helen.griffiths@slaughterandmay.com",
  "Name": "Helen Griffiths",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iy95Ii7nmKTz6WJGtPI0"
 },
 {
  "Email": "v.hiseni@kalo-attorneys.com",
  "Name": "Ms. Vjollca Hiseni",
  "Document Name": "BI 2020 KSV_bi_PPP_survey_KALO.docx",
  "Country": "KSV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iz2m7vTTqQ4pLMCLghjn"
 },
 {
  "Email": "patriciagomes@mme.gov.br",
  "Name": "Patricia Maria Gomes",
  "Document Name": "BI 2020 BRA_bi_concession_survey_4en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/izBYkUJAA1HgKdIXh5WI"
 },
 {
  "Email": "nerses.nersisyan@am.pwc.com",
  "Name": "Nerses Nersisyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/izJEIRgAVHvqvie69B5t"
 },
 {
  "Email": "jan.byok@twobirds.com",
  "Name": "Jan Byok",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/izLhvEBkyqvYTgVmZMZ9"
 },
 {
  "Email": "info@yotekconsruction.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/izVQgUTZVihOAyApElza"
 },
 {
  "Email": "c.d.evans@bangor.ac.uk",
  "Name": "Ceri Evans",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iznB0Ksqc6ThNrgqQ1e9"
 },
 {
  "Email": "sg@nationalchamber.lk",
  "Name": "Bandula Dissanayake",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/iztIK7D4FIdTCrJnGgon"
 },
 {
  "Email": "hello@limericaghana.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j0n71IzMz7E0dieQYOkq"
 },
 {
  "Email": "brioneslm@yahoo.com",
  "Name": "Leonor M. Briones",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j0paDyZIKjHQWwEiriG6"
 },
 {
  "Email": "contact@legists.com",
  "Name": "Nopadol Intralib",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j1Wh5AEVN46yzlKQDnTC"
 },
 {
  "Email": "komziuk@aequo.ua",
  "Name": "Mr. Viktor Komziuk",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j1p7LdFFRI5BZmGZXdsj"
 },
 {
  "Email": "vukcevic.dijana@gmail.com",
  "Name": "Ms. Dijana Vuk?evi?",
  "Document Name": "BI 2020 MNE_bi_PPP_survey_en_MOF.docx",
  "Country": "MNE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j2RWsxVU9Bmi3UGDFxMM"
 },
 {
  "Email": "vicequip@utlonline.co.ug",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j3Y9RaahazMHViFeBzSA"
 },
 {
  "Email": "rashid.aliyev@remells.com",
  "Name": "title Rashid Aliyev",
  "Document Name": "BI 2020 AZE_bi_TPI_survey_en_Remells.doc",
  "Country": "AZE",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j47SwkiG0kQYFbe6XBz4"
 },
 {
  "Email": "andrew.soresen@nortonrosefulbright.com",
  "Name": "Andrew Sorensen",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j4E1Z6NsWKaIj21WGVhe"
 },
 {
  "Email": "eduardo.pedemonte@gufalaw.com",
  "Name": "Eduardo Pedemonte Lara",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j4H5lpGLNKuDXSREsc4b"
 },
 {
  "Email": "shiraz@esklawfirm.com",
  "Name": "Saeed Soltani",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j4jMYSzvSl8nLQ0tTr93"
 },
 {
  "Email": "tadessek@tadessekiros.com",
  "Name": "Tadesse Kiros",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j5fb13tsYvAiBKFlTt09"
 },
 {
  "Email": "t.petrovic@fpjr.si",
  "Name": "Mr. Toma� Petrovi?",
  "Document Name": "BI 2020 SVN_bi_PPP_survey_en_190809.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j5utKtxokuafmIKV9qtE"
 },
 {
  "Email": "kvachantiradze@vbat.ge",
  "Name": "Davit Kvachantiradze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j5xLqjyjJ0ECUuPmDUAO"
 },
 {
  "Email": "sppzvdw@nus.edu.sg",
  "Name": "Zeger Van Der Wal",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j7M2q4A42JtGvptWdG8Z"
 },
 {
  "Email": "infodancomp@gmail.com",
  "Name": "??????? ????? ????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j8VGj7I0ydTRunAIUGQ6"
 },
 {
  "Email": "andrey.mironov@cmslegal.com",
  "Name": "Mr. Andrey Mironov",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_PPP_survey_en_CMS.doc",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j8toRr1hqo33rDOh9t5C"
 },
 {
  "Email": "gerald.jennings@leedschamber.co.uk",
  "Name": "Gerald Jennings",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j9OtBDKcww4lq6nIxvpI"
 },
 {
  "Email": "ruzica.t@inecco.net",
  "Name": "Ruzica Topic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/j9xIMStJno69X0WkkgEn"
 },
 {
  "Email": "matthew@lawyers.co.ck",
  "Name": "Mathew Scrowfot",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jAUqqLxM5fKJH0TM7KEk"
 },
 {
  "Email": "raphael@racane.mw",
  "Name": "Raphael Mhone",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jB484iqCeaJDrftz819J"
 },
 {
  "Email": "abbrillantes@upd.edu.ph",
  "Name": "Alex B. Brillantes",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jBT9fqoKqIV34nhCMIos"
 },
 {
  "Email": "mallozzi@fbattorneys.com",
  "Name": "Alex Mallozzi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jD6p1oUxKnC8BEIp7d3U"
 },
 {
  "Email": "jgarro@lexincorp.com",
  "Name": "Jaime Garro",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jEJeqQl2bQFg3WFQp7BF"
 },
 {
  "Email": "engyonas@gmail.com",
  "Name": "Engineer Yonas Andegergish",
  "Document Name": "BI 2020 ERI_bi_PPP_survey_en_Yonas.docx",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jFGfBqX0YeVzi7Taofib"
 },
 {
  "Email": "david.cohen@wilmerhale.com",
  "Name": "David S. Cohen",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jFbE8fHXEhdlUEZMOyRH"
 },
 {
  "Email": "jussi@zincpot.ee",
  "Name": "Jussi Ustal",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jFq0QkXq4pBdiuEcNgIo"
 },
 {
  "Email": "jppessoa@toledomarchetti.com.br",
  "Name": "Dr. João Pessoa",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jG3RwEm801dkUZu6zdBI"
 },
 {
  "Email": "hwhite@nixonpeabody.com",
  "Name": "Heather White",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jG6EQYzgBOCEQIGknhU8"
 },
 {
  "Email": "jmoya@godoyhoyos.com",
  "Name": "Mr Jaime Moya",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en (GH).docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jGlC2ADQJ5uYH0PRex6d"
 },
 {
  "Email": "godofredo.siercke@garciabodan.com",
  "Name": "Godofredo Siercke N��ez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jHP0CViPMnH9TFsPf6D8"
 },
 {
  "Email": "alonso.miranda@ariaslaw.com",
  "Name": "Mr. Alonso Miranda",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en-(final).docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jI5C70jcC19iJexWaK9d"
 },
 {
  "Email": "e.papponetti@studiogfferrari.it",
  "Name": "Mr. Ernesto Papponetti",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en DEF.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jIKxvdYrLoDdSJhIKIAD"
 },
 {
  "Email": "vkansal@luthra.com",
  "Name": "Mr. Vishrut Kansal",
  "Document Name": "PPP in India- World bank survey - BI 2020 IND_bi_PPP_survey_en (002)(5031384.1)(.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jIXMiNJUuZN0woiFx6zd"
 },
 {
  "Email": "Miriam.Baierl@cms-rrh.com",
  "Name": "Mag. Miriam Baierl",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_CMS.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jJpyIR5EFfRKCvU93ZKi"
 },
 {
  "Email": "jmoreno@altra.com.py",
  "Name": "Mr. Jos� Antonio Moreno Rodr�guez",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en(1).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jKzq4WqABo1NP7xmmbYc"
 },
 {
  "Email": "mihkel.miidla@sorainen.com",
  "Name": "Mihkel Midla",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jMiWyOI89OqiO0BCC3br"
 },
 {
  "Email": "shabibi_lawyer@yahoo.com",
  "Name": "Walid Al-Shabibi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jMlTOhRxE0I5GWuao4u5"
 },
 {
  "Email": "lajla.hastor@wolftheiss.com",
  "Name": "Lajla Hastor",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jNpF1jsm0rZ8eIhpYSj4"
 },
 {
  "Email": "mathesonconstruction@peilocal.com",
  "Name": "Roger Matheson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jQJu9dMIVhB2OHlA1L9Z"
 },
 {
  "Email": "alvaro@almanzalegal.com",
  "Name": "Alvaro Cabal",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jQe3lLoOdeo1XCZDJ6zL"
 },
 {
  "Email": "michael.cieslarczyk@dlapiper.com",
  "Name": "Michael Cieslarczyk",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jT7r59cBzSxFGBA6BxEH"
 },
 {
  "Email": "alg@servulo.com",
  "Name": "Ms. Ana Lu�sa Guimar�es",
  "Document Name": "SERVULO # 4024679 v 1 - World BanK BI 2020 PRT_bi_PPP_survey_en.2019_VF.DOCX.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jTTxFrFRXe2z7n7XR7nk"
 },
 {
  "Email": "olaf.otting@allenovery.com",
  "Name": "Olaf Otting",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jTYKDr50JfZmRM5M7yF8"
 },
 {
  "Email": "N.Braynina@aequitas.kz",
  "Name": "Natalia Braynina",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jUrywabUQqr2zzh3tdmD"
 },
 {
  "Email": "frederico@azevedosette.com.br",
  "Name": "Ms Bruna Bouissou",
  "Document Name": "Bruna - BI 2020 BRA_bi_concession_survey_en Done.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jVBZYvfS163P4F4qFlqW"
 },
 {
  "Email": "corina.ionescu@ionescumiron.com",
  "Name": "Ms. Corina Ionescu",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_Roxana Stoica.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jVSfaYDH3DkpI02BTCCq"
 },
 {
  "Email": "gregory@msca.com.sb",
  "Name": "Gregory Joseph",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jXXLjL6wAUPkCYS5Kj9i"
 },
 {
  "Email": "joneill@HuntonAK.com",
  "Name": "John D. O�Neill",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jZ61QdndQwPkfM9f0oea"
 },
 {
  "Email": "jlangdon@akingump.com",
  "Name": "James Langdon",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jZSisbQDmwyrYZKz18dD"
 },
 {
  "Email": "azizi_najibullah@yahoo.com",
  "Name": "Najibullah Azizi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jZsl5FiSPHRwmIotAk1y"
 },
 {
  "Email": "jkeeble@fabara.ec",
  "Name": "title James E. Keeble",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en 005 (DRM).docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jZxv399hSw0JR3xAHLU1"
 },
 {
  "Email": "offri@shenhavlaw.co.il",
  "Name": "Offri Meroz",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jbgDdPhjlsBoJRNfEHMe"
 },
 {
  "Email": "info@groupsawa.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jby440abQlc1pqL4g78N"
 },
 {
  "Email": "y.marsang@polanc.com",
  "Name": "Yukmai Marsang",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jcb3SLDwO3Y64HzfnemY"
 },
 {
  "Email": "rsalo@nixonpeabody.com",
  "Name": "Rudy Salo",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jd6QL4Cky9LgkqMvblgO"
 },
 {
  "Email": "sharlene.a.williams@pwc.com",
  "Name": "Ms. Sharlene Williams",
  "Document Name": "BI 2020 JAM_bi_PPP_survey_en_PWC.docx",
  "Country": "JAM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jdXI8RvIMRzu0g5HoN1I"
 },
 {
  "Email": "kaarel.berg@eversheds-sutherland.ee",
  "Name": "Kaarel Berg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jdcieEKwHgeWrqo5g4SN"
 },
 {
  "Email": "snackan@aecon.com",
  "Name": "Steven Nackan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jdpm4GVmBJCH2aO8vwqb"
 },
 {
  "Email": "scosgriff@claytonutz.com",
  "Name": "Mr Stuart Cosgriff",
  "Document Name": "BI 2020 AUS_bi_PPP_survey_en_Clayton Utz.docx",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jdqYIG3pkyaASHeuo7os"
 },
 {
  "Email": "viorel_russu@yahoo.com",
  "Name": "Mr. Rusu Viorel",
  "Document Name": "BI 2020  MDA_bi_PPP_survey_en_VR.docx",
  "Country": "MDA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jfCeHxBuw7UUYQI6O7iK"
 },
 {
  "Email": "albertus.andhika@mkklaw.net",
  "Name": "Mr Albertus Andhika",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_MKK Law.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jg5PsdzO1i9vvl3O6DwB"
 },
 {
  "Email": "comunicacion.pan@enel.com",
  "Name": "Antonio Cammisecra",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jgQcr2UaBoU2yiht42F3"
 },
 {
  "Email": "biswajit.chatterjee@squirepb.com",
  "Name": "Biswajit Chatterjee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jgmnl6JzUfOIhAMI5VDV"
 },
 {
  "Email": "Paul.Rawlinson@bakermckenzie.com",
  "Name": "Paul Rawlinson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jhM31sszKf3fYg0fo2DM"
 },
 {
  "Email": "n.tsakalidou@espo.org",
  "Name": "Natalie Tsakalidou",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jhhAcKeuqkn5ywO6liac"
 },
 {
  "Email": "nicholas.carney@hsf.com",
  "Name": "Partner Nick Carney",
  "Document Name": "Australia_TPI_survey_en HSF response 19.7.19.docx",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ji4TYVEuzOwnfueBXqN8"
 },
 {
  "Email": "luiza@ilg.am",
  "Name": "Luiza Grigoryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jik35e2dWrKQeNXDwrd5"
 },
 {
  "Email": "tom.thackray@cbi.org.uk",
  "Name": "Tom Thackray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jj1kddlP6QgwMluUV1Fs"
 },
 {
  "Email": "premium@ethionet.et",
  "Name": "Ezra Akloge Kebebe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jjbBxRXTWjExtXMoU3OR"
 },
 {
  "Email": "sugden@vanuatu.com.vu",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jjfJr5FMOcZ0j4S9EYYL"
 },
 {
  "Email": "geraldc@claslegal.com",
  "Name": "Gerald Cole",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jkQzCbUnifLMOdHDfKD8"
 },
 {
  "Email": "info@singoadvocates.co.tz",
  "Name": "Nesha Mringo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jl5pb5TuDGDR0KO9TtJu"
 },
 {
  "Email": "Fisseha.tigist@yahoo.com",
  "Name": "Tigist Fisseha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jmMsAyfjFycQClfoR4Xb"
 },
 {
  "Email": "kmmn@cats-net.com",
  "Name": "Josaphat Kanywanyi",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jmioknJ9AmW2iiJQhI1B"
 },
 {
  "Email": "timur.pulatov@kz.ey.com",
  "Name": "Timur Pulatov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jmj1SP5TkXMg9p34AxFi"
 },
 {
  "Email": "Ranno.Tingas@ee.ey.com",
  "Name": "Ranno Tingas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jnN5l5Pk526z3QnTTnSz"
 },
 {
  "Email": "info@olympex.kz",
  "Name": "Bolat Toktarov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jo4J6TvD1HQTfsKf9ZyF"
 },
 {
  "Email": "ccg@bdplaw.com",
  "Name": "Cheryl C. Gottselig",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/joRgae7hixwkZtrDqRVI"
 },
 {
  "Email": "enrique.delacruz@divinalaw.com",
  "Name": "Enrique V. Dela Cruz, Jr.A",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/joiP6wStrP47APDWxGU6"
 },
 {
  "Email": "d.gegechkori@atsu.edu.ge",
  "Name": "David Gegechkori",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jolMmuuCiSvC1STawlzf"
 },
 {
  "Email": "eustace.ngoma@cco.co.zm",
  "Name": "Mr Eustace Ng'oma",
  "Document Name": "BI 2020 ZMB_bi_PPP_survey_en.docx",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jomil6aGAyjGGu50Mrmz"
 },
 {
  "Email": "pt@prestigenetwork.com",
  "Name": "Peter Townsley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jpSvoL2PsMOB07vKwxku"
 },
 {
  "Email": "info@cec.lk�",
  "Name": "Sanjaya Geethanga",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jpgZxns1f1ZPxzh5Qf0e"
 },
 {
  "Email": "dcohen@velaw.com",
  "Name": "David Cohen",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jreCkrmLwJxMj9IH5367"
 },
 {
  "Email": "pdi@skaureipurth.com",
  "Name": "Peter Dianati",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/js8yZi67xaMn6495fsY9"
 },
 {
  "Email": "remba@sololaakpana.com",
  "Name": "Mrs. Rosemary Mba",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank PPP Survey.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jsJsBIewxQbT8Imj11C0"
 },
 {
  "Email": "cvetkovski@ddklaw.com.mk",
  "Name": "Mr. Ljupcho Cvetkovski",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_DDK.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jspbG5P2xHxA3yfTvsC3"
 },
 {
  "Email": "ants.karu@lextal.ee",
  "Name": "Ants Karu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jt7ZtTUjJiJzVRXoEetH"
 },
 {
  "Email": "aruttenberg@cooley.com",
  "Name": "Adam Ruttenberg",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/juEiamZqttjgdDqfxAgG"
 },
 {
  "Email": "enquiries@smithbrothersltd.co.uk",
  "Name": "Clive Naylor",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/juP9kNUJMMxt6SGT5CBe"
 },
 {
  "Email": "sescriba@consortiumlegal.com",
  "Name": "Mrs. Ana Sof�a Escrib� Barnoya",
  "Document Name": "Benchmarking Infrastructure Guatemala Consortium Legal - 190816.docx",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jvadzNJr9wl6Pi3jEjfw"
 },
 {
  "Email": "clbarnes@fasken.com",
  "Name": "Clarke Barnes",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jvnjA5l9z5usn7jCpEwY"
 },
 {
  "Email": "rolando@bufetecandanedo.net",
  "Name": "Rolando Candanedo Deneken",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jwKOZk55zlySFyHfOEO0"
 },
 {
  "Email": "aabeysekera@tiruchelvam.com",
  "Name": "Asanka Abeysekera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jwUjNrt7XWBX8dofpTH0"
 },
 {
  "Email": "matamoros@central-law.com",
  "Name": "Roberto Matamoros",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jwaxc70WkJo2G3TsHhCe"
 },
 {
  "Email": "jcowen@porterhedges.com",
  "Name": "James Cowen",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jxD9E8iMJn0Ry8MZ9SDC"
 },
 {
  "Email": "haneen@hejailanlaw.com",
  "Name": "Haneen Al Hejailan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jyMX36uW9a4RIEQ4QEJu"
 },
 {
  "Email": "tcdsco@ethionet.et",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jyshVb0Cic6okZbiLWqo"
 },
 {
  "Email": "holzinger@knauthe.com",
  "Name": "Endrik Holzinger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/jzbC5nO6X0sqHqEPsIAD"
 },
 {
  "Email": "safwan.moubaydeen@dentons.com",
  "Name": "Safwan Moubaydeen",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k0MHqK2hmq1UYXZcx2NX"
 },
 {
  "Email": "darren.craig@cms-cmck.com",
  "Name": "Darren Craig",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k1dQGPTabRXMYolriTrr"
 },
 {
  "Email": "charles.ks.loh@sg.pwc.com",
  "Name": "Charles Loh",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k26eu2AeEXGgrpSG9ChO"
 },
 {
  "Email": "brigid@greenwoodroche.com",
  "Name": "Brigid Mcarthur",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k2sjcSa6Izk57zLF86u3"
 },
 {
  "Email": "valters.gencs@gencs.eu",
  "Name": "Valters Gencs",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k46HRSAK1Klh6UvDCDXz"
 },
 {
  "Email": "monika.magi@concordia.ee",
  "Name": "Monika Magi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k4Emt39YhKmRXPgebhye"
 },
 {
  "Email": "metodi.baykushev@dpc.bg",
  "Name": "Mr. Metodi Baykushev",
  "Document Name": "BI 2020 BGR bi PPP survey en DPC 15.08.2019.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k4QiOjwPdy3ege5yYPQB"
 },
 {
  "Email": "cosmaliganya@gmail.com",
  "Name": "Emmanuel Malignaya",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k4R8p22vZ7qKgEdrnmL3"
 },
 {
  "Email": "martin.hirvoja@magnussonlaw.com",
  "Name": "Martin Hirvoja",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k545wInl4MPNvXRq5Mcn"
 },
 {
  "Email": "info@lawfrontadvocates.co.tz",
  "Name": "Cornelius Mtaki",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k5PTwUr15RGfMQtEuLbr"
 },
 {
  "Email": "medgulf@qatar.net.qa",
  "Name": "Chakib Nayfe",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/k6xjnGfgifB9QCjQEzB8"
 },
 {
  "Email": "info@alliancelf.com",
  "Name": "Mr Uche Obi",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_PPP_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kA9MIfvePGlZRC05PnNH"
 },
 {
  "Email": "mvalolaw@globemax4g.com",
  "Name": "Titus Mvalo",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kAcMnmobs8NBNaCTF6cr"
 },
 {
  "Email": "doris.wimmler@lawcouncil.asn.au",
  "Name": "Doris Wimmler",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kB7OtHP7ULLe6u0b4lTg"
 },
 {
  "Email": "mkilloran@osler.com",
  "Name": "Maureen Killoran",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kDdcBfukpLdvpAHRBska"
 },
 {
  "Email": "info@herguner.av.tr",
  "Name": "MS. BURCU BASAR",
  "Document Name": "TURKEY) HERGUNER) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kDzK5oVecBjGdS1CHqGD"
 },
 {
  "Email": "rhatoongo@unza.zm",
  "Name": "Ronald Hatoongo",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kE8ab5oi4CPDW5OAfnMX"
 },
 {
  "Email": "gac@prcp.com.pe",
  "Name": "Mr. Marcelo Castilla",
  "Document Name": "BI 2020 PER_bi_TPI_survey_en_Payet - 4837-1645-6348 v. 3.doc",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kE8tIFL7LszszNOg8Lin"
 },
 {
  "Email": "mengistuworku@gmail.com",
  "Name": "Mengistu Worku Mengesha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kEDUjK3ZVGJ9sIK06f40"
 },
 {
  "Email": "fbotchway@qu.edu.qa",
  "Name": "Francis Botchway",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kEY60vfphy6jh15Qmdyn"
 },
 {
  "Email": "alejandro.perez@fhlegal.ec",
  "Name": "Mr. Alejandro P�rez Arellano",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en, MAF.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kEyC33W5S1OVtXYFAl2H"
 },
 {
  "Email": "cecilia.arosemena@arodi.com",
  "Name": "Cecilia Arosemena",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kFJo5swfzvXzRzXLQ02d"
 },
 {
  "Email": "Erki.Fels@glimstedt.ee",
  "Name": "Erki Fels",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kFf3maM1yf2YpsKeF4YX"
 },
 {
  "Email": "jogwal@ligomarc.com",
  "Name": "Joshua Ogwal",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kFpEu0sxs3xXGCZO7E68"
 },
 {
  "Email": "ash@winlaw.dk",
  "Name": "Anne St�tt Hansen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kGLlClxUS1IywLvF9scH"
 },
 {
  "Email": "gbk@signumlaw.com",
  "Name": "Ms Gaukhar Kudaibergenova",
  "Document Name": "BI 2020 KAZ_bi_PPP_survey_en_SIGNUM Law Firm.docx",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kGcsWwRrjv7JaGoZruEu"
 },
 {
  "Email": "kheriah.alsaeed@saudilegal.com",
  "Name": "Ms Kheriah Alsaeed",
  "Document Name": "BI 2020_SAU_bi_PPP_survey_en_Oct4_heriah_Abdulaziz_AlSaeed_Saudilegal.doc",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kGxtrkFlZ4ZIx5IwHUKQ"
 },
 {
  "Email": "makeramug@yahoo.com",
  "Name": "Akera Moses",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kIWRJewOgNeP0Ma26JHO"
 },
 {
  "Email": "andres.vutt@magnussonlaw.com",
  "Name": "Andres Vutt",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kIqd51c9sfvgDVryF4d5"
 },
 {
  "Email": "roy@rrlaw.co.il",
  "Name": "Roy Ahiezer",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kJyQhjUTpblPC1VF7WRK"
 },
 {
  "Email": "karolis.kacerauskas@ellex.lt",
  "Name": "Dr. Karolis Ka?erauskas",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en. FINAL.doc.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kK6HkPXZrKMNXoxYpw6f"
 },
 {
  "Email": "jolson-welsh@mayerbrown.com",
  "Name": "Jonathan Olson-Welsh",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kKciv0a1kpDE2Pt0E2yL"
 },
 {
  "Email": "info@adtrpenoski.com.mk",
  "Name": "Darko Nikodinovski",
  "Document Name": "BI 2020 MKD_bi_PPP_survey_en_Trpenoski.docx",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kKhaVENEQKrdl2Va1o6H"
 },
 {
  "Email": "info@gpartners.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kLXtu4Z9BlNzWbAuU05k"
 },
 {
  "Email": "adam.lovett@nortonrosefulbright.com",
  "Name": "Adam Lovett",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kM901RXHXA3qKAht04QJ"
 },
 {
  "Email": "lawnasir@yahoo.com",
  "Name": "Nasir Elboshra",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kMDoIackhy1T6ZgEynYY"
 },
 {
  "Email": "sandra.metsamart@sorainen.com",
  "Name": "Sandra Metsamart",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kMhnIjPvowHmfsNgGG6A"
 },
 {
  "Email": "ermina.kamencic@karanovicpartners.com",
  "Name": "Ms. Ermina Deli? Kamen?i?",
  "Document Name": "PPP_Ermina.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kMip0CizVNoNo9RbyPMa"
 },
 {
  "Email": "mina.sekiguchi@jp.kpmg.com",
  "Name": "Mina Sekiguchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kNvwE7mEmSv8IKi1H7cq"
 },
 {
  "Email": "lawyers@rouhanipartners.com",
  "Name": "Riad Rouhani",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kOAmlHW5p7YtPYSzezb0"
 },
 {
  "Email": "dunya@desaram.com",
  "Name": "Ms Dunya Peiris",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en_DL&F De Saram.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kODV7Mm0OTWIN096B5Or"
 },
 {
  "Email": "focus.lutinwa@tz.pwc.com",
  "Name": "Focus Lutinwa",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kP8EPdOCL0sUK8vlC1Nz"
 },
 {
  "Email": "kadale@africa-online.net",
  "Name": "Jason Agar",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kPZrlTS2szr681CPMNSf"
 },
 {
  "Email": "pryoungbarristers@yahoo.com",
  "Name": "Archil Kaikatsishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kPiAuxZvU1VLX5Zj0KTr"
 },
 {
  "Email": "tom.hiew@ashurst.com",
  "Name": "Tom Hiew",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kQ2qcAjxERFykRvf0WyN"
 },
 {
  "Email": "mihkel.tasa@concordia.ee",
  "Name": "Mihkel Tasa",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kSLHEq73HFTmqkc8Nc5c"
 },
 {
  "Email": "jcousin@jrcc.ca",
  "Name": "Jerry Cousin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kSOZUx88htB2VSl7F6rw"
 },
 {
  "Email": "vedran.vucelic@cei.hr",
  "Name": "Vedran Vuceli?",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kSSF7ykYmV2Mtdzn3iEi"
 },
 {
  "Email": "jbannister@mcguirewoods.com",
  "Name": "Joel Bannister",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kSngcB3BIBlf0pVvsr10"
 },
 {
  "Email": "ema.soares@ccmp.org.mz",
  "Name": "Pedro Couto",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kTL4u2ExWj8RZIjfltY0"
 },
 {
  "Email": "ann.cheung@dlapiper.com",
  "Name": "Ann Cheung",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kTakZOMKqwHRKCgu09gS"
 },
 {
  "Email": "FHOQuaah@milbank.com",
  "Name": "Mrs Felicia lHanson Ofori-Quaah",
  "Document Name": "BI 2020 GBR_bi_PPP_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kUHiaejatZxPQDH2UwIL"
 },
 {
  "Email": "eiichi.kanda@cliffordchance.com",
  "Name": "Eiichi Kanda",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kUNiohuL1xSkmIrYSpRO"
 },
 {
  "Email": "lori.mathison@dentons.com",
  "Name": "Lori A. Mathison",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kUOZ0aYTYhLiY2rancNk"
 },
 {
  "Email": "nathaniel.rowe@shearman.com",
  "Name": "Nathaniel Rowe",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kUdi5qNELeMr7JZhEj9p"
 },
 {
  "Email": "stephan.jooste@aurecongroup.com",
  "Name": "Stephan Jooste",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kWKPRXMD25TQKmWIvcug"
 },
 {
  "Email": "dohaoffice@najeeblawfirm.com",
  "Name": "Najeeb Bin Mohammed Al Nuaimi",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kWZy6rzQuedGbynHwiy4"
 },
 {
  "Email": "enquiries@pg.ey.com",
  "Name": "Frank Bouraga",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kXCrrGco4bxBGZ6eSduZ"
 },
 {
  "Email": "rtchkuaseli@blc.ge",
  "Name": "Ms Rusa Tchkuaseli",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_BLC.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kXqWHHe4v8cGcbQm2gP8"
 },
 {
  "Email": "idailey@bbcgrp.com",
  "Name": "Lisa Dailey",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kYwpNF24B4pFbZlpB4ui"
 },
 {
  "Email": "yudhishtran.kanagasabai@lk.pwc.com",
  "Name": "Yudhishtran Kanagasabai",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kZVt6OqLfsds5DGrLpQc"
 },
 {
  "Email": "kib@uoa.edu.er",
  "Name": "Kibrom Tesfagabir",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ka9gHZJflLF0GVAlWtLN"
 },
 {
  "Email": "Kalunga@africaonline.co.tz",
  "Name": "Leopold Thomas Kalunga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kaRWyqsD8etlxSViAWXj"
 },
 {
  "Email": "mike.parker@ey.com",
  "Name": "Mike Parker",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kalHoB984Yoxd2C8YIvn"
 },
 {
  "Email": "kweku.lisk@bmtlaw.com",
  "Name": "Kweku Lisk",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kawjLmCXafHiLTvINaXj"
 },
 {
  "Email": "rmaxwell@fasken.com",
  "Name": "Robert D. Maxwell",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kbyuJq21BTh8HzzbA2z7"
 },
 {
  "Email": "obalogun@curtis.com",
  "Name": "Timi Balogun",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/keTMROXYkk5lHZL1rg8A"
 },
 {
  "Email": "phil.franklin@morobejv.com",
  "Name": "Phillip Franklin",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kfWTIhQxu7iqqO9Q8FeT"
 },
 {
  "Email": "cci@volgogradcci.ru",
  "Name": "Vladimir Vasilenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kg5SV7W2edGmcFh288BL"
 },
 {
  "Email": "will.tipping@maynewetherell.com",
  "Name": "Will Tipping",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kgO2cseaKLcZEglSTXVt"
 },
 {
  "Email": "mekdemb@yahoo.com",
  "Name": "Mekdem Belayneh Woldeselassie",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kgpJSJdtyGV7qtpROBql"
 },
 {
  "Email": "mhogson@deloitte.ca",
  "Name": "Mark Hodgson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/khyXZLzzS4QFMBuac81H"
 },
 {
  "Email": "kittidej@thai-iod.com",
  "Name": "Kittidej",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kj3QBxIFQZa7fgvunkq7"
 },
 {
  "Email": "smwakaje@nexlawadvocates.com",
  "Name": "Saudin J. Mwakaje",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kjAolRDgY7h0gKU3T0Hz"
 },
 {
  "Email": "tania.fernando@fjgdesaram.com",
  "Name": "Tania Fernando",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kjw1gXT42FT7GWiu03ik"
 },
 {
  "Email": "Heru.Mardijarto@makarim.com",
  "Name": "Mr. Heru Mardijarto",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Makarim v2.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kk2zo62zxVpItCv4DR8R"
 },
 {
  "Email": "emily.heard@bevanbrittan.com",
  "Name": "Emily Heard",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kkfCPmFNuKIYVlYEn45k"
 },
 {
  "Email": "omar@alrasheedlaw.com",
  "Name": "Omar Al-Rasheed",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kktZVIVkpXDDPw1YxK1q"
 },
 {
  "Email": "sikaulu@zamnet.zm",
  "Name": "Bubile Mupeso",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kl8IkcQWU8on9BRQKEK7"
 },
 {
  "Email": "markdavis@kpmg.com.au",
  "Name": "Mark Davis",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kmUZQOHmq6MGzfRoCww4"
 },
 {
  "Email": "vorasaree.wangwittaya@allenovery.com",
  "Name": "Vorasaree Wangwittaya",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kmdfdhN4oJzscwBHF2zD"
 },
 {
  "Email": "s.lim@nabarro.com",
  "Name": "Steven Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/koLHQsgFgFG0OCCUGqUt"
 },
 {
  "Email": "carrie_bee.hao@romulo.com",
  "Name": "Carrie Bee C. Hao",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/koT2rctjJMAHJNAC39Vr"
 },
 {
  "Email": "ealfaro@talial.com",
  "Name": "Eloy Alfaro De Alba",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/koi42glJMU2fqiY3mhjY"
 },
 {
  "Email": "associate@fidelitylegal.am",
  "Name": "Hripsime Asatryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kopKXBCoEeiyRXuFRHzS"
 },
 {
  "Email": "AtejanCole@yahoo.com",
  "Name": "Abdul O B Tejan-Cole",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/koq3ymZnJxpF3rCI4nIo"
 },
 {
  "Email": "dponder@osler.com",
  "Name": "Dale R. Ponder",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/koyUs9cwy2HExJnwmfWj"
 },
 {
  "Email": "sandra.fredman@law.ox.ac.uk",
  "Name": "Sandra Fredman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kpETyAOEaQvgROq7peej"
 },
 {
  "Email": "Y.Pylypets@lp.ua",
  "Name": "Yaroslav Pylypets",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en (ID 16188).doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kpWJx2NpdALgpgORwp5g"
 },
 {
  "Email": "blundyp@bennettjones.com",
  "Name": "Paul D. Blundy",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kptRMgEkKRUEtKWuZnHt"
 },
 {
  "Email": "riyadh@sa.ey.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kq5r6nu7ltLXp8MF8jgS"
 },
 {
  "Email": "acastorino@ristuf.it",
  "Name": "Mr. Antonino Castorino",
  "Document Name": "BI 2020 ITA_bi_TPI_RandT.doc",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ks0oP7jF1ytUukm2CwK2"
 },
 {
  "Email": "hokada@tmi.gr.jp",
  "Name": "Hideyuki Okada",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ktHwD2xgg4oy7XgZiRoo"
 },
 {
  "Email": "bmuftuoglu@yaziciao.com",
  "Name": "Ms Bilge M�ft�o?lu",
  "Document Name": "TURKEY) YAZICI) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kv6EZ5V2ZXNeYvMAFEOG"
 },
 {
  "Email": "seyoumy@tadessekiros.com",
  "Name": "Seyoum Yohannes",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kv99htP0JcIPFApTNFQ5"
 },
 {
  "Email": "duc.dang@indochinecousel.com",
  "Name": "Mr. The Duc Dang",
  "Document Name": "VIETNAM) INDOCHINE COUSEL) BI 2020 VNM_bi_TPI_survey_EN-20190806.doc",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kvhnjWhHqsVtBfuSrp9c"
 },
 {
  "Email": "mubarikbkhan15@gmail.com",
  "Name": "Ms Mubarik Khan",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_Haidermota & Co.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kw6I0l6H1sb92JQQM9xc"
 },
 {
  "Email": "green@brookfields.co.nz",
  "Name": "Andrew Green",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/kyMN1azcRGnqGgFcWQS1"
 },
 {
  "Email": "maletandumbaro@yahoo.co.uk",
  "Name": "Ramadhani Ally Maleta",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l0a8SmDXzj9txdOXQlof"
 },
 {
  "Email": "vcervino@uschamber.com",
  "Name": "Victor Cervino",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l25W7B8qMjMpfQWD7bAb"
 },
 {
  "Email": "brad.richards@haynesboone.com",
  "Name": "Bradley Richards",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l2RknVw0JLb6ZiEK0V1M"
 },
 {
  "Email": "info@ralphandarnoldassociates.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l4365YG6squ8h5kFUcKj"
 },
 {
  "Email": "vahag@lawgroup.am",
  "Name": "Vahagn Balabekyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l498AGXHzcLEkN9Cg3B1"
 },
 {
  "Email": "dejan.ljustina@hr.pwc",
  "Name": "Dejan Ljustina",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l5fYxVUkR8uo2SM7WNIp"
 },
 {
  "Email": "hmartirosyan@aua.am",
  "Name": "Hakob Martirosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l5oQJs5geoMCQWpe5PP0"
 },
 {
  "Email": "zhanna@ilg.am",
  "Name": "Zhanna Martirosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l5zWZ5kZbJxNzu8bIsrc"
 },
 {
  "Email": "mcupit@uk.ey.com",
  "Name": "Michael Cupit",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l6AxJXNwVcLOy04QMcVk"
 },
 {
  "Email": "charles.magdelaine@vdb-loi.com",
  "Name": "Mr. Charles Magdelaine",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en_07052019.docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l6SfllmzA25FqBe9p4it"
 },
 {
  "Email": "basil@abgross.co.za",
  "Name": "Basilio De Sousa",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l6w0daVr0EGU3RcE9GuP"
 },
 {
  "Email": "andrew@stcsamasmgt.com.sg",
  "Name": "Andrew Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l7FVs3RW2ns1jbauWIO6"
 },
 {
  "Email": "indrek.leppik@glimstedt.ee",
  "Name": "Indrek Leppik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l7lwWLiyZNHvCU2qDP0N"
 },
 {
  "Email": "RVD.Law@rvdlaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l9tI8G6Qwyy1URaW0vSY"
 },
 {
  "Email": "philo_major@yahoo.com",
  "Name": "Evecar B. Cruz",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/l9wkgaR5VsLvzVe6ur63"
 },
 {
  "Email": "b_hlaw@globemw.net",
  "Name": "Khuze Kapeta",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lAFfOC1rNrbKWiZkYoaq"
 },
 {
  "Email": "nova.fairbank@norfolkchamber.co.uk",
  "Name": "Nova Fairbank",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lDNaANrOy8Jwa99QJgn9"
 },
 {
  "Email": "anwen.evans@bangor.ac.uk",
  "Name": "Dermot Cahill",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lFJv7Cc8BTKMcO0dF8Sn"
 },
 {
  "Email": "vkuhsiek@arenales.com.gt",
  "Name": "Verena Kuhsiek",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lFh5S6buGKb1cwXPrA4m"
 },
 {
  "Email": "monica.sun@hsf.com",
  "Name": "Ms Monica Sun",
  "Document Name": "BI 2020 CHN_bi_PPP_survey_en - HSF 18 July 2019.docx",
  "Country": "CHN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lGcFpAmamYjqwUfOsQDt"
 },
 {
  "Email": "mlujan@qil4.com",
  "Name": "Maria Isabel Lujan",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lGlmgFftyMVvbc4qlBHa"
 },
 {
  "Email": "info@lexuganda.com",
  "Name": "Mathias Nalyanya",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lHHbODvMAM4ClsxGgwz0"
 },
 {
  "Email": "Sithembiso.Mkhwanazi@gtac.gov.za",
  "Name": "Sithembiso Mkhwananzi",
  "Document Name": "BI 2020 ZAF_bi_PPP_survey_en_National Treasury.docx",
  "Country": "ZAF",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lIneyatytcyjQzrJ8LTT"
 },
 {
  "Email": "kimathi@kimathilegal.com",
  "Name": "Mr. Kimathi Kuenyehia",
  "Document Name": "BI 2020 GHA_bi_TPI_survey_en KnPr 2.docx",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lKFLP6ZJfV0tRFqPMiEo"
 },
 {
  "Email": "hhristov@penev.eu",
  "Name": "Christopher Christov",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_en_PENEV_LLP_Aug_2019.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lKS3CfB0UT9mJ8nsNg80"
 },
 {
  "Email": "lawyers@aquinaslaw.sg",
  "Name": "Tong Chuan Lim",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lLAaYXaDO1oKbtHU8MCl"
 },
 {
  "Email": "barifi@abnrlaw.com",
  "Name": "Mr. Bhirawa J. Arifi",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_ABNR Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lLyo3DtwwdrF8brRWJAj"
 },
 {
  "Email": "graham.ragan@gowlings.com",
  "Name": "Graham Ragan",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lMFmGqgf2xzpzlhyEbGe"
 },
 {
  "Email": "bbender@wslaw.co.uk",
  "Name": "Bettina Bender",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lN5QkVH7ptEHlOXZMXfd"
 },
 {
  "Email": "rein.laid@hansalaw.ee",
  "Name": "Rein Laid",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lNBF8gb8V6XNxXqolH6v"
 },
 {
  "Email": "info@unicons.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lNpXnOv1oh1hvjDVrJu7"
 },
 {
  "Email": "othman@ksausalegal.com",
  "Name": "Othman S. Alshmry",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lNpuKtUVYXBSfumI2SXA"
 },
 {
  "Email": "chinnavat.c@weerawongcp.com",
  "Name": "Chinnavat Chinsangaram",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lNwkYmVCwMvjRdkgCs4j"
 },
 {
  "Email": "mdicarlo@ristuf.it",
  "Name": "Mr. Mario Di Carlo",
  "Document Name": "BI 2020 ITA_bi_TPI_RandT.doc",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lOl71j7vCH8bpn5058Bb"
 },
 {
  "Email": "anniengo@eplegal.com",
  "Name": "title Annie Ngo",
  "Document Name": "BI 2020  VNM_bi_TPI_survey_EPlegal.docx",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lQ5uSVWxafPAbwRzGqCv"
 },
 {
  "Email": "cradford@whitecase.com",
  "Name": "Carina Radford",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lQeAZJkbfcWFy7QCD7Um"
 },
 {
  "Email": "glenna.thompson@bmtlaw.com",
  "Name": "Glenna Thompson",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lQqDmUEnb7oHaxOfxKO4"
 },
 {
  "Email": "adrianpeh@ylp.com.sg",
  "Name": "Adrian Peh,Pbm",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lS8dEQi7s9T1dvsyqHZL"
 },
 {
  "Email": "aghevondyan@deloitte.com",
  "Name": "Arpine Ghevondyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lSDOhdQnP4c06W7ZnUBz"
 },
 {
  "Email": "vip-cons@mail.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lTAO0oPEWfRSaotoQhdB"
 },
 {
  "Email": "deirdreb@marquelawyers.com.au",
  "Name": "Deirdre Boyle",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lU1IpmY5U1WMLSo8azPe"
 },
 {
  "Email": "kpillay@sadc-dfrc.org",
  "Name": "Kogan Pillay",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lUbHNFQfMwUIFXNCPeQC"
 },
 {
  "Email": "greg.dobson@au.ey.com",
  "Name": "Greg Dobson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lVLqRE7ArZ1tvQGLxPkg"
 },
 {
  "Email": "klaus.bieberach@pa.ey.com",
  "Name": "Klaus Bieberach",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lW0tDKHr597B15LQPI6b"
 },
 {
  "Email": "pspublic@pmc.gov.sb",
  "Name": "Shmael M Avui",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lXDhKeImwBB16uFSTWWZ"
 },
 {
  "Email": "Nicholas.Leibham@klgates.com",
  "Name": "Nicholas Leibham",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lXLqpxkESPMris24DlKS"
 },
 {
  "Email": "ichiwaula@yahoo.co.uk",
  "Name": "Levinson Chiwaula",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lXMaGRzm3IMtldCn6vMC"
 },
 {
  "Email": "novella.maugeri@theigc.org",
  "Name": "Novella Maugeri",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lZ7rrHvaEzMojFV6bZOs"
 },
 {
  "Email": "david.harrison@blplaw.com",
  "Name": "David Harrison",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lZatfP8bF9nZk8HcSDyL"
 },
 {
  "Email": "chantal@rosenstocklegal.com",
  "Name": "Chantal Grut",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lZiXtGwdxHk4JIYiTYxx"
 },
 {
  "Email": "nermeen.maher@sksadvocates.com",
  "Name": "Nermeen Maher",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lZnSIxsSbhw1Siwb8E5G"
 },
 {
  "Email": "tulika.narayan@ubc.ca",
  "Name": "Tulika Narayan",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/la358ZpYZlccd6P75VHi"
 },
 {
  "Email": "angelika.yakhneva@dlapiper.com",
  "Name": "Angelika Yakhneva",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lbGW6deDjXbv2kSQzsH2"
 },
 {
  "Email": "lruano@umg.edu.gt",
  "Name": "Luis Antonio Ruano Castillo",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lbwgR1C5CoQmXG5tDm9x"
 },
 {
  "Email": "economics@ysu.am",
  "Name": "Hayk Sargsyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lc9H7lq3y05j3m42PA5C"
 },
 {
  "Email": "marius.toime@blplaw.com",
  "Name": "Marius Toime",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lcM1fLhvHvPb0lxg7Gp2"
 },
 {
  "Email": "stuart.rowson@linklaters.com",
  "Name": "Stuart Rowson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lcnACVcwXiIxNXSpcbKT"
 },
 {
  "Email": "todd.leishman@bbklaw.com",
  "Name": "Todd Leishman",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lcv8dkvAJwM0GU8P60uv"
 },
 {
  "Email": "hhorowitz@fbclawyers.com",
  "Name": "Hagit Horowitz",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lecgNesKhxqWLv9Wfqf5"
 },
 {
  "Email": "info@saklawph.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lfQxdo8CBV0V8ucbHAiW"
 },
 {
  "Email": "helen.haal@concordia.ee",
  "Name": "Helen H��l",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lgVJKQiTXxRdlwDpAHeq"
 },
 {
  "Email": "legal@ameria.am",
  "Name": "David Sargsyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lgx7QbwYVD9gExTZYSAn"
 },
 {
  "Email": "nabraham@bgalaw.co.il",
  "Name": "Abraham Nir",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lhJsPVDTt5dtObymI8ea"
 },
 {
  "Email": "iccoffice@iccwbo.ru",
  "Name": "Vladimir Dmitriyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/li2LdHi77IfG4w6ifRGZ"
 },
 {
  "Email": "davidng@kpmg.com.sg",
  "Name": "Mr David Ng",
  "Document Name": "SINGAPORE) KPMG) BI 2020 SGP_bi_PPP_survey_en KPMG.docx",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/liWCFVvHsldm3GdN93tG"
 },
 {
  "Email": "jsk@bruunhjejle.dk",
  "Name": "Jeppe Skadhauge",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lihwCQVJ3IjZGNycoVad"
 },
 {
  "Email": "p_hn@yahoo.com",
  "Name": "Juan Pablo Aguilera",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ljNqLrNI8LfHVYjkzB45"
 },
 {
  "Email": "carh@sam.sdu.dk",
  "Name": "Carina Risvig Hamer",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lkDdUED0VRRD9DQ6jEUv"
 },
 {
  "Email": "okudzeto@senachambers.com",
  "Name": "Sam Okudzeto",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lktbGlUdAk8mqHe7FYwa"
 },
 {
  "Email": "peter.mansfield@investec.com.au",
  "Name": "Peter Mansfield",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/llF6aQCJFLb0VUjY8MD7"
 },
 {
  "Email": "manatungevk@accessengsl.com",
  "Name": "Mr Vasantha Manatunge",
  "Document Name": "BI 2020 LKA_bi_PPP_survey_en.docx",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/llTAgmaiBpl9aJ7gPglv"
 },
 {
  "Email": "hayatmohamedsalih@gmail.com",
  "Name": "Ms Hayat Hasan",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_PPP Unit.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lm1imz0ajGekl7KvXvDk"
 },
 {
  "Email": "legalservices@iraq-legal.com",
  "Name": "Samir Al Azawi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lm37akKfgGMyldN155Dc"
 },
 {
  "Email": "lourina@steynlaw.co.za",
  "Name": "Lourina Wilson",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lmfe6zZkF5rZBAeog3kO"
 },
 {
  "Email": "service@ttca.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lp1Adatn3o5XiiYinvFd"
 },
 {
  "Email": "daniel.losk@morganlewis.com",
  "Name": "Daniel Losk",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lq37S8RJxllbefqho9in"
 },
 {
  "Email": "henry@bcmalawi.com",
  "Name": "Henry Kachaje",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lrTr7Jj0Oy7gbZLp6TCY"
 },
 {
  "Email": "kaori.yamada@freshfields.com",
  "Name": "Kaori Yamada",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lrZgn4qpZS4fnSkOK4A0"
 },
 {
  "Email": "cflyon@orrick.com",
  "Name": "Carl Lyon",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lseyI9Xt8Q9iNxr208nQ"
 },
 {
  "Email": "john.cassels@fieldfisher.com",
  "Name": "John Cassels",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lt6sUBrwQJnmRZgbNpJl"
 },
 {
  "Email": "chamari.desilva@fjgdesaram.com",
  "Name": "Chamari De Silva",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ltsbwbYglf5g7gpaA4kL"
 },
 {
  "Email": "david.pennington@bmo.com",
  "Name": "David Pennington",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lubKDTi1IjYQrNH7NEv6"
 },
 {
  "Email": "msubuga@nsubugaadvocates.com",
  "Name": "Richard Nsubuga",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lwPeTpaj9ae3ODaL3JVd"
 },
 {
  "Email": "Jose.Avila@bakermckenzie.com",
  "Name": "Jose Avila",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lz4JuAHzfcEBmOS5HoQA"
 },
 {
  "Email": "joachim.grote@bld.de",
  "Name": "JOACHIM GROTE",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/lzjY0TTmzjZO1rjCdDC3"
 },
 {
  "Email": "dfioretti@grimaldilex.com",
  "Name": "Ms Daniela Fioretti",
  "Document Name": "ITA_bi_TPI_survey_en _Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m0vX44nT26jdmYHXzFXe"
 },
 {
  "Email": "lawtrust@gmail.com",
  "Name": "Barima Manu",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m1XGOjX23UfmQmMnfFGC"
 },
 {
  "Email": "tkeepetsoe@bihl.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m1enJCry5DCwq1EPmMEs"
 },
 {
  "Email": "gabriela.vonwietersheim@dlapiper.com",
  "Name": "Gabriela von Wietersheim",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m2yGTaRJQh2izEqt1IBP"
 },
 {
  "Email": "isara@mitrphol.com",
  "Name": "Isara Vongkusolkit",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m3dtO09QFfRYpSvhuR1L"
 },
 {
  "Email": "kristo.kallas@sirel.com",
  "Name": "Kristo Kallas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m4RXwYnbsLVd1mEnwo6a"
 },
 {
  "Email": "paul.lockyer@nortonrosefulbright.com",
  "Name": "Paul Lockyer",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m4qCojOhlIoSKPcCgdg2"
 },
 {
  "Email": "fpenalba@seitt.es",
  "Name": "Mr Fernando Pe�alba",
  "Document Name": "19 07 08 Inf DGP BI 2020 ESP_bi_PPP_survey_env_SEITT.DOCX",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m6XlCjEgKjyzUM51z6Zr"
 },
 {
  "Email": "paulino.langa@abreuadvogados.com",
  "Name": "Paulino Langa",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m7EN5Uav9KuJAuKiPc7K"
 },
 {
  "Email": "dina.eldib@eldib.com",
  "Name": "Dina Eldib",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m8D80czeKXyc6NGc9DGO"
 },
 {
  "Email": "mekchamber@ethionet.et",
  "Name": "Gebrehiwot Gebreegziabher",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m8Z5BTunekhMsDqGUWi6"
 },
 {
  "Email": "giorgitsertsvadze@jtc.ge",
  "Name": "Giorgi Tsertsvadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m8krGInE7oANyogVmxBH"
 },
 {
  "Email": "Belayklawoffice@gmail.com",
  "Name": "Mr. Belay Ketema",
  "Document Name": "ETHIOPIA) KETEMA) BI 2020 ETH_bi_TPI_survey_en.docx",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m8lcrDpThCnYViu3JMe2"
 },
 {
  "Email": "mackinnonh@bennettjones.com",
  "Name": "Hugh L. Mackinnon",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m9VhT1hJ2W7ZslmMKhup"
 },
 {
  "Email": "rosekun@clcom.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m9d8p4rWLsyR6GwaoRpa"
 },
 {
  "Email": "andy.ferris@hoganlovells.com",
  "Name": "Andy Ferris",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m9hQYS74qTmQi6jc7J6l"
 },
 {
  "Email": "i.alfian@amoktarina.co",
  "Name": "Mr Irgi Alfian S.H",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_an_Oktarina.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/m9qoG7Yoag7EHWQUwo34"
 },
 {
  "Email": "gpazsitka@jalsovszky.com",
  "Name": "Dr. Gabor Pazsitka",
  "Document Name": "HUNGARY) JALSOVSZKY) BI 2020 HUN_bi_PPP_survey_en_BE_190731.docx",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mAHJ0RkZjCrRCBUWY71A"
 },
 {
  "Email": "richard.abbot@hfw.com",
  "Name": "Richard Abbott",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mAOLnIOEXp5OWIR8BcrK"
 },
 {
  "Email": "chsofocleous@sofocleous.com.cy",
  "Name": "Christina Sofocleous",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mBStzaVFqKrQbmKDewaZ"
 },
 {
  "Email": "jorge.diterlizzi@ppulegal.com",
  "Name": "Mr Jorge Di Terlizzi",
  "Document Name": "PPU-_8122162_V_1_TPI in Colombia - World Bank Survey 2020.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mBh9g2B8SE4gl6XJaMZV"
 },
 {
  "Email": "neil.cuthbert@dentons.com",
  "Name": "Neil Cuthbert",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mC0xQwjefzQaFc4yWpXD"
 },
 {
  "Email": "ojauch@goerg.de",
  "Name": "OLIVER JAUCH",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mDGQ8jZautcrfcn8M4Cg"
 },
 {
  "Email": "anneli.pytsepp@lindeberg.legal",
  "Name": "Anneli P�tsepp",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mDpN1PEEmj2wsNyQLZ5F"
 },
 {
  "Email": "enquiries@gsb.curtin.edu.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mEX2Rvl9s7GNFqjXbU8f"
 },
 {
  "Email": "jla@ah.com.au",
  "Name": "John Atanaskovic",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mEjvuPlcMDNBq4AfBvRK"
 },
 {
  "Email": "o.emanuele@nmlex.it",
  "Name": "Mr. Otello Emanuele",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_Daniela Jouvenal Long.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mFC8r0XacaoDaJwvEBqG"
 },
 {
  "Email": "merve.oner@sbb.gov.tr",
  "Name": "Mrs Merve Oner",
  "Document Name": "TURKEY) PRESIDENCY OF STRATEGY AND BUDGET) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mH5XmBgsMTNYhQkwHD6m"
 },
 {
  "Email": "konstantin.makarevich@hoganlovells.com",
  "Name": "Konstantin Makarevich",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mHewqNvoHBAdeePMIAwa"
 },
 {
  "Email": "saman@capitallaw.lk",
  "Name": "Saman Senadheera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mI5ZuZyVNmBZOGrpIVQn"
 },
 {
  "Email": "aizhan.karzhaubayeva@linkagemind.com",
  "Name": "Aizhan Karzhaubayeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mJbC7dksLa3vR8IoKPTW"
 },
 {
  "Email": "hosam.ghaith@allenovery.com",
  "Name": "Hosam Ghaith",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mJnSDZDrLztC1FJQgK4R"
 },
 {
  "Email": "mlm@law.co.za",
  "Name": "Metja Ledwaba",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mKiCj4Um2HlaPvXmu8Y6"
 },
 {
  "Email": "marpardo@dnp.gov.co",
  "Name": "Ms Mar�a Pardo Salinas",
  "Document Name": "Encuesta BI 2020 COL_bi_PPP_Ma. Cris.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mLYZD4fN4q70tX2oezyo"
 },
 {
  "Email": "a-kamori@blakemore.gr.jp",
  "Name": "Akimitsu Kamori",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mLqBGp9tt9XOuj0fK9Cw"
 },
 {
  "Email": "bishkekchamber@netmail.kg",
  "Name": "Asiya Barieva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mMOym4vW6r3uRqEcjZTe"
 },
 {
  "Email": "etienne.gelencser@shearman.com",
  "Name": "Etienne Gelencser",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mNGwNVezXL3jHnfLmLzw"
 },
 {
  "Email": "alavrentev@vegaslex.ru",
  "Name": "Alexander Lavrentyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mO8GOQaA4PYXJcleqG26"
 },
 {
  "Email": "counsel@globemw.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mOpvbGd0gxEeBcFu6d09"
 },
 {
  "Email": "supreedee.nimitkul@dlapiper.com",
  "Name": "Supreedee Nimitkul",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mPjTqBB97EiOF6SWyN2s"
 },
 {
  "Email": "godoy@berettagodoy.com",
  "Name": "Federico Godoy",
  "Document Name": "BI 2020 ARG_bi_concession_survey FF(FG).docx",
  "Country": "ARG",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mPy0VwVUymyn8WihhTym"
 },
 {
  "Email": "dellis@dellislaw.gr",
  "Name": "Mr George Dellis",
  "Document Name": "GREECE) DELLIS_SAKELLARIOU) BI 2020 GRC_bi_PPP_survey_en.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mQ1XtsvgShHXFH5uIn0Y"
 },
 {
  "Email": "cscissura@brooklynchamber.com",
  "Name": "Carlo Scissura",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mR6KWiyxa1vwbRkf72hV"
 },
 {
  "Email": "sam@ksausalegal.com",
  "Name": "Samuel Eversman",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mSzk9na78dfNvfXnM8Dq"
 },
 {
  "Email": "gsikira@bhlawassociates.com",
  "Name": "Geoffrey Sikira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mTVGLTidUCcu4trT4sfT"
 },
 {
  "Email": "mvalverde@cnbv.gob.mx",
  "Name": "title Valverde Okón Mireya",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en - SGRC.doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mTomkoVSFaJkFoZOTv0C"
 },
 {
  "Email": "jhawkins@trowers.com",
  "Name": "James Hawkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mTsGsbMdrWBvb1BgjkQ3"
 },
 {
  "Email": "marianne.paimre@ut.ee",
  "Name": "Marianne Paimre",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mUS9w6tvH3ULVHEpPdJ1"
 },
 {
  "Email": "aborjadze@cu.edu.ge",
  "Name": "Archil Borjadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mUXZuAi4LUEcaTUh5Lic"
 },
 {
  "Email": "armine.parsyan@gmail.com",
  "Name": "Armine Parsyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mUb8SoWmMtXPlMAmRCod"
 },
 {
  "Email": "marwan.elaraby@shearman.com",
  "Name": "Marwan Elaraby",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mW3wckvR6vXs1ZV1avbf"
 },
 {
  "Email": "conrad.andersen@allenovery.com",
  "Name": "Conrad Andersen",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mWUf16lObpuTUWn16LKO"
 },
 {
  "Email": "adminoffice@hw.sedu.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mWhUSKrtJnCOXZX6mNt9"
 },
 {
  "Email": "corporate@seyco.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mWk7v3QWI67ben8KprHs"
 },
 {
  "Email": "jrivera@blplegal.con",
  "Name": "Mr Julio Rivera",
  "Document Name": "BI 2020 HND_bi_PPP_survey_enBLP.doc",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mWndZQMJLFtQf2kTBTeB"
 },
 {
  "Email": "info@linkps.com",
  "Name": "Lenise Monteiro",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mX9cNNcwptE9cwlbvSDR"
 },
 {
  "Email": "thidatun210@gmail.com",
  "Name": "Mrs Thida Tun",
  "Document Name": "TPIs (BD).docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mXA5taBiBtoRwANux4Am"
 },
 {
  "Email": "ships@avilaco.com",
  "Name": "Augusto Ho S.",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mYcFMTyIhTh8LSSuDxNh"
 },
 {
  "Email": "sales@sciug.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mZaHFlqdFdRiffaPSCK5"
 },
 {
  "Email": "lino.antonio@rodrigorochalaw.com",
  "Name": "Lino Vasco Ant�nio",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/macSBNqqmr4DgrUob4Vx"
 },
 {
  "Email": "immo.von_fallois@de.transport.bombardier.com",
  "Name": "Mircea Alexoaia",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mb00quWRVSYhJ7AkhXi9"
 },
 {
  "Email": "feras@alshawaflaw.com",
  "Name": "Feras Al Shawaf",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mb3VNCOqyjRnhuHihtRW"
 },
 {
  "Email": "info@edcc.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mbupW1S3evFUOICgQiTP"
 },
 {
  "Email": "oleg.khokhlov@gblplaw.com",
  "Name": "Oleg Khokhlov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mcbBJYAUUjYqdxSfQmQO"
 },
 {
  "Email": "sollaw@sol-law.com.sb",
  "Name": "Law",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mgB6SMVQ9Q887BeefErH"
 },
 {
  "Email": "karen.kemp@ah.co.nz",
  "Name": "Karen Kemp",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mgWHmzZ44kes4G3SQq6n"
 },
 {
  "Email": "Maxim.Kalinin@bakermckenzie.com",
  "Name": "Maxim Kalinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mgopjFlEbkvCO16x4mob"
 },
 {
  "Email": "g.hawkins@ashfords.co.uk",
  "Name": "Giles Hawkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mjI4AVySzW2FWKllJTnS"
 },
 {
  "Email": "brigette.baillie@webberwentzel.com",
  "Name": "Brigette Baillie",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mkhq6OAMVM8UKrq6m2yT"
 },
 {
  "Email": "alex.lee@bkl.co.kr",
  "Name": "Alex Lee",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mlC11uq8TTWTYUPfwR7i"
 },
 {
  "Email": "adalatlf@gmail.com",
  "Name": "Mr. Mukhtar Mustafayev",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en_Mukhtar Mustafayev.docx",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mlh9Z3yLkH0kymuSh7rz"
 },
 {
  "Email": "n.kakabadse@henley.ac.uk",
  "Name": "Nada Korac Kakabadse",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mm2PrXXKzBoDmMzBIymE"
 },
 {
  "Email": "kimm@marquelawyers.com.au",
  "Name": "Kim Middleton",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mmMtdkheKBc7waba33Ec"
 },
 {
  "Email": "marirosalyn.barrenachea@cms-grau.com",
  "Name": "Ms. Marirosalyn Barrenachea",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en (15.07.19).docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mmQS8Gl61yzj40aBnnxS"
 },
 {
  "Email": "Port-Moresby@KramerAusenco.com",
  "Name": "Rabbie Namaliu",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mmeUkdpCz1fTdo5g1Qui"
 },
 {
  "Email": "info@tanjutcolaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mn6ntOSrE0965Fb7bnvj"
 },
 {
  "Email": "Rizanesia.Citrasari@makarim.com",
  "Name": "Ms Rizanesia Citrasari",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Makarim_v2.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mn8F30pZMXo1O7j19hYw"
 },
 {
  "Email": "sgizaw@deloitte.com",
  "Name": "Solomon Gizaw",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/moiDWV3GHdPTnlZXWPL6"
 },
 {
  "Email": "hazelman@samoaonline.ws",
  "Name": "Salma Hazelman",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mpCQvLSmMhLsgvQhdlqx"
 },
 {
  "Email": "dsnowden@stblaw.com",
  "Name": "David Snowden",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mq0iS1ITCbhC49Z1c25H"
 },
 {
  "Email": "mirjam.vosu@magnussonlaw.com",
  "Name": "Mirjam Vosu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mr2jKzyQPnQNn47ElrAu"
 },
 {
  "Email": "jhelm@goerg.de",
  "Name": "JULIA HELM",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mrhOGsipV8OWyTD18LVF"
 },
 {
  "Email": "info@sbg.com.sa",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/msPl8fDawKAlJTvp6XbJ"
 },
 {
  "Email": "mark.jones@hoganlovells.com",
  "Name": "Mark Jones",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/msZc9DJ5MQa4uqzaXWQF"
 },
 {
  "Email": "comunicacion@construccion.co.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mt0KYJwwOHc61Ph1ujvu"
 },
 {
  "Email": "haneen.tantash@zubilaw.com",
  "Name": "Miss Haneen Tantash",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Sharif.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mtCJzpWSNJNIXRy0u0Oj"
 },
 {
  "Email": "Joseph.Sheffu@tz.ey.com",
  "Name": "Joseph G Sheffu",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mu28JxZn8xyeDL5TsaaY"
 },
 {
  "Email": "etpr@vcci.com.vu",
  "Name": "Eliu Luen",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mv75M4tGIhLgizZragaY"
 },
 {
  "Email": "msuzuki@jonesday.com",
  "Name": "Masatomo Suzuki",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mvExo7YcdUBZIHByC60D"
 },
 {
  "Email": "abeller@stblaw.com",
  "Name": "Amy T. Beller",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mwRxNgL4TpDkCUueHmFi"
 },
 {
  "Email": "balf@tvcabo.co.mz",
  "Name": "Benjamin Alfredo",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mwWoRsL78gH4cWRuOPN3"
 },
 {
  "Email": "buwaneka.basnayake@fjgdesaram.com",
  "Name": "Buwaneka Basnayake",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mxXnF2ivwoGnvAocZ7OR"
 },
 {
  "Email": "info@ngc.co.tt",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/myBQZ9ulMsMpVNz1VG1l"
 },
 {
  "Email": "info@fbattorneys.com",
  "Name": "Fayaz A. Bhojani",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/mypX444oUeVYuX4lnD1M"
 },
 {
  "Email": "anuleshni.neelta@usp.ac.fj",
  "Name": "Anuleshni Neelum Neelta",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n0CEc6XbE3ObYqN907Tp"
 },
 {
  "Email": "bekelej@yahoo.com",
  "Name": "title Bekele Jebessa",
  "Document Name": "ETHIOPIA) ETHIO INFRA) BJ1_BI 2020  ETH_bi_TPI_survey_en.doc",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n1FJMPA8bSUmOoQ7Sjz3"
 },
 {
  "Email": "alinaitwe_h@tech.mak.ac.ug",
  "Name": "Henry Alinaitwe",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n1ZHUcq29ABElykW73kE"
 },
 {
  "Email": "twendling@milbank.com",
  "Name": "Timothy Wendling",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n2pyl0Res7KOET9WsKm1"
 },
 {
  "Email": "lilian.mwamdanga@tic.co.tz",
  "Name": "Lilian Mwamdanga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n305MChYtIjXczSbhPrX"
 },
 {
  "Email": "V.Avdieiev@lp.ua",
  "Name": "Vadym Avdieiev",
  "Document Name": "BI 2020 UKR_bi_PPP_survey_en (ID 16188).doc",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n34Xyvxm1x2uhvaw5AN9"
 },
 {
  "Email": "legal_services@cfa-law.com",
  "Name": "Jihan Garcia Merrera-Gonzales",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n3h3PfaKZb0RHBDHT5xU"
 },
 {
  "Email": "pope@kateeraandkagumire.com",
  "Name": "Pope Ahimbisibwe",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n3oHdzS2CUJy12OoSF8n"
 },
 {
  "Email": "Mutembo@nchito.co.zm",
  "Name": "Mutembo Nchito",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n3tkBb8EQUaa5dwekBUq"
 },
 {
  "Email": "greg.lawrence@scotiabank.com",
  "Name": "Gregory D. Lawrence",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n4120nk2o3YzFx503EHM"
 },
 {
  "Email": "luka.tadic-colic@wolftheiss.com",
  "Name": "Luka Tadic-colic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n4pDmUyVBztOXHSuISb9"
 },
 {
  "Email": "mlambe@mwe.com",
  "Name": "Martin Lambe",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n4tGkjpIyGMlPstNqI2Q"
 },
 {
  "Email": "murray@drakelawsamoa.com",
  "Name": "Murray Drake",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n60Fa4KVN53G2Jjpn1Bl"
 },
 {
  "Email": "charles@lawyers.co.ck�",
  "Name": "Charles Little",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n7BMwFzQB0bDVCq97chw"
 },
 {
  "Email": "abamasak@kau.edu.sa",
  "Name": "Abdullah Mohammed Bamasak",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n7MVBS8kGWewA3l9ddFw"
 },
 {
  "Email": "gargarlawfirm@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n7fWYZC2PljwES2b1OZ1"
 },
 {
  "Email": "swalli@exorattorneys.com",
  "Name": "Shehzada Walli",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n7hTymLv0DqjHmeP82vp"
 },
 {
  "Email": "jamie.manson@icon.com",
  "Name": "Jamie N. Manson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n7olOmdxRapZ7mJG6Ai2"
 },
 {
  "Email": "masha@immma.co.tz",
  "Name": "Lawrence Kego Masha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n85pISYNQQiEQ0cQ7WKS"
 },
 {
  "Email": "ml-ppp@toyo.jp",
  "Name": "Shin Otemachi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n8notph5N8U0qbsIG5nA"
 },
 {
  "Email": "kim.toftgaard@accura.dk",
  "Name": "Kim Toftgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/n8ztIgmsgBw5Q18MZQJ0"
 },
 {
  "Email": "atrager@jhu.edu",
  "Name": "Alan Trager",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nBIjNPwE8ZxrwB5Igjkm"
 },
 {
  "Email": "gzapata@ehernandez.com.pe",
  "Name": "Ms. Gracy Marita Zapata Or�",
  "Document Name": "BI 2020 PER_bi_PPP_A (003).doc.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nBrWkXQn43sGNTBbm4ca"
 },
 {
  "Email": "info@gdarwish.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nEdhFmQcwAyi5tVwbLVb"
 },
 {
  "Email": "ypustovit@abylaw.com",
  "Name": "Yuri Pustovit",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nFBCu6dsGsagDwINJ2LM"
 },
 {
  "Email": "adam.merlehan@merlehangroup.com",
  "Name": "Adam Merlehan",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nG36cUcCbnQFqKHRv6AM"
 },
 {
  "Email": "pedro@bndes.gov.br",
  "Name": "Pedro Ivo Peixoto",
  "Document Name": "Survey - PPP - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nGSuUNOIYvg4cw8n386N"
 },
 {
  "Email": "info@advocaat-law.com",
  "Name": "Mr. Ola Alokolaro",
  "Document Name": "NIGERIA) ADVOCAAT) BI 2020 NGA_bi_PPP_survey_en (004).docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nGc2Y9sOFAgkCnID69K2"
 },
 {
  "Email": "operations@stuttafordsmalawi.com",
  "Name": "Maxwell Gambani",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nH5d5d3Ay4C85cuW1rF5"
 },
 {
  "Email": "s.deeb@tamimi.com",
  "Name": "Salah Deeb",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nHPFeqQGtYbgG6a3YWGn"
 },
 {
  "Email": "sakari.sedbom@dittmar.fi",
  "Name": "Mr. Sakari Sedbom",
  "Document Name": "FINLAND) DITTMAR) 1079988-V2-BI 2020 FIN_bi_PPP_survey_en.DOC",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nHWQQeAYh5PZ9rRSOxqj"
 },
 {
  "Email": "patrick.boocock@au.brookfield.com",
  "Name": "Patrick Boocock",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nHvCkIJ0WquK0uAJjymI"
 },
 {
  "Email": "narriaga@blplegal.com",
  "Name": "Ms Nadia Arriaga",
  "Document Name": "BI 2020 HND_bi_PPP_survey_enBLP.doc",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nHx36mpKjbbqk9Z69g3X"
 },
 {
  "Email": "a9213042122@gmail.com",
  "Name": "Natalia Andrianova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nIwcZvXrlXj7UryfxHov"
 },
 {
  "Email": "solomongedamu2008@gmail.com",
  "Name": "Solomon Gedamu",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nJ0NzhPNbDzqyQjJhNEQ"
 },
 {
  "Email": "sgizaw@deloitte.com",
  "Name": "Solomon Gizaw",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nK88cl8bTllxeVj4tciM"
 },
 {
  "Email": "ybesnard@fasken.com",
  "Name": "Yolaine Besnard",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nLIvpjC7Y7rr6OIwNJZG"
 },
 {
  "Email": "chris.sargisson@norfolkchamber.co.uk",
  "Name": "Chris Sargisson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nLeIZDiu0PrOBeyMC1xa"
 },
 {
  "Email": "burak.sarikaya@alport.com.tr",
  "Name": "Burak Sarikaya",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nMLRerJwQPEqpMLnHudx"
 },
 {
  "Email": "kusnalaw @kusnandar.com",
  "Name": "Mrs Winita Kusnandar",
  "Document Name": "BI 2020  IDN_bi_PPP_survey_Kusnandar & Co.doc",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nPc8m8gjbpMbIu51ErfD"
 },
 {
  "Email": "hchavula@mccci.org",
  "Name": "Hope Chavula",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nPuBze8ImYQEdTnnrLZ4"
 },
 {
  "Email": "aalbujar@tpinvest.com.pe",
  "Name": "Alex Albujar",
  "Document Name": "MSM BI 2020 PER_bi_PPP_survey_en.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nQH320QoZF7fvHywffWS"
 },
 {
  "Email": "tanel.melk@lmp.ee",
  "Name": "Tanel Melk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nR1Vq7jw8UlkdIup3gCC"
 },
 {
  "Email": "olav.wagner@noerr.de",
  "Name": "Olav Wagner",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nRDF4H9CARtvCW7OrMpG"
 },
 {
  "Email": "manuel.vieira@utap.pt",
  "Name": "Mr. Manuel Vieira",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en_UTAP_final.docx",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nS7sJAV9NUWFM9v4v3VI"
 },
 {
  "Email": "derrick.lusiba@pwc.com",
  "Name": "Mr Derrick Lusiba",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_TPI_survey_en.docx 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nSO60hIsHTWcViDrZe90"
 },
 {
  "Email": "ashimko@bwslaw.com",
  "Name": "Anna Shimko",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nSPYbrNggW5xlzF8u3HW"
 },
 {
  "Email": "marc.gabriel@bakermckenzie.com",
  "Name": "Marc Gabriel",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nSQJYMXrfOHu1VUbpjck"
 },
 {
  "Email": "z.shvelidze@gvinadzeandpartners.ge",
  "Name": "Zakaria Shvelidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nTNbrLJx5ruDSkDFzQQY"
 },
 {
  "Email": "varnavsky@imemo.ru",
  "Name": "Vladimir Varnavskiy",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nU6K7tXGKiWyYZCwTSJE"
 },
 {
  "Email": "cfelig@meitar.com",
  "Name": "Clifford Felig",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nVH0jJv0EuDsvOZVOoKq"
 },
 {
  "Email": "andrew.tobin@bevanbrittan.com",
  "Name": "Andrew Tobin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nVLtjezEgHztmnCA7ElQ"
 },
 {
  "Email": "SSinclair@torchindustries.ca",
  "Name": "Stephen Sinclair",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nVNWw5ssBaLx0vtM0abu"
 },
 {
  "Email": "samson_lawyer@yahoo.com",
  "Name": "Samson Mesfin",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nXc7lyGMG7riI0c7YV4P"
 },
 {
  "Email": "csm@winlaw.dk",
  "Name": "Claudia Mathiasen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nXgVyo3OijOU7HuTujhv"
 },
 {
  "Email": "meinbinder@stblaw.com",
  "Name": "Matthew Einbinder",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nY2HDoazqR4sFZPTzjNT"
 },
 {
  "Email": "f.walsh@nus.edu.ws�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nYPpCLGE2uAcdpRhhgdX"
 },
 {
  "Email": "pdeganon@mofo.com",
  "Name": "Pieter Ganon",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nYQqeZRaV7vjNPoy9IrN"
 },
 {
  "Email": "Kristen.Alvin@glikmanalvin.ee",
  "Name": "Kristen Alvin",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nYSpHzF2VGDEFc11XgSs"
 },
 {
  "Email": "yilmaz.ilgin@sbb.gov.tr",
  "Name": "Mr YILMAZ ILGIN",
  "Document Name": "TURKEY) PRESIDENCY OF STRATEGY AND BUDGET) BI 2020 TUR_bi_PPP_survey_en.docx",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nYXMtpWG39OhcAYAJEtv"
 },
 {
  "Email": "john.lonsberg@bakerbotts.com",
  "Name": "John Vincent Lonsberg",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nZ2wN5dV0zIhCD6Dd2p3"
 },
 {
  "Email": "mostafa.eissa@eldib.com",
  "Name": "Mostafa Eissa",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nZT8LO2uNh4Wnp2rJBNA"
 },
 {
  "Email": "tsolola@sololaakpana.com",
  "Name": "Mr. Tope Solola",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank PPP Survey.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nZWkIGGivyncM6wSrzgB"
 },
 {
  "Email": "els@elslanka.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nbSGwD1FJUVTb4zmcUlW"
 },
 {
  "Email": "julian.johansen@allenovery.com",
  "Name": "Julian Johansen",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nc1eGikPX4Fbwz0Ps9be"
 },
 {
  "Email": "corinne.mccarthy@dlapiper.com",
  "Name": "Corinne Mccarthy",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ncENoVKEfMPs1TTfUgvi"
 },
 {
  "Email": "info@lexferghana.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ne7zLrn8vHI9aksTepA5"
 },
 {
  "Email": "k.tsakiris@kglawfirm.gr",
  "Name": "Mr Kimon Tsakiris",
  "Document Name": "GREECE) KYRIAKIDES) BI 2020 GRC_bi_PPP_survey_en_KG input.DOCX",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/neLNjUF701xtdVqCdhdq"
 },
 {
  "Email": "krispinana.shirima@kibuukalaw.com�",
  "Name": "Krispinana Shirima",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/neNpYFWinKDJpf4RU7pM"
 },
 {
  "Email": "tmaodi@gminc.co.za",
  "Name": "Thekiso Maodi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/neO2w4NYDolpHwSghSU6"
 },
 {
  "Email": "katie.carson@kensingtonswan.com",
  "Name": "Katie Carson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nefueBXEffp27emGHdZ4"
 },
 {
  "Email": "gracapedretti@felsberg.com.br",
  "Name": "Ms. Maria da Gra�a Pedretti",
  "Document Name": "Survey - PPP - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nfEeA7I2jfLdGSi2kZkG"
 },
 {
  "Email": "william.hyatt@klgates.com",
  "Name": "William Hyatt",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ngwkZrB3U3cGXJgXnm1S"
 },
 {
  "Email": "marc.bollen@rws.nl",
  "Name": "Mr Marc Bollen",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en MBO opm PM.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nhROrW9GoWW9TzumSwKP"
 },
 {
  "Email": "onwandem@aelex.com",
  "Name": "Osinachi Nwandem",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nhRw6VE8sLFbSchwYO0D"
 },
 {
  "Email": "danila.logofet@hsf.com",
  "Name": "Danila Logofet",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nhbLtiDpXPf4l207sHqv"
 },
 {
  "Email": "gsaenz@zaalaw.com",
  "Name": "Gloria V. Sa�nz",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nhjGTL7aDK1cu3lzdQyL"
 },
 {
  "Email": "chumbot@huntonak.com",
  "Name": "Mr. Chumbot Plangtrakul",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en (HuntonAK 2 Aug 2019).docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nhnw0zMIeWHHOOmG85YI"
 },
 {
  "Email": "Dmitry.Krupyshev@lecap.ru",
  "Name": "Dmitry Krupyshev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/niEAXzJlpRd5UH9ge18T"
 },
 {
  "Email": "frankconsultants2016@gmail.com",
  "Name": "Frank Sebbowa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/niqLf3dUoJMBZBm4DplE"
 },
 {
  "Email": "abell@minchinkelly.bw",
  "Name": "Andre Bell",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/njSgLV6SO5awy1sUJnqU"
 },
 {
  "Email": "enarilaw@keblegal.ws",
  "Name": "Karanita Enari",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nkEYjNPoIh6rDFVFJhv3"
 },
 {
  "Email": "libby.g.johnson@uk.pwc.com",
  "Name": "Libby Johnson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nkJGZSN1LllPRR7NCLMo"
 },
 {
  "Email": "Mona.Dajani@bakermckenzie.com",
  "Name": "Mona Dajani",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nlGi1ynwsiZLgH4EvSvO"
 },
 {
  "Email": "mmarchetti@toledomarchetti.com.br",
  "Name": "Mr. Marcelo Marchetti",
  "Document Name": "2019.07.15 - BI 2020 BRA_bi_PPP_survey_en.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nm7Ur3VrcslDYDtN0cqk"
 },
 {
  "Email": "carietti@ferrere.com",
  "Name": "title Claudia Arietti",
  "Document Name": "World Bank - PPP Survey 2020 (Ferrere Comments July 15 2019) (ii)(925506.4).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nmgH9vE4EJY4fvTxa1NV"
 },
 {
  "Email": "kersti.kagi@aaviklaw.ee",
  "Name": "Kersti Kagi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nmwFoaxMgfVl9GJQwpR7"
 },
 {
  "Email": "bcassidy@lockelord.com",
  "Name": "Brian Cassidy",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/npPBXpbbPhdkS9vvnZx3"
 },
 {
  "Email": "bland34@hotmail.com",
  "Name": "Blund Farirdoon Arif",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nq63vfTX5FQDtMHRA7Vb"
 },
 {
  "Email": "tatiana.serrao@fbladvogados.com",
  "Name": "Mrs Tatiana Serrao",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en_new PPP law 11 from 14 of May 2019.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nqJo6GyPrJshhnPmIF0l"
 },
 {
  "Email": "masanori.sato@mhm-global.com",
  "Name": "Mr. Masanori Sato",
  "Document Name": "BI 2020 JPN_bi_PPP_survey_en (MHM).docx",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nqWpXTDRWQTh4yZbz4EE"
 },
 {
  "Email": "dieter.neumann@gtlaw.com",
  "Name": "Dieter Neumann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nqmzf4Y8ecZQinwjp4wu"
 },
 {
  "Email": "kshirai@jonesday.com",
  "Name": "Katsumi Shirai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nr13ygGdFHxmDTenTvBc"
 },
 {
  "Email": "tawfiqtabbaa@eversheds-sutherland.com",
  "Name": "Tawfiq Tabbaa",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nrfbb3yqBTmYewZjaIv2"
 },
 {
  "Email": "elham.hassanzadeh@ehandpartners.com",
  "Name": "Elham Hassanzadeh",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nrj64GLTBxQyVGJbFr8X"
 },
 {
  "Email": "rodrigobertoccelli@felsberg.com.br",
  "Name": "Mr. Rodrigo de Pinho Bertoccelli",
  "Document Name": "Survey - PPP - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nsjvpGHlhHmzrGt4PFVw"
 },
 {
  "Email": "zelimir.sikonja@ina.hr",
  "Name": "�elimir �ikonja",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ntPQujbM9BvObhglgzMl"
 },
 {
  "Email": "tamratassefa@ethiolegal.com",
  "Name": "Tamrat Assefa�Liban",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nu0dvnzqceAOEpfXG70C"
 },
 {
  "Email": "Alexey.Anischenko@sorainen.com",
  "Name": "Mr Alexey Anischenko",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_Sorainen.doc",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nuISlLbsFqREszf4Tv6G"
 },
 {
  "Email": "remontalvo@mlabogados.com.ec",
  "Name": "Mr Ricardo Montalvo Lara",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en_RML.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nuhqz6RFn4FnLiq8Hjll"
 },
 {
  "Email": "locwal@slt.lk",
  "Name": "Jayatissa De Costa",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nv4h279y1tGk7leWZXMT"
 },
 {
  "Email": "ricardo.duarte@garciabodan.com",
  "Name": "Ricardo Alfredo Duarte Jimenez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nvUWCp2zkEUMZIq9wMuZ"
 },
 {
  "Email": "juan.chackiel@mop.gov.cl.",
  "Name": "Mr Juan Chackiel",
  "Document Name": "PO.BI 2020 CHL_PPP_survey.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nwKTF3BHvZRdxcqHWtzA"
 },
 {
  "Email": "fdegenhardt@whitecase.com",
  "Name": "FLORIAN DEGENHARDT",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nwNVfoZZG1iYlh3skEyX"
 },
 {
  "Email": "vesublessme@live.com",
  "Name": "Mavaetangi Manavahetau",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nx4JFAiQuxfqmwFD3pyq"
 },
 {
  "Email": "bgibson@mccarthy.ca",
  "Name": "Byran Gibson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nxDLwcvhLuURznLubh5G"
 },
 {
  "Email": "kirill.nikitin@ru.pwc.ru",
  "Name": "Kirill Nikitin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nxhU1Wjtr0aeOrbLsxSs"
 },
 {
  "Email": "jcotkin@nossaman.com",
  "Name": "Joan Cotkin",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nyCSd3tocziTCypY6wtT"
 },
 {
  "Email": "VVVasilenko@volgogradcci.ru",
  "Name": "Vladimir Vasilenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nyTrhuEmAXrNxUr4wlIW"
 },
 {
  "Email": "saud.ammari@blakes.com",
  "Name": "Saud Al-Ammari",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/nycLqleBz6Mye8OY9wXC"
 },
 {
  "Email": "pavel.riegger@cz.ey.com",
  "Name": "Pavel Riegger",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o0Tb3riaUOXID2xRDJ4z"
 },
 {
  "Email": "atishwar.pandaram@usp.ac.fj",
  "Name": "Atishwar Pandaram",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o0j6NkRze2DJMcVY7iN4"
 },
 {
  "Email": "rasha.nadeem@bhciq.com",
  "Name": "Rasha Nadeem",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o0qsES7aasYfReIueH8A"
 },
 {
  "Email": "ivana.vragovic@karanovic-nikolic.com",
  "Name": "Ivana Vragovic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o1dK3bWEFF08WUYfqs7m"
 },
 {
  "Email": "nbarakzai@lexferghana.com",
  "Name": "Niamatullah Barakzai",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o1rKy4gDEWs7qXgxIcDZ"
 },
 {
  "Email": "nora.spiegel@austriatech.at",
  "Name": "DI Nora Spiegel",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_Austria_Tech.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o2bcmmdkAk77ErSCJ4hF"
 },
 {
  "Email": "sakamotoy@gtlaw.com",
  "Name": "Yukari Sakamoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o2gujYBN2CMdRuOnpgon"
 },
 {
  "Email": "ilya.nikiforov@epam.ru",
  "Name": "Ilya Nikiforov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o2j2XruQZNhIthj5WVf5"
 },
 {
  "Email": "stefanie.atchinson@squirepb.com",
  "Name": "Stefanie Atchinson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o37UXFGGUjJYIZhcKZLr"
 },
 {
  "Email": "ecsu.planning@gmail.com",
  "Name": "Nesru Awel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o3IzzxuLRIPLdtst8vyS"
 },
 {
  "Email": "Julian.j.murphy@cardno.com.au",
  "Name": "John Marlay",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o4G64UvQ97Y5TFulCYW4"
 },
 {
  "Email": "mdelfino@delfinowillkie.com",
  "Name": "Mr. Maurizio Delfino",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en 2_713406v1_Delfino e Associati Willkie Farr & Gallagher LLP.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o4ILE6wOPoL9x9qVNM82"
 },
 {
  "Email": "john@armstrongs.bw",
  "Name": "Jonh Carr-Hartley",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o5KxHAqFWTbAnnLs4eug"
 },
 {
  "Email": "bowmans@bennettjones.com",
  "Name": "Stephen W. Bowman",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o5myfbmVyM8bwNSn0xhB"
 },
 {
  "Email": "MAMistriukova@volgogradcci.ru",
  "Name": "Marina Vmistryukova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o6J85Omgru2eHyOIQZCW"
 },
 {
  "Email": "tomislav.lucic@hpb.hr",
  "Name": "Tomislav Lucic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o7MiyqZeryRCwCsyNzoh"
 },
 {
  "Email": "Donald@raha.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o7PuqRSoFB66yrsY1QnO"
 },
 {
  "Email": "hvanommen@mccarthy.ca",
  "Name": "Herman Van Ommen",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o7iPAyWhNQdc8zhx3ais"
 },
 {
  "Email": "info@qf.org.qa",
  "Name": "Ahmed Al Muftah",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o8LmRrb3DxkvoyRnCozd"
 },
 {
  "Email": "cpa@louadvokatfirma.dk",
  "Name": "Carsten Palsgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o91pAcSlFfFlI0DFzwp8"
 },
 {
  "Email": "razan.ghamdii@gmail.com",
  "Name": "Ms. Razan Alghamdi",
  "Document Name": "TAGLegal__TPI_survey_en.docx",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/o9lUeSUrkqmCvR1qEyHW"
 },
 {
  "Email": "philippa.wilkinson@meed.com",
  "Name": "Philippa Wilkinson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oA5liKwbN7r8QDdvmHnG"
 },
 {
  "Email": "ben.cowling@clydeco.com",
  "Name": "Ben Cowling",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oABQhRcSDN34Rye153ZT"
 },
 {
  "Email": "diana.minumets@lextal.ee",
  "Name": "Diane Minumets",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oBVm2LN4NNbhzWLep9P5"
 },
 {
  "Email": "jvaca@s-s.mx",
  "Name": "Jair Vaca Avenda�o",
  "Document Name": "S-S-#76697-v1-PPP_SURVEY_2020_wb.doc",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oC7sSSukOxJMOrQ2Qzzt"
 },
 {
  "Email": "direccionejecutiva@icccostarica.com",
  "Name": "Maria Claudia Jim�nez Pajaro",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oCX0z1hc6GhNC3czBcXL"
 },
 {
  "Email": "richard.khoo@skrine.com",
  "Name": "Mr Richard Khoo",
  "Document Name": "MALAYSIA) SKRINE) BI 2020 MYS_bi_PPP_survey_en (Skrine 19 July 2019).docx",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oCfYi2Z7PIZ3DQfWkr4Z"
 },
 {
  "Email": "luismenezes@felsberg.com.br",
  "Name": "Mr. Luis Antonio Menezes da Silva",
  "Document Name": "Survey - PPP - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oCsEDN4T4mo2osJvOnra"
 },
 {
  "Email": "anneliis.lett@sorainen.com",
  "Name": "Annelis Lett",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oDCf54eNJpVmCrinrxIW"
 },
 {
  "Email": "malanco@iconnect.zm",
  "Name": "Vincent Malambo",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oDG3nHPDeduyi6rF6qrY"
 },
 {
  "Email": "ruba.m@hammourilaw.com",
  "Name": "Miss Ruba Madi",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Hammouri.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oDSPQQzQ3tbOJawL9KBf"
 },
 {
  "Email": "info@astuteattorneys.com",
  "Name": "Neema Lwise Kileo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oDUqbEa24U3p65iqeNiT"
 },
 {
  "Email": "d.g.clifford@bangor.ac.uk",
  "Name": "Gary Clifford",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oDop6gDMkASy0WJ3dY3b"
 },
 {
  "Email": "dvillafranca@consortiumlegal.com",
  "Name": "Daniela Villafranca Lamas",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oERzOfU8BCubS42ispGe"
 },
 {
  "Email": "a.okolo@icrc.gov.ng",
  "Name": "title Akwu Okolo",
  "Document Name": "NIGERIA) ICRC) WORLD BANK TPI QUESTIONNIAIRES.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oFeAV4TPRvZAwzkNQCtA"
 },
 {
  "Email": "mromoff@pppcouncil.ca",
  "Name": "Mark Romoff",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oGIiKrd7NxN3WizDNxUH"
 },
 {
  "Email": "info@hml.com.kh",
  "Name": "Ms. Leap Kang",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en_HML1.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oGKDWT0hgEhnYdl1VqDz"
 },
 {
  "Email": "kateryna.oliynyk@asterslaw.com",
  "Name": "Ms Kateryna Oliynyk",
  "Document Name": "BI_2020_UKR_bi_PPP_survey_en_Asters.DOCX",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oH5DfFi21px6gbOVwHGu"
 },
 {
  "Email": "bgultekin@morogluarseven.com",
  "Name": "Mr. Bahadr G�ltekin",
  "Document Name": "182807 - 1 - BI 2020 TUR_bi_PPP_survey_en (ID 182807).doc",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oHZ3apOpu2eOdD7Veara"
 },
 {
  "Email": "contact@dradamlawfirm.com",
  "Name": "Mohamed Adam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oHzZv1oLEp2H2JYIm4eq"
 },
 {
  "Email": "sabar@sabar.org.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oI91jUEOYR9A2lLmBcsi"
 },
 {
  "Email": "pbeauchemin@tremblaybois.qc.ca",
  "Name": "Patrick Bauchemin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oIik2FVqC4vTeTB128Hb"
 },
 {
  "Email": "araratbank@araratbank.am",
  "Name": "Davit Harutyunyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oJoClXdS6jVPGgxlwMJo"
 },
 {
  "Email": "paco@carreirapitti.com",
  "Name": "Francisco Carreira-Pitti",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oJu8CEmGmXKlo0VAZk5V"
 },
 {
  "Email": "renato.almeida@mirandalawfirm.com",
  "Name": "Mr Renato Guerra de Almeida",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_en(230330.1).docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oKeDaP6DbIXSHsX58cJF"
 },
 {
  "Email": "info@headrick.com.dp",
  "Name": "Dr. Mary Fern�ndez",
  "Document Name": "Survey World Bank - Benchmarking Infrastructure - Final (00780110xA22EA).DOCX",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oKhjfgRIcF2qFxE70c0a"
 },
 {
  "Email": "info@yotekconsruction.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oKkF8WRwgSdbupc5ejma"
 },
 {
  "Email": "mika.lehtimaki@thetrust.fi",
  "Name": "Mr. Mika Lehtim�ki",
  "Document Name": "FINLAND) TRUST) BI 2020 FIN_bi_PPP_survey_en, Mika Lehtim�ki 21082019.docx",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oL2gWWnLwWVxIkPGTc69"
 },
 {
  "Email": "nurshat@siar-consult.com",
  "Name": "Nurshat Karabashov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oL53DgPU8YywED2NeKRI"
 },
 {
  "Email": "fmassena@ucm.ac.mz",
  "Name": "Fern�o Magalh�es Massena",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oLFEaAJYLH7XyQI5QAd2"
 },
 {
  "Email": "karen@ilg.am",
  "Name": "Karen Petrosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oLqg45Y85H8vACV4euTx"
 },
 {
  "Email": "dhrkac@kpmg.com",
  "Name": "Domagoj Hrka?",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oMH2qFMw0ZwJ2dsNuS7a"
 },
 {
  "Email": "swatson@carillion.ca",
  "Name": "Stephen Watson",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oMdNoMFIM5c1oFbh8Eyj"
 },
 {
  "Email": "kadri.kallas@tgsbaltic.com",
  "Name": "Kadri Kallas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oNjq0szwO1LKlvk8iH08"
 },
 {
  "Email": "mark.paterson@burges-salmon.com",
  "Name": "Mark Paterson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oO18LjgYMlvQcxrAXEXp"
 },
 {
  "Email": "raluca.marcu@bpv-grigorescu.com",
  "Name": "title Raluca Marcu",
  "Document Name": "ROM _bi_TPI_survey_en_bpvGS.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oODbeKwP7Mu8EvNcFyLC"
 },
 {
  "Email": "hamish.bolland@chapmantripp.com",
  "Name": "Mr Hamish Bolland",
  "Document Name": "BI_2020_TON_bi_PPP_survey_en_TOM PEMBERTON.doc",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oONgmvTstCSNM3E0iWyA"
 },
 {
  "Email": "oleksandr.kurdydyk@dlapiper.com",
  "Name": "Mr Oleksandr Kurdydyk",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_eng final_Soroka_Kateryna.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oQ4mgnMsHdEnef9N0roo"
 },
 {
  "Email": "Gabriel.Golomb@moital.gov.il",
  "Name": "Gabriel Golomb",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oRBgZ4xli8agAyEp9AQ9"
 },
 {
  "Email": "lourdes@matapitti.com�",
  "Name": "Lourdes Pitti Sagrera",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oRHBdORq0adbJllCdC8l"
 },
 {
  "Email": "jackie.midlane@nortonrosefulbright.com",
  "Name": "Jackie Midlane",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oRoJzLAQ78shKC0ds4kS"
 },
 {
  "Email": "samuel.tohui@posman.com",
  "Name": "Samuel Tohui",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oS83oWltTWvQEZmoIzUK"
 },
 {
  "Email": "ccamacho@jcscaribbeanlaw.com",
  "Name": "Cecil Camacho",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oSKcOKVSv5kPiyHKyJqD"
 },
 {
  "Email": "eganyan@vegaslex.ru",
  "Name": "Albert Eganyan",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oT5Pu5iJRNEt2Rps3K4y"
 },
 {
  "Email": "gvlfirm@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oVDbQXRLOdfE1FW0R79d"
 },
 {
  "Email": "VVVasilenko@volgogradcci.ru",
  "Name": "Vladimir Vasilenko",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oVvaILbnr3xyziLtjGbp"
 },
 {
  "Email": "partners@moribamematthews.co.bw",
  "Name": "Kgaotsang Matthews",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oW4keuYyGxJPUrKA7UWK"
 },
 {
  "Email": "archava@lacllaw.com",
  "Name": "Archava Smuthranond",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oW8owpclIqzwYG62eDxv"
 },
 {
  "Email": "aguibert@deloitte.com",
  "Name": "Mr Armando Guibert",
  "Document Name": "01. BI 2020 ARG_bi_PPP_survey_en.doc",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oXIxiiKpmw2R5RvEBiMs"
 },
 {
  "Email": "sjaffa@barlaw.co.il",
  "Name": "Simon Jaffa",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oXhCCXo3Mcx4u8K4YpT2"
 },
 {
  "Email": "contacto@drgilbertoboutin.com",
  "Name": "Gilberto Boutin Icaza",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oXjEUnAEwu4g39RcPPuB"
 },
 {
  "Email": "fpi@fedpac.to",
  "Name": "Mele Saini Koloi",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oYly3sjMXs7yUngZOlRo"
 },
 {
  "Email": "julian.johansen@allenovery.com",
  "Name": "Julian Johansen",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oZ7Rzyk4scvuzfPqTzvZ"
 },
 {
  "Email": "lhmoreno@afra.com",
  "Name": "Mr, Luis H. Moreno",
  "Document Name": "BI 2020 PAN_bi_PPP_survey_en1.docx",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oa7V91aytjDFAQlvAjY3"
 },
 {
  "Email": "info@somalichamber.so",
  "Name": "Mohamoud Abdi Ali",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oaSBxW2o3W5FrCHtHfQ0"
 },
 {
  "Email": "KSmith@monckton.com",
  "Name": "Kassie Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oafbToFafyTqV9KcC6hZ"
 },
 {
  "Email": "korsholm@hvr.dk",
  "Name": "Frank Korsholm",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ocRSw8qtROcg7rGOM6wl"
 },
 {
  "Email": "courtenay.williams@tt.lexcaribbean.com",
  "Name": "Courtenay Williams",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/odPWi7XNoUq3Ak14kFKb"
 },
 {
  "Email": "richard.budge@dentons.com",
  "Name": "Richard Budge",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/odhd9kBU1iPvax6bJFsm"
 },
 {
  "Email": "anuralokuhetty@serenepavilions.com",
  "Name": "Anura Lokuhetty",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oe5uYUvYn6xuihegppQm"
 },
 {
  "Email": "kokusai@tokyo-cci.or.jp",
  "Name": "Akio Mimura",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oeMCQR2IBORvebI0Ud5q"
 },
 {
  "Email": "christian@roedl.pro",
  "Name": "Christian Rodl",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oeVf5yoY6UPFS22DlBfn"
 },
 {
  "Email": "phil.bentley@mitie.com",
  "Name": "Phil Bentley",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oeXQjZS1lS2tH3zBXCtA"
 },
 {
  "Email": "tmostert@mostertlaw.com",
  "Name": "Tony Mostert",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ogOpiYpFkShGCHB2U98U"
 },
 {
  "Email": "cilla_benjamin@sta.uwi.edu",
  "Name": "Cilla T. Benjamin",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ogj1cvNwMWPkhiedFp9K"
 },
 {
  "Email": "alabyath@yahoo.com",
  "Name": "Khawla Rasheed Al-Abyadh",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ohfTay8g3QjA16D1uuXZ"
 },
 {
  "Email": "ramonlimac@limayasociados.com",
  "Name": "Ram�n Lima",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oi8RJahpeem8sQAQq9ge"
 },
 {
  "Email": "sophie.nyombi@bowmanslaw.com",
  "Name": "Sophie Nyombi",
  "Document Name": "UGANDA) ABMAK) BI 2020 UGA_bi_PPP_survey_en-2.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oiS74A7QsxK4wrO8ir4e"
 },
 {
  "Email": "jana.filkova@camic.cz",
  "Name": "Jana Filkov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/okpvqn8EBDTqy1UwDLuu"
 },
 {
  "Email": "Sbusiso.Maseko@hsf.com",
  "Name": "Sbusiso Maseko",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/omkG2QdzDgPNK9ILsofg"
 },
 {
  "Email": "evelinb@s-horowitz.com",
  "Name": "Yehoshua Horesh",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oni48AhatMRtn5dkAZ4Y"
 },
 {
  "Email": "costarica_subanco@davivienda.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oo1N9Sr1XGod34hSE3E5"
 },
 {
  "Email": "frappier.martial@constructionsedb.com",
  "Name": "Martial Frappier",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ooHWLhn22msgmizJx0Hk"
 },
 {
  "Email": "jerome.buzenet@dfdl.com",
  "Name": "Mr. Jerome Buzenet",
  "Document Name": "VIETNAM) DFDL) BI 2020 VNM_bi_PPP_survey_en (02August19).docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oorBLfXIbZmgNkcOoFvg"
 },
 {
  "Email": "chris.mitchell@au.kwm.com",
  "Name": "Chris Mitchell",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/opB3dOgvcttuQUZbAP7b"
 },
 {
  "Email": "aadeboye@sololaakpana.com",
  "Name": "Mr Ademola Adeboye",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank PPP Survey.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/opU9P6U5k5ZFh3l5ccEQ"
 },
 {
  "Email": "muenster@baumeister.org",
  "Name": "Martin Beckmann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oqJk8HDa96KRFsTFCXYT"
 },
 {
  "Email": "zamsalem@kpmg.com",
  "Name": "Zion Amsalem",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oqKeKOryznctGiQMLY43"
 },
 {
  "Email": "frederico@azevedosette.com.br",
  "Name": "Ms Bruna Bouissou",
  "Document Name": "Bruna - BI 2020 BRA_bi_PPP_survey_en Done.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oqPCCwkATnFTTMDKKu9C"
 },
 {
  "Email": "Thomas.Hamerl@cms-rrh.com",
  "Name": "Mag Thomas Hamerl",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_CMS.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oqPMKOP4wvz5Oqld2xK6"
 },
 {
  "Email": "info@traesa.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oqaAH316hV0mcNkjUDVG"
 },
 {
  "Email": "mozahemkhalaf@eversheds-sutherland.com",
  "Name": "Mozahem Khalaf",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/or0MXEEnXmPeqKloJZIW"
 },
 {
  "Email": "bronock.reid@tt.lexcaribbean.com",
  "Name": "Bronock Reid",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ort7RWImYeWs7BHrqyAI"
 },
 {
  "Email": "asako.murata@freshfields.com",
  "Name": "Asako Murata",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/osdMRul9q7XCRzHkuAxm"
 },
 {
  "Email": "martin.irwin@nortonrosefulbright.com",
  "Name": "Martin Irwin",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/osstPPJnsFPsQYCfpBHB"
 },
 {
  "Email": "raul.siem@hansalaw.ee",
  "Name": "Raul Siem",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/otGIoNd9AnLARwC16Jrr"
 },
 {
  "Email": "chauee.lee@cn.kwm.com",
  "Name": "Chau Ee Lee",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/otGXZg1G9iH5qY97BstM"
 },
 {
  "Email": "kmorrow@jacmac.com.au",
  "Name": "Kate Morrow",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/otTSilDaGUZNa2XI2NDa"
 },
 {
  "Email": "n.pazusiene@cpva.lt",
  "Name": "Mrs. Neringa Pazusiene",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en (NP)_2018.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/otbAv1NJd5qicF2mjtoo"
 },
 {
  "Email": "procurement@hbkcontracting.com",
  "Name": "R. Venkatesan",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/otluagJGt1NiJlr1a24m"
 },
 {
  "Email": "borodkin@vkp.ua",
  "Name": "Mr Alexander Borodkin",
  "Document Name": "BI 2020 UKR_bi_TPI_survey2_en_Vasil Kisil & Partners.doc",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ouroZ3ChIy3E53gB0kYL"
 },
 {
  "Email": "lior@zelpel.com",
  "Name": "Lior Oren",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ov5uNobZZUEO087NlZ0A"
 },
 {
  "Email": "guido.ajello@pwc.com",
  "Name": "Mr. Guido Ajello",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/owIqa398FaI6aELmluF5"
 },
 {
  "Email": "fmandlate@kpmg.com",
  "Name": "Filipe Mandlate",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/owm4OapQ3BEsBk3sK8v4"
 },
 {
  "Email": "helfer@mega.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oxOjhA0wyfK6fAJZMvcI"
 },
 {
  "Email": "nmarshall@lawsonlundell.com",
  "Name": "Neil Marshall",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oxXLg2DLcVsu7ZFCPJz4"
 },
 {
  "Email": "Navika_ast@list.ru",
  "Name": "????????? ?????? ?????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oxo7ruv1RFIwfH3tkmnM"
 },
 {
  "Email": "crown-duke@sdnp.org.mw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oxogMig0i08HFjvJjXXR"
 },
 {
  "Email": "jchin@hwle.com.au",
  "Name": "Joyce Chin",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyBUfDqTiPF4QRtBlb28"
 },
 {
  "Email": "vnoriega@vvgm.com",
  "Name": "Vanessa Noriega Cano",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyEzPDamPeJB74s7wFx2"
 },
 {
  "Email": "kibuta.ongwamuhana@akolaw.com",
  "Name": "Kibuta Ongwamuhana",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyLriLjRMb8leWHsgfxP"
 },
 {
  "Email": "charles.morrison@dlapiper.com",
  "Name": "Charles Morrison",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyvVEpGPA7a9ZpK74lSQ"
 },
 {
  "Email": "Brigette.Baillie@hsf.com",
  "Name": "Brigette Baillie",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oywmgHtkMV1LtDXPSnEw"
 },
 {
  "Email": "mikhail.marinin@integrites.com",
  "Name": "Mikhail Marinin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyyi0G9Apc8XdvKek4op"
 },
 {
  "Email": "gustavo.magalhaes@fialhosalles.com.br",
  "Name": "Dr Gustavo Magalhães",
  "Document Name": "2 BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/oyzqw314Vg3mpdxad3N2"
 },
 {
  "Email": "ramahq@ramaconstructionplc.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p04yjBoE26PU9445bPHE"
 },
 {
  "Email": "Jeremy.Garson@hsf.com",
  "Name": "Jeremy Garson",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p0UpaqHNifbQqXwxOjFy"
 },
 {
  "Email": "youngj@brookfields.co.nz",
  "Name": "John Young",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p0VuGzhDoxLnyls7BFio"
 },
 {
  "Email": "info@jittuhorticulture.com",
  "Name": "Sheikh Mohammed Hussein Al-Amoudi",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p0lodJPZbpAdn5y2b4tA"
 },
 {
  "Email": "gerald.jennings@leedschamber.co.uk",
  "Name": "Gerald Jennings",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p1E2vUCvIE664DIlxVIf"
 },
 {
  "Email": "robert.thoms@hejailanlaw.com",
  "Name": "Robert Thoms",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p29AtBFgIKcU92EFwYUI"
 },
 {
  "Email": "lance.brasher@skadden.com",
  "Name": "Lance Brasher",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p3OzcWrPiQYZFtKzkJ67"
 },
 {
  "Email": "malalene@justice.com",
  "Name": "Antonio Malalene",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p3VnVdIcCENqlFG7TCzc"
 },
 {
  "Email": "salimuassociates@malawi.net",
  "Name": "Ambokire Salimu",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p3Wwjdbri2iHLxJpLKI6"
 },
 {
  "Email": "tamao.fujimoto@sidley.com",
  "Name": "Tamao Fujimoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p3eCJwS2n47Y4pLgIYzY"
 },
 {
  "Email": "dmc@legalmca.com",
  "Name": "Mr. Duarte Marques da Cruz",
  "Document Name": "BI 2020 AGO_bi_PPP_survey_en Angola_ MC&A.docx",
  "Country": "AGO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p4Kl9p70usrEK8mL5vTe"
 },
 {
  "Email": "yasuo.okamoto@hugheshubbard.com",
  "Name": "Yasuo Okamoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p6z6M5XPJcmjpbu5gLLE"
 },
 {
  "Email": "shinji.mizuno@hibiyapark.net",
  "Name": "Shinji Mizuno",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p7LA0lBfRe7FS7FRu96L"
 },
 {
  "Email": "info@thefirmva.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p8BKMFidJM8KT1ruunm6"
 },
 {
  "Email": "fkastner@goerg.de",
  "Name": "FRANZISKA KASTNER",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p8OUU00iOGtlr2fdUsdj"
 },
 {
  "Email": "bbasheka@yahoo.co.uk",
  "Name": "Basheka C. Benon",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p8aBK7KdCI5bMR6OS3Nw"
 },
 {
  "Email": "francis@craigconstruction.ws",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p8jWLOqIBSGletMwb4eP"
 },
 {
  "Email": "nick.helm@dlapiper.com",
  "Name": "Nick Helm",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p8wbAMb6rysc050yhhat"
 },
 {
  "Email": "mamaya@latamlex.com",
  "Name": "Jensy Melissa Amaya Pastrana",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p9rQ8jxw2MEETRcK1XDL"
 },
 {
  "Email": "rob.fitzgibbons@dfdl.com",
  "Name": "Robert Fitzgibbons",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/p9xNpbehLza5WkB8n9dL"
 },
 {
  "Email": "atp@ukservice.kz",
  "Name": "Vladislav Zinevich",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pA0Aczf8sBvp7KHuSnES"
 },
 {
  "Email": "kamemiya@mofo.com",
  "Name": "Kei Amemiya",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pABX1prkTspiLF8hmcTt"
 },
 {
  "Email": "kart.saar@lextal.ee",
  "Name": "Kart Saar",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pAcBcA8QvFAYNSj2Fp9i"
 },
 {
  "Email": "vaughn@ceal2005.com",
  "Name": "Vaughn Lezama",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pB0ooRUrKiDnvrDGDU7X"
 },
 {
  "Email": "gchasse@tremblaybois.qc.ca",
  "Name": "Gabriel Chasse",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pBBj7Uj8lwUb45GNu0Ri"
 },
 {
  "Email": "ssambri@grimaldilex.com",
  "Name": "Mr. Sergio Massimiliano Sambri",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Matteo Trabacchin.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pBhf0xjiNXirmgosb2vu"
 },
 {
  "Email": "mila.selak@ostermann.hr",
  "Name": "Mila Selak",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pC2YeUP72e2IXhHqZJub"
 },
 {
  "Email": "counsel@legal.am",
  "Name": "Haik Harutiunian",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pDcwfPMLmQO8QRKcwKyU"
 },
 {
  "Email": "k.filip@optima-al.com",
  "Name": "Mrs. Kristiana Filip",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en_Optima.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pDlgHerVmqqnWUnonTtQ"
 },
 {
  "Email": "denis.kachkin@kachkin.ru",
  "Name": "Denise Kachkin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pFtXywTZDa013ATpJzwi"
 },
 {
  "Email": "mzuzu.servicecentre@nbs.mw",
  "Name": "Felister Dossi",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pG6fuAg1dU7BGfHg5fo4"
 },
 {
  "Email": "abnolawi@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pGn68vPmj6CfiZnXNR38"
 },
 {
  "Email": "mart.nomper@roedl.ee",
  "Name": "Mart N�mper",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pH0DtfB4cl13DgmuJlYt"
 },
 {
  "Email": "kefelegnn@yencomad.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pH7rg3zJWiiPXATFljbR"
 },
 {
  "Email": "jhernandezw@johersa.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pHnNPLTCGlmlcDSzH4KM"
 },
 {
  "Email": "joe.cosma@za.ey.com",
  "Name": "Mr Joe Cosma",
  "Document Name": "MALAWI) ENY) BI 2020 MWI_bi_PPP_survey_en_ey.docx",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pIMSBMWRyPTAGQxJYOmY"
 },
 {
  "Email": "M.Taher@Tamimi.com",
  "Name": "Mr. Mohammmed Taher",
  "Document Name": "BI 2020 IRQ_bi_PPP_survey_en_Norri.docx",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pIhsypTyi12llLUUPjsn"
 },
 {
  "Email": "info@astuteattorneys.com",
  "Name": "Neema Lwise Kileo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pJRBovItMn1LaRlz4Kij"
 },
 {
  "Email": "azra.zaimovic@efsa.unsa.ba",
  "Name": "Azra Zaimovic",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_PO.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pK9caau5GUT6kF20L63X"
 },
 {
  "Email": "cliff.inskip@cibc.ca",
  "Name": "Cliff Inskip",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pKPQjW6XpH9vfqB58f0O"
 },
 {
  "Email": "Lnpillai@upng.ac.pg",
  "Name": "Lekshmi Pillai",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pKSXird0U9dxVFpNQ0qn"
 },
 {
  "Email": "peter.grigg@altusgroup.com",
  "Name": "Peter Grigg",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pLI5yvEm7hhCzArbDE6g"
 },
 {
  "Email": "request@clasconsult.com",
  "Name": "Chrispin Wilson",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pLfhdHj5S9qPX6lvwPLK"
 },
 {
  "Email": "michael.yoshii@lw.com",
  "Name": "Michael Yoshii",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pM0AX0OtPZOGdlmDlCTN"
 },
 {
  "Email": "ekeller@modernizacion.gob.ar",
  "Name": "Eric Keller last name",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_en 9.10.19.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pMusCcEmkphcTdHUsn3s"
 },
 {
  "Email": "alopez@aczalaw.com",
  "Name": "Ms Armida Lopez",
  "Document Name": "BI 2020 HND_bi_PPP_survey_enACZALAW.docx",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pN4hUv4dAn5QEoiXAmGT"
 },
 {
  "Email": "kirchner@berettagodoy.com",
  "Name": "Mr. Carlos Kirchner",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_BN2 (FG).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pNB0cFIZBsqAhUxssIif"
 },
 {
  "Email": "gerald.baladi@mcmillan.ca",
  "Name": "Gerald A. Badali",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pNmo8LMOLhfkUZBBGckn"
 },
 {
  "Email": "stgugushev@gugushev.com",
  "Name": "Mr. Stephan Gugushev",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_Gugushev&Partners_adjusted..docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pODbp8s7iVRVfisblSqC"
 },
 {
  "Email": "tesfubery@yahoo.com",
  "Name": "Tesfaye Berhe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pPez6kXrAOEQfmVVeLXM"
 },
 {
  "Email": "grant.goldsmith@ah.co.nz",
  "Name": "Grant Goldsmith",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQ0b8HbCSgYQKis429BN"
 },
 {
  "Email": "nshkordoff@fasken.com",
  "Name": "Nick Shkordoff",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQ5l4wUEX5InI5GgVrL5"
 },
 {
  "Email": "manuel.a.neves@abreuadvogados.com",
  "Name": "Mr. Manuel Andrade Neves",
  "Document Name": "Questionnaire PPP WB 2020 12.07.2019.DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQIYmop3P7kFSn3mAnAG"
 },
 {
  "Email": "info@dbm.mn",
  "Name": "Mr Gankhuyag Jamts",
  "Document Name": "MONGOLIA) DEVELOPMENT BANK) BI 2020 MNG_bi_PPP_survey_en.docx",
  "Country": "MNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQIkFjN53ncBwc4ASadC"
 },
 {
  "Email": "intombela@minchinkelly.bw",
  "Name": "Isaac Ntombela",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQU0dMKy6mkdxBkBNEOx"
 },
 {
  "Email": "conansa@conansa.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pQW0YtZubEByBRKvz3y3"
 },
 {
  "Email": "Info@mbaincorporated.co.za",
  "Name": "Michael Motsoeneng",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pRQ98sFAhFTysPjwrlQt"
 },
 {
  "Email": "cbailey@kslaw.com",
  "Name": "Christopher Bailey",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pRTdbBvh5FjkwjuO7vc0"
 },
 {
  "Email": "chinchuan.chen@ashurst.com",
  "Name": "Chin Chuan Chen",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pS7bOAt9sddulhpN9kob"
 },
 {
  "Email": "cuestan.law@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pUN76J3nFlKhBnlJqcrz"
 },
 {
  "Email": "terence.ng@dlapiper.com",
  "Name": "Terrence Ng",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pW9RoRaMWfj9HQs1QNa8"
 },
 {
  "Email": "chong.yeeleong@allenandgledhill.com",
  "Name": "Chong Yee Leong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pWO588nt63PNlO1RvjGU"
 },
 {
  "Email": "monica.reig@esade.edu",
  "Name": "Ms M�nica Reig",
  "Document Name": "NEW_BI 2020 ESP_bi_PPP_survey_en.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pWzBabzeqvAxTNfyPiVe"
 },
 {
  "Email": "tomas@avilaco.com",
  "Name": "Tom�s M. �vila",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pXARhfMGSTMtnBKfAaZw"
 },
 {
  "Email": "eldor.mannopov@dentons.com",
  "Name": "Mr. Eldor Mannopov",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Dentons_Counsel.DOCX",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pXoi3ktZWY76PhdG8e2X"
 },
 {
  "Email": "chukwunedum.orabueze@uubo.org",
  "Name": "Mr Chukwunedum Orabueze",
  "Document Name": "NIGERIA) UUBO) BI 2020 NGA_bi_TPI_survey_en (UUBO Contribution) 15082019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pY0Mv2gsCqq9hOfhGuVN"
 },
 {
  "Email": "gcambule@abcc.co.mz",
  "Name": "Gil Cambule",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pYP2M6emmlLVo5rZ6tKY"
 },
 {
  "Email": "zalfarisi@kslaw.com",
  "Name": "Zaid Hadir Al-Farisi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pZFb03Mhf07Bw5r9uHdi"
 },
 {
  "Email": "acastorino@ristuf.it",
  "Name": "Mr Antonino Castorino",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_RandT.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pZO0M94CzOrO6Exqte6R"
 },
 {
  "Email": "rangugnig@jefatura.gob.ar",
  "Name": "title Guido Rangugni",
  "Document Name": "BI 2020 ARG_bi_TPI_survey_DNIP.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pZn3mt2a6WuQGdk8Y9J6"
 },
 {
  "Email": "meinrad@dsouza.co.tz",
  "Name": "Meinrad D'Souza",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/paIJ4AwAfuvG4RQgcihF"
 },
 {
  "Email": "tim.briggs@hsf.com",
  "Name": "Tim Briggs",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/paemKUHFkb2M1m2Nm69O"
 },
 {
  "Email": "fmidence@lexicnorp.com",
  "Name": "Mr. Fernando Midence-Mantilla",
  "Document Name": "BI 2020 NIC_bi_PPP_survey_en.docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pb5UTy1ZwY8mZdeZ24j2"
 },
 {
  "Email": "acmanguiat@santiagolaw.com.ph",
  "Name": "Anthony C. Manguiat",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pb6RQEDYCsl5fLWJ8kzC"
 },
 {
  "Email": "gastorn.kennedy@mkono.com",
  "Name": "Kennedy Gastorn",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pbOEZHlvNpCbv3TYnKob"
 },
 {
  "Email": "fsantacruz@ritch.com.mx",
  "Name": "Mr. Federico Santacruz",
  "Document Name": "MEXICO) RITCH MUELLER) RMDOCS-#294303-v4-World_Bank_TPI_Survey_(2020).doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pboqZvoxhL4NxbXgIFoF"
 },
 {
  "Email": "gertrude.basiima@finance.go.ug",
  "Name": "Ms. Gertrude A Basiima",
  "Document Name": "BI 2020 UGA_bi_PO_MoFE_TPI_survey_en.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pcZSYxpu5q1s73aMkZ5p"
 },
 {
  "Email": "lahzz@dg.mitsui.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pcyduusuU47RroYfPuGc"
 },
 {
  "Email": "lucywayne@lwalegal.com",
  "Name": "title Lucy Wayne MBE",
  "Document Name": "BI 2020 MMR_bi-TPI-survey-en LWA d1kb23Jul19.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pczfJTBXQgkmtyzlAQcr"
 },
 {
  "Email": "Lysenko@aequo.ua",
  "Name": "Mr. Denis Lysenko",
  "Document Name": "BI 2020 2 UKR_bi_PPP_survey_en_AEQUO.docx",
  "Country": "UKR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pdEjgwXqyce3XhBUq8YV"
 },
 {
  "Email": "sergi.kapanadze@tsu.ge",
  "Name": "Sergi Kapanadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pdh6QUwiWc99HFXNnkW9"
 },
 {
  "Email": "michael.kennedy@tii.ie",
  "Name": "Michael Kennedy",
  "Document Name": "BI 2020 IRL_bi_PPP_survey_en_TII.docx",
  "Country": "IRL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pe1t4s8RTeeu3wvm8uIq"
 },
 {
  "Email": "sdubovik@deloitte.ru",
  "Name": "Sergey Dubovik",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pfw4gPmK7yAXjkVFf1dy"
 },
 {
  "Email": "lbam@deloitte.co.za",
  "Name": "Lwazi Bam",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pgTkukojPzuvh6uHWQed"
 },
 {
  "Email": "whw@bdplaw.com",
  "Name": "W.H Bill Winters",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/phbEQMo7OoHxknk9JwGV"
 },
 {
  "Email": "bquinn@granite.bm",
  "Name": "Brian Quinn",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/phyeLy4fOzCadL6ZXm2K"
 },
 {
  "Email": "grodriguez@roblesmiaja.com.mx",
  "Name": "Mr. Gustavo Rodriguez",
  "Document Name": "MEXICO) ROBLES MIAJA) BI 2020 MEX_bi_TPI_survey_en (ROBLES MIAJA).docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pjHmzij79u9YNQ1uEuzs"
 },
 {
  "Email": "kefelegnn@yencomad.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pjipvNpyMpoRrgyILt2b"
 },
 {
  "Email": "rodnei.iazzetta@ldr.com.br",
  "Name": "Mr. Rodnei Iazzetta",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pjtwmtZDUqGESBHmrpWA"
 },
 {
  "Email": "jon.dyson@fticonsulting.com",
  "Name": "Jon Dyson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/plghLuHS0P1j4dwaNBOi"
 },
 {
  "Email": "circe.batista@durlinglaw.com",
  "Name": "Circe Batista",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pnXbICIJ8dzRPYCATYnO"
 },
 {
  "Email": "gciufo@deloitte.ca",
  "Name": "Gianni Ciufo",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pnjqDbvDcbk03ZBV3DWk"
 },
 {
  "Email": "e.battioli@zbv.com.ar",
  "Name": "Mr. Emilio Battioli",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en EB2 F.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/poALSl6r7NjpfNvnG9mh"
 },
 {
  "Email": "svetlana.sorkina@hoganlovells.com",
  "Name": "Svetlana Sorkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/poIkPi1wNitAjYfkEJPk"
 },
 {
  "Email": "garuna@arminco.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/poXWAOOoA1bYI30bJqWj"
 },
 {
  "Email": "malcolm.shackell@au.pwc.com",
  "Name": "Malcolm Shackell",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ppgOWoyH25fvM1lOwJGm"
 },
 {
  "Email": "salingslaw@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pqBLScXYzG6fvZqvvED1"
 },
 {
  "Email": "jjh@fitzwilliamstone.com",
  "Name": "Jeffrey Herrera",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pqBaUeAV7z03lTbOzhut"
 },
 {
  "Email": "annisa.tharian@makarim.com",
  "Name": "Ms Annisa Ramadhani Tharian",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Makarim_v2.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pqCzIRJd3d1VFlAjcJNM"
 },
 {
  "Email": "info@afsajic.com",
  "Name": "Ms. Milica Karadza",
  "Document Name": "BI 2020 BIH_bi_PPP_survey_en_Sajic.docx",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pqKK6qOk40EMqn1NbB9u"
 },
 {
  "Email": "pallen@pernixgroup.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/psbRzB5mBp9Ky9DTvvJj"
 },
 {
  "Email": "info@nbg.gov.ge",
  "Name": "Evelina (Eka) Sulava",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pt2MTab30mXsW80nreec"
 },
 {
  "Email": "camara@camara-comercio.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ptWpdtMJhBqlxxlZqAmN"
 },
 {
  "Email": "jgriffiths@minchinkelly.bw",
  "Name": "John M. Griffiths",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ptgFgUriK096bIKpmjox"
 },
 {
  "Email": "josine.wynberg@minterellison.com",
  "Name": "Josine Wynberg",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pw3AXzNmgSSsXTdhQFIH"
 },
 {
  "Email": "info@mvgslaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pxGLW3yAxEDM0N9KcXH6"
 },
 {
  "Email": "kim.francis@meredithconnell.co.nz",
  "Name": "Kim Francis",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/py0mlX8lH9iXWderkQHO"
 },
 {
  "Email": "prr@flycia.cl",
  "Name": "Mr Paulo Román",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en (3).docxJDR.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/py5yN00DkV8diWgzsYBl"
 },
 {
  "Email": "info@ckandpartners.com",
  "Name": "Michael Imran Kanu",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pyqKIg2B276cW8nIYkvE"
 },
 {
  "Email": "satchu@satchuandzhouand.com",
  "Name": "Samir Satchu",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/pzuMEd7myagw8TQQyqTL"
 },
 {
  "Email": "charles.morrison@dlapiper.com",
  "Name": "Charles Morrison",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q04aZZLpYT5WS4RB5shT"
 },
 {
  "Email": "murilo.jacoby@jacoby.adv.br",
  "Name": "Mr. Murilo Jacoby Fernandes",
  "Document Name": "BRAZIL) JACOBY) BI 2020 BRA_bi_PPP_survey_en-JACOBY.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q0wygqUM6D2p6uxMrUxz"
 },
 {
  "Email": "enquiries@wastemanagement.co.nz",
  "Name": "Mike Winterbottom",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q1vTO8VvIzRmQKcWGmDd"
 },
 {
  "Email": "guys@gkh-law.com",
  "Name": "Guy Steiner",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q2janOVVw4xcUb7FVMSY"
 },
 {
  "Email": "Sergey.Krokhalev@bakermckenzie.com",
  "Name": "Sergey Krokhalev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q2v1KMa4T1xMbXeH0R7m"
 },
 {
  "Email": "info@nplaw.ge",
  "Name": "Ms Nino Kvinikadze",
  "Document Name": "BI 2020 GEO_bi_PPP_survey_en_Nino.docx",
  "Country": "GEO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q2zUMxz01QuRvu7Aq5jp"
 },
 {
  "Email": "MaiTrang.Le@bakermckenzie.com",
  "Name": "Ms. Mai Trang Le",
  "Document Name": "TPI_BakerMcKenzie_Vietnam.DOC",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q31PXCQBgtbIfhnd2RCq"
 },
 {
  "Email": "annaromano@sattaromano.it",
  "Name": "Avv. Anna Romano",
  "Document Name": "TPI- infrastrutture e insediamenti prioritari_ITA_Anna_Romano.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q3RWJAW0kOfBYQ5JuHfo"
 },
 {
  "Email": "naif@saajlaw.com",
  "Name": "Naif Alsabhan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q3zVeqUswi45VEro6hlH"
 },
 {
  "Email": "gvernola@beccarvarela.com",
  "Name": "Mr. Gabriel Vernola",
  "Document Name": "BI 2020 ARG_bi_TPI_ en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q40KJbtQto89LcN8cDxR"
 },
 {
  "Email": "HatemAl-Shammari@eversheds-sutherland.com",
  "Name": "Hatem Al-Shammari",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q44THwAeCuHRg6niQxBx"
 },
 {
  "Email": "gitanjali.bajaj@dlapiper.com",
  "Name": "Gitanjali Bajaj",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q4Ss9FBdfCTOQkAV2zUo"
 },
 {
  "Email": "khealey@afghanppp.org",
  "Name": "Kerry Healey",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q4UIDHsEaAnpncsJquDy"
 },
 {
  "Email": "zuzana.benedigova@fpedas.uniza.sk",
  "Name": "Zuzana Benedigov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q4ubuPYWBHRsxM2uBQTf"
 },
 {
  "Email": "julia.pyke@hsf.com",
  "Name": "Julia Pyke",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q50utoDqEJN26xAXsMD7"
 },
 {
  "Email": "dieu.mai@gleisslutz.com",
  "Name": "Dieu Hong Mai",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q5WSmuQ86tc4WGTW2p1m"
 },
 {
  "Email": "alopez@aczalaw.com",
  "Name": "Ms Armida Lopez",
  "Document Name": "BI 2020 HND_bi_TPI_survey_en.ACZALAW.doc.docx",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q5hjdo3NmIi4p7HTeB3O"
 },
 {
  "Email": "thanlinaung99@gmail.com",
  "Name": "Mr Than Linn Aung",
  "Document Name": "BI 2020 MMR_bi_TPI_survey_en_MOF.docx",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q6C4IbyTW7vJbJvT4xSH"
 },
 {
  "Email": "emp@abreuccadvogados.com",
  "Name": "Dra. Elisa Pereira",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_Abcc_19.7.19.docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q74FkgyNDvOsSzyx8PwD"
 },
 {
  "Email": "david.edwards@edwardslaw.to",
  "Name": "David Edwards",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q7Y1lf0BSfJ87CXueFpy"
 },
 {
  "Email": "h.blignaut@spoor.com",
  "Name": "Herman Blignaut",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q7pSX0XpFtCnIJWJskrl"
 },
 {
  "Email": "thaven.naidoo@pfan.net",
  "Name": "Thaven Naidoo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q7sO3vTzxz5QRF4pkK3d"
 },
 {
  "Email": "Kyasin@kpmg.com",
  "Name": "Khalid Yasin",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q8HNFusufxqpNm9Gp2wh"
 },
 {
  "Email": "friesen@bighornconstruction.ca",
  "Name": "Chris Friesen",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q9H5k6yxWDh33J0aCuyR"
 },
 {
  "Email": "mtsariashvili@blb.ge",
  "Name": "Maya Mtsariashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/q9vp0m3Draz0Gp0azj5N"
 },
 {
  "Email": "paul.mansouri@nortonrosefulbright.com",
  "Name": "Paul Mansouri",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qAJfxqbnx7Y7ZPrr3vDh"
 },
 {
  "Email": "agustin.hurtado@fhlegal.ec",
  "Name": "Agustin Hurtado",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en, MAF.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qALNZ1K3VNR7eIChUFKZ"
 },
 {
  "Email": "zyaqubi@shajjanlaw.com",
  "Name": "Zulaikha Yaqubi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qBGjVMXYuoNEc7NwO64W"
 },
 {
  "Email": "gnwangwu@ratioconsulting.org",
  "Name": "Dr George Nwangwu",
  "Document Name": "NIGERIA) NWANGWU) BI 2020 NGA_bi_PPP_survey [Final].docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qD0FE0sPZQoFs92WPWUu"
 },
 {
  "Email": "henn.eomois@hansalaw.ee",
  "Name": "Henn Eomois",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qD1Df9j8dnHlyq6KSmUg"
 },
 {
  "Email": "rbxarford@manica-malawi.com",
  "Name": "Reiner Barford",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qD5mkOLjwNqGLePHbTq5"
 },
 {
  "Email": "Kaori.Fakazawa@ropesgray.com",
  "Name": "Kaori Fukazawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qDCJetelp4un5AovDbOB"
 },
 {
  "Email": "fitsuma@tadessekiros.com",
  "Name": "Fitsum Andargatchew",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qDQCEHKeBMtrm0L97tew"
 },
 {
  "Email": "tommyp@fcc.co.nz",
  "Name": "Tommy Parker",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qE3usIDZiaGX4a8Ny3Jj"
 },
 {
  "Email": "tauno@lauspartners.ee",
  "Name": "Tauno Maarpu",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qESgLoDJBm13wjjw9sOb"
 },
 {
  "Email": "Reda@mansourlawfirm.com",
  "Name": "Reda Elsayed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qEr7x7U9cHJXmsa6tEQ9"
 },
 {
  "Email": "sboyajian@nossaman.com",
  "Name": "Shant Boyajian",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qG5jAKBGjzZ5K5KpDXtl"
 },
 {
  "Email": "hnarimoto@tmi.gr.jp",
  "Name": "Haruo Narimoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qGurlH1XybVpuZQBTLaq"
 },
 {
  "Email": "dkartiganer@bwslaw.com",
  "Name": "Deborah Kartiganer",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qH7kk2JWH8QVfwbUU2fp"
 },
 {
  "Email": "mark.godfrey@mc.co.nz",
  "Name": "Mark Godfrey",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qKETbfaHNQ5nug1EOgUB"
 },
 {
  "Email": "mackermann@goerg.de",
  "Name": "MARIE ACKERMANN",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qKEWpAqPxsCsHFzBDVCq"
 },
 {
  "Email": "nihal.fonseka@dfccbank.com",
  "Name": "Nihal Fonseka",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qKIkF6QPpGeEfoZPfzzl"
 },
 {
  "Email": "khadija.sijaona@forbixattorneys.co.tz",
  "Name": "Khadija Ngasongwa Sijaona",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qKkDY1Dh3HkwFAHu3V33"
 },
 {
  "Email": "rpaton1@kpmg.com",
  "Name": "Richard Paton",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qMHGamr0Xh97kBz4JSk6"
 },
 {
  "Email": "mark.plenderleith@freshfields.com",
  "Name": "Mark Plenderleith",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qMWQUAe3Bl5MgysIEq8h"
 },
 {
  "Email": "agh@ah.com.au",
  "Name": "Tony Hartnell",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qMeY3sg5xuaNPNOZyOZQ"
 },
 {
  "Email": "gab.onojason@alliancelf.com",
  "Name": "Mr Gabriel Onojason",
  "Document Name": "NIGERIA) ALLIANCE) BI 2020 NGA_bi_TPI_survey_en - ALF RESPONSE.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qMxgZnQ4urxXfHimp1lo"
 },
 {
  "Email": "ha.duong-@ykvn-law.com",
  "Name": "Mrs. Ha Duong Thu",
  "Document Name": "VIETNAM) YKVN) BI 2020 VNM_bi_PPP_survey_en_YKVN_20190816.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qNDzHOJ0zI4WWxcQw8F4"
 },
 {
  "Email": "s.wilkinson@auckland.ac.nz",
  "Name": "Suzanne Jane Wilkinson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qOCcOhXLER1IuxKQwCY9"
 },
 {
  "Email": "binkaaf31@gmail.com",
  "Name": "Mohamud Farah Ali",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qPBlXNflsetsttvrUBat"
 },
 {
  "Email": "kulvech@gmail.com",
  "Name": "Kulvech Janvatanavit",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qPRVAMN6XjLiSVFAYgwK"
 },
 {
  "Email": "marias@talial.com",
  "Name": "Magdalena E. Arias Porras",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qQfU3ZIUjo4ZGtnogckn"
 },
 {
  "Email": "sgarzon@lloredacamacho.com",
  "Name": "Mr Santiago lGarzon",
  "Document Name": "1340025.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qR0JAqbEWPmna4FexSfZ"
 },
 {
  "Email": "frt@kpmg.lk",
  "Name": "M.R Mihular",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qRMUTqtYq6tc71vt6SMO"
 },
 {
  "Email": "marcus.ojaruega@uubo.org",
  "Name": "Mr Marcus Ojaruega",
  "Document Name": "NIGERIA) UUBO) BI 2020 NGA_bi_TPI_survey_en (UUBO Contribution) 15082019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qRPuIKSdZDo7ERcGiZI6"
 },
 {
  "Email": "mafalda.t.abreu@abreuadvog ados.com",
  "Name": "Dra. Mafalda Teixeira de Abreu",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_Abcc_19.7.19.docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qSZrfcVA93SF7O52taWO"
 },
 {
  "Email": "reidt@redeker.de",
  "Name": "Prof Dr Olaf Reidt",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qSlI9tfb55eN0yph3wcH"
 },
 {
  "Email": "luismenezes@felsberg.com.br",
  "Name": "Mr. Luis Antonio Menezes da Silva",
  "Document Name": "Survey - Concession - BRA - World Bank (FeA) (8-29-19).doc",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qTTRKt2XriFgzAgB5hJg"
 },
 {
  "Email": "a.mkrtchyan@avenueconsulting.am",
  "Name": "Armen Mkrtchyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qTWGaLuhxIF9RkMSTsFF"
 },
 {
  "Email": "euan.murray@shepwedd.co.uk",
  "Name": "Euan Murray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qToyOVShZsRwQgPrh2lb"
 },
 {
  "Email": "mearegb@x-calibur.co",
  "Name": "Berhane Meareg",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qTz3KBzZHXq1J8TmfD5a"
 },
 {
  "Email": "premium@ethionet.et",
  "Name": "Ezra Akloge Kebebe",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qUYFST6tKLPw41Vs7q8p"
 },
 {
  "Email": "ahidalgo@lloredacamacho.com",
  "Name": "Mr Andres Hidalgo",
  "Document Name": "1340025.DOCX",
  "Country": "COL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qVpLw8FUKXWbRhHUvk3h"
 },
 {
  "Email": "Michael@elawnet.co.za",
  "Name": "Michael Judin",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qXuiEOR06bQBdDrC7AnO"
 },
 {
  "Email": "emekatay@hotmail.com",
  "Name": "Chukuemeka Cv Taylor",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qacOkmxLAeChpZ517jZs"
 },
 {
  "Email": "setika80@yahoo.com",
  "Name": "Sione Etika",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qanwLonJLIGXHgqAGtcG"
 },
 {
  "Email": "margus.poola@lextal.ee",
  "Name": "Margus Poola",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qax3rPCsvokpYKOVTo2g"
 },
 {
  "Email": "tmilawyers139@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qbSB2ZiOnnWQasUGyfha"
 },
 {
  "Email": "smaqsoudi@shajjanlaw.com",
  "Name": "Shamsi Maqsoudi",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qc02oXHnCyvS89apLYeY"
 },
 {
  "Email": "caiomario@pnm.adv.br",
  "Name": "Mr. Caio Mário Pereira Neto",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial concessão final.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qdXDIUT6zv99XZUyvq51"
 },
 {
  "Email": "hugh.stewart@bakermckenzie.com",
  "Name": "Hugh Stewart",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qddOBpHQ1lqdOu4CI4fA"
 },
 {
  "Email": "silvo.korez@austriatech.at",
  "Name": "Dr. Silvo Korez",
  "Document Name": "BI 2020 AUT_bi_PPP_survey_en_Austria_Tech.docx",
  "Country": "AUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qg68kxBcfacHsrKvsSzO"
 },
 {
  "Email": "jbehr@werksmans.com",
  "Name": "Jonathan Behr",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qgkxZJu5lohAvzKhJkXI"
 },
 {
  "Email": "mirna.lalic@karanovic-nikolic.com",
  "Name": "Mirna Milanovic-Lalic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qhOeb0WoeTmjstAikbev"
 },
 {
  "Email": "tanakakachara1@gmail.com",
  "Name": "Ms Tanaka Kachara",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_Evans Talent Moyo.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qhVUOukJySZ5we8Hfk1I"
 },
 {
  "Email": "Arie.Reich@biu.ac.il",
  "Name": "Arie Reich",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qhqqqqzBlrmtQPHKgGpP"
 },
 {
  "Email": "jonathan.davey@addleshawgoddard.com",
  "Name": "Jonathan Davey",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qjtkgMV0JWa0qt4MkTUe"
 },
 {
  "Email": "naidud@gaasienergia.ee",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qk9K2VjsafiXT7v9hIfX"
 },
 {
  "Email": "abdelaziz.zaki@eldib.com",
  "Name": "Abdelaziz Zaki",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qkjQQf6zedfq6Vh6w2YS"
 },
 {
  "Email": "james.marshall@blplaw.com",
  "Name": "James Marshall",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qlhM4LJak1zdA8mHTWbx"
 },
 {
  "Email": "oaf@ucr.ac.cr",
  "Name": "Isabel Pereira Stone",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qmMLHwmyENgLWMg26KtW"
 },
 {
  "Email": "serrykamalandco@gmail.com",
  "Name": "Abdul F. Serry-Kamal",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qmoetEYSqwhlMtOyYtcu"
 },
 {
  "Email": "g.pasquini@palazzochigi.it",
  "Name": "title Gabriele Pasquini",
  "Document Name": "BI 2020 ITA_bi_TPI_survey_en_review_PMO.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qmp8axHKICFDSmu47Nhi"
 },
 {
  "Email": "paul.mansouri@nortonrosefulbright.com",
  "Name": "Paul Mansouri",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qnrg7rX327dOJWzeWIh5"
 },
 {
  "Email": "james.stewart@kpmg.co.uk",
  "Name": "James Stewart",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qo8pTX0SGDQAw0Ycsgzk"
 },
 {
  "Email": "pfoxlee@kpmg.com.au",
  "Name": "Paul Foxlee",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qoO272q5SgLxMMlE9IyH"
 },
 {
  "Email": "nkpersad@gmail.com",
  "Name": "Nisha K. Pershad",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qpILk1ocMAcbFSMzHLGV"
 },
 {
  "Email": "rubadiri@global.bw",
  "Name": "Tengo Jabavu Rubadiri",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qq6uxJnVSytLBPm7mMEX"
 },
 {
  "Email": "Lfshriyadh@hejailanlaw.com",
  "Name": "Robert Thomas",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qqkS8w3eXH1thyxVJOaX"
 },
 {
  "Email": "charles.bogle@hoganlovells.com",
  "Name": "Charles Bogle",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qqpZvPd1Brl4ejezXuqx"
 },
 {
  "Email": "K.Kashefi@iccima.ir",
  "Name": "Keyvan Kashefi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qrFnzAFRoNYOxwXK80tf"
 },
 {
  "Email": "jason.vanderpoel@allenovery.com",
  "Name": "Jason Van Der Poel",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qrb57pUSYmho1jSLsRmu"
 },
 {
  "Email": "nigel.drew@dlapiper.com",
  "Name": "Nigel Drew",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qsJWlkdgr6lCqBe0sQiR"
 },
 {
  "Email": "nimrod.mkono@mkono.com",
  "Name": "Nimrod Mkono",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qt8NeFeMvQzAAU7NwhmW"
 },
 {
  "Email": "info@drdarabpour.ir",
  "Name": "Mehrab Darabpour",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qtQmTyyenViJFWtzRzFb"
 },
 {
  "Email": "ivan.madriz@durlinglaw.com",
  "Name": "Ivan I. Madriz",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qtm6T7xiueCaww1sXVj1"
 },
 {
  "Email": "info@gjika-associates.com",
  "Name": "Mr Gjergji Gjika",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en - FINAL.doc",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/quJ2o7e2LxmSuLWyYRsk"
 },
 {
  "Email": "nikki.ngiam@wongpartnership.com",
  "Name": "Nikki Ngiam",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/quxZQVtPbVbXF0il8RR2"
 },
 {
  "Email": "debiehg@yahoo.com",
  "Name": "Debebe Haile Gebriel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qvZ2jNgDknjnFhjfPY8I"
 },
 {
  "Email": "vglawmail@vglaw.com.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qvby335rdjSWpZfUtbcD"
 },
 {
  "Email": "craig.anderson@dlapiper.com",
  "Name": "Craig Anderson",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qwlHdj6BoVU2sPSFkbPi"
 },
 {
  "Email": "amr.eldib@eldib.com",
  "Name": "Amr Eldib",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qwzYEJJ1I5MJnQ4zEIHj"
 },
 {
  "Email": "shotad550@yahoo.com",
  "Name": "Shota Dogonadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qx0OPYBIrOWUsfdKYtmd"
 },
 {
  "Email": "kdrefke@orrick.com",
  "Name": "Kyle Drefke",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qyCcNenLEHcCFk8c0OtZ"
 },
 {
  "Email": "acannon@stblaw.com",
  "Name": "Alan Cannon",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/qzzR02xa8NBBRhlyGlFI"
 },
 {
  "Email": "kgaguilar@blplegal.com",
  "Name": "Karla Aguilar",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r02cfeBTnAE8UogSFJE9"
 },
 {
  "Email": "embassies@taxplannercpa.com",
  "Name": "Kathya Parsons",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r0nNzCoWM5hxeYAmSMMW"
 },
 {
  "Email": "m.faupin@slf-qa.com",
  "Name": "Mathieu R. Faupin",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r1zPs98OflEqOoSeieBe"
 },
 {
  "Email": "naomi.horton@ashurst.com",
  "Name": "Naomi Horton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r2d7CvOpV1KOKPLGr5WC"
 },
 {
  "Email": "simon.aaron@sr-law.co.uk",
  "Name": "Simon Aaron",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r4GMZ71a93m9EZSVYVwp"
 },
 {
  "Email": "Steenjensen2009@gmail.com",
  "Name": "Steen Jensen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r4wapxBa8Qtwysqom6yt"
 },
 {
  "Email": "gary.reader@kpmg.co.uk",
  "Name": "Gary Reader",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r53WaMh83nA7YGSgOXvb"
 },
 {
  "Email": "pat@arapnishi.com.br",
  "Name": "Ms. Patricia Levy",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en.doc.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r5g0n4peehd9kPH2u08G"
 },
 {
  "Email": "nchima@nchito.co.zm",
  "Name": "Nchima Nchito",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r6e6a7orRrqeXKuTOto4"
 },
 {
  "Email": "analiz.nieto@ariaslaw.com",
  "Name": "Analiz Nieto",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r6gzofgiKkOBq79aJVBG"
 },
 {
  "Email": "mary.haggie@kensingtonswan.com",
  "Name": "Mary Haggie",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r7N8BM1P31s6BIOmGQ9w"
 },
 {
  "Email": "glogothetis@koutalidis.gr",
  "Name": "Mr. Gregory Logothetis",
  "Document Name": "GREECE) KOUTALIDIS) BI 2020 GRC_bi_PPP_survey_en_07082019.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r7aNap4qBGpbP3ItIOf7"
 },
 {
  "Email": "rtinham@wslaw.co.uk",
  "Name": "Richard Tinham",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r8PuqQFoMLrf99sdX2wd"
 },
 {
  "Email": "geoffgee@ggp.com.vu",
  "Name": "Geoffrey Gee",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/r9yENNDSyGh14xvcgXLG"
 },
 {
  "Email": "Hgoi@loc.gov",
  "Name": "Hanibl Hanibl",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rAUXPxS5I3qrF1TGbyRN"
 },
 {
  "Email": "nyeinkyaw@rajahtann.com",
  "Name": "Mr. Nyein Kyaw",
  "Document Name": "BI 2020 MMR_bi_PPP_survey_en-1-Nyein Kyaw.docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rAZBODXO4TiZi4kL9Yip"
 },
 {
  "Email": "mearegb@x-calibur.co",
  "Name": "Berhane Meareg",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rBbwMz6fhGai1UBYUcHe"
 },
 {
  "Email": "shobbs@pppcouncil.ca",
  "Name": "Steven Hobbs",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rC2CPztmFJkhMUn8AlS6"
 },
 {
  "Email": "info@omlawphil.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rCedRhs1LHTFOc52QU4X"
 },
 {
  "Email": "nkyshtobaev@gratanet.com",
  "Name": "Mr. Nurlan Kyshtobaev",
  "Document Name": "BI 2020 KGZ_bi_TPI_survey_en_GRATA Law Firm.docx",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rCeg6TNrhOphDSwLcK3p"
 },
 {
  "Email": "contact@dirdeirylawfirm.com",
  "Name": "Dirdeiry Mohammed",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rDQA8O72rUpPJM0laJTa"
 },
 {
  "Email": "lwc@legallex.net",
  "Name": "Wai Cheong Low",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rDSgdnLztQnu4bbLOu16"
 },
 {
  "Email": "CBLo@duanemorrisselvam.com",
  "Name": "Mr. CN Bei Lo",
  "Document Name": "PPP_Maynmar (DMS29072019).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rEbRb9euF3k1Q9VGKhtJ"
 },
 {
  "Email": "fatihathiam@kpmg.com",
  "Name": "Fatiha Thiam",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rEzgk93Meg4I75V26CsJ"
 },
 {
  "Email": "aggie.goss@hsf.com",
  "Name": "Special Counsel Aggie Goss",
  "Document Name": "Australia_TPI_survey_en HSF response 19.7.19.docx",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rGYTYFkPgxVBRcFA0MfN"
 },
 {
  "Email": "cle@danskebank.dk",
  "Name": "Carina Lempert",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rGiWQv4DGY3OMvP39jfq"
 },
 {
  "Email": "Tamar.zarandia@tsu.ge",
  "Name": "Tamar Zarandia",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rGpRHVE2QoEo18N854yT"
 },
 {
  "Email": "jolivardia@sucre.net",
  "Name": "Jorge Alexander Olivard�a B.",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rHEBiMFFBwGRtUYtiei0"
 },
 {
  "Email": "nick.ogden@pinsentmasons.com",
  "Name": "Nick Ogden",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rHG01uAL9VEDuEr184GM"
 },
 {
  "Email": "Yury.Tuktarov@lecap.ru",
  "Name": "Yury Tuktarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rHYelHqtONssuIgPr1CU"
 },
 {
  "Email": "m.portes@castillo.com.do",
  "Name": "Dr. Maria Portes",
  "Document Name": "BI 2020 DOM_bi_PPP_survey_enMPGCyCJuly162019.docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rHgC82kCoHlOk6bRhlCv"
 },
 {
  "Email": "BBaratz@PearlCohen.com",
  "Name": "Benjamin Baratz",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rIqq3zBPYZjtJjWh3xGf"
 },
 {
  "Email": "chenge@immma.co.tz",
  "Name": "Madina Chenge",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rJT6OS4qxymZTo13s1ab"
 },
 {
  "Email": "martin.carlevaro@berke.com.py",
  "Name": "Mr. Martin Carlevaro",
  "Document Name": "Survey WBG (PPP) (21.7.19)[1].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rJY1DNfX77vtZittjyNq"
 },
 {
  "Email": "sally.carlin@huntandhumphry.com.au",
  "Name": "Sally Carlin",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rJhbmluiGzqQZtpAGv5w"
 },
 {
  "Email": "m@lawyers.af",
  "Name": "Abdul Shukor Mahjoor",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rKiwsWnLO686Fj2UVYh3"
 },
 {
  "Email": "gill.goodwin@ah.co.nz",
  "Name": "Gill Goodwin",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rLPfRalxrATbUtXrW7rQ"
 },
 {
  "Email": "jbutina@mccullough.com.au",
  "Name": "Jelena Butina",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rLQmIFrBcjlsr93QIxvt"
 },
 {
  "Email": "adel@aloulalaw.com",
  "Name": "Mr. Adel Abdulhadi",
  "Document Name": "BI 2020 KWT_bi_PPP_survey_en_Oula.docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rLXMLlCDjjtK94BN3Qi7"
 },
 {
  "Email": "secretariat@zacci.co.zm",
  "Name": "Prisca Chikwashi",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rLg0oGr7KE0jSeBpQbib"
 },
 {
  "Email": "mlp@botsnet.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rM2OdKP0x8SvFOGJazkH"
 },
 {
  "Email": "mth@bruunhjejle.dk",
  "Name": "Mogens Thorninger",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rM3mOptZ2tOn3zIdIB8J"
 },
 {
  "Email": "stuart.arndt@echarris.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rNE6CVKcGoya7X00GcDB"
 },
 {
  "Email": "crecio@carrizales.pe",
  "Name": "Carlos Carrizales Recio",
  "Document Name": "Rev- Doc 2-Cuestionario Banco Mundial - Versión Integrada.docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rNI0b7YlXhlgZPYEACsZ"
 },
 {
  "Email": "dankner@ebnlaw.co.il",
  "Name": "Yoav Dankner",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rPA3sZaVeEga4qOpc8iW"
 },
 {
  "Email": "campbellk@sullcrom.com",
  "Name": "Kathryn A. Campbell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rPCiDg2kNwaTzERlWayn"
 },
 {
  "Email": "george.gonzalez@haynesboone.com",
  "Name": "George Gonzalez",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rPrBZWh36EREMIk6sQBv"
 },
 {
  "Email": "barkerb@bennettjones.com",
  "Name": "Bruce C. Barker",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rPx8SaNYVsXLQ0I8O3vF"
 },
 {
  "Email": "stephen.jaggers@au.kwm.com",
  "Name": "Stephen Jaggers",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rQEaCCFHSHnxCpvhywbD"
 },
 {
  "Email": "ayasha@svlclaw.com",
  "Name": "Ms. Ayasha Sharma",
  "Document Name": "BI 2020 NPL_bi_PPP_survey_en.docx",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rQOCifl42f6f1aAFwZuo"
 },
 {
  "Email": "gesterkamp@baumeister.org",
  "Name": "Stefan Gesterkamp",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rQYJoQVWjtO9v9Prz88k"
 },
 {
  "Email": "david.gilbert@minterellison.co.nz",
  "Name": "David Gilbert",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rR2V12TVaGywbUa17S2L"
 },
 {
  "Email": "lbaran@sichamber.com",
  "Name": "Linda Baran",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rRbglHqSk8BzlJcifNxD"
 },
 {
  "Email": "patryk.figiel@linklaters.com",
  "Name": "Mr Patryk Figiel",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_LL.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rRoC9tV4YGKdjSarCVm9"
 },
 {
  "Email": "MAMistriukova@volgogradcci.ru",
  "Name": "Marina Vmistryukova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rSVHF4gJzA0ot9pbO3ws"
 },
 {
  "Email": "olga.revzina@hsf.com",
  "Name": "Olga Revzina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rSoxYXDv6tSvq0MksArE"
 },
 {
  "Email": "rwilliams@ecija.com",
  "Name": "Mr. Roberto Alejandro Williams Cruz",
  "Document Name": "UPDATED BI 2020 HND_bi_PPP_survey_en (07.10.19)Ecija.doc",
  "Country": "HND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rTpJHJObthBaBtTvzxJr"
 },
 {
  "Email": "judd.abramson@wilmerhale.com",
  "Name": "Judd Abramson",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rUTyNVa02J0nXefqqBoy"
 },
 {
  "Email": "meridiam@meridiam.com",
  "Name": "Thilo Tecklenburg",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rUYqesrTz8QRr7o8IecC"
 },
 {
  "Email": "info@asatiani-law.ge",
  "Name": "David Asatiani",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rVqfSpEfCoGMMikKLBlO"
 },
 {
  "Email": "syt@tsmplaw.com",
  "Name": "Stefanie Yuen Thio",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rWPesEdUK0YdvIGHG3YF"
 },
 {
  "Email": "scott.moran@duncancotterill.com",
  "Name": "Scott Moran",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rWyIuZkrCJJjnpkwl7x8"
 },
 {
  "Email": "msalgueiro@grossbrown.com.py",
  "Name": "Mr. Mauricio Salgueiro",
  "Document Name": "19.06.27 - Survey - Private Public Partnership - World Bank Group [6].docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rXeLhnx5Rnhe6MQX3O4A"
 },
 {
  "Email": "alistair.mcgillivray@cliffordchance.com",
  "Name": "Alistair Mcgillivray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rZ0nyMUfMrNBZJ4zrGbI"
 },
 {
  "Email": "info@ccit.hn",
  "Name": "Jose Ernesto Mejia Por",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/raRZYD6EIRmcHBd7Rrbb"
 },
 {
  "Email": "christopher.bovell@dunncox.com",
  "Name": "Mr Christopher Bovell",
  "Document Name": "BI 2020 JAM_DunnCox_bi_PPP_survey_en.docx",
  "Country": "JAM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ratH3UwXlgUgjOJFHvOn"
 },
 {
  "Email": "cathriin.torop@sorainen.com",
  "Name": "Cathriin Torop",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rb6UZYbmmEY9VPblGQx5"
 },
 {
  "Email": "admininternic@1asat.com",
  "Name": "Adolfo Rojas Breedy",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rcS1RpfBQHiqfhUkIo1r"
 },
 {
  "Email": "fombamc@unisa.ac.za",
  "Name": "Mc Fombad",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rcka96JXC3lqLGRpmxev"
 },
 {
  "Email": "samson_lawyer@yahoo.com",
  "Name": "Samson Mesfin",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rcrFtMFWTAHvI74o7kTS"
 },
 {
  "Email": "ewakida@lexuganda.com",
  "Name": "Edmund Wakida",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/reqJAEgHp2WIhdt67HaC"
 },
 {
  "Email": "sroldan@ksa.mx",
  "Name": "Mrs. Silvia Ema Rold�n Gregory",
  "Document Name": "KSA BI_2020_MEX_bi_PPP_survey_en.DOC",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rf8hYJZ7HpsvE5v9uRZV"
 },
 {
  "Email": "bhnarangoda@gmail.com",
  "Name": "B. Himalika Narangoda",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rfjGQ4ERuSCBiidCAABB"
 },
 {
  "Email": "reception@vimpelcom.com",
  "Name": "Mikhail Slobodin",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rfxXkEkcfwvfaYZFyJZM"
 },
 {
  "Email": "ay.shaposhnikov@vaz.ru",
  "Name": "Igor Komarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rg0ZUrhSJupnJE5JXNfY"
 },
 {
  "Email": "jduboff@lachamber.com",
  "Name": "Jessica Dubott",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rg1TZaKiQ2DJqCX5AmwK"
 },
 {
  "Email": "wbahar@bahar.co.id",
  "Name": "Mr. Wahyuni Bahar",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_en_Bahar.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rhaeRbo5j9bSGElxs82i"
 },
 {
  "Email": "robin.baillie@squirepb.com",
  "Name": "Robin Baillie",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ri1moX4LCrBj77tycATA"
 },
 {
  "Email": "graham.mcleod@blakes.com",
  "Name": "Graham Mcleod",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/riApsMWs1ykZiVEVp5bq"
 },
 {
  "Email": "goe.eco@cbs.dk",
  "Name": "Grith Skovsgaard �lykke",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/riOqKb1S1cDFyRl7otBZ"
 },
 {
  "Email": "walid.halabi@saudibauer.com",
  "Name": "Walid Halabi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rirD2m8hz28INnKVWcWE"
 },
 {
  "Email": "lbrown@mccarthy.ca",
  "Name": "Linda Brown",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rkYgcYdwj5uM7Iz0NdLH"
 },
 {
  "Email": "wanwisar.nakarat@linklaters.com",
  "Name": "Wanwisar Nakarat",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rkv9Wbi3Npb6bqpaUSBB"
 },
 {
  "Email": "constica@racsa.co.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rmdg1LEFPvs1wct4WDD5"
 },
 {
  "Email": "mmartinelli@deloitte.com",
  "Name": "Michelle Martinelli",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rmfGlWYlAkalLgQq22Jy"
 },
 {
  "Email": "rizmaylova@whitecase.com",
  "Name": "Rimma Izmaylova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rmiAByFZLoS6utFwAGZZ"
 },
 {
  "Email": "jlabandera@hughes.com.uy",
  "Name": "Mr. Joaqu�n Lavandera",
  "Document Name": "PPP ENCUESTA WORLD BANK (241053xBF7D6).docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rmp0FdqVUtlcZ2lcuLvP"
 },
 {
  "Email": "mark@fs-lawyers.com",
  "Name": "Mark Ford",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ro6S4FGQiDpaRFx8Le9b"
 },
 {
  "Email": "howard.kleiman@klgates.com",
  "Name": "Howard Kleiman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rqT4R8soeYeqp32ktnC7"
 },
 {
  "Email": "chawken@sdchamber.org",
  "Name": "Chanelle Hawken",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rqueYvf8IKai9qMYyNdh"
 },
 {
  "Email": "pbeswick@bsp.com.pg",
  "Name": "Peter Beswick",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rsISodt6kVK6fuRrp8F8"
 },
 {
  "Email": "elobied.elhaj@qpmc.qa",
  "Name": "Elobied Elhaj",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rtxG7AZ8UoQdolhcN7hw"
 },
 {
  "Email": "mengmeng.wong@wongpartnership.com",
  "Name": "Meng Meng Wong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rtySyX6UI7aPPsY0uZqT"
 },
 {
  "Email": "membership@cbi.org.uk",
  "Name": "Jim Bligh",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rucQ5xhcp6zfGk3Ft9uw"
 },
 {
  "Email": "john.stephens@mc.co.nz",
  "Name": "John Stephens",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rudSYhzkBBxV9u0wa6yt"
 },
 {
  "Email": "info@capitalfunds.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rv5lQU4C6KY7bX6O3vYd"
 },
 {
  "Email": "archil.mchedlidze@lawpractice.ge",
  "Name": "Archil Mchedlidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rv6oqnghT9g1jV22Rx0s"
 },
 {
  "Email": "david@flackswong.co.nz",
  "Name": "David Flacks",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rvWC1bGKgTa2LfWt4aTh"
 },
 {
  "Email": "shadia.badawi@sksadvocates.com",
  "Name": "Shadia Badawi",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rvwmOXqZw76iVI4Yy0iR"
 },
 {
  "Email": "i.antonopoulou@kglawfirm.gr",
  "Name": "Ms Ioanna Antonopoulou",
  "Document Name": "GREECE) KYRIAKIDES) BI 2020 GRC_bi_PPP_survey_en_KG input.DOCX",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rxQMroCKpRdtMUTQuYhT"
 },
 {
  "Email": "info@ktoinc.net",
  "Name": "Mr. Gourish Khishna Kharel",
  "Document Name": "NEPAL) KTO) BI 2020 NPL bi PPP survey en Nepal.docx",
  "Country": "NPL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ry0ll7cADyQpMHoyv2bn"
 },
 {
  "Email": "ncbgfsales@jncb.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ryQVLnFdFPIzXEAczXbS"
 },
 {
  "Email": "jkarp@sandw.com",
  "Name": "Jeffrey M. Karp",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/rzG8JrwEWZJjHtqRU9zC"
 },
 {
  "Email": "fsciaudone@grimaldilex.com",
  "Name": "Prof. Francesco Sciaudone",
  "Document Name": "ITA_bi_PPP_survey_en_Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s0oCOFP9CafwotTjFoZp"
 },
 {
  "Email": "info@colombolawyers.com",
  "Name": "Yohan Rajeeva Wijesinghe",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s1muU7f2XwZw7a1sGjGB"
 },
 {
  "Email": "info@elclawoffice.mn",
  "Name": "Ms. Nyamtseren Bataa",
  "Document Name": "MONGOLIA) ECL LAW) BI 2020 MNG_bi_PPP_survey_en_ELC.docx",
  "Country": "MNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s2PYorcOKNCfcr7fkCy0"
 },
 {
  "Email": "ankica.lijovic@hpb.hr",
  "Name": "Ankica Iijovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s37nCtukSuNorF4eOIlR"
 },
 {
  "Email": "nelson@fdh.co.mw",
  "Name": "Nelson Mkwende",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s3b295CWdVpihymob9kj"
 },
 {
  "Email": "jennifer.maxwell@blakes.com",
  "Name": "Jennifer Maxwell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s43E3WYF7J9G90W2smIB"
 },
 {
  "Email": "yimaracorro@limayasociados.com",
  "Name": "Yimara Corro",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s5Liw2gmgPaVZdBJuZv7"
 },
 {
  "Email": "arodriguez@consortiumlegal.com",
  "Name": "Mr. Alfredo lRodriguez",
  "Document Name": "Benchmarking Infrastructure Guatemala Consortium Legal - 190816.docx",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s69UYQWI12eBiZuzkUPb"
 },
 {
  "Email": "nationalpacificinsurance@npitonga.to",
  "Name": "Diana Tasion",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s6b0KR9WzXO0Im6gI2FC"
 },
 {
  "Email": "rkeenan@chadbourne.com",
  "Name": "Richard Keenan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s6cHB73BKr4BatlNArik"
 },
 {
  "Email": "klegesi@deloitte.com",
  "Name": "Kenneth Legesi",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s6pwG1almaAgCihwT9wc"
 },
 {
  "Email": "sieng.deline@rajahtann.com",
  "Name": "Mr. Deline Sieng",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en - RTSH020919.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s744pAcoYUeLRvMneHep"
 },
 {
  "Email": "veiko.vaske@nove.ee",
  "Name": "Veiko Vaske",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s7BB7owgtUxWQYpM3ccc"
 },
 {
  "Email": "Bill.Gilliam@addleshawgoddard.com",
  "Name": "Bill Gilliam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s7SWaUnK5lbyS7N5I2EZ"
 },
 {
  "Email": "pslands@pmc.gov.sb",
  "Name": "Ronald Unusi",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s7UxsiMPwvfkmv0UDgi7"
 },
 {
  "Email": "Greg.Gibson@mills-reeve.com",
  "Name": "Greg Gibson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s8CfS7QhBtSm9On5vSJj"
 },
 {
  "Email": "equipment@tiecol.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s8RWjqge5eUPthXU22K0"
 },
 {
  "Email": "lortiz@blplegal.com",
  "Name": "Mr. Luis Ortiz",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en.docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s9aHNPVAoDKX3IHxRUbp"
 },
 {
  "Email": "mmaza@arenales.com.gt",
  "Name": "Mariana Maza R.",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s9drZ7eX9GufA9psCIza"
 },
 {
  "Email": "suishin@jcci.or.jp",
  "Name": "Akio Mimura",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s9pNXzWCvw8KXo0GFSjh"
 },
 {
  "Email": "emanualay@tadessekiros.com",
  "Name": "Emanuala Yohannes",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/s9pmeJNTj6Tugas0wZFi"
 },
 {
  "Email": "debiehg@yahoo.com",
  "Name": "Debebe Haile Gebriel",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sACsFdmaOFhgN1HofMwe"
 },
 {
  "Email": "craig.vogelsang@bakerbotts.com",
  "Name": "Craig Vogelsang",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sARaPjPtXCIpq6bpzpyD"
 },
 {
  "Email": "giancarlo.villafranqui@cms-grau.com",
  "Name": "Mr. Giancarlo Villafranqui",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en (15.07.19).docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sASRFldPZzElKwGuhFe8"
 },
 {
  "Email": "wcicsl1@sltnet.lk�",
  "Name": "Chloe De Souza",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sAYl53M79YAJ4PNdWtGj"
 },
 {
  "Email": "kristel.valk@sirel.com",
  "Name": "Kristel Valk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sAcSQ9Mb0sAjqnHiIQ7w"
 },
 {
  "Email": "nigel.drew@dlapiper.com",
  "Name": "Nigel Drew",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sBC4bASHA0Nnz565i4YN"
 },
 {
  "Email": "roberto.cursano@bakermckenzie.com",
  "Name": "Mr Roberto Cursano",
  "Document Name": "Italy PPP survey World Bank (005)_Baker Mckenzie.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sBhfUut2fmCvc4UxmaAh"
 },
 {
  "Email": "tnishikawa@sidley.com",
  "Name": "Tomoo Nishikawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sBkmRk93FdvXYJILmmhx"
 },
 {
  "Email": "josko.tezulat@cemex.com",
  "Name": "Josko Tezulat",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sBkr8mEMg1mxCkMlThBr"
 },
 {
  "Email": "mauricegarber@yahoo.com",
  "Name": "Maurice Garber",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sBnqT6IsGKYwDk2Sh52Q"
 },
 {
  "Email": "eguth@bgalaw.co.il",
  "Name": "Ehud Guth",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sCwtStSpHjMuCUaEiEsK"
 },
 {
  "Email": "rtaboada@consortiumlegal.com",
  "Name": "Msc. Rodrigo Taboada",
  "Document Name": "Encuesta Banco mundial 17.07.2019.docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sEnX4SUDaJPQGFFHkfl2"
 },
 {
  "Email": "tokuoka@blakemore.gr.jp",
  "Name": "Takaki Tokuoka",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sFSrJ8X4Uy5BVkVgJR6C"
 },
 {
  "Email": "janna.pihanurmi@hannessnellman.com",
  "Name": "Associate i Janna Pihanurmi",
  "Document Name": "FINLAND) HANNES SNELLMAN ATTORNEYS) BI 2020 FIN_bi_PPP_survey_en_.doc",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sFgjAD7eFFUW5SAWJAuP"
 },
 {
  "Email": "ldemelo@abl.com.au",
  "Name": "Laila De Melo",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sGU698xU5kCA1IuGd9Fc"
 },
 {
  "Email": "Svitlana.Teush@redcliffe-partners.com",
  "Name": "Ms Svitlana Teush",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_RP comments_Rv.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sGahtyLbQe2A4w8Br428"
 },
 {
  "Email": "triinu.jarviste@tgsbaltic.com",
  "Name": "Triinu J�rviste",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sHp0HgQ6JUXNQZXUaUOv"
 },
 {
  "Email": "libby.g.johnson@uk.pwc.com",
  "Name": "Libby Johnson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sIBvR16icQirMhGpsHGN"
 },
 {
  "Email": "jonas.jensen@dk.ey.com",
  "Name": "Mr Torben Hartz",
  "Document Name": "DENMARK) EY) BI 2020 DNK_bi_PPP_survey_en-alle SPM.docx",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sIZEgam1N0yeMYTwFtAZ"
 },
 {
  "Email": "jrivera@consortiumlegal.com",
  "Name": "Jos� Rafael Rivera Ferrari",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sJg3t1VzNZq1LP6glVwa"
 },
 {
  "Email": "robin.durairajah@cco.co.zm",
  "Name": "Robin Durairajah",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sJzO5GBTUPkQlWVr3rg2"
 },
 {
  "Email": "susan.wong@wongpartnership.com",
  "Name": "Susan Wong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sK3f6M0Au5tqhN0QJhHW"
 },
 {
  "Email": "quynhanh.lam@hoganlovells.com",
  "Name": "Quynh Anh Lam",
  "Document Name": "VIETNAM) VCI LEGAL) BI 2020 VNM_bi_PPP_survey_en-[completed KW].docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sKjHgRtgtpdtoSXaGpwM"
 },
 {
  "Email": "fchan@corbanrevell.co.nz",
  "Name": "Frank Chan",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sL8BfLcXfbwyBFAj4hv0"
 },
 {
  "Email": "ricardo.durling@durlinglaw.com�",
  "Name": "Ricardo A. Durling",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sM62zCIR1yG7yBE8R4Ey"
 },
 {
  "Email": "dps@udsm.ac.tz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sMYFMvTfNeExQmxuVqW3"
 },
 {
  "Email": "hfch@flycia.cl",
  "Name": "Mr Hernán Fleischmann",
  "Document Name": "BI 2020 CHL_bi_TPI_survey_en (3).docxJDR.docx",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sMdVw6fxRJ5f7WPrGg0g"
 },
 {
  "Email": "sreekala.bajwa@ndsu.edu",
  "Name": "Joseph K. Ssegawa",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sMnxIiupMhFZafNVsWgB"
 },
 {
  "Email": "mohammad.amro@zubilaw.com",
  "Name": "Miss Mohammad Amro",
  "Document Name": "BI 2020 JOR_bi_PPP_survey_en_Sharif.docx",
  "Country": "JOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sNH1ZAGeQ0BkiUYmEDNk"
 },
 {
  "Email": "Yury.Tuktarov@lecap.ru",
  "Name": "Yury Tuktarov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sNKEAARlsG5eHuK9UhvO"
 },
 {
  "Email": "mohammad.hassan@ada.org.af",
  "Name": "Mohammad Hassan Akhundaza",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sOMO37w3O4TLfJOWfOuL"
 },
 {
  "Email": "chikako.hashimoto@hoganlovells.com",
  "Name": "Chikako Hashimoto",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sOO2dSWZ74TLWJPJf9zt"
 },
 {
  "Email": "vicbar@vicbar.com.au",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sOWJ2oI1am5XKh2beXgi"
 },
 {
  "Email": "ask@idilmat.com",
  "Name": "Ron Quist",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sPNGJ84etiXMpaa8jXy7"
 },
 {
  "Email": "caroline.williams@norfolkchamber.co.uk",
  "Name": "Caroline Williams",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sPkPXz4Ola1Cf1NhVtSA"
 },
 {
  "Email": "kiran.arora@blplaw.com",
  "Name": "Kiran Arora",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sRgLkcbSStmXmYiHTMaW"
 },
 {
  "Email": "v.sahakyan@bdoarmenia.am",
  "Name": "Vahagn Sahakyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sRypYvTBbnsfmOI73Hr7"
 },
 {
  "Email": "zarinach@gmail.com",
  "Name": "Zarina Chekirbaeva",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sRz8vc459tDG8wBOljSJ"
 },
 {
  "Email": "kabelo@herbco.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sSBtvMrqi3XNS8VVZheX"
 },
 {
  "Email": "vfranyutti@nhg.com.mx?????",
  "Name": "Ms. Vanessa Franyutti",
  "Document Name": "NHG-#68391-v3-World_Bank_PPP_survey.DOCX",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sSN39ixBs8HvkJoejdfv"
 },
 {
  "Email": "GYLA@GYLA.GE",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sSxSEmPgFniwERQws3Vr"
 },
 {
  "Email": "andrea.chambers@dlapiper.com",
  "Name": "Andrea Chambers",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sT9LkIAVlKjam8FAZN5Y"
 },
 {
  "Email": "maxine.ethier@bakermckenzie.com",
  "Name": "Maxine Ethier",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sV3tN6ZrsTEK2iEs77bb"
 },
 {
  "Email": "tomoko.fuminaga@morganlewis.com",
  "Name": "Tomoko Fuminaga",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sVAyDirdakuRLdIgzZhd"
 },
 {
  "Email": "kaupo.lepasepp@sorainen.com",
  "Name": "Kaupo Lepasepp",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sVfLQ66K6p9XZ1TEBWTm"
 },
 {
  "Email": "businesspro@mega.bw",
  "Name": "Mukam Sheikh",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sVzqG46Hh3g78NUjertj"
 },
 {
  "Email": "armenvosk@armcci.am",
  "Name": "Armen Voskanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sWDMDiLVhWfZTgBs0KuH"
 },
 {
  "Email": "cmalaba@kantorimmerman.co.zw",
  "Name": "Ms Chatapiwa Malaba",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_KI.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sWLH6wBTSUoUOnvL0hT4"
 },
 {
  "Email": "jeremy.kutner@shearman.com",
  "Name": "Jeremy Kutner",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sWtToMcW48u0josaaDaK"
 },
 {
  "Email": "master@thai-iod.com",
  "Name": "Bandid Nijathaworn",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sX5jlvPEs1hpP18biZ6J"
 },
 {
  "Email": "michael.jakobs@bld.de",
  "Name": "MICHAEL JAKOBS",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sY7SeSqFqcbj9NcrriAh"
 },
 {
  "Email": "samvutheary.mao@hml.com.kh",
  "Name": "Ms. Samvutheary Mao",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en_HML1.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sZEpIOLWhjQqYQPb5awE"
 },
 {
  "Email": "danijela.simeunovic@kps-law.com",
  "Name": "Dianijela Simeunovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sa1ZseR37givtFdxlnXn"
 },
 {
  "Email": "debuys.scott@kpmg.co.za",
  "Name": "Debuys Scott",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sbZm9dURaS3Fl4KK26HY"
 },
 {
  "Email": "murai@taisei.co.jp",
  "Name": "Kyo Murai",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sc7gB0PWGsFZqqfjcRPd"
 },
 {
  "Email": "info@ccmp.org.mz",
  "Name": "Juliao Dimande",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/scbtqrV3sBOUwsWaKJqb"
 },
 {
  "Email": "vsharma@millsoakley.com.au",
  "Name": "Vince Sharma",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/scwESYjDo18VDq8whmis"
 },
 {
  "Email": "pichitpon.eammongkolchai@linklaters.com",
  "Name": "Pichitpon Eammongkolchai",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sdJ0jI9nFAYtSv85X5Qu"
 },
 {
  "Email": "gorea@upng.ac.pg",
  "Name": "Emanuel Gorea",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sePWAHDEDwiM8g33Nc6R"
 },
 {
  "Email": "franz.koenig@bld.de",
  "Name": "FRANZ K�NIG",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sf05AzCtyRZCejk7NZYC"
 },
 {
  "Email": "jsegal@investorsresearchgroup.com",
  "Name": "Jacob Segal",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sf7v6pW6oj9GRUQ70Suk"
 },
 {
  "Email": "mrapaport@nixonpeabody.com",
  "Name": "Mitchell Rapaport",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sg5G4I8vONl1RhTxr9uS"
 },
 {
  "Email": "marta.pedro@plmj.pt",
  "Name": "MS Marta Pedro",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en_TTA.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/shlefSbAjs56rQgcXlgp"
 },
 {
  "Email": "bolkvadze@blb.ge",
  "Name": "Tornike Bolkvadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/si4wZ8R3jqgKSHqiF2TJ"
 },
 {
  "Email": "valerie.nera@calchamber.com",
  "Name": "Valerie Nera",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sj0EUUgv26A2bHOQD4Y5"
 },
 {
  "Email": "adina.chilim-dumitriu@nndkp.ro",
  "Name": "Ms. Adina Chilim-Dumitriu",
  "Document Name": "BI 2020 ROM _bi_TPI_survey_en (ID 347900)_Nestor.docx",
  "Country": "ROM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sj5nKLMpDtksN1dzS6UL"
 },
 {
  "Email": "o.kobasa@schoenherr.eu",
  "Name": "Ozren Kobsa",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sj7NRaOCmJ6bTlo6GP7S"
 },
 {
  "Email": "kusnalaw @kusnandar.com",
  "Name": "Ms Winata Kusnandar",
  "Document Name": "BI 2020  IDN_bi_TPI_survey_Kusnandar & Co.doc",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sjuCL0bSPiT08ICzOHo9"
 },
 {
  "Email": "stevelaw@ipasifika.net",
  "Name": "Trevor Stevenson",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sjuNIZO0VIp4DiV40TcR"
 },
 {
  "Email": "mohammed@aljadaan.com",
  "Name": "Mohammed Al-Jadaan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sk7MRiuMt30mvVeDXLkV"
 },
 {
  "Email": "deyaldin@yahoo.com",
  "Name": "Deya Eltayeb",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/skzL3PGOnSYKdOmnNNb4"
 },
 {
  "Email": "oanderson@milbank.com",
  "Name": "Miss Olivia Anderson",
  "Document Name": "BI 2020 GBR_bi_PPP_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/slJDkTZpOmb5wvueKrzA"
 },
 {
  "Email": "mgarza@jata.mx",
  "Name": "Mr. Mauricio Garza Bulnes",
  "Document Name": "20190712 BI 2020 MEX_bi_TPI_survey_en.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sm5RViyaarHP0MqBCJHh"
 },
 {
  "Email": "ritsilva@deloitte.com",
  "Name": "Rita Maria Silva",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sn4FFQJMSG99P37DyKKk"
 },
 {
  "Email": "admin@primaconsultants.com.sa",
  "Name": "Abdulrahman Bin Saud Al Kabeer",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/soPe9GRXsXZ2pHJWZ31O"
 },
 {
  "Email": "nfo@anedco.com",
  "Name": "Reza Golkari",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/soySRuj1zo1GS1xZ8AyZ"
 },
 {
  "Email": "leroy.levy@squirepb.com",
  "Name": "Leroy Levy",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/spmCG5veTPygv6Nv7OWE"
 },
 {
  "Email": "jonnalagaddallp@gmail.com",
  "Name": "J N L Murthy",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sqNMA4RS3JwbevkYyZaI"
 },
 {
  "Email": "jr.nelson@dlapiper.com",
  "Name": "James Nelson",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sqmMc9AdkM1Mu0MZGc1e"
 },
 {
  "Email": "dvnikiforov@debevoise.com",
  "Name": "Dmitri Nikiforov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sr0CTyoPgN6ZeX2mxNVh"
 },
 {
  "Email": "jtravers@stewartmckelvey.com",
  "Name": "James Travers",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/srQmGeJV5OBSYgoUrHxF"
 },
 {
  "Email": "lae@manases.com.pg",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/srmXUXk7hy3pb55Y6wKi"
 },
 {
  "Email": "Anton.Rekun@redcliffe-partners.com",
  "Name": "Mr Anton Rekun",
  "Document Name": "BI 2020 UKR_bi_TPI_survey_en_RP comments_Rv.docx",
  "Country": "UKR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ssVB4CuPvCMzlhFstXSN"
 },
 {
  "Email": "altaf.tapia@am.pwc.com",
  "Name": "Altaf Tapia",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ssy9r0MXQ0cTLIRLnp9G"
 },
 {
  "Email": "lderas@dumaslex.com",
  "Name": "Luis Alfonso Deras Escobar",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/stoumv8ThH1WBp3HpAq2"
 },
 {
  "Email": "jkahukiwa@corbanrevell.co.nz",
  "Name": "John Kahukiwa",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sv5Oz5RZpk3OTF4qJHb2"
 },
 {
  "Email": "n.daely@amoktarina.co",
  "Name": "Ms Nasfiahtul Istani Daely S.H",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_an_Oktarina.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sv7UPk8xlhp590m06Nex"
 },
 {
  "Email": "artur.ghambaryan@gmail.com",
  "Name": "Artur Ghambaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/svbczRi7kyx9t6sQFEXt"
 },
 {
  "Email": "info@mogadishucenter.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/sveLHViwfg7KZiJ589uo"
 },
 {
  "Email": "shalini@legacylawoffices.com",
  "Name": "Ms. Shalini Munjal Shalini Munjal",
  "Document Name": "BI 2020  IND_bi_PPP_survey_en_Shalini Munjal.docx",
  "Country": "IND",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/svikIoM1dAsTBcoT5XL4"
 },
 {
  "Email": "info@albandaryeng.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/svrNHgkrjGhMYTgt4Lre"
 },
 {
  "Email": "i.alfian@amoktarina.co",
  "Name": "Mr Irgi Alfian S.H",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Oktarina Counsellors.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/svyt0BrFXzOohuvcp1CH"
 },
 {
  "Email": "remba@sololaakpana.com",
  "Name": "Mrs Rosemary Mba",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank Questionairre TPI Document 29-7-19.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/szPPLMaLl3KwRGsl3PaD"
 },
 {
  "Email": "ukalinic@deloittece.com",
  "Name": "Uros Kalinic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/szUJ9rGAXEGd0F5PP0pN"
 },
 {
  "Email": "mario.flor@fhlegal.ec",
  "Name": "Dr. Mario Flor",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en, MAF.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/szmNiVas7IRJFgahJzHK"
 },
 {
  "Email": "Marco.Martinez@bbklaw.com",
  "Name": "Marco Martinez",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/szqsIm56kyVXafY4ejQR"
 },
 {
  "Email": "kkalumiya@kaa.co.ug",
  "Name": "Hon. Dr. Charles Kallu Kalumiya",
  "Document Name": "UGANDA) KAMPALA ASSOCIATED ADVOCATES) BI 2020 UGA_bi_PPP_survey_en.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t0VsuofjKsCedZWd9YDa"
 },
 {
  "Email": "gruber@baumeister.org",
  "Name": "Jens Tobias Gruber",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t0t1lSJZdXzfvS0wwrfO"
 },
 {
  "Email": "grgo.aljinovic@cemex.com",
  "Name": "Grgo Aljinovic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t3BQmXbOCOrb3vcAr9ib"
 },
 {
  "Email": "duy.cao@rajahtannlct.com",
  "Name": "Senior Associate Duy Cao Dang",
  "Document Name": "VIETNAM) RTLCT) BI 2020 VNM_bi_PPP_survey_en.doc",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t3FBhd7DUSgyFJGU8SYr"
 },
 {
  "Email": "jaylayug@punolaw.com",
  "Name": "Jose M. Layug Jr.",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t42AJzlXhvhodmNXorRV"
 },
 {
  "Email": "kerry.anderson@dlapiper.com",
  "Name": "Kerry Anderson",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t48ooAyQmHkDUCfTCRZQ"
 },
 {
  "Email": "josephine.wong@sc.com",
  "Name": "Josephine Wong",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t4QAEzchtR4BzwR7ZlTc"
 },
 {
  "Email": "tadlaw@ethionet.et",
  "Name": "Dilnesahu Tadesse",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t5JigEsF6R7U7EwdkhAn"
 },
 {
  "Email": "zeevl@chamber.org.il",
  "Name": "Ze'Ev Lavie",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t5Tg2ue9l67Tv3XygYzD"
 },
 {
  "Email": "nopazd@cableonda.net",
  "Name": "N�stor Paz Rold�n Adames",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t6tgADAMYHFz1wOg3Q6b"
 },
 {
  "Email": "jturcios@melarayasociados.com",
  "Name": "Jaime Miguel Turcio Zacar�as",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t74L29WI76MwSvLaYWVu"
 },
 {
  "Email": "kbutterfield@fasken.com",
  "Name": "Kathleen E. Butterfield",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t8VUP8fKcbctmvStpxm7"
 },
 {
  "Email": "fincageo@finca.ge",
  "Name": "Giorgi `Mirotadze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t8nvdQpmJ9rfQxe3JeH8"
 },
 {
  "Email": "nja@pagbam.com",
  "Name": "title Nicole Jaureguiberry l",
  "Document Name": "World Bank- PPP survey (1).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/t9jswLBZLNnT6YZmawBF"
 },
 {
  "Email": "garth.sinclair@webbhenderson.com",
  "Name": "Garth Sinclair",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tAAC8vas0I7O8CGsJBJk"
 },
 {
  "Email": "lskilbeck@kpmg.com.au",
  "Name": "Louise Skilbeck",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tAM8s6FGKzNUoRFdpdrd"
 },
 {
  "Email": "info@godfreycoorayassociates.com",
  "Name": "Godfrey Cooray",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tAc5myN84hSglyHtmdb5"
 },
 {
  "Email": "carguello@nassarabogados.com",
  "Name": "Carolina Arguello",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tAut8EYoR9aP6VTMjr5S"
 },
 {
  "Email": "mulugetazemene@gmail.com",
  "Name": "Mulugeta Zemene Zerihun",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tBTcE32ZzrTCIjimeXsI"
 },
 {
  "Email": "info@inocongroupltd.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tC5Vrbarfw8GDZQ8Wu5z"
 },
 {
  "Email": "fradinta.laksmita@dentons.com",
  "Name": "Ms. Fradinta Nadya Laksmita",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Dentons.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tCCoa585xyWkErcq38Em"
 },
 {
  "Email": "azimsudanco@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tCWDYnOlHUvMz25vwgdx"
 },
 {
  "Email": "awortwi@gmail.com",
  "Name": "Nicholas Awortwi",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tDbfQzGzXeN2RQZwhIu5"
 },
 {
  "Email": "belm@africaonline.com.gh",
  "Name": "Kojo Bentsi-Enchill",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tEK8eCiOXIyDkepOdrxq"
 },
 {
  "Email": "jorge.kawas@kymabogados.com",
  "Name": "Jorge J. Kawas",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tEMtPIOmJ60uwDb288lT"
 },
 {
  "Email": "rarango@arifa.com",
  "Name": "Ricardo M. Arango",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tF9So6DYP020UZxLHUNi"
 },
 {
  "Email": "daniele.archilletti@pwc.com",
  "Name": "title Daniele Archilletti",
  "Document Name": "Italy TPI_Survey_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tFaTXMpjp05n1jtGW9E5"
 },
 {
  "Email": "smwakaje@nexlawadvocates.com",
  "Name": "Saudin J. Mwakaje",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tFcUUm3CpvdDJK2g3rks"
 },
 {
  "Email": "kbalderston@nixonpeabody.com",
  "Name": "Kathleen M. Balderston",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tFcjK1dtDlXSsFHf8LzX"
 },
 {
  "Email": "tmaharshak@tmlw.co.il",
  "Name": "Tomer Maharshak",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tG72PzORk4ADIud0ruxe"
 },
 {
  "Email": "jeffrey@bookbinderlaw.co.bw",
  "Name": "Jeffrey Bookbinder",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tH2TJty6UKQM1hHiN4Cm"
 },
 {
  "Email": "daodeuane.duangdara@vdb-loi.com",
  "Name": "Mrs. Doudeuane Duangdara",
  "Document Name": "LAO) VDB-LOI) BI 2020 LAO_bi_PPP_survey_en.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tHHOtOv7ZwxTEpfGpc3R"
 },
 {
  "Email": "ralf.leinemann@leinemann-partner.de",
  "Name": "RALF LEINEMANN",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tHklU1LsxXH9NN0Kmf82"
 },
 {
  "Email": "lrosas@bufeterosa.com",
  "Name": "Leonidas Rosa Suazo",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tIgGRKKJmzXiaa9JTCtM"
 },
 {
  "Email": "s.akhmedov@aaa.tj",
  "Name": "Shavkat Akhmedov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tJVUhF2Ml4ZT83fYzOjb"
 },
 {
  "Email": "Vivian@sierratel.sl",
  "Name": "Vivian M. Solomon",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tJymDmQs48cafu8y0EUx"
 },
 {
  "Email": "derya.bandak@roedl.pro",
  "Name": "Derya Bandak",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tKstH6S1J6k3oTsZvZDW"
 },
 {
  "Email": "info@botrail.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tLl91aFKIsnOZ6rJskoC"
 },
 {
  "Email": "t.mozammel@as-associates.net",
  "Name": "Mr. Tanzum Mozammel",
  "Document Name": "BANGLADESH) AS ASSOCIATES) Benchmarking Infratructure PPP in Bd_Benchmarking Infrastructure 2020.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tM32TkUZ8HsWbR71clDi"
 },
 {
  "Email": "eeshi.katugugu@pwc.com",
  "Name": "Mrs Eeshi Katugugu",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_PPP_survey_en 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tNu10nTqiJ9uIYXcQNV0"
 },
 {
  "Email": "gabrielg@icazalaw.com",
  "Name": "Gabriel Gonz�lez-Ruiz",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tPCUFLCVS2SfbEXYVeDy"
 },
 {
  "Email": "gloria.roman@tz.pwc.com",
  "Name": "Gloria Roman",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tPQKsWIXx3epqjz7sY87"
 },
 {
  "Email": "gfernandez@bufelco.com.gt",
  "Name": "German Fernandez Acevedo",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tQZ9qSCAY2gDOV1v0KPx"
 },
 {
  "Email": "marti@alexela.ee",
  "Name": "Marti H��l",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tQgomzWqvsx19eFdT2rM"
 },
 {
  "Email": "gvalera@jcpdr.com",
  "Name": "Ms. Gisselle lValera",
  "Document Name": "BI 2020 DOM_bi_PPP-survey_en_LJJ (00402513xAEE47).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tRdUxXdZVX8L6roIyecE"
 },
 {
  "Email": "sga@prcp.com.pe",
  "Name": "Mr. Sebastian Gamarra",
  "Document Name": "BI_2020 PER_bi_PPP_survey_en_Payet - 4832-7662-0956 v. 5.doc",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tT9L8OB5MM04Iz2aCDvs"
 },
 {
  "Email": "enquiries@malaikachambers.org",
  "Name": "Joseph Andrew Kalie Sesay",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tUJvaRIfSAs4jb3C9OhR"
 },
 {
  "Email": "dazcue@stblaw.com",
  "Name": "David Azcue",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tUccT5RpC0F9k7oyug6X"
 },
 {
  "Email": "advokatuur@advokatuur.ee",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tUf5bt7P2yurgJgdIv6z"
 },
 {
  "Email": "mike.marasco@plenarygroup.com",
  "Name": "Mike Marasco",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tUn68Cj6oPiB86I0hvBt"
 },
 {
  "Email": "jbrizuela@blplegal.com",
  "Name": "Jorge Brizuela",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tW24H2sxamNDWnILXi87"
 },
 {
  "Email": "nadery@areu.org.af",
  "Name": "Nader Nadery",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tW8z4emVQG2yqqhNwv0e"
 },
 {
  "Email": "spillai@cnplaw.com",
  "Name": "Subramanian Pillai",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tWlHhLcodug9YuuRbWKB"
 },
 {
  "Email": "mnzkabul@mandviwallaandzafar.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tWm874QjkYGB4VaRglU8"
 },
 {
  "Email": "dclark@applebyglobal.com",
  "Name": "David Clark",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tX29A6vox0ODozCCObdD"
 },
 {
  "Email": "marin.hresic@hr.pwc",
  "Name": "Marin Hresic",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tXMIr45iHLkyZUnjLdK8"
 },
 {
  "Email": "d.nicholls@hopgoodganim.com.au",
  "Name": "David Nicholls",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tXUAVUUPqlJa6YUuJ3VY"
 },
 {
  "Email": "heiki.lindpere@tlu.ee",
  "Name": "Heiki Lindpere",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tYI34ZdWmyQ6g7T1IVWg"
 },
 {
  "Email": "ckubota@cov.com",
  "Name": "Carolyn Kubota",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/taMGJNRnjvM5U0G13tfE"
 },
 {
  "Email": "g.nelson@tamimi.com",
  "Name": "Grahame Nelson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tb0W3ukbCGE661rr1bQQ"
 },
 {
  "Email": "nnangendo@governancesystemsug.org",
  "Name": "Norah Nangendo",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tb4R3zgR6vn7U2HSTzfH"
 },
 {
  "Email": "channa.manoharan@lk.pwc.com",
  "Name": "Channa Manoharan",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tbaXGO6lLNybi67ypkHp"
 },
 {
  "Email": "ross.t@tilleke.com",
  "Name": "Dr. Ross Taylor",
  "Document Name": "MM_Benchmark Infrastructure Survey_TPI.doc",
  "Country": "MMR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tc1j1m6zT55nyadw5Vdp"
 },
 {
  "Email": "smabiti@nexlawadvocates.com",
  "Name": "Stanley Mabiti",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tc8uPCTS349nUAubF48b"
 },
 {
  "Email": "rking@porterhedges.com",
  "Name": "Randall King",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tcAtXdtpvEBenAvQ7wlc"
 },
 {
  "Email": "fisherya@i-biz-co.il",
  "Name": "Yaacov Fisher",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tdSg16UUu5GMpU9FAbxT"
 },
 {
  "Email": "miguel.martinez@mop.gob.sv",
  "Name": "title Miguel Martinez",
  "Document Name": "PO.BI 2020 SLV_bi_TPI_survey_en Miguel Martínez.docx",
  "Country": "SLV",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tfRueJJQ4kyYAxpW2jkw"
 },
 {
  "Email": "charles.lloyd@uk.pwc.com",
  "Name": "Charles Lloyd",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tgcMLeU1cZf2uVu8mScu"
 },
 {
  "Email": "msaragoca@stoccheforbes.com.br",
  "Name": "Ms. Mariana Sarago�a",
  "Document Name": "WB PPP.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tgkkiRBUrui1Yp0wkrFC"
 },
 {
  "Email": "matti.kauppi@tlu.ee",
  "Name": "Matti Kauppi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tgvXWTtk36D51VyCwbzu"
 },
 {
  "Email": "RAMON.QUISUMBING@QUISUMBINGTORRES.COM",
  "Name": "Ramon J. Quisumbing",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/thewVjUHL7YK9Z5JtPtL"
 },
 {
  "Email": "eaalampay@upd.edu.ph",
  "Name": "Erwin Gaspar A. Alampay",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/thfuuTbi05KNkmqaBv22"
 },
 {
  "Email": "info@ccplaw.com.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/thobJCha0QdCxCThuGpQ"
 },
 {
  "Email": "ben.morton@dlapiper.com",
  "Name": "Ben Morton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tiTau7yCic8MGdwwiZQi"
 },
 {
  "Email": "nfinkelstein@mccarthy.ca",
  "Name": "Neil Finfelstein",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tin5WzAJvgijuHhm9EWF"
 },
 {
  "Email": "ess@shalakany.com",
  "Name": "Mr. Emad El-Shalakany",
  "Document Name": "BI 2020 EGY_bi_PPP_survey_en_Shalakany.doc",
  "Country": "EGY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tkJTcjllhqQIUZFGagnS"
 },
 {
  "Email": "alen@armirac.hr",
  "Name": "Alen Komljenovi?",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tkOnZdii5GzasjQdaSJQ"
 },
 {
  "Email": "attorneys@lawyers.com.gt",
  "Name": "Karla Guevara H.",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tkkO1pg7s8XFWAHEL3ss"
 },
 {
  "Email": "jhhines@morganlewis.com",
  "Name": "Jonathan Hines",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tkkZA1rzecItX0J38Ryp"
 },
 {
  "Email": "aias@bu.edu",
  "Name": "Thomas Barfield",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tlJIlKmqlyDLXhkhRMjC"
 },
 {
  "Email": "adnan.sarajlic@wolftheiss.com",
  "Name": "Adnan Srajlic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tlYJCEqbP6vFNp7wJIJO"
 },
 {
  "Email": "info@fnslaw.com.ph",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tmJtxvHSr8Ot1qifuUfN"
 },
 {
  "Email": "info@tgmblawoffice.com",
  "Name": "Teshome Gabre-Mariam Bokan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tmUdjj5DR62laA70vuvo"
 },
 {
  "Email": "badenja@unisa.ac.za",
  "Name": "Hannie Ja Badenhorst-Weiss",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tmkZxjUtYGjdb9gURWTB"
 },
 {
  "Email": "absa0c@bangor.ac.uk",
  "Name": "Gwilym Owen",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tnGIfa1ST4mERmAlkcrs"
 },
 {
  "Email": "othman@ksausalegal.com",
  "Name": "Othman S. Alshmry",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/to7Jx2FboIySSpbZWMFH"
 },
 {
  "Email": "GAMMACONSULT@MAIL.RU",
  "Name": "????????? ????? ?????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tqxh82f7yNGRRDJ1A5RM"
 },
 {
  "Email": "info@kpc.kg",
  "Name": "Robert Brown",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tr3gwUuyOyTG6ile4MAv"
 },
 {
  "Email": "maslova@gsom.spbu.ru",
  "Name": "Svetlana Maslova",
  "Document Name": "RUSSIA) PROF MASLOVA) BI 2020 RUS_bi_concession_survey_en_Maslova S.docx",
  "Country": "RUS",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/trUFiuDenUMAFsWmoMMu"
 },
 {
  "Email": "info@alhazmilawfirm.com.sa",
  "Name": "Hasan Al Hazmi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tshYUkthtSLtsEYhCkAy"
 },
 {
  "Email": "fkaryadi@abnrlaw.com",
  "Name": "Mr. Freddy Karyadi",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_ABNR Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tu4hf8a5DQ7WcZWkqOeH"
 },
 {
  "Email": "ls@homannlaw.dk",
  "Name": "Lars S�ndergaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/tvL5zNVFnE0ukHJE0ARH"
 },
 {
  "Email": "a.kozmina@maximalegal.ru",
  "Name": "Alina Kozmina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u1lnvECbmNKg41nlpl7J"
 },
 {
  "Email": "tom@rosenstocklegal.com��",
  "Name": "Tom Rosenstock",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u2okaAQoekkiA3qNl8zE"
 },
 {
  "Email": "ben.cowling@clydeco.com",
  "Name": "Ben Cowling",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u3JkxEPSWzATU1v0fkYb"
 },
 {
  "Email": "maryeling.guevara@ariaslaw.com",
  "Name": "Ms Maryeling Suyen Guevara Sequeira",
  "Document Name": "BI 2020 NIC_bi_PPP_survey_en (REV).docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u4YVH2HGSDZwrSzMARNb"
 },
 {
  "Email": "haleem.himat@ada.org.af",
  "Name": "Abdul Halim Himmat",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u4kFZxm3ZEse1p4WKBLv"
 },
 {
  "Email": "eero.tonka@keevallik.ee",
  "Name": "Eero Tonka",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u6PacvOXr2VVGyqX4w2g"
 },
 {
  "Email": "silweyaco@yahoo.com",
  "Name": "Henry Silweya",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u78VGwC7479oCR2SDPoV"
 },
 {
  "Email": "adelaida@aua.am",
  "Name": "Adelaida Baghdasaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u7TSbg447NdIOEa7BRqF"
 },
 {
  "Email": "marcelin.joanis@usherbrooke.ca",
  "Name": "Marcelin Joanis",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u7kRkmYKaMhvlYC8injv"
 },
 {
  "Email": "ss@satchuassociates.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u8fWHxolae0kEvdgHJz2"
 },
 {
  "Email": "lee.hill@shearman.com",
  "Name": "Lee Hill",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u8n8hMrhUuEeYHMtdISi"
 },
 {
  "Email": "achequer@mayerbrown.com",
  "Name": "Alexandre R. Chequer",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u8tIhLM75q8QWY0NQhBr"
 },
 {
  "Email": "fzhao@paulweiss.com",
  "Name": "Feida Zhao",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u8zuP8Ycg5ECU9LpXAf7"
 },
 {
  "Email": "juanpa@fmm.com.pa",
  "Name": "Juan Pablo Fabrega Polleri",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u93OrYchKwydVVQOeEcW"
 },
 {
  "Email": "avindra.rodrigo@fjgdesaram.com",
  "Name": "Avindra Rodrigo",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u9JX9dxzj1AwjdNMnsSD"
 },
 {
  "Email": "n.ozbek@cakmak.av.tr",
  "Name": "Ms. Nigar �zbek",
  "Document Name": "TURKEY) CAKMAK) EA- World Bank 2020 PPP Survey (E).DOCX",
  "Country": "TUR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/u9fwDCZhYDLqkeuJJ3tk"
 },
 {
  "Email": "Bmartirosyan@edrc.am",
  "Name": "Bela Martirosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uAAdES9oEqnjFkkLrPFY"
 },
 {
  "Email": "ROMAN.RINGWALD@BBH-ONLINE.DE",
  "Name": "ROMAN RINGWALD",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uAWzQOOfunBo5qMHFu2t"
 },
 {
  "Email": "kraisorn@dfdl.com",
  "Name": "Kraissorn Rueangkul",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uBkeOCS9zCu1XQaJ2RAt"
 },
 {
  "Email": "ebsen@jur.uni-frankfurt.de",
  "Name": "Ingwer Ebsen",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uCpRmV4BM7H8ydvm71rE"
 },
 {
  "Email": "abdulaziz.alabduljabbar@cliffordchance.com",
  "Name": "Abdulaziz Al-Abduljabbar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uD1oFTVqbGrp5E7AlaN5"
 },
 {
  "Email": "jonathan.bevan@allenovery.com",
  "Name": "Jonathan Bevan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uFMDx2CMd4vYJg4EXTnv"
 },
 {
  "Email": "jean-francois.marquaire@cmslegal.ru",
  "Name": "Mr Jean-Francois Marquaire",
  "Document Name": "RUSSIA) CMS) BI 2020 RUS_bi_TPI_survey_en_CMS.DOCX",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uFyesPLeOEUxN02KnKah"
 },
 {
  "Email": "info@mahmoudelsheikh.com",
  "Name": "Tariq Mahmoud Elsheikh Omer",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uGPh6LhN675PflT8htjf"
 },
 {
  "Email": "sol.lawconsult1983@gmail.com",
  "Name": "Solomon Teshome",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uH0V7mxdfxEqeqP0u6Zj"
 },
 {
  "Email": "nprior@deloitte.co.uk",
  "Name": "Nick Prior",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uHFF69eihOzqYrn9LpA9"
 },
 {
  "Email": "info@caaicon.com",
  "Name": "Stephanie Bax",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uIa6b9VI2T1mSafOEIvm"
 },
 {
  "Email": "izaldivar@moralesybesa.cl",
  "Name": "Mr. Ignacio Zaldivar",
  "Document Name": "MYB-#387783-v1-World_Bank_TPI_Survey.DOCX",
  "Country": "CHL",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uJBF6Aw4LjnR0ITLXXSO"
 },
 {
  "Email": "kr@kr-consulting.com",
  "Name": "Kyle Rudden",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uJDRPPG1Z0RTHGBrgfWe"
 },
 {
  "Email": "basamoah@aelex.com",
  "Name": "Beverly Asamoah",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uLwlX8aV63rxhcna0Ju3"
 },
 {
  "Email": "joce@cowi.co.mz",
  "Name": "Jos� Chembeze",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uMUzfiZjZklJWmQdbkvQ"
 },
 {
  "Email": "joaofigueiredo@mota-engil.com",
  "Name": "Mr Joao Figueiredo",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en.docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uMXdKkFpZ8lBviyCWsKV"
 },
 {
  "Email": "shida@blakemore.gr.jp",
  "Name": "Yasuo Shida",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uMYYAfT3TWcrwEUYK5a5"
 },
 {
  "Email": "ronny@aicci.org",
  "Name": "Ronny Bassan",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uN0GMlvxkXzp8nfB2H4q"
 },
 {
  "Email": "nina.knyazeva@verkhovodko.com",
  "Name": "Mrs Nina Knyazeva",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_V&P.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uOclb4uIQD1HtkVHuz7W"
 },
 {
  "Email": "rniemann@mccullough.com.au",
  "Name": "Ren Niemann",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uP5wSexE5kSZw8sPxwwZ"
 },
 {
  "Email": "r.murray@ashfords.co.uk",
  "Name": "Ruth Murray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uPH3tNUmvjcpDn6oXey1"
 },
 {
  "Email": "nigel.boardman@slaughterandmay.com",
  "Name": "Nigel Boardman",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uPI3DOOTXnXLcm4QxDxC"
 },
 {
  "Email": "rectoria@incae.edu",
  "Name": "Arturo Condo",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uPPNA1i96fvX67TKc2AC"
 },
 {
  "Email": "rwalz@nhg.com.mx",
  "Name": "Mr. Rainer Walz",
  "Document Name": "NHG-#68391-v3-World_Bank_PPP_survey.DOCX",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uPZSLCjtQFZSlLcnFggP"
 },
 {
  "Email": "bobbydemissie@mckinsey.com",
  "Name": "Bobby Demissie",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uQ0rAA1GwJdgsI5mVoz0"
 },
 {
  "Email": "gmendoza@s-s.mx",
  "Name": "Mr. Gustavo Mendoza",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en (230719).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uRIjPe67khkqAF5jPF1b"
 },
 {
  "Email": "enquiries@venture-p.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uRy018iHRc6pRLLMtpQu"
 },
 {
  "Email": "info@tropicaladvocates.com",
  "Name": "Paul John Musede",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uS4WHXIyvhtUZFE2YRHB"
 },
 {
  "Email": "gabriella.szabo@lakatoskoves.hu",
  "Name": "Dr. Gabriella Szab�",
  "Document Name": "HUNGARY) LAKATOS) BI 2020 HUN_bi_PPP_survey_en- finalised version.docx",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uU1bJ40PvopEvlUIl4Vy"
 },
 {
  "Email": "mclima@limayasociados.com",
  "Name": "Maria Cristina Lima",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uVsQg2f2L0rMNd0wuZMB"
 },
 {
  "Email": "ilieva@ddklaw.com.mk",
  "Name": "Mrs. Jasmina Ilieva Jovanovik",
  "Document Name": "BI_2020_MKD_bi_PPP_survey_en_DDK 2.doc",
  "Country": "MKD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uVvJ9pfGFN1vR3MEcy1S"
 },
 {
  "Email": "dbarnett@barlaw.co.il",
  "Name": "David Barnett",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uVvhjnZrWXIMT47NXCIL"
 },
 {
  "Email": "dfoulis@hwle.com.au",
  "Name": "Damien Foulis",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uWThNcFrrwewBmdr5AmA"
 },
 {
  "Email": "jad@jdlo.co.nz",
  "Name": "John Dean",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uWTxjzebcP6qaxnhR7bS"
 },
 {
  "Email": "julian.l.smith@ru.pwc.com",
  "Name": "Julian Smith",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uWVOd8djS6AHplGRNiGL"
 },
 {
  "Email": "carminjon@wanpartners.com",
  "Name": "Charles-Henri Arminjon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uWZJGKEpauGZWC7bk7sV"
 },
 {
  "Email": "n.pasaribu@amoktarina.co",
  "Name": "Mr Noverizki Tri Putra Pasaribu S.H. LL.M. (Adv)",
  "Document Name": "BI 2020 IDN_bi_TPI_survey_an_Oktarina.docx",
  "Country": "IDN",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uZojXIeGdgFLQ8q72Wsy"
 },
 {
  "Email": "lesley.tan@wongpartnership.com",
  "Name": "Lesley Tan",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uaIGz7PHDpj9V6T6llku"
 },
 {
  "Email": "plmwikisa@gmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uaTg9MRge8zJHMpeGpjE"
 },
 {
  "Email": "aivar.raudsik@aaviklaw.ee",
  "Name": "Aivar Raudsik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ubfcXANiWF76RUfHvjw2"
 },
 {
  "Email": "council@hcoj.gov.ge",
  "Name": "Vera Doborjginidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ucCNIrD7WuseZunC2jwP"
 },
 {
  "Email": "hseifzade@gmail.com",
  "Name": "Seifzadeh S. Hossein",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/udhKpG7XB4REK9N7YAzk"
 },
 {
  "Email": "ivar.kiigemagi@ey.com",
  "Name": "Ivan Kiigemagi",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ue3gEgqpOI7HZv48qpV5"
 },
 {
  "Email": "rnunez@consortiumlegal.com",
  "Name": "Roberto Enrique N��ez C�rdova",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ufhCGU1FGsKr0AJSDEAv"
 },
 {
  "Email": "safecon@ethionet.et",
  "Name": "Tihitina Shigizaw Gebre",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ugx09FOwGDEJoUrmTa1R"
 },
 {
  "Email": "riyadh@toban-lawfirm.com",
  "Name": "Sameh M. Toban",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ugzLnnCVYLOd1khR8M3p"
 },
 {
  "Email": "salmahdi@wanpartners.com",
  "Name": "Saad Al-Mahdi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uiQeHg8hi2OS2X9K01Ca"
 },
 {
  "Email": "a.paul@ealc.co.tz",
  "Name": "Miss Angela lPaul",
  "Document Name": "Tanzania - PPP EALC_.docx",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ujaHJtRws5Lx9VQtpvfe"
 },
 {
  "Email": "ahmed.butt@simmons-simmons.com",
  "Name": "Ahmed Butt",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ujf5s1YfLf5Rz8CYy2bi"
 },
 {
  "Email": "mrzayeva@bmlawaz.com",
  "Name": "Ms Mehri Rzayeva",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en_BM Morrison Partners.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ujm9fc21pRNtvrKWIGM0"
 },
 {
  "Email": "tsolola@sololaakpana.com",
  "Name": "Mr Tope Solola",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank Questionairre TPI Document 29-7-19.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ukD61IpicHMT7XxZ6z2P"
 },
 {
  "Email": "jaha@rambler.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ukQgSHZPZjVR9xsIhWjP"
 },
 {
  "Email": "rifjan@yahoo.com",
  "Name": "Mr. Rafiq Jan",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_P&DD_Government of KP province.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ulzqy9X0YOjBpRM6iXcH"
 },
 {
  "Email": "maslova@gsom.spbu.ru",
  "Name": "title Svetlana Maslova",
  "Document Name": "RUSSIA) PROF MASLOVA) BI 2020 RUS_bi_TPI_survey_en_Maslova S.docx",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/undZlpXiJufHPNzPRIfA"
 },
 {
  "Email": "david@rhodespng.com",
  "Name": "David Mackenzie",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uoFbTRUipdejLIWX77r2"
 },
 {
  "Email": "varuzhan@vardanyanlaw.com",
  "Name": "Varuzhan Vardanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uoqmNz33ucntEqW9v6CK"
 },
 {
  "Email": "dlkgathi@orc.info.bw",
  "Name": "Benjamin Bolaane",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/us12krr7EVY0jBQxpXsm"
 },
 {
  "Email": "zimbitiw@gmail.com",
  "Name": "Wilbert Zimbiti",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en.doc-Ronald Mutasa (Zimbabwe) Responses-20-07-19-FINAL.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/usC7SFEHPH7NKCVI2mwm"
 },
 {
  "Email": "cbennett@osler.com",
  "Name": "Chris Bennett",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/utqR4fsCXojZBFlRQZJQ"
 },
 {
  "Email": "admin@phumaphi.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uulCuiH33xwMA82jLcE1"
 },
 {
  "Email": "anita.omonuwa@templars-law.com",
  "Name": "Anita Omonuwa Ogbalu",
  "Document Name": "NIGERIA) TEMPLARS) BI 2020 NGA_bi_PPP_survey_(Templars).docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uuprBwULLePHxZQpXWBg"
 },
 {
  "Email": "godoy@berettagodoy.com",
  "Name": "Mr. Federico Godoy",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_BN2 (FG).docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uvXIPPyxvjtsgdjUvnp5"
 },
 {
  "Email": "mei.nah@maynewetherell.com",
  "Name": "Mei Nah",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uveYUEkBuYcO1dGdRrIW"
 },
 {
  "Email": "maairut@airutlaw.com",
  "Name": "Marie Antoinette Airut",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ux7D2cbxyYZE3R442RZo"
 },
 {
  "Email": "ilma.kasumagic@wolftheiss.com",
  "Name": "Ilma Kasumagic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uxJhSWa8MoqJxDgLFOdD"
 },
 {
  "Email": "astrid.fleisch@gtlaw.com",
  "Name": "Astrid Sophie Fleisch",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uy4fJ8odX73LkPu2sx1V"
 },
 {
  "Email": "o.abdulghani@aaglawfirm.com",
  "Name": "Osama Abdulla Abdulghani",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uyDGrUJIYZdYDhmejFgX"
 },
 {
  "Email": "david.little@dentons.com",
  "Name": "David P. Little",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uyshLjPWigJSb1eIM2wW"
 },
 {
  "Email": "kennychooi@ylp.com.sg",
  "Name": "Kenny Chooi",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uzw73kYctsnmVVB76OZK"
 },
 {
  "Email": "alex@fieldingrobinson.com.au",
  "Name": "Alex Robinson",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/uzwb8Pwmg0XxsZdbE8MJ"
 },
 {
  "Email": "ccimosa@tvcabo.co.mz",
  "Name": "Ant�nio Matos",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v0RKKeZKABxMWA3nJtZk"
 },
 {
  "Email": "atolchinsky@cdcfoundation.org",
  "Name": "Amy Tolchinsky",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v0qZm6DJxcLVYhl7nbx3"
 },
 {
  "Email": "abraham.akkawi@ae.ey.com",
  "Name": "Abraham Akkawi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v12FZgPCcSLeBEHQNwZI"
 },
 {
  "Email": "cmillersmith@whitecase.com",
  "Name": "Caroline Miller Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v1PwjBNXkdilqo2VqEII"
 },
 {
  "Email": "ethan.schultz@skadden.com",
  "Name": "Ethan Schultz",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v28sD1eKqpgt7zY8K5cD"
 },
 {
  "Email": "tomas.venckus@primus.legal",
  "Name": "Tomas Venckus",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v3U88yONUYJdT5LR3Fkk"
 },
 {
  "Email": "kevin.coon@bakermckenzie.com",
  "Name": "Kevin B. Coon",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v4nx2uXrP3ab0othgNYE"
 },
 {
  "Email": "achinula@malawi.net",
  "Name": "Alan Chinula",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v63QFhKFmNxLOF6jJvCm"
 },
 {
  "Email": "rrobles@roblesmiaja.com.mx",
  "Name": "Mr. Rafael Robles",
  "Document Name": "MEXICO) ROBLES MIAJA) BI 2020 MEX_bi_TPI_survey_en (ROBLES MIAJA).docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v6Zijn7WgFVsfKiz00ds"
 },
 {
  "Email": "georg.vonwallis@gtlaw.com",
  "Name": "Georg von Wallis",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v6xD6simVXunKFlmnLvi"
 },
 {
  "Email": "cmillersmith@whitecase.com",
  "Name": "Caroline Miller Smith",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v7zPfWqaUywZ00ClliiM"
 },
 {
  "Email": "gdion@fasken.com",
  "Name": "Guy C. Dion",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v8DbQW4i9BP3g8sNuQPG"
 },
 {
  "Email": "arthur.chung@meredithconnell.co.nz",
  "Name": "Arthur Chung",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v8LKeXTimR7zz5eTsByr"
 },
 {
  "Email": "kalanipitumpe@hsbc.com.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v8NMlhxtQnxYBDc6Rr4f"
 },
 {
  "Email": "kokuragu@yahoo.com",
  "Name": "Jk Ofori Kuragu",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v99hU8GVU2tZxeH1kxjV"
 },
 {
  "Email": "cpennycook@dwpv.com",
  "Name": "Carol Pennycock",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/v9nEhlUqeezDAhtc7nYA"
 },
 {
  "Email": "ian.andrews@linklaters.com",
  "Name": "Ian Andrews",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vBFQ6U2RYzakzqT0jO1U"
 },
 {
  "Email": "namba@mmn-law.gr.jp",
  "Name": "Shuichi Namba",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vBIUswfpetyWRkfrhMMb"
 },
 {
  "Email": "leho.pihkva@glimstedt.ee",
  "Name": "Leho Pskov",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vCalrh9HBprfVU1jUNil"
 },
 {
  "Email": "ekaterina.nekrasova@ru.pwc.com",
  "Name": "Ekaterina Nekrasova",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vCyjX6JyVUjrtmFZdBxi"
 },
 {
  "Email": "mark.thorne@dilloneustace.ie",
  "Name": "Mark Thorne",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vD9qukeWKMcqEF7MbS4F"
 },
 {
  "Email": "tessa.kimber@blplaw.com",
  "Name": "Tessa Kimber",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vEIEsBo6IyF6CRzuBajP"
 },
 {
  "Email": "mibragimov@whitecase.com",
  "Name": "Marat Ibragimov",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vEQ4HxZgsEQApMLSdgBq"
 },
 {
  "Email": "ibrahim@saajlaw.com",
  "Name": "Ibrahim Alajaji",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vEx7ff5y5cqHCnO1mRf0"
 },
 {
  "Email": "kai.mertens@squirepb.com",
  "Name": "Kai Mertens",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vF6yWLlUg7yLV4YQn0Xq"
 },
 {
  "Email": "jvasquez@mef.gob.pe",
  "Name": "Joaqu�n V�squez",
  "Document Name": "PO1.BI 2020 PER_bi_PPP_survey_en (19.07.19).docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vFdqXIsZwm5oygC7DnKq"
 },
 {
  "Email": "douglas@phinc.co.za",
  "Name": "Douglas Henney",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vHl043W4Tj68CbjJaAVT"
 },
 {
  "Email": "christopher.lee@christopherleeong.com",
  "Name": "Mr. Christopher Lee",
  "Document Name": "MALAYSIA) CHRISTOPHER N LEE) BI 2020 MYS_bi_PPP_survey_en.doc",
  "Country": "MYS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vI3q9gEDvWkXSGn1GBnC"
 },
 {
  "Email": "ltarazona@dnp.gov.co",
  "Name": "Ms Laura Tarazona Boh�rquez",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en[1]DNP4.docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vIy2W6JTN8UNL4XjUkr0"
 },
 {
  "Email": "lwells@nixonpeabody.com",
  "Name": "Lisel Wells",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vIzMpwFF2Yc0KSLRyEe1"
 },
 {
  "Email": "nasim.gheidi@gheidilawoffice.com",
  "Name": "Nasim Gheidi",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vJiW5YDHPlw8Gn3EA4A3"
 },
 {
  "Email": "info@coastcolour.co.tz",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vKN7v10fX78wqEpiT5cg"
 },
 {
  "Email": "camilla.burkot@anu.edu.au",
  "Name": "Camilla Burkot",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vM5jnj85kxo5U3rw1yrq"
 },
 {
  "Email": "shadi.haroon@bakerbotts.com",
  "Name": "Shadi Haroon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vMIToOXYfsA0SXBCzxVz"
 },
 {
  "Email": "president@ttgbc.org",
  "Name": "Devanand Ragbir",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vNyoHNlJL8tROxyBbnMo"
 },
 {
  "Email": "ishikawak@gtlaw.com",
  "Name": "Koji Ishikawa",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vP0CqikUiSr4F64Hr5SU"
 },
 {
  "Email": "mkatz@ENSafrica.com�",
  "Name": "Michael Katz",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vPST2kWgeSxfI9zGyODj"
 },
 {
  "Email": "rocenar@yahoo.com",
  "Name": "Remigio Ed. Ocenar",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vRHnQ5APenc7mnly3OEj"
 },
 {
  "Email": "zane.eglite-fogele@primus.legal",
  "Name": "Zane Eglite",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vROC8orfZitZvUlXteFX"
 },
 {
  "Email": "friesecke@uni-bonn.de",
  "Name": "Frank Friesecke",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vTYgr6YW5KmrNxOp92Ja"
 },
 {
  "Email": "bonzom@cmclaw.co.bw",
  "Name": "Mercia B. Makgalemele",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vUTyZ4rUiyKYBZzNI5cw"
 },
 {
  "Email": "ulla.saar@primus.legal",
  "Name": "Ulla Saar",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vUb9pzl4RF3hqAbp4fpP"
 },
 {
  "Email": "sona.taghiyeva@dentons.com",
  "Name": "Ms. Sona Taghiyeva",
  "Document Name": "BI 2020 AZE_Dentons_bi_PPP_survey_en.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vUrYmaHCcvxsho4HxgC2"
 },
 {
  "Email": "pgutermann@akingump.com",
  "Name": "Paul Gutermann",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vVW6K8juNSXfGu8xJw60"
 },
 {
  "Email": "christian.keilich@cliffordchance.com",
  "Name": "CHRISTIAN KEILICH",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vVb3NgrCIkFtaYk01owq"
 },
 {
  "Email": "million.habte@mh-tdlo.com",
  "Name": "Million Habte",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vWKcC1OxAEHISraxpFpV"
 },
 {
  "Email": "trevor.butcher@dlapiper.com",
  "Name": "Trevor Butcher",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vXGChf41PJBUaLnBpuKU"
 },
 {
  "Email": "gho@plesner.com",
  "Name": "Ms Gitte Holts�",
  "Document Name": "DENMARK) PLESNER) World Bank 2020 PPP survey (2).docx",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vXNWrB2ZcCyaUNteNoUY"
 },
 {
  "Email": "info@qureshilawassociates.com",
  "Name": "Mr Adnan Qureshi",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_en_Qureshi.doc",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vXuokTsizQTLo3o1PhPA"
 },
 {
  "Email": "alarrea@bustamante.com.ec",
  "Name": "Mr. Alfredo Larrea",
  "Document Name": "BI 2020 ECU_bi_PPP_survey_en.1.docx",
  "Country": "ECU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vY6PianBfbTMv5U1BKMp"
 },
 {
  "Email": "wbahar@bahar.co.id",
  "Name": "Mr. Wahyuni Bahar",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_Bahar.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vYJ3vxBvc8z0u8Zkg9jy"
 },
 {
  "Email": "sivi@patherandpather.co.za",
  "Name": "Sivi Pather",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vZamPXSr6qMS3Zv0mKQS"
 },
 {
  "Email": "umair@aml.com.af",
  "Name": "Mohammad Umair",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vaa7o5xiGrtArMLK5dhO"
 },
 {
  "Email": "indrek.kangur@varul.com",
  "Name": "Indrek Kangur",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vav5FEWndw1CdP5NurE6"
 },
 {
  "Email": "nsakellariou@dellislaw.gr",
  "Name": "Mrs Nadia Sakellariou",
  "Document Name": "GREECE) DELLIS_SAKELLARIOU) BI 2020 GRC_bi_PPP_survey_en.docx",
  "Country": "GRC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vcA49ltrAALbfgSXipQR"
 },
 {
  "Email": "abogado@ernestocedeno.com",
  "Name": "Ernesto Cede�o",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vcUwPfIsF6sWm9g2Hffk"
 },
 {
  "Email": "info@anekgroup.com",
  "Name": "Anek Srisanit",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vccB6iZyxj6sanaOCIuS"
 },
 {
  "Email": "DeBuys.Scott@kpmg.co.za",
  "Name": "Scott Debuys",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vcqoirqOsIt53Uj0es2t"
 },
 {
  "Email": "alooma@slcb.biz",
  "Name": "Idriss Alooma Kamara",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vcuKtgMmjPd4dDkS6YRx"
 },
 {
  "Email": "ala@horten.dk",
  "Name": "Anne Louise Haack Andersen",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vcvepTysbFAhlzVEW0vU"
 },
 {
  "Email": "LHM@foleyhoag.com",
  "Name": "Lawrence Martin",
  "Document Name": "-",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vd72KcimHx32yI2ccRWF"
 },
 {
  "Email": "jscotto@chadbourne.com",
  "Name": "Julie Scotto",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vdk6n0KUseGDv2GF11KS"
 },
 {
  "Email": "TZSakala@idbz.co.zw",
  "Name": "Mr Thomas Zondo Sakala",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en IDBZ.doc.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ve9M5fZMUPvMM4Mh6Te2"
 },
 {
  "Email": "simon.huxley@allenovery.com",
  "Name": "Mr Simon Huxley",
  "Document Name": "AU TPI Survey_Allen and Overy.doc",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/veKXKrSQhWZdCm6kBVuS"
 },
 {
  "Email": "michael.wigley@wigleylaw.com",
  "Name": "Michael Wigley",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vgF7dOaClpjWMFAuGXcU"
 },
 {
  "Email": "carminjon@wanpartners.com",
  "Name": "Charles-Henri Arminjon",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vghxpOQTIK3E4TxNSe7H"
 },
 {
  "Email": "aibr@kimep.kz",
  "Name": "Aigerim Ibrayeva",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vhcGqCLIJN5t1qgskaf9"
 },
 {
  "Email": "jmendoza@iqsh.com.mx",
  "Name": "Lic. Jesus Mendoza Henriquez",
  "Document Name": "MEXICO) IBANEZ) World BI 2020 MEX_bi_TPI_survey_en (003).docx REV JMH DA 2.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vhi7wfVgCIRCfOkBtH5b"
 },
 {
  "Email": "tazchaponda@gmail.com",
  "Name": "Taziona Chaponda",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vi6AiET67xDf0iEnCJyf"
 },
 {
  "Email": "emiliana.obrien@dentons.com",
  "Name": "Ms. Emiliana O'Brien",
  "Document Name": "For World Bank PPP v3.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/viZVqD31i0Xn9wVeFQsC"
 },
 {
  "Email": "peter.livesey@ipa.gov.uk",
  "Name": "Mr Peter Livesey",
  "Document Name": "BI 2020 GBR_bi_PPP_survey_en_PO_IPA.docx",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vizW6fK9LDKH5Go7h8mD"
 },
 {
  "Email": "lawrence.rodkin@sr-law.co.uk",
  "Name": "Lawrence Rodkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vjH0B3maAjr356yXb1CY"
 },
 {
  "Email": "reginald@kimathilegal.com",
  "Name": "Mr Reginald Nii Odoi",
  "Document Name": "BI 2020 GHA_bi_PPP_survey_en (KnPr).docx",
  "Country": "GHA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vjYu5rdFR3m5iHBn1rIt"
 },
 {
  "Email": "kmarkman@ENSafrica.com�",
  "Name": "Kevin Markman",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vjtL2M7LhmRn3PvWVHV7"
 },
 {
  "Email": "tanyawaksman@eversheds-sutherland.co.za",
  "Name": "Tanya Waksman",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vkZxjlIt23oP2V8q5YEQ"
 },
 {
  "Email": "eduardo@erplawyers.com",
  "Name": "Eduardo Rojas Piedra",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vkj1EAielz0Tq38GkJPO"
 },
 {
  "Email": "akitchen@kpmg.com.au",
  "Name": "Alison Kitchen",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vl4kTVwMmlbk1AIlqTl2"
 },
 {
  "Email": "olga.vijard@sorainen.com",
  "Name": "Olga Vijard",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vlDRgJUuXYJqV80zptms"
 },
 {
  "Email": "kristen.vieira.traynor@us.pwc.com",
  "Name": "Kristen Vieira Traynor",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vloWYeCSHmK5QwAJwnxk"
 },
 {
  "Email": "info@massygroup.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vlz22kAv6UnvxWsYqGSK"
 },
 {
  "Email": "gigi@transparency.ge",
  "Name": "Gigi Chikhladze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vmH5NlnIgDRWSvyoMymT"
 },
 {
  "Email": "james.stewart@kpmg.co.uk",
  "Name": "James Stewart",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vncZXIlj4N0FLX1R9xLc"
 },
 {
  "Email": "zashcroft@winston.com",
  "Name": "Zoe Ashcroft",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vnlTENTZOvkFZ3XQL00b"
 },
 {
  "Email": "Olatungiec@yahoo.com",
  "Name": "C.A Campbell",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/voFRY3IoLT8D47x0LgWO"
 },
 {
  "Email": "indrek.grauberg@tlu.ee",
  "Name": "Indrek Grauberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vpYm5LKIuVKt7JNrPOcr"
 },
 {
  "Email": "amela.selmanagic@wolftheiss.com",
  "Name": "Amela Selmanagic",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vpgyn7LlFYulvaF4bdOr"
 },
 {
  "Email": "vip-cons@mail.ru",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vqZC9zEJdOrXtYD8HBwi"
 },
 {
  "Email": "alisinunia@tmplaw.com",
  "Name": "Alisi Nunia Taumoepeau",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vqlVXMpR8YMOCGUdUFtf"
 },
 {
  "Email": "mohammed.al-ghamdi@nortonrosefulbright.com",
  "Name": "Mohammed Al-Ghamdi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vr8RCSOL6Eqzr3w0gaUC"
 },
 {
  "Email": "jhoan.prato@alimakhek.com",
  "Name": "Jhoan Prato",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vsjjlaJhtbWOTMul2EIQ"
 },
 {
  "Email": "venica@fe.gov.mz",
  "Name": "Mr. Louren�o Veni�a",
  "Document Name": "MOZAMBIQUE) ROAD FUND) BI 2020 MOZ_bi_PPP_survey_en_Venica.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vtowSWh6Qq2iUmSdOlwm"
 },
 {
  "Email": "kaido.pihlakas@heta.ee",
  "Name": "Kaido Pihlakas",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vtyW1Et26ZftjJtyVF7L"
 },
 {
  "Email": "annaromano@sattaromano.it",
  "Name": "Ms Anna Romano",
  "Document Name": "Partenariato pubb priv_ITA_Anna_Romano .docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vuPwDC6Ycy97p4MEKCnw"
 },
 {
  "Email": "sharabidze@blb.ge",
  "Name": "Kakha Sharabidze",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vufQFPR4XS04zHnxXpW7"
 },
 {
  "Email": "rarancio@grimaldilex.com",
  "Name": "Ms Rosaria Arancio",
  "Document Name": "ITA_bi_TPI_survey_en _Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vvVirn13U2tm1dDhA7Pa"
 },
 {
  "Email": "wolfram.hertel@raue.com",
  "Name": "Hertel Wolfram",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vvh4w9ywQNi0bEo2381W"
 },
 {
  "Email": "denbow@denlawtt.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vvn4RAmmjkzdr6lwpr4w"
 },
 {
  "Email": "info@loudred.co.uk",
  "Name": "Phil Matthews",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vwXQuC3U6prZAf9j9hcp"
 },
 {
  "Email": "glenn.lovell@me.kwm.com",
  "Name": "Glenn Lovell",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vx8KWNKpsLAXUTZ3DxsQ"
 },
 {
  "Email": "eyobgt3@yahoo.com",
  "Name": "Eyob Ghezai",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vxYvu8mFAAJoizMDdztH"
 },
 {
  "Email": "maidu.kaasik@aaviklaw.ee",
  "Name": "Maidu Kaasik",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vyeH9qvzBz1wxQ1na3si"
 },
 {
  "Email": "caiomario@pnm.adv.br",
  "Name": "Mr. Caio M�rio Pereira Neto",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial PPP vfinal.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vygxL0BHzijrcm8p27ez"
 },
 {
  "Email": "david.ehrenwerth@klgates.com",
  "Name": "David Ehrenwerth",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/vznZZ3Bh8Cj6yZH6nkrL"
 },
 {
  "Email": "medine.akhaeva@centil.law",
  "Name": "?????? ??????",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_ru_Centil.doc",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w07eA2oTd0P4B8zxTqQi"
 },
 {
  "Email": "Sekr.Hermes@jur.uni-frankfurt.de",
  "Name": "Georg Hermes",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w0e8EXqComURfSKs25ch"
 },
 {
  "Email": "khathlan@ksu.edu.sa",
  "Name": "Khalid Al-Khathlan",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w0j2JNDiF9SQkvOiLe8s"
 },
 {
  "Email": "andrew.petry@simmons-simmons.com",
  "Name": "Andrew Petry",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w0yWhGqPFsHJBhDWDHp8"
 },
 {
  "Email": "mp@vda.pt",
  "Name": "Mr. Manuel Prot�sio",
  "Document Name": "BI 2020 PRT_bi_PPP_survey_en (002)_(DM 7606538_1) (002) (003).DOCX_(DM 7641292_1).DOCX",
  "Country": "PRT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w2buFUDcgHUuZ2If6aqB"
 },
 {
  "Email": "leon.larrain@bakermckenzie.com",
  "Name": "Mr Leon Larrain",
  "Document Name": "BI 2020 CHL_bi_PPP_survey_en (003) (002).Bakerdocx.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w3VfNiD5k9Q9dD1rwDin"
 },
 {
  "Email": "bernard.lui@stamfordlaw.com.sg",
  "Name": "Lynette Chew",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w3xGr23c2e6t9d3s10YJ"
 },
 {
  "Email": "prome@promeconsult.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w4GWjrM5Vw17zxP3X6f0"
 },
 {
  "Email": "scott.mccoy@allens.com.au",
  "Name": "Mr Scott McCoy",
  "Document Name": "BI 2020 AUS_BI_PPP_Survey_en_Allens.docx",
  "Country": "AUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w5OyEDcesd1FuYNMjnNJ"
 },
 {
  "Email": "helen.scott-lawler@burges-salmon.com",
  "Name": "Helen Scott Lawler",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w6i5BfkfTsJKfxbI4OAH"
 },
 {
  "Email": "michael.kariya@blakes.com",
  "Name": "Michael Kariya",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w6kQk1EybknIBd4KwRm1"
 },
 {
  "Email": "sesibaloyi@law.co.za",
  "Name": "Sesi Baloyi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/w9RtRFIjaXaKXpK643DA"
 },
 {
  "Email": "raith.pickup@mills-reeve.com",
  "Name": "Raith Pickup",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wA26TzyoIDKip4jpYZtW"
 },
 {
  "Email": "hcubero@abpcr.com",
  "Name": "Hannia Cubero",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wA7IMDno5Qysd3frZKMx"
 },
 {
  "Email": "paul.kibuuka@isidoralaw.co.tz",
  "Name": "Paul Kibuuka",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wA8decDDYlgWwTiLWqoA"
 },
 {
  "Email": "sgizaw@deloitte.com",
  "Name": "Solomon Gizaw",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wAPKjl6xYXRiPoc7Kbt4"
 },
 {
  "Email": "chris.sargisson@norfolkchamber.co.uk",
  "Name": "Chris Sargisson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wBMkRi2h6lZcUu1mln74"
 },
 {
  "Email": "rutt.vark@primus.legal",
  "Name": "Rutt Vark",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wC5F6vmPuV5ZBo9EXhKc"
 },
 {
  "Email": "ulrik.sanders@bcg.com",
  "Name": "Ulrik Sanders",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wC891SedkFtYtMKIKlve"
 },
 {
  "Email": "samuel.castro@mattosfilho.com.br",
  "Name": "Mr. Samuel Olavo Castro",
  "Document Name": "BI 2020 BRA_bi_concession_survey_en (05.08.2019).DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wCtEbHTay3xYJ63kv449"
 },
 {
  "Email": "Ian.Colotla@bcg.com",
  "Name": "Ian Colotla",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wD0Rw8IiJ7g6EahUKPf5"
 },
 {
  "Email": "marcin.oszczak@cms-cmno.com",
  "Name": "Mr. Marcin Oszczak",
  "Document Name": "BI 2020 POL_bi_PPP_survey_en_CMS.docx",
  "Country": "POL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wFNwb3Lmrb4bBZqjE71v"
 },
 {
  "Email": "info@hbg.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wFVbq0mjRQwrBTOfSBYE"
 },
 {
  "Email": "cgomero@lq.com.pe",
  "Name": "Dr. Carlos Gomero Rigacci",
  "Document Name": "BI 2020 PER_bi_PPP_survey_en 2.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wFdQSrsTSXMDMX7ULoVF"
 },
 {
  "Email": "fmcniel@velaw.com",
  "Name": "D. Ferguson Mcniel, Iii",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wG5JvKoIJXihjdb6PkJ9"
 },
 {
  "Email": "egle.kavoliunaite@teise.org",
  "Name": "Dr. Egle Kavoliunaite-Ragauskiene",
  "Document Name": "BI 2020 LTU_bi_PPP_survey_en.docx",
  "Country": "LTU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wGgOj80uLIiTpVQhaHaM"
 },
 {
  "Email": "msazos@sofocleous.com.cy",
  "Name": "Menelaos Sazos",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wGn7nrB1pOwOvYQras3u"
 },
 {
  "Email": "richards@telfer.uOttawa.ca",
  "Name": "Greg Richards",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wHhi1PWnvhP2SMh5VIKj"
 },
 {
  "Email": "catherine.merity@maddocks.com.au",
  "Name": "Cartherine Merity",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wITfODc9dXDpPEVuAzNA"
 },
 {
  "Email": "maivi.ots@eversheds-sutherland.ee",
  "Name": "Maivi Ots",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wIeWQdbUbs8gMGSZ4mLr"
 },
 {
  "Email": "elegrange@ENSafrica.com",
  "Name": "Eric Le Grange",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wJDegzRIbiE3R0PqCkfo"
 },
 {
  "Email": "suaalexander@gmail.com",
  "Name": "Alexander Su'A",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wJzarfoHmyImyegn2s7e"
 },
 {
  "Email": "nzervos@velmalaw.com",
  "Name": "Nicholas Zervos",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wLOp7Aqj5KNsicbwaKtz"
 },
 {
  "Email": "anna.soroka@whitecase.com",
  "Name": "Anna Soroka",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wLbUWtt3uURsIbHHrQPR"
 },
 {
  "Email": "cambodia@dfdl.com",
  "Name": "Mr. Guillaume Massin",
  "Document Name": "BI 2020 KHM_bi_PPP_survey_en (27082019)_Leab Seng.docx",
  "Country": "KHM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wNV5p6r23XlqTM5ZMOOj"
 },
 {
  "Email": "billjamieson@cnplaw.com",
  "Name": "Bill Jamieson",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wO93HvWcy6FKFgev6Vyc"
 },
 {
  "Email": "joanne.emersontaqi@nortonrosefulbright.com",
  "Name": "Joanne Emerson Taqi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wOci083ZYWgEIf0xfRkw"
 },
 {
  "Email": "carlos.arrea@caobalegal.com",
  "Name": "Mr. Carlos Arrea",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en (C.A. rev).docx",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wOujVFHiNgShAK87v1ms"
 },
 {
  "Email": "triin.raudsepp@varul.com",
  "Name": "Triin Raudsepp",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wOxdkWSipysndEwYDPOD"
 },
 {
  "Email": "janno.kuusk@sirel.com",
  "Name": "Janno Kuusk",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wP7z1xED7XDU8m41akMn"
 },
 {
  "Email": "nicole.heller@au.kwm.com",
  "Name": "Nicole Heller",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wPP8st2mWzGPRF0cW13t"
 },
 {
  "Email": "josemanuel.larrain@dentons.com",
  "Name": "Mr. Jos� Manuel Larra�n",
  "Document Name": "For World Bank PPP v3.docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wPjPIKFKMYB3aFGz2fj0"
 },
 {
  "Email": "caroline.sherrell@whitecase.com",
  "Name": "Caroline Sherrell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wPmpbkR2lwIifsN6fAlI"
 },
 {
  "Email": "hamidjapan@gmail.com",
  "Name": "Hamid Alsubaei",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wQEdSR7ss3JR3S0wrCrd"
 },
 {
  "Email": "president@westcoastuniversity.edu.pa",
  "Name": "S. Lloyd",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wQSj0PiTstRrPwbLX4Fl"
 },
 {
  "Email": "info@spa5.cz",
  "Name": "Al�b?tiny L�zn?",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wQZdZgvhgN6b0UpN7zXD"
 },
 {
  "Email": "edoi@foley.com",
  "Name": "Etsuo Doi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wQhR7CFqQEsvZisDIj43"
 },
 {
  "Email": "tonis.tamme@triniti.ee",
  "Name": "Tonis Tamme",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wRMJD0eIuy15sze2S5b2"
 },
 {
  "Email": "bruno.bordignon@avid.legal",
  "Name": "Bruno Bordignon",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wSWYURSA0CDIKNZYfTN8"
 },
 {
  "Email": "fedya0094@mail.ru",
  "Name": "Phiruz Barotov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wSfWvBa7GBGZFX5VO6AN"
 },
 {
  "Email": "plima@demarest.com.br",
  "Name": "Ms. Paloma Lima",
  "Document Name": "DEMAREST_SP-#10961845-v1-2019_08_02_BI_2020_BRA_bi_concession_survey_en.DOCX",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wT8Tdx0jtwoayCcEYAGQ"
 },
 {
  "Email": "zsudairy@zaaslaw.com",
  "Name": "Ziad Al-Sudairy",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wTXExOAix3dgV7Je6N28"
 },
 {
  "Email": "katerina.helikarova@mfcr.cz",
  "Name": "Ms. Katerina Helikarova",
  "Document Name": "BI 2020 CZE_bi_PPP_survey_en_Ministry of Finance.docx",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wU0udgEOjA7OKQ7UrWpG"
 },
 {
  "Email": "geoff@martellimckegg.co.nz",
  "Name": "Geoff Hardy",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wUQUskX2BMzuENETgVWJ"
 },
 {
  "Email": "nharic@gmail.com",
  "Name": "Mooka Mushemi",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wVDsBnAu6Lhy9CoCXbfU"
 },
 {
  "Email": "jdewar@milbank.com",
  "Name": "Mr John Dewar",
  "Document Name": "BI 2020 GBR_bi_PPP_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wVEkA227znvnjDmtb5N9"
 },
 {
  "Email": "jaristy@rvhb.com",
  "Name": "Miss Jeanny Aristy",
  "Document Name": "BI 2020 DOM__bi_PPP_survey_en.doc (00137128xA81FF).docx",
  "Country": "DOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wVQkfF3oBZEJkmsPflLe"
 },
 {
  "Email": "kimseng.lo@stamfordlaw.com.sg",
  "Name": "Kim Seng Lo",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wW50aNMlZ5uxzQpwGx7T"
 },
 {
  "Email": "ebome@carlsonwagonlit.ee",
  "Name": "Ene Bome",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wXigMOMSzufxsy2XYzFT"
 },
 {
  "Email": "cmrsgo@syciplaw.com",
  "Name": "Mr. Carlo Miguel Romeo S. Go",
  "Document Name": "BI 2020 PHL_bi_PPP_survey_en SyCipLaw_rev 20190902.docx",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/waJu3Oh8L215Bes4P0VT"
 },
 {
  "Email": "rvillatoro@novales.com.gt",
  "Name": "Roselyn Villatoro",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/waRQ9NeBkinBZ0GhoWR4"
 },
 {
  "Email": "ringoeric@yahoo.com",
  "Name": "Eric Frank Ringo",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/waagjj47ObW0VWLxA7g6"
 },
 {
  "Email": "yousef.wahbah@ae.ey.com",
  "Name": "Yousef Wahbah",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wamwOD663xrKZK8fj5DP"
 },
 {
  "Email": "pm@nohr-con.dk",
  "Name": "Peter Melgaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wb0irLGUsUjaCn2RkdDK"
 },
 {
  "Email": "info@kone-areeco.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wb7WKxetjXHImfbfgv7R"
 },
 {
  "Email": "info@bankgaborone.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wbPCslhhzTZ6j6CIO2yW"
 },
 {
  "Email": "Kamil.Jambakiyev@nortonrosefulbright.com",
  "Name": "Kamil Jambakiyev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wboobgiKGH8qrMB58eVr"
 },
 {
  "Email": "giorgi.gaprindashvili@tsu.ge",
  "Name": "George/Giorgi Gaprindashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wcm1IC25NuMlmHZRYrUN"
 },
 {
  "Email": "Ori.Primo@evronlaw.com",
  "Name": "Ori Primo",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wcvNOqOoWxIwFPczZCli"
 },
 {
  "Email": "hku@kammeradvokaten.dk",
  "Name": "Henrik Kure",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wdh84SJCZ6FrJnFfue9V"
 },
 {
  "Email": "mgdaly@mgdaly.com",
  "Name": "Martin G. Daly",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/we6PEEntlOaxctg22r7G"
 },
 {
  "Email": "arabian@bemco.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/weOPQ8lDGeznm9DOzAfz"
 },
 {
  "Email": "nbuckworth@shearman.com",
  "Name": "Nicholas Buckworth",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/weQTYYQlbKYj43yfMPqq"
 },
 {
  "Email": "olof.hallberg@cirio.se",
  "Name": "Mr Olof Hallberg",
  "Document Name": "SWEDEN) CIRIO LAW) BI 2020 SWE_bi_PPP_survey_FINAL.docx",
  "Country": "SWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/weqglk0wPC9HYAlBm6oa"
 },
 {
  "Email": "infodancomp@gmail.com",
  "Name": "??????? ????? ????????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wfFAkzU0PnQ9WPojgPv8"
 },
 {
  "Email": "admin@alphaengtt.com",
  "Name": "Leigh Mcmayo",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wg17lOC5jR9KhWrI3ojj"
 },
 {
  "Email": "rbec.directorate@undp.org",
  "Name": "Irakli Kotetishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgBfYrgKPgKHOt7PuzMM"
 },
 {
  "Email": "volkmar.wagner@cms-hs.com",
  "Name": "Volkmar Wagner",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgF1kFp3KYbQYX8O6vhF"
 },
 {
  "Email": "aboghossian@arax.am",
  "Name": "Ashot Boghossian",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgObUZ5qd8s7htCojqWu"
 },
 {
  "Email": "huw.jenkins@cliffordchance.com",
  "Name": "Huw Jenkins",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgdAZ9UQOXJAIzbIhF68"
 },
 {
  "Email": "general@srilankalawyer.com",
  "Name": "Jagath Hemantha",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgfu7ql9Ks8ZX07Vb2gh"
 },
 {
  "Email": "Carlo.Alloni@mitie.com",
  "Name": "Carlo Alloni",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wgjOV62HmvKKLwvlAG8s"
 },
 {
  "Email": "info@ttifc.co.tt",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/whgh5UowrxrUXs1SHASy"
 },
 {
  "Email": "nzinfo@ford.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wi9NsejymuY3HJH029fK"
 },
 {
  "Email": "companysecretarial@srilankalawyer.com",
  "Name": "M. Dissanayaka",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wiMAwcq4ufpaOSdkDuiB"
 },
 {
  "Email": "martin.hamer@gtlaw.com",
  "Name": "Martin Hamer",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wizFxtQVpnVBYADHzgF5"
 },
 {
  "Email": "angus.mitchell@dfdl.com",
  "Name": "Angus Mitchell",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wjsAPkB7XqSqkr61bih7"
 },
 {
  "Email": "nsinanan@jcscaribbeanlaw.com",
  "Name": "Nicholas Sinanan",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wjwFAkkAuk1VsLUkBkuz"
 },
 {
  "Email": "ml.manaligod@cruzmarcelo.com",
  "Name": "Manuel, Jr. Manaligod",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wjx9VauEKSUnVzTf9BZn"
 },
 {
  "Email": "igor.verkhovodko@verkhovodko.com",
  "Name": "Mr. Igor Verkhovodko",
  "Document Name": "BI 2020 BLR_bi_PPP_survey_en_V&P.docx",
  "Country": "BLR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wkHN0Wmzm6vyjfFEnzQS"
 },
 {
  "Email": "oumejima@whitecase.com",
  "Name": "Osamu Umejima",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wkTW6SI1kZwJz6HWmssV"
 },
 {
  "Email": "fahenriques@hrlegalcircle.com",
  "Name": "Ms. Fabr�cia de Almeida Henriques",
  "Document Name": "BI 2020 MOZ_bi_PPP_survey_en.docx",
  "Country": "MOZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wl0BJggXCZmAkngGgiuW"
 },
 {
  "Email": "peter.koves@lakatoskoves.hu",
  "Name": "Dr. P�ter K�ves",
  "Document Name": "HUNGARY) LAKATOS) BI 2020 HUN_bi_PPP_survey_en- finalised version.docx",
  "Country": "HUN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wlLHPJNiy7j35sWkUq51"
 },
 {
  "Email": "pconlin@conlinbedard.com",
  "Name": "Paul Conlin",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wlw0SSmE9dNu7SPMQesc"
 },
 {
  "Email": "dr.khalil@unitedlawyersfirm.com",
  "Name": "Khalil A. Khalil",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wmNfUWu5FoEcoOBJSeAD"
 },
 {
  "Email": "daniele.archilletti@pwc.com",
  "Name": "Mr. Daniele Archilletti",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Federica De Luca.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wnG5wk2IAI4NqMpQKUPp"
 },
 {
  "Email": "cibarra@ibarrapg.com?????",
  "Name": "Mr. Carlos Ibarra Fern�ndez",
  "Document Name": "BI 2020 MEX_bi_PPP_survey_en.doc (004).docx",
  "Country": "MEX",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wnLsvCS1UclzigOj49K4"
 },
 {
  "Email": "areg@ameria.am",
  "Name": "Areg Lazaryan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wob4BFvgKtZQLuAPGuSQ"
 },
 {
  "Email": "info@jittuhorticulture.com",
  "Name": "Sheikh Mohammed Hussein Al-Amoudi",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wodZVYCAM3OwHFO1vzLY"
 },
 {
  "Email": "nick.whittington@meredithconnell.co.nz",
  "Name": "Nick Whittington",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wp1kprqRK5DP3M9X4yVo"
 },
 {
  "Email": "rac@raclawoffice.com",
  "Name": "Robert A. Cedeno",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wpF0uxe7nPCOOdhZglH1"
 },
 {
  "Email": "Fleur.Clegg@AllenOvery.com",
  "Name": "Fleur Clegg",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wpWaIvjfXFZQFLE8v0kj"
 },
 {
  "Email": "kristi.lehtis@sorainen.com",
  "Name": "Kristi Lehtis",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wpbJv3c3hUHYW49U47HF"
 },
 {
  "Email": "amelkumyan@fidelitylegal.am",
  "Name": "Armen Melkumyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wplxyQRp04s9NB6WdoW4"
 },
 {
  "Email": "magaqs@maga.lk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wpxyJbgMefQ6QJr7hvff"
 },
 {
  "Email": "mzdravkova@penev.eu",
  "Name": "Ms. Manuela Zdravkova",
  "Document Name": "BI 2020 BGR_bi_PPP_survey_en_PENEV_LLP_Aug_2019.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wqSvUykagXjlgH4zHJKP"
 },
 {
  "Email": "andrea.contreras@legalsa.com",
  "Name": "Andrea Contreras",
  "Document Name": "-",
  "Country": "GTM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wqjtJyLGdLN6XGG3o6zi"
 },
 {
  "Email": "wesley.veekman@pianoo.nl",
  "Name": "Mr Wesley Veekman",
  "Document Name": "BI 2020 NLD_bi_PPP_survey_en_PIANO.docx",
  "Country": "NLD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wr5km7hpMbASZwqBGFUx"
 },
 {
  "Email": "laytheng.kua@wongpartnership.com",
  "Name": "Lay Theng Kua",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ws1UhujlfY1sWFjs0ZWs"
 },
 {
  "Email": "driranpour@yahoo.com",
  "Name": "Iranpour Farhad",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wtr4R7ge8u4W98ijtpr0"
 },
 {
  "Email": "Uwe-Carsten.Voellink@heussen-law.de",
  "Name": "UWE-CARSTEN V�LLINK",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wuHWv3QcgBJsHpVkmKg7"
 },
 {
  "Email": "info@cci.kg",
  "Name": "Marat Sharshekeev",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wuYrSE89LrckcqUrk9UK"
 },
 {
  "Email": "tradedirector@panamcham.com",
  "Name": "Pilar V. Cer�n",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wvVMF2Ugz5w4FUn2CEAk"
 },
 {
  "Email": "sandra@leedsareachamber.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wvZrNGapTmLOR3w7QrMc"
 },
 {
  "Email": "cassam@cspabogados.com.ar",
  "Name": "Mr. Mario Eduardo Castro Sammartino",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en.doc",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wwDWW8iafZFSu7Y5vKuM"
 },
 {
  "Email": "maarten.wolfs@ae.pwc.com",
  "Name": "Maarten Wolfs",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wwOsLQ15vndWkN4GEET7"
 },
 {
  "Email": "luislainez@lainezlaw.com",
  "Name": "Luis Fernando La�nez",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wx0DwL1zvquIAw8QAF5D"
 },
 {
  "Email": "dany.labaky@alessalaw.com",
  "Name": "Mr. Dany Labaky",
  "Document Name": "PPP_survey_en (DEL 11-9-2019).docx",
  "Country": "KWT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wyYgzGzf0Hovmw15S3QA"
 },
 {
  "Email": "mawada@aihlawfirm.com",
  "Name": "Ms. Mawada Ahmed",
  "Document Name": "BI 2020 SDN_bi_PPP_survey_en_Kayan.docx",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wyp6ipFgJuAGluA8zhot"
 },
 {
  "Email": "walter.heiser@dfdl.com",
  "Name": "Mr. Walter Heiser",
  "Document Name": "LAO) DFDL) World Bank_Lao PDR PPP Survey_201819.docx",
  "Country": "LAO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wz18hOSka6wqoi41aaVQ"
 },
 {
  "Email": "keijo.lindeberg@lindeberg.legal",
  "Name": "Keijo Lindeberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wzhtmAECrkZJ8HlB2Yrj"
 },
 {
  "Email": "inquiries@tcmrlaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/wzrekjHbx3z6BIwDwyp0"
 },
 {
  "Email": "aubrey.garcia@yahoo.com",
  "Name": "Aubrey E. Garcia",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x0ZEDcXSoHw9A7DTlcE7"
 },
 {
  "Email": "info@hatamilawfirm.com",
  "Name": "Zahra Darvish",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x0wxvWk3puh8rXfeF4xJ"
 },
 {
  "Email": "peter.beekink@lavanlegal.com.au",
  "Name": "Peter Beekink",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x1PcVWUwzHnuYbij3Hv6"
 },
 {
  "Email": "tvilakazi@gminc.co.za",
  "Name": "Thenjiwe Vilakazi",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x4PBsQo2NHdLYHwgu2mz"
 },
 {
  "Email": "berhanum@ethionet.et",
  "Name": "Berhanu Mengiste Mulat",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x5gYdRKwOMDOAowXE1SO"
 },
 {
  "Email": "adeola.sunmola@uubo.org",
  "Name": "Mrs Adeola Sunmola",
  "Document Name": "NIGERIA) UUBO) BI 2020 NGA_bi_TPI_survey_en (UUBO Contribution) 15082019.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x6olpoBjyLHtLuTEK06p"
 },
 {
  "Email": "peter.bachmann@noerr.com",
  "Name": "Peter Bachmann",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x7011xcPlKMHv5lTPJMD"
 },
 {
  "Email": "mbw@mbw.co.ug",
  "Name": "Patrick Batumbya",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x7Gipjvy3IjJw8CO0dL0"
 },
 {
  "Email": "stefanie.atchinson@squirepb.com",
  "Name": "Stefanie Atchinson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x8FTwCIww2GiLEY5FmEW"
 },
 {
  "Email": "DeBuys.Scott@kpmg.co.za",
  "Name": "De Buys Scott",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/x8XWCZU779e424rLMHZm"
 },
 {
  "Email": "andronikosn@sullcrom.com",
  "Name": "Nikolaos Andronikos",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xB7voJClitxh6WrN7Z1m"
 },
 {
  "Email": "info@dansultlogistics.com",
  "Name": "Dan Mugara",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xBRt13oE9PIAHK0B0ZWv"
 },
 {
  "Email": "sserebrenik@godoyhoyos.com",
  "Name": "Ms. Steffany Serebrenik Beltr�n",
  "Document Name": "BI 2020 COL_bi_PPP_survey_en (SSB).docx",
  "Country": "COL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xCEWf1JcQ6efZ8zsU6fS"
 },
 {
  "Email": "rebecca.timms@blplaw.com",
  "Name": "Rebecca Timms",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xCXBWSFOlvvYRO3p4GeQ"
 },
 {
  "Email": "matias.wallgren@castren.fi",
  "Name": "Mr Matias Wallgren",
  "Document Name": "FINLAND) CASTREN) World Bank Questionnaire PPP 2020, FIN, 2 August 2019 (9687111_5).DOCX",
  "Country": "FIN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xCoQPD6MsIWufRDsZbif"
 },
 {
  "Email": "john.cassels@fieldfisher.com",
  "Name": "John Cassels",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xDYrGLckzL2xDlyrHB5x"
 },
 {
  "Email": "greg.horton@hhl.co.nz",
  "Name": "Greg Horton",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xEC8ya3CeQ7oJmKKW5iW"
 },
 {
  "Email": "heather-latu@latulaw.com",
  "Name": "Taulapapa Heather-Latu",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xEvq9dOCQppePdFZUgf4"
 },
 {
  "Email": "Amitha_gooneratne@combank.com",
  "Name": "Amitha Lal Gooneratne",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xGDCU0qpdIYkLkimWBSL"
 },
 {
  "Email": "nsadler@tglaw.com.au",
  "Name": "Neil Sadler",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xGjmJp9FZa94vDqz0u4U"
 },
 {
  "Email": "tram.dao@indochinecounsel.com",
  "Name": "Ms. Thi Bich Tram Dao",
  "Document Name": "VIETNAM) INDOCHINE COUSEL) BI 2020 VNM_bi_TPI_survey_EN-20190806.doc",
  "Country": "VNM",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xGqwyPumMlmIT3qHUZF3"
 },
 {
  "Email": "a.kozmina@maximalegal.ru",
  "Name": "Alina Kozmina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xHMCowfQIdNQs5tVfNvS"
 },
 {
  "Email": "ylee@orrick.com",
  "Name": "Young Lee",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xHlE37uWtKVLmTVZnDWc"
 },
 {
  "Email": "yoji-maeda@omm.com",
  "Name": "Yoji Maeda",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xI3FjojeyV862xdQ2w2W"
 },
 {
  "Email": "priszaballero@cdmzlaw.com",
  "Name": "Priscilla F. Zaballero",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xIFR0HA5QvZUvVe9TFGz"
 },
 {
  "Email": "shiara@sudathpereraassociates.com",
  "Name": "Shiara Sellamuttu",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xJ2xJ0lbYabgYGHzlhW5"
 },
 {
  "Email": "law@ysu.am",
  "Name": "Vahe Stepanyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xJaFBH1WeKKtwm0J4MVf"
 },
 {
  "Email": "Lotfian@ut.ac.ir",
  "Name": "Lotfian Saiede",
  "Document Name": "-",
  "Country": "IRN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xJne6vIGPrWGlzKBgUSJ"
 },
 {
  "Email": "info@imlarbilaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xJtNV2hH3REMk9LkmXu1"
 },
 {
  "Email": "tadao.horibe@morganlewis.com",
  "Name": "Tadao Horibe",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xLRjJ0YAB4zqXcAUBBi0"
 },
 {
  "Email": "info@aimgroup.ca�",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xLg0flriWD5nOa1rRVni"
 },
 {
  "Email": "carlabarker@witherskhattarwong.com",
  "Name": "Carla Barker",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xMEggMUo9PicZK9zYbxl"
 },
 {
  "Email": "mrlopes@hrlegalcircle.com",
  "Name": "Ms. Mara Rupia Lopes",
  "Document Name": "BI 2020 MOZ_bi_TPI_survey_en.docx",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xMTh6waRGep5H1wBUyrf"
 },
 {
  "Email": "fsciaudone@grimaldilex.com",
  "Name": "Prof. Francesco Sciaudone",
  "Document Name": "ITA_bi_TPI_survey_en _Grimaldi Studio Legale.docx",
  "Country": "ITA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xMcjtnLsJJAfetcl06ZY"
 },
 {
  "Email": "nassim.mohammed@tt.ey.com",
  "Name": "Nassim Mohammed",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xMg9uo722AE17dOfCWx3"
 },
 {
  "Email": "ctam@deloitte.com",
  "Name": "Tam Chee Chong",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xN26Mu9hcaUMRub4qpu2"
 },
 {
  "Email": "ippu.uganda@gmail.com",
  "Name": "Hilda Mwesigwa",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xNhdL5m6juhfbo8vtIfo"
 },
 {
  "Email": "sjalowayski@gibsondunn.com",
  "Name": "Scott Jalowayski",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xNrbA45gzWR3GiyjwIvR"
 },
 {
  "Email": "ahmed.ibrahim@sksadvocates.com",
  "Name": "Ahmed Ibrahim",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xO4fkwjBbD4Rvo9TwuXN"
 },
 {
  "Email": "Paulo.Pimenta@pimentalawfirm.com",
  "Name": "Paulo Pimenta",
  "Document Name": "-",
  "Country": "MOZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xOKfYUUk4RmArmQ5bq7W"
 },
 {
  "Email": "hugh.stewart@bakermckenzie.com",
  "Name": "Hugh Stewart",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xOykm1OuFMQULFcPmdrv"
 },
 {
  "Email": "info@kpmglaw.lv",
  "Name": "",
  "Document Name": "BI 2020 LVA_bi_PPP_survey_en_KPMG.doc",
  "Country": "LVA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xPRUdmN7a3ADL2ToiZXx"
 },
 {
  "Email": "manage@krsu.edu.kg",
  "Name": "Ludmila Hasanova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xSF4biK86JLl1qPrC3jY"
 },
 {
  "Email": "mehari35@yahoo.com",
  "Name": "Teka Mehari",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xTiNcIX9P5soDmt6Oaj2"
 },
 {
  "Email": "info@apiit.lk",
  "Name": "Upeka Perera",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xTvROgTZtzkmgFcKmdC4"
 },
 {
  "Email": "sales@parkaregroup.co.uk",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xUgeSLvbpv1nAHmRCPPh"
 },
 {
  "Email": "ramon.huapaya@cms-grau.com",
  "Name": "Mr. Ramón Huapaya",
  "Document Name": "BI 2020 PER_bi_TPI_survey.docx  (16.07.19).docx",
  "Country": "PER",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xUhfVD1snPO0JjPXWabZ"
 },
 {
  "Email": "Artur.Sanglepp@levinlaw.ee",
  "Name": "Artur Sanglepp",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xV1MOD1zAY0t4lrZk6kw"
 },
 {
  "Email": "Irakli_legalgeorgia@yahoo.com",
  "Name": "Irkali Kandashvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xW8cDRv0TfUoeFFjYcUv"
 },
 {
  "Email": "info@abg.la",
  "Name": "Azim Ishmatov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xWrSV6Csky553BVtPzlq"
 },
 {
  "Email": "arad@solomon.com.sb",
  "Name": "Andrew Radclyf",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xX9PPkZgN9freODTj8WA"
 },
 {
  "Email": "gglukwanda@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xZ1GuCU7UY6j7rC0T8hU"
 },
 {
  "Email": "lalakkas@velaw.com",
  "Name": "Looaye M. Al-Akkas",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xZ2OxdH4LFwFNXJrFuD5"
 },
 {
  "Email": "jerry@sdchamber.org",
  "Name": "Jerry Sanders",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xasriqyHJf5Z96SEZbD1"
 },
 {
  "Email": "handerson@wslaw.co.uk",
  "Name": "Hazel Anderson",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xbKLuAdP1GS8fFZU4C31"
 },
 {
  "Email": "nguyen.dang@asiattorneys.com",
  "Name": "Mr. Dang Nguyen Ha",
  "Document Name": "BI 2020 VNM_bi_PPP_survey_en_ FidalAsiaattorneys_Albert Franceskinj04.09.2019.docx",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xbUU3KMHp7jLQ51Hznr2"
 },
 {
  "Email": "bruntkeli@ipasifika.net",
  "Name": "Jerry Brunt",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xbzGUgpIy3fqXmRdUVmJ"
 },
 {
  "Email": "charlie.villasenor@transprocure.com",
  "Name": "Charlie Villasenor",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xcDEM8EJEkuqLtZKCgCS"
 },
 {
  "Email": "segokgoattorneys@brobemail.co.bw",
  "Name": "Refilwe Seodi Segokgo",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xcQt20g1u2JSdj8TEU4B"
 },
 {
  "Email": "JKamau@httanzania.com",
  "Name": "James Kamau",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xdLhjh6ObVHx45QwUpwV"
 },
 {
  "Email": "adeboye@sololaakpana.com",
  "Name": "Mr. Ademola Adeboye",
  "Document Name": "NIGERIA) TOPE SOLOLA) World Bank Questionairre TPI Document 29-7-19.docx",
  "Country": "NGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xdbLpxCX1ZhKGMk4m9pN"
 },
 {
  "Email": "legal@lex.kg",
  "Name": "Vitaliy Yen",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xdnaDrtxCbdUx9gw8Aoy"
 },
 {
  "Email": "mmarino@carrizales.pe",
  "Name": "Mart�n Mari�o Marquina",
  "Document Name": "2019-Rev-DOC1-BI 2020 PER_bi_PPP_survey_BID.docx",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xeEdXSxHGGpHEvcUiLEs"
 },
 {
  "Email": "bshorten@shearman.com",
  "Name": "Ben Shorten",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xeW4ALWUvZPWQ1xuJ8FN"
 },
 {
  "Email": "commerce@commerce.gov.sb",
  "Name": "Rex Dodo",
  "Document Name": "-",
  "Country": "SLB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xfSKrLeBhVUthnbqnuBr"
 },
 {
  "Email": "tom.thackray@cbi.org.uk",
  "Name": "Tom Thackray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xfcNuy9POLFP1zBKLoJt"
 },
 {
  "Email": "partners@migalloslunalaw.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xg1fk4f8cCRfMGQ2m1a7"
 },
 {
  "Email": "info@remlawgh.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xgFSv1CALvNLjyUnHmB7"
 },
 {
  "Email": "ignaciocastellanos@kpmg.es",
  "Name": "Mr. Ignacio Castellanos Herraiz",
  "Document Name": "BI 2020 ESP_bi_PPP_survey_en-v2.docx",
  "Country": "ESP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xggzrBtTK0VQFD4w7yYl"
 },
 {
  "Email": "jmercant@guyer.com.uy",
  "Name": "Mr Juan Manuel Mercant",
  "Document Name": "BI 2020 URY_bi_PPP_survey_en final.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xgyUZaxiLlrgAzmhu576"
 },
 {
  "Email": "info@desailawgroup.co.bw",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xh09jPh0fV4vKgnznjTu"
 },
 {
  "Email": "beatrice.fabry@menoldbezler.de",
  "Name": "Beatrice Fabry",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xh7zUZyYvF9XlTVfqL3x"
 },
 {
  "Email": "hamish.mcardle@bakerbotts.com",
  "Name": "Hamish Mcardle",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xhCR0mKuxAIpYYSjkMyx"
 },
 {
  "Email": "pr@alexander-partner.com",
  "Name": "Philippe De Richoufftz",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xhj8BtDxTBtGquk61vAD"
 },
 {
  "Email": "naito@mmn-law.gr.jp",
  "Name": "Junya Naito",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xiQ1zSuKcL8FXHKZcQ1v"
 },
 {
  "Email": "drminas@qcci.org",
  "Name": "Minas Khatchadourian",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xiUOvCzZCjOlLfxQI6nE"
 },
 {
  "Email": "gebreg@tadessekiros.com",
  "Name": "Gebreamlak Gebrigiogis",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xiy9Gll8aRBfqCI6uz0Y"
 },
 {
  "Email": "dakota@dakotaltd.com",
  "Name": "Benny Nugent",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xlsYjePUJjVceQr9ww7h"
 },
 {
  "Email": "rebeccagang.iba@gmail.com",
  "Name": "Rebecca Rebecca Gang",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xnPelUo2sBM6fooE7HMO"
 },
 {
  "Email": "chie.kasahara@aplaw.jp",
  "Name": "Chie Kasahara",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xoOs9FIthY2pd3qrkMCh"
 },
 {
  "Email": "joseph.bevash@lw.com",
  "Name": "Joseph A Bevash",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xrOGfof2f2XBt4RhVRUL"
 },
 {
  "Email": "tmoyo@kantorimmerman.co.zw",
  "Name": "Mr Tatenda Moyo",
  "Document Name": "BI 2020 ZWE_bi_PPP_survey_en_KI.docx",
  "Country": "ZWE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xrTud6YcrQPjc8LSE03E"
 },
 {
  "Email": "robert@brslawyers.com",
  "Name": "Robert Schuler",
  "Document Name": "-",
  "Country": "THA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xrwNi7EzhjOgrL8EUzrh"
 },
 {
  "Email": "ivorynelivera@hsbc.com.lk",
  "Name": "Nick Nicolaou",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xsPPwSv1lgrIkd4xn5Nd"
 },
 {
  "Email": "rodnei.iazzetta@ldr.com.br",
  "Name": "Mr. Rodnei Iazzetta",
  "Document Name": "BI 2020 BRA_bi_PPP_survey_en (002).DOCX",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xuGRE7O3uXDi8StRJeZv"
 },
 {
  "Email": "henrik.trasberg@hedman.ee",
  "Name": "Henrik Traberg",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xuZXikvIEjZbEF8PFOgh"
 },
 {
  "Email": "silvina.panizza@mef.gub.uy",
  "Name": "Ms Silvina Panizza",
  "Document Name": "2019 06 27 Survey_Silvina Panizza.docx",
  "Country": "URY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xugVzK3kBqZ9v188jogd"
 },
 {
  "Email": "jurica.novak@mckinsey.com",
  "Name": "Jurica Novak Novak",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xuqHRsswuLs5eC6P7uEK"
 },
 {
  "Email": "pkarpunin@cls.ru",
  "Name": "?-? ????? ????????",
  "Document Name": "BI 2020 RUS_bi_PPP_survey_ru_CLS.doc",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xuyqwWsy3w3bF7CmqNae"
 },
 {
  "Email": "bluna@ksa.mx",
  "Name": "Mr. Bernardo Luna Gutiérrez",
  "Document Name": "KSA BI_2020_MEX_bi_TPI_survey_en_.DOCX",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xwXVZNOTqsaKNzoPt2Jt"
 },
 {
  "Email": "jacqueline.harkin@klgates.com",
  "Name": "Jacqueline T. Harkin",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xxHWOGllAcZDZMwC9uaI"
 },
 {
  "Email": "INFO@TULLOWOIL.COM",
  "Name": "Rupert Rowland-Clark",
  "Document Name": "-",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xyBlN55cthwWNrQlJ3d1"
 },
 {
  "Email": "marina.freitas@pnm.adv.br",
  "Name": "Ms. Marina Freitas",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial PPP vfinal.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/xyt6KNkleaTntKzRhamU"
 },
 {
  "Email": "masha@immma.co.tz",
  "Name": "Lawrence Kego Masha",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y0S2kMtkmXjrA8Ya23sT"
 },
 {
  "Email": "ghorvat@kpmg.com",
  "Name": "Goran Horvat",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y0aZ9KPNenZmI8I9bvYU"
 },
 {
  "Email": "prince.sinkala@ventus.co.zm",
  "Name": "Mr Prince Sinkala",
  "Document Name": "BI 2020 ZMB_bi_PPP_survey_en_VLP Ventus .docx",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y0azJIR4Fmb9KsGBimhA"
 },
 {
  "Email": "madiasan@gmail.com",
  "Name": "title Mariela Díaz Sandoval",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en.doc",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y19c8wtAfF3E7SorHg1s"
 },
 {
  "Email": "chriscollins@velaw.com",
  "Name": "Christopher Collins",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y1fANSQrr8XZmdQhqNHY"
 },
 {
  "Email": "lance.miller@dlapiper.com",
  "Name": "Lance Miller",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y1gzRvIKDKCT3n5sJwiJ"
 },
 {
  "Email": "andrew@kurialawyers.com",
  "Name": "Mr Andrew Kuria",
  "Document Name": "BI 2020 PNG_bi_PPP_survey_en_Kuria Lawyers.docx",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y1xLMkuPUpUyRTGu6LzH"
 },
 {
  "Email": "info@alaflaw.com",
  "Name": "Abdulwahid Alaf",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y28ShI041ajd7H4uxfmj"
 },
 {
  "Email": "macus.schimidt@pnm.adv.br",
  "Name": "Mr. Marcus Vinicius Schimidt",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial concessão final.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y2z0cXGIIuHkXECJ7rY4"
 },
 {
  "Email": "manjula.ellepola@fjgdesaram.com",
  "Name": "Manjula Ellepola",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y4WGY4YWFe8jCY9FoXLN"
 },
 {
  "Email": "akbar_muratov@yahoo.com",
  "Name": "Akbar Muratov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y4vdyiu4BU5fPrRi6pmm"
 },
 {
  "Email": "lawyers@vanuatu.com.vu",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y6SQ48YrAjIqbJBPNQc4"
 },
 {
  "Email": "sgow@hotmail.co.uk",
  "Name": "Shabir Latif",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y6ZmtxRT7inVmkNJ2gEH"
 },
 {
  "Email": "sipho@armstrongs.bw",
  "Name": "Sipho Ziga",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y7FIWq8Dysw9gq1lYKXu"
 },
 {
  "Email": "duba@cnc.go.cr",
  "Name": "Mr. Daniel Uba",
  "Document Name": "BI 2020 CRI_bi_concession_survey_en_(1)PO.doc",
  "Country": "CRI",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y7Oj1TnvhCFXMslOuWbG"
 },
 {
  "Email": "suzanaziz@eversheds-sutherland.com",
  "Name": "Suzan Aziz",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y7vB1Da8f2DR0uMFTv9P"
 },
 {
  "Email": "william.weber@hugheshubbard.com",
  "Name": "William Weber",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y8aDSrG2JnB43s6KXb5f"
 },
 {
  "Email": "info@peltt.com",
  "Name": "Rowland Mackenzie",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y8eBT5jEIHSqVUlkSqlS"
 },
 {
  "Email": "kaylee.kwok@rhtlawtaylorwessing.com",
  "Name": "Kaylee Kwok",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/y9dspjBSxCtFytSiTRVH"
 },
 {
  "Email": "maria@spb.amcham.ru",
  "Name": "Marian Chernobrovkina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yBFxj80zN0IAPWgiiC0i"
 },
 {
  "Email": "arabian@bemco.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yC8zPmkzO84bz641FXcD"
 },
 {
  "Email": "marc.fevre@bakermckenzie.com",
  "Name": "Marc Fevre",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yCqVx6Yc3MpRidYLxa5C"
 },
 {
  "Email": "ferdinand.jullaga@mkklaw.net",
  "Name": "Mr Ferdinand Jullaga",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_MMK Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yD3FaHZotGN8EjDVitty"
 },
 {
  "Email": "aberdalin@szp.kz",
  "Name": "Arman Berdalin",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yEDIVmmIyDFqQkeULtBd"
 },
 {
  "Email": "planning@mpwr.gov.so",
  "Name": "Mr. Abdullahi Sheik Abukar",
  "Document Name": "BI 2020 SOM_bi_PPP_survey_en_Ministry of Public Works, Recontstruction & Housing.docx",
  "Country": "SOM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yENwjLxQNdssBKT0dOy2"
 },
 {
  "Email": "eadinyira.feds@knust.edu.gh",
  "Name": "Emmanuel Adinyira",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yFD0F0L6AIOeREHRcfcV"
 },
 {
  "Email": "marcal@unisa.ac.za",
  "Name": "Letitia Marcantuono",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yFaoTelnuU0kWE2Ujt1i"
 },
 {
  "Email": "preyburn@ensafrica.com",
  "Name": "Pippa Reyburn",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yGPvHmtx3j9Mh1QS1fs0"
 },
 {
  "Email": "info@mkakaconstruction.com",
  "Name": "Newton Kambala",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yGag371vkreOTQxth1oy"
 },
 {
  "Email": "halsayed@qu.edu.qa",
  "Name": "Hassan Al �Sayed",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yHGqPyPoVJTf8sgBi1fK"
 },
 {
  "Email": "Edith.Osoro@ke.ey.com",
  "Name": "Edith Osoro",
  "Document Name": "-",
  "Country": "ERI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yHty7CDhRIWIp3s2TTbz"
 },
 {
  "Email": "b.abdulhamidov@aaa.tj",
  "Name": "Bakhtiyor Abdulhamidov",
  "Document Name": "-",
  "Country": "TJK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yKPZ7JNcffbWpBlukcu4"
 },
 {
  "Email": "i.daci@optima-al.com",
  "Name": "Mr. ILIR DACI",
  "Document Name": "BI 2020 ALB_bi_PPP_survey_en_Optima.docx",
  "Country": "ALB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yLPd97laVp0P9xHfa9Q7"
 },
 {
  "Email": "jon.gray@davispolk.com",
  "Name": "Jon Gray",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yMHpTXm5FusQtKNaszGS"
 },
 {
  "Email": "gsikira@bhlawassociates.com",
  "Name": "Geoffrey Sikira",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yMZPoTahBSc4I9gAXvsu"
 },
 {
  "Email": "sabine.schlacke@uni-muenster.de",
  "Name": "Prof Sabine Schlacke",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yMhchI77jofkPst8NtyV"
 },
 {
  "Email": "sarah.phillips@au.ey.com",
  "Name": "Sarah Phillips",
  "Document Name": "-",
  "Country": "AUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yMxvqtxadenUQ2Ki8gAH"
 },
 {
  "Email": "denise.littman@ariaslaw.com",
  "Name": "Denise Littman",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yNU3b0p1Ubk0Jm4l4ki7"
 },
 {
  "Email": "salman.al-sudairi@lw.com",
  "Name": "Salman Al-Sudairi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yPbOPrpP7bWR17WgmKPm"
 },
 {
  "Email": "lnunez@claro.cl",
  "Name": "Ms. Luisa Nu�ez",
  "Document Name": "CHL PPP Survey (2020)_.DOC",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yQdVIKj6hMgOcWs8oKfD"
 },
 {
  "Email": "zkhan@qatarlaw.com",
  "Name": "Ms Zoyal Khan",
  "Document Name": "BI 2020 QAT_bi_PPP_survey_en_Sultan.docx",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yQfNt8MIe9pJIUmSXI9z"
 },
 {
  "Email": "Sprint_mc@mail.ru",
  "Name": "???????? ????? ??????????",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yQju00uBq6LcBtpHde39"
 },
 {
  "Email": "rrg24@cornell.edu",
  "Name": "Richard Geddes",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yRqmMeHUmtWBFyQyczFw"
 },
 {
  "Email": "philippa.wilkinson@meed.com",
  "Name": "Philippa Wilkinson",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ySM7Z2g0OYDsNJWV3hiw"
 },
 {
  "Email": "ivan.sahula@ujv.cz",
  "Name": "Ivan Sahula",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yT7KkEuh8cMOtIrriC6Y"
 },
 {
  "Email": "matimba_1@yahoo.co.uk",
  "Name": "Peter Matimba",
  "Document Name": "-",
  "Country": "ZMB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yTckmRHNFV8cj6Ruy3kq"
 },
 {
  "Email": "pgu@a-r-c.dk",
  "Name": "Patrik Gustavsson",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yVUjwQec3OdWBOO2U6GS"
 },
 {
  "Email": "msvoboda@deloittece.com",
  "Name": "Miroslav Svoboda",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yValrszGCjb1g5ak8DSW"
 },
 {
  "Email": "bobur.shamsiev@dentons.com",
  "Name": "Mr. Bobur Shamsiev",
  "Document Name": "BI 2020 UZB_bi_PPP_survey_en_Dentons_Partner.docx",
  "Country": "UZB",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yWRJT1wMNAOIhIlfkXuU"
 },
 {
  "Email": "mateus.adami@pnm.adv.br",
  "Name": "Mr. Mateus Adami",
  "Document Name": "BRAZIL) PEREIRA NETO MACEDO) 20190802 Pesquisa Banco Mundial PPP vfinal.docx",
  "Country": "BRA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yWkprPh7RNCT7Dj9XWlG"
 },
 {
  "Email": "k.ayansola@abdulaitaiwo.com.ng",
  "Name": "Mr. Kunle Ayansola",
  "Document Name": "NIGERIA) TAIWO) BI 2020 NGA_bi_PPP_survey_en.docx",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yX1SuaJ86SLg8QWmXucA"
 },
 {
  "Email": "anna.markina@ut.ee",
  "Name": "Anna Markina",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yXBrgEBCPLNui8yOLPSQ"
 },
 {
  "Email": "degina@iep.ru",
  "Name": "Irina Dezhina",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yXQtC775WRQGP4Q12Zm1"
 },
 {
  "Email": "mboeglin@laliveinqatar.com",
  "Name": "Marcus C. Boeglin",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yYyQsfX1t5LHopZmeCbN"
 },
 {
  "Email": "a.nguluma@rexattorneys.co.tz�",
  "Name": "Alex Thomas Nguluma",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yZ98rAkecDtXT6FS1t8S"
 },
 {
  "Email": "marija.prskalo@karanovic-nikolic.com",
  "Name": "Marija Prskalo",
  "Document Name": "-",
  "Country": "BIH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yZB3N0XanMTDULD4YnHO"
 },
 {
  "Email": "andreas.geiger@gsk.de",
  "Name": "Andreas Geiger",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yZJYrLsnAjheVfiTrXnu"
 },
 {
  "Email": "jay.govender@cdhlegal.com",
  "Name": "Jay Govender",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yZOm9NqAeMcBdrRzKBe7"
 },
 {
  "Email": "michael.kariya@blakes.com",
  "Name": "Michael Kariya",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ybaTWMV2kLdB9sHvGZWu"
 },
 {
  "Email": "adansoh@consultant.com",
  "Name": "title Ayirebi Dansoh",
  "Document Name": "BI 2020 GHA_bi_TPI_survey_en_Ayirebi.doc",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ybmIQXgtD4fQvCb9PCB8"
 },
 {
  "Email": "dbouwer@perlaw.ca",
  "Name": "Dirk Bouwer",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ycW89iol9ruL7G4sU9sP"
 },
 {
  "Email": "dulloa@dumaslex.com",
  "Name": "Daphne Johanna Ulloa Doninelli",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ycXdzZZs5zcAGzWdOJrJ"
 },
 {
  "Email": "contactus@azylawfirm.com",
  "Name": "Ahmed Zaki Yamani",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ydJUJJ2VvlLsCjYGQ1nF"
 },
 {
  "Email": "Alexander.Gomonov@bakermckenzie.com",
  "Name": "Alexander Gomonov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ydZeLwvb2xvVohYdvR4U"
 },
 {
  "Email": "beautymovete@yahoo.com",
  "Name": "Beauty Movete",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yevjeD2UUa0d7XNZOMYE"
 },
 {
  "Email": "cpc@vda.pt",
  "Name": "Mrs. Catarina Pinto Correia",
  "Document Name": "BI 2020 TMP_bi_PPP_survey_en.doc_(DM 7605157_1) (005).DOCX_(DM 7633273_1).docx",
  "Country": "TMP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yghWkBZ6K3DiGnuIFyNJ"
 },
 {
  "Email": "dahlegal@qatar.net.qa",
  "Name": "Sayel Al-Daher",
  "Document Name": "-",
  "Country": "QAT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ygxqMbasNKoQtbn44kRS"
 },
 {
  "Email": "rnb@signumlaw.com",
  "Name": "Mr Rustam Baitazin",
  "Document Name": "BI 2020 KAZ_bi_PPP_survey_en_SIGNUM Law Firm.docx",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yh9XeM16LaYY7Si59ne7"
 },
 {
  "Email": "service@bap.com.vu",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "VUT",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yjuzyWJwWWc9ahbCQ7wh"
 },
 {
  "Email": "mad@prcp.com.pe",
  "Name": "Ms. Michelle Arambur�",
  "Document Name": "BI_2020 PER_bi_PPP_survey_en_Payet - 4832-7662-0956 v. 5.doc",
  "Country": "PER",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yk83KcSJ8DE1uocdEUZv"
 },
 {
  "Email": "Dvortsov.AV@gazprom-neft.ru",
  "Name": "Alexey Vladimirovich Dvortsov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ykURXZ4z1Td7eVHJMXKM"
 },
 {
  "Email": "asif.hasan@tanjibalam.com",
  "Name": "Mr. Asif Hasan",
  "Document Name": "BI 2020 BGD_bi_PPP_survey_en_Tanjib Alam and Associates.doc",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ykXp6SmpKxBSzEceejvS"
 },
 {
  "Email": "saak@nortonrosefulbright.com",
  "Name": "Mr. Somboon Kitiyansub",
  "Document Name": "BI 2020 THA_bi_TPI_survey_en_NORTON ROSE FULBRIGHT.docx",
  "Country": "THA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ylzTujmKzXqwh2Fb0dsq"
 },
 {
  "Email": "rafael.veras@lllaw.com.br",
  "Name": "Mr. Rafael Véras",
  "Document Name": "BRAZIL) VERAS DE FREITAS) BI 2020 BRA_bi_concession_survey_en.docx",
  "Country": "BRA",
  "Survey": "Concessions",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ymj2GzgfgbGMbBhZJOmd"
 },
 {
  "Email": "mjema@dsouza.co.tz",
  "Name": "Jeremiah Mjema",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yn2Y4h0F0uGBOB3fTopV"
 },
 {
  "Email": "ninok@nplaw.ge",
  "Name": "Ms Nino Kvinikadze",
  "Document Name": "BI 2020 GEO_bi_TPI_survey_en (filled).doc.docx",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ynO7EqUV34gVBiT3lfA1"
 },
 {
  "Email": "cellina@udbs.udsm.ac.tz",
  "Name": "Marcellina Chijoriga",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yoeOO4If6Be6GZRYNLsW"
 },
 {
  "Email": "andy.wotton@nz.pwc.com",
  "Name": "Andy Wotton",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yqF21jYJ7PGdrjC2z6mQ"
 },
 {
  "Email": "aa@pagbam.com",
  "Name": "Alan Arntsen l",
  "Document Name": "World Bank- Traditional Public Investment in Infrastructure survey (2).docx",
  "Country": "ARG",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yqeUlCIXhqIAlcD1Rj8r"
 },
 {
  "Email": "info@fmbmalawi.com",
  "Name": "Shwetank Singhvi",
  "Document Name": "-",
  "Country": "MWI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yqmFI8cCJFPwkmrASoh9"
 },
 {
  "Email": "eckhart.schleifenbaum@noerr.com",
  "Name": "Eckhart Schleifenbaum",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ysfH3Lxrc1wTHm3PEgcp"
 },
 {
  "Email": "khalil@khazindarlaw.com",
  "Name": "Khalil Khazindar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yt6agAuJy9F3Xvr32L1z"
 },
 {
  "Email": "info@mahassni.com.sa",
  "Name": "Hassan M.S. Mahassni",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ytPWJHUNOMxUQASfoKPy"
 },
 {
  "Email": "hilda.kamugisha@pwc.com",
  "Name": "Ms Hilda Kamugisha",
  "Document Name": "UGANDA) PWC) BI 2020 UGA_bi_TPI_survey_en.docx 23 August 2019.docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ytqQYvizSwQQ2SiF5aqX"
 },
 {
  "Email": "oanderson@milbank.com",
  "Name": "Miss Olivia Anderson",
  "Document Name": "BI 2020 GBR_bi_TPI_survey_en_Milbank.docx",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yuG788tfQ30uRLJiwaQI"
 },
 {
  "Email": "osman.jalloh@yadawilliams.com",
  "Name": "Osman Jenkins-Johnson Jalloh",
  "Document Name": "-",
  "Country": "SLE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yud8ofICHiu6dgYILv6Y"
 },
 {
  "Email": "erik.andersen@dentons.com",
  "Name": "Erik Andersen",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yuoo3UAbixguPjZns2eh"
 },
 {
  "Email": "jcollaz@proesa.gob.sv",
  "Name": "Mr. Schafik Collazo",
  "Document Name": "PO.BI 2020 SLV_bi_PPP_survey_en.PROESA.docx",
  "Country": "SLV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yv8WuTSclRIsHTG0Ox5U"
 },
 {
  "Email": "rjeyhan@abnrlaw.com",
  "Name": "Ms. Rahmi Intan Jeyhan",
  "Document Name": "BI 2020 IDN_bi_PPP_survey_en_ABNR Law.docx",
  "Country": "IDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yv98FgbFQQn0QH8kRjeS"
 },
 {
  "Email": "joanne.emersontaqi@nortonrosefulbright.com",
  "Name": "Joanne Emerson Taqi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yvNhqA07hxxmHO6EHAh1"
 },
 {
  "Email": "cew@ppplaw.com",
  "Name": "C.E. Chip Wullbrandt",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ywejfU9cXVh8lw94GIWe"
 },
 {
  "Email": "allison.page@dlapiper.com",
  "Name": "Allison Page",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yxMaIx6mLeQVDgM9Kj1Q"
 },
 {
  "Email": "info@chirgwin.cl",
  "Name": "Mr. Hern�n Pe�afiel",
  "Document Name": "BI 2020 CHL_bi_PPP_survey_en_20190830_Chirgwin .docx",
  "Country": "CHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/yxxTOMRP8Y7quCl007Wo"
 },
 {
  "Email": "Robert.Gray@cms-cmno.com",
  "Name": "Robert Gray",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z03ifGH2dVApmbCdsCwp"
 },
 {
  "Email": "s.dumanaeva@lorenz-law.com",
  "Name": "Ms. Samara Dumanaeva",
  "Document Name": "BI 2020 KGZ_bi_PPP_survey_en_Lorenz.docx",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z07k4eevrw49LgCuzETi"
 },
 {
  "Email": "mja_lukwaro@hotmail.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z0IJvn30b0tHoLSHtRSO"
 },
 {
  "Email": "trockell1@kpmg.com.sg",
  "Name": "Tim Rockell",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z0ZZXaofJth89aiNrFsW"
 },
 {
  "Email": "marko.ketler@karanovicpartners.com",
  "Name": "Mr. Marko Ketler",
  "Document Name": "PPP_Ermina.docx",
  "Country": "SVN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z0achQXLeSLPhnHgodQj"
 },
 {
  "Email": "zalqurashi@kau.edu.sa",
  "Name": "Zeyad Al Qurashi",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z149ChjNgPkkzFlao1Zt"
 },
 {
  "Email": "barichelloe@bennettjones.com",
  "Name": "Enzo J. Barichello",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z14Q7K699jDTX2o3dNPL"
 },
 {
  "Email": "georgy.kalashnikov@hoganlovells.com",
  "Name": "Georgy Kalashnikov",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z1IK2A52ljzm2wTiH5QJ"
 },
 {
  "Email": "pcarbone@mwe.com",
  "Name": "Piero Carbone",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z2BcBUus0FrYSVRjlC0c"
 },
 {
  "Email": "yoav.dotan@mail.huji.ac.il",
  "Name": "Yoav Dotan",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z2eoMXPkY6rxmvbFrjrF"
 },
 {
  "Email": "jmcclenahan@kslaw.com",
  "Name": "John Mcclenahan",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z3YtIImezcYlhDBVN47U"
 },
 {
  "Email": "alexandru.aman@nndkp.ro",
  "Name": "Mr. Alexandru Aman",
  "Document Name": "BI 2020 ROM _bi_PPP_survey_en_Nestor.docx",
  "Country": "ROM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z4KeZj4BlsXWfEXIOVjE"
 },
 {
  "Email": "aklinemintz@tmlw.co.il",
  "Name": "Ayal Klinemintz",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z4gOJSCJ2JoM331Vs7hH"
 },
 {
  "Email": "alex.regan@corrs.com.au",
  "Name": "Alex Regan",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z5ide5jH7HYAMHn4fMys"
 },
 {
  "Email": "khill@torys.com",
  "Name": "Krista Hill",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z5jWWzWzEZaVx2HSYZVI"
 },
 {
  "Email": "kyoshino@paulweiss.com",
  "Name": "Kaye Yoshino",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z5zgeUAge5eVE15eiMs2"
 },
 {
  "Email": "sandip@thinkhub.co.nz",
  "Name": "Sandip (Sandy) Ranchhod",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z7KzWAUHSi1Ete3xo5ZN"
 },
 {
  "Email": "stephany.aw@stamfordlaw.com.sg",
  "Name": "Stephany Aw",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z7NZZ1jGdjpRbE6K5HmM"
 },
 {
  "Email": "psrivastava@duanemorrisselvam.com",
  "Name": "Mr. PRIYANK SRIVASTAVA",
  "Document Name": "PPP_Maynmar (DMS29072019).docx",
  "Country": "MMR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z7XRogVxlskL8FyJQYkE"
 },
 {
  "Email": "npf@homannlaw.dk",
  "Name": "Nicolai Platzer Funder",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z7aajbWcUEG17aycWjKC"
 },
 {
  "Email": "vining@sfu.ca",
  "Name": "Aidan Vining",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z8BzQFuQ93jHv55B86V7"
 },
 {
  "Email": "info@saurenergy.com",
  "Name": "Bill Peacock",
  "Document Name": "-",
  "Country": "GHA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/z8gwiiNUOMilpuyzsEHq"
 },
 {
  "Email": "rgray@houstonicc.org",
  "Name": "Reggie Gray",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zA7rF5Rq4FCHA0kDLP87"
 },
 {
  "Email": "Kairat.Serikpayev@vsbpartnersllp.com",
  "Name": "Kairat Serikpayev",
  "Document Name": "-",
  "Country": "KAZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zA7ueRy2XLv5JQZ3cLYu"
 },
 {
  "Email": "dhkruse@keblegal.ws",
  "Name": "Herman Kruse",
  "Document Name": "-",
  "Country": "WSM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zCIR8vksOy96iu9HWbia"
 },
 {
  "Email": "elgamal@hotakelgamal.com",
  "Name": "Nehad El Gamal",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zCVMhp7HNoqsGAWuOIeR"
 },
 {
  "Email": "info@psdc-iraq.org",
  "Name": "Khalid Mahdi",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zCk9geiej5vZDLaltYe7"
 },
 {
  "Email": "donka.stoyanova@dpc.bg",
  "Name": "Ms. Donka Stoyanova",
  "Document Name": "BI 2020 BGR bi PPP survey en DPC 15.08.2019.docx",
  "Country": "BGR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zD9g8e92T2xbkMlYjzCL"
 },
 {
  "Email": "jaythomasbrennan@gmail.com",
  "Name": "Jay Thomas Brennan",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zDkPmxGK3uf6mX71Shkx"
 },
 {
  "Email": "dekan@fpedas.uniza.sk",
  "Name": "Alica Kala�ov�",
  "Document Name": "-",
  "Country": "CZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zDlCcYEZcWxjnBHZI5up"
 },
 {
  "Email": "contact@idc.ge",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zFefeIFnNBm4HGucEcwC"
 },
 {
  "Email": "yyamaguchi@tmi.gr.jp",
  "Name": "Yoshiyasu Yamaguchi",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zGk6vZdvgQyxDuYRlSRm"
 },
 {
  "Email": "mm@gorrissenfederspiel.com",
  "Name": "Michael Meyer",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zGk8Z9X4cT2inBgsogUY"
 },
 {
  "Email": "eamonn.ohanrahan@mccannfitzgerald.com",
  "Name": "Mr Eamonn O'Hanrahan",
  "Document Name": "IRL_World Bank - Benchmarking Infrastructure 2020 - Eamonn O Hanrahan response.docx",
  "Country": "IRL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zH8CgHoiRS7ihpGWdMlD"
 },
 {
  "Email": "cmomota@paulweiss.com",
  "Name": "Chikara Momota",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zJBxSXwA36WpSzbiAFJQ"
 },
 {
  "Email": "dinah@byenkyakihika.co.ug",
  "Name": "Ms Dinah Mukasa",
  "Document Name": "UGANDA) BYENKYA) BI 2020 UGA_bi_TPI_survey_en (2).docx",
  "Country": "UGA",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zJIbckTehENs73UJZ5XF"
 },
 {
  "Email": "yanjuna@catholic.ac.kr",
  "Name": "Prof. Junsok Yang",
  "Document Name": "KOREA) PROF YANG) BI 2020 KOR_bi_PPP_survey_en-Yang.docx",
  "Country": "KOR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zJJYiusAutdK7uvHDdXv"
 },
 {
  "Email": "info@nassarabogados.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zJMejVvw0LbcVHeozFW3"
 },
 {
  "Email": "road@road.am",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zK7gqZEtW3SJgl61lokM"
 },
 {
  "Email": "Taniela.fusimalohi@gmail.com",
  "Name": "Taniela Liku'Ohihifo Fusimalohi",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zKIUe8oJnBj6iRqkokF4"
 },
 {
  "Email": "alvin.yeo@wongpartnership.com",
  "Name": "Alvin Yeo",
  "Document Name": "-",
  "Country": "SGP",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zKYSL0i5hBV1xaefBW6v"
 },
 {
  "Email": "robert.juodka@primus.legal",
  "Name": "Robbert Juodka",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zKfMgD6vfJ5IRbNeZ4xO"
 },
 {
  "Email": "torsten.moe@dk.pwc.com",
  "Name": "Torsten Moe",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zLB4LBXUroMzplt4JnR6"
 },
 {
  "Email": "elnur.aliyev@bhm.az",
  "Name": "Mr Elnur Aliyev",
  "Document Name": "BI 2020 AZE_bi_PPP_survey_en completed by BHM Law Firm.doc",
  "Country": "AZE",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zLGpKylNlE7o8YOhkkCC"
 },
 {
  "Email": "mrascoff@melarayasociados.com",
  "Name": "Michael Alexander Rascoff Irias",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zLYFwOoppQk4zQoHE9vp"
 },
 {
  "Email": "coordinator@rahmansc.com",
  "Name": "Mr. Khandaker Mashfique Ahmed",
  "Document Name": "BANGADESH) RAHMAN'S CHAMBERS) BI 2020 BGD_bi_PPP_survey_en.doc",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zMg5IdXLIX0o8xZH4cnd"
 },
 {
  "Email": "enquiries@hallowell-law.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zNI9M1JUQCxwb5qoKDug"
 },
 {
  "Email": "admin@chamberscolombo.com",
  "Name": "Dhammika Ranasinghe",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zNNLFwOSUHsldqnlCUns"
 },
 {
  "Email": "admin@primaconsultants.com.sa",
  "Name": "Abdulrahman Bin Saud Al Kabeer",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zNfuw1h8R2Zy44rRDO7l"
 },
 {
  "Email": "lorraine.ball@allenovery.com",
  "Name": "Lorraine Bayliss",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zNsrLICkk20zHGxgRoML"
 },
 {
  "Email": "jose.roman@ariaslaw.com",
  "Name": "title Jos� Rom�n",
  "Document Name": "071919 2020 NIC PPP Survey .docx",
  "Country": "NIC",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zOH8MesFZaszi48HV50N"
 },
 {
  "Email": "hwang@adb.org",
  "Name": "Hong Wang",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zOT98babgvY45Yo7IR9V"
 },
 {
  "Email": "nhaffar@kpmg.com",
  "Name": "Nader Haffar",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zP8ywpkiMUgWcftkFWFO"
 },
 {
  "Email": "Alexander.Yerofeyev@ru.ey.com",
  "Name": "Alexander Yerofeyev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zQ4xz8oYixnfEzIhuaUH"
 },
 {
  "Email": "ahmed_mo1972@yahoo.com",
  "Name": "Ahmed Mohmed",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zQYB6YCoCxCPRA6f6jSI"
 },
 {
  "Email": "info@sunshineinvestmentgroup.net",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zRIuIAdjLn9cPbi3G2OQ"
 },
 {
  "Email": "MaiTrang.Le@BakerMcKenzie.com",
  "Name": "Ms. Mai Trang Le",
  "Document Name": "PPP_BakerMckenzie_Vietnam_en.DOCX",
  "Country": "VNM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zRYD4xOTZ5Aqwzfurz2m"
 },
 {
  "Email": "a.nguluma@rexattorneys.co.tz�",
  "Name": "Alex Thomas Nguluma",
  "Document Name": "-",
  "Country": "TZA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zRhO1SB3tf25EmNmsbD2"
 },
 {
  "Email": "a.okolo@icrc.gov.ng",
  "Name": "Mr Akwu Okolo",
  "Document Name": "NIGERIA) ICRC) BI 2020 NGA_bi_PPP_survey_en r1Answers.doc",
  "Country": "NGA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zRmEV5TPZgszPFs6Wtga"
 },
 {
  "Email": "carlislechambers@gmail.com",
  "Name": "Terrence Bharath",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zRunWmkK6Y8fRyf5tWZb"
 },
 {
  "Email": "caroline.sherrell@whitecase.com",
  "Name": "Caroline Sherrell",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zUJeCpT0OLFsSXsBN1Vh"
 },
 {
  "Email": "marco.koenig@gleisslutz.com",
  "Name": "Marco K�NIG",
  "Document Name": "-",
  "Country": "DEU",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zUNo5zJ8BfSxtbXHi4SG"
 },
 {
  "Email": "asma.khan@surridgeandbeecheno.com.pk",
  "Name": "Ms. Asma Hameed Khan",
  "Document Name": "BI 2020 PAK_bi_PPP_survey_Surridge&Beecheno.docx",
  "Country": "PAK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zUZXuRFjXtlqnlxQWFb6"
 },
 {
  "Email": "gisselle.hassan@hatstone.com",
  "Name": "Gisselle Hassan",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWBqXlYAa646o4GHTNN1"
 },
 {
  "Email": "info@izquierdo.co.cr",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWCn8VL04I2GkbvmEefH"
 },
 {
  "Email": "rmacdonald@stikeman.com",
  "Name": "Ross A. Macdonald",
  "Document Name": "-",
  "Country": "CAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWPRDONXlBOOOfZGd8aD"
 },
 {
  "Email": "cillijo@unisa.ac.za",
  "Name": "Orpha Cilliers",
  "Document Name": "-",
  "Country": "ZAF",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWSyQXaoN7wwPwPfj20Z"
 },
 {
  "Email": "ivan.drezga@cemex.com",
  "Name": "Ivan Drezga",
  "Document Name": "-",
  "Country": "HRV",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWjmfKrYnxh1UGKe30Ic"
 },
 {
  "Email": "taktakishvili@mikadze.ge",
  "Name": "Giorgi Taktakishvili",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWthrbZpblXjLS0199Ji"
 },
 {
  "Email": "info@commonwealthofnations.org",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "TON",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zWwEcz1ovxCEwZVvQFM7"
 },
 {
  "Email": "info@henaos.com.pg",
  "Name": "Jacinta Joan Murray",
  "Document Name": "-",
  "Country": "PNG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zZ6eZaNRi6NfmPckSiWg"
 },
 {
  "Email": "sami@crlfsd.com",
  "Name": "Sami Abdelhalim",
  "Document Name": "-",
  "Country": "SDN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zZhr8Q0j5ysMJXdxK8Sk"
 },
 {
  "Email": "omlalla@krlalla.com",
  "Name": "Om Lalla",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/za4s8aPLu0YX6OaUbQVU"
 },
 {
  "Email": "martin.j.callaghan@uk.pwc.com",
  "Name": "Martin Callaghan",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zb5kTE37uW7piwxxay3Q"
 },
 {
  "Email": "info@metka.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zcnOerx93xQm28KpMTo8"
 },
 {
  "Email": "dostos@s-s.mx",
  "Name": "title Diego Ostos",
  "Document Name": "BI 2020 MEX_bi_TPI_survey_en 230719.docx",
  "Country": "MEX",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zdCCuWZS9IFQZqNJMMv2"
 },
 {
  "Email": "info@kjlaw.ge",
  "Name": "Irakli Jgenti",
  "Document Name": "-",
  "Country": "GEO",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zde9u9xLpDKSiYUDURtR"
 },
 {
  "Email": "jose@erplawyers.com",
  "Name": "Jose Martin Azofeifa Rodriguez",
  "Document Name": "-",
  "Country": "CRI",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zfNMUgRo3bHN872s4j69"
 },
 {
  "Email": "hugo.coetzee@cms-cmck.com",
  "Name": "Hugo Coetzee",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zfQzlgqrGa20pe7b4wpJ"
 },
 {
  "Email": "tim.castle@xtra.co.nz",
  "Name": "Tim Castle",
  "Document Name": "-",
  "Country": "NZL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zfhWHsJNLaOzBcnhNWcN"
 },
 {
  "Email": "saodat.shakirova@arte-ip.kg",
  "Name": "Saodat Shakirova",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zfnLhjTKcv6BtGyDxUTu"
 },
 {
  "Email": "nmodiri@minchinkelly.bw",
  "Name": "Namie Modiri",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zg5lmGc7zjWhELdg0C4B"
 },
 {
  "Email": "mcaterini@orrick.com",
  "Name": "Mark Caterini",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zg875brasAJgUeRVGAX9"
 },
 {
  "Email": "aarosemena@arifa.com",
  "Name": "Augusto R. Arosemena",
  "Document Name": "-",
  "Country": "PAN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zhv3xmPtntbKTPBC3lgQ"
 },
 {
  "Email": "jgross@mcguirewoods.com",
  "Name": "James E. Gross",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zhvnPQdRuXbP5oNDsDWI"
 },
 {
  "Email": "Carlo.Alloni@mitie.com",
  "Name": "Carlo Alloni",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ziAO2bmQ7q2vcIxaQLb8"
 },
 {
  "Email": "csteiner@capitalregionchamber.com",
  "Name": "Chuck Steiner",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ziEPR1DuRnvZLYpNeAVx"
 },
 {
  "Email": "kbrumfield@dcchamber.org",
  "Name": "Krystal Brumfield",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ziL3AJiRlj3jK4ae0cge"
 },
 {
  "Email": "fcairella@beccarvarela.com",
  "Name": "Ms. Florencia Cairella",
  "Document Name": "BI 2020 ARG_bi_PPP_survey_en_Beccar Varela.docx",
  "Country": "ARG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ziZpCTvwuVz0PTOxmdpf"
 },
 {
  "Email": "alejandra.corrales@fca.com.py",
  "Name": "Ms Alejandra Corrales",
  "Document Name": "BI 2020 PRY_bi_PPP_survey_en (08.28.19).docx",
  "Country": "PRY",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zig1ZVEW3nP4hxik7yUq"
 },
 {
  "Email": "siyarahmed@kpmg.com",
  "Name": "Siyar Ahmed",
  "Document Name": "-",
  "Country": "AFG",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zjH2m4Doo7FJs699Yi7m"
 },
 {
  "Email": "mmengassini@grimaldilex.com",
  "Name": "Mr. Maurizio Mengassini",
  "Document Name": "BI 2020 ITA_bi_PPP_survey_en_Matteo Trabacchin.docx",
  "Country": "ITA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zjxtkSNlcOhTpKtqGJIp"
 },
 {
  "Email": "Kokorev@gazprom-neft.ru",
  "Name": "Alexey Sergeevich Kokorev",
  "Document Name": "-",
  "Country": "RUS",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zk9ExusVHLYIacemzBFe"
 },
 {
  "Email": "wilfredo.peralta@hn.pwc.com",
  "Name": "Wilfredo Peralta",
  "Document Name": "-",
  "Country": "HND",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zkUwKGHMNU9zoMNV5DwR"
 },
 {
  "Email": "alaa_harba@yahoo.co.uk",
  "Name": "Alaa Harba",
  "Document Name": "-",
  "Country": "IRQ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zkuc4CiQ6c4gYvqZCIex"
 },
 {
  "Email": "kwong@milbank.com",
  "Name": "Karen Wong",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zl0u0whdsDzNouHDGnnK"
 },
 {
  "Email": "mmo@forumadvokater.dk",
  "Name": "Morten Mark �stergaard",
  "Document Name": "-",
  "Country": "DNK",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zlEAY0f3bWysk0DC22QO"
 },
 {
  "Email": "lloyd.parker@hoganlovells.com",
  "Name": "Lloyd Parker",
  "Document Name": "-",
  "Country": "JPN",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zmqH238P8npPdH46t2pV"
 },
 {
  "Email": "mengistuworku@gmail.com",
  "Name": "Mengistu Worku Mengesha",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/znAvbdgsWN7zOSo01U3t"
 },
 {
  "Email": "cccbw@stanbic.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "BWA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/znQOihMqcC58bI2jfCql"
 },
 {
  "Email": "jayathri.kulatilaka@fjgdesaram.com",
  "Name": "Jayathri Kulatilleke",
  "Document Name": "-",
  "Country": "LKA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zoEOlGZeJD8Fp6gh3GJq"
 },
 {
  "Email": "jpmouttet@fitzwilliamstone.com",
  "Name": "Jon Paul Mouttet",
  "Document Name": "-",
  "Country": "TTO",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zouXs76roTXfHCn4tyiM"
 },
 {
  "Email": "JFORRER@GWU.EDU",
  "Name": "John Forrer",
  "Document Name": "-",
  "Country": "USA",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zpFnLd56J3QSofad6GQ6"
 },
 {
  "Email": "nurshat@siar-consult.com",
  "Name": "Nurshat Karabashov",
  "Document Name": "-",
  "Country": "KGZ",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zpmzXorEywEGEAQqvp2z"
 },
 {
  "Email": "ratry.intern@khossain.com",
  "Name": "Ms. Tasnuva Tabassum lRatry",
  "Document Name": "BANGLADESH) KAMAL) BI 2020 BGD_bi_PPP_survey_en_26 08 2019.docx",
  "Country": "BGD",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zr23hCuMCibpLDufBoEe"
 },
 {
  "Email": "jora@lawyer.am",
  "Name": "Zhora Martirosyan",
  "Document Name": "-",
  "Country": "ARM",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zrpyiLhEnYonCuvgzsbn"
 },
 {
  "Email": "janek@lauspartners.ee",
  "Name": "Janek V�li",
  "Document Name": "-",
  "Country": "EST",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zsOgHflyc3tE1WuvOVqk"
 },
 {
  "Email": "ibp_national@yahoo.com",
  "Name": "Sir/Madam",
  "Document Name": "-",
  "Country": "PHL",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ztb5ncSs7qdAa28XnIzy"
 },
 {
  "Email": "robbins@viab.org",
  "Name": "Ralph Robbins",
  "Document Name": "-",
  "Country": "ISR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/ztijjpCJBY6GKyCQJKxJ"
 },
 {
  "Email": "naomi.horton@ashurst.com",
  "Name": "Naomi Horton",
  "Document Name": "-",
  "Country": "GBR",
  "Survey": "PPP",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zvwReFy0jkilJ3viptsY"
 },
 {
  "Email": "ipaskal@whitecase.com",
  "Name": "Ivan Paskal",
  "Document Name": "-",
  "Country": "SAU",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zxSW4jcmW3MPuwBTaYxG"
 },
 {
  "Email": "mashora@mashora.com.kw",
  "Name": "Abdulrahman Alhumaidan",
  "Document Name": "-",
  "Country": "ETH",
  "Survey": "TPI",
  "Language": "EN",
  "Link": "https://bpp-2020-practice.exploredata.app/survey/zyTCpISl3EwlymrWKZIY"
 }
];